<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    width="100%" viewBox="0 0 2000 2000" enable-background="new 0 0 2000 2000" xml:space="preserve">
  <path fill="#000000" opacity="1.000000" stroke="none" 
    d="
  M1.000004,927.000000 
    C1.000000,618.404541 1.000000,309.809021 1.000000,1.000000 
    C302.692474,1.000000 604.385010,1.000000 906.752319,1.410428 
    C905.913818,2.215367 904.408142,2.912582 902.885803,2.950989 
    C896.901611,3.101962 890.911194,2.992483 884.925659,3.112442 
    C883.777771,3.135447 881.988098,3.426461 881.615112,4.162063 
    C880.111389,7.127535 877.685303,7.110870 874.970337,7.031364 
    C871.150513,6.919501 867.295593,6.745136 863.512695,7.141494 
    C861.518738,7.350420 859.645752,8.713903 857.718079,9.556084 
    C857.912842,10.035580 858.107605,10.515076 858.302368,10.994572 
    C859.280396,10.994572 860.277039,11.119456 861.233704,10.976526 
    C895.760132,5.818170 930.492126,3.047974 965.368896,1.908672 
    C966.587830,1.868855 967.790039,1.314524 969.000000,1.000000 
    C985.359192,1.000000 1001.718323,1.000000 1018.948364,1.000499 
    C1029.787964,1.426795 1039.787964,1.491680 1049.719604,2.347364 
    C1077.371826,4.729796 1104.996094,7.438777 1132.630859,10.023640 
    C1136.085815,10.346806 1139.538086,10.699112 1144.191406,11.155616 
    C1140.629517,6.043613 1136.504761,7.208150 1132.831909,7.001604 
    C1130.024658,6.843740 1125.405518,7.724002 1124.724854,6.458108 
    C1122.092407,1.562315 1118.050781,3.229174 1114.398682,3.042048 
    C1110.908936,2.863244 1107.397217,3.101603 1103.909424,2.905409 
    C1103.239258,2.867719 1102.634766,1.665165 1102.000000,1.000001 
    C1401.594971,1.000000 1701.189819,1.000000 2001.000000,1.000000 
    C2001.000000,289.692474 2001.000000,578.385010 2000.577637,867.458008 
    C1999.770264,865.577148 1999.033813,863.308105 1999.083496,861.056396 
    C1999.156372,857.748657 1999.155518,854.809814 1995.014282,854.447693 
    C1995.014282,848.365784 1995.088989,842.699829 1994.965576,837.038269 
    C1994.931519,835.477417 1994.527954,832.683655 1993.916992,832.575073 
    C1989.510010,831.791504 1991.111206,828.538879 1991.034668,826.154846 
    C1990.874146,821.160400 1991.045654,816.155823 1990.928833,811.158997 
    C1990.902954,810.046936 1990.310181,808.924438 1989.870850,807.850708 
    C1988.947266,805.593872 1987.385864,803.432617 1987.113770,801.111633 
    C1986.652588,797.178223 1986.986938,793.151611 1986.986938,789.164124 
    C1986.481689,789.337646 1985.976440,789.511169 1985.471313,789.684753 
    C1984.643066,787.633606 1983.430298,785.646301 1983.076660,783.516418 
    C1982.546875,780.324768 1983.854004,775.312866 1982.194580,774.123352 
    C1978.084106,771.176636 1979.271606,767.634338 1978.955933,764.088013 
    C1978.863159,763.046021 1978.519775,761.130554 1978.290039,761.130310 
    C1974.574707,761.127258 1976.297241,758.333374 1976.022339,756.741272 
    C1975.419556,753.248169 1976.209717,748.745483 1974.288208,746.445251 
    C1971.930908,743.623474 1972.128906,741.107300 1971.958374,738.186707 
    C1971.873169,736.728394 1971.831299,735.128784 1971.213623,733.864990 
    C1968.931396,729.195923 1967.053589,724.489502 1967.817261,718.951416 
    C1962.105469,718.251770 1964.561523,713.813782 1963.919800,710.612427 
    C1963.523926,708.638306 1962.277588,706.834656 1961.413086,704.954407 
    C1961.025635,705.073669 1960.638306,705.192871 1960.250854,705.312073 
    C1958.792114,701.325256 1962.779297,695.585205 1956.247437,693.151184 
    C1955.912964,693.026550 1956.009521,691.604065 1955.996704,690.784363 
    C1955.957886,688.285278 1956.259277,685.736450 1955.854492,683.302307 
    C1955.555908,681.506287 1954.358398,679.859741 1953.561523,678.146606 
    C1953.124878,678.276428 1952.688232,678.406189 1952.251587,678.535950 
    C1951.060425,675.701599 1954.439575,670.612183 1947.988892,670.570679 
    C1947.988892,668.461365 1948.047852,666.635559 1947.971069,664.815552 
    C1947.903809,663.217651 1947.979370,660.345520 1947.485474,660.231628 
    C1942.968018,659.189819 1944.367676,655.745911 1943.891235,652.879211 
    C1943.537720,650.751465 1942.290527,648.772278 1941.441406,646.726929 
    C1941.019165,646.846130 1940.596924,646.965332 1940.174805,647.084595 
    C1939.111572,644.579712 1942.040649,640.643799 1937.285278,639.395142 
    C1936.993042,639.318481 1936.731689,638.146118 1936.864136,637.579102 
    C1938.329346,631.313354 1932.647339,627.137390 1932.191772,621.446106 
    C1932.156982,621.012085 1931.846191,620.232605 1931.663086,620.232483 
    C1928.219360,620.230530 1929.125000,617.743652 1928.943115,615.757263 
    C1928.781128,613.986694 1928.907471,611.287231 1927.884888,610.657898 
    C1923.954224,608.238892 1925.287109,604.463013 1924.444702,601.454773 
    C1923.022217,600.746399 1921.552124,599.907898 1921.076660,598.683228 
    C1919.410034,594.390015 1919.276123,588.732788 1916.337769,585.892883 
    C1912.475464,582.159790 1913.303589,578.296265 1912.868652,574.075256 
    C1907.567871,573.544922 1909.218140,569.349243 1908.988525,566.239197 
    C1907.510010,565.981689 1906.287842,565.768860 1905.270264,565.591614 
    C1904.318115,562.399048 1906.983643,557.806885 1901.346802,557.604492 
    C1901.002441,555.497253 1901.302368,552.450500 1900.280884,551.912537 
    C1895.435303,549.360413 1897.576294,543.647522 1894.193848,540.177307 
    C1890.901001,536.798950 1889.454468,531.649414 1887.060669,527.353760 
    C1885.988159,525.429199 1884.582153,523.690491 1883.327637,521.867371 
    C1882.910645,522.041382 1882.493652,522.215332 1882.076660,522.389343 
    C1882.076660,520.088623 1882.076660,517.787903 1882.076660,515.403137 
    C1880.640259,515.054749 1879.324463,514.735657 1877.892822,514.388489 
    C1877.892822,511.785065 1877.892822,509.491974 1877.892822,507.242859 
    C1876.482300,506.988617 1875.267822,506.769714 1873.901611,506.523468 
    C1875.379028,499.593353 1870.152954,497.253052 1866.080566,493.996918 
    C1865.462036,491.174286 1867.778564,486.719757 1861.848267,486.607422 
    C1862.265747,483.021790 1862.783203,479.549957 1859.549194,479.435486 
    C1857.931519,476.372223 1856.824951,474.206085 1855.646729,472.079620 
    C1855.173218,471.224792 1854.534546,470.462585 1853.985718,469.648254 
    C1851.700806,466.257355 1848.888672,463.092712 1847.295532,459.402313 
    C1845.810669,455.962738 1840.872070,454.415558 1842.013672,449.621887 
    C1842.042114,449.502228 1840.846802,449.260223 1840.475098,448.847595 
    C1838.609741,446.776764 1835.526123,444.772308 1835.276001,442.481873 
    C1834.668579,436.918701 1830.697388,434.754974 1827.371216,432.156586 
    C1826.800537,423.859253 1820.188599,420.504486 1815.277100,415.829865 
    C1814.966553,413.899475 1815.300171,411.298279 1814.170654,409.800690 
    C1810.317627,404.691772 1803.893677,401.744720 1802.563599,394.365906 
    C1802.178711,392.230530 1798.553589,390.679230 1796.184937,388.665405 
    C1796.002563,387.409332 1796.299072,385.276428 1795.390747,384.002716 
    C1792.947876,380.577301 1790.386841,377.014099 1787.127075,374.455322 
    C1783.808350,371.850372 1780.520874,369.574921 1779.158081,365.360138 
    C1778.954224,364.729828 1778.218018,364.258789 1777.696289,363.746429 
    C1775.824585,361.908173 1773.753662,360.234558 1772.110474,358.212341 
    C1770.430298,356.144440 1769.267212,353.664459 1767.683472,351.507568 
    C1766.488403,349.880096 1765.048828,348.415192 1763.607788,346.989410 
    C1761.449219,344.853973 1759.202271,342.807373 1756.977661,340.739471 
    C1754.502197,338.438568 1752.009766,336.156036 1750.647095,334.900024 
    C1748.054443,330.491943 1746.626953,326.768188 1744.109253,324.056976 
    C1739.021362,318.577911 1732.115356,314.913116 1728.181030,308.195282 
    C1727.347900,306.772705 1726.079956,305.534851 1724.805298,304.456879 
    C1722.737183,302.708008 1718.658569,301.121643 1718.692993,299.537598 
    C1718.779297,295.571136 1714.916382,296.605530 1713.854248,294.341644 
    C1712.758301,292.005493 1710.999146,289.828217 1709.081299,288.071411 
    C1707.035034,286.196838 1704.260376,285.126068 1702.173706,283.284943 
    C1699.620483,281.032013 1697.712524,278.009186 1695.048584,275.930603 
    C1691.985229,273.540253 1689.106079,270.683258 1686.539307,268.080261 
    C1683.694336,265.194916 1681.277344,262.454865 1677.524902,260.494812 
    C1673.729248,258.512268 1670.449341,255.380783 1667.304443,252.374924 
    C1665.437134,250.590149 1664.716309,247.336227 1662.662476,246.088943 
    C1660.426880,244.731293 1659.042847,241.389618 1658.270752,241.316010 
    C1654.089233,240.917206 1653.546631,236.924164 1650.993652,235.076843 
    C1647.014160,232.197220 1643.479248,228.709442 1639.557983,225.740860 
    C1637.258179,223.999893 1633.693848,223.352341 1632.247803,221.181000 
    C1629.256348,216.689438 1626.318604,212.996429 1621.545044,213.723236 
    C1617.417480,209.524246 1613.950806,205.997589 1610.484009,202.470932 
    C1608.220947,201.644394 1605.965698,200.624374 1604.070435,199.143631 
    C1599.753784,195.771011 1596.810913,190.794418 1590.472656,189.844070 
    C1588.094604,189.487518 1586.191406,185.965027 1584.071655,183.885925 
    C1582.568726,182.815887 1581.366333,181.310501 1579.803589,180.496552 
    C1577.898926,179.504517 1575.691284,179.093842 1573.427002,178.371811 
    C1572.427002,174.615021 1567.408203,171.266510 1561.775269,170.015991 
    C1560.423706,168.601715 1558.647095,167.980408 1557.160034,166.943665 
    C1555.546631,165.818787 1554.327881,164.126953 1552.712524,163.005966 
    C1550.226562,161.280807 1547.272705,160.146652 1545.028931,158.178619 
    C1542.684937,156.122772 1535.478882,152.010895 1533.095581,150.945114 
    C1530.081909,149.597458 1527.515137,147.250443 1524.755737,145.334503 
    C1525.033081,144.839188 1525.310547,144.343857 1525.587891,143.848541 
    C1523.110596,143.848541 1520.633423,143.848541 1518.084106,143.445770 
    C1517.754395,137.441559 1513.289673,141.179138 1511.031982,139.495026 
    C1510.453369,138.052155 1510.069458,136.905655 1509.343262,136.049347 
    C1508.619873,135.196625 1507.583496,134.589096 1506.628540,133.958359 
    C1505.573364,133.261276 1504.493164,132.580322 1503.355347,132.035004 
    C1501.498413,131.144897 1499.586060,130.370453 1497.697021,129.547226 
    C1493.478760,126.813843 1488.365479,125.651283 1484.851318,122.629112 
    C1481.922119,120.109909 1479.231079,120.081528 1476.030762,119.490364 
    C1473.257324,116.797104 1470.815063,114.053261 1467.792603,112.323647 
    C1464.346924,110.352005 1460.383057,109.286491 1456.645874,107.823647 
    C1453.897705,106.747833 1451.026489,105.900993 1448.440308,104.520744 
    C1445.896729,103.163155 1443.643433,101.261688 1441.262695,99.598839 
    C1439.579102,97.822304 1426.719849,92.823372 1422.082397,93.571426 
    C1439.917358,102.575562 1457.708008,111.557327 1475.748047,120.773071 
    C1487.516968,127.477890 1499.036499,133.948730 1510.760010,140.687927 
    C1513.074951,142.183563 1515.185669,143.410828 1517.560547,144.856049 
    C1578.049072,181.276581 1633.612915,223.610245 1684.853027,271.683228 
    C1753.966431,336.524719 1812.805054,409.616150 1861.160034,491.101929 
    C1910.154663,573.665405 1946.609863,661.444031 1970.121704,754.572205 
    C1981.742676,800.601868 1990.656250,847.132812 1994.920410,894.424072 
    C1997.607422,924.223206 1999.017334,954.137390 2001.000000,984.000000 
    C2001.000000,995.025818 2001.000000,1006.051697 2000.999512,1017.945312 
    C2000.722046,1023.127747 2000.440796,1027.442139 2000.168823,1031.756958 
    C1998.788086,1053.667480 1998.096924,1075.648560 1995.853027,1097.470093 
    C1993.171631,1123.544800 1989.987549,1149.624634 1985.555542,1175.450562 
    C1976.611206,1227.570068 1963.257690,1278.625244 1945.897461,1328.612183 
    C1908.538940,1436.182129 1854.232788,1534.458130 1783.396851,1623.518799 
    C1731.113037,1689.253906 1671.308228,1747.447632 1604.380371,1798.221680 
    C1508.156128,1871.220947 1402.078003,1924.901978 1286.413330,1959.635376 
    C1246.233398,1971.701294 1205.332886,1980.739746 1164.010864,1987.810303 
    C1147.998535,1990.550049 1131.838013,1992.539551 1115.682617,1994.297119 
    C1098.339111,1996.183960 1080.923584,1997.408569 1063.537231,1998.897949 
    C1055.027222,1999.626953 1046.512573,2000.301025 1038.000000,2001.000000 
    C1014.640808,2001.000000 991.281677,2001.000000 967.225586,2000.642090 
    C946.946472,1999.148682 927.268799,1998.863403 907.804932,1996.675537 
    C879.648621,1993.510986 851.552002,1989.540405 823.599976,1984.891235 
    C770.792664,1976.108276 719.229431,1962.221680 668.788574,1944.369019 
    C587.798950,1915.703735 511.700592,1877.318604 440.571045,1829.021729 
    C359.153168,1773.739136 287.184265,1708.161865 225.439362,1631.579956 
    C205.437790,1606.771851 187.235733,1580.512939 168.155640,1554.640137 
    C167.823730,1554.138306 167.546677,1553.914185 167.198532,1553.348755 
    C164.622284,1549.141968 162.117111,1545.276733 159.441879,1541.114990 
    C152.994797,1530.768311 146.717773,1520.718140 140.325592,1510.336426 
    C134.925995,1500.918335 129.641541,1491.831421 124.279755,1482.412964 
    C122.978973,1479.888550 121.755531,1477.695923 120.407043,1475.171265 
    C111.343925,1457.216675 102.405853,1439.593872 93.467773,1421.971191 
    C93.103340,1424.786133 92.369385,1428.845947 93.911263,1430.094116 
    C97.352730,1432.879639 97.060455,1436.068970 96.956306,1439.611694 
    C98.383537,1439.950073 99.689919,1440.259766 100.795914,1440.521973 
    C101.529228,1443.879028 99.167091,1448.349365 103.599983,1448.409424 
    C105.311440,1452.137695 106.699097,1455.056274 107.997238,1458.014160 
    C109.717392,1461.933960 111.227715,1465.952637 113.103462,1469.794434 
    C114.132797,1471.902710 115.605164,1473.839966 117.141090,1475.628174 
    C117.608047,1476.171997 118.953682,1475.961182 119.914719,1476.538574 
    C119.932533,1478.898560 119.932533,1480.815918 119.932533,1483.016235 
    C121.486618,1483.016235 122.734833,1483.016235 123.966103,1483.469971 
    C123.949158,1486.210571 123.949158,1488.497437 123.949158,1490.713745 
    C125.520210,1490.994995 126.734550,1491.212280 127.948898,1491.429688 
    C127.575829,1491.712280 127.202759,1491.994873 126.829689,1492.277588 
    C130.151581,1498.459595 133.473465,1504.641602 136.929733,1511.073730 
    C137.604477,1511.073730 138.765091,1511.073730 139.934814,1511.506836 
    C140.132477,1513.881226 140.009369,1517.410645 140.557877,1517.518066 
    C146.011490,1518.588623 143.154495,1523.103638 144.923141,1525.504883 
    C146.625916,1526.728149 147.803070,1528.246338 148.788895,1529.880127 
    C151.172882,1533.830933 153.467651,1537.835693 155.976578,1542.123291 
    C156.565475,1542.123291 157.716156,1542.123291 158.894440,1542.546753 
    C160.307068,1546.722656 161.692062,1550.474976 163.013947,1554.056396 
    C164.669220,1554.056396 165.803452,1554.056396 166.923218,1554.299561 
    C166.908737,1554.542725 167.082458,1554.997681 167.052277,1555.443726 
    C167.022110,1557.514771 167.022110,1559.139893 167.022110,1560.275635 
    C168.598129,1561.045166 170.229523,1561.313721 170.858887,1562.253296 
    C172.423935,1564.589600 173.406525,1567.307007 174.857635,1569.731079 
    C176.448547,1572.388550 178.359940,1574.852173 180.023987,1577.468628 
    C181.415680,1579.656982 182.490234,1582.059570 183.990784,1584.163696 
    C187.241028,1588.721191 190.567154,1593.234131 194.071304,1597.597534 
    C196.286285,1600.355591 198.878571,1602.810669 202.017181,1606.166748 
    C202.133575,1607.996216 203.433777,1610.262451 205.375458,1613.005737 
    C207.079895,1615.413574 210.589111,1616.155029 211.367889,1619.831909 
    C211.776489,1621.761108 218.002182,1628.935059 218.071793,1630.713745 
    C221.038971,1633.177734 225.292130,1634.968262 225.627151,1637.317627 
    C226.592834,1644.089478 232.705841,1646.292725 235.924210,1650.927246 
    C238.253967,1654.282349 240.338501,1658.239990 244.830048,1659.904663 
    C246.551163,1660.542480 247.749954,1662.830688 248.974411,1664.520752 
    C252.173416,1668.936401 255.196594,1673.479858 258.417206,1677.879150 
    C259.479431,1679.330200 260.837708,1680.608032 262.226379,1681.766357 
    C264.386169,1683.568359 266.875153,1685.007690 268.878693,1686.956421 
    C271.101471,1689.118408 272.814331,1691.796509 274.969086,1694.038574 
    C277.794159,1696.978027 281.029694,1699.538818 283.714325,1702.591797 
    C285.543610,1704.671997 286.365479,1707.686401 288.307404,1709.605957 
    C290.335114,1711.610352 294.099884,1712.227539 295.472626,1714.456665 
    C299.950012,1721.727173 307.715179,1725.663574 312.622833,1732.537842 
    C315.357788,1736.368652 320.672516,1738.302612 323.644318,1742.031860 
    C328.272766,1747.840088 335.855560,1750.087524 339.917725,1756.540771 
    C340.588104,1757.605591 343.460999,1757.558350 343.236572,1760.146973 
    C346.328735,1760.305420 346.510071,1763.494385 348.277618,1764.947266 
    C351.656250,1767.724854 356.990295,1769.352539 358.578979,1772.806763 
    C361.350342,1778.832520 368.681732,1778.255493 371.429779,1783.828613 
    C372.526306,1786.052124 376.236389,1786.858032 377.807526,1789.004028 
    C380.832123,1793.135620 383.536072,1797.205322 387.330902,1796.442383 
    C393.036194,1800.629517 397.182800,1804.156738 401.788025,1806.919678 
    C406.633423,1809.827026 409.123108,1816.967651 415.568329,1815.215332 
    C419.401031,1819.253296 422.711121,1822.740723 425.537537,1825.718384 
    C428.277313,1827.276978 430.677155,1828.563110 432.996643,1829.980591 
    C436.284210,1831.989624 439.512512,1834.095581 442.766174,1836.160034 
    C444.138123,1836.532104 444.837250,1837.925903 445.929504,1838.859985 
    C449.258972,1841.707275 453.881287,1842.298584 456.986969,1846.016113 
    C459.021423,1848.451416 461.985626,1850.619751 465.925507,1851.312744 
    C468.579407,1851.779541 470.749908,1854.994507 473.136658,1856.980103 
    C472.907013,1857.328857 472.677368,1857.677612 472.447754,1858.026367 
    C474.745636,1858.026367 477.043518,1858.026367 479.678864,1858.026367 
    C479.903046,1859.354858 480.106415,1860.560059 480.313263,1861.785645 
    C482.563354,1861.951416 486.135864,1861.770874 486.241058,1862.291138 
    C487.295593,1867.506836 491.531799,1865.392822 494.405884,1866.186157 
    C495.678284,1870.444702 501.070801,1874.039917 506.561981,1874.081787 
    C506.734100,1879.789185 511.313721,1877.416992 514.622986,1878.216309 
    C514.857056,1879.430908 515.112976,1880.758545 515.383728,1882.163696 
    C518.018005,1882.163696 520.303894,1882.163696 522.689758,1882.163696 
    C522.900513,1883.622803 523.075928,1884.837280 523.169067,1885.481934 
    C525.773743,1886.074829 528.702637,1885.841064 529.837463,1887.155762 
    C534.721008,1892.814453 540.728516,1895.943848 547.985596,1897.004272 
    C548.608276,1897.095215 549.221741,1897.248901 549.718384,1897.348999 
    C549.978882,1898.774902 550.193359,1899.948853 550.399719,1901.078125 
    C552.964844,1901.078125 555.121033,1901.078125 557.559814,1901.078125 
    C557.828491,1902.435303 558.090698,1903.759399 558.365112,1905.145264 
    C561.007324,1905.145264 563.304138,1905.145264 565.919617,1905.145264 
    C564.962585,1912.580322 571.683044,1907.073608 574.159058,1910.235840 
    C576.027832,1912.622681 580.590088,1912.900635 582.650635,1913.645996 
    C585.614258,1915.178223 587.365295,1916.076782 589.110291,1916.987305 
    C590.876648,1917.908691 592.637024,1918.841797 594.400024,1919.769653 
    C594.249268,1920.122070 594.098572,1920.474487 593.947876,1920.826904 
    C596.219604,1920.957397 598.491333,1921.087891 600.667664,1921.213013 
    C600.959045,1922.749878 601.182495,1923.928223 601.345703,1924.789062 
    C604.519409,1925.623657 607.676514,1923.453003 609.936279,1927.807007 
    C610.832397,1929.533691 616.190186,1928.944702 619.516663,1929.410156 
    C619.366760,1929.826294 619.216919,1930.242554 619.067017,1930.658813 
    C620.897095,1931.448975 622.696167,1932.326050 624.569519,1932.995117 
    C625.605286,1933.364990 627.062866,1933.016113 627.821045,1933.625122 
    C632.358826,1937.270752 637.216187,1939.982666 643.229004,1939.988037 
    C644.699646,1939.989380 646.170288,1939.988281 647.640930,1939.988281 
    C648.303894,1941.943359 649.310364,1943.542969 650.601624,1943.821411 
    C654.016113,1944.557373 658.376465,1942.346191 660.275024,1947.438843 
    C660.447693,1947.902100 662.095703,1947.932129 663.064270,1947.958984 
    C665.541870,1948.028198 668.022644,1947.981934 670.566406,1947.981934 
    C670.977112,1949.437866 671.313599,1950.630615 671.497986,1951.284302 
    C674.478821,1952.003906 677.019104,1952.445923 679.437317,1953.253296 
    C681.508545,1953.944702 683.365295,1955.558716 685.449890,1955.867798 
    C689.042847,1956.400513 693.166077,1954.882446 695.318298,1959.536499 
    C695.568970,1960.078247 697.467041,1959.873413 698.604065,1959.987427 
    C701.726685,1960.300293 705.580200,1958.515869 707.176575,1963.233032 
    C707.362122,1963.781250 709.257080,1963.902466 710.371826,1963.953369 
    C712.688293,1964.059326 715.012878,1963.985352 717.373047,1963.985352 
    C718.011169,1965.414795 718.584045,1966.697876 719.180237,1968.033447 
    C722.655273,1968.033447 725.960083,1968.033447 729.846008,1968.033447 
    C729.118225,1972.779907 732.507935,1971.846924 735.236816,1972.014771 
    C738.496521,1972.215332 742.710876,1971.307373 744.784180,1972.997925 
    C747.862793,1975.508667 750.904358,1975.583008 754.263672,1976.023438 
    C761.132751,1976.924316 767.977783,1978.010376 774.826477,1979.060669 
    C775.263611,1979.127686 775.902039,1979.457642 776.017517,1979.807007 
    C777.490479,1984.264648 781.190918,1982.814209 784.275940,1982.985596 
    C786.749939,1983.122925 791.138550,1982.659668 791.389954,1983.475586 
    C793.093994,1989.007812 797.352356,1986.634399 800.557556,1986.909058 
    C804.691223,1987.263428 810.933350,1985.377075 812.624634,1987.440918 
    C816.776794,1992.507812 821.558533,1990.126953 826.024414,1991.057129 
    C828.439880,1991.560181 830.706604,1992.777832 833.040405,1993.672974 
    C836.533752,1995.033447 841.497925,1994.084961 844.040588,1996.136963 
    C847.665344,1999.062256 851.095093,1998.924194 854.920532,1998.970093 
    C859.251648,1999.021973 863.590576,1998.857300 867.910828,1999.080200 
    C868.970764,1999.134888 869.971802,2000.329468 871.000000,2001.000000 
    C581.068115,2001.000000 291.136292,2001.000000 1.000000,2001.000000 
    C1.000000,1691.974243 1.000000,1382.948364 1.410685,1073.243408 
    C2.194372,1073.572632 2.879100,1074.577148 2.892234,1075.590210 
    C3.025728,1085.887817 3.360112,1096.199219 2.943328,1106.478638 
    C2.788423,1110.299194 4.113848,1112.279419 7.121371,1114.358887 
    C7.194355,1123.812134 7.194355,1132.786987 7.194355,1141.898071 
    C8.304714,1142.534912 9.541231,1143.244019 11.324534,1144.266846 
    C10.872731,1140.613647 10.550659,1137.506958 10.094043,1134.420044 
    C9.084539,1127.595215 8.007382,1120.780396 7.026166,1113.509155 
    C7.073388,1111.563477 7.122328,1110.065308 7.020691,1108.577393 
    C5.314331,1083.596558 3.596269,1058.616577 1.839441,1033.639282 
    C1.776490,1032.744263 1.289417,1031.879028 1.000007,1031.000000 
    C1.000000,1010.640808 1.000000,990.281677 1.349537,969.214478 
    C3.245767,943.074890 4.792459,917.643311 6.339151,892.211792 
    C4.791260,894.250488 3.290494,896.699646 3.176389,899.211731 
    C2.807825,907.325928 3.022755,915.465088 2.811009,923.589417 
    C2.780992,924.741211 1.631409,925.863892 1.000004,927.000000 
  M324.139069,265.193024 
    C326.845276,262.664856 329.551453,260.136688 332.257629,257.608551 
    C331.980255,257.288605 331.702881,256.968689 331.425507,256.648743 
    C328.470886,259.262482 323.719910,259.717163 322.180145,265.089417 
    C320.929718,266.070679 319.679260,267.051971 318.428833,268.033234 
    C318.800720,268.458679 319.172577,268.884094 319.544434,269.309540 
    C320.887268,268.055084 322.230103,266.800629 324.139069,265.193024 
  M852.069031,10.941895 
    C846.574707,10.982346 841.073303,10.884916 835.591370,11.166334 
    C834.321350,11.231527 833.117859,12.590193 831.883728,13.353684 
    C833.204346,13.846324 834.597046,14.896344 835.833191,14.736353 
    C841.579590,13.992625 847.282593,12.913847 853.638123,12.013111 
    C854.350586,11.870660 855.063049,11.728209 857.138611,11.313223 
    C854.818665,11.162837 853.909851,11.103928 852.069031,10.941895 
  M62.080929,1346.386719 
    C59.668499,1339.202148 57.256069,1332.017700 54.843636,1324.833130 
    C54.076111,1328.251831 53.096680,1332.726440 54.819126,1334.370483 
    C57.825127,1337.239624 58.206955,1340.085571 58.048107,1343.543701 
    C57.919327,1346.347412 59.190681,1347.459351 61.926243,1347.984009 
    C62.192970,1352.075562 62.037849,1355.830933 64.806015,1359.814941 
    C67.727295,1364.019287 68.317238,1369.839600 69.951408,1374.945679 
    C70.250237,1375.879395 70.646492,1376.785034 71.044403,1377.682983 
    C71.661125,1379.074585 72.297699,1380.458130 72.961647,1381.827881 
    C74.781540,1385.582031 76.559135,1389.359619 78.513969,1393.042725 
    C78.823120,1393.625244 79.965584,1393.765503 81.113693,1394.288208 
    C74.899757,1378.316650 68.920883,1362.937866 62.898281,1347.576172 
    C62.805927,1347.340576 62.173634,1347.316650 62.080929,1346.386719 
  M1413.075928,89.896538 
    C1415.583740,90.987274 1418.091431,92.078018 1421.022705,93.352936 
    C1420.927856,91.615860 1420.856567,90.308937 1420.782837,88.959351 
    C1417.938477,88.959351 1415.488892,88.959351 1412.971558,88.071144 
    C1413.708862,84.646286 1411.408447,85.251984 1409.279785,84.917839 
    C1407.408813,84.624176 1405.696655,83.318832 1403.914429,82.460304 
    C1404.073486,81.947754 1404.232544,81.435196 1404.391602,80.922646 
    C1401.910889,80.922646 1399.135498,81.643974 1397.009399,80.775726 
    C1392.274292,78.841957 1387.911133,76.017654 1383.305542,73.740067 
    C1379.809204,72.010994 1376.249390,70.348244 1372.578979,69.048294 
    C1367.913086,67.395790 1362.202393,67.275040 1358.603516,64.408279 
    C1354.631104,61.244049 1351.092651,62.570400 1347.244019,62.366852 
    C1351.553589,64.357140 1355.996460,65.949593 1360.356445,67.743439 
    C1377.788330,74.915451 1395.194580,82.150070 1413.075928,89.896538 
  M11.065495,963.966614 
    C11.313454,963.949829 11.561414,963.932983 11.809374,963.916199 
    C11.811302,964.078613 11.817982,964.241150 11.814482,964.403442 
    C11.579837,975.281555 11.344371,986.159729 11.016056,997.966248 
    C11.346980,1017.078857 10.954655,1036.238403 12.190569,1055.292236 
    C13.760983,1079.502686 16.223358,1103.678955 19.107174,1127.773315 
    C21.452961,1147.372681 24.504301,1166.919189 28.095013,1186.331299 
    C35.027851,1223.811890 44.346424,1260.731689 55.843151,1297.088745 
    C57.900082,1303.593506 57.839973,1303.597046 64.038361,1301.570312 
    C93.174553,1292.043091 122.317352,1282.536133 151.450668,1273.000244 
    C277.731659,1231.666260 404.011749,1190.329590 530.273010,1148.935547 
    C532.052124,1148.352051 533.582886,1147.010986 536.020630,1146.012207 
    C537.312439,1146.613037 538.604309,1147.213745 539.896240,1147.814453 
    C538.564331,1149.204712 537.232483,1150.594849 535.110962,1151.889648 
    C524.179443,1155.321167 513.221313,1158.670654 502.322418,1162.202881 
    C484.630981,1167.936646 466.983185,1173.805176 449.307678,1179.588379 
    C432.420319,1185.113647 415.516602,1190.588867 398.628387,1196.111572 
    C379.881134,1202.242310 361.147949,1208.416260 342.399963,1214.544800 
    C325.353088,1220.117432 308.290833,1225.643066 291.242126,1231.210083 
    C273.721100,1236.931274 256.209534,1242.681396 238.691574,1248.411865 
    C220.577515,1254.337524 202.457703,1260.245605 184.346008,1266.178467 
    C166.672180,1271.967896 148.987808,1277.725952 131.341171,1283.597290 
    C117.408791,1288.232788 103.567429,1293.144165 89.608543,1297.696655 
    C79.600410,1300.960449 69.464928,1303.833862 59.287903,1306.911255 
    C59.790333,1308.666382 60.068172,1309.779053 60.425800,1310.865723 
    C81.954910,1376.277222 110.244263,1438.689209 144.722198,1498.234253 
    C206.764450,1605.383789 286.749329,1697.210083 383.261383,1774.604492 
    C483.668488,1855.122437 595.775024,1913.516724 719.119385,1950.193726 
    C741.076965,1956.722778 763.317688,1962.423950 785.652222,1967.523804 
    C805.562378,1972.069824 825.741394,1975.500122 845.882446,1978.951416 
    C858.673828,1981.143311 871.592163,1982.653076 884.491211,1984.143066 
    C900.066772,1985.941895 915.661621,1987.650146 931.287354,1988.911987 
    C942.041931,1989.780518 952.863220,1989.823730 963.522888,1989.786743 
    C975.030823,1990.155396 986.538757,1990.524048 998.847717,1990.564209 
    C998.898376,1988.569458 998.993225,1986.574829 998.993286,1984.580078 
    C999.000122,1818.382690 998.998962,1652.185303 999.006409,1485.987915 
    C999.006470,1483.993408 999.108704,1481.999023 999.901001,1480.000366 
    C1000.884338,1480.000732 1001.867676,1480.001099 1002.967957,1480.932007 
    C1002.967957,1650.835449 1002.967957,1820.738770 1002.967957,1990.017456 
    C1017.146362,1990.017456 1030.598877,1990.408569 1044.019653,1989.920532 
    C1061.623413,1989.280396 1079.287476,1988.706177 1096.770996,1986.733521 
    C1122.766724,1983.800537 1148.688965,1980.058472 1174.531250,1975.959229 
    C1219.002930,1968.904663 1262.463745,1957.519775 1305.281982,1943.714355 
    C1375.215332,1921.166138 1441.675171,1890.851929 1504.992310,1853.618042 
    C1559.484741,1821.573975 1610.245361,1784.387939 1657.466919,1742.384277 
    C1703.117798,1701.778076 1744.856567,1657.484497 1782.547485,1609.370483 
    C1819.734009,1561.899902 1852.014648,1511.282104 1879.736084,1457.779297 
    C1904.131592,1410.695557 1925.090942,1362.117310 1941.574097,1311.660889 
    C1942.438599,1309.014648 1942.665039,1307.491699 1939.315063,1306.570312 
    C1933.761841,1305.043213 1928.381836,1302.895508 1922.900757,1301.095215 
    C1904.447021,1295.033569 1885.982422,1289.005493 1867.519043,1282.973389 
    C1849.485107,1277.081665 1831.443481,1271.213135 1813.412476,1265.312012 
    C1794.760010,1259.207397 1776.119995,1253.064819 1757.467651,1246.959717 
    C1739.447388,1241.061279 1721.414673,1235.200806 1703.394165,1229.302979 
    C1684.744629,1223.199219 1666.104980,1217.065063 1647.457642,1210.954712 
    C1630.264038,1205.320923 1613.070557,1199.686157 1595.868164,1194.078979 
    C1577.085571,1187.956787 1558.300537,1181.841675 1539.501343,1175.770508 
    C1528.920166,1172.353394 1518.297119,1169.065430 1507.712891,1165.657349 
    C1493.698486,1161.144775 1479.703491,1156.572021 1465.019409,1151.877441 
    C1463.931152,1151.517334 1462.671143,1151.387451 1461.799438,1150.737061 
    C1460.779907,1149.976440 1460.098999,1148.761841 1459.271240,1147.744263 
    C1460.502930,1147.325439 1461.712280,1146.675781 1462.972778,1146.552734 
    C1464.233643,1146.429932 1465.545776,1146.833374 1467.153442,1147.667236 
    C1468.350220,1148.199707 1469.511475,1148.839722 1470.749023,1149.248901 
    C1496.849121,1157.875732 1522.946899,1166.509888 1549.067383,1175.074463 
    C1589.813599,1188.434814 1630.574951,1201.748413 1671.332275,1215.074585 
    C1708.336426,1227.173462 1745.361084,1239.209595 1782.345215,1251.369141 
    C1834.417480,1268.489624 1886.469727,1285.671021 1938.498169,1302.923828 
    C1942.526123,1304.259399 1944.388062,1303.370605 1945.541016,1299.207642 
    C1949.553589,1284.720825 1954.516846,1270.467651 1957.911743,1255.845459 
    C1964.774536,1226.286743 1971.175293,1196.609863 1977.100220,1166.848877 
    C1979.913452,1152.718628 1981.497559,1138.317383 1983.099976,1123.978760 
    C1985.339111,1103.942017 1987.173096,1083.857910 1988.980103,1063.776123 
    C1989.748901,1055.230835 1990.010864,1046.639771 1990.696167,1038.663818 
    C1990.497314,1038.644897 1990.281616,1038.663574 1990.109497,1038.585571 
    C1990.053345,1038.560181 1990.112793,1038.282959 1990.116699,1038.120972 
    C1990.376221,1027.399170 1990.635376,1016.677429 1990.984009,1005.096008 
    C1990.956299,1003.080933 1990.928711,1001.065918 1991.080566,998.119873 
    C1990.757812,986.955750 1990.433716,975.791626 1990.133911,964.626831 
    C1990.131226,964.523560 1990.453613,964.411499 1990.624146,964.303467 
    C1990.555908,964.453064 1990.487671,964.602600 1990.228760,963.366943 
    C1989.823242,957.937317 1989.410522,952.508301 1989.013916,947.078003 
    C1988.014404,933.399109 1987.236084,919.699951 1985.969238,906.046021 
    C1984.622070,891.528320 1983.404297,876.958252 1981.081909,862.580322 
    C1976.681274,835.336548 1972.384644,808.027710 1966.510864,781.080322 
    C1955.244385,729.392944 1939.028442,679.176208 1919.186646,630.110657 
    C1877.892700,527.997437 1821.198242,435.344330 1748.918335,352.256531 
    C1712.219727,310.070526 1672.327515,271.121185 1629.119507,235.604797 
    C1620.433716,228.465347 1611.571899,221.540009 1602.599365,214.362350 
    C1589.803467,230.980545 1577.425781,247.067291 1565.036011,263.144653 
    C1474.395142,380.762512 1383.748779,498.376038 1293.149414,616.025818 
    C1292.097534,617.391846 1291.646484,619.220459 1290.225220,621.037720 
    C1288.812988,621.720398 1287.400757,622.403137 1285.988525,623.085876 
    C1285.552734,622.735779 1285.117065,622.385742 1284.681274,622.035706 
    C1285.760620,620.123901 1286.839844,618.212097 1288.434082,615.823853 
    C1300.879150,599.707703 1313.337036,583.601440 1325.766235,567.473145 
    C1344.955933,542.571960 1364.119995,517.651001 1383.306396,492.747223 
    C1402.085693,468.371796 1420.924316,444.041962 1439.653320,419.628082 
    C1457.583252,396.255737 1475.314331,372.730499 1493.301147,349.402191 
    C1511.904419,325.274323 1530.736206,301.322662 1549.416626,277.254059 
    C1559.149658,264.713745 1568.773926,252.088837 1578.444458,239.499847 
    C1585.288940,230.589691 1592.128418,221.675598 1599.557617,211.997971 
    C1598.113159,210.928360 1596.809937,209.924042 1595.467529,208.975174 
    C1579.574341,197.741501 1563.809082,186.319443 1547.727295,175.362274 
    C1538.062012,168.776932 1527.940552,162.854477 1517.951050,156.753464 
    C1507.755981,150.526886 1497.572021,144.270432 1487.192993,138.360886 
    C1479.689819,134.088791 1471.916748,130.280762 1464.192505,126.408760 
    C1444.859863,116.717720 1425.581909,106.909119 1406.085693,97.556892 
    C1397.443359,93.411255 1388.302124,90.313141 1379.431763,86.632904 
    C1369.716919,82.602310 1360.161499,78.163582 1350.336426,74.429573 
    C1340.734009,70.780273 1330.877197,67.801338 1321.135742,64.517204 
    C1308.597778,60.290310 1296.153687,55.755989 1283.501465,51.905437 
    C1271.607788,48.285847 1259.570190,45.065357 1247.463013,42.238708 
    C1228.844604,37.891865 1210.144653,33.875431 1191.416504,30.024248 
    C1180.122437,27.701765 1168.729004,25.836424 1157.343628,23.991232 
    C1148.051880,22.485346 1138.710327,21.283077 1129.382690,20.005293 
    C1123.411987,19.187378 1117.428101,18.465422 1111.447510,17.721071 
    C1103.335693,16.711468 1095.241577,15.482370 1087.102051,14.795793 
    C1080.056030,14.201451 1072.948120,14.383626 1065.884277,13.948722 
    C1057.019287,13.402923 1048.180054,12.146366 1039.314209,11.969309 
    C1024.070801,11.664886 1008.814514,11.869992 993.565308,12.024381 
    C976.416260,12.198003 959.267334,12.479528 942.121887,12.867835 
    C936.195190,13.002063 930.267273,13.469952 924.360535,14.010412 
    C914.574097,14.905870 904.805908,15.998832 895.027100,16.979317 
    C888.033936,17.680477 880.994690,18.051710 874.049438,19.070915 
    C862.004456,20.838514 850.015930,22.991369 838.004517,24.987370 
    C825.515320,27.062773 812.905212,28.596794 800.566162,31.346558 
    C780.528748,35.811913 760.654236,41.015781 740.740723,46.026066 
    C730.410889,48.625065 720.053162,51.178593 709.875244,54.298115 
    C699.364807,57.519600 689.059814,61.410549 678.659790,64.993721 
    C670.267090,67.885277 661.823181,70.635017 653.486084,73.678040 
    C648.352661,75.551743 643.397949,77.909630 638.326599,79.960075 
    C626.712097,84.656097 614.988770,89.095177 603.477478,94.030159 
    C595.651184,97.385353 588.133728,101.455223 580.434570,105.113815 
    C568.977539,110.558128 557.311401,115.590820 546.046509,121.403755 
    C532.231567,128.532532 518.604431,136.053284 505.149933,143.843063 
    C494.864594,149.797989 484.978882,156.442474 474.906128,162.765457 
    C464.891968,169.051651 454.745911,175.137146 444.881409,181.649551 
    C436.040558,187.486176 427.445251,193.702316 418.851654,199.903564 
    C411.862701,204.946915 405.036713,210.216141 397.960938,215.518204 
    C503.246643,349.372955 608.191772,482.794769 713.499023,616.720520 
    C714.255981,617.554749 715.309326,618.272888 715.693420,619.253174 
    C716.152039,620.423950 716.037659,621.819214 716.171509,623.117188 
    C714.951294,622.755432 713.706604,622.457764 712.521301,622.004700 
    C711.934631,621.780457 711.457458,621.270020 710.898926,620.190735 
    C709.622681,618.290649 708.464294,616.297852 707.053406,614.503662 
    C605.299316,485.094055 503.526276,355.699341 401.744263,226.311676 
    C399.530457,223.497421 397.194855,220.778961 394.484100,217.492065 
    C376.244904,233.035355 358.246368,247.939758 340.729187,263.389923 
    C301.625092,297.879669 265.847504,335.642487 233.071655,376.138611 
    C216.247086,396.926208 200.747208,418.795898 184.923691,440.378174 
    C179.638397,447.587006 175.114029,455.364349 170.403381,462.981750 
    C158.623276,482.030884 146.734192,501.017700 135.308273,520.278320 
    C130.612137,528.194580 127.116180,536.814148 122.848190,544.995728 
    C119.121170,552.140320 114.823227,558.993103 111.234207,566.202148 
    C106.302773,576.107666 101.308838,586.030518 97.209534,596.292725 
    C85.115005,626.570007 72.745491,656.767334 61.789532,687.462097 
    C47.862961,726.479431 37.361805,766.549133 29.929012,807.319519 
    C25.321316,832.593872 21.401161,858.016357 18.034403,883.486267 
    C15.610605,901.822632 14.521309,920.339722 13.012390,938.790588 
    C12.307771,947.406555 12.018976,956.056641 11.065495,963.966614 
  M8.533077,879.164001 
    C10.559629,864.503113 12.586183,849.842224 14.612735,835.181335 
    C14.098827,834.999756 13.584921,834.818237 13.071013,834.636658 
    C12.414456,836.047607 11.291619,837.425781 11.189885,838.875671 
    C10.899354,843.016235 11.201508,847.199219 10.893465,851.337402 
    C10.778171,852.886230 9.644976,854.368530 8.933633,855.860962 
    C8.292611,857.206055 7.033703,858.513794 7.010246,859.854858 
    C6.842262,869.457825 6.920481,879.065125 6.920481,888.671021 
    C7.127742,888.667908 7.335004,888.664734 7.542266,888.661621 
    C7.794796,885.781921 8.047326,882.902283 8.533077,879.164001 
  M40.972073,1289.734131 
    C41.313736,1292.102539 41.638508,1294.473389 42.004795,1296.838013 
    C42.167633,1297.889282 42.121696,1299.631104 42.669743,1299.858887 
    C46.547302,1301.471069 46.169399,1304.710449 45.991959,1307.839233 
    C45.815739,1310.946167 47.191246,1311.496338 49.850311,1310.606934 
    C46.108555,1298.187134 42.415794,1285.929932 38.723034,1273.672729 
    C38.080463,1277.830566 37.920982,1281.903076 38.185726,1285.947754 
    C38.257385,1287.042725 39.612564,1288.053711 40.972073,1289.734131 
  M1158.708252,13.670837 
    C1161.294434,14.036755 1163.880737,14.402671 1166.716797,14.803937 
    C1166.807617,13.478589 1166.888062,12.304135 1166.968018,11.137262 
    C1159.417969,11.137262 1152.381836,11.137262 1145.345703,11.137262 
    C1145.328979,11.316952 1145.312378,11.496640 1145.295654,11.676330 
    C1149.490356,12.254539 1153.685181,12.832749 1158.708252,13.670837 
  M83.669479,1404.976074 
    C84.337486,1407.609497 85.005493,1410.242920 85.726418,1413.085083 
    C86.595421,1412.981445 87.800941,1412.837891 89.554947,1412.628906 
    C86.787491,1406.418457 84.262482,1400.752075 81.737473,1395.085693 
    C81.244888,1395.255127 80.752304,1395.424561 80.259727,1395.593994 
    C81.106285,1398.666992 81.952850,1401.739868 83.669479,1404.976074 
  M12.042981,1147.944580 
    C12.002506,1147.617310 12.012697,1147.272461 11.906678,1146.968018 
    C11.809059,1146.687744 11.586588,1146.451050 11.417639,1146.196045 
    C9.723130,1156.478516 10.767969,1164.872803 14.495932,1165.760498 
    C13.677026,1159.923340 12.890817,1154.319214 12.042981,1147.944580 
  M820.537842,15.013417 
    C818.544067,14.980868 816.464539,14.596284 814.589966,15.052931 
    C813.531311,15.310803 812.809814,16.952654 811.936462,17.971106 
    C812.318481,18.259327 812.700439,18.547548 813.082458,18.835770 
    C818.738647,17.778023 824.394775,16.720278 830.050964,15.662532 
    C830.017517,15.445657 829.984070,15.228783 829.950684,15.011908 
    C827.129395,15.011908 824.308167,15.011908 820.537842,15.013417 
  M1263.698853,34.026943 
    C1262.087036,34.026943 1260.475342,34.026943 1258.863525,34.026943 
    C1258.861084,34.317097 1258.858765,34.607250 1258.856323,34.897404 
    C1263.113647,35.995708 1267.370972,37.094017 1272.050049,38.301132 
    C1271.487061,31.828531 1267.195923,34.733624 1263.698853,34.026943 
  M33.178089,1253.157471 
    C32.342422,1249.861816 31.506760,1246.566162 30.671095,1243.270386 
    C30.824017,1248.070435 27.855343,1253.587280 34.038486,1257.844360 
    C33.744980,1255.969238 33.586956,1254.959595 33.178089,1253.157471 
  M38.093781,1271.513428 
    C36.982731,1267.350098 35.871681,1263.186768 34.760632,1259.023438 
    C34.052189,1262.332642 33.721478,1265.494629 34.205582,1268.526367 
    C34.416149,1269.845215 36.300762,1270.896606 38.093781,1271.513428 
  M1245.455811,31.220053 
    C1249.253784,32.232273 1253.051636,33.244495 1256.849609,34.256714 
    C1253.315796,27.991985 1248.083984,30.640249 1243.312134,30.837769 
    C1243.784668,30.933266 1244.257202,31.028761 1245.455811,31.220053 
  M1240.490479,28.843027 
    C1236.241089,24.393753 1230.934448,26.523510 1225.903564,26.873243 
    C1230.930176,27.760880 1235.956909,28.648514 1240.490479,28.843027 
  M1174.091431,14.903400 
    C1172.954712,15.022401 1171.817993,15.141401 1169.731445,15.359835 
    C1176.003418,16.438519 1181.375488,17.362419 1186.747559,18.286320 
    C1186.893311,17.839123 1187.039185,17.391924 1187.184937,16.944727 
    C1185.736084,16.297972 1184.334229,15.277143 1182.827637,15.087568 
    C1180.230469,14.760731 1177.568115,14.950948 1174.091431,14.903400 
  M26.983778,1239.180298 
    C27.762339,1239.895386 28.540899,1240.610596 29.319460,1241.325684 
    C29.606865,1241.080811 29.894270,1240.836060 30.181675,1240.591187 
    C29.014978,1235.972046 27.848282,1231.352783 26.681585,1226.733643 
    C26.328203,1226.797119 25.974821,1226.860596 25.621439,1226.924072 
    C26.121222,1230.718506 26.621002,1234.512939 26.983778,1239.180298 
  M16.022673,1172.971069 
    C15.883060,1172.195557 15.743447,1171.420166 15.603835,1170.644653 
    C15.061347,1175.146851 14.956292,1179.591919 15.158326,1184.022949 
    C15.194630,1184.818970 16.497398,1185.557373 17.215435,1186.322388 
    C17.526398,1186.016113 17.837360,1185.709961 18.148323,1185.403687 
    C17.465059,1181.508179 16.781796,1177.612549 16.022673,1172.971069 
  M762.532104,29.932978 
    C766.882263,28.819326 771.232483,27.705673 775.582642,26.592022 
    C772.693420,25.911022 769.885620,25.703705 767.121277,25.961489 
    C763.340454,26.314066 762.286011,27.279160 762.532104,29.932978 
  M1285.037720,40.317356 
    C1281.784302,35.859882 1277.453003,39.115131 1273.676025,38.369740 
    C1276.889038,39.810097 1280.144165,40.916279 1283.456787,41.809422 
    C1284.049194,41.969162 1284.879272,41.247498 1285.037720,40.317356 
  M17.249943,820.927063 
    C17.552637,819.304810 17.855330,817.682495 18.307236,815.260559 
    C14.828101,817.741272 14.067435,824.348999 15.745305,830.727295 
    C16.226002,827.579407 16.669212,824.677002 17.249943,820.927063 
  M1197.093384,20.542379 
    C1200.014282,20.148188 1203.547485,24.086763 1207.067383,19.116951 
    C1201.453613,19.116951 1197.059570,19.116951 1192.665649,19.116951 
    C1192.633789,19.334227 1192.602051,19.551502 1192.570312,19.768776 
    C1193.833008,19.938316 1195.095703,20.107855 1197.093384,20.542379 
  M1321.007080,53.586281 
    C1321.673462,53.295460 1322.339722,53.004639 1323.005981,52.713852 
    C1322.498169,51.838230 1322.053955,50.258575 1321.471802,50.205933 
    C1318.585327,49.944942 1315.662598,50.086948 1312.752563,50.086948 
    C1312.757690,50.355690 1312.762939,50.624428 1312.768066,50.893169 
    C1315.265137,51.671883 1317.762329,52.450596 1321.007080,53.586281 
  M23.010006,1218.666260 
    C23.010006,1220.770874 23.010006,1222.875366 23.010006,1225.117432 
    C26.647638,1223.935669 26.595308,1221.462769 23.010952,1212.354126 
    C23.010952,1214.477539 23.010952,1216.130005 23.010006,1218.666260 
  M1329.224854,56.280277 
    C1331.004639,56.946289 1332.784302,57.612301 1334.741943,58.344887 
    C1334.516724,53.586460 1332.439819,52.921535 1324.745117,54.733139 
    C1326.067017,55.225521 1327.263794,55.671310 1329.224854,56.280277 
  M1304.428589,48.150429 
    C1306.523315,48.782749 1308.617920,49.415070 1310.886475,50.099861 
    C1310.190552,45.862309 1307.244629,45.034733 1299.933838,46.666607 
    C1301.266602,47.144768 1302.466919,47.575344 1304.428589,48.150429 
  M50.031281,1315.262573 
    C50.048969,1322.681152 50.048969,1322.681152 54.031807,1322.596436 
    C52.890511,1319.308838 51.775887,1316.098022 50.193115,1311.538574 
    C50.079792,1313.547607 50.052761,1314.026855 50.031281,1315.262573 
  M317.506348,271.474274 
    C317.506348,271.474274 317.504700,271.512512 317.506348,271.474274 
  z"/>
  <path fill="#000000" opacity="1.000000" stroke="none" 
    d="
  M2001.000000,1135.000000 
    C2001.000000,1423.598022 2001.000000,1712.195923 2001.000000,2001.000000 
    C1712.637329,2001.000000 1424.274536,2001.000000 1135.539185,2000.574951 
    C1136.263794,1999.763916 1137.354126,1999.069092 1138.459595,1999.044189 
    C1143.788208,1998.924438 1149.136597,1999.217896 1154.444092,1998.860352 
    C1156.401855,1998.728516 1158.266602,1997.212646 1160.173706,1996.328003 
    C1160.042236,1995.877075 1159.910889,1995.426025 1159.779419,1994.975098 
    C1163.937500,1994.975098 1168.106689,1995.153076 1172.248291,1994.892456 
    C1174.047363,1994.779175 1175.816040,1993.829956 1177.549927,1993.138550 
    C1179.127808,1992.509277 1180.579102,1991.358154 1182.196167,1991.082764 
    C1184.300415,1990.724243 1186.552734,1990.745361 1188.670532,1991.067627 
    C1192.084106,1991.586914 1194.290771,1990.677612 1194.451782,1987.515747 
    C1202.672729,1985.175293 1211.156738,1990.016968 1218.786011,1983.360474 
    C1221.482422,1981.007935 1227.442383,1983.363037 1231.775391,1980.388550 
    C1234.256470,1978.685425 1238.395142,1979.410767 1241.783447,1979.007690 
    C1242.870361,1978.878296 1244.876587,1978.673218 1244.885620,1978.441528 
    C1245.054688,1974.089478 1248.330566,1976.492432 1250.134644,1976.021973 
    C1253.661499,1975.101807 1257.288208,1974.569580 1260.832031,1973.706299 
    C1262.210205,1973.370605 1263.422607,1972.322754 1264.802124,1972.027954 
    C1272.243286,1970.437012 1280.118896,1969.967041 1287.028564,1967.125732 
    C1291.511841,1965.282104 1296.046997,1964.993652 1300.202026,1963.516113 
    C1303.630737,1962.296997 1306.505127,1959.302734 1310.737183,1959.677979 
    C1311.209961,1959.719971 1311.697144,1958.747681 1312.284790,1958.500610 
    C1314.424561,1957.601074 1316.634644,1956.868530 1318.770142,1955.959595 
    C1320.562988,1955.196289 1322.288574,1954.274902 1324.043823,1953.423462 
    C1327.795166,1950.738525 1333.006592,1954.229736 1336.468018,1949.320923 
    C1339.214844,1945.425293 1346.772949,1951.708374 1347.645020,1943.934570 
    C1349.724121,1943.934570 1351.542725,1943.934570 1353.417114,1943.934570 
    C1353.857788,1942.540039 1354.265259,1941.250610 1354.503174,1940.497803 
    C1359.026978,1938.708496 1364.366333,1942.612305 1367.335938,1936.967651 
    C1367.459351,1936.733154 1368.292603,1936.918823 1368.777222,1936.820435 
    C1374.987427,1935.559814 1381.197144,1934.296265 1387.395752,1932.980957 
    C1387.807373,1932.893677 1388.089844,1932.313965 1388.499146,1932.079102 
    C1391.044922,1930.617065 1393.609863,1929.187988 1396.792480,1927.397095 
    C1396.602173,1921.815308 1402.213013,1926.502441 1404.809082,1924.513916 
    C1404.955200,1923.596069 1405.147949,1922.385254 1405.338745,1921.187134 
    C1413.618286,1921.529663 1420.024780,1917.956909 1425.907349,1912.930176 
    C1427.555908,1912.930176 1429.204346,1912.930176 1430.852783,1912.930176 
    C1432.030762,1910.959351 1433.803589,1910.107910 1435.361938,1908.963989 
    C1438.913452,1906.357300 1442.536499,1904.172852 1447.215820,1904.351807 
    C1447.640015,1904.367920 1448.146240,1902.240234 1448.661499,1900.994385 
    C1451.037598,1900.994385 1453.337402,1900.994385 1455.825684,1900.994385 
    C1456.003296,1899.640259 1456.163818,1898.416748 1456.324341,1897.193237 
    C1456.627197,1897.562378 1456.930054,1897.931396 1457.232910,1898.300537 
    C1459.764282,1896.860596 1462.143677,1894.836792 1464.865601,1894.127930 
    C1468.293335,1893.235474 1469.733521,1888.029785 1474.307861,1889.976562 
    C1474.543091,1890.076538 1475.084473,1889.474243 1475.475464,1889.188477 
    C1477.472290,1887.729736 1479.466675,1886.267700 1481.461914,1884.806763 
    C1481.760864,1885.147827 1482.059937,1885.489014 1482.358887,1885.830078 
    C1482.797241,1884.536987 1483.235596,1883.243774 1483.705811,1881.856689 
    C1486.305054,1881.856689 1488.595947,1881.856689 1490.886841,1881.856689 
    C1490.680298,1881.371338 1490.473755,1880.885986 1490.267212,1880.400635 
    C1491.627930,1879.594727 1492.978638,1878.770996 1494.352173,1877.987427 
    C1495.894775,1877.107300 1497.444092,1876.236938 1499.017334,1875.413696 
    C1500.021362,1874.888428 1501.061157,1874.425659 1502.106934,1873.987305 
    C1504.179321,1873.119019 1506.267090,1872.287354 1508.348511,1871.440552 
    C1508.209106,1870.937256 1508.069824,1870.433960 1507.930542,1869.930664 
    C1509.581665,1869.930664 1511.232910,1869.930664 1511.760376,1869.930664 
    C1515.097900,1867.018311 1517.632935,1864.806152 1520.941650,1861.918823 
    C1521.816284,1861.918823 1523.783447,1861.918823 1525.750610,1861.918823 
    C1525.455933,1861.484375 1525.161133,1861.050049 1524.866455,1860.615601 
    C1527.907349,1858.410034 1530.878174,1856.098389 1534.009155,1854.029175 
    C1537.067261,1852.008057 1540.288940,1850.234497 1543.438721,1848.352295 
    C1543.196289,1847.945190 1542.953735,1847.538086 1542.711182,1847.131104 
    C1545.584106,1846.354980 1550.227173,1849.143188 1550.307861,1844.870239 
    C1560.397095,1837.464478 1571.057739,1832.792603 1577.351807,1824.140747 
    C1580.545410,1822.926880 1583.089722,1822.438721 1585.045776,1821.094604 
    C1587.484131,1819.419189 1589.281860,1816.836670 1591.639893,1815.012573 
    C1594.628174,1812.701050 1597.695679,1810.284546 1601.114014,1808.797974 
    C1604.185303,1807.462036 1605.005249,1803.347656 1609.646118,1803.514648 
    C1612.026489,1803.600342 1614.559814,1799.439941 1617.023926,1797.198486 
    C1622.216187,1793.414673 1628.877441,1791.459351 1632.130737,1784.815063 
    C1632.341675,1784.384277 1633.269043,1784.359497 1633.750488,1783.996460 
    C1635.869873,1782.398193 1638.140259,1780.932373 1639.972900,1779.046143 
    C1641.183838,1777.799683 1646.386108,1772.560059 1647.400391,1771.960571 
    C1649.994263,1770.427124 1653.254028,1769.224487 1654.827026,1766.920044 
    C1658.509644,1761.525513 1665.033447,1759.067383 1668.131348,1753.135864 
    C1669.031616,1751.412109 1671.260620,1749.173828 1672.813232,1749.224731 
    C1677.589722,1749.381104 1679.287842,1745.250122 1682.194946,1743.127319 
    C1685.484497,1740.725708 1687.558350,1736.702759 1690.335693,1733.538208 
    C1691.800049,1731.869751 1693.609009,1730.495239 1695.312988,1729.047729 
    C1697.511597,1727.179810 1699.835815,1725.453613 1701.965698,1723.512573 
    C1703.839844,1721.804932 1705.433716,1719.789307 1707.310303,1718.084595 
    C1709.416992,1716.170776 1711.890869,1714.635620 1713.855835,1712.598877 
    C1715.720337,1710.666138 1716.729614,1707.080688 1718.831421,1706.384521 
    C1722.711426,1705.098877 1723.620117,1701.645020 1725.927246,1699.297363 
    C1728.748413,1696.426880 1730.917480,1692.887939 1733.861694,1690.172852 
    C1738.515259,1685.881836 1743.708618,1682.178589 1748.399414,1677.924438 
    C1750.044800,1676.432129 1750.871216,1674.041870 1752.089600,1672.072754 
    C1753.912598,1669.126831 1755.099609,1664.901245 1757.742554,1663.564819 
    C1761.349121,1661.741211 1762.491333,1658.398071 1765.040771,1656.067871 
    C1767.997314,1653.365601 1770.864380,1650.768921 1773.062744,1647.151489 
    C1775.991699,1642.331787 1780.292114,1638.347778 1783.985107,1633.989258 
    C1785.630371,1632.047607 1786.849365,1629.342285 1788.927368,1628.249878 
    C1793.835205,1625.669800 1796.225830,1621.974243 1796.216919,1616.587280 
    C1801.156250,1614.554077 1815.816772,1598.150024 1815.209106,1590.448975 
    C1820.583496,1585.285767 1827.113770,1581.697388 1827.397339,1572.795654 
    C1832.240845,1575.480103 1829.965088,1569.971802 1831.961670,1569.103516 
    C1836.094116,1567.306030 1837.877686,1563.828491 1839.033813,1559.796387 
    C1839.225830,1559.126709 1839.743896,1558.518677 1840.209961,1557.965332 
    C1842.155273,1555.656738 1844.593262,1553.626709 1846.000366,1551.033203 
    C1848.075439,1547.208862 1849.411133,1542.985107 1851.109253,1538.951538 
    C1851.267212,1538.576294 1851.782104,1538.361572 1852.101562,1538.042480 
    C1855.304688,1534.843628 1859.575684,1532.214722 1857.953735,1526.670044 
    C1862.499756,1525.370972 1865.860229,1520.703979 1866.215332,1515.172852 
    C1872.570312,1515.481079 1868.977417,1510.388062 1870.390747,1507.379761 
    C1871.445435,1507.171997 1872.774414,1506.910278 1873.776123,1506.712891 
    C1874.713867,1503.353760 1871.571289,1498.501099 1878.124512,1498.674927 
    C1878.124512,1496.099365 1878.124512,1493.791260 1878.124512,1491.483154 
    C1878.516968,1491.667725 1878.909302,1491.852417 1879.301758,1492.036987 
    C1887.410156,1481.363525 1893.101318,1469.374878 1898.274902,1456.125488 
    C1898.456177,1456.096191 1899.667603,1455.901001 1901.036987,1455.680298 
    C1901.036987,1453.254272 1901.036987,1450.957642 1901.036987,1448.414673 
    C1907.477539,1448.397705 1903.934814,1443.122314 1905.413696,1440.297363 
    C1906.629639,1440.113525 1907.838501,1439.930786 1909.151001,1439.732422 
    C1909.151001,1437.102295 1909.151001,1434.803589 1909.151001,1432.143433 
    C1910.506226,1432.036865 1911.717163,1431.941772 1912.530029,1431.877930 
    C1913.018311,1429.288086 1912.665039,1426.086304 1913.988770,1425.070679 
    C1918.382690,1421.699585 1917.319092,1415.848389 1920.732300,1412.040283 
    C1921.866821,1410.774414 1920.911255,1407.635254 1920.911255,1405.338623 
    C1922.661499,1405.063354 1923.861572,1404.874512 1925.116699,1404.677124 
    C1925.116699,1402.030640 1925.116699,1399.725952 1925.116699,1397.421143 
    C1925.604492,1397.565552 1926.092163,1397.709961 1926.579956,1397.854248 
    C1927.381104,1396.213501 1928.321289,1394.622803 1928.935547,1392.914795 
    C1929.360107,1391.734741 1928.966553,1389.518433 1929.569092,1389.265015 
    C1933.383545,1387.660767 1932.313843,1384.198120 1933.009521,1381.404175 
    C1933.293823,1380.262329 1933.646118,1379.114746 1934.147217,1378.054565 
    C1935.006470,1376.236694 1936.058350,1374.509888 1936.925049,1372.695190 
    C1937.312012,1371.884766 1937.463379,1370.186890 1937.692383,1370.192017 
    C1941.277588,1370.272949 1939.829712,1367.622559 1939.942383,1366.023682 
    C1940.115845,1363.561523 1939.988037,1361.078125 1939.988037,1358.336914 
    C1941.451904,1358.095337 1942.652344,1357.897217 1943.823120,1357.704102 
    C1943.973633,1354.268799 1943.008545,1348.853271 1944.472168,1348.088989 
    C1948.694824,1345.884155 1947.849609,1342.777954 1948.054443,1339.553833 
    C1948.086060,1339.055176 1948.669556,1338.612305 1948.913330,1338.103027 
    C1949.955322,1335.926025 1951.425537,1333.822144 1951.867310,1331.523926 
    C1952.382080,1328.845703 1951.987549,1325.992920 1951.987549,1323.190674 
    C1953.671997,1323.042725 1954.757568,1322.947510 1955.990479,1322.839233 
    C1955.990479,1318.993286 1955.990479,1315.359497 1955.990479,1311.725586 
    C1956.496216,1311.848633 1957.001953,1311.971680 1957.507568,1312.094604 
    C1958.342163,1309.963989 1959.389648,1307.887451 1959.950195,1305.687134 
    C1960.489258,1303.571289 1960.234619,1301.240967 1960.854126,1299.161377 
    C1961.622681,1296.580811 1963.011353,1294.191284 1963.968506,1291.657349 
    C1964.358765,1290.624756 1964.108398,1288.537964 1964.506470,1288.443970 
    C1969.578491,1287.247070 1967.595093,1283.237549 1967.987305,1280.198608 
    C1968.154053,1278.907227 1967.875977,1276.775879 1968.516724,1276.454224 
    C1972.985229,1274.211548 1971.535156,1270.090942 1971.971436,1266.606567 
    C1972.216675,1264.646851 1971.457397,1261.379150 1972.358276,1260.880127 
    C1977.390015,1258.092529 1975.336548,1253.481445 1975.941772,1249.574829 
    C1976.165161,1248.133301 1976.197388,1245.482788 1976.590820,1245.430054 
    C1980.412354,1244.918213 1978.764893,1242.098755 1978.935303,1240.220215 
    C1979.234131,1236.925659 1978.018188,1231.646729 1979.604126,1230.651123 
    C1985.053589,1227.229980 1982.178345,1222.487549 1982.989624,1218.406738 
    C1983.265869,1217.017700 1983.190186,1214.561401 1983.784424,1214.393433 
    C1987.905273,1213.228760 1986.943237,1210.072388 1986.970459,1207.296631 
    C1987.012695,1202.988892 1986.981689,1198.680542 1986.981689,1194.372437 
    C1987.546631,1194.534668 1988.111572,1194.696777 1988.676514,1194.859009 
    C1989.444824,1193.221436 1990.788940,1191.613770 1990.875977,1189.940796 
    C1991.161377,1184.456299 1990.933960,1178.947021 1991.040161,1173.449829 
    C1991.061768,1172.331543 1991.532959,1171.151245 1992.052368,1170.129150 
    C1992.928711,1168.404419 1994.689087,1166.852539 1994.867432,1165.104614 
    C1995.288086,1160.982300 1994.964722,1156.786865 1995.012573,1152.621826 
    C1995.025635,1151.488770 1994.907471,1149.659546 1995.497803,1149.337280 
    C2000.409668,1146.656250 1998.596680,1142.079834 1999.078247,1138.101929 
    C1999.210815,1137.006470 2000.332397,1136.030640 2001.000000,1135.000000 
  z"/>
  <path fill="#ADADAD" opacity="1.000000" stroke="none" 
    d="
  M2001.000000,1134.531372 
    C2000.332397,1136.030640 1999.210815,1137.006470 1999.078247,1138.101929 
    C1998.596680,1142.079834 2000.409668,1146.656250 1995.497803,1149.337280 
    C1994.907471,1149.659546 1995.025635,1151.488770 1995.012573,1152.621826 
    C1994.964722,1156.786865 1995.288086,1160.982300 1994.867432,1165.104614 
    C1994.689087,1166.852539 1992.928711,1168.404419 1992.052368,1170.129150 
    C1991.532959,1171.151245 1991.061768,1172.331543 1991.040161,1173.449829 
    C1990.933960,1178.947021 1991.161377,1184.456299 1990.875977,1189.940796 
    C1990.788940,1191.613770 1989.444824,1193.221436 1988.676514,1194.859009 
    C1988.111572,1194.696777 1987.546631,1194.534668 1986.981689,1194.372437 
    C1986.981689,1198.680542 1987.012695,1202.988892 1986.970459,1207.296631 
    C1986.943237,1210.072388 1987.905273,1213.228760 1983.784424,1214.393433 
    C1983.190186,1214.561401 1983.265869,1217.017700 1982.989624,1218.406738 
    C1982.178345,1222.487549 1985.053589,1227.229980 1979.604126,1230.651123 
    C1978.018188,1231.646729 1979.234131,1236.925659 1978.935303,1240.220215 
    C1978.764893,1242.098755 1980.412354,1244.918213 1976.590820,1245.430054 
    C1976.197388,1245.482788 1976.165161,1248.133301 1975.941772,1249.574829 
    C1975.336548,1253.481445 1977.390015,1258.092529 1972.358276,1260.880127 
    C1971.457397,1261.379150 1972.216675,1264.646851 1971.971436,1266.606567 
    C1971.535156,1270.090942 1972.985229,1274.211548 1968.516724,1276.454224 
    C1967.875977,1276.775879 1968.154053,1278.907227 1967.987305,1280.198608 
    C1967.595093,1283.237549 1969.578491,1287.247070 1964.506470,1288.443970 
    C1964.108398,1288.537964 1964.358765,1290.624756 1963.968506,1291.657349 
    C1963.011353,1294.191284 1961.622681,1296.580811 1960.854126,1299.161377 
    C1960.234619,1301.240967 1960.489258,1303.571289 1959.950195,1305.687134 
    C1959.389648,1307.887451 1958.342163,1309.963989 1957.507568,1312.094604 
    C1957.001953,1311.971680 1956.496216,1311.848633 1955.990479,1311.725586 
    C1955.990479,1315.359497 1955.990479,1318.993286 1955.990479,1322.839233 
    C1954.757568,1322.947510 1953.671997,1323.042725 1951.987549,1323.190674 
    C1951.987549,1325.992920 1952.382080,1328.845703 1951.867310,1331.523926 
    C1951.425537,1333.822144 1949.955322,1335.926025 1948.913330,1338.103027 
    C1948.669556,1338.612305 1948.086060,1339.055176 1948.054443,1339.553833 
    C1947.849609,1342.777954 1948.694824,1345.884155 1944.472168,1348.088989 
    C1943.008545,1348.853271 1943.973633,1354.268799 1943.823120,1357.704102 
    C1942.652344,1357.897217 1941.451904,1358.095337 1939.988037,1358.336914 
    C1939.988037,1361.078125 1940.115845,1363.561523 1939.942383,1366.023682 
    C1939.829712,1367.622559 1941.277588,1370.272949 1937.692383,1370.192017 
    C1937.463379,1370.186890 1937.312012,1371.884766 1936.925049,1372.695190 
    C1936.058350,1374.509888 1935.006470,1376.236694 1934.147217,1378.054565 
    C1933.646118,1379.114746 1933.293823,1380.262329 1933.009521,1381.404175 
    C1932.313843,1384.198120 1933.383545,1387.660767 1929.569092,1389.265015 
    C1928.966553,1389.518433 1929.360107,1391.734741 1928.935547,1392.914795 
    C1928.321289,1394.622803 1927.381104,1396.213501 1926.579956,1397.854248 
    C1926.092163,1397.709961 1925.604492,1397.565552 1925.116699,1397.421143 
    C1925.116699,1399.725952 1925.116699,1402.030640 1925.116699,1404.677124 
    C1923.861572,1404.874512 1922.661499,1405.063354 1920.911255,1405.338623 
    C1920.911255,1407.635254 1921.866821,1410.774414 1920.732300,1412.040283 
    C1917.319092,1415.848389 1918.382690,1421.699585 1913.988770,1425.070679 
    C1912.665039,1426.086304 1913.018311,1429.288086 1912.530029,1431.877930 
    C1911.717163,1431.941772 1910.506226,1432.036865 1909.151001,1432.143433 
    C1909.151001,1434.803589 1909.151001,1437.102295 1909.151001,1439.732422 
    C1907.838501,1439.930786 1906.629639,1440.113525 1905.413696,1440.297363 
    C1903.934814,1443.122314 1907.477539,1448.397705 1901.036987,1448.414673 
    C1901.036987,1450.957642 1901.036987,1453.254272 1901.036987,1455.680298 
    C1899.667603,1455.901001 1898.456177,1456.096191 1898.274902,1456.125488 
    C1893.101318,1469.374878 1887.410156,1481.363525 1879.301758,1492.036987 
    C1878.909302,1491.852417 1878.516968,1491.667725 1878.124512,1491.483154 
    C1878.124512,1493.791260 1878.124512,1496.099365 1878.124512,1498.674927 
    C1871.571289,1498.501099 1874.713867,1503.353760 1873.776123,1506.712891 
    C1872.774414,1506.910278 1871.445435,1507.171997 1870.390747,1507.379761 
    C1868.977417,1510.388062 1872.570312,1515.481079 1866.215332,1515.172852 
    C1865.860229,1520.703979 1862.499756,1525.370972 1857.953735,1526.670044 
    C1859.575684,1532.214722 1855.304688,1534.843628 1852.101562,1538.042480 
    C1851.782104,1538.361572 1851.267212,1538.576294 1851.109253,1538.951538 
    C1849.411133,1542.985107 1848.075439,1547.208862 1846.000366,1551.033203 
    C1844.593262,1553.626709 1842.155273,1555.656738 1840.209961,1557.965332 
    C1839.743896,1558.518677 1839.225830,1559.126709 1839.033813,1559.796387 
    C1837.877686,1563.828491 1836.094116,1567.306030 1831.961670,1569.103516 
    C1829.965088,1569.971802 1832.240845,1575.480103 1827.397339,1572.795654 
    C1827.113770,1581.697388 1820.583496,1585.285767 1815.209106,1590.448975 
    C1815.816772,1598.150024 1801.156250,1614.554077 1796.216919,1616.587280 
    C1796.225830,1621.974243 1793.835205,1625.669800 1788.927368,1628.249878 
    C1786.849365,1629.342285 1785.630371,1632.047607 1783.985107,1633.989258 
    C1780.292114,1638.347778 1775.991699,1642.331787 1773.062744,1647.151489 
    C1770.864380,1650.768921 1767.997314,1653.365601 1765.040771,1656.067871 
    C1762.491333,1658.398071 1761.349121,1661.741211 1757.742554,1663.564819 
    C1755.099609,1664.901245 1753.912598,1669.126831 1752.089600,1672.072754 
    C1750.871216,1674.041870 1750.044800,1676.432129 1748.399414,1677.924438 
    C1743.708618,1682.178589 1738.515259,1685.881836 1733.861694,1690.172852 
    C1730.917480,1692.887939 1728.748413,1696.426880 1725.927246,1699.297363 
    C1723.620117,1701.645020 1722.711426,1705.098877 1718.831421,1706.384521 
    C1716.729614,1707.080688 1715.720337,1710.666138 1713.855835,1712.598877 
    C1711.890869,1714.635620 1709.416992,1716.170776 1707.310303,1718.084595 
    C1705.433716,1719.789307 1703.839844,1721.804932 1701.965698,1723.512573 
    C1699.835815,1725.453613 1697.511597,1727.179810 1695.312988,1729.047729 
    C1693.609009,1730.495239 1691.800049,1731.869751 1690.335693,1733.538208 
    C1687.558350,1736.702759 1685.484497,1740.725708 1682.194946,1743.127319 
    C1679.287842,1745.250122 1677.589722,1749.381104 1672.813232,1749.224731 
    C1671.260620,1749.173828 1669.031616,1751.412109 1668.131348,1753.135864 
    C1665.033447,1759.067383 1658.509644,1761.525513 1654.827026,1766.920044 
    C1653.254028,1769.224487 1649.994263,1770.427124 1647.400391,1771.960571 
    C1646.386108,1772.560059 1641.183838,1777.799683 1639.972900,1779.046143 
    C1638.140259,1780.932373 1635.869873,1782.398193 1633.750488,1783.996460 
    C1633.269043,1784.359497 1632.341675,1784.384277 1632.130737,1784.815063 
    C1628.877441,1791.459351 1622.216187,1793.414673 1617.023926,1797.198486 
    C1614.559814,1799.439941 1612.026489,1803.600342 1609.646118,1803.514648 
    C1605.005249,1803.347656 1604.185303,1807.462036 1601.114014,1808.797974 
    C1597.695679,1810.284546 1594.628174,1812.701050 1591.639893,1815.012573 
    C1589.281860,1816.836670 1587.484131,1819.419189 1585.045776,1821.094604 
    C1583.089722,1822.438721 1580.545410,1822.926880 1577.351807,1824.140747 
    C1571.057739,1832.792603 1560.397095,1837.464478 1550.307861,1844.870239 
    C1550.227173,1849.143188 1545.584106,1846.354980 1542.711182,1847.131104 
    C1542.953735,1847.538086 1543.196289,1847.945190 1543.438721,1848.352295 
    C1540.288940,1850.234497 1537.067261,1852.008057 1534.009155,1854.029175 
    C1530.878174,1856.098389 1527.907349,1858.410034 1524.866455,1860.615601 
    C1525.161133,1861.050049 1525.455933,1861.484375 1525.750610,1861.918823 
    C1523.783447,1861.918823 1521.816284,1861.918823 1520.941650,1861.918823 
    C1517.632935,1864.806152 1515.097900,1867.018311 1511.760376,1869.930664 
    C1511.232910,1869.930664 1509.581665,1869.930664 1507.930542,1869.930664 
    C1508.069824,1870.433960 1508.209106,1870.937256 1508.348511,1871.440552 
    C1506.267090,1872.287354 1504.179321,1873.119019 1502.106934,1873.987305 
    C1501.061157,1874.425659 1500.021362,1874.888428 1499.017334,1875.413696 
    C1497.444092,1876.236938 1495.894775,1877.107300 1494.352173,1877.987427 
    C1492.978638,1878.770996 1491.627930,1879.594727 1490.267212,1880.400635 
    C1490.473755,1880.885986 1490.680298,1881.371338 1490.886841,1881.856689 
    C1488.595947,1881.856689 1486.305054,1881.856689 1483.705811,1881.856689 
    C1483.235596,1883.243774 1482.797241,1884.536987 1482.358887,1885.830078 
    C1482.059937,1885.489014 1481.760864,1885.147827 1481.461914,1884.806763 
    C1479.466675,1886.267700 1477.472290,1887.729736 1475.475464,1889.188477 
    C1475.084473,1889.474243 1474.543091,1890.076538 1474.307861,1889.976562 
    C1469.733521,1888.029785 1468.293335,1893.235474 1464.865601,1894.127930 
    C1462.143677,1894.836792 1459.764282,1896.860596 1457.232910,1898.300537 
    C1456.930054,1897.931396 1456.627197,1897.562378 1456.324341,1897.193237 
    C1456.163818,1898.416748 1456.003296,1899.640259 1455.825684,1900.994385 
    C1453.337402,1900.994385 1451.037598,1900.994385 1448.661499,1900.994385 
    C1448.146240,1902.240234 1447.640015,1904.367920 1447.215820,1904.351807 
    C1442.536499,1904.172852 1438.913452,1906.357300 1435.361938,1908.963989 
    C1433.803589,1910.107910 1432.030762,1910.959351 1430.852783,1912.930176 
    C1429.204346,1912.930176 1427.555908,1912.930176 1425.907349,1912.930176 
    C1420.024780,1917.956909 1413.618286,1921.529663 1405.338745,1921.187134 
    C1405.147949,1922.385254 1404.955200,1923.596069 1404.809082,1924.513916 
    C1402.213013,1926.502441 1396.602173,1921.815308 1396.792480,1927.397095 
    C1393.609863,1929.187988 1391.044922,1930.617065 1388.499146,1932.079102 
    C1388.089844,1932.313965 1387.807373,1932.893677 1387.395752,1932.980957 
    C1381.197144,1934.296265 1374.987427,1935.559814 1368.777222,1936.820435 
    C1368.292603,1936.918823 1367.459351,1936.733154 1367.335938,1936.967651 
    C1364.366333,1942.612305 1359.026978,1938.708496 1354.503174,1940.497803 
    C1354.265259,1941.250610 1353.857788,1942.540039 1353.417114,1943.934570 
    C1351.542725,1943.934570 1349.724121,1943.934570 1347.645020,1943.934570 
    C1346.772949,1951.708374 1339.214844,1945.425293 1336.468018,1949.320923 
    C1333.006592,1954.229736 1327.795166,1950.738525 1324.043823,1953.423462 
    C1322.288574,1954.274902 1320.562988,1955.196289 1318.770142,1955.959595 
    C1316.634644,1956.868530 1314.424561,1957.601074 1312.284790,1958.500610 
    C1311.697144,1958.747681 1311.209961,1959.719971 1310.737183,1959.677979 
    C1306.505127,1959.302734 1303.630737,1962.296997 1300.202026,1963.516113 
    C1296.046997,1964.993652 1291.511841,1965.282104 1287.028564,1967.125732 
    C1280.118896,1969.967041 1272.243286,1970.437012 1264.802124,1972.027954 
    C1263.422607,1972.322754 1262.210205,1973.370605 1260.832031,1973.706299 
    C1257.288208,1974.569580 1253.661499,1975.101807 1250.134644,1976.021973 
    C1248.330566,1976.492432 1245.054688,1974.089478 1244.885620,1978.441528 
    C1244.876587,1978.673218 1242.870361,1978.878296 1241.783447,1979.007690 
    C1238.395142,1979.410767 1234.256470,1978.685425 1231.775391,1980.388550 
    C1227.442383,1983.363037 1221.482422,1981.007935 1218.786011,1983.360474 
    C1211.156738,1990.016968 1202.672729,1985.175293 1194.451782,1987.515747 
    C1194.290771,1990.677612 1192.084106,1991.586914 1188.670532,1991.067627 
    C1186.552734,1990.745361 1184.300415,1990.724243 1182.196167,1991.082764 
    C1180.579102,1991.358154 1179.127808,1992.509277 1177.549927,1993.138550 
    C1175.816040,1993.829956 1174.047363,1994.779175 1172.248291,1994.892456 
    C1168.106689,1995.153076 1163.937500,1994.975098 1159.779419,1994.975098 
    C1159.910889,1995.426025 1160.042236,1995.877075 1160.173706,1996.328003 
    C1158.266602,1997.212646 1156.401855,1998.728516 1154.444092,1998.860352 
    C1149.136597,1999.217896 1143.788208,1998.924438 1138.459595,1999.044189 
    C1137.354126,1999.069092 1136.263794,1999.763916 1135.083252,2000.574951 
    C1102.979126,2001.000000 1070.958130,2001.000000 1038.468628,2001.000000 
    C1046.512573,2000.301025 1055.027222,1999.626953 1063.537231,1998.897949 
    C1080.923584,1997.408569 1098.339111,1996.183960 1115.682617,1994.297119 
    C1131.838013,1992.539551 1147.998535,1990.550049 1164.010864,1987.810303 
    C1205.332886,1980.739746 1246.233398,1971.701294 1286.413330,1959.635376 
    C1402.078003,1924.901978 1508.156128,1871.220947 1604.380371,1798.221680 
    C1671.308228,1747.447632 1731.113037,1689.253906 1783.396851,1623.518799 
    C1854.232788,1534.458130 1908.538940,1436.182129 1945.897461,1328.612183 
    C1963.257690,1278.625244 1976.611206,1227.570068 1985.555542,1175.450562 
    C1989.987549,1149.624634 1993.171631,1123.544800 1995.853027,1097.470093 
    C1998.096924,1075.648560 1998.788086,1053.667480 2000.168823,1031.756958 
    C2000.440796,1027.442139 2000.722046,1023.127747 2000.999512,1018.406555 
    C2001.000000,1056.687622 2001.000000,1095.375122 2001.000000,1134.531372 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M2001.000000,983.531372 
    C1999.017334,954.137390 1997.607422,924.223206 1994.920410,894.424072 
    C1990.656250,847.132812 1981.742676,800.601868 1970.121704,754.572205 
    C1946.609863,661.444031 1910.154663,573.665405 1861.160034,491.101929 
    C1812.805054,409.616150 1753.966431,336.524719 1684.853027,271.683228 
    C1633.612915,223.610245 1578.049072,181.276581 1517.779541,144.663147 
    C1517.875244,144.117722 1518.015747,143.983139 1518.156128,143.848541 
    C1520.633423,143.848541 1523.110596,143.848541 1525.587891,143.848541 
    C1525.310547,144.343857 1525.033081,144.839188 1524.755737,145.334503 
    C1527.515137,147.250443 1530.081909,149.597458 1533.095581,150.945114 
    C1535.478882,152.010895 1542.684937,156.122772 1545.028931,158.178619 
    C1547.272705,160.146652 1550.226562,161.280807 1552.712524,163.005966 
    C1554.327881,164.126953 1555.546631,165.818787 1557.160034,166.943665 
    C1558.647095,167.980408 1560.423706,168.601715 1561.775269,170.015991 
    C1567.408203,171.266510 1572.427002,174.615021 1573.427002,178.371811 
    C1575.691284,179.093842 1577.898926,179.504517 1579.803589,180.496552 
    C1581.366333,181.310501 1582.568726,182.815887 1584.071655,183.885925 
    C1586.191406,185.965027 1588.094604,189.487518 1590.472656,189.844070 
    C1596.810913,190.794418 1599.753784,195.771011 1604.070435,199.143631 
    C1605.965698,200.624374 1608.220947,201.644394 1610.484009,202.470932 
    C1613.950806,205.997589 1617.417480,209.524246 1621.545044,213.723236 
    C1626.318604,212.996429 1629.256348,216.689438 1632.247803,221.181000 
    C1633.693848,223.352341 1637.258179,223.999893 1639.557983,225.740860 
    C1643.479248,228.709442 1647.014160,232.197220 1650.993652,235.076843 
    C1653.546631,236.924164 1654.089233,240.917206 1658.270752,241.316010 
    C1659.042847,241.389618 1660.426880,244.731293 1662.662476,246.088943 
    C1664.716309,247.336227 1665.437134,250.590149 1667.304443,252.374924 
    C1670.449341,255.380783 1673.729248,258.512268 1677.524902,260.494812 
    C1681.277344,262.454865 1683.694336,265.194916 1686.539307,268.080261 
    C1689.106079,270.683258 1691.985229,273.540253 1695.048584,275.930603 
    C1697.712524,278.009186 1699.620483,281.032013 1702.173706,283.284943 
    C1704.260376,285.126068 1707.035034,286.196838 1709.081299,288.071411 
    C1710.999146,289.828217 1712.758301,292.005493 1713.854248,294.341644 
    C1714.916382,296.605530 1718.779297,295.571136 1718.692993,299.537598 
    C1718.658569,301.121643 1722.737183,302.708008 1724.805298,304.456879 
    C1726.079956,305.534851 1727.347900,306.772705 1728.181030,308.195282 
    C1732.115356,314.913116 1739.021362,318.577911 1744.109253,324.056976 
    C1746.626953,326.768188 1748.054443,330.491943 1750.647095,334.900024 
    C1752.009766,336.156036 1754.502197,338.438568 1756.977661,340.739471 
    C1759.202271,342.807373 1761.449219,344.853973 1763.607788,346.989410 
    C1765.048828,348.415192 1766.488403,349.880096 1767.683472,351.507568 
    C1769.267212,353.664459 1770.430298,356.144440 1772.110474,358.212341 
    C1773.753662,360.234558 1775.824585,361.908173 1777.696289,363.746429 
    C1778.218018,364.258789 1778.954224,364.729828 1779.158081,365.360138 
    C1780.520874,369.574921 1783.808350,371.850372 1787.127075,374.455322 
    C1790.386841,377.014099 1792.947876,380.577301 1795.390747,384.002716 
    C1796.299072,385.276428 1796.002563,387.409332 1796.184937,388.665405 
    C1798.553589,390.679230 1802.178711,392.230530 1802.563599,394.365906 
    C1803.893677,401.744720 1810.317627,404.691772 1814.170654,409.800690 
    C1815.300171,411.298279 1814.966553,413.899475 1815.277100,415.829865 
    C1820.188599,420.504486 1826.800537,423.859253 1827.371216,432.156586 
    C1830.697388,434.754974 1834.668579,436.918701 1835.276001,442.481873 
    C1835.526123,444.772308 1838.609741,446.776764 1840.475098,448.847595 
    C1840.846802,449.260223 1842.042114,449.502228 1842.013672,449.621887 
    C1840.872070,454.415558 1845.810669,455.962738 1847.295532,459.402313 
    C1848.888672,463.092712 1851.700806,466.257355 1853.985718,469.648254 
    C1854.534546,470.462585 1855.173218,471.224792 1855.646729,472.079620 
    C1856.824951,474.206085 1857.931519,476.372223 1859.549194,479.435486 
    C1862.783203,479.549957 1862.265747,483.021790 1861.848267,486.607422 
    C1867.778564,486.719757 1865.462036,491.174286 1866.080566,493.996918 
    C1870.152954,497.253052 1875.379028,499.593353 1873.901611,506.523468 
    C1875.267822,506.769714 1876.482300,506.988617 1877.892822,507.242859 
    C1877.892822,509.491974 1877.892822,511.785065 1877.892822,514.388489 
    C1879.324463,514.735657 1880.640259,515.054749 1882.076660,515.403137 
    C1882.076660,517.787903 1882.076660,520.088623 1882.076660,522.389343 
    C1882.493652,522.215332 1882.910645,522.041382 1883.327637,521.867371 
    C1884.582153,523.690491 1885.988159,525.429199 1887.060669,527.353760 
    C1889.454468,531.649414 1890.901001,536.798950 1894.193848,540.177307 
    C1897.576294,543.647522 1895.435303,549.360413 1900.280884,551.912537 
    C1901.302368,552.450500 1901.002441,555.497253 1901.346802,557.604492 
    C1906.983643,557.806885 1904.318115,562.399048 1905.270264,565.591614 
    C1906.287842,565.768860 1907.510010,565.981689 1908.988525,566.239197 
    C1909.218140,569.349243 1907.567871,573.544922 1912.868652,574.075256 
    C1913.303589,578.296265 1912.475464,582.159790 1916.337769,585.892883 
    C1919.276123,588.732788 1919.410034,594.390015 1921.076660,598.683228 
    C1921.552124,599.907898 1923.022217,600.746399 1924.444702,601.454773 
    C1925.287109,604.463013 1923.954224,608.238892 1927.884888,610.657898 
    C1928.907471,611.287231 1928.781128,613.986694 1928.943115,615.757263 
    C1929.125000,617.743652 1928.219360,620.230530 1931.663086,620.232483 
    C1931.846191,620.232605 1932.156982,621.012085 1932.191772,621.446106 
    C1932.647339,627.137390 1938.329346,631.313354 1936.864136,637.579102 
    C1936.731689,638.146118 1936.993042,639.318481 1937.285278,639.395142 
    C1942.040649,640.643799 1939.111572,644.579712 1940.174805,647.084595 
    C1940.596924,646.965332 1941.019165,646.846130 1941.441406,646.726929 
    C1942.290527,648.772278 1943.537720,650.751465 1943.891235,652.879211 
    C1944.367676,655.745911 1942.968018,659.189819 1947.485474,660.231628 
    C1947.979370,660.345520 1947.903809,663.217651 1947.971069,664.815552 
    C1948.047852,666.635559 1947.988892,668.461365 1947.988892,670.570679 
    C1954.439575,670.612183 1951.060425,675.701599 1952.251587,678.535950 
    C1952.688232,678.406189 1953.124878,678.276428 1953.561523,678.146606 
    C1954.358398,679.859741 1955.555908,681.506287 1955.854492,683.302307 
    C1956.259277,685.736450 1955.957886,688.285278 1955.996704,690.784363 
    C1956.009521,691.604065 1955.912964,693.026550 1956.247437,693.151184 
    C1962.779297,695.585205 1958.792114,701.325256 1960.250854,705.312073 
    C1960.638306,705.192871 1961.025635,705.073669 1961.413086,704.954407 
    C1962.277588,706.834656 1963.523926,708.638306 1963.919800,710.612427 
    C1964.561523,713.813782 1962.105469,718.251770 1967.817261,718.951416 
    C1967.053589,724.489502 1968.931396,729.195923 1971.213623,733.864990 
    C1971.831299,735.128784 1971.873169,736.728394 1971.958374,738.186707 
    C1972.128906,741.107300 1971.930908,743.623474 1974.288208,746.445251 
    C1976.209717,748.745483 1975.419556,753.248169 1976.022339,756.741272 
    C1976.297241,758.333374 1974.574707,761.127258 1978.290039,761.130310 
    C1978.519775,761.130554 1978.863159,763.046021 1978.955933,764.088013 
    C1979.271606,767.634338 1978.084106,771.176636 1982.194580,774.123352 
    C1983.854004,775.312866 1982.546875,780.324768 1983.076660,783.516418 
    C1983.430298,785.646301 1984.643066,787.633606 1985.471313,789.684753 
    C1985.976440,789.511169 1986.481689,789.337646 1986.986938,789.164124 
    C1986.986938,793.151611 1986.652588,797.178223 1987.113770,801.111633 
    C1987.385864,803.432617 1988.947266,805.593872 1989.870850,807.850708 
    C1990.310181,808.924438 1990.902954,810.046936 1990.928833,811.158997 
    C1991.045654,816.155823 1990.874146,821.160400 1991.034668,826.154846 
    C1991.111206,828.538879 1989.510010,831.791504 1993.916992,832.575073 
    C1994.527954,832.683655 1994.931519,835.477417 1994.965576,837.038269 
    C1995.088989,842.699829 1995.014282,848.365784 1995.014282,854.447693 
    C1999.155518,854.809814 1999.156372,857.748657 1999.083496,861.056396 
    C1999.033813,863.308105 1999.770264,865.577148 2000.577637,867.919250 
    C2001.000000,906.354248 2001.000000,944.708435 2001.000000,983.531372 
  z"/>
  <path fill="#AEAEAE" opacity="1.000000" stroke="none" 
    d="
  M168.210480,1554.917725 
    C187.235733,1580.512939 205.437790,1606.771851 225.439362,1631.579956 
    C287.184265,1708.161865 359.153168,1773.739136 440.571045,1829.021729 
    C511.700592,1877.318604 587.798950,1915.703735 668.788574,1944.369019 
    C719.229431,1962.221680 770.792664,1976.108276 823.599976,1984.891235 
    C851.552002,1989.540405 879.648621,1993.510986 907.804932,1996.675537 
    C927.268799,1998.863403 946.946472,1999.148682 966.764282,2000.642090 
    C935.312439,2001.000000 903.624878,2001.000000 871.468628,2001.000000 
    C869.971802,2000.329468 868.970764,1999.134888 867.910828,1999.080200 
    C863.590576,1998.857300 859.251648,1999.021973 854.920532,1998.970093 
    C851.095093,1998.924194 847.665344,1999.062256 844.040588,1996.136963 
    C841.497925,1994.084961 836.533752,1995.033447 833.040405,1993.672974 
    C830.706604,1992.777832 828.439880,1991.560181 826.024414,1991.057129 
    C821.558533,1990.126953 816.776794,1992.507812 812.624634,1987.440918 
    C810.933350,1985.377075 804.691223,1987.263428 800.557556,1986.909058 
    C797.352356,1986.634399 793.093994,1989.007812 791.389954,1983.475586 
    C791.138550,1982.659668 786.749939,1983.122925 784.275940,1982.985596 
    C781.190918,1982.814209 777.490479,1984.264648 776.017517,1979.807007 
    C775.902039,1979.457642 775.263611,1979.127686 774.826477,1979.060669 
    C767.977783,1978.010376 761.132751,1976.924316 754.263672,1976.023438 
    C750.904358,1975.583008 747.862793,1975.508667 744.784180,1972.997925 
    C742.710876,1971.307373 738.496521,1972.215332 735.236816,1972.014771 
    C732.507935,1971.846924 729.118225,1972.779907 729.846008,1968.033447 
    C725.960083,1968.033447 722.655273,1968.033447 719.180237,1968.033447 
    C718.584045,1966.697876 718.011169,1965.414795 717.373047,1963.985352 
    C715.012878,1963.985352 712.688293,1964.059326 710.371826,1963.953369 
    C709.257080,1963.902466 707.362122,1963.781250 707.176575,1963.233032 
    C705.580200,1958.515869 701.726685,1960.300293 698.604065,1959.987427 
    C697.467041,1959.873413 695.568970,1960.078247 695.318298,1959.536499 
    C693.166077,1954.882446 689.042847,1956.400513 685.449890,1955.867798 
    C683.365295,1955.558716 681.508545,1953.944702 679.437317,1953.253296 
    C677.019104,1952.445923 674.478821,1952.003906 671.497986,1951.284302 
    C671.313599,1950.630615 670.977112,1949.437866 670.566406,1947.981934 
    C668.022644,1947.981934 665.541870,1948.028198 663.064270,1947.958984 
    C662.095703,1947.932129 660.447693,1947.902100 660.275024,1947.438843 
    C658.376465,1942.346191 654.016113,1944.557373 650.601624,1943.821411 
    C649.310364,1943.542969 648.303894,1941.943359 647.640930,1939.988281 
    C646.170288,1939.988281 644.699646,1939.989380 643.229004,1939.988037 
    C637.216187,1939.982666 632.358826,1937.270752 627.821045,1933.625122 
    C627.062866,1933.016113 625.605286,1933.364990 624.569519,1932.995117 
    C622.696167,1932.326050 620.897095,1931.448975 619.067017,1930.658813 
    C619.216919,1930.242554 619.366760,1929.826294 619.516663,1929.410156 
    C616.190186,1928.944702 610.832397,1929.533691 609.936279,1927.807007 
    C607.676514,1923.453003 604.519409,1925.623657 601.345703,1924.789062 
    C601.182495,1923.928223 600.959045,1922.749878 600.667664,1921.213013 
    C598.491333,1921.087891 596.219604,1920.957397 593.947876,1920.826904 
    C594.098572,1920.474487 594.249268,1920.122070 594.400024,1919.769653 
    C592.637024,1918.841797 590.876648,1917.908691 589.110291,1916.987305 
    C587.365295,1916.076782 585.614258,1915.178223 582.650635,1913.645996 
    C580.590088,1912.900635 576.027832,1912.622681 574.159058,1910.235840 
    C571.683044,1907.073608 564.962585,1912.580322 565.919617,1905.145264 
    C563.304138,1905.145264 561.007324,1905.145264 558.365112,1905.145264 
    C558.090698,1903.759399 557.828491,1902.435303 557.559814,1901.078125 
    C555.121033,1901.078125 552.964844,1901.078125 550.399719,1901.078125 
    C550.193359,1899.948853 549.978882,1898.774902 549.718384,1897.348999 
    C549.221741,1897.248901 548.608276,1897.095215 547.985596,1897.004272 
    C540.728516,1895.943848 534.721008,1892.814453 529.837463,1887.155762 
    C528.702637,1885.841064 525.773743,1886.074829 523.169067,1885.481934 
    C523.075928,1884.837280 522.900513,1883.622803 522.689758,1882.163696 
    C520.303894,1882.163696 518.018005,1882.163696 515.383728,1882.163696 
    C515.112976,1880.758545 514.857056,1879.430908 514.622986,1878.216309 
    C511.313721,1877.416992 506.734100,1879.789185 506.561981,1874.081787 
    C501.070801,1874.039917 495.678284,1870.444702 494.405884,1866.186157 
    C491.531799,1865.392822 487.295593,1867.506836 486.241058,1862.291138 
    C486.135864,1861.770874 482.563354,1861.951416 480.313263,1861.785645 
    C480.106415,1860.560059 479.903046,1859.354858 479.678864,1858.026367 
    C477.043518,1858.026367 474.745636,1858.026367 472.447754,1858.026367 
    C472.677368,1857.677612 472.907013,1857.328857 473.136658,1856.980103 
    C470.749908,1854.994507 468.579407,1851.779541 465.925507,1851.312744 
    C461.985626,1850.619751 459.021423,1848.451416 456.986969,1846.016113 
    C453.881287,1842.298584 449.258972,1841.707275 445.929504,1838.859985 
    C444.837250,1837.925903 444.138123,1836.532104 442.766174,1836.160034 
    C439.512512,1834.095581 436.284210,1831.989624 432.996643,1829.980591 
    C430.677155,1828.563110 428.277313,1827.276978 425.537537,1825.718384 
    C422.711121,1822.740723 419.401031,1819.253296 415.568329,1815.215332 
    C409.123108,1816.967651 406.633423,1809.827026 401.788025,1806.919678 
    C397.182800,1804.156738 393.036194,1800.629517 387.330902,1796.442383 
    C383.536072,1797.205322 380.832123,1793.135620 377.807526,1789.004028 
    C376.236389,1786.858032 372.526306,1786.052124 371.429779,1783.828613 
    C368.681732,1778.255493 361.350342,1778.832520 358.578979,1772.806763 
    C356.990295,1769.352539 351.656250,1767.724854 348.277618,1764.947266 
    C346.510071,1763.494385 346.328735,1760.305420 343.236572,1760.146973 
    C343.460999,1757.558350 340.588104,1757.605591 339.917725,1756.540771 
    C335.855560,1750.087524 328.272766,1747.840088 323.644318,1742.031860 
    C320.672516,1738.302612 315.357788,1736.368652 312.622833,1732.537842 
    C307.715179,1725.663574 299.950012,1721.727173 295.472626,1714.456665 
    C294.099884,1712.227539 290.335114,1711.610352 288.307404,1709.605957 
    C286.365479,1707.686401 285.543610,1704.671997 283.714325,1702.591797 
    C281.029694,1699.538818 277.794159,1696.978027 274.969086,1694.038574 
    C272.814331,1691.796509 271.101471,1689.118408 268.878693,1686.956421 
    C266.875153,1685.007690 264.386169,1683.568359 262.226379,1681.766357 
    C260.837708,1680.608032 259.479431,1679.330200 258.417206,1677.879150 
    C255.196594,1673.479858 252.173416,1668.936401 248.974411,1664.520752 
    C247.749954,1662.830688 246.551163,1660.542480 244.830048,1659.904663 
    C240.338501,1658.239990 238.253967,1654.282349 235.924210,1650.927246 
    C232.705841,1646.292725 226.592834,1644.089478 225.627151,1637.317627 
    C225.292130,1634.968262 221.038971,1633.177734 218.071793,1630.713745 
    C218.002182,1628.935059 211.776489,1621.761108 211.367889,1619.831909 
    C210.589111,1616.155029 207.079895,1615.413574 205.375458,1613.005737 
    C203.433777,1610.262451 202.133575,1607.996216 202.017181,1606.166748 
    C198.878571,1602.810669 196.286285,1600.355591 194.071304,1597.597534 
    C190.567154,1593.234131 187.241028,1588.721191 183.990784,1584.163696 
    C182.490234,1582.059570 181.415680,1579.656982 180.023987,1577.468628 
    C178.359940,1574.852173 176.448547,1572.388550 174.857635,1569.731079 
    C173.406525,1567.307007 172.423935,1564.589600 170.858887,1562.253296 
    C170.229523,1561.313721 168.598129,1561.045166 167.022110,1560.275635 
    C167.022110,1559.139893 167.022110,1557.514771 167.334717,1555.429932 
    C167.835052,1554.952515 168.022766,1554.935181 168.210480,1554.917725 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M1101.531372,1.000001 
    C1102.634766,1.665165 1103.239258,2.867719 1103.909424,2.905409 
    C1107.397217,3.101603 1110.908936,2.863244 1114.398682,3.042048 
    C1118.050781,3.229174 1122.092407,1.562315 1124.724854,6.458108 
    C1125.405518,7.724002 1130.024658,6.843740 1132.831909,7.001604 
    C1136.504761,7.208150 1140.629517,6.043613 1144.191406,11.155616 
    C1139.538086,10.699112 1136.085815,10.346806 1132.630859,10.023640 
    C1104.996094,7.438777 1077.371826,4.729796 1049.719604,2.347364 
    C1039.787964,1.491680 1029.787964,1.426795 1019.409607,1.000499 
    C1046.354248,1.000000 1073.708496,1.000000 1101.531372,1.000001 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M968.531372,1.000000 
    C967.790039,1.314524 966.587830,1.868855 965.368896,1.908672 
    C930.492126,3.047974 895.760132,5.818170 861.233704,10.976526 
    C860.277039,11.119456 859.280396,10.994572 858.302368,10.994572 
    C858.107605,10.515076 857.912842,10.035580 857.718079,9.556084 
    C859.645752,8.713903 861.518738,7.350420 863.512695,7.141494 
    C867.295593,6.745136 871.150513,6.919501 874.970337,7.031364 
    C877.685303,7.110870 880.111389,7.127535 881.615112,4.162063 
    C881.988098,3.426461 883.777771,3.135447 884.925659,3.112442 
    C890.911194,2.992483 896.901611,3.101962 902.885803,2.950989 
    C904.408142,2.912582 905.913818,2.215367 907.213623,1.410428 
    C927.354248,1.000000 947.708435,1.000000 968.531372,1.000000 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M7.048388,1113.880615 
    C4.113848,1112.279419 2.788423,1110.299194 2.943328,1106.478638 
    C3.360112,1096.199219 3.025728,1085.887817 2.892234,1075.590210 
    C2.879100,1074.577148 2.194372,1073.572632 1.410685,1072.782104 
    C1.000000,1059.312378 1.000000,1045.624878 1.000007,1031.468628 
    C1.289417,1031.879028 1.776490,1032.744263 1.839441,1033.639282 
    C3.596269,1058.616577 5.314331,1083.596558 7.020691,1108.577393 
    C7.122328,1110.065308 7.073388,1111.563477 7.052461,1113.493042 
    C7.010409,1113.929199 7.048388,1113.880615 7.048388,1113.880615 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M1.000004,927.468628 
    C1.631409,925.863892 2.780992,924.741211 2.811009,923.589417 
    C3.022755,915.465088 2.807825,907.325928 3.176389,899.211731 
    C3.290494,896.699646 4.791260,894.250488 6.339151,892.211792 
    C4.792459,917.643311 3.245767,943.074890 1.349537,968.753174 
    C1.000000,955.312439 1.000000,941.624878 1.000004,927.468628 
  z"/>
  <path fill="#22B14C" opacity="1.000000" stroke="none" 
    d="
  M1465.700073,1152.025146 
    C1479.703491,1156.572021 1493.698486,1161.144775 1507.712891,1165.657349 
    C1518.297119,1169.065430 1528.920166,1172.353394 1539.501343,1175.770508 
    C1558.300537,1181.841675 1577.085571,1187.956787 1595.868164,1194.078979 
    C1613.070557,1199.686157 1630.264038,1205.320923 1647.457642,1210.954712 
    C1666.104980,1217.065063 1684.744629,1223.199219 1703.394165,1229.302979 
    C1721.414673,1235.200806 1739.447388,1241.061279 1757.467651,1246.959717 
    C1776.119995,1253.064819 1794.760010,1259.207397 1813.412476,1265.312012 
    C1831.443481,1271.213135 1849.485107,1277.081665 1867.519043,1282.973389 
    C1885.982422,1289.005493 1904.447021,1295.033569 1922.900757,1301.095215 
    C1928.381836,1302.895508 1933.761841,1305.043213 1939.315063,1306.570312 
    C1942.665039,1307.491699 1942.438599,1309.014648 1941.574097,1311.660889 
    C1925.090942,1362.117310 1904.131592,1410.695557 1879.736084,1457.779297 
    C1852.014648,1511.282104 1819.734009,1561.899902 1782.547485,1609.370483 
    C1744.856567,1657.484497 1703.117798,1701.778076 1657.466919,1742.384277 
    C1610.245361,1784.387939 1559.484741,1821.573975 1504.992310,1853.618042 
    C1441.675171,1890.851929 1375.215332,1921.166138 1305.281982,1943.714355 
    C1262.463745,1957.519775 1219.002930,1968.904663 1174.531250,1975.959229 
    C1148.688965,1980.058472 1122.766724,1983.800537 1096.770996,1986.733521 
    C1079.287476,1988.706177 1061.623413,1989.280396 1044.019653,1989.920532 
    C1030.598877,1990.408569 1017.146362,1990.017456 1002.967957,1990.017456 
    C1002.967957,1820.738770 1002.967957,1650.835449 1003.060303,1480.146240 
    C1010.004150,1474.399780 1016.805176,1469.367432 1023.714844,1464.489014 
    C1155.785400,1371.243164 1287.875732,1278.025391 1419.939697,1184.770020 
    C1435.260986,1173.951172 1450.449829,1162.944702 1465.700073,1152.025146 
  M1505.003906,1606.000000 
    C1505.003906,1606.000000 1505.062988,1605.955078 1504.947144,1605.397827 
    C1504.614014,1605.272583 1504.280884,1605.147461 1503.649536,1604.918579 
    C1503.649536,1604.918579 1503.339966,1604.979370 1503.097046,1604.273926 
    C1501.361694,1602.517212 1499.626343,1600.760498 1497.626465,1598.892822 
    C1497.626465,1598.892822 1497.342896,1598.935791 1497.103394,1598.235474 
    C1493.080078,1594.705444 1489.056763,1591.175415 1485.069946,1586.932617 
    C1483.696167,1585.486450 1482.322388,1584.040405 1481.729126,1583.415771 
    C1482.311157,1580.477417 1482.754883,1578.454224 1483.107300,1576.415039 
    C1483.912964,1571.754639 1484.529175,1567.056152 1485.492188,1562.429443 
    C1486.544189,1557.374634 1488.016724,1552.407959 1489.094727,1547.357788 
    C1490.494507,1540.799805 1491.660034,1534.191772 1493.045166,1527.630371 
    C1493.113159,1527.308472 1494.316895,1527.226440 1494.970825,1527.774780 
    C1497.632812,1530.536377 1500.294678,1533.298096 1503.007446,1536.016724 
    C1503.007446,1536.016724 1502.946411,1536.040771 1503.156738,1536.679199 
    C1503.775269,1536.923828 1504.393921,1537.168579 1504.937500,1538.101074 
    C1507.326782,1539.742310 1509.716064,1541.383545 1512.257446,1543.692749 
    C1518.817749,1548.232178 1525.216309,1553.035034 1532.004517,1557.203369 
    C1535.557617,1559.385376 1539.794556,1560.454102 1543.903442,1562.788208 
    C1544.961426,1563.179321 1546.019409,1563.570557 1547.352417,1564.073486 
    C1547.352417,1564.073486 1547.645874,1564.027710 1547.898926,1564.835815 
    C1549.939697,1565.249023 1551.980469,1565.662354 1553.976074,1565.991821 
    C1553.976074,1565.991821 1553.891357,1566.035156 1553.959351,1566.847168 
    C1556.331055,1567.910522 1558.607422,1569.377563 1561.091553,1569.965454 
    C1570.367310,1572.160767 1579.642456,1574.539429 1589.054321,1575.915039 
    C1595.169922,1576.808960 1601.522461,1576.083374 1607.743896,1576.083374 
    C1607.743896,1560.716675 1607.743896,1546.001465 1607.743896,1531.173950 
    C1605.362915,1531.173950 1603.230347,1531.173950 1600.232300,1530.993286 
    C1591.911255,1529.658936 1583.590210,1528.324707 1575.088867,1526.171875 
    C1573.085327,1525.756714 1571.081787,1525.341431 1569.043823,1524.115479 
    C1567.635620,1523.769531 1566.227539,1523.423706 1564.940552,1523.065186 
    C1564.940552,1523.065186 1564.930786,1523.186646 1565.052124,1522.339233 
    C1563.645752,1521.927490 1562.239380,1521.515747 1560.937622,1521.083984 
    C1560.937622,1521.083984 1560.930908,1521.190308 1561.049683,1520.342896 
    C1559.646362,1519.926392 1558.243042,1519.509766 1556.947021,1519.079102 
    C1556.947021,1519.079102 1556.936890,1519.186890 1557.039429,1518.411133 
    C1555.067261,1516.925293 1553.149048,1515.360474 1551.112549,1513.968994 
    C1546.217285,1510.624146 1541.266602,1507.360596 1536.482910,1504.029053 
    C1536.482910,1504.029053 1536.509521,1504.175537 1536.170898,1503.510620 
    C1535.518921,1502.967285 1534.866943,1502.424072 1534.100708,1501.147461 
    C1532.671631,1500.121948 1531.242432,1499.096313 1529.932007,1498.060181 
    C1529.932007,1498.060181 1529.919678,1498.178589 1530.031982,1497.405273 
    C1528.650635,1496.095581 1527.269165,1494.785889 1525.994751,1493.505371 
    C1525.994751,1493.505371 1525.963379,1493.611816 1526.039551,1492.751343 
    C1524.641968,1490.296143 1523.442261,1487.698120 1521.800171,1485.419067 
    C1519.328369,1481.988281 1516.546997,1478.780396 1513.997314,1475.503540 
    C1513.997314,1475.503540 1513.969482,1475.603149 1514.030518,1474.724121 
    C1513.355347,1473.667969 1512.680176,1472.611694 1512.088623,1471.378418 
    C1512.088623,1471.378418 1512.011719,1471.198364 1512.084106,1470.436768 
    C1508.952393,1464.868408 1506.410645,1458.884033 1501.036011,1454.927979 
    C1501.036011,1454.927979 1501.103027,1454.990967 1501.079102,1454.188110 
    C1500.410156,1453.006470 1499.741211,1451.824829 1499.101440,1450.343506 
    C1499.101440,1450.343506 1499.001831,1450.059570 1498.978638,1449.458984 
    C1498.637451,1449.311035 1498.296387,1449.162964 1497.614014,1448.922363 
    C1497.614014,1448.922363 1497.261353,1448.947632 1497.110229,1448.164917 
    C1496.429321,1446.994507 1495.748535,1445.824097 1495.095215,1444.358032 
    C1495.095215,1444.358032 1494.995728,1444.078125 1494.916382,1443.401611 
    C1494.283936,1443.235352 1493.651489,1443.069092 1493.035400,1442.985840 
    C1493.035400,1442.985840 1493.116699,1442.962036 1493.071899,1442.241821 
    C1492.393066,1441.787964 1491.714233,1441.334106 1491.027344,1440.969971 
    C1491.027344,1440.969971 1491.117432,1440.967529 1491.068604,1440.241699 
    C1490.393433,1439.725708 1489.718262,1439.209717 1489.082275,1438.377319 
    C1489.082275,1438.377319 1488.989380,1438.072388 1488.863037,1437.344116 
    C1485.225952,1434.617798 1482.672852,1429.965942 1477.096436,1430.387207 
    C1477.096436,1430.387207 1476.998779,1430.078247 1476.918335,1429.392578 
    C1476.279907,1429.269409 1475.641602,1429.146240 1474.391968,1428.926636 
    C1473.981445,1428.891602 1473.570801,1428.856689 1473.045776,1427.959473 
    C1472.077271,1427.603027 1471.111206,1426.946533 1470.140015,1426.938965 
    C1463.759155,1426.888550 1457.377319,1426.978271 1450.143188,1426.912231 
    C1447.719482,1427.180664 1445.295654,1427.449219 1442.190918,1428.119141 
    C1437.731567,1430.008911 1433.272217,1431.898560 1428.043335,1433.894287 
    C1424.982666,1435.572266 1421.921997,1437.250244 1418.935913,1438.972046 
    C1418.935913,1438.972046 1418.968628,1438.892090 1418.285522,1438.946411 
    C1417.503540,1439.262085 1416.721558,1439.577637 1415.501465,1440.113281 
    C1415.216553,1440.310547 1415.043945,1440.579956 1414.140503,1440.948486 
    C1412.336426,1441.602539 1410.532227,1442.256714 1408.365723,1442.936890 
    C1408.365723,1442.936890 1408.018799,1443.044189 1407.249878,1442.926147 
    C1406.419800,1443.595215 1405.589600,1444.264282 1404.372925,1444.964478 
    C1404.372925,1444.964478 1404.001221,1445.074829 1403.196289,1444.946411 
    C1400.377197,1446.269287 1397.557983,1447.592041 1394.374023,1448.945068 
    C1394.374023,1448.945068 1394.023804,1449.052124 1393.210571,1448.931152 
    C1390.936768,1449.686646 1388.536743,1450.195312 1386.429077,1451.274902 
    C1384.724976,1452.147827 1383.373291,1453.708740 1381.408203,1455.031250 
    C1381.408203,1455.031250 1380.960571,1455.145630 1380.212280,1454.987793 
    C1379.471191,1455.646729 1378.730103,1456.305664 1377.131592,1457.001587 
    C1371.156738,1456.828613 1366.687744,1460.369141 1361.132080,1463.020386 
    C1357.703613,1464.291626 1354.275024,1465.562866 1350.097046,1466.926392 
    C1347.421387,1467.946167 1344.608032,1468.710693 1342.108643,1470.057373 
    C1339.609863,1471.403931 1337.425049,1473.332764 1335.041504,1475.940918 
    C1335.052734,1508.946045 1335.064087,1541.951172 1335.374023,1575.777954 
    C1348.669312,1575.857300 1361.966919,1575.821289 1375.258423,1576.089722 
    C1379.010742,1576.165527 1380.142212,1574.921631 1380.117554,1571.236450 
    C1379.964844,1548.454956 1380.005005,1525.672119 1379.931396,1502.950806 
    C1379.931396,1502.950806 1379.879028,1502.891724 1380.629028,1503.004028 
    C1382.121704,1502.293579 1383.614380,1501.583252 1385.904541,1500.867676 
    C1394.216797,1498.302368 1402.529175,1495.737061 1411.185181,1493.065674 
    C1410.441528,1498.494019 1409.750244,1504.312988 1408.813477,1510.092163 
    C1408.228027,1513.704102 1407.316772,1517.266479 1406.472412,1520.832397 
    C1405.323853,1525.683105 1403.911987,1530.479248 1402.961304,1535.366455 
    C1402.009888,1540.256348 1401.629761,1545.255737 1400.728027,1550.157227 
    C1400.095581,1553.594116 1398.940063,1556.931519 1398.139771,1560.341797 
    C1396.996948,1565.211792 1395.808960,1570.079956 1394.929688,1575.000610 
    C1394.044678,1579.953369 1393.510742,1584.969116 1392.828369,1589.957886 
    C1391.956177,1596.334351 1391.076416,1602.709839 1390.226196,1609.089355 
    C1389.863281,1611.811523 1389.566406,1614.542480 1389.345703,1618.164795 
    C1388.296265,1622.153809 1387.246826,1626.142822 1385.348511,1630.096558 
    C1384.222534,1635.839722 1382.672485,1641.540283 1382.091797,1647.338135 
    C1381.532837,1652.919556 1379.295410,1655.104736 1373.850342,1654.053955 
    C1359.665771,1651.316650 1345.464844,1648.662720 1331.078369,1645.119629 
    C1330.788696,1644.766602 1330.535767,1644.146362 1330.203857,1644.100586 
    C1324.710205,1643.345215 1319.188232,1642.779175 1313.711426,1641.922485 
    C1309.860474,1641.320068 1306.052490,1640.410278 1302.253418,1639.517700 
    C1297.406372,1638.378784 1292.606445,1637.036133 1287.749512,1635.944092 
    C1285.018066,1635.330078 1282.212891,1635.043823 1278.400391,1634.447144 
    C1277.774414,1635.862549 1276.421143,1637.895752 1275.989258,1640.108643 
    C1275.036133,1644.992554 1274.717773,1649.998169 1273.826050,1654.896851 
    C1272.680054,1661.192871 1270.882568,1667.384644 1269.993896,1673.709473 
    C1268.952148,1681.125122 1269.407959,1681.332275 1277.741943,1680.980713 
    C1280.729126,1681.677856 1283.711304,1682.397827 1286.706909,1683.056519 
    C1287.500244,1683.230957 1288.358398,1683.118408 1289.147095,1683.305054 
    C1294.382812,1684.544800 1299.580811,1685.957397 1304.844116,1687.061523 
    C1309.300415,1687.996460 1313.974243,1688.117798 1318.290527,1689.447510 
    C1325.001709,1691.514893 1331.653198,1693.412964 1339.137207,1693.793945 
    C1340.813965,1694.227295 1342.470337,1694.778931 1344.171387,1695.071533 
    C1348.922974,1695.889038 1353.733154,1696.409180 1358.444580,1697.404663 
    C1363.251099,1698.420044 1367.924927,1700.069702 1372.735962,1701.055664 
    C1377.498413,1702.031982 1382.378296,1702.420898 1387.171753,1703.266113 
    C1390.825684,1703.910400 1394.396729,1705.036255 1398.055176,1705.641602 
    C1403.317871,1706.512207 1408.626587,1707.104736 1414.717773,1707.947998 
    C1415.796021,1707.958130 1416.874268,1707.968262 1418.718262,1707.781128 
    C1419.510376,1705.702759 1420.586914,1703.683594 1421.034180,1701.533447 
    C1421.911865,1697.315308 1422.382812,1693.014404 1423.128296,1688.766479 
    C1423.768433,1685.118652 1424.553101,1681.496094 1425.280396,1677.863770 
    C1426.135864,1673.591064 1426.998413,1669.319824 1427.960083,1664.229248 
    C1428.515381,1660.903809 1429.070801,1657.578491 1429.374878,1653.402710 
    C1429.623657,1652.601685 1429.872559,1651.800537 1430.823608,1650.675171 
    C1431.925903,1647.649414 1433.358154,1644.698364 1434.063599,1641.582764 
    C1435.676758,1634.459473 1436.934448,1627.255737 1438.400146,1619.758789 
    C1440.794556,1621.464722 1442.609863,1622.758179 1444.561035,1624.816162 
    C1447.660767,1627.921021 1450.760620,1631.026001 1453.948730,1634.864990 
    C1454.947754,1635.200195 1455.946899,1635.535278 1457.563599,1636.304077 
    C1458.221558,1637.538086 1458.615601,1639.054077 1459.582031,1639.958496 
    C1464.321045,1644.393799 1469.212402,1648.666260 1474.078613,1653.539185 
    C1474.378662,1653.714844 1474.678711,1653.890625 1474.995605,1654.005249 
    C1474.995605,1654.005249 1474.933716,1654.019165 1475.064575,1654.549927 
    C1475.370239,1654.722046 1475.675781,1654.894165 1475.995361,1655.004395 
    C1475.995361,1655.004395 1475.933594,1655.019043 1476.063843,1655.549805 
    C1476.369141,1655.722046 1476.674561,1655.894287 1476.995361,1656.004761 
    C1476.995361,1656.004761 1476.933716,1656.020386 1477.063599,1656.551025 
    C1477.369019,1656.722900 1477.674438,1656.894775 1477.995361,1657.004883 
    C1477.995361,1657.004883 1477.933716,1657.020508 1478.063477,1657.550781 
    C1478.368652,1657.722778 1478.673828,1657.894775 1479.000122,1658.001099 
    C1479.000122,1658.001099 1478.932495,1657.988647 1478.980957,1658.928101 
    C1478.984253,1698.630249 1478.975708,1738.332520 1479.032104,1778.034668 
    C1479.034424,1779.709839 1479.640137,1781.384277 1479.985962,1782.996704 
    C1479.985962,1782.996704 1479.931885,1783.034302 1480.030029,1783.898560 
    C1480.485107,1784.259521 1480.938721,1784.933838 1481.395386,1784.935791 
    C1494.938843,1784.996460 1508.482666,1785.017700 1522.025513,1784.908813 
    C1522.659668,1784.903687 1523.283569,1783.641968 1524.046509,1782.316406 
    C1523.984009,1781.880493 1523.921509,1781.444702 1523.953613,1780.074585 
    C1523.964844,1741.148071 1523.991943,1702.221436 1523.978149,1663.294922 
    C1523.973755,1650.822144 1523.861328,1638.349243 1523.952026,1625.126831 
    C1522.573364,1623.771362 1521.194824,1622.415771 1519.949341,1621.050903 
    C1519.949341,1621.050903 1519.940552,1621.184082 1520.021362,1620.424927 
    C1517.273926,1617.979858 1514.526489,1615.534790 1511.907959,1613.076050 
    C1511.907959,1613.076050 1511.890869,1613.204468 1512.032959,1612.411865 
    C1511.287231,1611.977051 1510.541626,1611.542236 1509.909058,1611.090820 
    C1509.909058,1611.090820 1509.892578,1611.203857 1510.034302,1610.409058 
    C1509.285645,1609.979370 1508.536987,1609.549683 1507.916016,1609.099976 
    C1507.916016,1609.099976 1507.902588,1609.228516 1507.999756,1608.572266 
    C1507.352661,1608.027222 1506.705566,1607.482056 1505.994263,1606.974121 
    C1505.994263,1606.974121 1506.066528,1606.960449 1505.969849,1606.420166 
    C1505.660400,1606.258789 1505.350952,1606.097412 1505.003906,1606.000000 
  M1464.020264,1343.029175 
    C1464.020264,1343.029175 1464.168701,1343.028564 1463.304443,1343.329102 
    C1463.237671,1344.070435 1463.170898,1344.811768 1463.150757,1345.955200 
    C1462.974976,1346.257324 1462.742554,1346.310791 1462.578125,1345.373657 
    C1462.065552,1345.632935 1461.553101,1345.892334 1461.038940,1346.023071 
    C1461.038940,1346.023071 1461.167236,1346.032593 1460.494751,1346.126953 
    C1459.685303,1347.150513 1458.875732,1348.173950 1458.047974,1349.101196 
    C1458.047974,1349.101196 1458.145752,1349.109497 1457.514648,1349.068481 
    C1457.391968,1349.428467 1457.269165,1349.788452 1457.134277,1350.057861 
    C1457.134277,1350.057861 1457.223022,1350.079590 1456.473145,1350.087158 
    C1455.001587,1353.447754 1453.530029,1356.808472 1452.028931,1360.026855 
    C1452.028931,1360.026855 1452.172852,1360.007324 1451.440674,1360.244751 
    C1450.911743,1362.450317 1450.382812,1364.656006 1448.985229,1366.944092 
    C1448.620972,1371.826538 1448.157715,1376.705566 1447.988525,1381.594727 
    C1447.959961,1382.420654 1449.198608,1383.290405 1449.953613,1385.001831 
    C1449.829712,1389.211914 1449.486816,1393.498535 1453.902466,1396.916382 
    C1454.558350,1398.030273 1455.214233,1399.144287 1455.905518,1400.626831 
    C1455.905518,1400.626831 1456.004883,1400.983643 1456.149780,1401.692017 
    C1456.731934,1402.363892 1457.236328,1403.128906 1457.910034,1403.690918 
    C1460.528320,1405.874878 1463.200073,1407.994751 1465.939697,1410.807373 
    C1466.959106,1411.493530 1467.978638,1412.179565 1469.583252,1413.114868 
    C1470.750732,1413.255371 1471.918213,1413.395752 1474.541626,1414.036865 
    C1474.947876,1414.350464 1475.354248,1414.663940 1476.047729,1415.442139 
    C1478.152100,1416.651855 1480.214844,1418.813477 1482.368042,1418.907715 
    C1492.062744,1419.332031 1501.967285,1419.783813 1511.080811,1415.857544 
    C1514.603760,1414.339966 1517.229126,1410.739136 1520.971558,1408.081177 
    C1523.911133,1404.996704 1527.854858,1402.391724 1529.600098,1398.736938 
    C1534.638550,1388.186523 1538.017822,1377.036011 1533.904907,1365.273315 
    C1532.406250,1360.987671 1529.888794,1357.058472 1528.001953,1352.190308 
    C1527.768677,1348.215454 1525.224121,1346.265747 1521.917480,1345.084229 
    C1521.917480,1345.084229 1521.900635,1345.213989 1522.029419,1344.447510 
    C1519.768677,1340.639893 1516.446411,1338.509644 1511.383423,1338.007446 
    C1510.949951,1337.995361 1510.516479,1337.983398 1509.566040,1337.368286 
    C1497.080566,1334.728882 1484.635620,1332.931763 1472.041870,1339.581299 
    C1470.025879,1340.406250 1468.009888,1341.231201 1465.325806,1342.010742 
    C1464.893799,1342.399658 1464.461792,1342.788452 1464.020264,1343.029175 
  z"/>
  <path fill="#FFF200" opacity="1.000000" stroke="none" 
    d="
  M999.163269,1480.004517 
    C999.108704,1481.999023 999.006470,1483.993408 999.006409,1485.987915 
    C998.998962,1652.185303 999.000122,1818.382690 998.993286,1984.580078 
    C998.993225,1986.574829 998.898376,1988.569458 998.198364,1990.375366 
    C986.250916,1990.202881 974.952820,1990.219238 963.654663,1990.235840 
    C952.863220,1989.823730 942.041931,1989.780518 931.287354,1988.911987 
    C915.661621,1987.650146 900.066772,1985.941895 884.491211,1984.143066 
    C871.592163,1982.653076 858.673828,1981.143311 845.882446,1978.951416 
    C825.741394,1975.500122 805.562378,1972.069824 785.652222,1967.523804 
    C763.317688,1962.423950 741.076965,1956.722778 719.119385,1950.193726 
    C595.775024,1913.516724 483.668488,1855.122437 383.261383,1774.604492 
    C286.749329,1697.210083 206.764450,1605.383789 144.722198,1498.234253 
    C110.244263,1438.689209 81.954910,1376.277222 60.425800,1310.865723 
    C60.068172,1309.779053 59.790333,1308.666382 59.287903,1306.911255 
    C69.464928,1303.833862 79.600410,1300.960449 89.608543,1297.696655 
    C103.567429,1293.144165 117.408791,1288.232788 131.341171,1283.597290 
    C148.987808,1277.725952 166.672180,1271.967896 184.346008,1266.178467 
    C202.457703,1260.245605 220.577515,1254.337524 238.691574,1248.411865 
    C256.209534,1242.681396 273.721100,1236.931274 291.242126,1231.210083 
    C308.290833,1225.643066 325.353088,1220.117432 342.399963,1214.544800 
    C361.147949,1208.416260 379.881134,1202.242310 398.628387,1196.111572 
    C415.516602,1190.588867 432.420319,1185.113647 449.307678,1179.588379 
    C466.983185,1173.805176 484.630981,1167.936646 502.322418,1162.202881 
    C513.221313,1158.670654 524.179443,1155.321167 535.628906,1152.256836 
    C537.342468,1153.522461 538.515564,1154.453003 539.736816,1155.315186 
    C676.103394,1251.583618 812.479492,1347.838379 948.835632,1444.121704 
    C965.665833,1456.005615 982.389954,1468.039795 999.163269,1480.004517 
  M470.024109,1720.541016 
    C470.763733,1720.983887 471.503357,1721.426880 472.092621,1721.892212 
    C472.092621,1721.892212 472.113251,1721.741699 472.018341,1722.498901 
    C474.811249,1724.967773 477.604156,1727.436523 480.501221,1730.000366 
    C480.501221,1730.000366 480.639679,1729.973999 480.915436,1730.646484 
    C481.599426,1731.108521 482.283417,1731.570679 482.998749,1732.000000 
    C482.998749,1732.000000 482.975220,1732.038208 483.162811,1732.673340 
    C484.402557,1733.491577 485.642273,1734.309814 487.256805,1735.737549 
    C489.470001,1736.764404 491.683197,1737.791260 494.556152,1739.181763 
    C498.234070,1743.797974 503.396545,1745.707397 508.978882,1747.777344 
    C509.981934,1748.131836 510.984985,1748.486206 512.427246,1748.973267 
    C512.427246,1748.973267 512.881470,1749.037964 512.993164,1749.816772 
    C515.986206,1750.823486 518.979187,1751.830078 522.407715,1752.973145 
    C522.407715,1752.973145 522.860046,1753.034668 522.980652,1753.810181 
    C524.334045,1754.158081 525.687439,1754.505981 527.423218,1754.982666 
    C527.423218,1754.982666 527.823364,1755.033691 528.204712,1755.743652 
    C531.116882,1756.106812 534.029053,1756.469971 537.478699,1757.056763 
    C537.973511,1757.314087 538.468384,1757.571533 539.781616,1758.002930 
    C543.130493,1758.335571 546.479431,1758.668335 550.212769,1759.738037 
    C550.890991,1760.156738 551.566223,1760.934204 552.247864,1760.939819 
    C562.500610,1761.025757 572.754700,1761.051025 583.006653,1760.932129 
    C583.731201,1760.923828 584.441528,1759.678955 586.039551,1759.000244 
    C596.486511,1756.900269 606.999939,1755.071045 617.340332,1752.536255 
    C620.470337,1751.768799 623.121277,1749.047485 626.807739,1747.042969 
    C628.030029,1746.274414 629.252319,1745.505859 630.361267,1744.931519 
    C630.361267,1744.931519 630.182983,1744.794434 631.115601,1744.957520 
    C632.230103,1744.220703 633.344604,1743.483887 634.370544,1742.913696 
    C634.370544,1742.913696 634.222290,1742.796997 635.168213,1742.967285 
    C635.801025,1742.933228 636.433899,1742.899170 637.657471,1742.763916 
    C638.087402,1742.129639 638.517395,1741.495239 639.660828,1740.978149 
    C640.747253,1739.905151 641.833618,1738.832275 642.934570,1737.901855 
    C642.934570,1737.901855 642.792664,1737.881470 643.563599,1738.001709 
    C645.382935,1736.694702 647.202271,1735.387573 649.051453,1734.056763 
    C649.051453,1734.056763 649.069214,1734.023071 649.703125,1734.023193 
    C650.088745,1733.654419 650.474365,1733.285767 651.115234,1732.443604 
    C651.406006,1732.242432 651.696777,1732.041382 652.659424,1731.757324 
    C653.089050,1730.672363 653.518677,1729.587280 653.963501,1728.161865 
    C654.170471,1727.892090 654.377441,1727.622192 655.393433,1727.897461 
    C656.267944,1727.544434 657.142456,1727.191284 658.557861,1726.846924 
    C658.779602,1726.567993 659.001343,1726.289062 659.599731,1725.892822 
    C659.843689,1725.743896 659.973022,1725.526733 660.594421,1724.893066 
    C665.774048,1719.299927 670.953735,1713.706787 676.735107,1707.750732 
    C678.440186,1704.820923 680.145264,1701.890991 682.268677,1698.351685 
    C684.864380,1694.354004 687.846008,1690.549194 689.963196,1686.312378 
    C692.956970,1680.321655 695.679443,1674.136475 697.828674,1667.800537 
    C699.672974,1662.363403 700.549561,1656.598022 701.974731,1650.249268 
    C701.927856,1649.515015 701.880920,1648.780884 702.209595,1647.346313 
    C702.758545,1643.888550 703.307495,1640.430786 703.983154,1636.047363 
    C704.032654,1621.723511 704.082092,1607.399780 704.792297,1593.020874 
    C706.358643,1592.355591 707.917419,1591.671875 709.493286,1591.030029 
    C711.323792,1590.284424 713.169250,1589.575806 715.500122,1588.951050 
    C715.664551,1588.920166 715.829041,1588.889160 716.813293,1588.991089 
    C720.887329,1587.606812 724.961426,1586.222534 729.833130,1584.975342 
    C730.911316,1584.939087 731.989563,1584.902710 733.743530,1584.977295 
    C734.509155,1584.263306 735.274780,1583.549194 736.822449,1582.972168 
    C738.293762,1582.657104 739.765076,1582.342041 741.795959,1581.751587 
    C742.541626,1581.446777 743.287231,1581.141968 744.702576,1580.967529 
    C745.479614,1580.679443 746.256653,1580.391479 747.733154,1579.968018 
    C748.835571,1579.589844 749.937927,1579.211670 751.734619,1578.968384 
    C752.788574,1578.582642 753.842590,1578.196899 755.618958,1577.902588 
    C756.755981,1577.547974 757.893066,1577.193481 759.702820,1576.974365 
    C760.484436,1576.685303 761.266052,1576.396240 762.737366,1575.967041 
    C763.824768,1575.589478 764.912170,1575.211914 766.816833,1574.973511 
    C768.050476,1574.238770 769.284119,1573.504028 770.412720,1572.859497 
    C770.412720,1572.859497 770.353271,1572.734497 771.159668,1572.921021 
    C771.703491,1572.890625 772.247253,1572.860229 773.631042,1572.967407 
    C775.786682,1572.599243 777.942261,1572.231201 780.788879,1572.003418 
    C781.849426,1571.760864 782.909973,1571.518188 784.677002,1570.879272 
    C786.422058,1570.577271 788.201721,1570.405273 789.906433,1569.951660 
    C799.718140,1567.341187 809.541504,1564.766113 819.296936,1561.957153 
    C823.019348,1560.885376 826.572327,1559.225098 830.591125,1557.920410 
    C830.591125,1557.920410 830.979858,1557.833374 831.649902,1557.940796 
    C832.189087,1557.607178 832.728333,1557.273560 833.594727,1556.939697 
    C833.594727,1556.939697 833.905640,1556.837891 834.662109,1556.729614 
    C836.512451,1556.143921 838.362732,1555.558228 840.593140,1554.947632 
    C840.593140,1554.947632 840.956604,1554.833862 841.693481,1554.934692 
    C842.864441,1554.569824 844.035400,1554.204956 845.538147,1553.918701 
    C845.538147,1553.918701 845.869873,1553.839233 846.637634,1553.750610 
    C847.751526,1552.342773 849.820129,1550.945190 849.835266,1549.525635 
    C850.045959,1529.771484 849.994263,1510.014160 849.896606,1490.258179 
    C849.893127,1489.559082 848.752625,1488.865601 847.195312,1488.035278 
    C772.264282,1488.022461 697.333313,1488.008911 622.402283,1488.003784 
    C621.572815,1488.003784 620.743286,1488.110596 619.067200,1488.119873 
    C618.714172,1489.591919 618.070740,1491.061157 618.055542,1492.536621 
    C617.961365,1501.698242 618.008118,1510.861328 618.008118,1520.023926 
    C618.008118,1523.945923 618.008118,1527.867798 618.008118,1532.208252 
    C667.425232,1532.208252 716.151550,1532.208252 764.877869,1532.208252 
    C765.036499,1532.611206 765.195129,1533.014038 765.353760,1533.416992 
    C764.514343,1533.936157 763.737854,1534.702393 762.825378,1534.935059 
    C755.985474,1536.678833 749.097778,1538.240234 742.285278,1540.081665 
    C741.374023,1540.327881 740.801147,1541.826050 739.227112,1542.958984 
    C736.803467,1543.333740 734.323486,1543.495117 731.965698,1544.118896 
    C719.682678,1547.367920 707.437744,1550.760376 695.164978,1554.048584 
    C689.526428,1555.559448 683.804504,1556.776978 678.211975,1558.435913 
    C672.442139,1560.147583 666.783447,1562.233887 660.198120,1564.071533 
    C659.797546,1565.005493 659.047913,1565.939453 659.047546,1566.873535 
    C659.039673,1588.521973 659.113098,1610.170532 659.076050,1632.427734 
    C659.105652,1632.630981 659.135315,1632.834106 659.016785,1633.849365 
    C658.398682,1636.914185 657.780518,1639.978882 657.066589,1643.477051 
    C657.066589,1643.477051 657.155151,1643.911865 656.989075,1644.690186 
    C655.625427,1649.764893 654.261780,1654.839600 652.156860,1659.997925 
    C651.319519,1661.270020 650.327087,1662.467651 649.674316,1663.828247 
    C647.769348,1667.798828 646.000000,1671.834351 643.923401,1676.509766 
    C642.853455,1678.034790 641.783447,1679.559692 639.984070,1680.984375 
    C639.381775,1681.157837 638.570801,1681.140015 638.209534,1681.534302 
    C634.682434,1685.382202 632.542908,1690.505981 627.380493,1692.887939 
    C626.531494,1693.279663 626.266296,1694.936890 625.151733,1696.584351 
    C624.951355,1696.768555 624.751038,1696.952881 624.054260,1697.536133 
    C614.780823,1701.806885 605.598145,1706.291016 596.206482,1710.283569 
    C588.052673,1713.750122 579.500732,1716.234009 570.538757,1715.897949 
    C562.923889,1715.612427 555.312622,1714.805176 547.744019,1713.870483 
    C543.222778,1713.312134 538.786743,1712.063721 534.456482,1711.039307 
    C534.456482,1711.039307 534.529114,1711.190674 534.110901,1710.449463 
    C532.644165,1709.340210 531.299316,1707.992432 529.686890,1707.168335 
    C525.529724,1705.043457 521.254150,1703.150146 516.402710,1700.880737 
    C515.571289,1700.600220 514.739868,1700.319702 513.980896,1700.013794 
    C513.980896,1700.013794 513.958679,1700.087280 513.990784,1699.208618 
    C513.061584,1698.541382 512.132446,1697.874268 511.369904,1697.077759 
    C511.369904,1697.077759 511.473633,1697.261475 511.133881,1696.559570 
    C505.744354,1691.275146 500.354828,1685.990723 494.976105,1680.519287 
    C494.976105,1680.519287 494.868896,1680.361084 494.991302,1679.589600 
    C492.316284,1675.966797 489.641266,1672.344116 486.971680,1668.502808 
    C486.971680,1668.502808 486.861816,1668.309814 486.989441,1667.572632 
    C486.314362,1666.620239 485.639282,1665.667847 484.970734,1664.495483 
    C484.970734,1664.495483 484.861633,1664.304321 484.982391,1663.525635 
    C483.577057,1661.515625 482.171722,1659.505737 480.894836,1657.575806 
    C480.894836,1657.575806 480.787903,1657.682861 480.920074,1656.856323 
    C480.891693,1656.579224 480.863312,1656.302124 480.968414,1655.258667 
    C480.346252,1654.154785 479.724121,1653.051025 479.013916,1651.307251 
    C478.956085,1650.882080 478.898224,1650.456909 478.971954,1649.202881 
    C478.336609,1647.435425 477.701263,1645.667969 477.007507,1643.245239 
    C476.949371,1642.810303 476.891235,1642.375366 476.959320,1641.169556 
    C476.580902,1639.494385 476.202454,1637.819214 475.697601,1635.300781 
    C475.498260,1628.611816 474.871216,1621.899902 475.226929,1615.240601 
    C475.545410,1609.278931 476.946899,1603.375000 478.282043,1596.985962 
    C478.547913,1596.681396 478.813812,1596.376831 479.674896,1595.708984 
    C480.127258,1594.184937 480.579620,1592.660889 481.804108,1591.013428 
    C482.821686,1588.623047 483.839264,1586.232666 484.986145,1583.528076 
    C484.986145,1583.528076 485.026123,1583.190674 485.790985,1583.029419 
    C487.805389,1579.351196 489.819824,1575.673096 492.030487,1571.488403 
    C492.176819,1571.163330 492.323151,1570.838257 493.122101,1570.241943 
    C499.092438,1564.170776 505.062775,1558.099731 510.998596,1552.000000 
    C510.998596,1552.000000 511.023773,1552.037964 511.741150,1552.010132 
    C512.248352,1551.326904 512.755554,1550.643677 513.819519,1549.558228 
    C514.345703,1549.047119 514.799255,1548.417236 515.409668,1548.043823 
    C519.935303,1545.276367 524.492249,1542.559937 529.720947,1539.958984 
    C530.518555,1539.659668 531.316162,1539.360352 532.725464,1538.992310 
    C533.429199,1538.613647 534.132935,1538.234985 535.616455,1537.993164 
    C536.462158,1537.336182 537.307800,1536.679077 538.585205,1535.971191 
    C538.585205,1535.971191 538.999817,1535.840698 539.822449,1535.978760 
    C541.201538,1535.276489 542.580627,1534.574219 543.958313,1533.959473 
    C543.958313,1533.959473 543.888367,1533.907104 544.672668,1533.971558 
    C545.455688,1533.926758 546.238647,1533.881836 547.749756,1533.968262 
    C548.848694,1533.682495 549.947693,1533.396729 551.875977,1532.953491 
    C554.129761,1532.636719 556.379272,1532.087646 558.638062,1532.046753 
    C565.366089,1531.925171 572.097778,1532.003174 578.745605,1532.003174 
    C578.745605,1516.969604 578.745605,1502.738647 578.745605,1488.197754 
    C560.384766,1487.735229 542.278687,1486.917236 524.196594,1494.016357 
    C516.424072,1497.298462 508.651520,1500.580444 500.137695,1503.966919 
    C497.059784,1506.275757 493.981903,1508.584717 490.169037,1510.957397 
    C488.373688,1512.295166 486.578308,1513.632812 484.482178,1515.011719 
    C484.482178,1515.011719 484.203033,1515.130981 483.628601,1515.071655 
    C483.421539,1515.363159 483.214478,1515.654663 482.957977,1515.931030 
    C482.957977,1515.931030 482.911377,1515.953125 482.267303,1516.195435 
    C477.490448,1521.112061 472.713593,1526.028687 467.232880,1531.007324 
    C466.128387,1532.309448 465.023926,1533.611694 463.209442,1534.982544 
    C461.513000,1537.119385 459.816589,1539.256104 458.024017,1541.512695 
    C458.024017,1541.512695 458.049164,1541.664429 457.342316,1541.920166 
    C454.303741,1545.842285 450.332306,1549.235474 449.538574,1555.082520 
    C449.036163,1555.983276 448.533783,1556.884033 447.288391,1557.958618 
    C445.077240,1561.998657 442.272034,1565.833618 440.791229,1570.125610 
    C438.448761,1576.915527 436.993622,1584.011597 434.980682,1591.773438 
    C434.325043,1592.798584 433.198425,1593.776123 433.088959,1594.856567 
    C432.278381,1602.857666 431.510773,1610.870239 431.054901,1618.897583 
    C430.754974,1624.178467 430.585907,1629.530884 431.106628,1634.776978 
    C431.667999,1640.432983 433.101990,1646.002441 434.170715,1652.586182 
    C434.487122,1653.466797 434.803528,1654.347412 435.076080,1655.566528 
    C435.062164,1655.818237 435.098877,1656.062500 435.040741,1657.110352 
    C435.170502,1664.290649 438.160217,1670.620850 440.982086,1677.016724 
    C440.982086,1677.016724 440.974182,1677.044189 440.981140,1677.794678 
    C442.653839,1680.956177 444.326538,1684.117554 446.010529,1687.509033 
    C446.010529,1687.509033 446.119019,1687.712280 446.008240,1688.509277 
    C448.672699,1692.424072 451.337128,1696.338867 454.044830,1700.974487 
    C456.745178,1704.280396 459.445526,1707.586304 462.022125,1711.572632 
    C462.668488,1712.389771 463.314819,1713.206909 463.999176,1714.004883 
    C463.999176,1714.004883 463.968262,1714.035522 463.979279,1714.734009 
    C464.641388,1715.167480 465.303528,1715.600952 466.000000,1716.000000 
    C466.000000,1716.000000 465.965851,1716.035034 465.989838,1716.787109 
    C466.752045,1717.153564 467.514221,1717.519897 468.117493,1717.906494 
    C468.117493,1717.906494 468.142761,1717.748291 468.021820,1718.536621 
    C468.763397,1718.980347 469.504974,1719.424072 470.109467,1719.890015 
    C470.109467,1719.890015 470.134186,1719.753418 470.024109,1720.541016 
  M459.457397,1383.126709 
    C459.168488,1383.325073 458.996307,1383.597290 458.156158,1383.979858 
    C455.383148,1385.965942 452.610107,1387.952148 449.452759,1389.995239 
    C449.452759,1389.995239 449.086609,1390.125244 448.329285,1390.016357 
    C446.058014,1392.094238 443.786743,1394.172241 441.615051,1396.070435 
    C441.615051,1396.070435 441.781982,1396.190308 440.933441,1396.027100 
    C439.233246,1397.329224 437.533051,1398.631348 435.234894,1400.245483 
    C435.205383,1401.816650 435.175873,1403.387939 435.018219,1405.708618 
    C436.100342,1406.767334 437.182465,1407.826050 438.175446,1408.927734 
    C438.175446,1408.927734 438.187653,1408.829468 438.023010,1409.546875 
    C438.438660,1409.985718 438.854309,1410.424561 439.120575,1410.873901 
    C439.120575,1410.873901 439.154266,1410.728027 439.014435,1411.499756 
    C440.665070,1413.381104 442.315704,1415.262573 444.019226,1417.842163 
    C448.014893,1423.639526 451.801697,1429.595215 456.053131,1435.198608 
    C463.187775,1444.602173 470.618256,1453.781250 477.972504,1463.812256 
    C479.534698,1465.834473 480.824860,1469.099365 482.738007,1469.518188 
    C484.537170,1469.911987 486.993805,1467.302246 489.555786,1465.975098 
    C489.555786,1465.975098 489.930908,1465.843872 490.734344,1465.977295 
    C493.560333,1464.650269 496.386322,1463.323364 499.949097,1461.960205 
    C501.927490,1461.282593 503.900146,1460.587524 505.885437,1459.930664 
    C511.097778,1458.206299 516.318176,1456.506226 521.530396,1454.781128 
    C524.464172,1453.810059 524.972107,1451.308594 523.505310,1449.365112 
    C520.259521,1445.064575 516.440002,1441.197021 512.999207,1436.376831 
    C510.345123,1432.500854 507.691040,1428.624878 505.010651,1424.479492 
    C505.010651,1424.479492 504.890656,1424.236816 504.893646,1423.541870 
    C504.268494,1423.336670 503.643372,1423.131470 503.008575,1422.993408 
    C503.008575,1422.993408 503.073761,1422.975342 503.036163,1422.225586 
    C501.700836,1420.403564 500.365540,1418.581421 499.010803,1416.471680 
    C499.010803,1416.471680 498.889374,1416.208496 498.905945,1415.500366 
    C496.966766,1413.656250 495.027557,1411.812134 493.032349,1409.190552 
    C492.217621,1407.549561 491.598816,1405.768921 490.548431,1404.296021 
    C488.176971,1400.970703 485.637939,1397.760986 483.084229,1394.570557 
    C478.420471,1388.743774 473.696655,1382.965210 468.330017,1377.059082 
    C467.199524,1377.670898 466.069000,1378.282715 464.397797,1379.140747 
    C463.906311,1379.749878 463.414825,1380.358887 462.278229,1381.001953 
    C461.491791,1381.651855 460.705353,1382.301880 459.457397,1383.126709 
  M723.572510,1382.126343 
    C723.367798,1382.714355 723.163086,1383.302246 722.348877,1384.261108 
    C717.836609,1390.860962 713.324341,1397.460938 708.038086,1403.975952 
    C705.395264,1407.384644 702.752441,1410.793335 699.985413,1414.469727 
    C699.985413,1414.469727 699.957153,1414.767700 699.345215,1415.107910 
    C698.194397,1417.038208 697.043579,1418.968628 695.177856,1420.975830 
    C692.482117,1424.431030 689.650574,1427.792847 687.169128,1431.395752 
    C686.370728,1432.555176 686.495239,1434.350220 686.102051,1436.189819 
    C685.870972,1436.514771 685.639832,1436.839844 684.770874,1438.045898 
    C684.526001,1438.313354 684.281128,1438.580688 683.402710,1439.153320 
    C681.608215,1441.670532 679.813782,1444.187744 677.215088,1447.833008 
    C695.921082,1447.833008 712.962646,1447.833008 730.768921,1447.964844 
    C735.881897,1445.020386 738.918152,1440.406738 741.834717,1435.016479 
    C743.515564,1432.652588 745.196411,1430.288696 747.012390,1427.550415 
    C747.012390,1427.550415 747.078613,1427.156128 747.808777,1427.033936 
    C749.058838,1425.018921 752.733215,1423.822876 750.081360,1419.999390 
    C750.538635,1419.645508 750.995911,1419.291626 752.032532,1419.607666 
    C752.635803,1419.067749 753.239075,1418.527954 754.074890,1417.468018 
    C754.399536,1417.008667 754.724121,1416.549438 755.690796,1415.790527 
    C758.076965,1412.660034 760.789490,1409.714111 762.708740,1406.319702 
    C763.637756,1404.676636 763.997131,1401.045410 763.039734,1400.277344 
    C757.580811,1395.898071 751.647400,1392.110229 745.545166,1387.994995 
    C745.545166,1387.994995 745.190796,1387.958252 745.040466,1387.223145 
    C742.644958,1385.520752 740.249451,1383.818359 737.541748,1381.987915 
    C737.541748,1381.987915 737.202820,1381.952881 737.045166,1381.219727 
    C735.609924,1380.525391 734.174683,1379.831055 732.911804,1379.096191 
    C732.911804,1379.096191 732.899780,1379.272827 732.858459,1378.516724 
    C731.135803,1378.845459 730.237610,1372.588013 727.196716,1377.974854 
    C726.149963,1379.391602 725.103149,1380.808350 724.043884,1382.045288 
    C724.043884,1382.045288 724.223694,1382.058472 723.572510,1382.126343 
  M577.031799,1344.117065 
    C577.031799,1378.666138 577.031799,1413.215088 577.031799,1447.863770 
    C591.781372,1447.863770 605.756226,1447.863770 620.647156,1447.938354 
    C621.100037,1446.385864 621.944397,1444.834229 621.948059,1443.280640 
    C622.024780,1410.665283 622.009949,1378.049927 621.995056,1345.434448 
    C621.994446,1344.010864 621.821899,1342.587402 621.720215,1341.021362 
    C607.470947,1341.021362 593.670471,1340.979736 579.871765,1341.115479 
    C578.956055,1341.124390 578.053589,1342.482422 577.031799,1344.117065 
  z"/>
  <path fill="#01A2E8" opacity="1.000000" stroke="none" 
    d="
  M1290.914917,620.833191 
    C1291.646484,619.220459 1292.097534,617.391846 1293.149414,616.025818 
    C1383.748779,498.376038 1474.395142,380.762512 1565.036011,263.144653 
    C1577.425781,247.067291 1589.803467,230.980545 1602.599365,214.362350 
    C1611.571899,221.540009 1620.433716,228.465347 1629.119507,235.604797 
    C1672.327515,271.121185 1712.219727,310.070526 1748.918335,352.256531 
    C1821.198242,435.344330 1877.892700,527.997437 1919.186646,630.110657 
    C1939.028442,679.176208 1955.244385,729.392944 1966.510864,781.080322 
    C1972.384644,808.027710 1976.681274,835.336548 1981.081909,862.580322 
    C1983.404297,876.958252 1984.622070,891.528320 1985.969238,906.046021 
    C1987.236084,919.699951 1988.014404,933.399109 1989.013916,947.078003 
    C1989.410522,952.508301 1989.823242,957.937317 1990.333130,964.076355 
    C1990.266113,975.028442 1990.061401,985.270752 1989.968994,995.514160 
    C1989.958252,996.690125 1990.575073,997.871826 1990.901001,999.050842 
    C1990.928711,1001.065918 1990.956299,1003.080933 1990.572144,1005.758606 
    C1990.274658,1016.970642 1990.388916,1027.520142 1990.503174,1038.069580 
    C1990.010864,1046.639771 1989.748901,1055.230835 1988.980103,1063.776123 
    C1987.173096,1083.857910 1985.339111,1103.942017 1983.099976,1123.978760 
    C1981.497559,1138.317383 1979.913452,1152.718628 1977.100220,1166.848877 
    C1971.175293,1196.609863 1964.774536,1226.286743 1957.911743,1255.845459 
    C1954.516846,1270.467651 1949.553589,1284.720825 1945.541016,1299.207642 
    C1944.388062,1303.370605 1942.526123,1304.259399 1938.498169,1302.923828 
    C1886.469727,1285.671021 1834.417480,1268.489624 1782.345215,1251.369141 
    C1745.361084,1239.209595 1708.336426,1227.173462 1671.332275,1215.074585 
    C1630.574951,1201.748413 1589.813599,1188.434814 1549.067383,1175.074463 
    C1522.946899,1166.509888 1496.849121,1157.875732 1470.749023,1149.248901 
    C1469.511475,1148.839722 1468.350220,1148.199707 1467.022217,1146.960449 
    C1466.700317,1145.793701 1466.480347,1145.343750 1466.323120,1144.872803 
    C1413.885254,987.881165 1361.462646,830.884399 1309.003052,673.900024 
    C1303.080078,656.175537 1296.949341,638.520447 1290.914917,620.833191 
  M1741.003418,752.043762 
    C1741.003418,752.043762 1741.069824,752.078552 1741.817139,752.033142 
    C1742.168945,751.277588 1742.520752,750.522034 1742.924438,749.893677 
    C1742.924438,749.893677 1742.788574,749.914856 1743.583008,749.986816 
    C1744.005615,749.240479 1744.428345,748.494202 1744.879395,747.903442 
    C1744.879395,747.903442 1744.721924,747.890015 1745.424683,747.951355 
    C1746.325806,746.677673 1747.226807,745.403992 1748.734253,743.777954 
    C1750.431152,739.888977 1752.128052,735.999939 1754.230591,731.446655 
    C1755.567627,727.849182 1756.815918,724.215637 1758.261108,720.662170 
    C1760.805420,714.406250 1762.334717,708.007324 1762.068604,701.181458 
    C1761.874878,696.209351 1762.071655,691.222473 1762.068359,686.242188 
    C1762.067505,685.088623 1762.206299,683.855469 1761.862061,682.794922 
    C1759.925049,676.826782 1757.859985,670.900208 1755.988403,664.146606 
    C1755.274170,662.928955 1754.559814,661.711304 1754.002808,660.560852 
    C1754.002808,660.560852 1753.930664,660.715881 1753.995483,659.840759 
    C1753.074951,656.429993 1753.162842,652.411987 1748.871826,651.093445 
    C1748.871826,651.093445 1748.846680,651.225403 1749.028687,650.460266 
    C1747.737183,648.595459 1746.445801,646.730652 1745.066528,644.265564 
    C1744.765381,643.792664 1744.464233,643.319763 1743.853638,642.231567 
    C1739.619019,638.099060 1735.384521,633.966553 1730.765015,629.227051 
    C1729.421875,628.536011 1728.078857,627.844910 1726.871216,627.118469 
    C1726.871216,627.118469 1726.859741,627.257996 1726.884399,626.516296 
    C1726.201538,626.392883 1725.518677,626.269531 1724.930908,626.132446 
    C1724.930908,626.132446 1724.906616,626.225464 1725.022827,625.412842 
    C1722.690552,624.326904 1720.358154,623.241028 1717.583862,622.022888 
    C1717.583862,622.022888 1717.128418,621.949524 1717.054443,621.195190 
    C1716.035522,620.844116 1715.016602,620.493103 1713.560669,620.028015 
    C1713.560669,620.028015 1713.114502,619.956604 1713.042114,619.195557 
    C1710.369385,618.167053 1707.696533,617.138489 1704.598145,615.982361 
    C1704.598145,615.982361 1704.165161,615.882263 1703.791626,615.177612 
    C1697.998413,613.466797 1692.339111,610.969543 1685.116943,612.036865 
    C1679.728394,612.077393 1674.339966,612.117920 1668.056274,612.026184 
    C1662.573975,612.731201 1657.087891,613.409729 1651.619263,614.208496 
    C1651.297852,614.255554 1651.118286,615.273499 1650.420044,615.948120 
    C1649.827881,616.318909 1649.235840,616.689697 1647.345947,617.913757 
    C1646.387817,618.280457 1645.429688,618.647156 1644.104736,618.851929 
    C1643.254639,618.611877 1642.129028,617.896606 1641.596924,618.205078 
    C1636.135742,621.371582 1630.700806,624.595459 1625.393188,628.012146 
    C1613.321533,635.782959 1605.928223,647.289795 1599.695435,660.673828 
    C1598.808105,662.567749 1597.627197,664.381897 1597.086792,666.370178 
    C1595.245483,673.146240 1592.520508,679.932068 1592.200195,686.810425 
    C1591.769897,696.051453 1592.966797,705.415710 1594.014771,714.664795 
    C1595.041748,723.727905 1598.336670,732.067627 1603.987305,739.592224 
    C1603.987305,739.592224 1604.095581,739.819275 1604.100708,740.485535 
    C1604.735962,741.083008 1605.371094,741.680481 1605.996826,742.598572 
    C1605.996826,742.598572 1606.119507,742.894836 1606.193604,743.585815 
    C1608.090820,745.754822 1609.987915,747.923889 1611.959595,750.777588 
    C1612.628662,751.240479 1613.297852,751.703369 1613.986206,752.858643 
    C1617.657227,756.280945 1621.328247,759.703247 1625.622070,763.457703 
    C1625.768555,763.273499 1625.914917,763.089294 1625.999756,762.986145 
    C1625.999756,762.986145 1626.074463,762.918213 1625.602295,763.627686 
    C1626.758301,764.374451 1627.914307,765.121216 1629.504517,766.090576 
    C1629.774780,766.287903 1629.973389,766.541321 1630.090698,767.488403 
    C1630.459473,767.630249 1630.828369,767.772095 1631.427124,768.016113 
    C1631.427124,768.016113 1631.677246,767.990173 1631.908203,768.739624 
    C1632.707764,769.138245 1633.507202,769.536865 1634.442749,770.031311 
    C1634.442749,770.031311 1634.603638,769.988770 1635.021973,770.608704 
    C1636.103027,771.047913 1637.183960,771.487061 1638.440430,772.028198 
    C1638.440430,772.028198 1638.641602,772.003052 1639.052124,772.644836 
    C1642.143555,773.856384 1645.358765,774.825378 1648.302246,776.326904 
    C1655.814209,780.159119 1664.019287,781.416504 1672.147705,781.860046 
    C1678.899658,782.228516 1685.803589,781.040527 1692.547363,779.961243 
    C1698.575562,778.996643 1704.532471,777.429321 1710.401001,775.716980 
    C1712.208740,775.189453 1713.622070,773.310547 1715.973389,772.062134 
    C1717.065918,771.399048 1718.158569,770.735962 1719.579712,770.041138 
    C1719.579712,770.041138 1719.889160,769.926331 1720.664062,770.052124 
    C1721.529297,769.394104 1722.394409,768.736084 1723.580811,768.050537 
    C1723.580811,768.050537 1723.882324,767.937134 1724.630127,767.806335 
    C1727.495972,765.229248 1730.361938,762.652100 1733.556396,760.044922 
    C1733.556396,760.044922 1733.865112,759.927979 1734.582886,759.853088 
    C1735.452515,758.578918 1736.322021,757.304749 1737.556274,756.013794 
    C1737.556274,756.013794 1737.906738,755.911438 1738.569824,755.869751 
    C1738.790527,755.263977 1739.011230,754.658203 1739.567017,754.031799 
    C1739.567017,754.031799 1739.884521,753.921875 1740.554443,753.884094 
    C1740.728882,753.267151 1740.903198,752.650208 1741.003418,752.043762 
  M1655.025757,865.373047 
    C1655.025757,865.373047 1654.994751,865.776917 1654.137573,865.945435 
    C1653.785156,866.238281 1653.159424,866.498962 1653.120728,866.828857 
    C1652.364380,873.257935 1651.678955,879.695312 1650.971680,886.130249 
    C1650.882324,886.944092 1650.814453,887.768372 1650.627808,888.562195 
    C1649.408447,893.746216 1647.867920,898.874878 1646.997070,904.115479 
    C1646.003906,910.091736 1645.599243,916.165833 1644.936768,922.197144 
    C1644.900635,922.524353 1644.854126,922.851318 1644.793335,923.174805 
    C1643.508301,930.011658 1642.178711,936.840454 1640.947876,943.687073 
    C1640.135864,948.204163 1639.497559,952.752686 1638.664551,957.265442 
    C1638.604004,957.593262 1637.591187,957.745239 1636.993286,957.283020 
    C1636.654663,956.566956 1636.316162,955.850952 1635.440063,955.050049 
    C1635.078247,955.068909 1634.716431,955.087708 1633.971680,954.400635 
    C1633.922119,954.137573 1633.872559,953.874512 1633.437500,953.139954 
    C1633.264526,952.149597 1633.091553,951.159241 1633.026123,949.360657 
    C1632.282715,948.740051 1631.539185,948.119507 1630.951538,947.521851 
    C1630.951538,947.521851 1630.912598,947.674438 1630.904053,946.830139 
    C1630.233887,946.385315 1629.563599,945.940430 1628.996338,945.557800 
    C1628.996338,945.557800 1628.929810,945.658020 1628.960815,944.831726 
    C1628.362549,943.169983 1627.764282,941.508301 1627.072876,939.119141 
    C1624.032593,932.660522 1621.138672,926.127075 1617.889771,919.775146 
    C1616.291870,916.650879 1614.036743,913.862671 1612.016113,910.231140 
    C1611.689209,909.455078 1611.362305,908.679016 1610.966919,907.156433 
    C1609.320435,901.479370 1607.666016,895.804504 1606.029053,890.124695 
    C1603.368408,880.892578 1600.227295,871.762085 1598.226929,862.388489 
    C1596.731689,855.381714 1596.679810,848.062378 1596.060547,840.875793 
    C1595.889893,838.895691 1596.226929,836.848145 1595.868164,834.917480 
    C1595.673096,833.868103 1594.302734,832.088684 1593.808838,832.198486 
    C1590.780518,832.871094 1587.851074,833.989746 1583.724121,835.127319 
    C1583.334106,835.169006 1582.944092,835.210632 1582.205688,835.633850 
    C1581.093506,835.821533 1579.981201,836.009216 1578.059692,835.983521 
    C1573.658203,837.602234 1569.256592,839.220947 1564.113892,840.937561 
    C1559.972656,843.281799 1555.831421,845.625977 1551.391602,847.959778 
    C1551.391602,847.959778 1551.113892,848.070374 1550.510254,848.056091 
    C1550.369263,848.396973 1550.228394,848.737854 1549.613525,849.682129 
    C1547.066772,850.728149 1544.018921,851.204346 1542.063599,852.923157 
    C1535.162964,858.989319 1528.636597,865.481323 1521.259155,871.932129 
    C1520.734741,872.604980 1520.210327,873.277771 1519.008423,873.956604 
    C1518.645386,874.884827 1518.282349,875.813049 1517.397705,877.021301 
    C1517.157349,877.330139 1516.916992,877.639038 1516.112183,878.365173 
    C1511.770630,884.159302 1509.503052,890.700684 1508.990234,898.859436 
    C1509.030884,928.245056 1509.071533,957.630737 1508.989014,987.707092 
    C1509.618042,988.116211 1510.247070,988.525330 1511.825317,989.024902 
    C1623.174438,989.024902 1734.523682,989.024902 1845.936646,989.024902 
    C1845.936646,959.123169 1845.936646,929.979675 1846.018066,900.101624 
    C1845.279053,899.559021 1844.540039,899.016357 1843.924561,898.452515 
    C1843.924561,898.452515 1843.944092,898.576233 1843.936768,897.600220 
    C1844.260254,892.777588 1844.639893,887.934570 1838.872559,883.988220 
    C1838.848389,883.566956 1838.824219,883.145752 1838.641479,882.200562 
    C1837.582886,877.148804 1836.578369,872.061890 1830.899414,870.094116 
    C1830.899414,870.094116 1830.879883,870.235535 1831.020630,869.498718 
    C1829.981323,868.356018 1828.942139,867.213379 1827.580933,865.956543 
    C1827.580933,865.956543 1827.239746,865.939270 1827.086548,865.296265 
    C1826.694214,864.888489 1826.301758,864.480713 1825.575684,863.958191 
    C1825.575684,863.958191 1825.223999,863.930115 1825.075439,863.207642 
    C1822.766602,860.898865 1821.310791,857.299316 1817.034424,857.970764 
    C1817.034424,857.970764 1817.096924,857.978394 1817.044189,857.320984 
    C1816.668945,856.906982 1816.293701,856.492981 1815.576294,855.964722 
    C1815.576294,855.964722 1815.217041,855.935730 1815.069458,855.192139 
    C1813.058838,854.090759 1811.048096,852.989441 1808.645996,851.297668 
    C1807.741211,850.968323 1806.754150,850.775330 1805.945190,850.287109 
    C1801.352539,847.515503 1797.011108,844.229431 1792.187866,841.961121 
    C1785.283813,838.714172 1778.111572,835.984863 1770.907837,833.449158 
    C1767.227051,832.153503 1763.228638,831.760376 1759.120239,830.906677 
    C1759.120239,836.869629 1759.364746,842.166687 1759.045532,847.429565 
    C1758.771729,851.942993 1757.852783,856.417236 1757.212524,861.797302 
    C1756.863403,863.194275 1756.514282,864.591187 1755.788574,866.682800 
    C1751.241699,881.116455 1746.694946,895.550049 1741.817993,910.627380 
    C1741.592285,911.747375 1741.366577,912.867371 1741.016846,914.423462 
    C1741.016846,914.423462 1740.963623,914.873657 1740.186401,914.968811 
    C1736.479980,921.549866 1732.630737,928.056580 1729.147583,934.753662 
    C1727.988403,936.982300 1727.768433,939.699341 1727.097534,942.061646 
    C1727.097534,942.061646 1727.230225,942.074402 1726.589966,942.092590 
    C1726.111938,942.731750 1725.633911,943.370911 1724.880127,944.581909 
    C1724.290527,945.427612 1723.700928,946.273376 1722.994263,947.390625 
    C1722.994263,947.390625 1723.006836,947.686157 1722.273682,947.910278 
    C1720.357300,951.307861 1718.441040,954.705444 1716.103516,958.410706 
    C1715.665405,958.776001 1715.227173,959.141357 1714.893433,959.464355 
    C1714.893433,959.464355 1714.932861,959.569885 1714.947388,958.673218 
    C1714.908691,957.779785 1714.869995,956.886292 1714.967896,955.110413 
    C1714.272949,952.564880 1717.085205,949.018250 1712.903320,947.468506 
    C1712.903320,947.468506 1712.926880,947.578308 1712.951050,946.642273 
    C1712.911987,945.398926 1712.872803,944.155640 1712.951294,942.036865 
    C1711.973267,933.022339 1711.072632,923.998413 1709.982666,914.997498 
    C1709.482788,910.869751 1708.739502,906.759766 1707.875854,902.690735 
    C1706.723145,897.259094 1705.047119,891.924500 1704.144043,886.457642 
    C1703.133423,880.339478 1702.746826,874.118713 1702.054077,867.946472 
    C1701.985474,867.334839 1701.559692,866.761047 1701.502686,866.150696 
    C1701.373047,864.764771 1701.273315,863.362122 1701.342285,861.975342 
    C1701.411865,860.573792 1701.699585,859.183044 1701.916748,857.920349 
    C1701.916748,857.920349 1701.781982,857.910645 1702.598511,858.015503 
    C1703.463623,856.686035 1704.551392,855.449280 1705.151489,854.009399 
    C1706.826172,849.990723 1708.298950,845.887878 1709.869995,841.923218 
    C1709.869995,841.923218 1709.766357,841.897888 1710.611816,841.997620 
    C1711.025513,840.608215 1711.439087,839.218811 1711.937866,837.908997 
    C1711.937866,837.908997 1711.821899,837.896606 1712.570435,837.791016 
    C1712.683594,837.315735 1712.796753,836.840454 1712.939087,836.492249 
    C1712.939087,836.492249 1712.809326,836.505249 1713.565674,836.148865 
    C1714.709595,833.464600 1715.853394,830.780273 1717.604980,827.725037 
    C1719.455688,823.388428 1717.973389,820.980896 1713.349976,820.929321 
    C1708.238037,820.872314 1703.125122,820.890137 1697.666382,820.146179 
    C1696.970093,819.760681 1696.275757,819.043274 1695.577271,819.039185 
    C1683.430786,818.967468 1671.283691,818.951111 1659.137817,819.060974 
    C1658.417114,819.067444 1657.707031,820.240784 1656.067017,820.978455 
    C1650.038940,821.611328 1644.010742,822.244263 1637.187622,822.948914 
    C1636.608765,823.999390 1635.270142,825.404114 1635.569092,826.045593 
    C1638.518433,832.373535 1641.700928,838.594971 1644.943726,844.780334 
    C1645.263550,845.390503 1646.423218,845.560303 1647.092896,845.952271 
    C1647.092896,845.952271 1647.104980,845.851196 1646.992676,846.686951 
    C1647.727661,847.766235 1648.462646,848.845520 1649.104614,849.946045 
    C1649.104614,849.946045 1649.116699,849.851379 1648.994629,850.685181 
    C1649.724365,851.767944 1650.454102,852.850708 1651.088989,853.950256 
    C1651.088989,853.950256 1651.101929,853.854919 1651.008179,854.691406 
    C1651.736206,855.770325 1652.464111,856.849243 1653.095581,857.945618 
    C1653.095581,857.945618 1653.110229,857.848694 1653.006836,858.683655 
    C1653.726196,859.769897 1654.445557,860.856140 1655.083130,861.963867 
    C1655.083130,861.963867 1655.085693,861.879272 1655.043945,862.658264 
    C1655.082642,863.435791 1655.121338,864.213379 1655.025757,865.373047 
  z"/>
  <path fill="#ED1C24" opacity="1.000000" stroke="none" 
    d="
  M713.136902,616.216553 
    C608.191772,482.794769 503.246643,349.372955 397.960938,215.518204 
    C405.036713,210.216141 411.862701,204.946915 418.851654,199.903564 
    C427.445251,193.702316 436.040558,187.486176 444.881409,181.649551 
    C454.745911,175.137146 464.891968,169.051651 474.906128,162.765457 
    C484.978882,156.442474 494.864594,149.797989 505.149933,143.843063 
    C518.604431,136.053284 532.231567,128.532532 546.046509,121.403755 
    C557.311401,115.590820 568.977539,110.558128 580.434570,105.113815 
    C588.133728,101.455223 595.651184,97.385353 603.477478,94.030159 
    C614.988770,89.095177 626.712097,84.656097 638.326599,79.960075 
    C643.397949,77.909630 648.352661,75.551743 653.486084,73.678040 
    C661.823181,70.635017 670.267090,67.885277 678.659790,64.993721 
    C689.059814,61.410549 699.364807,57.519600 709.875244,54.298115 
    C720.053162,51.178593 730.410889,48.625065 740.740723,46.026066 
    C760.654236,41.015781 780.528748,35.811913 800.566162,31.346558 
    C812.905212,28.596794 825.515320,27.062773 838.004517,24.987370 
    C850.015930,22.991369 862.004456,20.838514 874.049438,19.070915 
    C880.994690,18.051710 888.033936,17.680477 895.027100,16.979317 
    C904.805908,15.998832 914.574097,14.905870 924.360535,14.010412 
    C930.267273,13.469952 936.195190,13.002063 942.121887,12.867835 
    C959.267334,12.479528 976.416260,12.198003 993.565308,12.024381 
    C1008.814514,11.869992 1024.070801,11.664886 1039.314209,11.969309 
    C1048.180054,12.146366 1057.019287,13.402923 1065.884277,13.948722 
    C1072.948120,14.383626 1080.056030,14.201451 1087.102051,14.795793 
    C1095.241577,15.482370 1103.335693,16.711468 1111.447510,17.721071 
    C1117.428101,18.465422 1123.411987,19.187378 1129.382690,20.005293 
    C1138.710327,21.283077 1148.051880,22.485346 1157.343628,23.991232 
    C1168.729004,25.836424 1180.122437,27.701765 1191.416504,30.024248 
    C1210.144653,33.875431 1228.844604,37.891865 1247.463013,42.238708 
    C1259.570190,45.065357 1271.607788,48.285847 1283.501465,51.905437 
    C1296.153687,55.755989 1308.597778,60.290310 1321.135742,64.517204 
    C1330.877197,67.801338 1340.734009,70.780273 1350.336426,74.429573 
    C1360.161499,78.163582 1369.716919,82.602310 1379.431763,86.632904 
    C1388.302124,90.313141 1397.443359,93.411255 1406.085693,97.556892 
    C1425.581909,106.909119 1444.859863,116.717720 1464.192505,126.408760 
    C1471.916748,130.280762 1479.689819,134.088791 1487.192993,138.360886 
    C1497.572021,144.270432 1507.755981,150.526886 1517.951050,156.753464 
    C1527.940552,162.854477 1538.062012,168.776932 1547.727295,175.362274 
    C1563.809082,186.319443 1579.574341,197.741501 1595.467529,208.975174 
    C1596.809937,209.924042 1598.113159,210.928360 1599.557617,211.997971 
    C1592.128418,221.675598 1585.288940,230.589691 1578.444458,239.499847 
    C1568.773926,252.088837 1559.149658,264.713745 1549.416626,277.254059 
    C1530.736206,301.322662 1511.904419,325.274323 1493.301147,349.402191 
    C1475.314331,372.730499 1457.583252,396.255737 1439.653320,419.628082 
    C1420.924316,444.041962 1402.085693,468.371796 1383.306396,492.747223 
    C1364.119995,517.651001 1344.955933,542.571960 1325.766235,567.473145 
    C1313.337036,583.601440 1300.879150,599.707703 1287.720947,615.992432 
    C1285.010742,616.105530 1283.013550,616.001709 1281.016479,616.001648 
    C1094.220337,615.994263 907.424133,615.993896 720.627930,616.003967 
    C718.130920,616.004089 715.633911,616.142639 713.136902,616.216553 
  M907.961670,121.500359 
    C907.590210,121.374207 907.218750,121.248047 906.954163,121.100395 
    C906.954163,121.100395 906.930969,121.206886 906.904358,120.424507 
    C905.772156,119.633324 904.639893,118.842148 903.499390,117.999962 
    C903.499390,117.999962 903.481812,118.048798 903.085510,117.338287 
    C902.548340,116.900467 902.011169,116.462654 901.467773,115.984947 
    C901.467773,115.984947 901.477051,116.026573 901.103516,115.335854 
    C899.083923,114.208626 897.064331,113.081398 895.013123,111.156998 
    C889.361877,107.467705 883.388428,105.741882 876.416992,105.831627 
    C849.945190,106.172417 823.466370,105.968643 796.990173,105.968475 
    C795.378296,105.968460 793.766418,105.968468 792.145203,105.968468 
    C792.145203,107.642899 792.145203,108.803650 791.988098,110.894669 
    C791.968201,173.489670 791.987793,236.084778 791.849854,298.679504 
    C791.839355,303.451904 793.501648,307.313293 796.038818,311.845978 
    C796.876892,314.217651 797.221985,316.944366 798.632874,318.903595 
    C808.072693,332.012054 820.551392,339.421509 837.167664,339.133667 
    C849.972412,338.911865 862.784119,339.081116 875.592712,339.099823 
    C877.019775,339.101898 878.446594,339.256714 878.747864,339.274475 
    C880.045471,342.481140 880.999023,344.854095 881.965820,347.221619 
    C883.041931,349.857117 885.445984,352.766266 884.958984,355.066589 
    C883.650452,361.247467 887.684509,365.190643 889.741028,369.969543 
    C889.805908,370.120209 890.674072,369.925232 891.068237,369.922394 
    C891.068237,369.922394 891.104797,369.824829 890.963745,370.546570 
    C891.007812,371.032288 891.051880,371.518005 891.083435,372.535980 
    C891.366760,372.732880 891.650085,372.929810 891.959167,373.033325 
    C891.959167,373.033325 891.879578,373.088531 892.138855,373.677399 
    C892.734924,374.513184 893.331055,375.348999 893.971741,376.603394 
    C893.971741,376.603394 894.098206,377.004913 894.062866,377.538635 
    C894.347107,377.735138 894.631348,377.931641 894.916565,378.006714 
    C894.916565,378.006714 894.879333,378.122375 895.128845,378.693726 
    C896.075500,379.482635 897.022156,380.271545 898.057617,381.534973 
    C898.057617,381.534973 898.169495,382.004608 898.193848,382.672699 
    C899.534790,384.096710 900.875793,385.520752 902.732056,387.422638 
    C908.887756,394.768036 915.974243,400.950104 924.932251,405.861145 
    C925.840515,406.213043 926.748840,406.564941 927.513977,406.967346 
    C927.513977,406.967346 927.478088,406.819824 927.835022,407.560577 
    C933.556580,409.992065 939.278198,412.423553 945.765686,415.044128 
    C948.327087,415.844025 950.878052,416.679382 953.452209,417.435883 
    C957.702759,418.685059 961.915710,420.137604 966.242371,421.029938 
    C970.386047,421.884552 974.654358,422.135223 978.942200,422.660400 
    C978.942200,435.463470 979.046265,447.115967 978.812134,458.761597 
    C978.782471,460.240143 976.982422,461.683105 975.427063,463.206024 
    C974.947144,463.529480 974.467224,463.852905 973.201111,464.029724 
    C971.469421,464.403320 969.737671,464.776917 967.433044,465.200134 
    C966.955383,465.516205 966.477661,465.832275 965.188965,466.000183 
    C962.079529,467.320251 958.970154,468.640320 955.433167,470.011902 
    C955.433167,470.011902 955.017090,470.123383 954.271667,469.998840 
    C953.560242,470.850098 952.848877,471.701355 951.922974,472.951569 
    C951.922974,472.951569 951.536072,473.187317 950.998596,473.307190 
    C950.663452,473.172485 950.328308,473.037750 949.757751,472.275055 
    C948.486145,472.830902 947.214478,473.386780 946.004395,473.967529 
    C946.004395,473.967529 945.945129,473.927856 945.213867,473.939606 
    C944.116394,474.942383 943.018860,475.945129 941.973877,476.995911 
    C941.973877,476.995911 941.977234,476.924866 941.267273,476.947327 
    C940.859497,477.377563 940.451782,477.807800 939.928101,478.411316 
    C939.928101,478.411316 939.993164,478.609375 939.389282,478.898834 
    C938.906555,479.247833 938.423828,479.596832 938.000000,479.995117 
    C938.000000,479.995117 937.941895,479.940521 937.281494,480.135712 
    C935.138611,482.378815 932.995728,484.621918 930.227600,487.218170 
    C928.516907,490.181030 926.806213,493.143890 924.602356,496.695465 
    C922.012024,499.240417 920.319153,502.117310 921.069397,506.754578 
    C921.065491,507.028717 921.061584,507.302887 921.035339,507.493896 
    C921.035339,507.493896 921.120667,507.482483 920.376465,507.882782 
    C919.768311,509.581024 919.160156,511.279297 917.725525,513.002625 
    C917.531006,516.669556 917.336487,520.336548 917.088501,524.875549 
    C918.531250,525.220703 919.973633,525.866150 921.416748,525.867493 
    C974.163879,525.918457 1026.911011,525.909546 1079.658203,525.908936 
    C1082.080811,525.908875 1084.503418,525.908936 1088.126709,525.908936 
    C1086.549805,519.160522 1085.243652,513.225647 1083.733154,507.343323 
    C1083.341797,505.819580 1082.310547,504.460205 1081.532959,502.939087 
    C1081.532959,502.939087 1081.478394,503.017487 1081.126465,502.380890 
    C1080.761475,501.568634 1080.396484,500.756378 1080.012573,500.005096 
    C1080.012573,500.005096 1080.058960,499.960999 1079.833374,499.280090 
    C1078.903198,498.172150 1077.973022,497.064209 1077.023438,495.129761 
    C1077.774170,490.684357 1074.305176,489.096649 1071.509277,486.986633 
    C1071.509277,486.986633 1071.467529,487.022614 1071.123413,486.328949 
    C1069.767090,484.869141 1068.410889,483.409363 1067.009766,482.000214 
    C1067.009766,482.000214 1067.041870,481.942261 1066.886108,481.292175 
    C1065.634399,480.476990 1064.382690,479.661804 1063.061646,478.114014 
    C1059.986084,474.539917 1056.368042,472.004608 1051.493652,472.003479 
    C1051.493652,472.003479 1051.518311,472.085510 1051.120483,471.408630 
    C1050.127075,470.997986 1049.133545,470.587341 1047.403442,470.130402 
    C1046.018555,469.761200 1044.633667,469.391998 1042.961182,468.784515 
    C1042.961182,468.784515 1042.739990,468.483551 1042.741577,468.529907 
    C1042.741577,468.529907 1042.783569,468.506653 1041.964722,468.134338 
    C1041.672241,468.068451 1041.379761,468.002594 1040.677856,467.305817 
    C1035.061401,465.508514 1029.444946,463.711212 1023.957397,460.996857 
    C1023.927429,448.669800 1023.897461,436.342743 1024.011963,423.658722 
    C1024.011963,423.658722 1024.015625,423.273590 1024.817871,423.117798 
    C1031.194092,421.766571 1037.602295,420.548065 1043.937256,419.025146 
    C1049.759155,417.625580 1055.621826,416.232666 1061.246094,414.220612 
    C1066.788574,412.237885 1072.317261,409.925507 1077.363770,406.934265 
    C1081.971680,404.203064 1085.925781,400.369141 1090.773560,396.723328 
    C1094.529663,392.885010 1098.285767,389.046661 1102.784668,385.091766 
    C1103.841431,383.669861 1104.898193,382.247955 1106.064453,380.587738 
    C1106.064453,380.587738 1106.039673,380.326630 1106.761719,380.122986 
    C1107.824097,378.361816 1108.886475,376.600647 1110.060547,374.591797 
    C1110.060547,374.591797 1110.038940,374.320923 1110.802124,374.110626 
    C1111.177124,373.041382 1111.552124,371.972168 1112.044800,370.594116 
    C1112.044800,370.594116 1112.045898,370.263672 1112.829956,370.088837 
    C1117.090088,360.033325 1121.350220,349.977814 1125.962402,339.091034 
    C1139.162598,339.091034 1153.780762,339.509186 1168.355103,338.893951 
    C1174.552734,338.632324 1180.706543,336.372833 1186.771484,334.640442 
    C1188.170898,334.240662 1189.124023,332.278442 1191.041748,331.092316 
    C1191.854980,331.036804 1192.978760,331.308533 1193.434326,330.876160 
    C1199.195190,325.409271 1204.888672,319.841492 1207.916138,312.268188 
    C1208.843384,309.948730 1209.356689,307.463898 1210.800781,304.716125 
    C1211.202148,303.195709 1211.953247,301.675568 1211.954590,300.154816 
    C1212.010864,237.172668 1212.007202,174.190506 1211.954346,111.208359 
    C1211.953003,109.661507 1211.311157,108.115196 1210.889404,106.214417 
    C1210.719482,105.975548 1210.503784,105.922264 1209.253662,106.003639 
    C1179.416992,106.019714 1149.580322,106.035797 1119.009399,105.903809 
    C1106.125977,110.592178 1096.315430,118.828903 1089.959473,130.978699 
    C1089.959473,130.978699 1090.035767,130.956284 1089.500854,131.114914 
    C1089.260864,131.396759 1089.020874,131.678589 1088.003296,131.965286 
    C1086.968262,134.962952 1085.933228,137.960617 1084.205566,141.267654 
    C1083.826416,142.656921 1083.447388,144.046204 1082.930298,145.764420 
    C1082.883667,146.012039 1082.933838,146.238297 1082.247314,146.924271 
    C1030.478516,146.949265 978.709656,146.946701 926.941040,147.064865 
    C923.688049,147.072281 920.923340,146.798767 918.996338,143.234451 
    C918.944397,142.818634 918.892456,142.402802 918.951416,141.358093 
    C918.659790,140.839294 918.368164,140.320496 918.030823,139.122223 
    C917.642944,138.086472 917.255066,137.050720 916.844910,135.413208 
    C916.505859,134.920670 916.166809,134.428146 915.683594,133.290375 
    C915.144836,132.173615 914.606079,131.056854 913.782104,129.291931 
    C912.836670,128.366455 911.891174,127.440987 911.040344,126.000839 
    C910.527466,125.347511 910.014648,124.694183 909.093262,123.421082 
    C908.659485,122.964455 908.225708,122.507820 907.909546,122.034256 
    C907.909546,122.034256 907.888062,122.151169 907.961670,121.500359 
  z"/>
  <path fill="#FF7F28" opacity="1.000000" stroke="none" 
    d="
  M535.229553,1146.023560 
    C533.582886,1147.010986 532.052124,1148.352051 530.273010,1148.935547 
    C404.011749,1190.329590 277.731659,1231.666260 151.450668,1273.000244 
    C122.317352,1282.536133 93.174553,1292.043091 64.038361,1301.570312 
    C57.839973,1303.597046 57.900082,1303.593506 55.843151,1297.088745 
    C44.346424,1260.731689 35.027851,1223.811890 28.095013,1186.331299 
    C24.504301,1166.919189 21.452961,1147.372681 19.107174,1127.773315 
    C16.223358,1103.678955 13.760983,1079.502686 12.190569,1055.292236 
    C10.954655,1036.238403 11.346980,1017.078857 11.421062,997.260010 
    C11.731285,985.932861 11.636500,975.312073 11.541716,964.691223 
    C12.018976,956.056641 12.307771,947.406555 13.012390,938.790588 
    C14.521309,920.339722 15.610605,901.822632 18.034403,883.486267 
    C21.401161,858.016357 25.321316,832.593872 29.929012,807.319519 
    C37.361805,766.549133 47.862961,726.479431 61.789532,687.462097 
    C72.745491,656.767334 85.115005,626.570007 97.209534,596.292725 
    C101.308838,586.030518 106.302773,576.107666 111.234207,566.202148 
    C114.823227,558.993103 119.121170,552.140320 122.848190,544.995728 
    C127.116180,536.814148 130.612137,528.194580 135.308273,520.278320 
    C146.734192,501.017700 158.623276,482.030884 170.403381,462.981750 
    C175.114029,455.364349 179.638397,447.587006 184.923691,440.378174 
    C200.747208,418.795898 216.247086,396.926208 233.071655,376.138611 
    C265.847504,335.642487 301.625092,297.879669 340.729187,263.389923 
    C358.246368,247.939758 376.244904,233.035355 394.484100,217.492065 
    C397.194855,220.778961 399.530457,223.497421 401.744263,226.311676 
    C503.526276,355.699341 605.299316,485.094055 707.053406,614.503662 
    C708.464294,616.297852 709.622681,618.290649 710.639648,620.785522 
    C666.106079,753.887695 621.821228,886.391663 577.563416,1018.904541 
    C563.415405,1061.265381 549.338867,1103.649902 535.229553,1146.023560 
  M508.825439,991.073120 
    C509.277527,990.436890 509.729614,989.800659 510.724518,988.878967 
    C511.537933,987.976440 512.351318,987.073853 513.775452,985.829590 
    C514.142273,984.805542 514.509094,983.781433 514.901367,982.880432 
    C514.901367,982.880432 514.776428,982.866882 515.560547,983.003784 
    C515.994995,982.256592 516.429382,981.509399 516.886658,980.881165 
    C516.886658,980.881165 516.767151,980.861755 517.555908,981.000061 
    C517.986206,980.250244 518.416565,979.500366 518.871887,978.890625 
    C518.871887,978.890625 518.730713,978.872375 519.525940,979.004578 
    C519.973083,978.003601 520.420227,977.002625 520.979858,975.510071 
    C521.007202,975.344238 521.034607,975.178345 521.763855,974.999023 
    C522.891968,973.711853 524.020142,972.424622 525.867920,971.055542 
    C527.001343,969.052002 528.134766,967.048523 530.005615,965.001770 
    C531.490784,962.971008 533.128845,961.029663 534.393127,958.869690 
    C534.976562,957.872986 534.829529,956.448792 535.744202,955.060181 
    C536.138245,954.310791 536.532288,953.561340 537.026123,952.579834 
    C537.026123,952.579834 537.010315,952.327637 537.629456,951.948547 
    C538.060608,950.905090 538.491699,949.861572 539.024353,948.582336 
    C539.024353,948.582336 539.010864,948.325989 539.628845,947.948486 
    C540.059937,946.907104 540.490967,945.865723 541.023071,944.582031 
    C541.023071,944.582031 541.010864,944.319824 541.685852,943.897705 
    C542.145996,941.929504 542.606140,939.961243 543.001953,938.034119 
    C543.001953,938.034119 543.036499,938.102234 543.820862,938.028687 
    C545.611267,932.337646 547.599304,926.699402 549.136780,920.940796 
    C550.681152,915.156555 551.840820,909.265564 553.042358,903.395447 
    C553.662903,900.363953 554.284912,897.288574 554.421631,894.211487 
    C554.714722,887.611450 555.224670,880.951599 554.660095,874.401245 
    C554.021667,866.992676 552.423279,859.653992 551.006775,852.330444 
    C550.221558,848.270691 549.090149,844.261475 547.847534,840.313538 
    C547.241943,838.389282 546.024414,836.657654 545.055542,834.125305 
    C544.980103,833.414124 544.904663,832.703003 544.792603,831.404419 
    C544.213013,830.887573 543.633362,830.370728 543.046692,829.069336 
    C540.227844,822.817993 537.603821,816.467773 534.504333,810.358826 
    C533.048584,807.489563 530.677063,805.084961 528.915649,802.513489 
    C528.915649,802.513489 528.852112,802.703003 529.007751,801.843750 
    C527.609314,800.271057 526.210815,798.698425 524.905701,797.110229 
    C524.905701,797.110229 524.873291,797.199219 525.003052,796.388184 
    C524.006653,795.546631 523.010254,794.705078 521.676392,793.298462 
    C519.495422,790.526367 517.314453,787.754272 515.051880,784.205994 
    C510.622986,778.089172 512.060730,771.047791 512.049194,764.292725 
    C511.983917,726.015747 511.953156,687.738342 512.070557,649.461548 
    C512.103516,638.705872 506.805817,630.595520 500.017853,623.097778 
    C499.430389,622.448914 498.101105,622.471619 496.477234,621.809204 
    C492.919983,616.903931 488.562714,613.464722 481.513336,613.296143 
    C479.782074,613.247192 478.050842,613.198303 476.440063,613.057373 
    C476.440063,613.057373 476.517609,613.187622 475.859070,612.529602 
    C474.897186,612.353149 473.935333,612.022522 472.973450,612.022583 
    C443.132721,612.024414 413.291962,612.058594 383.523956,612.104065 
    C383.523956,612.104065 383.499756,612.174561 383.166229,611.404419 
    C382.422424,608.830750 382.216248,605.904663 380.812714,603.763428 
    C378.530334,600.281494 375.464630,597.313049 372.883911,594.111511 
    C372.883911,594.111511 372.858948,594.264709 372.992950,593.496582 
    C372.330536,592.872253 371.668091,592.247925 371.028351,591.459106 
    C371.028351,591.459106 370.941223,591.317688 370.924988,590.578552 
    C370.286133,590.267883 369.647278,589.957275 369.022644,589.458496 
    C369.022644,589.458496 368.934082,589.291992 368.928894,588.517456 
    C367.057709,587.373474 365.186554,586.229492 363.458099,585.035034 
    C363.458099,585.035034 363.496307,585.181519 363.126465,584.501038 
    C362.419952,583.897705 361.713470,583.294312 360.979401,581.979492 
    C355.015045,578.977539 349.318329,575.092590 343.022491,573.184387 
    C333.983307,570.444763 324.612885,569.480042 314.926727,570.801758 
    C307.181915,571.858582 299.775024,572.861633 293.182129,578.269470 
    C292.490906,578.710632 291.799652,579.151855 290.973511,579.981934 
    C290.973511,579.981934 290.569855,580.062744 289.909637,580.170593 
    C286.471466,582.121704 282.599915,583.580261 279.694305,586.136658 
    C275.055817,590.217529 269.828644,594.181641 268.832031,601.861694 
    C268.497131,602.245239 268.162262,602.628723 267.303375,603.450012 
    C266.218689,606.324951 265.134003,609.199951 263.989990,612.031311 
    C263.989990,612.031311 264.061157,612.048401 263.116974,612.013916 
    C233.697128,612.009277 204.277237,611.986694 174.857513,612.046021 
    C173.154114,612.049500 171.452057,612.718140 169.025757,613.277466 
    C165.653183,614.166687 162.280609,615.055908 158.077362,615.992737 
    C156.589813,616.463440 153.710602,614.498840 154.095932,618.098145 
    C154.095932,618.098145 154.258713,618.124390 153.503510,618.015320 
    C152.937866,618.665344 152.372223,619.315308 151.435547,619.988770 
    C151.435547,619.988770 151.078384,620.091980 150.430801,620.149353 
    C150.275284,620.750854 150.119781,621.352417 149.495621,622.021240 
    C149.495621,622.021240 149.034988,622.130798 148.328247,621.998657 
    C147.135178,623.317444 145.942093,624.636230 144.020676,625.984314 
    C142.073303,629.286194 140.125931,632.588013 138.010513,636.654968 
    C135.462387,641.992798 134.913208,647.589355 134.919998,653.496765 
    C135.033768,752.413208 134.981308,851.329895 135.092285,950.246399 
    C135.095642,953.235107 136.465179,956.222229 137.076065,959.931458 
    C137.769409,961.968689 138.462738,964.005859 139.013992,966.781128 
    C139.665894,967.562500 140.317810,968.343872 140.969681,969.682373 
    C141.002533,970.051331 141.035385,970.420227 141.070877,971.500610 
    C141.809021,971.962646 142.547150,972.424622 143.110992,972.896912 
    C143.110992,972.896912 143.139618,972.724670 142.986923,973.457214 
    C143.614136,974.017700 144.241364,974.578186 144.944199,975.841125 
    C147.292526,977.587585 149.640869,979.334106 151.991638,981.006165 
    C151.991638,981.006165 151.917206,981.006470 151.954926,981.706238 
    C152.387848,982.119324 152.820786,982.532410 153.425919,983.041504 
    C153.425919,983.041504 153.620712,983.010986 154.033646,983.615601 
    C155.086060,984.053040 156.138489,984.490479 157.420441,985.028137 
    C157.420441,985.028137 157.670288,985.010620 157.912796,985.762573 
    C158.993790,986.149536 160.074768,986.536438 161.408844,987.026489 
    C161.408844,987.026489 161.682083,987.021423 162.138306,987.730652 
    C163.819519,988.170532 165.500153,988.991882 167.182022,988.994446 
    C208.154922,989.056519 249.128052,989.065552 290.100952,988.986938 
    C296.626678,988.974426 303.223969,988.226746 308.067383,994.034363 
    C308.235504,994.235962 308.698425,994.191650 309.385590,994.755798 
    C310.195068,994.845642 311.004517,994.935486 312.067139,995.057190 
    C312.067139,995.057190 312.049530,995.311707 312.489685,995.682983 
    C313.815857,996.731445 315.142029,997.779968 317.031494,999.152954 
    C317.130280,999.345825 317.229034,999.538696 317.774323,999.948547 
    C319.103210,1001.306458 320.432098,1002.664307 321.928192,1004.762573 
    C324.958801,1006.465637 327.989410,1008.168701 331.445923,1009.985718 
    C331.445923,1009.985718 331.885101,1010.024170 331.958679,1010.698059 
    C332.369904,1011.109253 332.781097,1011.520447 333.423065,1012.031799 
    C333.423065,1012.031799 333.674377,1012.020081 334.051117,1012.635742 
    C335.088013,1013.064392 336.124939,1013.493042 337.423187,1014.023254 
    C337.423187,1014.023254 337.703522,1014.018860 337.913330,1014.777954 
    C338.990997,1015.156616 340.068665,1015.535339 341.420410,1016.017639 
    C341.420410,1016.017639 341.713379,1016.017517 341.914764,1016.775330 
    C342.985046,1017.152954 344.055359,1017.530579 345.416412,1018.013428 
    C345.416412,1018.013428 345.725616,1018.017456 345.917267,1018.776550 
    C346.986847,1019.156738 348.056427,1019.536987 349.405365,1020.021973 
    C349.405365,1020.021973 349.703674,1020.026917 350.137512,1020.665894 
    C355.522034,1022.463562 360.849335,1024.466431 366.310364,1025.989746 
    C370.242310,1027.086548 374.353851,1027.537231 378.383057,1028.287964 
    C385.147095,1029.548218 391.898743,1031.792114 398.674713,1031.865723 
    C410.107025,1031.990234 421.579132,1031.001709 432.980347,1029.913696 
    C436.446533,1029.582886 439.734528,1027.384521 443.038635,1026.004150 
    C443.038635,1026.004150 442.995728,1026.066162 443.885040,1026.027710 
    C448.792206,1026.413818 453.206543,1025.168701 457.013763,1021.996704 
    C457.013763,1021.996704 457.027710,1022.061707 457.518372,1021.996887 
    C457.518372,1021.996887 457.993744,1021.859314 458.731750,1021.949524 
    C466.204041,1018.616394 473.929993,1015.740356 481.056854,1011.784851 
    C485.602753,1009.261841 489.261383,1005.140259 493.443573,1001.444336 
    C493.443573,1001.444336 493.717773,1001.285156 494.223816,1000.972656 
    C495.137939,1000.604980 496.052094,1000.237305 497.717316,1000.019287 
    C500.865479,997.400879 504.013672,994.782471 507.606720,991.955872 
    C507.885925,991.757507 508.072083,991.493530 508.825439,991.073120 
  z"/>
  <path fill="#090606" opacity="1.000000" stroke="none" 
    d="
  M535.625122,1146.017822 
    C549.338867,1103.649902 563.415405,1061.265381 577.563416,1018.904541 
    C621.821228,886.391663 666.106079,753.887695 710.655579,621.134705 
    C711.457458,621.270020 711.934631,621.780457 712.521301,622.004700 
    C713.706604,622.457764 714.951294,622.755432 716.171509,623.117188 
    C716.037659,621.819214 716.152039,620.423950 715.693420,619.253174 
    C715.309326,618.272888 714.255981,617.554749 713.317993,616.468506 
    C715.633911,616.142639 718.130920,616.004089 720.627930,616.003967 
    C907.424133,615.993896 1094.220337,615.994263 1281.016479,616.001648 
    C1283.013550,616.001709 1285.010742,616.105530 1287.463501,616.230652 
    C1286.839844,618.212097 1285.760620,620.123901 1284.681274,622.035706 
    C1285.117065,622.385742 1285.552734,622.735779 1285.988525,623.085876 
    C1287.400757,622.403137 1288.812988,621.720398 1290.570068,620.935425 
    C1296.949341,638.520447 1303.080078,656.175537 1309.003052,673.900024 
    C1361.462646,830.884399 1413.885254,987.881165 1466.323120,1144.872803 
    C1466.480347,1145.343750 1466.700317,1145.793701 1466.863281,1146.629883 
    C1465.545776,1146.833374 1464.233643,1146.429932 1462.972778,1146.552734 
    C1461.712280,1146.675781 1460.502930,1147.325439 1459.271240,1147.744263 
    C1460.098999,1148.761841 1460.779907,1149.976440 1461.799438,1150.737061 
    C1462.671143,1151.387451 1463.931152,1151.517334 1465.359741,1151.951294 
    C1450.449829,1162.944702 1435.260986,1173.951172 1419.939697,1184.770020 
    C1287.875732,1278.025391 1155.785400,1371.243164 1023.714844,1464.489014 
    C1016.805176,1469.367432 1010.004150,1474.399780 1003.001831,1479.680908 
    C1001.867676,1480.001099 1000.884338,1480.000732 999.532104,1480.002441 
    C982.389954,1468.039795 965.665833,1456.005615 948.835632,1444.121704 
    C812.479492,1347.838379 676.103394,1251.583618 539.736816,1155.315186 
    C538.515564,1154.453003 537.342468,1153.522461 536.023682,1152.304443 
    C537.232483,1150.594849 538.564331,1149.204712 539.896240,1147.814453 
    C538.604309,1147.213745 537.312439,1146.613037 535.625122,1146.017822 
  M719.739319,628.645630 
    C717.109253,636.281921 714.418213,643.897766 711.858093,651.557434 
    C664.926514,791.975647 618.004822,932.397034 571.097229,1072.823242 
    C562.948303,1097.218262 554.873047,1121.637939 546.650879,1146.386108 
    C698.015381,1253.276001 849.297058,1360.107300 1000.708435,1467.030151 
    C1008.536926,1461.554443 1016.181213,1456.253784 1023.778564,1450.886963 
    C1166.116089,1350.337036 1308.438599,1249.765747 1450.842163,1149.309204 
    C1454.003784,1147.078857 1454.654907,1145.375732 1453.413330,1141.710327 
    C1441.961914,1107.900269 1430.740112,1074.012573 1419.433350,1040.153442 
    C1376.455078,911.450012 1333.482422,782.744812 1290.460327,654.056030 
    C1287.544067,645.333008 1284.236450,636.740845 1280.680786,627.307373 
    C1279.360352,627.207642 1278.039917,627.020691 1276.719482,627.020569 
    C1092.704834,627.007629 908.690125,627.005798 724.675476,627.049927 
    C723.166748,627.050293 721.658203,627.680847 719.739319,628.645630 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1412.610229,89.361526 
    C1395.194580,82.150070 1377.788330,74.915451 1360.356445,67.743439 
    C1355.996460,65.949593 1351.553589,64.357140 1347.244019,62.366852 
    C1351.092651,62.570400 1354.631104,61.244049 1358.603516,64.408279 
    C1362.202393,67.275040 1367.913086,67.395790 1372.578979,69.048294 
    C1376.249390,70.348244 1379.809204,72.010994 1383.305542,73.740067 
    C1387.911133,76.017654 1392.274292,78.841957 1397.009399,80.775726 
    C1399.135498,81.643974 1401.910889,80.922646 1404.391602,80.922646 
    C1404.232544,81.435196 1404.073486,81.947754 1403.914429,82.460304 
    C1405.696655,83.318832 1407.408813,84.624176 1409.279785,84.917839 
    C1411.408447,85.251984 1413.708862,84.646286 1412.898682,88.616364 
    C1412.825806,89.161591 1412.610229,89.361519 1412.610229,89.361526 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M119.896912,1476.095947 
    C118.953682,1475.961182 117.608047,1476.171997 117.141090,1475.628174 
    C115.605164,1473.839966 114.132797,1471.902710 113.103462,1469.794434 
    C111.227715,1465.952637 109.717392,1461.933960 107.997238,1458.014160 
    C106.699097,1455.056274 105.311440,1452.137695 103.599983,1448.409424 
    C99.167091,1448.349365 101.529228,1443.879028 100.795914,1440.521973 
    C99.689919,1440.259766 98.383537,1439.950073 96.956306,1439.611694 
    C97.060455,1436.068970 97.352730,1432.879639 93.911263,1430.094116 
    C92.369385,1428.845947 93.103340,1424.786133 93.467773,1421.971191 
    C102.405853,1439.593872 111.343925,1457.216675 120.246307,1475.317383 
    C120.210609,1475.795410 119.896919,1476.095825 119.896912,1476.095947 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M1475.498657,120.539078 
    C1457.708008,111.557327 1439.917358,102.575562 1422.082397,93.571426 
    C1426.719849,92.823372 1439.579102,97.822304 1441.262695,99.598839 
    C1443.643433,101.261688 1445.896729,103.163155 1448.440308,104.520744 
    C1451.026489,105.900993 1453.897705,106.747833 1456.645874,107.823647 
    C1460.383057,109.286491 1464.346924,110.352005 1467.792603,112.323647 
    C1470.815063,114.053261 1473.257324,116.797104 1475.876709,119.651047 
    C1475.797607,120.209167 1475.498657,120.539070 1475.498657,120.539078 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M61.793301,1347.193970 
    C62.173634,1347.316650 62.805927,1347.340576 62.898281,1347.576172 
    C68.920883,1362.937866 74.899757,1378.316650 81.113693,1394.288208 
    C79.965584,1393.765503 78.823120,1393.625244 78.513969,1393.042725 
    C76.559135,1389.359619 74.781540,1385.582031 72.961647,1381.827881 
    C72.297699,1380.458130 71.661125,1379.074585 71.044403,1377.682983 
    C70.646492,1376.785034 70.250237,1375.879395 69.951408,1374.945679 
    C68.317238,1369.839600 67.727295,1364.019287 64.806015,1359.814941 
    C62.037849,1355.830933 62.192970,1352.075562 61.888580,1347.562500 
    C61.850918,1347.141113 61.793304,1347.193970 61.793301,1347.193970 
  z"/>
  <path fill="#AEAEAE" opacity="1.000000" stroke="none" 
    d="
  M8.416467,879.593262 
    C8.047326,882.902283 7.794796,885.781921 7.542266,888.661621 
    C7.335004,888.664734 7.127742,888.667908 6.920481,888.671021 
    C6.920481,879.065125 6.842262,869.457825 7.010246,859.854858 
    C7.033703,858.513794 8.292611,857.206055 8.933633,855.860962 
    C9.644976,854.368530 10.778171,852.886230 10.893465,851.337402 
    C11.201508,847.199219 10.899354,843.016235 11.189885,838.875671 
    C11.291619,837.425781 12.414456,836.047607 13.071013,834.636658 
    C13.584921,834.818237 14.098827,834.999756 14.612735,835.181335 
    C12.586183,849.842224 10.559629,864.503113 8.416467,879.593262 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M1510.556030,140.419586 
    C1499.036499,133.948730 1487.516968,127.477890 1475.748047,120.773056 
    C1475.498657,120.539070 1475.797607,120.209167 1475.951660,120.048485 
    C1479.231079,120.081528 1481.922119,120.109909 1484.851318,122.629112 
    C1488.365479,125.651283 1493.478760,126.813843 1497.697021,129.547226 
    C1499.586060,130.370453 1501.498413,131.144897 1503.355347,132.035004 
    C1504.493164,132.580322 1505.573364,133.261276 1506.628540,133.958359 
    C1507.583496,134.589096 1508.619873,135.196625 1509.343262,136.049347 
    C1510.069458,136.905655 1510.453369,138.052155 1510.902100,139.620590 
    C1510.816895,140.169785 1510.556030,140.419601 1510.556030,140.419586 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M40.675346,1289.418701 
    C39.612564,1288.053711 38.257385,1287.042725 38.185726,1285.947754 
    C37.920982,1281.903076 38.080463,1277.830566 38.723034,1273.672729 
    C42.415794,1285.929932 46.108555,1298.187134 49.850311,1310.606934 
    C47.191246,1311.496338 45.815739,1310.946167 45.991959,1307.839233 
    C46.169399,1304.710449 46.547302,1301.471069 42.669743,1299.858887 
    C42.121696,1299.631104 42.167633,1297.889282 42.004795,1296.838013 
    C41.638508,1294.473389 41.313736,1292.102539 40.675346,1289.418701 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M140.440765,1510.667847 
    C146.717773,1520.718140 152.994797,1530.768311 159.252274,1541.289551 
    C159.110764,1541.881470 158.988785,1542.002441 158.866821,1542.123291 
    C157.716156,1542.123291 156.565475,1542.123291 155.976578,1542.123291 
    C153.467651,1537.835693 151.172882,1533.830933 148.788895,1529.880127 
    C147.803070,1528.246338 146.625916,1526.728149 144.923141,1525.504883 
    C143.154495,1523.103638 146.011490,1518.588623 140.557877,1517.518066 
    C140.009369,1517.410645 140.132477,1513.881226 140.061981,1511.403320 
    C140.180069,1510.866821 140.440765,1510.667847 140.440765,1510.667847 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M124.357109,1482.744629 
    C129.641541,1491.831421 134.925995,1500.918335 140.325607,1510.336426 
    C140.440765,1510.667847 140.180069,1510.866821 140.052887,1510.970215 
    C138.765091,1511.073730 137.604477,1511.073730 136.929733,1511.073730 
    C133.473465,1504.641602 130.151581,1498.459595 126.829689,1492.277588 
    C127.202759,1491.994873 127.575829,1491.712280 127.948898,1491.429688 
    C126.734550,1491.212280 125.520210,1490.994995 123.949158,1490.713745 
    C123.949158,1488.497437 123.949158,1486.210571 124.057800,1483.399536 
    C124.166443,1482.875366 124.357124,1482.744629 124.357109,1482.744629 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M6.984114,1113.945312 
    C8.007382,1120.780396 9.084539,1127.595215 10.094043,1134.420044 
    C10.550659,1137.506958 10.872731,1140.613647 11.324534,1144.266846 
    C9.541231,1143.244019 8.304714,1142.534912 7.194355,1141.898071 
    C7.194355,1132.786987 7.194355,1123.812134 7.121371,1114.358887 
    C7.048388,1113.880615 7.010409,1113.929199 6.984114,1113.945312 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M61.877563,1347.112549 
    C59.190681,1347.459351 57.919327,1346.347412 58.048107,1343.543701 
    C58.206955,1340.085571 57.825127,1337.239624 54.819126,1334.370483 
    C53.096680,1332.726440 54.076111,1328.251831 54.843636,1324.833130 
    C57.256069,1332.017700 59.668499,1339.202148 61.937119,1346.790283 
    C61.793304,1347.193970 61.850918,1347.141113 61.877563,1347.112549 
  z"/>
  <path fill="#ADADAD" opacity="1.000000" stroke="none" 
    d="
  M853.001160,11.954975 
    C847.282593,12.913847 841.579590,13.992625 835.833191,14.736353 
    C834.597046,14.896344 833.204346,13.846324 831.883728,13.353676 
    C833.117859,12.590193 834.321350,11.231527 835.591370,11.166334 
    C841.073303,10.884916 846.574707,10.982346 852.529236,11.220946 
    C852.989441,11.499998 853.001160,11.954975 853.001160,11.954975 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1158.294067,13.540899 
    C1153.685181,12.832749 1149.490356,12.254539 1145.295654,11.676330 
    C1145.312378,11.496640 1145.328979,11.316952 1145.345703,11.137262 
    C1152.381836,11.137262 1159.417969,11.137262 1166.968018,11.137262 
    C1166.888062,12.304135 1166.807617,13.478589 1166.716797,14.803937 
    C1163.880737,14.402671 1161.294434,14.036755 1158.294067,13.540899 
  z"/>
  <path fill="#AEAEAE" opacity="1.000000" stroke="none" 
    d="
  M83.234451,1404.894409 
    C81.952850,1401.739868 81.106285,1398.666992 80.259727,1395.593994 
    C80.752304,1395.424561 81.244888,1395.255127 81.737473,1395.085693 
    C84.262482,1400.752075 86.787491,1406.418457 89.554947,1412.628906 
    C87.800941,1412.837891 86.595421,1412.981445 85.726418,1413.085083 
    C85.005493,1410.242920 84.337486,1407.609497 83.234451,1404.894409 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M12.073794,1148.329834 
    C12.890817,1154.319214 13.677026,1159.923340 14.495932,1165.760498 
    C10.767969,1164.872803 9.723130,1156.478516 11.418373,1146.195557 
    C11.586588,1146.451050 11.809059,1146.687744 11.906678,1146.968018 
    C12.012697,1147.272461 12.002506,1147.617310 12.073794,1148.329834 
  z"/>
  <path fill="#ADADAD" opacity="1.000000" stroke="none" 
    d="
  M821.012390,15.012663 
    C824.308167,15.011908 827.129395,15.011908 829.950684,15.011908 
    C829.984070,15.228783 830.017517,15.445657 830.050964,15.662532 
    C824.394775,16.720278 818.738647,17.778023 813.082458,18.835770 
    C812.700439,18.547548 812.318481,18.259327 811.936462,17.971106 
    C812.809814,16.952654 813.531311,15.310803 814.589966,15.052931 
    C816.464539,14.596284 818.544067,14.980868 821.012390,15.012663 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M159.422333,1541.585938 
    C162.117111,1545.276733 164.622284,1549.141968 167.117462,1553.443359 
    C167.107498,1553.879395 166.937683,1554.056396 166.937683,1554.056396 
    C165.803452,1554.056396 164.669220,1554.056396 163.013947,1554.056396 
    C161.692062,1550.474976 160.307068,1546.722656 158.894440,1542.546753 
    C158.988785,1542.002441 159.110764,1541.881470 159.422333,1541.585938 
  z"/>
  <path fill="#C3C3C3" opacity="1.000000" stroke="none" 
    d="
  M1990.990723,998.585327 
    C1990.575073,997.871826 1989.958252,996.690125 1989.968994,995.514160 
    C1990.061401,985.270752 1990.266113,975.028442 1990.428467,964.768921 
    C1990.487671,964.602600 1990.555908,964.453064 1990.624268,964.303467 
    C1990.453613,964.411499 1990.131226,964.523560 1990.133911,964.626831 
    C1990.433716,975.791626 1990.757812,986.955750 1990.990723,998.585327 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M963.588745,1990.011230 
    C974.952820,1990.219238 986.250916,1990.202881 997.797852,1990.539551 
    C986.538757,1990.524048 975.030823,1990.155396 963.588745,1990.011230 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M11.303605,964.328918 
    C11.636500,975.312073 11.731285,985.932861 11.467523,996.795776 
    C11.344371,986.159729 11.579837,975.281555 11.814482,964.403442 
    C11.817982,964.241150 11.811302,964.078613 11.809374,963.916199 
    C11.561414,963.932983 11.313454,963.949829 11.303605,964.328918 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1264.145020,34.028816 
    C1267.195923,34.733624 1271.487061,31.828531 1272.050049,38.301132 
    C1267.370972,37.094017 1263.113647,35.995708 1258.856323,34.897404 
    C1258.858765,34.607250 1258.861084,34.317097 1258.863525,34.026943 
    C1260.475342,34.026943 1262.087036,34.026943 1264.145020,34.028816 
  z"/>
  <path fill="#CACACA" opacity="1.000000" stroke="none" 
    d="
  M1990.599609,1038.366699 
    C1990.388916,1027.520142 1990.274658,1016.970642 1990.527344,1006.188416 
    C1990.635376,1016.677429 1990.376221,1027.399170 1990.116699,1038.120972 
    C1990.112793,1038.282959 1990.053345,1038.560181 1990.109497,1038.585571 
    C1990.281616,1038.663574 1990.497314,1038.644897 1990.599609,1038.366699 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M33.303513,1253.553711 
    C33.586956,1254.959595 33.744980,1255.969238 34.038486,1257.844360 
    C27.855343,1253.587280 30.824017,1248.070435 30.671095,1243.270386 
    C31.506760,1246.566162 32.342422,1249.861816 33.303513,1253.553711 
  z"/>
  <path fill="#ADADAD" opacity="1.000000" stroke="none" 
    d="
  M37.759422,1271.791504 
    C36.300762,1270.896606 34.416149,1269.845215 34.205582,1268.526367 
    C33.721478,1265.494629 34.052189,1262.332642 34.760632,1259.023438 
    C35.871681,1263.186768 36.982731,1267.350098 37.759422,1271.791504 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1245.092773,31.172155 
    C1244.257202,31.028761 1243.784668,30.933266 1243.312134,30.837769 
    C1248.083984,30.640249 1253.315796,27.991985 1256.849609,34.256714 
    C1253.051636,33.244495 1249.253784,32.232273 1245.092773,31.172155 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1240.737061,29.189589 
    C1235.956909,28.648514 1230.930176,27.760880 1225.903564,26.873243 
    C1230.934448,26.523510 1236.241089,24.393753 1240.737061,29.189589 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M1174.512207,14.913798 
    C1177.568115,14.950948 1180.230469,14.760731 1182.827637,15.087568 
    C1184.334229,15.277143 1185.736084,16.297972 1187.184937,16.944727 
    C1187.039185,17.391924 1186.893311,17.839123 1186.747559,18.286320 
    C1181.375488,17.362419 1176.003418,16.438519 1169.731445,15.359835 
    C1171.817993,15.141401 1172.954712,15.022401 1174.512207,14.913798 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M27.052280,1238.743896 
    C26.621002,1234.512939 26.121222,1230.718506 25.621439,1226.924072 
    C25.974821,1226.860596 26.328203,1226.797119 26.681585,1226.733643 
    C27.848282,1231.352783 29.014978,1235.972046 30.181675,1240.591187 
    C29.894270,1240.836060 29.606865,1241.080811 29.319460,1241.325684 
    C28.540899,1240.610596 27.762339,1239.895386 27.052280,1238.743896 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M16.060602,1173.343994 
    C16.781796,1177.612549 17.465059,1181.508179 18.148323,1185.403687 
    C17.837360,1185.709961 17.526398,1186.016113 17.215435,1186.322388 
    C16.497398,1185.557373 15.194630,1184.818970 15.158326,1184.022949 
    C14.956292,1179.591919 15.061347,1175.146851 15.603835,1170.644653 
    C15.743447,1171.420166 15.883060,1172.195557 16.060602,1173.343994 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M762.114624,29.984863 
    C762.286011,27.279160 763.340454,26.314066 767.121277,25.961489 
    C769.885620,25.703705 772.693420,25.911022 775.582642,26.592022 
    C771.232483,27.705673 766.882263,28.819326 762.114624,29.984863 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1285.318604,40.625084 
    C1284.879272,41.247498 1284.049194,41.969162 1283.456787,41.809422 
    C1280.144165,40.916279 1276.889038,39.810097 1273.676025,38.369740 
    C1277.453003,39.115131 1281.784302,35.859882 1285.318604,40.625084 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M17.181183,821.350830 
    C16.669212,824.677002 16.226002,827.579407 15.745305,830.727295 
    C14.067435,824.348999 14.828101,817.741272 18.307236,815.260559 
    C17.855330,817.682495 17.552637,819.304810 17.181183,821.350830 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M1196.725830,20.409885 
    C1195.095703,20.107855 1193.833008,19.938316 1192.570312,19.768776 
    C1192.602051,19.551502 1192.633789,19.334227 1192.665649,19.116951 
    C1197.059570,19.116951 1201.453613,19.116951 1207.067383,19.116951 
    C1203.547485,24.086763 1200.014282,20.148188 1196.725830,20.409885 
  z"/>
  <path fill="#ADADAD" opacity="1.000000" stroke="none" 
    d="
  M1320.633301,53.407795 
    C1317.762329,52.450596 1315.265137,51.671883 1312.768066,50.893169 
    C1312.762939,50.624428 1312.757690,50.355690 1312.752563,50.086948 
    C1315.662598,50.086948 1318.585327,49.944942 1321.471802,50.205933 
    C1322.053955,50.258575 1322.498169,51.838230 1323.006104,52.713833 
    C1322.339722,53.004639 1321.673462,53.295460 1320.633301,53.407795 
  z"/>
  <path fill="#ADADAD" opacity="1.000000" stroke="none" 
    d="
  M23.010479,1218.224365 
    C23.010952,1216.130005 23.010952,1214.477539 23.010952,1212.354126 
    C26.595308,1221.462769 26.647638,1223.935669 23.010006,1225.117432 
    C23.010006,1222.875366 23.010006,1220.770874 23.010479,1218.224365 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M1328.842773,56.198685 
    C1327.263794,55.671310 1326.067017,55.225521 1324.745117,54.733139 
    C1332.439819,52.921535 1334.516724,53.586460 1334.741943,58.344887 
    C1332.784302,57.612301 1331.004639,56.946289 1328.842773,56.198685 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1304.047852,48.078171 
    C1302.466919,47.575344 1301.266602,47.144768 1299.933838,46.666607 
    C1307.244629,45.034733 1310.190552,45.862309 1310.886475,50.099861 
    C1308.617920,49.415070 1306.523315,48.782749 1304.047852,48.078171 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M50.028503,1314.884277 
    C50.052761,1314.026855 50.079792,1313.547607 50.193115,1311.538574 
    C51.775887,1316.098022 52.890511,1319.308838 54.031807,1322.596436 
    C50.048969,1322.681152 50.048969,1322.681152 50.028503,1314.884277 
  z"/>
  <path fill="#C0C0C0" opacity="1.000000" stroke="none" 
    d="
  M322.928864,264.931335 
    C323.719910,259.717163 328.470886,259.262482 331.425507,256.648743 
    C331.702881,256.968689 331.980255,257.288605 332.257629,257.608551 
    C329.551453,260.136688 326.845276,262.664856 323.697632,265.213135 
    C323.256165,265.233276 322.928864,264.931335 322.928864,264.931335 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1412.932495,89.060471 
    C1415.488892,88.959351 1417.938477,88.959351 1420.782837,88.959351 
    C1420.856567,90.308937 1420.927856,91.615860 1421.022705,93.352936 
    C1418.091431,92.078018 1415.583740,90.987274 1412.843018,89.629028 
    C1412.610229,89.361519 1412.825806,89.161591 1412.932495,89.060471 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M1510.946777,140.044220 
    C1513.289673,141.179138 1517.754395,137.441559 1518.084106,143.445770 
    C1518.015747,143.983139 1517.875244,144.117722 1517.515625,144.445221 
    C1515.185669,143.410828 1513.074951,142.183563 1510.760010,140.687958 
    C1510.556030,140.419601 1510.816895,140.169785 1510.946777,140.044220 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M120.371353,1475.649292 
    C121.755531,1477.695923 122.978973,1479.888550 124.279770,1482.412964 
    C124.357124,1482.744629 124.166443,1482.875366 124.074745,1482.945801 
    C122.734833,1483.016235 121.486618,1483.016235 119.932533,1483.016235 
    C119.932533,1480.815918 119.932533,1478.898560 119.914726,1476.538452 
    C119.896919,1476.095825 120.210609,1475.795410 120.371353,1475.649292 
  z"/>
  <path fill="#C0C0C0" opacity="1.000000" stroke="none" 
    d="
  M323.414551,265.389709 
    C322.230103,266.800629 320.887268,268.055084 319.544434,269.309540 
    C319.172577,268.884094 318.800720,268.458679 318.428833,268.033234 
    C319.679260,267.051971 320.929718,266.070679 322.554504,265.010376 
    C322.928864,264.931335 323.256165,265.233276 323.414551,265.389709 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M853.319641,11.984043 
    C853.001160,11.954975 852.989441,11.499998 852.995239,11.272509 
    C853.909851,11.103928 854.818665,11.162837 857.138611,11.313223 
    C855.063049,11.728209 854.350586,11.870660 853.319641,11.984043 
  z"/>
  <path fill="#C0C0C0" opacity="1.000000" stroke="none" 
    d="
  M317.505524,271.493408 
    C317.504700,271.512512 317.506348,271.474274 317.505524,271.493408 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M168.155640,1554.640137 
    C168.022766,1554.935181 167.835052,1554.952515 167.364899,1554.983887 
    C167.082458,1554.997681 166.908737,1554.542725 166.923218,1554.299561 
    C166.937683,1554.056396 167.107498,1553.879395 167.188568,1553.784790 
    C167.546677,1553.914185 167.823730,1554.138306 168.155640,1554.640137 
  z"/>
  <path fill="#030303" opacity="1.000000" stroke="none" 
    d="
  M1536.509521,1504.175537 
    C1536.509521,1504.175537 1536.482910,1504.029053 1536.101318,1504.401123 
    C1536.185181,1505.500610 1536.650879,1506.228271 1537.164062,1507.279297 
    C1538.124390,1508.119995 1539.037109,1508.637207 1540.106445,1509.398560 
    C1540.893188,1510.076050 1541.523438,1510.509521 1542.208252,1511.224365 
    C1542.891479,1511.806396 1543.520264,1512.106934 1544.375122,1512.672241 
    C1546.302002,1514.026123 1548.002808,1515.115356 1549.875732,1516.491699 
    C1551.016235,1517.236938 1551.984741,1517.694946 1553.275879,1518.382690 
    C1554.711182,1518.803955 1555.824097,1518.995483 1556.936890,1519.186890 
    C1556.936890,1519.186890 1556.947021,1519.079102 1556.642212,1519.484863 
    C1557.868530,1520.323730 1559.399780,1520.757080 1560.930908,1521.190308 
    C1560.930908,1521.190308 1560.937622,1521.083984 1560.625488,1521.491455 
    C1561.852417,1522.328125 1563.391602,1522.757324 1564.930786,1523.186646 
    C1564.930786,1523.186646 1564.940552,1523.065186 1564.611816,1523.339478 
    C1564.412476,1523.831055 1564.541870,1524.048218 1564.842529,1524.572510 
    C1566.336792,1525.266602 1567.659912,1525.653320 1569.157471,1526.124756 
    C1569.331909,1526.209473 1569.719727,1526.198486 1569.868896,1526.466797 
    C1570.734863,1526.912964 1571.451416,1527.090698 1572.448486,1527.449341 
    C1573.166138,1527.692017 1573.603638,1527.753784 1574.321289,1528.042236 
    C1583.404053,1529.550049 1592.206665,1530.831299 1601.376099,1532.180420 
    C1602.736572,1532.231079 1603.729980,1532.213745 1604.858643,1532.642090 
    C1605.238770,1534.874023 1605.678833,1536.658325 1605.695068,1538.446411 
    C1605.770752,1546.741577 1605.729004,1555.037720 1605.728882,1563.333496 
    C1605.728882,1572.591797 1605.728394,1572.588379 1596.766357,1573.138062 
    C1596.454834,1573.156982 1596.155884,1573.383057 1595.444336,1573.394531 
    C1593.345825,1573.243408 1591.653687,1573.210449 1589.820557,1573.006592 
    C1589.117920,1572.883911 1588.556519,1572.931885 1587.659668,1572.872314 
    C1586.389771,1572.733032 1585.455200,1572.701294 1584.279053,1572.421143 
    C1581.353271,1571.762695 1578.669067,1571.352661 1575.728027,1570.840698 
    C1575.106323,1570.751221 1574.741455,1570.763794 1574.142700,1570.543091 
    C1571.597900,1569.842651 1569.287109,1569.375366 1566.735840,1568.795044 
    C1566.145264,1568.678955 1565.795166,1568.675903 1565.221436,1568.402344 
    C1559.266846,1565.998535 1553.259277,1564.401978 1547.862427,1561.620728 
    C1536.432495,1555.730591 1525.321167,1549.222534 1513.955811,1542.661133 
    C1509.513428,1538.729736 1505.194214,1535.104858 1500.680664,1531.207764 
    C1499.062744,1529.596558 1497.639404,1528.257568 1496.192383,1526.584961 
    C1495.141846,1525.044434 1494.114990,1523.837891 1492.446533,1521.877319 
    C1491.483643,1524.485962 1490.592773,1526.212036 1490.210205,1528.044312 
    C1486.969482,1543.563965 1483.699951,1559.079468 1480.711182,1574.648682 
    C1479.669556,1580.075317 1477.168457,1586.243896 1484.763916,1589.814453 
    C1485.306885,1590.355469 1485.738037,1590.656250 1486.203613,1591.283447 
    C1489.140259,1594.152100 1492.042480,1596.694580 1494.995239,1599.353516 
    C1495.045776,1599.469971 1495.291016,1599.536011 1495.384521,1599.849365 
    C1496.304199,1600.795288 1497.130493,1601.427734 1497.975342,1602.029297 
    C1497.994019,1601.998535 1497.938477,1602.044678 1497.992432,1602.351562 
    C1498.706055,1603.091431 1499.365967,1603.524658 1500.017578,1603.976440 
    C1500.009521,1603.995117 1500.045410,1603.973022 1500.134521,1604.292969 
    C1502.080933,1606.232178 1503.938477,1607.851440 1506.142334,1609.756348 
    C1506.960083,1609.770630 1507.431274,1609.499512 1507.902588,1609.228516 
    C1507.902588,1609.228516 1507.916016,1609.099976 1507.479126,1609.493896 
    C1507.992310,1610.326660 1508.942505,1610.765259 1509.892578,1611.203857 
    C1509.892578,1611.203857 1509.909058,1611.090820 1509.480103,1611.479004 
    C1509.997681,1612.312866 1510.944214,1612.758667 1511.890869,1613.204468 
    C1511.890869,1613.204468 1511.907959,1613.076050 1511.471436,1613.336426 
    C1513.286377,1616.967651 1515.140381,1620.804810 1519.940552,1621.184082 
    C1519.940552,1621.184082 1519.949341,1621.050903 1519.555420,1621.311035 
    C1520.437012,1623.049316 1521.712524,1624.527344 1522.942627,1626.471924 
    C1522.918945,1678.287354 1522.940796,1729.636353 1522.532959,1781.189697 
    C1510.786255,1781.471924 1499.459961,1781.307739 1488.156372,1781.739014 
    C1483.183594,1781.928833 1482.154785,1780.192627 1482.176880,1775.534546 
    C1482.356323,1737.733887 1482.306030,1699.931885 1482.199463,1662.130737 
    C1482.193359,1659.981201 1481.749268,1657.147949 1480.369263,1655.800171 
    C1472.425293,1648.042847 1464.137695,1640.637329 1455.810181,1632.833130 
    C1454.401123,1631.520874 1453.148560,1630.488159 1451.697632,1629.176025 
    C1449.721558,1627.241699 1447.943970,1625.586670 1446.059326,1623.609619 
    C1443.430054,1620.858276 1440.907715,1618.428833 1437.465332,1615.113159 
    C1435.205444,1624.937500 1433.179443,1633.409668 1431.340088,1641.922241 
    C1430.697266,1644.896851 1430.514404,1647.970825 1430.121338,1650.999390 
    C1429.872559,1651.800537 1429.623657,1652.601685 1429.198608,1653.785156 
    C1427.958374,1658.463013 1426.894409,1662.758423 1425.692749,1667.307373 
    C1425.564819,1668.127563 1425.574463,1668.694336 1425.376465,1669.511963 
    C1424.763184,1671.513794 1424.357666,1673.264648 1423.797607,1675.309937 
    C1423.603271,1676.480225 1423.563599,1677.356079 1423.309326,1678.475586 
    C1422.724487,1680.480957 1422.354248,1682.243042 1421.844727,1684.275146 
    C1421.706055,1685.143921 1421.706543,1685.742554 1421.488281,1686.600220 
    C1420.819824,1688.914917 1420.370239,1690.970459 1419.782959,1693.288574 
    C1419.649536,1694.135254 1419.653442,1694.719238 1419.429443,1695.553955 
    C1418.751831,1697.886353 1418.302246,1699.968140 1417.725586,1702.305786 
    C1417.591309,1703.123291 1417.584229,1703.684937 1417.267944,1704.522949 
    C1414.954468,1705.145020 1412.950195,1705.490967 1410.650024,1705.699463 
    C1409.495117,1705.544678 1408.636230,1705.527344 1407.522827,1705.285278 
    C1405.157715,1704.644043 1403.046875,1704.227539 1400.640625,1703.677124 
    C1399.490356,1703.527954 1398.635498,1703.512573 1397.524902,1703.276733 
    C1395.171265,1702.680298 1393.073608,1702.304443 1390.707031,1701.794434 
    C1389.846802,1701.674927 1389.255493,1701.689697 1388.391113,1701.487549 
    C1385.735474,1700.817749 1383.352905,1700.364990 1380.702637,1699.780396 
    C1379.848022,1699.663330 1379.260864,1699.677979 1378.400879,1699.471558 
    C1375.747681,1698.820923 1373.367310,1698.391357 1370.706421,1697.841309 
    C1369.822632,1697.730347 1369.219604,1697.739624 1368.341797,1697.534180 
    C1365.712524,1696.883179 1363.357910,1696.446899 1360.720581,1695.880371 
    C1359.824097,1695.752686 1359.210327,1695.755127 1358.332275,1695.530762 
    C1355.711670,1694.868408 1353.355347,1694.432861 1350.704834,1693.867920 
    C1349.776001,1693.727051 1349.141357,1693.715332 1348.224121,1693.469971 
    C1346.660522,1692.890259 1345.394287,1692.469971 1344.096069,1692.209229 
    C1327.855957,1688.947876 1311.621826,1685.654053 1295.362427,1682.490479 
    C1287.919067,1681.042236 1280.423340,1679.862549 1272.616455,1678.305176 
    C1272.037964,1676.991455 1271.794189,1675.933594 1271.774902,1674.628174 
    C1272.360229,1672.245483 1272.721069,1670.110229 1273.206177,1667.698242 
    C1273.333496,1666.822510 1273.336670,1666.223511 1273.566650,1665.364502 
    C1274.232056,1662.725342 1274.670410,1660.346069 1275.230713,1657.693848 
    C1275.357300,1656.830078 1275.362061,1656.239136 1275.602051,1655.390747 
    C1276.249146,1652.748047 1276.660767,1650.362915 1277.185425,1647.689209 
    C1277.321533,1646.784546 1277.344727,1646.168457 1277.628296,1645.303955 
    C1278.370605,1642.643555 1278.852661,1640.231567 1279.789795,1637.651123 
    C1281.532593,1637.512817 1282.820435,1637.543091 1284.299194,1637.839478 
    C1286.332642,1638.425903 1288.174927,1638.746338 1290.336670,1639.187744 
    C1291.559448,1639.365723 1292.463013,1639.422607 1293.591675,1639.729980 
    C1295.881226,1640.332886 1297.945557,1640.685669 1300.312256,1641.142700 
    C1301.250244,1641.263794 1301.886108,1641.280640 1302.763428,1641.535889 
    C1305.338013,1642.187622 1307.670776,1642.601074 1310.303467,1643.128418 
    C1311.240479,1643.261719 1311.877563,1643.281128 1312.741211,1643.556396 
    C1315.316162,1644.224365 1317.664307,1644.636475 1320.314331,1645.161133 
    C1321.254639,1645.299072 1321.893311,1645.324585 1322.786621,1645.615112 
    C1340.691284,1649.512329 1358.353516,1653.085815 1375.982910,1656.814331 
    C1381.031494,1657.881958 1383.119385,1656.038086 1382.993164,1651.012451 
    C1382.961060,1649.742432 1383.702881,1648.472534 1383.888184,1647.173950 
    C1384.698242,1641.498901 1385.434326,1635.813477 1386.197510,1630.131714 
    C1387.246826,1626.142822 1388.296265,1622.153809 1389.452393,1617.499756 
    C1397.991211,1574.347534 1406.423340,1531.860352 1414.855469,1489.373291 
    C1414.346436,1489.072266 1413.837524,1488.771118 1413.328613,1488.470093 
    C1403.893433,1492.330688 1394.458252,1496.191406 1384.643188,1500.004517 
    C1382.801880,1500.935303 1381.340454,1501.913574 1379.879028,1502.891846 
    C1379.879028,1502.891724 1379.931396,1502.950806 1379.560059,1502.718506 
    C1378.487427,1504.285034 1377.187256,1506.080322 1377.176025,1507.883789 
    C1377.040649,1529.596436 1377.095947,1551.310425 1376.815430,1573.107910 
    C1376.145630,1573.635864 1375.761841,1574.079956 1374.960693,1574.421631 
    C1362.228760,1574.387817 1349.913940,1574.456421 1337.342529,1574.198120 
    C1336.733765,1571.820679 1336.080688,1569.770874 1336.075562,1567.719482 
    C1336.007568,1540.179810 1336.176880,1512.638550 1335.917114,1485.101196 
    C1335.859009,1478.941650 1336.199463,1473.965942 1343.617554,1472.880127 
    C1344.305176,1472.779419 1344.876343,1471.883057 1345.770996,1471.376465 
    C1346.362915,1471.249756 1346.685669,1471.102905 1347.264160,1471.069092 
    C1351.552124,1469.257812 1355.584229,1467.333496 1359.869263,1465.427002 
    C1360.416260,1465.291138 1360.710327,1465.137573 1361.261353,1465.103760 
    C1366.994019,1462.722534 1372.469482,1460.221558 1378.319458,1457.730469 
    C1379.127197,1457.514648 1379.560425,1457.289062 1380.301514,1457.115723 
    C1382.464844,1456.136230 1384.320068,1455.104614 1386.548340,1454.051270 
    C1387.600464,1453.746338 1388.279541,1453.463257 1389.218750,1453.251709 
    C1390.027588,1452.899536 1390.576294,1452.475830 1391.507812,1452.047363 
    C1392.568237,1451.727295 1393.245972,1451.411987 1394.239502,1451.147217 
    C1396.462891,1450.170532 1398.370483,1449.143433 1400.644409,1448.118652 
    C1401.668091,1447.836304 1402.325439,1447.551514 1403.314697,1447.304810 
    C1405.768555,1446.240479 1407.890625,1445.138184 1410.370850,1444.041504 
    C1411.147949,1443.836914 1411.567017,1443.626709 1412.339111,1443.428833 
    C1416.279785,1441.718628 1419.867310,1439.996094 1423.788086,1438.280273 
    C1424.730957,1438.045776 1425.340454,1437.804443 1426.313354,1437.567139 
    C1430.310181,1435.803589 1433.943726,1434.035767 1437.896118,1432.280029 
    C1438.794556,1432.059082 1439.374146,1431.825928 1440.260010,1431.620972 
    C1441.245361,1431.196411 1441.924316,1430.743652 1442.848145,1430.337524 
    C1443.441772,1430.372681 1443.743530,1430.247925 1444.360352,1430.142090 
    C1449.051270,1429.646484 1453.380615,1429.018311 1458.066895,1428.481689 
    C1460.381104,1428.514038 1462.338379,1428.454834 1464.556641,1428.610596 
    C1466.874512,1429.203247 1468.931396,1429.580933 1471.230103,1430.087891 
    C1471.653931,1430.202271 1471.835938,1430.187622 1472.159058,1430.312988 
    C1472.300293,1430.453125 1472.678589,1430.329468 1472.688354,1430.332275 
    C1472.698120,1430.335083 1472.715942,1430.338013 1472.941895,1430.591797 
    C1474.434692,1431.281372 1475.701416,1431.717285 1477.076050,1432.248413 
    C1477.183960,1432.343750 1477.457397,1432.253418 1477.662598,1432.478760 
    C1478.594849,1432.997192 1479.321899,1433.290405 1480.216064,1433.782715 
    C1480.554932,1434.003052 1480.726807,1434.024292 1481.066895,1434.326416 
    C1482.486450,1435.494751 1483.737793,1436.382080 1485.063477,1437.474609 
    C1485.338867,1437.924805 1485.597168,1438.037354 1486.046143,1438.325439 
    C1489.397705,1442.140015 1492.616211,1445.646851 1495.867920,1449.507935 
    C1497.585938,1452.274414 1499.270874,1454.686890 1501.045654,1457.425659 
    C1503.963135,1462.119385 1506.790649,1466.486816 1509.555908,1471.153564 
    C1510.143799,1472.216797 1510.793823,1472.980591 1511.539062,1474.104492 
    C1512.412598,1474.843994 1513.191040,1475.223511 1513.969482,1475.603149 
    C1513.969482,1475.603149 1513.997314,1475.503540 1513.607910,1475.796631 
    C1516.683472,1481.647217 1520.111450,1487.228638 1523.670166,1492.725220 
    C1524.030762,1493.282349 1525.180054,1493.328491 1525.963379,1493.611816 
    C1525.963379,1493.611816 1525.994751,1493.505371 1525.609131,1493.826294 
    C1526.788940,1495.490967 1528.354248,1496.834839 1529.919678,1498.178589 
    C1529.919678,1498.178589 1529.932007,1498.060181 1529.542358,1498.295654 
    C1530.176636,1499.792969 1531.200562,1501.054810 1532.464355,1502.730469 
    C1533.972534,1503.488037 1535.240967,1503.831787 1536.509521,1504.175537 
  z"/>
  <path fill="#040404" opacity="1.000000" stroke="none" 
    d="
  M1472.576050,1339.147461 
    C1484.635620,1332.931763 1497.080566,1334.728882 1509.782837,1338.032959 
    C1510.993164,1339.189331 1511.986572,1339.681030 1513.228027,1340.396973 
    C1514.890747,1341.676392 1516.219971,1342.884766 1517.746948,1343.740112 
    C1519.010498,1344.447510 1520.507202,1344.738403 1521.900635,1345.213989 
    C1521.900635,1345.213989 1521.917480,1345.084229 1521.498047,1345.354492 
    C1522.986694,1348.100830 1524.894775,1350.576782 1526.819824,1353.429810 
    C1532.875732,1364.936157 1535.742798,1376.773071 1530.816650,1388.769531 
    C1527.998779,1395.631714 1522.798218,1401.515625 1518.333496,1407.911621 
    C1517.033203,1408.610718 1516.082153,1409.258057 1515.104370,1409.862427 
    C1506.207886,1415.360718 1496.845337,1418.912231 1486.118774,1416.845459 
    C1482.673950,1416.181641 1479.213745,1415.597900 1475.760498,1414.977539 
    C1475.354248,1414.663940 1474.947876,1414.350464 1474.028076,1413.692139 
    C1472.071167,1412.509644 1470.627930,1411.671875 1469.176025,1410.860840 
    C1469.167358,1410.887329 1469.195801,1410.847412 1469.049927,1410.587646 
    C1467.924072,1409.778442 1466.944214,1409.229126 1465.766602,1408.423950 
    C1465.069092,1407.770142 1464.569580,1407.372070 1463.968140,1406.690918 
    C1463.250488,1405.927246 1462.634644,1405.446533 1462.010010,1404.984131 
    C1462.001343,1405.002441 1462.036133,1404.980225 1461.924072,1404.688721 
    C1461.212280,1403.849731 1460.612427,1403.302368 1459.932495,1402.492065 
    C1459.491821,1401.822876 1459.131470,1401.416504 1458.766357,1400.723877 
    C1458.245483,1399.926758 1457.729126,1399.416016 1457.197754,1398.608887 
    C1456.843750,1397.857056 1456.504761,1397.401611 1456.083496,1396.577637 
    C1454.398193,1392.596313 1452.795410,1388.983643 1451.283936,1385.143188 
    C1451.391357,1384.569214 1451.282471,1384.268066 1451.151001,1383.775269 
    C1451.096191,1382.718628 1450.938721,1381.898926 1450.863525,1380.672363 
    C1450.799561,1379.181519 1450.653442,1378.097412 1450.647461,1376.609863 
    C1450.682007,1374.800293 1450.576538,1373.394287 1450.642334,1371.635254 
    C1450.819092,1370.504761 1450.824463,1369.727295 1450.974121,1368.791748 
    C1451.094971,1368.085083 1451.071411,1367.536499 1451.181763,1366.791016 
    C1451.453003,1366.273560 1451.424683,1365.968262 1451.469482,1365.520386 
    C1451.978760,1364.514038 1452.249390,1363.665649 1452.723633,1362.453491 
    C1452.675781,1361.395630 1452.424316,1360.701416 1452.172852,1360.007324 
    C1452.172852,1360.007324 1452.028931,1360.026855 1452.243164,1360.360352 
    C1452.661987,1360.614380 1452.866821,1360.535034 1453.311279,1360.276367 
    C1453.815186,1359.391968 1454.079468,1358.687012 1454.579590,1357.723999 
    C1454.889771,1357.012573 1454.964355,1356.559082 1455.277344,1355.968994 
    C1455.847290,1355.216064 1456.178955,1354.599854 1456.832031,1353.630859 
    C1457.176636,1352.211914 1457.199829,1351.145752 1457.223145,1350.079590 
    C1457.223022,1350.079590 1457.134277,1350.057861 1457.509521,1350.230225 
    C1457.971802,1349.971558 1458.058838,1349.540527 1458.145752,1349.109497 
    C1458.145752,1349.109497 1458.047974,1349.101196 1458.369629,1349.557129 
    C1459.516479,1348.686279 1460.341919,1347.359497 1461.167236,1346.032593 
    C1461.167236,1346.032593 1461.038940,1346.023071 1461.400391,1346.361572 
    C1461.992310,1346.505127 1462.222778,1346.310303 1462.453369,1346.115601 
    C1462.742554,1346.310791 1462.974976,1346.257324 1463.595947,1345.657349 
    C1464.083740,1344.582520 1464.126221,1343.805542 1464.168701,1343.028564 
    C1464.168701,1343.028564 1464.020264,1343.029175 1464.261353,1343.469116 
    C1465.006226,1343.726440 1465.510010,1343.543823 1466.351318,1343.248413 
    C1468.651245,1341.806274 1470.613647,1340.476929 1472.576050,1339.147461 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M1455.966553,1633.112671 
    C1464.137695,1640.637329 1472.425293,1648.042847 1480.369263,1655.800171 
    C1481.749268,1657.147949 1482.193359,1659.981201 1482.199463,1662.130737 
    C1482.306030,1699.931885 1482.356323,1737.733887 1482.176880,1775.534546 
    C1482.154785,1780.192627 1483.183594,1781.928833 1488.156372,1781.739014 
    C1499.459961,1781.307739 1510.786255,1781.471924 1522.757080,1781.197632 
    C1523.410767,1781.001343 1523.859131,1781.008789 1523.859131,1781.008789 
    C1523.921509,1781.444702 1523.984009,1781.880493 1523.516479,1782.657959 
    C1508.634888,1783.011108 1494.283447,1783.022705 1479.931885,1783.034302 
    C1479.931885,1783.034302 1479.985962,1782.996704 1480.094971,1782.567505 
    C1480.183838,1742.578735 1480.179688,1703.019287 1480.092163,1663.459839 
    C1480.088135,1661.635254 1479.336182,1659.812378 1478.932617,1657.988647 
    C1478.932495,1657.988647 1479.000122,1658.001099 1478.987915,1657.728516 
    C1478.628418,1657.310913 1478.281128,1657.165649 1477.933716,1657.020508 
    C1477.933716,1657.020508 1477.995361,1657.004883 1477.983887,1656.731079 
    C1477.626099,1656.311646 1477.279907,1656.166016 1476.933716,1656.020386 
    C1476.933716,1656.020386 1476.995361,1656.004761 1476.983643,1655.731689 
    C1476.625732,1655.312134 1476.279663,1655.165527 1475.933594,1655.019043 
    C1475.933594,1655.019043 1475.995361,1655.004395 1475.980957,1654.732300 
    C1475.622314,1654.313232 1475.277954,1654.166260 1474.933716,1654.019165 
    C1474.933716,1654.019165 1474.995605,1654.005249 1474.992920,1653.750977 
    C1474.677002,1653.329712 1474.363525,1653.162964 1474.050049,1652.996216 
    C1469.212402,1648.666260 1464.321045,1644.393799 1459.582031,1639.958496 
    C1458.615601,1639.054077 1458.221558,1637.538086 1457.175781,1635.842773 
    C1456.508545,1634.949585 1456.229248,1634.517700 1455.950684,1633.842285 
    C1455.951416,1633.598999 1455.966553,1633.112671 1455.966553,1633.112671 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1385.023071,1500.052002 
    C1394.458252,1496.191406 1403.893433,1492.330688 1413.328613,1488.470093 
    C1413.837524,1488.771118 1414.346436,1489.072266 1414.855469,1489.373291 
    C1406.423340,1531.860352 1397.991211,1574.347534 1389.399414,1617.052002 
    C1389.566406,1614.542480 1389.863281,1611.811523 1390.226196,1609.089355 
    C1391.076416,1602.709839 1391.956177,1596.334351 1392.828369,1589.957886 
    C1393.510742,1584.969116 1394.044678,1579.953369 1394.929688,1575.000610 
    C1395.808960,1570.079956 1396.996948,1565.211792 1398.139771,1560.341797 
    C1398.940063,1556.931519 1400.095581,1553.594116 1400.728027,1550.157227 
    C1401.629761,1545.255737 1402.009888,1540.256348 1402.961304,1535.366455 
    C1403.911987,1530.479248 1405.323853,1525.683105 1406.472412,1520.832397 
    C1407.316772,1517.266479 1408.228027,1513.704102 1408.813477,1510.092163 
    C1409.750244,1504.312988 1410.441528,1498.494019 1411.185181,1493.065674 
    C1402.529175,1495.737061 1394.216797,1498.302368 1385.508301,1500.662842 
    C1385.112183,1500.458130 1385.023071,1500.052002 1385.023071,1500.052002 
  z"/>
  <path fill="#E2E2E2" opacity="1.000000" stroke="none" 
    d="
  M1377.101562,1573.024048 
    C1377.095947,1551.310425 1377.040649,1529.596436 1377.176025,1507.883789 
    C1377.187256,1506.080322 1378.487427,1504.285034 1379.584961,1502.687866 
    C1380.005005,1525.672119 1379.964844,1548.454956 1380.117554,1571.236450 
    C1380.142212,1574.921631 1379.010742,1576.165527 1375.258423,1576.089722 
    C1361.966919,1575.821289 1348.669312,1575.857300 1335.656494,1575.350586 
    C1336.492432,1574.790649 1337.045776,1574.657837 1337.599243,1574.525024 
    C1349.913940,1574.456421 1362.228760,1574.387817 1375.268433,1574.557373 
    C1376.362793,1574.204956 1376.732178,1573.614502 1377.101562,1573.024048 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1272.951416,1678.561035 
    C1280.423340,1679.862549 1287.919067,1681.042236 1295.362427,1682.490479 
    C1311.621826,1685.654053 1327.855957,1688.947876 1344.096069,1692.209229 
    C1345.394287,1692.469971 1346.660522,1692.890259 1347.779297,1693.569946 
    C1344.662476,1693.623047 1341.707764,1693.342407 1338.753052,1693.061890 
    C1331.653198,1693.412964 1325.001709,1691.514893 1318.290527,1689.447510 
    C1313.974243,1688.117798 1309.300415,1687.996460 1304.844116,1687.061523 
    C1299.580811,1685.957397 1294.382812,1684.544800 1289.147095,1683.305054 
    C1288.358398,1683.118408 1287.500244,1683.230957 1286.706909,1683.056519 
    C1283.711304,1682.397827 1280.729126,1681.677856 1277.104248,1680.699463 
    C1275.294922,1679.799194 1274.123169,1679.180054 1272.951416,1678.561035 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1484.652100,1589.574219 
    C1477.168457,1586.243896 1479.669556,1580.075317 1480.711182,1574.648682 
    C1483.699951,1559.079468 1486.969482,1543.563965 1490.210205,1528.044312 
    C1490.592773,1526.212036 1491.483643,1524.485962 1492.446533,1521.877319 
    C1494.114990,1523.837891 1495.141846,1525.044434 1495.887451,1526.625244 
    C1495.401367,1527.010620 1495.196533,1527.021729 1494.991821,1527.032715 
    C1494.316895,1527.226440 1493.113159,1527.308472 1493.045166,1527.630371 
    C1491.660034,1534.191772 1490.494507,1540.799805 1489.094727,1547.357788 
    C1488.016724,1552.407959 1486.544189,1557.374634 1485.492188,1562.429443 
    C1484.529175,1567.056152 1483.912964,1571.754639 1483.107300,1576.415039 
    C1482.754883,1578.454224 1482.311157,1580.477417 1481.729126,1583.415771 
    C1482.322388,1584.040405 1483.696167,1585.486450 1484.971436,1587.774658 
    C1484.799438,1588.935669 1484.725708,1589.254883 1484.652100,1589.574219 
  z"/>
  <path fill="#ADADAD" opacity="1.000000" stroke="none" 
    d="
  M1385.772949,1630.114136 
    C1385.434326,1635.813477 1384.698242,1641.498901 1383.888184,1647.173950 
    C1383.702881,1648.472534 1382.961060,1649.742432 1382.993164,1651.012451 
    C1383.119385,1656.038086 1381.031494,1657.881958 1375.982910,1656.814331 
    C1358.353516,1653.085815 1340.691284,1649.512329 1323.218384,1645.485596 
    C1326.020386,1645.385864 1328.645386,1645.680542 1331.270508,1645.975342 
    C1345.464844,1648.662720 1359.665771,1651.316650 1373.850342,1654.053955 
    C1379.295410,1655.104736 1381.532837,1652.919556 1382.091797,1647.338135 
    C1382.672485,1641.540283 1384.222534,1635.839722 1385.772949,1630.114136 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M1331.174438,1645.547363 
    C1328.645386,1645.680542 1326.020386,1645.385864 1322.963623,1645.220703 
    C1321.893311,1645.324585 1321.254639,1645.299072 1320.067139,1644.873047 
    C1317.183594,1644.081787 1314.849121,1643.691284 1312.514648,1643.300659 
    C1311.877563,1643.281128 1311.240479,1643.261719 1310.058838,1642.839355 
    C1307.183350,1642.056763 1304.852661,1641.677246 1302.521851,1641.297607 
    C1301.886108,1641.280640 1301.250244,1641.263794 1300.060059,1640.856689 
    C1297.459351,1640.137451 1295.412964,1639.808472 1293.366577,1639.479614 
    C1292.463013,1639.422607 1291.559448,1639.365723 1290.141968,1638.914307 
    C1287.788086,1638.204468 1285.948120,1637.889038 1284.108154,1637.573486 
    C1282.820435,1637.543091 1281.532593,1637.512817 1279.489990,1637.826172 
    C1278.279419,1640.630737 1277.823730,1643.091553 1277.367920,1645.552490 
    C1277.344727,1646.168457 1277.321533,1646.784546 1276.899536,1647.946533 
    C1276.122803,1650.877686 1275.744873,1653.263062 1275.366821,1655.648315 
    C1275.362061,1656.239136 1275.357300,1656.830078 1274.931641,1657.939453 
    C1274.120483,1660.846680 1273.730103,1663.235596 1273.339722,1665.624390 
    C1273.336670,1666.223511 1273.333496,1666.822510 1272.928955,1667.908936 
    C1272.201660,1670.556030 1271.876099,1672.715942 1271.550537,1674.875732 
    C1271.794189,1675.933594 1272.037964,1676.991455 1272.616455,1678.305176 
    C1274.123169,1679.180054 1275.294922,1679.799194 1276.689453,1680.627197 
    C1269.407959,1681.332275 1268.952148,1681.125122 1269.993896,1673.709473 
    C1270.882568,1667.384644 1272.680054,1661.192871 1273.826050,1654.896851 
    C1274.717773,1649.998169 1275.036133,1644.992554 1275.989258,1640.108643 
    C1276.421143,1637.895752 1277.774414,1635.862549 1278.400391,1634.447144 
    C1282.212891,1635.043823 1285.018066,1635.330078 1287.749512,1635.944092 
    C1292.606445,1637.036133 1297.406372,1638.378784 1302.253418,1639.517700 
    C1306.052490,1640.410278 1309.860474,1641.320068 1313.711426,1641.922485 
    C1319.188232,1642.779175 1324.710205,1643.345215 1330.203857,1644.100586 
    C1330.535767,1644.146362 1330.788696,1644.766602 1331.174438,1645.547363 
  z"/>
  <path fill="#A4A4A4" opacity="1.000000" stroke="none" 
    d="
  M1523.906372,1780.541748 
    C1523.859131,1781.008789 1523.410767,1781.001343 1523.186646,1780.993408 
    C1522.940796,1729.636353 1522.918945,1678.287354 1523.140625,1626.411499 
    C1523.384277,1625.884644 1523.798340,1625.876465 1523.798340,1625.876465 
    C1523.861328,1638.349243 1523.973755,1650.822144 1523.978149,1663.294922 
    C1523.991943,1702.221436 1523.964844,1741.148071 1523.906372,1780.541748 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1518.670410,1407.839966 
    C1522.798218,1401.515625 1527.998779,1395.631714 1530.816650,1388.769531 
    C1535.742798,1376.773071 1532.875732,1364.936157 1527.076904,1353.392822 
    C1527.489868,1352.974854 1527.662964,1352.970703 1527.836182,1352.966675 
    C1529.888794,1357.058472 1532.406250,1360.987671 1533.904907,1365.273315 
    C1538.017822,1377.036011 1534.638550,1388.186523 1529.600098,1398.736938 
    C1527.854858,1402.391724 1523.911133,1404.996704 1520.218384,1408.026611 
    C1519.200195,1407.927979 1518.935303,1407.883911 1518.670410,1407.839966 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M1514.079224,1542.967896 
    C1525.321167,1549.222534 1536.432495,1555.730591 1547.862427,1561.620728 
    C1553.259277,1564.401978 1559.266846,1565.998535 1564.821045,1568.519287 
    C1561.060059,1567.949463 1557.475708,1566.992310 1553.891357,1566.035156 
    C1553.891357,1566.035156 1553.976074,1565.991821 1553.751709,1565.758911 
    C1551.566895,1565.026611 1549.606323,1564.527100 1547.645874,1564.027710 
    C1547.645874,1564.027710 1547.352417,1564.073486 1547.071289,1563.696533 
    C1545.767700,1562.888184 1544.745117,1562.456909 1543.722656,1562.025635 
    C1539.794556,1560.454102 1535.557617,1559.385376 1532.004517,1557.203369 
    C1525.216309,1553.035034 1518.817749,1548.232178 1512.510010,1543.358398 
    C1513.201416,1543.005249 1513.640381,1542.986572 1514.079224,1542.967896 
  z"/>
  <path fill="#D5D5D5" opacity="1.000000" stroke="none" 
    d="
  M1553.925293,1566.441162 
    C1557.475708,1566.992310 1561.060059,1567.949463 1565.044800,1568.789673 
    C1565.795166,1568.675903 1566.145264,1568.678955 1566.981201,1569.083496 
    C1569.770264,1569.915405 1572.073486,1570.345825 1574.376709,1570.776245 
    C1574.741455,1570.763794 1575.106323,1570.751221 1575.980469,1571.127319 
    C1579.166870,1571.900391 1581.843872,1572.285034 1584.520752,1572.669678 
    C1585.455200,1572.701294 1586.389771,1572.733032 1587.791748,1573.095825 
    C1588.826660,1573.343750 1589.394165,1573.260620 1589.961670,1573.177490 
    C1591.653687,1573.210449 1593.345825,1573.243408 1595.598755,1573.734497 
    C1598.435303,1574.438110 1600.707397,1574.726685 1602.987671,1574.918213 
    C1605.899658,1575.163208 1607.250977,1573.829590 1607.237915,1570.847900 
    C1607.186279,1559.057129 1607.282227,1547.265137 1607.106812,1535.476685 
    C1607.090454,1534.371704 1605.554077,1533.289307 1604.723389,1532.196289 
    C1603.729980,1532.213745 1602.736572,1532.231079 1601.422607,1531.948242 
    C1601.102295,1531.647949 1601.097778,1531.173950 1601.097778,1531.173950 
    C1603.230347,1531.173950 1605.362915,1531.173950 1607.743896,1531.173950 
    C1607.743896,1546.001465 1607.743896,1560.716675 1607.743896,1576.083374 
    C1601.522461,1576.083374 1595.169922,1576.808960 1589.054321,1575.915039 
    C1579.642456,1574.539429 1570.367310,1572.160767 1561.091553,1569.965454 
    C1558.607422,1569.377563 1556.331055,1567.910522 1553.925293,1566.441162 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1518.333496,1407.911621 
    C1518.935303,1407.883911 1519.200195,1407.927979 1519.864258,1408.029785 
    C1517.229126,1410.739136 1514.603760,1414.339966 1511.080811,1415.857544 
    C1501.967285,1419.783813 1492.062744,1419.332031 1482.368042,1418.907715 
    C1480.214844,1418.813477 1478.152100,1416.651855 1475.904053,1415.209717 
    C1479.213745,1415.597900 1482.673950,1416.181641 1486.118774,1416.845459 
    C1496.845337,1418.912231 1506.207886,1415.360718 1515.104370,1409.862427 
    C1516.082153,1409.258057 1517.033203,1408.610718 1518.333496,1407.911621 
  z"/>
  <path fill="#F6F6F6" opacity="1.000000" stroke="none" 
    d="
  M1478.956787,1658.458374 
    C1479.336182,1659.812378 1480.088135,1661.635254 1480.092163,1663.459839 
    C1480.179688,1703.019287 1480.183838,1742.578735 1480.084473,1782.598633 
    C1479.640137,1781.384277 1479.034424,1779.709839 1479.032104,1778.034668 
    C1478.975708,1738.332520 1478.984253,1698.630249 1478.956787,1658.458374 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1337.342529,1574.198120 
    C1337.045776,1574.657837 1336.492432,1574.790649 1335.507202,1574.939819 
    C1335.064087,1541.951172 1335.052734,1508.946045 1335.427734,1475.416260 
    C1339.043091,1473.713013 1342.272339,1472.534546 1345.501709,1471.356201 
    C1344.876343,1471.883057 1344.305176,1472.779419 1343.617554,1472.880127 
    C1336.199463,1473.965942 1335.859009,1478.941650 1335.917114,1485.101196 
    C1336.176880,1512.638550 1336.007568,1540.179810 1336.075562,1567.719482 
    C1336.080688,1569.770874 1336.733765,1571.820679 1337.342529,1574.198120 
  z"/>
  <path fill="#CACACA" opacity="1.000000" stroke="none" 
    d="
  M1338.945068,1693.427979 
    C1341.707764,1693.342407 1344.662476,1693.623047 1348.062012,1693.803589 
    C1349.141357,1693.715332 1349.776001,1693.727051 1350.955811,1694.152466 
    C1353.866333,1694.963379 1356.231567,1695.360474 1358.596680,1695.757568 
    C1359.210327,1695.755127 1359.824097,1695.752686 1360.960815,1696.178467 
    C1363.861450,1696.987549 1366.238892,1697.368286 1368.616455,1697.749023 
    C1369.219604,1697.739624 1369.822632,1697.730347 1370.959961,1698.129150 
    C1373.887329,1698.922607 1376.280518,1699.307617 1378.673828,1699.692627 
    C1379.260864,1699.677979 1379.848022,1699.663330 1380.948486,1700.078491 
    C1383.862549,1700.906982 1386.263306,1701.305664 1388.664062,1701.704346 
    C1389.255493,1701.689697 1389.846802,1701.674927 1390.955688,1702.091797 
    C1393.575684,1702.847900 1395.678223,1703.172485 1397.780762,1703.497192 
    C1398.635498,1703.512573 1399.490356,1703.527954 1400.882812,1703.987793 
    C1403.539307,1704.791504 1405.658325,1705.150757 1407.777222,1705.510010 
    C1408.636230,1705.527344 1409.495117,1705.544678 1410.812012,1705.962158 
    C1412.151733,1706.846924 1413.033691,1707.331421 1413.915649,1707.815918 
    C1408.626587,1707.104736 1403.317871,1706.512207 1398.055176,1705.641602 
    C1394.396729,1705.036255 1390.825684,1703.910400 1387.171753,1703.266113 
    C1382.378296,1702.420898 1377.498413,1702.031982 1372.735962,1701.055664 
    C1367.924927,1700.069702 1363.251099,1698.420044 1358.444580,1697.404663 
    C1353.733154,1696.409180 1348.922974,1695.889038 1344.171387,1695.071533 
    C1342.470337,1694.778931 1340.813965,1694.227295 1338.945068,1693.427979 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1430.472412,1650.837280 
    C1430.514404,1647.970825 1430.697266,1644.896851 1431.340088,1641.922241 
    C1433.179443,1633.409668 1435.205444,1624.937500 1437.465332,1615.113159 
    C1440.907715,1618.428833 1443.430054,1620.858276 1445.626465,1623.674072 
    C1445.008911,1624.057617 1444.717163,1624.054688 1444.425293,1624.051636 
    C1442.609863,1622.758179 1440.794556,1621.464722 1438.400146,1619.758789 
    C1436.934448,1627.255737 1435.676758,1634.459473 1434.063599,1641.582764 
    C1433.358154,1644.698364 1431.925903,1647.649414 1430.472412,1650.837280 
  z"/>
  <path fill="#F6F6F6" opacity="1.000000" stroke="none" 
    d="
  M1479.980957,1783.466431 
    C1494.283447,1783.022705 1508.634888,1783.011108 1523.449341,1782.982422 
    C1523.283569,1783.641968 1522.659668,1784.903687 1522.025513,1784.908813 
    C1508.482666,1785.017700 1494.938843,1784.996460 1481.395386,1784.935791 
    C1480.938721,1784.933838 1480.485107,1784.259521 1479.980957,1783.466431 
  z"/>
  <path fill="#CACACA" opacity="1.000000" stroke="none" 
    d="
  M1421.707031,1686.341187 
    C1421.706543,1685.742554 1421.706055,1685.143921 1422.150635,1684.039917 
    C1422.905151,1681.767090 1423.214600,1679.999512 1423.524048,1678.232056 
    C1423.563599,1677.356079 1423.603271,1676.480225 1424.110107,1675.082031 
    C1424.912720,1672.793457 1425.248413,1671.027222 1425.584106,1669.260986 
    C1425.574463,1668.694336 1425.564819,1668.127563 1425.950439,1667.173218 
    C1426.849731,1666.206299 1427.353760,1665.627075 1427.857910,1665.047852 
    C1426.998413,1669.319824 1426.135864,1673.591064 1425.280396,1677.863770 
    C1424.553101,1681.496094 1423.768433,1685.118652 1423.128296,1688.766479 
    C1422.382812,1693.014404 1421.911865,1697.315308 1421.034180,1701.533447 
    C1420.586914,1703.683594 1419.510376,1705.702759 1418.320312,1707.410645 
    C1417.807251,1706.108887 1417.692139,1705.177856 1417.577148,1704.246704 
    C1417.584229,1703.684937 1417.591309,1703.123291 1418.027100,1702.062012 
    C1418.856323,1699.476074 1419.256836,1697.389648 1419.657349,1695.303345 
    C1419.653442,1694.719238 1419.649536,1694.135254 1420.093384,1693.056396 
    C1420.929810,1690.488037 1421.318481,1688.414673 1421.707031,1686.341187 
  z"/>
  <path fill="#9C9C9C" opacity="1.000000" stroke="none" 
    d="
  M1600.665039,1531.083618 
    C1601.097778,1531.173950 1601.102295,1531.647949 1601.055664,1531.880249 
    C1592.206665,1530.831299 1583.404053,1529.550049 1574.466553,1527.831543 
    C1574.644043,1527.259644 1574.956543,1527.125000 1575.269165,1526.990479 
    C1583.590210,1528.324707 1591.911255,1529.658936 1600.665039,1531.083618 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M1537.116455,1506.955811 
    C1536.650879,1506.228271 1536.185181,1505.500610 1536.028931,1504.418579 
    C1541.266602,1507.360596 1546.217285,1510.624146 1551.112549,1513.968994 
    C1553.149048,1515.360474 1555.067261,1516.925293 1556.988159,1518.799072 
    C1555.824097,1518.995483 1554.711182,1518.803955 1553.150391,1518.055664 
    C1551.702881,1517.067505 1550.703247,1516.635986 1549.703613,1516.204468 
    C1548.002808,1515.115356 1546.302002,1514.026123 1544.293945,1512.413086 
    C1543.375610,1511.573730 1542.764648,1511.258301 1542.153687,1510.942871 
    C1541.523438,1510.509521 1540.893188,1510.076050 1540.029419,1509.083984 
    C1538.902832,1508.001953 1538.009644,1507.478882 1537.116455,1506.955811 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1377.944946,1457.720703 
    C1372.469482,1460.221558 1366.994019,1462.722534 1361.315430,1464.852173 
    C1361.381226,1464.043945 1361.650024,1463.607056 1361.918823,1463.170166 
    C1366.687744,1460.369141 1371.156738,1456.828613 1377.572144,1457.173584 
    C1378.012695,1457.345581 1377.944946,1457.720581 1377.944946,1457.720703 
  z"/>
  <path fill="#CACACA" opacity="1.000000" stroke="none" 
    d="
  M1509.618286,1470.854126 
    C1506.790649,1466.486816 1503.963135,1462.119385 1501.081909,1457.052979 
    C1501.050293,1455.854858 1501.072266,1455.355713 1501.094238,1454.856689 
    C1506.410645,1458.884033 1508.952393,1464.868408 1511.743652,1470.841064 
    C1510.808228,1471.114990 1510.213257,1470.984619 1509.618286,1470.854126 
  z"/>
  <path fill="#A4A4A4" opacity="1.000000" stroke="none" 
    d="
  M1513.955811,1542.661133 
    C1513.640381,1542.986572 1513.201416,1543.005249 1512.433838,1543.024414 
    C1509.716064,1541.383545 1507.326782,1539.742310 1504.865479,1537.414307 
    C1504.177734,1536.498535 1503.562012,1536.269653 1502.946411,1536.040771 
    C1502.946411,1536.040771 1503.007446,1536.016724 1503.055298,1535.710449 
    C1502.360474,1534.096191 1501.617798,1532.788086 1500.875122,1531.480103 
    C1505.194214,1535.104858 1509.513428,1538.729736 1513.955811,1542.661133 
  z"/>
  <path fill="#CACACA" opacity="1.000000" stroke="none" 
    d="
  M1526.001465,1493.181641 
    C1525.180054,1493.328491 1524.030762,1493.282349 1523.670166,1492.725220 
    C1520.111450,1487.228638 1516.683472,1481.647217 1513.557861,1475.783936 
    C1516.546997,1478.780396 1519.328369,1481.988281 1521.800171,1485.419067 
    C1523.442261,1487.698120 1524.641968,1490.296143 1526.001465,1493.181641 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M1450.830078,1368.949829 
    C1450.824463,1369.727295 1450.819092,1370.504761 1450.343262,1371.750244 
    C1450.084473,1373.816772 1450.295898,1375.415039 1450.507324,1377.013428 
    C1450.653442,1378.097412 1450.799561,1379.181519 1450.647705,1380.894043 
    C1450.246826,1382.334961 1450.144043,1383.147583 1449.994019,1384.005127 
    C1449.946777,1384.050293 1449.851685,1384.140015 1449.851685,1384.140015 
    C1449.198608,1383.290405 1447.959961,1382.420654 1447.988525,1381.594727 
    C1448.157715,1376.705566 1448.620972,1371.826538 1449.466797,1366.947510 
    C1449.948486,1366.951050 1450.042847,1367.040771 1450.051270,1367.313599 
    C1450.316406,1368.040894 1450.573242,1368.495361 1450.830078,1368.949829 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1495.834717,1449.153809 
    C1492.616211,1445.646851 1489.397705,1442.140015 1486.430908,1438.308105 
    C1487.451660,1438.012817 1488.220459,1438.042603 1488.989380,1438.072266 
    C1488.989380,1438.072388 1489.082275,1438.377319 1489.144531,1438.852783 
    C1489.843750,1439.874634 1490.480591,1440.421143 1491.117432,1440.967529 
    C1491.117432,1440.967529 1491.027344,1440.969971 1491.121948,1441.224121 
    C1491.849976,1441.972900 1492.483276,1442.467407 1493.116699,1442.962036 
    C1493.116699,1442.962036 1493.035400,1442.985840 1493.165405,1443.223999 
    C1493.862183,1443.667480 1494.428955,1443.872803 1494.995728,1444.078125 
    C1494.995728,1444.078125 1495.095215,1444.358032 1495.053711,1444.872314 
    C1495.411499,1446.520752 1495.810669,1447.654907 1496.116455,1448.880737 
    C1496.023193,1448.972412 1495.834717,1449.153809 1495.834717,1449.153809 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1427.908936,1664.638550 
    C1427.353760,1665.627075 1426.849731,1666.206299 1426.088013,1666.919678 
    C1426.894409,1662.758423 1427.958374,1658.463013 1429.324219,1654.210205 
    C1429.070801,1657.578491 1428.515381,1660.903809 1427.908936,1664.638550 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M1484.763916,1589.814453 
    C1484.725708,1589.254883 1484.799438,1588.935669 1484.953369,1588.130859 
    C1489.056763,1591.175415 1493.080078,1594.705444 1496.708008,1598.729004 
    C1495.972046,1599.327026 1495.631470,1599.431519 1495.291016,1599.536011 
    C1495.291016,1599.536011 1495.045776,1599.469971 1494.932373,1599.010132 
    C1491.935791,1596.019287 1489.052490,1593.488159 1486.169189,1590.957031 
    C1485.738037,1590.656250 1485.306885,1590.355469 1484.763916,1589.814453 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M1345.770996,1471.376343 
    C1342.272339,1472.534546 1339.043091,1473.713013 1335.458252,1474.948975 
    C1337.425049,1473.332764 1339.609863,1471.403931 1342.108643,1470.057373 
    C1344.608032,1468.710693 1347.421387,1467.946167 1350.530640,1466.943848 
    C1350.964233,1466.961426 1351.081665,1467.088623 1351.046387,1467.418701 
    C1349.676880,1468.817871 1348.342529,1469.886963 1347.008301,1470.955933 
    C1346.685669,1471.102905 1346.362915,1471.249756 1345.770996,1471.376343 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M1500.680664,1531.207764 
    C1501.617798,1532.788086 1502.360474,1534.096191 1503.029785,1535.731934 
    C1500.294678,1533.298096 1497.632812,1530.536377 1494.981323,1527.403809 
    C1495.196533,1527.021729 1495.401367,1527.010620 1495.911011,1526.958984 
    C1497.639404,1528.257568 1499.062744,1529.596558 1500.680664,1531.207764 
  z"/>
  <path fill="#C3C3C3" opacity="1.000000" stroke="none" 
    d="
  M1388.958740,1453.180298 
    C1388.279541,1453.463257 1387.600464,1453.746338 1386.177490,1454.047363 
    C1384.244141,1454.364990 1383.054810,1454.664673 1381.865356,1454.964355 
    C1383.373291,1453.708740 1384.724976,1452.147827 1386.429077,1451.274902 
    C1388.536743,1450.195312 1390.936768,1449.686646 1393.618896,1449.247681 
    C1393.992798,1450.075073 1393.958252,1450.585938 1393.923584,1451.096802 
    C1393.245972,1451.411987 1392.568237,1451.727295 1391.237549,1452.025513 
    C1390.042480,1452.399048 1389.500610,1452.789673 1388.958740,1453.180298 
  z"/>
  <path fill="#E2E2E2" opacity="1.000000" stroke="none" 
    d="
  M1444.493164,1624.433838 
    C1444.717163,1624.054688 1445.008911,1624.057617 1445.733521,1623.996094 
    C1447.943970,1625.586670 1449.721558,1627.241699 1451.754150,1629.491821 
    C1452.676270,1631.387451 1453.343506,1632.688110 1453.973511,1634.024658 
    C1453.936279,1634.060547 1453.860352,1634.130859 1453.860352,1634.130859 
    C1450.760620,1631.026001 1447.660767,1627.921021 1444.493164,1624.433838 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M1472.017822,1430.172974 
    C1471.835938,1430.187622 1471.653931,1430.202271 1471.037598,1429.744385 
    C1468.500854,1428.979614 1466.398193,1428.687622 1464.295654,1428.395630 
    C1462.338379,1428.454834 1460.381104,1428.514038 1457.591553,1428.356201 
    C1454.836304,1428.108032 1452.913208,1428.076782 1450.990967,1427.789795 
    C1450.993164,1427.363403 1450.994507,1427.192749 1450.995728,1427.022217 
    C1457.377319,1426.978271 1463.759155,1426.888550 1470.140015,1426.938965 
    C1471.111206,1426.946533 1472.077271,1427.603027 1473.049438,1428.452637 
    C1473.053101,1428.945923 1472.947021,1429.071167 1472.742310,1429.210449 
    C1472.255127,1429.554932 1472.081909,1429.829468 1472.017822,1430.172974 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M1521.965088,1344.830811 
    C1520.507202,1344.738403 1519.010498,1344.447510 1517.746948,1343.740112 
    C1516.219971,1342.884766 1514.890747,1341.676392 1513.161133,1340.118896 
    C1512.572754,1339.116455 1512.298828,1338.616089 1512.025024,1338.115845 
    C1516.446411,1338.509644 1519.768677,1340.639893 1521.965088,1344.830811 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M1519.980957,1620.804443 
    C1515.140381,1620.804810 1513.286377,1616.967651 1511.406982,1613.343262 
    C1514.526489,1615.534790 1517.273926,1617.979858 1519.980957,1620.804443 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M1443.998535,1430.009766 
    C1443.743530,1430.247925 1443.441772,1430.372681 1442.508789,1430.261841 
    C1441.267578,1430.623901 1440.610718,1431.108398 1439.953735,1431.592773 
    C1439.374146,1431.825928 1438.794556,1432.059082 1437.490112,1432.220215 
    C1434.232056,1432.826538 1431.698975,1433.504883 1429.077148,1434.084961 
    C1428.988403,1433.986572 1428.812866,1433.788330 1428.812866,1433.788330 
    C1433.272217,1431.898560 1437.731567,1430.008911 1442.667969,1428.187744 
    C1443.449463,1428.512939 1443.753784,1428.769531 1444.026245,1429.270996 
    C1443.994385,1429.515869 1443.998535,1430.009766 1443.998535,1430.009766 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M1464.069946,1406.974121 
    C1464.569580,1407.372070 1465.069092,1407.770142 1465.774170,1408.639404 
    C1466.001343,1409.397583 1466.021240,1409.684448 1465.992188,1410.012817 
    C1465.945068,1410.054321 1465.851929,1410.138428 1465.851929,1410.138428 
    C1463.200073,1407.994751 1460.528320,1405.874878 1457.910034,1403.690918 
    C1457.236328,1403.128906 1456.731934,1402.363892 1456.423096,1401.332886 
    C1457.388062,1400.985840 1458.079468,1400.997925 1458.770996,1401.010132 
    C1459.131470,1401.416504 1459.491821,1401.822876 1459.962524,1402.837646 
    C1460.727173,1403.957520 1461.381714,1404.468872 1462.036133,1404.980225 
    C1462.036133,1404.980225 1462.001343,1405.002441 1462.048828,1405.310913 
    C1462.754150,1406.070923 1463.411987,1406.522583 1464.069946,1406.974121 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M1488.926270,1437.708252 
    C1488.220459,1438.042603 1487.451660,1438.012817 1486.297974,1438.000488 
    C1485.597168,1438.037354 1485.338867,1437.924805 1484.972900,1437.131104 
    C1483.504761,1435.736694 1482.201660,1434.890991 1480.898682,1434.045410 
    C1480.726807,1434.024292 1480.554932,1434.003052 1480.121338,1433.459229 
    C1479.058838,1432.708984 1478.258179,1432.481201 1477.457397,1432.253418 
    C1477.457397,1432.253418 1477.183960,1432.343750 1477.090576,1431.886719 
    C1477.025269,1431.190063 1477.053345,1430.950317 1477.081421,1430.710693 
    C1482.672852,1429.965942 1485.225952,1434.617798 1488.926270,1437.708252 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1423.454834,1438.273682 
    C1419.867310,1439.996094 1416.279785,1441.718628 1412.428345,1443.148682 
    C1413.104248,1442.211426 1414.044067,1441.566406 1414.983887,1440.921387 
    C1415.043945,1440.579956 1415.216553,1440.310547 1415.895020,1440.203125 
    C1417.182007,1439.825928 1418.075317,1439.359009 1418.968628,1438.892090 
    C1418.968628,1438.892090 1418.935913,1438.972046 1419.294189,1438.950317 
    C1420.920044,1438.710205 1422.187378,1438.491943 1423.454834,1438.273682 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M1527.918945,1352.578491 
    C1527.662964,1352.970703 1527.489868,1352.974854 1527.059814,1353.015869 
    C1524.894775,1350.576782 1522.986694,1348.100830 1521.433105,1345.361328 
    C1525.224121,1346.265747 1527.768677,1348.215454 1527.918945,1352.578491 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M1423.788086,1438.280396 
    C1422.187378,1438.491943 1420.920044,1438.710205 1419.256958,1438.928467 
    C1421.921997,1437.250244 1424.982666,1435.572266 1428.428101,1433.841309 
    C1428.812866,1433.788330 1428.988403,1433.986572 1428.988525,1434.379883 
    C1427.975830,1435.703125 1426.962891,1436.633179 1425.949951,1437.563110 
    C1425.340454,1437.804443 1424.730957,1438.045776 1423.788086,1438.280396 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1501.065186,1454.892334 
    C1501.072266,1455.355713 1501.050293,1455.854858 1500.992065,1456.726562 
    C1499.270874,1454.686890 1497.585938,1452.274414 1495.867920,1449.507935 
    C1495.834717,1449.153809 1496.023193,1448.972412 1496.375732,1448.942627 
    C1496.905884,1448.924316 1497.083618,1448.935913 1497.261353,1448.947632 
    C1497.261353,1448.947632 1497.614014,1448.922363 1497.870117,1449.219604 
    C1498.418091,1449.697754 1498.709961,1449.878662 1499.001831,1450.059570 
    C1499.001831,1450.059570 1499.101440,1450.343506 1499.057617,1450.859985 
    C1499.710205,1452.581299 1500.406616,1453.786133 1501.103027,1454.990967 
    C1501.103027,1454.990967 1501.036011,1454.927979 1501.065186,1454.892334 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1417.267944,1704.522949 
    C1417.692139,1705.177856 1417.807251,1706.108887 1417.937378,1707.509277 
    C1416.874268,1707.968262 1415.796021,1707.958130 1414.316650,1707.881958 
    C1413.033691,1707.331421 1412.151733,1706.846924 1411.107910,1706.099731 
    C1412.950195,1705.490967 1414.954468,1705.145020 1417.267944,1704.522949 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M1456.848145,1350.083374 
    C1457.199829,1351.145752 1457.176636,1352.211914 1456.553223,1353.711060 
    C1455.648438,1354.797852 1455.343750,1355.451782 1455.039062,1356.105591 
    C1454.964355,1356.559082 1454.889771,1357.012573 1454.298584,1357.844116 
    C1453.545166,1358.966675 1453.308472,1359.711182 1453.071777,1360.455566 
    C1452.866821,1360.535034 1452.661987,1360.614380 1452.257812,1360.431396 
    C1453.530029,1356.808472 1455.001587,1353.447754 1456.848145,1350.083374 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M1361.525391,1463.095215 
    C1361.650024,1463.607056 1361.381226,1464.043945 1361.058350,1464.732422 
    C1360.710327,1465.137573 1360.416260,1465.291138 1359.469727,1465.321045 
    C1356.238647,1465.827759 1353.660156,1466.458130 1351.081665,1467.088623 
    C1351.081665,1467.088623 1350.964233,1466.961426 1350.905396,1466.897705 
    C1354.275024,1465.562866 1357.703613,1464.291626 1361.525391,1463.095215 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M1451.048462,1384.012207 
    C1451.282471,1384.268066 1451.391357,1384.569214 1451.231812,1385.569336 
    C1452.070923,1389.473022 1453.053345,1392.722656 1453.987061,1396.015625 
    C1453.938354,1396.058960 1453.841553,1396.146240 1453.841553,1396.146240 
    C1449.486816,1393.498535 1449.829712,1389.211914 1449.902588,1384.570923 
    C1449.851685,1384.140015 1449.946777,1384.050293 1450.245483,1384.022705 
    C1450.712158,1384.000610 1450.880249,1384.006348 1451.048462,1384.012207 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1410.012695,1444.035889 
    C1407.890625,1445.138184 1405.768555,1446.240479 1403.356689,1447.064453 
    C1403.378418,1446.215576 1403.689819,1445.645142 1404.001221,1445.074829 
    C1404.001221,1445.074829 1404.372925,1444.964478 1404.906982,1444.959473 
    C1406.300293,1444.317627 1407.159546,1443.680908 1408.018799,1443.044189 
    C1408.018799,1443.044189 1408.365723,1442.936890 1408.809082,1443.053467 
    C1409.505737,1443.458618 1409.759277,1443.747192 1410.012695,1444.035889 
  z"/>
  <path fill="#C3C3C3" opacity="1.000000" stroke="none" 
    d="
  M1403.598755,1445.010620 
    C1403.689819,1445.645142 1403.378418,1446.215576 1403.024902,1447.026367 
    C1402.325439,1447.551514 1401.668091,1447.836304 1400.239990,1448.105591 
    C1397.892456,1448.365112 1396.315674,1448.640015 1394.738770,1448.914795 
    C1397.557983,1447.592041 1400.377197,1446.269287 1403.598755,1445.010620 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1505.795898,1609.470825 
    C1503.938477,1607.851440 1502.080933,1606.232178 1500.483154,1604.298828 
    C1501.608398,1604.316284 1502.474243,1604.647827 1503.339966,1604.979370 
    C1503.339966,1604.979370 1503.649536,1604.918579 1503.870361,1605.240234 
    C1504.415039,1605.692871 1504.739014,1605.823975 1505.062988,1605.955078 
    C1505.062988,1605.955078 1505.003906,1606.000000 1505.048218,1606.251465 
    C1505.417236,1606.655396 1505.741821,1606.807861 1506.066528,1606.960449 
    C1506.066528,1606.960449 1505.994263,1606.974121 1505.950928,1607.374023 
    C1505.870361,1608.339478 1505.833130,1608.905151 1505.795898,1609.470825 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1472.308960,1339.364380 
    C1470.613647,1340.476929 1468.651245,1341.806274 1466.342041,1342.921997 
    C1465.994873,1342.490967 1465.994385,1342.273682 1465.993896,1342.056274 
    C1468.009888,1341.231201 1470.025879,1340.406250 1472.308960,1339.364380 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1394.556396,1448.929932 
    C1396.315674,1448.640015 1397.892456,1448.365112 1399.873779,1448.103271 
    C1398.370483,1449.143433 1396.462891,1450.170532 1394.239502,1451.147217 
    C1393.958252,1450.585938 1393.992798,1450.075073 1394.025635,1449.308105 
    C1394.023804,1449.052124 1394.374023,1448.945068 1394.556396,1448.929932 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1469.184692,1410.834229 
    C1470.627930,1411.671875 1472.071167,1412.509644 1473.300049,1413.441895 
    C1471.918213,1413.395752 1470.750732,1413.255371 1469.306030,1412.650391 
    C1469.080688,1411.735352 1469.132690,1411.284790 1469.184692,1410.834229 
  z"/>
  <path fill="#989898" opacity="1.000000" stroke="none" 
    d="
  M1384.643188,1500.004517 
    C1385.023071,1500.052002 1385.112183,1500.458130 1385.109619,1500.665527 
    C1383.614380,1501.583252 1382.121704,1502.293579 1380.254028,1502.947998 
    C1381.340454,1501.913574 1382.801880,1500.935303 1384.643188,1500.004517 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1381.636719,1454.997803 
    C1383.054810,1454.664673 1384.244141,1454.364990 1385.804443,1454.069214 
    C1384.320068,1455.104614 1382.464844,1456.136230 1380.343750,1456.903076 
    C1380.372314,1456.140747 1380.666382,1455.643188 1380.960571,1455.145630 
    C1380.960571,1455.145630 1381.408203,1455.031250 1381.636719,1454.997803 
  z"/>
  <path fill="#CACACA" opacity="1.000000" stroke="none" 
    d="
  M1444.058105,1429.026123 
    C1443.753784,1428.769531 1443.449463,1428.512939 1443.008545,1427.987061 
    C1445.295654,1427.449219 1447.719482,1427.180664 1450.569458,1426.967285 
    C1450.994507,1427.192749 1450.993164,1427.363403 1450.597534,1427.807495 
    C1448.154907,1428.395996 1446.106567,1428.711060 1444.058105,1429.026123 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M1523.875244,1625.501709 
    C1523.798340,1625.876465 1523.384277,1625.884644 1523.186157,1625.945068 
    C1521.712524,1624.527344 1520.437012,1623.049316 1519.488770,1621.315796 
    C1521.194824,1622.415771 1522.573364,1623.771362 1523.875244,1625.501709 
  z"/>
  <path fill="#CFCFCF" opacity="1.000000" stroke="none" 
    d="
  M1575.178955,1526.581177 
    C1574.956543,1527.125000 1574.644043,1527.259644 1574.186279,1527.604980 
    C1573.603638,1527.753784 1573.166138,1527.692017 1572.340576,1527.163330 
    C1571.208130,1526.530518 1570.463989,1526.364502 1569.719727,1526.198486 
    C1569.719727,1526.198486 1569.331909,1526.209473 1569.154785,1525.863281 
    C1568.986816,1525.343018 1568.996094,1525.168945 1569.023682,1524.977783 
    C1569.041870,1524.960571 1569.078247,1524.926147 1569.078247,1524.926147 
    C1571.081787,1525.341431 1573.085327,1525.756714 1575.178955,1526.581177 
  z"/>
  <path fill="#C3C3C3" opacity="1.000000" stroke="none" 
    d="
  M1410.370850,1444.041504 
    C1409.759277,1443.747192 1409.505737,1443.458618 1408.990234,1443.040405 
    C1410.532227,1442.256714 1412.336426,1441.602539 1414.562256,1440.934937 
    C1414.044067,1441.566406 1413.104248,1442.211426 1412.075195,1443.136475 
    C1411.567017,1443.626709 1411.147949,1443.836914 1410.370850,1444.041504 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M1503.218506,1604.626709 
    C1502.474243,1604.647827 1501.608398,1604.316284 1500.394043,1603.979004 
    C1500.045410,1603.973022 1500.009521,1603.995117 1499.992676,1603.647705 
    C1499.296631,1602.881714 1498.617554,1602.463135 1497.938477,1602.044678 
    C1497.938477,1602.044678 1497.994019,1601.998535 1497.996826,1601.646606 
    C1497.963501,1600.531006 1497.927246,1599.767456 1497.890991,1599.003784 
    C1499.626343,1600.760498 1501.361694,1602.517212 1503.218506,1604.626709 
  z"/>
  <path fill="#D5D5D5" opacity="1.000000" stroke="none" 
    d="
  M1547.772461,1564.431763 
    C1549.606323,1564.527100 1551.566895,1565.026611 1553.774292,1565.800781 
    C1551.980469,1565.662354 1549.939697,1565.249023 1547.772461,1564.431763 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M1456.165894,1396.946289 
    C1456.504761,1397.401611 1456.843750,1397.857056 1456.916138,1398.770996 
    C1456.389771,1399.572510 1456.129883,1399.915283 1455.870117,1400.258179 
    C1455.214233,1399.144287 1454.558350,1398.030273 1453.872070,1396.531250 
    C1453.841553,1396.146240 1453.938354,1396.058960 1454.251709,1396.144653 
    C1455.098755,1396.468994 1455.632324,1396.707642 1456.165894,1396.946289 
  z"/>
  <path fill="#CACACA" opacity="1.000000" stroke="none" 
    d="
  M1529.975830,1497.791992 
    C1528.354248,1496.834839 1526.788940,1495.490967 1525.555664,1493.811768 
    C1527.269165,1494.785889 1528.650635,1496.095581 1529.975830,1497.791992 
  z"/>
  <path fill="#CACACA" opacity="1.000000" stroke="none" 
    d="
  M1532.224609,1502.316650 
    C1531.200562,1501.054810 1530.176636,1499.792969 1529.483032,1498.300903 
    C1531.242432,1499.096313 1532.671631,1500.121948 1533.658447,1501.614746 
    C1532.885742,1502.160278 1532.555176,1502.238525 1532.224609,1502.316650 
  z"/>
  <path fill="#CACACA" opacity="1.000000" stroke="none" 
    d="
  M1564.991455,1522.762939 
    C1563.391602,1522.757324 1561.852417,1522.328125 1560.573120,1521.501465 
    C1562.239380,1521.515747 1563.645752,1521.927490 1564.991455,1522.762939 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M1451.806763,1360.125977 
    C1452.424316,1360.701416 1452.675781,1361.395630 1452.359863,1362.680298 
    C1451.605469,1364.073242 1451.418091,1364.875854 1451.230835,1365.678345 
    C1451.424683,1365.968262 1451.453003,1366.273560 1450.930298,1366.799805 
    C1450.377441,1367.017212 1450.210083,1367.028931 1450.042847,1367.040771 
    C1450.042847,1367.040771 1449.948486,1366.951050 1449.901123,1366.906250 
    C1450.382812,1364.656006 1450.911743,1362.450317 1451.806763,1360.125977 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M1560.990234,1520.766602 
    C1559.399780,1520.757080 1557.868530,1520.323730 1556.588623,1519.491821 
    C1558.243042,1519.509766 1559.646362,1519.926392 1560.990234,1520.766602 
  z"/>
  <path fill="#C3C3C3" opacity="1.000000" stroke="none" 
    d="
  M1380.586426,1455.066650 
    C1380.666382,1455.643188 1380.372314,1456.140747 1380.035889,1456.850952 
    C1379.560425,1457.289062 1379.127197,1457.514648 1378.319458,1457.730347 
    C1377.944946,1457.720581 1378.012695,1457.345581 1378.000854,1457.155029 
    C1378.730103,1456.305664 1379.471191,1455.646729 1380.586426,1455.066650 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1477.088867,1430.548950 
    C1477.053345,1430.950317 1477.025269,1431.190063 1476.982666,1431.791382 
    C1475.701416,1431.717285 1474.434692,1431.281372 1473.301270,1430.482178 
    C1473.933594,1430.117065 1474.432373,1430.115112 1475.097900,1430.270996 
    C1475.842529,1430.311890 1476.420654,1430.195068 1476.998779,1430.078247 
    C1476.998779,1430.078247 1477.096436,1430.387207 1477.088867,1430.548950 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M1532.464355,1502.730469 
    C1532.555176,1502.238525 1532.885742,1502.160278 1533.715576,1501.981445 
    C1534.866943,1502.424072 1535.518921,1502.967285 1536.340210,1503.843018 
    C1535.240967,1503.831787 1533.972534,1503.488037 1532.464355,1502.730469 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1455.887695,1400.442505 
    C1456.129883,1399.915283 1456.389771,1399.572510 1456.931152,1399.067627 
    C1457.729126,1399.416016 1458.245483,1399.926758 1458.766357,1400.723877 
    C1458.079468,1400.997925 1457.388062,1400.985840 1456.350708,1400.978760 
    C1456.004883,1400.983643 1455.905518,1400.626831 1455.887695,1400.442505 
  z"/>
  <path fill="#CACACA" opacity="1.000000" stroke="none" 
    d="
  M1501.091064,1454.589600 
    C1500.406616,1453.786133 1499.710205,1452.581299 1499.042969,1451.009766 
    C1499.741211,1451.824829 1500.410156,1453.006470 1501.091064,1454.589600 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M1497.185791,1448.556274 
    C1497.083618,1448.935913 1496.905884,1448.924316 1496.468994,1448.850952 
    C1495.810669,1447.654907 1495.411499,1446.520752 1495.040039,1445.020142 
    C1495.748535,1445.824097 1496.429321,1446.994507 1497.185791,1448.556274 
  z"/>
  <path fill="#CFCFCF" opacity="1.000000" stroke="none" 
    d="
  M1564.671265,1524.265259 
    C1564.541870,1524.048218 1564.412476,1523.831055 1564.551147,1523.345703 
    C1566.227539,1523.423706 1567.635620,1523.769531 1569.061035,1524.520752 
    C1569.078247,1524.926147 1569.041870,1524.960571 1568.648682,1524.968262 
    C1567.060791,1524.739014 1565.865967,1524.502197 1564.671265,1524.265259 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1497.758789,1598.948242 
    C1497.927246,1599.767456 1497.963501,1600.531006 1497.978271,1601.677490 
    C1497.130493,1601.427734 1496.304199,1600.795288 1495.384521,1599.849365 
    C1495.631470,1599.431519 1495.972046,1599.327026 1496.827637,1599.079102 
    C1497.342896,1598.935791 1497.626465,1598.892822 1497.758789,1598.948242 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M1460.831055,1346.079834 
    C1460.341919,1347.359497 1459.516479,1348.686279 1458.378662,1349.605225 
    C1458.875732,1348.173950 1459.685303,1347.150513 1460.831055,1346.079834 
  z"/>
  <path fill="#9C9C9C" opacity="1.000000" stroke="none" 
    d="
  M1509.555908,1471.153564 
    C1510.213257,1470.984619 1510.808228,1471.114990 1511.707520,1471.221924 
    C1512.011719,1471.198364 1512.088623,1471.378418 1511.902100,1472.013550 
    C1511.625122,1473.013916 1511.534546,1473.379272 1511.443970,1473.744507 
    C1510.793823,1472.980591 1510.143799,1472.216797 1509.555908,1471.153564 
  z"/>
  <path fill="#CACACA" opacity="1.000000" stroke="none" 
    d="
  M1511.539062,1474.104492 
    C1511.534546,1473.379272 1511.625122,1473.013916 1511.860352,1472.102051 
    C1512.680176,1472.611694 1513.355347,1473.667969 1514.000000,1475.163574 
    C1513.191040,1475.223511 1512.412598,1474.843994 1511.539062,1474.104492 
  z"/>
  <path fill="#C3C3C3" opacity="1.000000" stroke="none" 
    d="
  M1407.634277,1442.985107 
    C1407.159546,1443.680908 1406.300293,1444.317627 1405.100342,1444.943848 
    C1405.589600,1444.264282 1406.419800,1443.595215 1407.634277,1442.985107 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M1469.176025,1410.860840 
    C1469.132690,1411.284790 1469.080688,1411.735352 1469.013428,1412.525879 
    C1467.978638,1412.179565 1466.959106,1411.493530 1465.895752,1410.472900 
    C1465.851929,1410.138428 1465.945068,1410.054321 1466.294678,1410.157471 
    C1467.494873,1410.456177 1468.345337,1410.651855 1469.195801,1410.847412 
    C1469.195801,1410.847412 1469.167358,1410.887329 1469.176025,1410.860840 
  z"/>
  <path fill="#E2E2E2" opacity="1.000000" stroke="none" 
    d="
  M1455.949951,1634.085693 
    C1456.229248,1634.517700 1456.508545,1634.949585 1456.866943,1635.625977 
    C1455.946899,1635.535278 1454.947754,1635.200195 1453.904541,1634.497925 
    C1453.860352,1634.130859 1453.936279,1634.060547 1454.297363,1633.982666 
    C1455.088867,1633.965088 1455.519409,1634.025391 1455.949951,1634.085693 
  z"/>
  <path fill="#D5D5D5" opacity="1.000000" stroke="none" 
    d="
  M1543.812988,1562.406982 
    C1544.745117,1562.456909 1545.767700,1562.888184 1546.933838,1563.640625 
    C1546.019409,1563.570557 1544.961426,1563.179321 1543.812988,1562.406982 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1511.704224,1338.061646 
    C1512.298828,1338.616089 1512.572754,1339.116455 1512.913330,1339.894775 
    C1511.986572,1339.681030 1510.993164,1339.189331 1510.041260,1338.334473 
    C1510.516479,1337.983398 1510.949951,1337.995361 1511.704224,1338.061646 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M1509.963379,1610.806396 
    C1508.942505,1610.765259 1507.992310,1610.326660 1507.415283,1609.504028 
    C1508.536987,1609.549683 1509.285645,1609.979370 1509.963379,1610.806396 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M1511.961914,1612.808105 
    C1510.944214,1612.758667 1509.997681,1612.312866 1509.423584,1611.487305 
    C1510.541626,1611.542236 1511.287231,1611.977051 1511.961914,1612.808105 
  z"/>
  <path fill="#C3C3C3" opacity="1.000000" stroke="none" 
    d="
  M1418.627075,1438.919189 
    C1418.075317,1439.359009 1417.182007,1439.825928 1416.114136,1440.093018 
    C1416.721558,1439.577637 1417.503540,1439.262085 1418.627075,1438.919189 
  z"/>
  <path fill="#CACACA" opacity="1.000000" stroke="none" 
    d="
  M1476.958496,1429.735352 
    C1476.420654,1430.195068 1475.842529,1430.311890 1475.123901,1429.998291 
    C1474.989990,1429.386230 1474.996582,1429.204590 1475.003174,1429.023071 
    C1475.641602,1429.146240 1476.279907,1429.269409 1476.958496,1429.735352 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M1493.094238,1442.601929 
    C1492.483276,1442.467407 1491.849976,1441.972900 1491.125977,1441.179199 
    C1491.714233,1441.334106 1492.393066,1441.787964 1493.094238,1442.601929 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M1491.093018,1440.604614 
    C1490.480591,1440.421143 1489.843750,1439.874634 1489.125000,1439.010986 
    C1489.718262,1439.209717 1490.393433,1439.725708 1491.093018,1440.604614 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M1506.142334,1609.756348 
    C1505.833130,1608.905151 1505.870361,1608.339478 1505.983154,1607.355347 
    C1506.705566,1607.482056 1507.352661,1608.027222 1507.951172,1608.900391 
    C1507.431274,1609.499512 1506.960083,1609.770630 1506.142334,1609.756348 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M1503.051514,1536.360107 
    C1503.562012,1536.269653 1504.177734,1536.498535 1504.902954,1537.070312 
    C1504.393921,1537.168579 1503.775269,1536.923828 1503.051514,1536.360107 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M1474.697510,1428.974854 
    C1474.996582,1429.204590 1474.989990,1429.386230 1474.957275,1429.840576 
    C1474.432373,1430.115112 1473.933594,1430.117065 1473.075317,1430.228516 
    C1472.715942,1430.338013 1472.698120,1430.335083 1472.768311,1430.020386 
    C1472.874634,1429.494141 1472.910767,1429.282715 1472.947021,1429.071167 
    C1472.947021,1429.071167 1473.053101,1428.945923 1473.106689,1428.883789 
    C1473.570801,1428.856689 1473.981445,1428.891602 1474.697510,1428.974854 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1463.736572,1343.178833 
    C1464.126221,1343.805542 1464.083740,1344.582520 1463.572510,1345.456299 
    C1463.170898,1344.811768 1463.237671,1344.070435 1463.736572,1343.178833 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M1465.659912,1342.033447 
    C1465.994385,1342.273682 1465.994873,1342.490967 1466.004517,1343.034790 
    C1465.510010,1343.543823 1465.006226,1343.726440 1464.266113,1343.543213 
    C1464.461792,1342.788452 1464.893799,1342.399658 1465.659912,1342.033447 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M1494.956055,1443.739868 
    C1494.428955,1443.872803 1493.862183,1443.667480 1493.157227,1443.182617 
    C1493.651489,1443.069092 1494.283936,1443.235352 1494.956055,1443.739868 
  z"/>
  <path fill="#CACACA" opacity="1.000000" stroke="none" 
    d="
  M1498.990234,1449.759277 
    C1498.709961,1449.878662 1498.418091,1449.697754 1498.040771,1449.265869 
    C1498.296387,1449.162964 1498.637451,1449.311035 1498.990234,1449.759277 
  z"/>
  <path fill="#F6F6F6" opacity="1.000000" stroke="none" 
    d="
  M1476.998657,1656.285645 
    C1477.279907,1656.166016 1477.626099,1656.311646 1477.976074,1656.761963 
    C1477.674438,1656.894775 1477.369019,1656.722900 1476.998657,1656.285645 
  z"/>
  <path fill="#F6F6F6" opacity="1.000000" stroke="none" 
    d="
  M1475.998779,1655.284424 
    C1476.279663,1655.165527 1476.625732,1655.312134 1476.975830,1655.762573 
    C1476.674561,1655.894287 1476.369141,1655.722046 1475.998779,1655.284424 
  z"/>
  <path fill="#F6F6F6" opacity="1.000000" stroke="none" 
    d="
  M1474.999146,1654.284546 
    C1475.277954,1654.166260 1475.622314,1654.313232 1475.974121,1654.763306 
    C1475.675781,1654.894165 1475.370239,1654.722046 1474.999146,1654.284546 
  z"/>
  <path fill="#F6F6F6" opacity="1.000000" stroke="none" 
    d="
  M1474.064331,1653.267700 
    C1474.363525,1653.162964 1474.677002,1653.329712 1474.984619,1653.781494 
    C1474.678711,1653.890625 1474.378662,1653.714844 1474.064331,1653.267700 
  z"/>
  <path fill="#F6F6F6" opacity="1.000000" stroke="none" 
    d="
  M1477.998535,1657.285645 
    C1478.281128,1657.165649 1478.628418,1657.310913 1478.977417,1657.761353 
    C1478.673828,1657.894775 1478.368652,1657.722778 1477.998535,1657.285645 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M1505.005127,1605.676514 
    C1504.739014,1605.823975 1504.415039,1605.692871 1504.019409,1605.291992 
    C1504.280884,1605.147461 1504.614014,1605.272583 1505.005127,1605.676514 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M1506.018188,1606.690308 
    C1505.741821,1606.807861 1505.417236,1606.655396 1505.067017,1606.219482 
    C1505.350952,1606.097412 1505.660400,1606.258789 1506.018188,1606.690308 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M1457.830200,1349.088989 
    C1458.058838,1349.540527 1457.971802,1349.971558 1457.515625,1350.275513 
    C1457.269165,1349.788452 1457.391968,1349.428467 1457.830200,1349.088989 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1462.515747,1345.744629 
    C1462.222778,1346.310303 1461.992310,1346.505127 1461.401123,1346.425781 
    C1461.553101,1345.892334 1462.065552,1345.632935 1462.515747,1345.744629 
  z"/>
  <path fill="#030303" opacity="1.000000" stroke="none" 
    d="
  M480.787903,1657.682861 
    C480.787903,1657.682861 480.894836,1657.575806 480.604431,1657.931641 
    C481.107635,1660.157593 481.901276,1662.027710 482.628052,1664.165039 
    C483.007385,1664.965332 483.453644,1665.498535 483.933167,1666.370850 
    C484.170776,1667.109375 484.375183,1667.508911 484.532104,1668.183594 
    C484.980560,1668.975220 485.476562,1669.491577 486.023682,1670.353638 
    C488.164551,1673.778442 490.254333,1676.857788 492.333862,1680.221191 
    C492.851105,1681.013550 493.378571,1681.521729 493.979126,1682.358521 
    C496.065918,1684.790649 498.079681,1686.894165 500.152069,1689.278564 
    C500.816803,1690.010620 501.422882,1690.461670 502.133484,1691.192017 
    C502.596893,1691.618408 502.955811,1691.765503 503.400818,1692.159668 
    C503.995972,1692.799194 504.505066,1693.191528 505.215698,1693.916992 
    C507.436066,1695.253784 509.454865,1696.257568 511.473633,1697.261475 
    C511.473633,1697.261475 511.369904,1697.077759 511.086884,1697.518433 
    C511.855469,1698.668457 512.907104,1699.377808 513.958679,1700.087280 
    C513.958679,1700.087280 513.980896,1700.013794 513.845459,1700.361938 
    C515.169678,1701.554688 516.629456,1702.399414 518.358521,1703.462646 
    C518.847473,1703.753540 519.067200,1703.825806 519.340210,1704.190186 
    C520.254578,1704.843140 521.115662,1705.204102 522.175720,1705.819214 
    C523.120178,1706.445557 523.865662,1706.817749 524.787842,1707.428223 
    C525.665466,1707.944458 526.366455,1708.222534 527.276001,1708.729492 
    C527.884216,1709.023682 528.283813,1709.089111 528.857544,1709.390869 
    C530.365234,1710.122925 531.698975,1710.618896 533.400757,1711.252930 
    C534.022278,1711.324341 534.275696,1711.257446 534.529114,1711.190674 
    C534.529114,1711.190674 534.456482,1711.039307 534.551270,1711.420898 
    C566.167236,1723.604492 595.487793,1719.068359 622.792114,1699.855347 
    C623.610596,1699.279419 623.974731,1698.057739 624.550659,1697.137085 
    C624.751038,1696.952881 624.951355,1696.768555 625.585083,1696.425537 
    C630.997131,1691.471558 635.975830,1686.676392 641.176880,1681.650391 
    C642.697632,1679.671997 643.995972,1677.924438 645.615479,1676.047241 
    C648.332397,1671.356689 650.728149,1666.795776 653.438293,1662.112793 
    C654.273499,1660.293213 654.794312,1658.595581 655.550415,1656.620117 
    C655.954529,1655.395874 656.123291,1654.449463 656.539673,1653.317261 
    C656.999878,1652.390869 657.212585,1651.650391 657.646118,1650.603516 
    C658.034607,1649.058228 658.202209,1647.819336 658.628052,1646.364014 
    C659.248291,1644.100708 659.610352,1642.054077 660.073730,1639.639160 
    C660.235657,1638.007446 660.296143,1636.744263 660.632935,1635.202515 
    C661.264587,1630.470703 661.894348,1626.019165 661.926758,1621.563477 
    C662.050171,1604.607422 661.893982,1587.648804 662.106384,1570.694580 
    C662.129761,1568.826172 663.477600,1565.718994 664.842590,1565.313843 
    C681.498474,1560.370605 698.298340,1555.915894 715.006226,1551.143066 
    C724.820679,1548.339355 734.537598,1545.194214 744.712646,1542.259155 
    C750.367615,1540.813843 755.529419,1538.848145 760.871094,1537.939819 
    C766.291382,1537.017944 766.190613,1534.125244 764.946533,1529.749878 
    C763.087769,1529.749878 761.286682,1529.749878 759.485596,1529.749878 
    C715.340393,1529.749878 671.195129,1529.756470 627.049927,1529.730103 
    C624.903137,1529.728882 622.756531,1529.438843 620.669556,1528.797974 
    C620.854004,1515.229614 620.978638,1502.146729 621.564575,1489.029541 
    C697.154602,1488.995361 772.283447,1488.995361 847.774170,1488.995361 
    C847.774170,1507.553955 847.639587,1525.348511 847.868347,1543.138550 
    C847.925781,1547.605957 847.530090,1551.192993 842.385742,1552.683350 
    C841.736267,1552.775513 841.370850,1552.870728 840.746338,1552.838623 
    C838.872314,1553.363403 837.257446,1554.015381 835.364502,1554.663086 
    C834.728210,1554.749634 834.369995,1554.840332 833.751343,1554.801880 
    C831.834778,1555.284424 830.178650,1555.895996 828.201416,1556.514648 
    C827.256348,1556.664551 826.632324,1556.807617 825.755005,1556.810547 
    C823.860535,1557.334106 822.219299,1557.997925 820.312012,1558.650635 
    C819.703064,1558.725952 819.360291,1558.812134 818.758240,1558.765625 
    C816.848877,1559.294434 815.198669,1559.956055 813.223938,1560.612305 
    C812.266296,1560.737549 811.633240,1560.868164 810.765015,1560.864990 
    C809.172302,1561.312134 807.814636,1561.893188 806.145508,1562.481445 
    C805.228394,1562.624878 804.622742,1562.760864 803.781738,1562.751099 
    C802.177917,1563.217773 800.809509,1563.830200 799.132446,1564.440674 
    C798.224243,1564.574951 797.624634,1564.711182 796.782471,1564.712646 
    C795.168701,1565.185303 793.797546,1565.792603 792.077332,1566.408325 
    C790.819824,1566.605347 789.911377,1566.794067 788.774048,1566.839355 
    C787.179871,1567.276611 785.814453,1567.857300 784.136780,1568.432861 
    C783.219666,1568.569336 782.614807,1568.710938 781.778442,1568.704712 
    C780.175171,1569.168335 778.803406,1569.779907 777.124512,1570.387695 
    C776.221680,1570.519653 775.625916,1570.655518 774.774780,1570.653809 
    C773.130676,1571.255615 771.742004,1571.995117 770.353271,1572.734619 
    C770.353271,1572.734497 770.412720,1572.859497 770.051636,1572.613403 
    C768.798035,1572.543213 767.905579,1572.719116 766.825684,1572.735352 
    C766.008789,1572.990845 765.379333,1573.406250 764.341187,1573.874634 
    C756.286621,1576.066772 748.640686,1578.205688 740.642944,1580.291748 
    C739.854370,1580.401978 739.417664,1580.565063 738.616760,1580.654297 
    C727.466980,1583.577515 716.658997,1586.498779 705.927429,1589.678223 
    C704.732727,1590.032104 703.973145,1591.854980 702.908325,1593.455811 
    C702.762451,1607.075073 702.720093,1620.235229 702.474121,1633.698242 
    C700.839783,1641.994629 699.710205,1650.056396 697.915283,1657.967529 
    C694.284424,1673.971069 686.676270,1688.249023 677.734009,1702.176270 
    C676.964600,1703.169922 676.433350,1703.982178 675.618652,1704.961182 
    C674.522339,1706.406860 673.709595,1707.685669 672.659424,1709.031738 
    C672.113708,1709.292358 671.963318,1709.570801 671.692383,1710.044556 
    C670.966553,1710.782593 670.519104,1711.410522 670.036133,1712.027588 
    C670.000549,1712.016846 670.043213,1712.077881 669.764160,1712.198486 
    C668.786438,1713.254761 668.087708,1714.190308 667.069763,1715.251709 
    C664.466980,1717.847534 662.183411,1720.317505 659.553589,1722.845703 
    C657.666382,1724.386841 656.125366,1725.869629 654.584412,1727.352417 
    C654.377441,1727.622192 654.170471,1727.892090 653.639771,1728.286865 
    C652.868958,1728.833374 652.421875,1729.255005 651.636230,1729.769043 
    C649.608948,1731.247559 647.920166,1732.633667 645.885986,1734.134888 
    C644.624695,1735.460571 643.708679,1736.671021 642.792664,1737.881470 
    C642.792664,1737.881470 642.934570,1737.901855 642.616150,1737.458252 
    C641.198975,1737.586304 640.100220,1738.157959 638.711426,1738.726074 
    C637.446899,1739.407104 636.472473,1740.091797 635.162781,1740.886475 
    C634.625732,1741.596558 634.424011,1742.196777 634.222290,1742.796997 
    C634.222290,1742.796997 634.370544,1742.913696 634.048645,1742.544189 
    C633.165222,1742.409302 632.603638,1742.643799 631.883911,1742.783447 
    C631.207031,1743.153076 630.688354,1743.617554 630.083374,1744.261841 
    C629.997192,1744.441650 630.182983,1744.794434 630.182983,1744.794434 
    C630.182983,1744.794434 630.361267,1744.931519 630.088379,1744.536133 
    C628.545776,1744.769287 627.276123,1745.397827 625.632141,1746.008545 
    C617.009644,1748.836060 608.828552,1751.901123 600.489136,1754.447632 
    C595.123108,1756.085938 589.524353,1756.961914 583.665527,1758.152344 
    C582.581787,1758.234741 581.862488,1758.344360 580.691650,1758.287964 
    C571.444336,1758.231445 562.648499,1758.341064 553.503662,1758.348877 
    C552.430542,1758.216797 551.706482,1758.186523 550.671509,1757.945679 
    C546.568481,1757.172363 542.776367,1756.609741 538.660034,1755.909058 
    C536.218384,1755.347046 534.100952,1754.922974 531.664062,1754.349854 
    C530.877869,1754.200195 530.411072,1754.199829 529.681152,1754.030273 
    C528.275757,1753.535522 527.133545,1753.209595 525.702759,1752.642822 
    C524.923279,1752.343750 524.432312,1752.285400 523.702026,1752.015015 
    C522.293152,1751.422485 521.123596,1751.042114 519.652588,1750.452271 
    C518.631348,1750.131958 517.911499,1750.020874 516.999756,1749.632446 
    C509.237244,1745.508423 501.666656,1741.661865 493.946472,1737.541748 
    C492.580536,1736.493164 491.364258,1735.718384 490.034912,1734.656128 
    C488.909363,1733.772461 487.896942,1733.176514 486.740814,1732.364990 
    C486.439056,1732.079956 486.281036,1732.010254 486.057587,1731.612671 
    C483.990295,1729.863525 481.988403,1728.442139 479.993164,1727.010254 
    C479.999847,1727.000000 479.978119,1727.013672 479.902985,1726.728149 
    C479.209991,1725.994995 478.592133,1725.547363 477.819946,1724.871338 
    C477.356842,1724.448120 477.048065,1724.253296 476.739380,1723.782593 
    C476.124084,1723.185913 475.508698,1722.864990 474.654358,1722.139404 
    C473.648010,1721.737061 472.880646,1721.739380 472.113251,1721.741699 
    C472.113251,1721.741699 472.092621,1721.892212 472.510590,1721.498535 
    C471.997101,1720.654419 471.065613,1720.203979 470.134155,1719.753418 
    C470.134186,1719.753418 470.109467,1719.890015 470.529327,1719.496582 
    C470.013702,1718.651611 469.078217,1718.199951 468.142761,1717.748291 
    C468.142761,1717.748291 468.117493,1717.906494 468.508057,1717.681885 
    C468.805298,1716.998047 468.711945,1716.538940 468.646790,1715.797607 
    C463.534454,1709.195801 458.393951,1702.875977 453.273621,1696.387695 
    C453.293762,1696.218994 453.036346,1695.997314 453.069336,1695.659424 
    C452.460388,1694.429565 451.818420,1693.537476 451.132385,1692.317139 
    C450.270599,1690.676636 449.452820,1689.364502 448.611755,1687.699463 
    C446.158630,1682.407593 443.728821,1677.468384 441.335938,1672.259277 
    C441.240784,1671.657715 441.108673,1671.325928 441.083862,1670.766479 
    C440.610413,1669.461182 440.029633,1668.383667 439.498566,1667.084717 
    C439.547577,1666.541016 439.429504,1666.270020 439.297302,1665.786865 
    C438.746277,1664.118896 438.092010,1662.713989 437.475952,1660.916748 
    C437.109253,1659.917969 436.704346,1659.311768 436.580627,1658.709473 
    C436.281219,1657.551636 435.700592,1656.389893 435.119934,1655.228027 
    C434.803528,1654.347412 434.487122,1653.466797 434.494354,1652.062378 
    C434.984283,1650.505249 435.344940,1649.460938 435.287018,1648.440308 
    C434.679138,1637.728516 433.310699,1627.004517 433.559662,1616.316528 
    C433.772461,1607.183350 435.820251,1598.093018 437.194153,1588.710938 
    C437.370270,1587.833496 437.408600,1587.228760 437.653564,1586.404907 
    C438.282867,1584.780396 438.705505,1583.374878 439.262451,1581.767822 
    C439.518219,1581.252441 439.530731,1580.934326 439.658997,1580.401611 
    C440.088837,1579.430542 440.293976,1578.669922 440.720734,1577.636597 
    C441.109131,1576.450439 441.275940,1575.536865 441.705383,1574.415527 
    C442.979980,1571.805054 443.991943,1569.402100 445.180389,1566.750488 
    C445.605499,1565.731079 445.854095,1564.960327 446.376465,1564.095215 
    C446.814667,1563.297241 446.979156,1562.593750 447.354187,1561.604370 
    C447.774445,1560.898560 447.984192,1560.478394 448.500977,1559.961548 
    C450.056549,1557.546753 451.305054,1555.228882 452.782776,1552.645752 
    C454.341980,1550.255127 455.671967,1548.129517 457.273254,1545.898071 
    C457.909790,1545.171021 458.274994,1544.549805 458.829224,1543.743042 
    C459.058746,1543.385254 459.099182,1543.213257 459.432495,1542.967529 
    C460.315887,1541.896118 460.906342,1540.898438 461.789307,1539.726807 
    C462.384033,1538.959106 462.686218,1538.365479 463.278168,1537.676514 
    C464.163177,1536.768311 464.758453,1535.955688 465.641846,1535.081421 
    C466.629608,1534.096558 467.329224,1533.173584 468.340240,1532.107666 
    C473.408936,1527.457886 478.166229,1522.950806 483.238983,1518.408691 
    C485.386902,1516.922729 487.219421,1515.471924 489.290009,1513.996460 
    C489.862854,1513.850952 490.056915,1513.614502 490.429077,1513.189575 
    C491.531067,1512.434204 492.314270,1511.751831 493.058167,1511.047363 
    C493.018921,1511.025269 493.053192,1511.108765 493.377319,1511.051758 
    C494.561951,1510.373291 495.422485,1509.751831 496.537903,1509.097656 
    C497.196960,1508.757568 497.601074,1508.450439 498.364380,1508.134033 
    C500.626617,1506.815796 502.529694,1505.506714 504.716919,1504.204834 
    C505.320129,1504.023560 505.639221,1503.835205 506.313538,1503.628174 
    C509.497955,1502.096558 512.327026,1500.583618 515.449158,1499.052124 
    C516.473145,1498.765015 517.204102,1498.496460 518.199219,1498.323242 
    C519.871826,1497.735962 521.280273,1497.053345 522.914062,1496.427490 
    C523.471558,1496.485229 523.746155,1496.359985 524.250244,1496.204834 
    C541.616455,1490.190552 559.212708,1488.015747 577.325073,1489.019531 
    C577.325073,1502.579224 577.325073,1515.783691 577.325073,1528.545654 
    C568.252869,1529.629883 559.587952,1530.665405 550.604858,1531.611938 
    C549.870850,1531.646606 549.455017,1531.770386 548.767456,1531.764771 
    C546.959961,1532.392700 545.424194,1533.149902 543.888367,1533.907104 
    C543.888367,1533.907104 543.958313,1533.959473 543.675964,1533.643677 
    C542.631653,1533.452271 541.869751,1533.576660 540.842834,1533.602783 
    C539.411316,1534.096069 538.244812,1534.687500 536.714844,1535.267334 
    C535.916687,1535.450439 535.481934,1535.644897 534.732056,1535.786865 
    C532.562073,1536.773193 530.707214,1537.812134 528.478455,1538.866943 
    C521.362000,1543.237671 514.619507,1547.592529 507.602661,1552.129883 
    C505.577484,1553.953735 503.826599,1555.594971 501.759827,1557.282471 
    C500.529724,1558.497803 499.615509,1559.666870 498.427612,1560.989258 
    C497.102051,1562.427124 496.050171,1563.711670 494.698761,1565.029785 
    C494.058319,1565.760254 493.717407,1566.457031 493.112213,1567.307983 
    C492.580078,1568.001099 492.312256,1568.540161 491.736328,1569.177246 
    C490.883423,1570.171143 490.338593,1571.066650 489.522705,1572.105103 
    C488.816956,1573.124756 488.382263,1574.001587 487.714478,1575.031860 
    C487.148407,1575.803833 486.815460,1576.422485 486.254822,1577.312500 
    C485.338684,1579.051880 484.650299,1580.520020 483.722229,1582.109619 
    C483.246857,1582.844727 483.011108,1583.458496 482.559387,1584.363403 
    C481.738586,1586.188721 481.133698,1587.722778 480.316040,1589.522339 
    C479.762054,1591.882568 479.420898,1593.977417 479.079712,1596.072266 
    C478.813812,1596.376831 478.547913,1596.681396 477.862061,1597.434448 
    C473.316406,1610.379150 472.445343,1623.111328 474.576477,1636.423828 
    C474.625916,1637.491577 474.771912,1638.203979 474.779968,1639.234375 
    C475.149200,1641.028198 475.656403,1642.503784 476.150757,1644.384277 
    C476.382446,1645.831543 476.627014,1646.873901 476.755615,1648.179199 
    C477.026978,1649.030273 477.414276,1649.618652 477.896484,1650.175049 
    C477.991394,1650.143066 477.793274,1650.171509 477.771881,1650.502319 
    C477.923401,1651.236450 478.096283,1651.639771 478.248108,1652.369385 
    C478.366730,1653.103638 478.506378,1653.511719 478.558533,1654.199463 
    C478.913177,1655.057495 479.355347,1655.635986 479.906433,1656.131226 
    C480.015381,1656.048096 479.789337,1656.200317 479.791504,1656.551025 
    C480.125092,1657.161987 480.456512,1657.422485 480.787903,1657.682861 
  z"/>
  <path fill="#050505" opacity="1.000000" stroke="none" 
    d="
  M441.781982,1396.190308 
    C441.781982,1396.190308 441.615051,1396.070435 441.834991,1396.543701 
    C444.033112,1395.718872 446.011292,1394.420654 448.327606,1393.100830 
    C449.858246,1392.120728 451.050781,1391.162354 452.192688,1390.181885 
    C452.142059,1390.159668 452.151123,1390.269897 452.478149,1390.210693 
    C453.605133,1389.441406 454.405090,1388.731201 455.476166,1387.948242 
    C456.160767,1387.510254 456.574249,1387.144897 457.279846,1386.759644 
    C458.089905,1386.187866 458.607819,1385.636108 459.088562,1385.050537 
    C459.051331,1385.016724 459.075287,1385.114380 459.409363,1385.094116 
    C460.376678,1384.474854 461.009949,1383.875854 461.890564,1383.276733 
    C462.463287,1382.943726 462.788696,1382.610962 463.445648,1382.215332 
    C464.605011,1381.454956 465.432800,1380.757446 466.533813,1379.963867 
    C467.524719,1379.620361 468.242432,1379.373047 469.206909,1379.355835 
    C477.253723,1390.150879 485.053772,1400.715820 492.893555,1411.510986 
    C492.933258,1411.741211 493.347076,1411.957886 493.360718,1412.260254 
    C493.894165,1413.129150 494.413971,1413.695679 494.983398,1414.449219 
    C495.180969,1414.871460 495.392792,1415.006348 495.704529,1415.396240 
    C497.143982,1417.537842 498.547455,1419.324097 499.968872,1421.345459 
    C500.107483,1421.916748 500.346100,1422.096069 500.779480,1422.462402 
    C502.522461,1424.977051 504.188690,1427.147583 505.923737,1429.645020 
    C507.818604,1432.287842 509.644623,1434.603638 511.440918,1437.255127 
    C514.810486,1442.472168 518.209717,1447.353516 521.870972,1452.611206 
    C518.177795,1453.749756 515.322449,1454.500854 512.561279,1455.509766 
    C507.687012,1457.291016 502.870117,1459.229248 497.673462,1461.109619 
    C495.565735,1461.886475 493.813843,1462.655396 491.769867,1463.361572 
    C490.898865,1463.779785 490.319885,1464.260742 489.843323,1464.877930 
    C489.945709,1465.014160 489.755737,1464.732544 489.376953,1464.702637 
    C487.748810,1465.357178 486.499481,1466.041748 484.851379,1466.732544 
    C482.712189,1465.482422 480.971771,1464.226074 479.144714,1462.623291 
    C474.926727,1456.512817 470.874115,1450.690552 466.646973,1444.997925 
    C458.866333,1434.519775 450.983063,1424.117798 443.082764,1413.333252 
    C441.733368,1412.230835 440.443817,1411.479370 439.154297,1410.728027 
    C439.154266,1410.728027 439.120575,1410.873901 439.531647,1410.531006 
    C439.357697,1409.735352 438.772675,1409.282349 438.187653,1408.829468 
    C438.187653,1408.829468 438.175446,1408.927734 438.572083,1408.650391 
    C438.275665,1407.252075 437.582611,1406.130981 436.790527,1404.697998 
    C437.371735,1402.933228 438.052002,1401.480469 439.031555,1399.913208 
    C440.147949,1398.595947 440.964966,1397.393188 441.781982,1396.190308 
  z"/>
  <path fill="#060606" opacity="1.000000" stroke="none" 
    d="
  M684.036255,1438.848145 
    C684.281128,1438.580688 684.526001,1438.313354 685.101868,1437.806152 
    C685.404907,1437.677368 685.376953,1437.788452 685.348999,1437.899414 
    C685.449402,1437.850830 685.589233,1437.829346 685.643616,1437.749512 
    C686.042786,1437.163330 686.425049,1436.565552 687.022522,1435.710205 
    C688.530518,1433.725464 689.828674,1432.002075 691.420288,1430.103394 
    C692.253479,1428.958130 692.793152,1427.988281 693.583252,1426.859131 
    C694.598145,1425.560425 695.362732,1424.421265 696.417969,1423.180420 
    C697.042419,1422.353027 697.376221,1421.627197 697.990845,1420.802246 
    C698.544006,1420.201050 698.816467,1419.698975 699.393677,1419.040039 
    C700.928467,1416.933960 702.158630,1414.984985 703.635315,1412.933838 
    C704.442627,1411.899292 705.003418,1410.966797 705.801941,1410.078979 
    C706.245239,1409.740112 706.450806,1409.356567 706.881897,1408.708740 
    C707.729309,1407.236572 708.351135,1406.028809 709.224548,1404.601196 
    C714.029968,1398.137573 718.583801,1391.893799 723.541138,1385.418213 
    C724.037720,1384.143799 724.130737,1383.101074 724.223755,1382.058472 
    C724.223694,1382.058472 724.043884,1382.045288 724.313354,1382.512695 
    C725.707520,1381.844604 726.832275,1380.709106 728.224854,1379.572021 
    C729.000427,1379.396484 729.508301,1379.222534 730.351318,1379.322998 
    C731.424255,1379.489258 732.161987,1379.381104 732.899780,1379.272827 
    C732.899780,1379.272827 732.911804,1379.096191 732.496948,1379.403687 
    C733.360901,1380.879395 734.639648,1382.047607 736.017334,1383.479736 
    C736.752441,1384.078003 737.388550,1384.412354 738.232971,1385.012695 
    C740.282288,1386.552612 742.123352,1387.826416 744.094299,1389.392822 
    C745.152100,1390.157715 746.080017,1390.630005 747.184692,1391.388916 
    C751.164490,1394.506226 754.862488,1397.495605 758.808350,1400.110962 
    C761.361816,1401.803467 762.330200,1403.130737 759.987122,1405.850708 
    C757.983826,1408.176270 756.520752,1410.967163 754.500977,1413.698975 
    C753.348267,1415.225220 752.513367,1416.604736 751.464294,1418.185303 
    C751.317871,1418.570312 751.385498,1418.754150 751.453125,1418.937866 
    C750.995911,1419.291626 750.538635,1419.645508 749.716064,1420.372559 
    C748.185730,1422.478271 747.020630,1424.210815 745.585571,1426.037354 
    C744.956055,1426.758667 744.596436,1427.385864 743.988281,1428.222778 
    C742.804016,1429.821655 741.868286,1431.211060 740.650269,1432.728760 
    C740.016235,1433.577881 739.664429,1434.298706 738.998901,1435.179077 
    C735.758362,1439.175781 732.831421,1443.013184 729.444702,1446.793335 
    C713.164795,1446.736206 697.344788,1446.736206 681.153992,1446.736206 
    C682.298157,1443.604858 683.167175,1441.226562 684.036255,1438.848145 
  z"/>
  <path fill="#A5A5A5" opacity="1.000000" stroke="none" 
    d="
  M619.731079,1447.863770 
    C605.756226,1447.863770 591.781372,1447.863770 577.031799,1447.863770 
    C577.031799,1413.215088 577.031799,1378.666138 577.316223,1343.576782 
    C577.600647,1343.036499 578.046387,1342.842407 578.046387,1342.842407 
    C578.046387,1342.842407 578.526794,1342.916382 578.563538,1343.387695 
    C578.524597,1376.821533 578.470032,1409.784302 578.338440,1442.746704 
    C578.326111,1445.825195 579.614502,1446.748779 582.546082,1446.716187 
    C592.867859,1446.601074 603.198364,1446.457153 613.511841,1446.771973 
    C618.099548,1446.911987 619.080750,1445.134888 619.062683,1440.956055 
    C618.928589,1409.987427 619.014587,1379.017944 618.929810,1348.048950 
    C618.924683,1346.168945 618.051392,1344.291382 617.974243,1342.280762 
    C619.199036,1344.038818 620.748230,1345.925537 620.757263,1347.819458 
    C620.907532,1379.250122 620.884399,1410.681641 620.816162,1442.112915 
    C620.811951,1444.030640 620.108887,1445.946899 619.731079,1447.863770 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M620.609802,1529.283325 
    C622.756531,1529.438843 624.903137,1529.728882 627.049927,1529.730103 
    C671.195129,1529.756470 715.340393,1529.749878 759.485596,1529.749878 
    C761.286682,1529.749878 763.087769,1529.749878 764.946533,1529.749878 
    C766.190613,1534.125244 766.291382,1537.017944 760.871094,1537.939819 
    C755.529419,1538.848145 750.367615,1540.813843 744.361145,1542.134033 
    C742.420837,1542.216431 741.246216,1542.480469 740.071655,1542.744629 
    C740.801147,1541.826050 741.374023,1540.327881 742.285278,1540.081665 
    C749.097778,1538.240234 755.985474,1536.678833 762.825378,1534.935059 
    C763.737854,1534.702393 764.514343,1533.936157 765.353760,1533.416992 
    C765.195129,1533.014038 765.036499,1532.611206 764.877869,1532.208252 
    C716.151550,1532.208252 667.425232,1532.208252 618.008118,1532.208252 
    C618.008118,1527.867798 618.008118,1523.945923 618.008118,1520.023926 
    C618.008118,1510.861328 617.961365,1501.698242 618.055542,1492.536621 
    C618.070740,1491.061157 618.714172,1489.591919 619.471069,1488.315918 
    C619.874939,1488.512085 619.805420,1488.851929 619.538879,1489.183594 
    C619.198608,1501.739258 619.086975,1513.963379 619.119568,1526.187134 
    C619.122314,1527.220459 620.090210,1528.251343 620.609802,1529.283325 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M739.649414,1542.851807 
    C741.246216,1542.480469 742.420837,1542.216431 743.946899,1542.077515 
    C734.537598,1545.194214 724.820679,1548.339355 715.006226,1551.143066 
    C698.298340,1555.915894 681.498474,1560.370605 664.842590,1565.313843 
    C663.477600,1565.718994 662.129761,1568.826172 662.106384,1570.694580 
    C661.893982,1587.648804 662.050171,1604.607422 661.926758,1621.563477 
    C661.894348,1626.019165 661.264587,1630.470703 660.500610,1634.879639 
    C659.783020,1634.235840 659.473999,1633.636597 659.164917,1633.037354 
    C659.135315,1632.834106 659.105652,1632.630981 659.386597,1631.823975 
    C659.828430,1611.136230 659.929810,1591.052002 660.132263,1570.968750 
    C660.155212,1568.694946 660.747742,1566.426880 661.076111,1564.156128 
    C666.783447,1562.233887 672.442139,1560.147583 678.211975,1558.435913 
    C683.804504,1556.776978 689.526428,1555.559448 695.164978,1554.048584 
    C707.437744,1550.760376 719.682678,1547.367920 731.965698,1544.118896 
    C734.323486,1543.495117 736.803467,1543.333740 739.649414,1542.851807 
  z"/>
  <path fill="#8F8F8F" opacity="1.000000" stroke="none" 
    d="
  M619.805420,1488.851929 
    C619.805420,1488.851929 619.874939,1488.512085 619.894409,1488.339844 
    C620.743286,1488.110596 621.572815,1488.003784 622.402283,1488.003784 
    C697.333313,1488.008911 772.264282,1488.022461 847.897278,1488.443237 
    C848.814026,1490.638794 849.209961,1492.426025 849.215393,1494.214233 
    C849.264343,1510.368286 849.176758,1526.522949 849.292297,1542.676270 
    C849.322083,1546.842651 849.511475,1550.879395 845.869873,1553.839233 
    C845.869873,1553.839233 845.538147,1553.918701 845.119751,1553.623413 
    C844.024231,1553.114136 843.347046,1552.900269 842.669861,1552.686279 
    C847.530090,1551.192993 847.925781,1547.605957 847.868347,1543.138550 
    C847.639587,1525.348511 847.774170,1507.553955 847.774170,1488.995361 
    C772.283447,1488.995361 697.154602,1488.995361 621.241089,1488.970215 
    C620.239441,1488.913940 620.022400,1488.882935 619.805420,1488.851929 
  z"/>
  <path fill="#C0C0C0" opacity="1.000000" stroke="none" 
    d="
  M624.302490,1697.336670 
    C623.974731,1698.057739 623.610596,1699.279419 622.792114,1699.855347 
    C595.487793,1719.068359 566.167236,1723.604492 534.479248,1711.464111 
    C538.786743,1712.063721 543.222778,1713.312134 547.744019,1713.870483 
    C555.312622,1714.805176 562.923889,1715.612427 570.538757,1715.897949 
    C579.500732,1716.234009 588.052673,1713.750122 596.206482,1710.283569 
    C605.598145,1706.291016 614.780823,1701.806885 624.302490,1697.336670 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M550.923035,1531.700928 
    C559.587952,1530.665405 568.252869,1529.629883 577.325073,1528.545654 
    C577.325073,1515.783691 577.325073,1502.579224 577.325073,1489.019531 
    C559.212708,1488.015747 541.616455,1490.190552 524.341858,1495.941895 
    C524.438782,1495.107544 524.731262,1494.632812 525.023743,1494.157959 
    C542.278687,1486.917236 560.384766,1487.735229 578.745605,1488.197754 
    C578.745605,1502.738647 578.745605,1516.969604 578.745605,1532.003174 
    C572.097778,1532.003174 565.366089,1531.925171 558.638062,1532.046753 
    C556.379272,1532.087646 554.129761,1532.636719 551.414368,1532.681152 
    C550.942871,1532.172852 550.932983,1531.936768 550.923035,1531.700928 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M677.972107,1701.994751 
    C686.676270,1688.249023 694.284424,1673.971069 697.915283,1657.967529 
    C699.710205,1650.056396 700.839783,1641.994629 702.564819,1634.077637 
    C703.191650,1635.093872 703.524109,1636.033447 703.856445,1636.973022 
    C703.307495,1640.430786 702.758545,1643.888550 701.814819,1647.894043 
    C701.564636,1649.287109 701.709351,1650.132446 701.854065,1650.977783 
    C700.549561,1656.598022 699.672974,1662.363403 697.828674,1667.800537 
    C695.679443,1674.136475 692.956970,1680.321655 689.963196,1686.312378 
    C687.846008,1690.549194 684.864380,1694.354004 681.783447,1698.827637 
    C680.189575,1700.200562 679.080872,1701.097656 677.972107,1701.994751 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M437.056366,1588.983643 
    C435.820251,1598.093018 433.772461,1607.183350 433.559662,1616.316528 
    C433.310699,1627.004517 434.679138,1637.728516 435.287018,1648.440308 
    C435.344940,1649.460938 434.984283,1650.505249 434.486664,1651.574097 
    C433.101990,1646.002441 431.667999,1640.432983 431.106628,1634.776978 
    C430.585907,1629.530884 430.754974,1624.178467 431.054901,1618.897583 
    C431.510773,1610.870239 432.278381,1602.857666 433.088959,1594.856567 
    C433.198425,1593.776123 434.325043,1592.798584 435.281616,1591.187256 
    C436.073822,1590.062012 436.565094,1589.522827 437.056366,1588.983643 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M443.142609,1413.684082 
    C450.983063,1424.117798 458.866333,1434.519775 466.646973,1444.997925 
    C470.874115,1450.690552 474.926727,1456.512817 478.818298,1462.650635 
    C478.360474,1463.034668 478.142395,1463.044678 477.924255,1463.054810 
    C470.618256,1453.781250 463.187775,1444.602173 456.053131,1435.198608 
    C451.801697,1429.595215 448.014893,1423.639526 443.880249,1417.149170 
    C443.541748,1415.532104 443.342163,1414.608032 443.142609,1413.684082 
  z"/>
  <path fill="#E6E6E6" opacity="1.000000" stroke="none" 
    d="
  M620.189087,1447.901123 
    C620.108887,1445.946899 620.811951,1444.030640 620.816162,1442.112915 
    C620.884399,1410.681641 620.907532,1379.250122 620.757263,1347.819458 
    C620.748230,1345.925537 619.199036,1344.038818 617.536743,1342.340576 
    C603.980225,1342.660278 591.253540,1342.788330 578.526794,1342.916382 
    C578.526794,1342.916382 578.046387,1342.842407 578.046387,1342.842407 
    C578.046387,1342.842407 577.600647,1343.036499 577.372803,1343.124756 
    C578.053589,1342.482422 578.956055,1341.124390 579.871765,1341.115479 
    C593.670471,1340.979736 607.470947,1341.021362 621.720215,1341.021362 
    C621.821899,1342.587402 621.994446,1344.010864 621.995056,1345.434448 
    C622.009949,1378.049927 622.024780,1410.665283 621.948059,1443.280640 
    C621.944397,1444.834229 621.100037,1446.385864 620.189087,1447.901123 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M498.029236,1461.101685 
    C502.870117,1459.229248 507.687012,1457.291016 512.561279,1455.509766 
    C515.322449,1454.500854 518.177795,1453.749756 521.870972,1452.611206 
    C518.209717,1447.353516 514.810486,1442.472168 511.676514,1437.252930 
    C512.242737,1437.006958 512.546997,1437.086304 512.854492,1437.152954 
    C516.440002,1441.197021 520.259521,1445.064575 523.505310,1449.365112 
    C524.972107,1451.308594 524.464172,1453.810059 521.530396,1454.781128 
    C516.318176,1456.506226 511.097778,1458.206299 505.885437,1459.930664 
    C503.900146,1460.587524 501.927490,1461.282593 499.337555,1461.890991 
    C498.493744,1461.581787 498.261475,1461.341797 498.029236,1461.101685 
  z"/>
  <path fill="#A5A5A5" opacity="1.000000" stroke="none" 
    d="
  M584.029907,1758.179443 
    C589.524353,1756.961914 595.123108,1756.085938 600.489136,1754.447632 
    C608.828552,1751.901123 617.009644,1748.836060 625.642761,1746.307373 
    C626.015686,1746.823120 626.003723,1747.022095 625.991699,1747.221191 
    C623.121277,1749.047485 620.470337,1751.768799 617.340332,1752.536255 
    C606.999939,1755.071045 596.486511,1756.900269 585.365662,1758.924805 
    C584.336853,1758.758789 584.116272,1758.535522 584.029907,1758.179443 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M492.853821,1411.280762 
    C485.053772,1400.715820 477.253723,1390.150879 469.217651,1379.029297 
    C468.987061,1378.037354 468.992462,1377.601929 468.997864,1377.166504 
    C473.696655,1382.965210 478.420471,1388.743774 483.084229,1394.570557 
    C485.637939,1397.760986 488.176971,1400.970703 490.548431,1404.296021 
    C491.598816,1405.768921 492.217621,1407.549561 493.021240,1409.910645 
    C492.957977,1410.847534 492.905884,1411.064087 492.853821,1411.280762 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M703.011841,1592.996704 
    C703.973145,1591.854980 704.732727,1590.032104 705.927429,1589.678223 
    C716.658997,1586.498779 727.466980,1583.577515 738.520325,1580.908081 
    C737.872192,1581.768799 736.956238,1582.302002 736.040405,1582.835083 
    C735.274780,1583.549194 734.509155,1584.263306 733.354126,1584.646484 
    C731.654968,1584.489868 730.345215,1584.664185 729.035522,1584.838379 
    C724.961426,1586.222534 720.887329,1587.606812 716.310059,1588.783203 
    C715.540588,1588.667114 715.274414,1588.759155 715.008179,1588.851074 
    C713.169250,1589.575806 711.323792,1590.284424 709.493286,1591.030029 
    C707.917419,1591.671875 706.358643,1592.355591 704.182434,1593.023682 
    C703.385620,1593.016357 703.198730,1593.006470 703.011841,1592.996704 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M797.025085,1564.847412 
    C797.624634,1564.711182 798.224243,1564.574951 799.489258,1564.569336 
    C801.442139,1564.098999 802.729675,1563.497925 804.017151,1562.896851 
    C804.622742,1562.760864 805.228394,1562.624878 806.497925,1562.605225 
    C808.441284,1562.147339 809.720764,1561.572998 811.000183,1560.998657 
    C811.633240,1560.868164 812.266296,1560.737549 813.596313,1560.707764 
    C815.867981,1560.171875 817.442688,1559.535034 819.017456,1558.898315 
    C819.360291,1558.812134 819.703064,1558.725952 820.685852,1558.755005 
    C822.886658,1558.230469 824.447449,1557.590454 826.008301,1556.950562 
    C826.632324,1556.807617 827.256348,1556.664551 828.503418,1556.710449 
    C829.485168,1557.210571 829.843811,1557.521851 830.202515,1557.833008 
    C826.572327,1559.225098 823.019348,1560.885376 819.296936,1561.957153 
    C809.541504,1564.766113 799.718140,1567.341187 789.906433,1569.951660 
    C788.201721,1570.405273 786.422058,1570.577271 783.875000,1570.952148 
    C782.476257,1570.845215 781.879456,1570.665405 781.477722,1570.250488 
    C781.785217,1569.627686 781.897644,1569.240112 782.010010,1568.852539 
    C782.614807,1568.710938 783.219666,1568.569336 784.490479,1568.555176 
    C786.438599,1568.115967 787.720703,1567.549316 789.002808,1566.982666 
    C789.911377,1566.794067 790.819824,1566.605347 792.436279,1566.537598 
    C794.437805,1566.054810 795.731445,1565.451050 797.025085,1564.847412 
  z"/>
  <path fill="#CFCFCF" opacity="1.000000" stroke="none" 
    d="
  M754.818665,1413.552246 
    C756.520752,1410.967163 757.983826,1408.176270 759.987122,1405.850708 
    C762.330200,1403.130737 761.361816,1401.803467 758.808350,1400.110962 
    C754.862488,1397.495605 751.164490,1394.506226 747.077759,1391.086060 
    C746.487854,1389.704956 746.181580,1388.913208 745.875244,1388.121460 
    C751.647400,1392.110229 757.580811,1395.898071 763.039734,1400.277344 
    C763.997131,1401.045410 763.637756,1404.676636 762.708740,1406.319702 
    C760.789490,1409.714111 758.076965,1412.660034 755.344849,1415.516357 
    C754.938843,1414.678833 754.878723,1414.115601 754.818665,1413.552246 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M474.673035,1636.068237 
    C472.445343,1623.111328 473.316406,1610.379150 477.656311,1597.664307 
    C476.946899,1603.375000 475.545410,1609.278931 475.226929,1615.240601 
    C474.871216,1621.899902 475.498260,1628.611816 475.567474,1635.716309 
    C475.176971,1636.178101 474.922211,1636.156860 474.673035,1636.068237 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M846.253784,1553.794922 
    C849.511475,1550.879395 849.322083,1546.842651 849.292297,1542.676270 
    C849.176758,1526.522949 849.264343,1510.368286 849.215393,1494.214233 
    C849.209961,1492.426025 848.814026,1490.638794 848.370667,1488.510254 
    C848.752625,1488.865601 849.893127,1489.559082 849.896606,1490.258179 
    C849.994263,1510.014160 850.045959,1529.771484 849.835266,1549.525635 
    C849.820129,1550.945190 847.751526,1552.342773 846.253784,1553.794922 
  z"/>
  <path fill="#EFEFEF" opacity="1.000000" stroke="none" 
    d="
  M660.637085,1564.113770 
    C660.747742,1566.426880 660.155212,1568.694946 660.132263,1570.968750 
    C659.929810,1591.052002 659.828430,1611.136230 659.434326,1631.519531 
    C659.113098,1610.170532 659.039673,1588.521973 659.047546,1566.873535 
    C659.047913,1565.939453 659.797546,1565.005493 660.637085,1564.113770 
  z"/>
  <path fill="#9C9C9C" opacity="1.000000" stroke="none" 
    d="
  M683.719482,1439.000732 
    C683.167175,1441.226562 682.298157,1443.604858 681.153992,1446.736206 
    C697.344788,1446.736206 713.164795,1446.736206 729.494141,1447.036499 
    C730.003479,1447.336792 730.004150,1447.833008 730.004150,1447.833008 
    C712.962646,1447.833008 695.921082,1447.833008 677.215088,1447.833008 
    C679.813782,1444.187744 681.608215,1441.670532 683.719482,1439.000732 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M453.253479,1696.556152 
    C458.393951,1702.875977 463.534454,1709.195801 468.203430,1715.766602 
    C467.143250,1716.023315 466.554535,1716.029175 465.965851,1716.035034 
    C465.965851,1716.035034 466.000000,1716.000000 466.010864,1715.669312 
    C465.337250,1714.904297 464.652740,1714.469971 463.968262,1714.035522 
    C463.968262,1714.035522 463.999176,1714.004883 464.039978,1713.690918 
    C463.435791,1712.548706 462.790802,1711.720581 462.145813,1710.892334 
    C459.445526,1707.586304 456.745178,1704.280396 454.017395,1700.229248 
    C453.744446,1698.507935 453.498993,1697.532104 453.253479,1696.556152 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M723.137573,1385.649902 
    C718.583801,1391.893799 714.029968,1398.137573 709.181702,1404.411621 
    C708.887268,1404.442017 708.812073,1404.060791 708.812073,1404.060791 
    C713.324341,1397.460938 717.836609,1390.860962 722.703613,1384.515137 
    C723.084778,1385.062622 723.111145,1385.356323 723.137573,1385.649902 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M494.096069,1737.815430 
    C501.666656,1741.661865 509.237244,1745.508423 516.628784,1749.649048 
    C515.260376,1749.641357 514.070923,1749.339722 512.881470,1749.037964 
    C512.881470,1749.037964 512.427246,1748.973267 512.039246,1748.636963 
    C510.726624,1747.879272 509.801971,1747.457886 508.877319,1747.036499 
    C503.396545,1745.707397 498.234070,1743.797974 494.254578,1738.744873 
    C494.000702,1738.143921 494.048370,1737.979614 494.096069,1737.815430 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M437.194153,1588.710938 
    C436.565094,1589.522827 436.073822,1590.062012 435.372772,1590.789551 
    C436.993622,1584.011597 438.448761,1576.915527 440.791229,1570.125610 
    C442.272034,1565.833618 445.077240,1561.998657 447.613770,1558.139160 
    C448.024078,1558.899292 448.108978,1559.478882 448.193909,1560.058350 
    C447.984192,1560.478394 447.774445,1560.898560 447.108215,1561.735962 
    C446.468719,1562.832153 446.285736,1563.510864 446.102722,1564.189697 
    C445.854095,1564.960327 445.605499,1565.731079 444.852509,1566.890991 
    C443.379669,1569.727905 442.411194,1572.175659 441.442719,1574.623291 
    C441.275940,1575.536865 441.109131,1576.450439 440.400757,1577.748291 
    C439.717499,1578.958862 439.575867,1579.785400 439.434265,1580.611816 
    C439.530731,1580.934326 439.518219,1581.252441 438.911652,1581.940186 
    C438.100006,1583.750732 437.773468,1585.187378 437.446930,1586.623901 
    C437.408600,1587.228760 437.370270,1587.833496 437.194153,1588.710938 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M507.876953,1551.947388 
    C514.619507,1547.592529 521.362000,1543.237671 528.570923,1538.963379 
    C529.037231,1539.043701 529.220947,1539.237549 529.155151,1539.378784 
    C529.089417,1539.520020 529.039368,1539.827637 529.039307,1539.827637 
    C524.492249,1542.559937 519.935303,1545.276367 515.409668,1548.043823 
    C514.799255,1548.417236 514.345703,1549.047119 513.167603,1549.753540 
    C512.018372,1550.645264 511.521057,1551.341553 511.023743,1552.037964 
    C511.023773,1552.037964 510.998596,1552.000000 510.627869,1551.924072 
    C509.463745,1551.881226 508.670349,1551.914307 507.876953,1551.947388 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M640.954529,1681.881104 
    C635.975830,1686.676392 630.997131,1691.471558 625.874817,1696.137939 
    C626.266296,1694.936890 626.531494,1693.279663 627.380493,1692.887939 
    C632.542908,1690.505981 634.682434,1685.382202 638.209534,1681.534302 
    C638.570801,1681.140015 639.381775,1681.157837 640.404297,1681.235107 
    C640.824585,1681.485840 640.954529,1681.881104 640.954529,1681.881104 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M511.303772,1696.910400 
    C509.454865,1696.257568 507.436066,1695.253784 505.163330,1693.660645 
    C504.377838,1692.685181 503.846252,1692.298950 503.314697,1691.912720 
    C502.955811,1691.765503 502.596893,1691.618408 502.086426,1690.888184 
    C501.321045,1689.869385 500.707214,1689.433594 500.093384,1688.997803 
    C498.079681,1686.894165 496.065918,1684.790649 494.228485,1682.207520 
    C494.591644,1681.387329 494.778473,1681.046875 494.965302,1680.706299 
    C500.354828,1685.990723 505.744354,1691.275146 511.303772,1696.910400 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M482.923553,1518.443726 
    C478.166229,1522.950806 473.408936,1527.457886 468.312744,1531.781738 
    C467.961517,1531.380737 467.949127,1531.162964 467.936768,1530.945312 
    C472.713593,1526.028687 477.490448,1521.112061 482.662231,1516.381104 
    C483.012604,1517.192383 482.968079,1517.818115 482.923553,1518.443726 
  z"/>
  <path fill="#E2E2E2" opacity="1.000000" stroke="none" 
    d="
  M507.602692,1552.129883 
    C508.670349,1551.914307 509.463745,1551.881226 510.645142,1551.938477 
    C505.062775,1558.099731 499.092438,1564.170776 492.727173,1570.006592 
    C492.236298,1569.540405 492.140350,1569.309692 492.044434,1569.079102 
    C492.312256,1568.540161 492.580078,1568.001099 493.417938,1567.262939 
    C494.324768,1566.374512 494.661560,1565.685303 494.998322,1564.996094 
    C496.050171,1563.711670 497.102051,1562.427124 498.765656,1560.981812 
    C500.276855,1559.626099 501.176331,1558.431152 502.075745,1557.236206 
    C503.826599,1555.594971 505.577484,1553.953735 507.602692,1552.129883 
  z"/>
  <path fill="#E6E6E6" opacity="1.000000" stroke="none" 
    d="
  M583.665527,1758.152344 
    C584.116272,1758.535522 584.336853,1758.758789 584.925171,1758.929199 
    C584.441528,1759.678955 583.731201,1760.923828 583.006653,1760.932129 
    C572.754700,1761.051025 562.500610,1761.025757 552.247864,1760.939819 
    C551.566223,1760.934204 550.890991,1760.156738 550.257874,1759.287720 
    C550.529480,1758.610474 550.755981,1758.383423 550.982422,1758.156372 
    C551.706482,1758.186523 552.430542,1758.216797 553.671997,1758.691406 
    C562.218140,1759.384033 570.246094,1759.682495 578.276672,1759.814087 
    C579.224426,1759.829590 580.187256,1758.929565 581.143127,1758.454102 
    C581.862488,1758.344360 582.581787,1758.234741 583.665527,1758.152344 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M740.994812,1580.344604 
    C748.640686,1578.205688 756.286621,1576.066772 764.652100,1573.988770 
    C765.588501,1574.091187 765.805298,1574.132446 766.015625,1574.338867 
    C766.009155,1574.504028 765.999512,1574.834229 765.999512,1574.834229 
    C764.912170,1575.211914 763.824768,1575.589478 762.235718,1575.836060 
    C760.832764,1576.083008 759.931396,1576.460938 759.030090,1576.838867 
    C757.893066,1577.193481 756.755981,1577.547974 755.066284,1577.660400 
    C753.355896,1577.890015 752.198059,1578.361694 751.040283,1578.833496 
    C749.937927,1579.211670 748.835571,1579.589844 747.227783,1579.836670 
    C745.825867,1580.082642 744.929321,1580.459839 744.032837,1580.837158 
    C743.287231,1581.141968 742.541626,1581.446777 741.449585,1581.614014 
    C741.067017,1581.099121 741.030945,1580.721924 740.994812,1580.344604 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M659.899780,1722.787476 
    C662.183411,1720.317505 664.466980,1717.847534 667.379028,1715.191162 
    C668.686096,1714.029053 669.364624,1713.053467 670.043213,1712.077881 
    C670.043213,1712.077881 670.000549,1712.016846 670.359253,1711.985107 
    C671.135559,1711.280396 671.553162,1710.607544 671.970825,1709.934570 
    C671.963318,1709.570801 672.113708,1709.292358 672.963257,1708.958496 
    C674.241333,1708.455811 674.978088,1708.093506 675.819092,1707.827393 
    C675.923340,1707.923584 676.133423,1708.113770 676.133423,1708.113770 
    C670.953735,1713.706787 665.774048,1719.299927 660.275024,1724.656982 
    C659.937012,1723.876343 659.918396,1723.331909 659.899780,1722.787476 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M524.610168,1494.087158 
    C524.731262,1494.632812 524.438782,1495.107544 524.054688,1495.845459 
    C523.746155,1496.359985 523.471558,1496.485229 522.522400,1496.338135 
    C520.582031,1496.870728 519.258545,1497.549316 517.935059,1498.227783 
    C517.204102,1498.496460 516.473145,1498.765015 515.072449,1499.046143 
    C511.587952,1500.588135 508.773102,1502.117432 505.958252,1503.646729 
    C505.639221,1503.835205 505.320129,1504.023560 504.324646,1504.150391 
    C502.871429,1504.178101 502.094574,1504.267578 501.207703,1504.233643 
    C501.097626,1504.110352 500.878967,1503.862427 500.878967,1503.862427 
    C508.651520,1500.580444 516.424072,1497.298462 524.610168,1494.087158 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M730.386536,1447.898926 
    C730.004150,1447.833008 730.003479,1447.336792 729.953979,1447.093628 
    C732.831421,1443.013184 735.758362,1439.175781 739.265747,1435.177734 
    C740.199646,1434.981079 740.553040,1434.945190 740.955811,1434.958740 
    C741.005188,1435.008301 741.102661,1435.108521 741.102661,1435.108521 
    C738.918152,1440.406738 735.881897,1445.020386 730.386536,1447.898926 
  z"/>
  <path fill="#C0C0C0" opacity="1.000000" stroke="none" 
    d="
  M702.908325,1593.455811 
    C703.198730,1593.006470 703.385620,1593.016357 703.852051,1593.051147 
    C704.082092,1607.399780 704.032654,1621.723511 703.919800,1636.510254 
    C703.524109,1636.033447 703.191650,1635.093872 702.768555,1633.774902 
    C702.720093,1620.235229 702.762451,1607.075073 702.908325,1593.455811 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M653.123901,1662.234863 
    C650.728149,1666.795776 648.332397,1671.356689 645.344604,1675.935791 
    C644.560913,1675.917480 644.369141,1675.880859 644.177490,1675.844360 
    C646.000000,1671.834351 647.769348,1667.798828 649.674316,1663.828247 
    C650.327087,1662.467651 651.319519,1661.270020 652.584961,1659.999146 
    C653.013062,1660.000366 653.129761,1660.084351 653.093506,1660.442749 
    C653.079407,1661.279053 653.101624,1661.756958 653.123901,1662.234863 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M519.286926,1703.897949 
    C519.067200,1703.825806 518.847473,1703.753540 518.310730,1703.231445 
    C517.671021,1702.242432 517.348389,1701.703369 517.025818,1701.164429 
    C521.254150,1703.150146 525.529724,1705.043457 529.686890,1707.168335 
    C531.299316,1707.992432 532.644165,1709.340210 534.320007,1710.820068 
    C534.275696,1711.257446 534.022278,1711.324341 533.234985,1710.920410 
    C531.361938,1710.017822 530.022705,1709.586182 528.683472,1709.154541 
    C528.283813,1709.089111 527.884216,1709.023682 527.194092,1708.416992 
    C526.139465,1707.647217 525.375305,1707.418579 524.611145,1707.190063 
    C523.865662,1706.817749 523.120178,1706.445557 522.037720,1705.579590 
    C520.896179,1704.689819 520.091553,1704.293945 519.286926,1703.897949 
  z"/>
  <path fill="#D5D5D5" opacity="1.000000" stroke="none" 
    d="
  M691.126831,1430.278809 
    C689.828674,1432.002075 688.530518,1433.725464 686.870178,1435.673584 
    C686.507935,1435.898438 686.197571,1435.854492 686.197571,1435.854492 
    C686.495239,1434.350220 686.370728,1432.555176 687.169128,1431.395752 
    C689.650574,1427.792847 692.482117,1424.431030 695.590271,1420.989380 
    C696.002686,1421.002930 696.112183,1421.107300 696.082275,1421.469727 
    C696.077332,1422.315308 696.102356,1422.798706 696.127319,1423.281982 
    C695.362732,1424.421265 694.598145,1425.560425 693.235107,1426.972168 
    C692.133362,1428.256104 691.630127,1429.267456 691.126831,1430.278809 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M441.299011,1672.529297 
    C443.728821,1677.468384 446.158630,1682.407593 448.293854,1687.705566 
    C447.372528,1687.947021 446.745758,1687.829712 446.119019,1687.712402 
    C446.119019,1687.712280 446.010529,1687.509033 446.043030,1686.985718 
    C444.375092,1683.322998 442.674652,1680.183594 440.974182,1677.044189 
    C440.974182,1677.044189 440.982086,1677.016724 441.029144,1676.566162 
    C441.150482,1674.920288 441.224731,1673.724731 441.299011,1672.529297 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M459.139587,1543.041382 
    C459.099182,1543.213257 459.058746,1543.385254 458.535339,1543.798096 
    C457.702271,1544.693970 457.352112,1545.348999 457.001953,1546.004028 
    C455.671967,1548.129517 454.341980,1550.255127 452.501221,1552.653809 
    C451.352264,1553.529541 450.714142,1554.132324 450.076050,1554.735229 
    C450.332306,1549.235474 454.303741,1545.842285 457.812103,1542.075317 
    C458.567780,1542.500732 458.853668,1542.771118 459.139587,1543.041382 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M477.948395,1463.433594 
    C478.142395,1463.044678 478.360474,1463.034668 478.904968,1462.997314 
    C480.971771,1464.226074 482.712189,1465.482422 485.119080,1466.837158 
    C486.910767,1466.628418 488.035980,1466.321289 489.161194,1466.014160 
    C486.993805,1467.302246 484.537170,1469.911987 482.738007,1469.518188 
    C480.824860,1469.099365 479.534698,1465.834473 477.948395,1463.433594 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M512.926880,1436.764893 
    C512.546997,1437.086304 512.242737,1437.006958 511.706238,1436.917236 
    C509.644623,1434.603638 507.818604,1432.287842 505.949341,1429.254028 
    C505.616425,1427.273682 505.326691,1426.011230 505.036957,1424.748901 
    C507.691040,1428.624878 510.345123,1432.500854 512.926880,1436.764893 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M492.344086,1679.937012 
    C490.254333,1676.857788 488.164551,1673.778442 486.261414,1670.206055 
    C486.620758,1669.382324 486.793488,1669.051758 486.966217,1668.721313 
    C489.641266,1672.344116 492.316284,1675.966797 494.615997,1679.901123 
    C493.608490,1680.120728 492.976288,1680.028809 492.344086,1679.937012 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M441.335938,1672.259277 
    C441.224731,1673.724731 441.150482,1674.920288 441.015533,1676.562378 
    C438.160217,1670.620850 435.170502,1664.290649 435.300842,1656.840088 
    C435.807098,1657.281860 436.053223,1657.993652 436.299377,1658.705566 
    C436.704346,1659.311768 437.109253,1659.917969 437.361420,1661.300293 
    C437.870483,1663.400879 438.532288,1664.725586 439.194061,1666.050171 
    C439.429504,1666.270020 439.547577,1666.541016 439.383423,1667.446533 
    C439.804535,1669.017822 440.390564,1670.006104 440.976562,1670.994263 
    C441.108673,1671.325928 441.240784,1671.657715 441.335938,1672.259277 
  z"/>
  <path fill="#A5A5A5" opacity="1.000000" stroke="none" 
    d="
  M550.671509,1757.945679 
    C550.755981,1758.383423 550.529480,1758.610474 550.065674,1758.919189 
    C546.479431,1758.668335 543.130493,1758.335571 539.378235,1757.619019 
    C538.978027,1756.839111 538.981140,1756.443115 538.984314,1756.047119 
    C542.776367,1756.609741 546.568481,1757.172363 550.671509,1757.945679 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M656.292114,1653.503052 
    C656.123291,1654.449463 655.954529,1655.395874 655.277466,1656.718384 
    C654.222778,1658.091064 653.676270,1659.087769 653.129761,1660.084351 
    C653.129761,1660.084351 653.013062,1660.000366 652.955566,1659.957275 
    C654.261780,1654.839600 655.625427,1649.764893 657.327271,1644.574951 
    C657.900269,1645.166626 658.135071,1645.873535 658.369873,1646.580566 
    C658.202209,1647.819336 658.034607,1649.058228 657.339233,1650.713257 
    C656.638367,1651.920654 656.465210,1652.711914 656.292114,1653.503052 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M446.063599,1688.110840 
    C446.745758,1687.829712 447.372528,1687.947021 448.317200,1688.058350 
    C449.452820,1689.364502 450.270599,1690.676636 451.082397,1692.666138 
    C451.729706,1694.228027 452.383026,1695.112671 453.036377,1695.997314 
    C453.036346,1695.997314 453.293762,1696.218994 453.273651,1696.387573 
    C453.498993,1697.532104 453.744446,1698.507935 453.995758,1699.868774 
    C451.337128,1696.338867 448.672699,1692.424072 446.063599,1688.110840 
  z"/>
  <path fill="#C0C0C0" opacity="1.000000" stroke="none" 
    d="
  M487.947601,1574.878418 
    C488.382263,1574.001587 488.816956,1573.124756 489.862793,1572.115479 
    C490.927368,1571.987061 491.380768,1571.990967 491.834229,1571.994873 
    C489.819824,1575.673096 487.805389,1579.351196 485.287415,1582.861816 
    C484.509888,1582.458862 484.235870,1582.223511 483.961884,1581.988037 
    C484.650299,1580.520020 485.338684,1579.051880 486.537720,1577.230713 
    C487.348083,1576.211060 487.647858,1575.544800 487.947601,1574.878418 
  z"/>
  <path fill="#D5D5D5" opacity="1.000000" stroke="none" 
    d="
  M708.425049,1404.018311 
    C708.812073,1404.060791 708.887268,1404.442017 708.930115,1404.631592 
    C708.351135,1406.028809 707.729309,1407.236572 706.534180,1408.897217 
    C705.828674,1409.578247 705.696472,1409.806274 705.564209,1410.034424 
    C705.003418,1410.966797 704.442627,1411.899292 703.294678,1413.015747 
    C701.841553,1413.533813 700.975525,1413.867920 700.109558,1414.202026 
    C702.752441,1410.793335 705.395264,1407.384644 708.425049,1404.018311 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M472.065796,1722.120361 
    C472.880646,1721.739380 473.648010,1721.737061 474.712585,1722.395752 
    C475.586273,1723.390747 476.162781,1723.724609 476.739288,1724.058350 
    C477.048065,1724.253296 477.356842,1724.448120 477.841766,1725.191895 
    C478.671295,1726.165161 479.324677,1726.589478 479.978088,1727.013672 
    C479.978119,1727.013672 479.999847,1727.000000 479.987488,1727.375000 
    C480.115753,1728.468506 480.256409,1729.186890 480.397064,1729.905396 
    C477.604156,1727.436523 474.811249,1724.967773 472.065796,1722.120361 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M498.005188,1508.143311 
    C497.601074,1508.450439 497.196960,1508.757568 496.189209,1509.074707 
    C494.741486,1509.759277 493.897339,1510.433960 493.053162,1511.108765 
    C493.053192,1511.108765 493.018921,1511.025269 492.724182,1511.020020 
    C491.985321,1511.054688 491.541168,1511.094604 491.049377,1511.073975 
    C491.001678,1511.013306 490.904022,1510.893677 490.903992,1510.893677 
    C493.981903,1508.584717 497.059784,1506.275757 500.508331,1503.914673 
    C500.878967,1503.862427 501.097626,1504.110352 501.059204,1504.508545 
    C500.015594,1505.985474 499.010406,1507.064331 498.005188,1508.143311 
  z"/>
  <path fill="#CFCFCF" opacity="1.000000" stroke="none" 
    d="
  M743.964355,1389.100098 
    C742.123352,1387.826416 740.282288,1386.552612 738.232300,1384.683105 
    C737.966858,1383.430298 737.910400,1382.773193 737.853943,1382.115967 
    C740.249451,1383.818359 742.644958,1385.520752 744.857422,1387.719727 
    C744.437683,1388.510986 744.200989,1388.805542 743.964355,1389.100098 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M497.673431,1461.109619 
    C498.261475,1461.341797 498.493744,1461.581787 498.969147,1461.909180 
    C496.386322,1463.323364 493.560333,1464.650269 490.316467,1465.628418 
    C489.850983,1465.097168 489.803375,1464.914795 489.755737,1464.732544 
    C489.755737,1464.732544 489.945709,1465.014160 490.148376,1464.953613 
    C490.921295,1464.403564 491.491577,1463.913818 492.061890,1463.424072 
    C493.813843,1462.655396 495.565735,1461.886475 497.673431,1461.109619 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M677.734009,1702.176270 
    C679.080872,1701.097656 680.189575,1700.200562 681.574341,1699.132324 
    C680.145264,1701.890991 678.440186,1704.820923 676.434265,1707.932251 
    C676.133423,1708.113770 675.923340,1707.923584 675.896667,1707.468994 
    C675.880676,1706.274414 675.891357,1705.534424 675.902100,1704.794434 
    C676.433350,1703.982178 676.964600,1703.169922 677.734009,1702.176270 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M449.807312,1554.908936 
    C450.714142,1554.132324 451.352264,1553.529541 452.271973,1552.918823 
    C451.305054,1555.228882 450.056549,1557.546753 448.500977,1559.961548 
    C448.108978,1559.478882 448.024078,1558.899292 447.985291,1558.052246 
    C448.533783,1556.884033 449.036163,1555.983276 449.807312,1554.908936 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M447.989471,1393.122437 
    C446.011292,1394.420654 444.033112,1395.718872 441.785187,1396.633667 
    C443.786743,1394.172241 446.058014,1392.094238 448.655731,1390.388184 
    C448.651276,1391.547607 448.320374,1392.334961 447.989471,1393.122437 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M440.977661,1677.419434 
    C442.674652,1680.183594 444.375092,1683.322998 446.037384,1686.870728 
    C444.326538,1684.117554 442.653839,1680.956177 440.977661,1677.419434 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M740.932617,1432.600342 
    C741.868286,1431.211060 742.804016,1429.821655 744.318481,1428.222168 
    C745.557251,1427.982910 746.217224,1427.953857 746.877197,1427.924805 
    C745.196411,1430.288696 743.515564,1432.652588 741.468689,1435.062500 
    C741.102661,1435.108521 741.005188,1435.008301 740.983582,1434.575684 
    C740.952148,1433.628784 740.942383,1433.114502 740.932617,1432.600342 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M512.937317,1749.427368 
    C514.070923,1749.339722 515.260376,1749.641357 516.820740,1749.926514 
    C517.911499,1750.020874 518.631348,1750.131958 519.726624,1750.696533 
    C520.725464,1751.712280 521.348816,1752.274536 521.972229,1752.836792 
    C518.979187,1751.830078 515.986206,1750.823486 512.937317,1749.427368 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M456.987732,1386.779663 
    C456.574249,1387.144897 456.160767,1387.510254 455.124115,1387.962891 
    C453.717682,1388.790039 452.934418,1389.530029 452.151123,1390.269897 
    C452.151123,1390.269897 452.142059,1390.159668 451.794067,1390.115234 
    C450.909729,1390.026489 450.373413,1389.982422 449.837097,1389.938354 
    C452.610107,1387.952148 455.383148,1385.965942 458.579102,1384.254639 
    C459.026428,1384.724243 459.050842,1384.919312 459.075287,1385.114380 
    C459.075287,1385.114380 459.051331,1385.016724 458.773499,1385.046997 
    C457.993011,1385.644775 457.490356,1386.212158 456.987732,1386.779663 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M745.855469,1425.943359 
    C747.020630,1424.210815 748.185730,1422.478271 749.688232,1420.608398 
    C752.733215,1423.822876 749.058838,1425.018921 747.295288,1426.840698 
    C746.473022,1426.412720 746.164246,1426.178101 745.855469,1425.943359 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M480.449158,1729.952881 
    C480.256409,1729.186890 480.115753,1728.468506 479.980804,1727.385254 
    C481.988403,1728.442139 483.990295,1729.863525 485.663025,1731.640381 
    C484.547699,1732.009888 483.761444,1732.024048 482.975220,1732.038208 
    C482.975220,1732.038208 482.998749,1732.000000 482.980103,1731.652588 
    C482.187531,1730.861572 481.413605,1730.417725 480.639679,1729.973999 
    C480.639679,1729.973999 480.501221,1730.000366 480.449158,1729.952881 
  z"/>
  <path fill="#C0C0C0" opacity="1.000000" stroke="none" 
    d="
  M480.528870,1589.256958 
    C481.133698,1587.722778 481.738586,1586.188721 482.820648,1584.348877 
    C483.817505,1583.976074 484.337158,1583.909180 484.856812,1583.842285 
    C483.839264,1586.232666 482.821686,1588.623047 481.316376,1590.598633 
    C480.728729,1589.874756 480.628815,1589.565796 480.528870,1589.256958 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M646.231323,1734.019653 
    C647.920166,1732.633667 649.608948,1731.247559 651.647705,1730.129883 
    C651.994324,1730.879028 651.990967,1731.359619 651.987549,1731.840332 
    C651.696777,1732.041382 651.406006,1732.242432 650.706665,1732.720947 
    C649.888489,1733.339722 649.478821,1733.681396 649.069214,1734.023071 
    C649.069214,1734.023071 649.051453,1734.056763 648.688965,1734.033936 
    C647.628113,1734.014038 646.929688,1734.016846 646.231323,1734.019653 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M538.660034,1755.909058 
    C538.981140,1756.443115 538.978027,1756.839111 538.968994,1757.531982 
    C538.468384,1757.571533 537.973511,1757.314087 536.959045,1756.731689 
    C534.954102,1755.770874 533.468872,1755.134888 531.983582,1754.499023 
    C534.100952,1754.922974 536.218384,1755.347046 538.660034,1755.909058 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M443.082764,1413.333252 
    C443.342163,1414.608032 443.541748,1415.532104 443.853821,1416.800049 
    C442.315704,1415.262573 440.665070,1413.381104 439.084351,1411.113892 
    C440.443817,1411.479370 441.733368,1412.230835 443.082764,1413.333252 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M505.023804,1424.614258 
    C505.326691,1426.011230 505.616425,1427.273682 505.880554,1428.927002 
    C504.188690,1427.147583 502.522461,1424.977051 501.096375,1422.496826 
    C501.915588,1422.449707 502.494690,1422.712524 503.073792,1422.975342 
    C503.073761,1422.975342 503.008575,1422.993408 503.141510,1423.233887 
    C503.813202,1423.728638 504.351929,1423.982666 504.890686,1424.236816 
    C504.890656,1424.236816 505.010651,1424.479492 505.023804,1424.614258 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M528.944824,1538.947388 
    C530.707214,1537.812134 532.562073,1536.773193 534.732971,1536.040527 
    C534.978271,1536.850098 534.907471,1537.353271 534.836670,1537.856445 
    C534.132935,1538.234985 533.429199,1538.613647 532.243774,1538.826904 
    C530.915039,1538.853516 530.067993,1539.045532 529.220947,1539.237549 
    C529.220947,1539.237549 529.037231,1539.043701 528.944824,1538.947388 
  z"/>
  <path fill="#C3C3C3" opacity="1.000000" stroke="none" 
    d="
  M645.885986,1734.134888 
    C646.929688,1734.016846 647.628113,1734.014038 648.674072,1734.045898 
    C647.202271,1735.387573 645.382935,1736.694702 643.178101,1737.941650 
    C643.708679,1736.671021 644.624695,1735.460571 645.885986,1734.134888 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M493.946442,1737.541748 
    C494.048370,1737.979614 494.000702,1738.143921 493.924713,1738.563232 
    C491.683197,1737.791260 489.470001,1736.764404 487.197388,1735.300415 
    C487.138000,1734.863281 487.395721,1734.600098 487.724731,1734.713745 
    C488.751831,1734.866211 489.449921,1734.904907 490.148010,1734.943726 
    C491.364258,1735.718384 492.580536,1736.493164 493.946442,1737.541748 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M483.238983,1518.408691 
    C482.968079,1517.818115 483.012604,1517.192383 482.984253,1516.260010 
    C482.911377,1515.953125 482.957977,1515.931030 483.236450,1515.904297 
    C483.744293,1515.628662 483.973633,1515.379761 484.203003,1515.130981 
    C484.203033,1515.130981 484.482178,1515.011719 485.004761,1515.003296 
    C486.702240,1514.670288 487.877106,1514.345703 489.051941,1514.021118 
    C487.219421,1515.471924 485.386902,1516.922729 483.238983,1518.408691 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M531.664062,1754.349854 
    C533.468872,1755.134888 534.954102,1755.770874 536.690308,1756.619995 
    C534.029053,1756.469971 531.116882,1756.106812 528.308716,1755.351074 
    C528.923279,1754.705444 529.433838,1754.452393 529.944336,1754.199341 
    C530.411072,1754.199829 530.877869,1754.200195 531.664062,1754.349854 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M659.553589,1722.845703 
    C659.918396,1723.331909 659.937012,1723.876343 659.971680,1724.831055 
    C659.973022,1725.526733 659.843689,1725.743896 659.162231,1726.011108 
    C658.488831,1726.365601 658.252869,1726.601807 658.016968,1726.838135 
    C657.142456,1727.191284 656.267944,1727.544434 654.988892,1727.625000 
    C656.125366,1725.869629 657.666382,1724.386841 659.553589,1722.845703 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M462.988464,1537.771973 
    C462.686218,1538.365479 462.384033,1538.959106 461.489807,1539.792725 
    C459.971863,1540.486084 459.045990,1540.939453 458.120148,1541.392822 
    C459.816589,1539.256104 461.513000,1537.119385 463.596252,1534.985840 
    C463.983093,1534.989258 464.044495,1535.066406 463.909576,1535.328613 
    C463.512573,1536.317871 463.250519,1537.044922 462.988464,1537.771973 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M476.871582,1647.916382 
    C476.627014,1646.873901 476.382446,1645.831543 476.379089,1644.396240 
    C476.620300,1644.003296 477.065887,1643.900513 477.065918,1643.900513 
    C477.701263,1645.667969 478.336609,1647.435425 478.641174,1649.627075 
    C478.138031,1650.091309 477.965668,1650.131348 477.793274,1650.171509 
    C477.793274,1650.171509 477.991394,1650.143066 477.969849,1649.904785 
    C477.589386,1649.083130 477.230499,1648.499756 476.871582,1647.916382 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M659.090820,1633.443359 
    C659.473999,1633.636597 659.783020,1634.235840 660.224365,1635.157959 
    C660.296143,1636.744263 660.235657,1638.007446 659.828857,1639.841064 
    C658.709106,1641.288696 657.935730,1642.166260 657.162354,1643.043701 
    C657.780518,1639.978882 658.398682,1636.914185 659.090820,1633.443359 
  z"/>
  <path fill="#D5D5D5" opacity="1.000000" stroke="none" 
    d="
  M699.088867,1419.196899 
    C698.816467,1419.698975 698.544006,1420.201050 697.721313,1420.810303 
    C696.818054,1420.980713 696.465149,1421.044067 696.112183,1421.107300 
    C696.112183,1421.107300 696.002686,1421.002930 695.947693,1420.950928 
    C697.043579,1418.968628 698.194397,1417.038208 699.661255,1415.321655 
    C699.681213,1416.755859 699.385071,1417.976440 699.088867,1419.196899 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M482.694885,1663.897949 
    C481.901276,1662.027710 481.107635,1660.157593 480.540192,1657.891602 
    C482.171722,1659.505737 483.577057,1661.515625 484.652008,1663.851318 
    C483.779358,1664.083984 483.237122,1663.990967 482.694885,1663.897949 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M480.316040,1589.522339 
    C480.628815,1589.565796 480.728729,1589.874756 480.930328,1590.660400 
    C480.579620,1592.660889 480.127258,1594.184937 479.377319,1595.890625 
    C479.420898,1593.977417 479.762054,1591.882568 480.316040,1589.522339 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M503.054993,1422.600464 
    C502.494690,1422.712524 501.915588,1422.449707 501.019592,1422.152588 
    C500.346100,1422.096069 500.107483,1421.916748 499.967987,1420.970825 
    C499.642822,1419.160645 499.336548,1417.959961 499.030243,1416.759399 
    C500.365540,1418.581421 501.700836,1420.403564 503.054993,1422.600464 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M492.893555,1411.510986 
    C492.905884,1411.064087 492.957977,1410.847534 493.049255,1410.299438 
    C495.027557,1411.812134 496.966766,1413.656250 498.560425,1415.777344 
    C497.366089,1415.716553 496.517303,1415.378662 495.668549,1415.040771 
    C495.392792,1415.006348 495.180969,1414.871460 494.994629,1414.128906 
    C494.419861,1413.067017 493.883453,1412.512451 493.347046,1411.957886 
    C493.347076,1411.957886 492.933258,1411.741211 492.893555,1411.510986 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M438.732239,1400.027588 
    C438.052002,1401.480469 437.371735,1402.933228 436.499756,1404.701904 
    C435.920776,1404.998169 435.533569,1404.978638 435.146362,1404.959106 
    C435.175873,1403.387939 435.205383,1401.816650 436.015869,1400.117920 
    C437.441986,1400.002686 438.087097,1400.015137 438.732239,1400.027588 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M489.290039,1513.996460 
    C487.877106,1514.345703 486.702240,1514.670288 485.155151,1514.982666 
    C486.578308,1513.632812 488.373688,1512.295166 490.536530,1510.925537 
    C490.904022,1510.893677 491.001678,1511.013306 490.893433,1511.327271 
    C490.560211,1512.181763 490.335236,1512.722168 490.110291,1513.262695 
    C490.056915,1513.614502 489.862854,1513.850952 489.290039,1513.996460 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M495.704529,1415.396240 
    C496.517303,1415.378662 497.366089,1415.716553 498.552124,1416.131470 
    C498.889374,1416.208496 499.010803,1416.471680 499.020508,1416.615479 
    C499.336548,1417.959961 499.642822,1419.160645 499.950012,1420.735840 
    C498.547455,1419.324097 497.143982,1417.537842 495.704529,1415.396240 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M657.114502,1643.260376 
    C657.935730,1642.166260 658.709106,1641.288696 659.727417,1640.209351 
    C659.610352,1642.054077 659.248291,1644.100708 658.628052,1646.364014 
    C658.135071,1645.873535 657.900269,1645.166626 657.410278,1644.185791 
    C657.155151,1643.911865 657.066589,1643.477051 657.114502,1643.260376 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M699.393616,1419.040039 
    C699.385071,1417.976440 699.681213,1416.755859 699.967285,1415.151611 
    C699.957153,1414.767700 699.985413,1414.469727 700.047485,1414.335938 
    C700.975525,1413.867920 701.841553,1413.533813 703.048218,1413.117920 
    C702.158630,1414.984985 700.928467,1416.933960 699.393616,1419.040039 
  z"/>
  <path fill="#CFCFCF" opacity="1.000000" stroke="none" 
    d="
  M735.918396,1383.215820 
    C734.639648,1382.047607 733.360901,1380.879395 732.410767,1379.423950 
    C734.174683,1379.831055 735.609924,1380.525391 736.853882,1381.736450 
    C736.414490,1382.574097 736.166443,1382.894897 735.918396,1383.215820 
  z"/>
  <path fill="#8F8F8F" opacity="1.000000" stroke="none" 
    d="
  M830.396851,1557.876709 
    C829.843811,1557.521851 829.485168,1557.210571 828.824463,1556.703613 
    C830.178650,1555.895996 831.834778,1555.284424 833.726440,1555.119385 
    C833.943237,1555.989868 833.924438,1556.413818 833.905640,1556.837891 
    C833.905640,1556.837891 833.594727,1556.939697 833.231934,1556.718018 
    C832.239441,1556.942017 831.609680,1557.387695 830.979858,1557.833496 
    C830.979858,1557.833374 830.591125,1557.920410 830.396851,1557.876709 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M439.031555,1399.913330 
    C438.087097,1400.015137 437.441986,1400.002686 436.314880,1399.961914 
    C437.533051,1398.631348 439.233246,1397.329224 441.357727,1396.108643 
    C440.964966,1397.393188 440.147949,1398.595947 439.031555,1399.913330 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M544.280518,1533.939331 
    C545.424194,1533.149902 546.959961,1532.392700 548.638428,1532.019775 
    C548.194580,1532.881592 547.608093,1533.359253 547.021667,1533.836914 
    C546.238647,1533.881836 545.455688,1533.926758 544.280518,1533.939331 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M644.050415,1676.177002 
    C644.369141,1675.880859 644.560913,1675.917480 645.023499,1676.065430 
    C643.995972,1677.924438 642.697632,1679.671997 641.176880,1681.650391 
    C640.954529,1681.881104 640.824585,1681.485840 640.769043,1681.285278 
    C641.783447,1679.559692 642.853455,1678.034790 644.050415,1676.177002 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M474.576477,1636.423828 
    C474.922211,1636.156860 475.176971,1636.178101 475.630676,1636.137939 
    C476.202454,1637.819214 476.580902,1639.494385 476.703430,1641.370728 
    C475.937653,1640.686768 475.427795,1639.801514 474.917908,1638.916260 
    C474.771912,1638.203979 474.625916,1637.491577 474.576477,1636.423828 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M635.498108,1740.776611 
    C636.472473,1740.091797 637.446899,1739.407104 638.712524,1738.992432 
    C638.984863,1739.795288 638.966064,1740.328125 638.947388,1740.860840 
    C638.517395,1741.495239 638.087402,1742.129639 637.293335,1742.473633 
    C636.452209,1741.714355 635.975159,1741.245483 635.498108,1740.776611 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M775.030151,1570.791260 
    C775.625916,1570.655518 776.221680,1570.519653 777.552002,1570.533447 
    C778.888062,1570.698853 779.489624,1570.714600 780.088867,1571.013672 
    C780.090332,1571.485474 780.094116,1571.674194 780.097900,1571.863037 
    C777.942261,1572.231201 775.786682,1572.599243 773.437500,1572.679443 
    C773.839355,1571.858154 774.434753,1571.324707 775.030151,1570.791260 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M474.779968,1639.234375 
    C475.427795,1639.801514 475.937653,1640.686768 476.640320,1641.756104 
    C476.891235,1642.375366 476.949371,1642.810303 477.036682,1643.572876 
    C477.065887,1643.900513 476.620300,1644.003296 476.391968,1643.991455 
    C475.656403,1642.503784 475.149200,1641.028198 474.779968,1639.234375 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M436.580597,1658.709473 
    C436.053223,1657.993652 435.807098,1657.281860 435.373596,1656.434570 
    C435.098877,1656.062500 435.062164,1655.818237 435.098022,1655.397217 
    C435.700592,1656.389893 436.281219,1657.551636 436.580597,1658.709473 
  z"/>
  <path fill="#8F8F8F" opacity="1.000000" stroke="none" 
    d="
  M835.642517,1554.667236 
    C837.257446,1554.015381 838.872314,1553.363403 840.734985,1553.149902 
    C840.974060,1554.003662 840.965393,1554.418701 840.956665,1554.833862 
    C840.956604,1554.833862 840.593140,1554.947632 840.157227,1554.719238 
    C838.361694,1554.549561 837.002075,1554.608398 835.642517,1554.667236 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M740.642944,1580.291748 
    C741.030945,1580.721924 741.067017,1581.099121 741.169800,1581.751709 
    C739.765076,1582.342041 738.293762,1582.657104 736.431396,1582.903564 
    C736.956238,1582.302002 737.872192,1581.768799 738.884583,1580.981934 
    C739.417664,1580.565063 739.854370,1580.401978 740.642944,1580.291748 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M458.072083,1541.452759 
    C459.045990,1540.939453 459.971863,1540.486084 461.197266,1539.966797 
    C460.906342,1540.898438 460.315887,1541.896118 459.432495,1542.967529 
    C458.853668,1542.771118 458.567780,1542.500732 458.165527,1541.947510 
    C458.049164,1541.664429 458.024017,1541.512695 458.072083,1541.452759 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M435.082275,1405.333862 
    C435.533569,1404.978638 435.920776,1404.998169 436.598755,1405.013916 
    C437.582611,1406.130981 438.275665,1407.252075 438.616638,1408.628906 
    C437.182465,1407.826050 436.100342,1406.767334 435.082275,1405.333862 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M537.078308,1535.278809 
    C538.244812,1534.687500 539.411316,1534.096069 540.706421,1533.875488 
    C540.223267,1534.777832 539.611511,1535.309204 538.999817,1535.840698 
    C538.999817,1535.840698 538.585205,1535.971191 538.154358,1535.925903 
    C537.422607,1535.771973 537.207581,1535.571411 537.078308,1535.278809 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M529.681152,1754.030273 
    C529.433838,1754.452393 528.923279,1754.705444 528.118042,1754.996094 
    C527.823364,1755.033691 527.423218,1754.982666 527.125977,1754.717163 
    C526.549622,1753.929077 526.270508,1753.406372 525.991394,1752.883789 
    C527.133545,1753.209595 528.275757,1753.535522 529.681152,1754.030273 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M525.702759,1752.642822 
    C526.270508,1753.406372 526.549622,1753.929077 526.934814,1754.652832 
    C525.687439,1754.505981 524.334045,1754.158081 523.138916,1753.341797 
    C523.596680,1752.742432 523.811401,1752.527100 523.941406,1752.227173 
    C524.432312,1752.285400 524.923279,1752.343750 525.702759,1752.642822 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M754.500977,1413.698975 
    C754.878723,1414.115601 754.938843,1414.678833 755.023804,1415.666260 
    C754.724121,1416.549438 754.399536,1417.008667 753.598145,1417.729248 
    C752.640381,1417.988281 752.159424,1417.986206 751.678467,1417.984253 
    C752.513367,1416.604736 753.348267,1415.225220 754.500977,1413.698975 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M449.644928,1389.966797 
    C450.373413,1389.982422 450.909729,1390.026489 451.844666,1390.137451 
    C451.050781,1391.162354 449.858246,1392.120728 448.327606,1393.100830 
    C448.320374,1392.334961 448.651276,1391.547607 449.034393,1390.442627 
    C449.086609,1390.125244 449.452759,1389.995239 449.644928,1389.966797 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M523.702026,1752.015015 
    C523.811401,1752.527100 523.596680,1752.742432 523.078613,1752.953979 
    C522.860046,1753.034668 522.407715,1752.973145 522.189941,1752.905029 
    C521.348816,1752.274536 520.725464,1751.712280 520.028076,1750.905762 
    C521.123596,1751.042114 522.293152,1751.422485 523.702026,1752.015015 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M835.364502,1554.663086 
    C837.002075,1554.608398 838.361694,1554.549561 839.967163,1554.731689 
    C838.362732,1555.558228 836.512451,1556.143921 834.283875,1556.783691 
    C833.924438,1556.413818 833.943237,1555.989868 833.986938,1555.248291 
    C834.369995,1554.840332 834.728210,1554.749634 835.364502,1554.663086 
  z"/>
  <path fill="#C0C0C0" opacity="1.000000" stroke="none" 
    d="
  M516.714233,1701.022583 
    C517.348389,1701.703369 517.671021,1702.242432 518.041382,1703.012695 
    C516.629456,1702.399414 515.169678,1701.554688 513.809204,1700.374634 
    C514.739868,1700.319702 515.571289,1700.600220 516.714233,1701.022583 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M467.584839,1530.976318 
    C467.949127,1531.162964 467.961517,1531.380737 468.001343,1531.924561 
    C467.329224,1533.173584 466.629608,1534.096558 465.315491,1535.046143 
    C464.482147,1535.070435 464.263336,1535.068359 464.044495,1535.066406 
    C464.044495,1535.066406 463.983093,1534.989258 463.951263,1534.951538 
    C465.023926,1533.611694 466.128387,1532.309448 467.584839,1530.976318 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M483.069031,1732.355713 
    C483.761444,1732.024048 484.547699,1732.009888 485.728455,1731.968140 
    C486.281036,1732.010254 486.439056,1732.079956 486.761902,1732.629150 
    C487.083069,1733.605957 487.239380,1734.103027 487.395691,1734.600098 
    C487.395721,1734.600098 487.138000,1734.863281 487.010010,1734.995605 
    C485.642273,1734.309814 484.402557,1733.491577 483.069031,1732.355713 
  z"/>
  <path fill="#CFCFCF" opacity="1.000000" stroke="none" 
    d="
  M727.957031,1379.573608 
    C726.832275,1380.709106 725.707520,1381.844604 724.319580,1382.602539 
    C725.103149,1380.808350 726.149963,1379.391602 727.597900,1377.988647 
    C727.999023,1378.002441 728.104675,1378.111450 728.068420,1378.353760 
    C727.966736,1378.918823 727.941650,1379.244629 727.957031,1379.573608 
  z"/>
  <path fill="#CFCFCF" opacity="1.000000" stroke="none" 
    d="
  M732.879150,1378.894775 
    C732.161987,1379.381104 731.424255,1379.489258 730.200684,1379.076660 
    C729.178162,1378.407593 728.641418,1378.259521 728.104675,1378.111450 
    C728.104675,1378.111450 727.999023,1378.002441 727.945435,1377.948730 
    C730.237610,1372.588013 731.135803,1378.845459 732.879150,1378.894775 
  z"/>
  <path fill="#8F8F8F" opacity="1.000000" stroke="none" 
    d="
  M774.774780,1570.653687 
    C774.434753,1571.324707 773.839355,1571.858154 773.017578,1572.610718 
    C772.247253,1572.860229 771.703491,1572.890625 770.756470,1572.827881 
    C771.742004,1571.995117 773.130676,1571.255615 774.774780,1570.653687 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M536.714844,1535.267334 
    C537.207581,1535.571411 537.422607,1535.771973 537.938477,1535.951416 
    C537.307800,1536.679077 536.462158,1537.336182 535.226562,1537.924805 
    C534.907471,1537.353271 534.978271,1536.850098 535.048096,1536.093262 
    C535.481934,1535.644897 535.916687,1535.450439 536.714844,1535.267334 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M539.411133,1535.909668 
    C539.611511,1535.309204 540.223267,1534.777832 540.971436,1533.973633 
    C541.869751,1533.576660 542.631653,1533.452271 543.676697,1533.599976 
    C542.580627,1534.574219 541.201538,1535.276489 539.411133,1535.909668 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M639.304077,1740.919434 
    C638.966064,1740.328125 638.984863,1739.795288 639.002563,1738.996094 
    C640.100220,1738.157959 641.198975,1737.586304 642.608887,1737.386963 
    C641.833618,1738.832275 640.747253,1739.905151 639.304077,1740.919434 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M478.646027,1653.919678 
    C478.506378,1653.511719 478.366730,1653.103638 478.458679,1652.366211 
    C478.690308,1652.036743 479.101959,1651.947144 479.101959,1651.947144 
    C479.724121,1653.051025 480.346252,1654.154785 480.636139,1655.660889 
    C480.132355,1656.108887 479.960846,1656.154541 479.789337,1656.200317 
    C479.789337,1656.200317 480.015381,1656.048096 479.976135,1655.845093 
    C479.506622,1655.067993 479.076324,1654.493774 478.646027,1653.919678 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M744.094238,1389.392822 
    C744.200989,1388.805542 744.437683,1388.510986 744.932556,1388.087402 
    C745.190796,1387.958252 745.545166,1387.994995 745.710205,1388.058228 
    C746.181580,1388.913208 746.487854,1389.704956 746.901062,1390.799561 
    C746.080017,1390.630005 745.152100,1390.157715 744.094238,1389.392822 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M466.260559,1380.059937 
    C465.432800,1380.757446 464.605011,1381.454956 463.393127,1381.888428 
    C462.980499,1381.405518 462.951935,1381.186768 462.923340,1380.968018 
    C463.414825,1380.358887 463.906311,1379.749878 464.827637,1379.273438 
    C465.591858,1379.624146 465.926208,1379.842041 466.260559,1380.059937 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M466.533752,1379.963867 
    C465.926208,1379.842041 465.591858,1379.624146 465.098022,1379.150391 
    C466.069000,1378.282715 467.199524,1377.670898 468.663940,1377.112793 
    C468.992462,1377.601929 468.987061,1378.037354 468.970917,1378.799316 
    C468.242432,1379.373047 467.524719,1379.620361 466.533752,1379.963867 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M484.579590,1667.908325 
    C484.375183,1667.508911 484.170776,1667.109375 484.180847,1666.218750 
    C484.584930,1665.390259 484.774567,1665.052856 484.964233,1664.715454 
    C485.639282,1665.667847 486.314362,1666.620239 486.641785,1667.873291 
    C485.722626,1668.085449 485.151093,1667.996948 484.579590,1667.908325 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M489.376953,1464.702637 
    C489.803375,1464.914795 489.850983,1465.097168 489.914764,1465.561768 
    C489.930908,1465.843872 489.555786,1465.975098 489.358490,1465.994629 
    C488.035980,1466.321289 486.910767,1466.628418 485.517853,1466.830933 
    C486.499481,1466.041748 487.748810,1465.357178 489.376953,1464.702637 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M626.399719,1747.132080 
    C626.003723,1747.022095 626.015686,1746.823120 626.017029,1746.325317 
    C627.276123,1745.397827 628.545776,1744.769287 630.145020,1744.438965 
    C629.252319,1745.505859 628.030029,1746.274414 626.399719,1747.132080 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M766.408203,1574.903809 
    C765.999512,1574.834229 766.009155,1574.504028 766.238281,1574.169922 
    C766.649353,1573.522217 766.831238,1573.208618 767.013123,1572.895020 
    C767.905579,1572.719116 768.798035,1572.543213 770.104126,1572.568359 
    C769.284119,1573.504028 768.050476,1574.238770 766.408203,1574.903809 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M484.921448,1583.685181 
    C484.337158,1583.909180 483.817505,1583.976074 483.036621,1584.057617 
    C483.011108,1583.458496 483.246857,1582.844727 483.722229,1582.109619 
    C484.235870,1582.223511 484.509888,1582.458862 484.904999,1582.942505 
    C485.026123,1583.190674 484.986145,1583.528076 484.921448,1583.685181 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M736.017334,1383.479736 
    C736.166443,1382.894897 736.414490,1382.574097 736.932678,1382.103027 
    C737.202820,1381.952881 737.541748,1381.987915 737.697876,1382.052002 
    C737.910400,1382.773193 737.966858,1383.430298 738.024048,1384.417114 
    C737.388550,1384.412354 736.752441,1384.078003 736.017334,1383.479736 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M745.585632,1426.037354 
    C746.164246,1426.178101 746.473022,1426.412720 746.930176,1426.901855 
    C747.078613,1427.156128 747.012390,1427.550415 746.944824,1427.737549 
    C746.217224,1427.953857 745.557251,1427.982910 744.567017,1428.012695 
    C744.596436,1427.385864 744.956055,1426.758667 745.585632,1426.037354 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M491.932343,1571.741699 
    C491.380768,1571.990967 490.927368,1571.987061 490.133850,1571.972656 
    C490.338593,1571.066650 490.883423,1570.171143 491.736328,1569.177246 
    C492.140350,1569.309692 492.236298,1569.540405 492.400818,1570.142090 
    C492.323151,1570.838257 492.176819,1571.163330 491.932343,1571.741699 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M484.967468,1664.605469 
    C484.774567,1665.052856 484.584930,1665.390259 484.147583,1665.879639 
    C483.453644,1665.498535 483.007385,1664.965332 482.628021,1664.165039 
    C483.237122,1663.990967 483.779358,1664.083984 484.591614,1664.240723 
    C484.861633,1664.304321 484.970734,1664.495483 484.967468,1664.605469 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M484.532104,1668.183594 
    C485.151093,1667.996948 485.722626,1668.085449 486.577972,1668.241943 
    C486.861816,1668.309814 486.971680,1668.502808 486.968933,1668.612061 
    C486.793488,1669.051758 486.620758,1669.382324 486.210266,1669.860352 
    C485.476562,1669.491577 484.980560,1668.975220 484.532104,1668.183594 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M492.333862,1680.221191 
    C492.976288,1680.028809 493.608490,1680.120728 494.554810,1680.286865 
    C494.868896,1680.361084 494.976105,1680.519287 494.970703,1680.612793 
    C494.778473,1681.046875 494.591644,1681.387329 494.155457,1681.878906 
    C493.378571,1681.521729 492.851105,1681.013550 492.333862,1680.221191 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M513.974731,1699.647949 
    C512.907104,1699.377808 511.855469,1698.668457 511.003540,1697.583130 
    C512.132446,1697.874268 513.061584,1698.541382 513.974731,1699.647949 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M547.385742,1533.902588 
    C547.608093,1533.359253 548.194580,1532.881592 548.910156,1532.148926 
    C549.455017,1531.770386 549.870850,1531.646606 550.604858,1531.611816 
    C550.932983,1531.936768 550.942871,1532.172852 550.999756,1532.760010 
    C549.947693,1533.396729 548.848694,1533.682495 547.385742,1533.902588 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M841.325073,1554.884277 
    C840.965393,1554.418701 840.974060,1554.003662 840.994141,1553.277222 
    C841.370850,1552.870728 841.736267,1552.775513 842.385742,1552.683350 
    C843.347046,1552.900269 844.024231,1553.114136 844.953857,1553.584106 
    C844.035400,1554.204956 842.864441,1554.569824 841.325073,1554.884277 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M686.149780,1436.022217 
    C686.197571,1435.854492 686.507935,1435.898438 686.660278,1435.935059 
    C686.425049,1436.565552 686.042786,1437.163330 685.643616,1437.749512 
    C685.589233,1437.829346 685.449402,1437.850830 685.348999,1437.899414 
    C685.376953,1437.788452 685.404907,1437.677368 685.420776,1437.365601 
    C685.639832,1436.839844 685.870972,1436.514771 686.149780,1436.022217 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M630.649292,1744.875977 
    C630.182983,1744.794434 629.997192,1744.441650 630.464966,1744.181641 
    C631.302490,1743.573853 631.672302,1743.225952 632.042053,1742.878174 
    C632.603638,1742.643799 633.165222,1742.409302 634.092896,1742.460938 
    C633.344604,1743.483887 632.230103,1744.220703 630.649292,1744.875977 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M508.928101,1747.406982 
    C509.801971,1747.457886 510.726624,1747.879272 511.819641,1748.570679 
    C510.984985,1748.486206 509.981934,1748.131836 508.928101,1747.406982 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M462.600800,1380.984985 
    C462.951935,1381.186768 462.980499,1381.405518 463.061584,1381.951172 
    C462.788696,1382.610962 462.463287,1382.943726 461.461700,1383.179932 
    C460.496643,1383.039551 460.207764,1382.995605 459.918915,1382.951782 
    C460.705353,1382.301880 461.491791,1381.651855 462.600800,1380.984985 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M729.434326,1584.906860 
    C730.345215,1584.664185 731.654968,1584.489868 733.016235,1584.591064 
    C731.989563,1584.902710 730.911316,1584.939087 729.434326,1584.906860 
  z"/>
  <path fill="#C3C3C3" opacity="1.000000" stroke="none" 
    d="
  M652.323486,1731.798828 
    C651.990967,1731.359619 651.994324,1730.879028 651.986206,1730.037598 
    C652.421875,1729.255005 652.868958,1728.833374 653.632141,1728.457031 
    C653.518677,1729.587280 653.089050,1730.672363 652.323486,1731.798828 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M751.387451,1578.900879 
    C752.198059,1578.361694 753.355896,1577.890015 754.705139,1577.614746 
    C753.842590,1578.196899 752.788574,1578.582642 751.387451,1578.900879 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M462.083984,1711.232422 
    C462.790802,1711.720581 463.435791,1712.548706 464.020966,1713.700439 
    C463.314819,1713.206909 462.668488,1712.389771 462.083984,1711.232422 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M463.973755,1714.384766 
    C464.652740,1714.469971 465.337250,1714.904297 465.993713,1715.686523 
    C465.303528,1715.600952 464.641388,1715.167480 463.973755,1714.384766 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M465.977844,1716.411133 
    C466.554535,1716.029175 467.143250,1716.023315 468.175262,1716.048584 
    C468.711945,1716.538940 468.805298,1716.998047 468.587524,1717.671875 
    C467.514221,1717.519897 466.752045,1717.153564 465.977844,1716.411133 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M468.082275,1718.142456 
    C469.078217,1718.199951 470.013702,1718.651611 470.597900,1719.485596 
    C469.504974,1719.424072 468.763397,1718.980347 468.082275,1718.142456 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M635.162781,1740.886475 
    C635.975159,1741.245483 636.452209,1741.714355 636.997986,1742.524170 
    C636.433899,1742.899170 635.801025,1742.933228 634.695251,1742.882080 
    C634.424011,1742.196777 634.625732,1741.596558 635.162781,1740.886475 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M470.079102,1720.147217 
    C471.065613,1720.203979 471.997101,1720.654419 472.585754,1721.487305 
    C471.503357,1721.426880 470.763733,1720.983887 470.079102,1720.147217 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M480.777557,1730.310303 
    C481.413605,1730.417725 482.187531,1730.861572 482.964417,1731.668945 
    C482.283417,1731.570679 481.599426,1731.108521 480.777557,1730.310303 
  z"/>
  <path fill="#E2E2E2" opacity="1.000000" stroke="none" 
    d="
  M511.382446,1552.024048 
    C511.521057,1551.341553 512.018372,1550.645264 512.889221,1549.954590 
    C512.755554,1550.643677 512.248352,1551.326904 511.382446,1552.024048 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M529.155151,1539.378784 
    C530.067993,1539.045532 530.915039,1538.853516 531.937927,1538.861328 
    C531.316162,1539.360352 530.518555,1539.659668 529.380127,1539.893311 
    C529.039368,1539.827637 529.089417,1539.520020 529.155151,1539.378784 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M831.314941,1557.887207 
    C831.609680,1557.387695 832.239441,1556.942017 833.068359,1556.718140 
    C832.728333,1557.273560 832.189087,1557.607178 831.314941,1557.887207 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M780.443359,1571.933228 
    C780.094116,1571.674194 780.090332,1571.485474 780.292358,1570.990967 
    C780.770630,1570.661865 781.032104,1570.595337 781.282654,1570.485596 
    C781.879456,1570.665405 782.476257,1570.845215 783.521790,1571.150391 
    C782.909973,1571.518188 781.849426,1571.760864 780.443359,1571.933228 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M759.366455,1576.906616 
    C759.931396,1576.460938 760.832764,1576.083008 761.890869,1575.906128 
    C761.266052,1576.396240 760.484436,1576.685303 759.366455,1576.906616 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M744.367676,1580.902344 
    C744.929321,1580.459839 745.825867,1580.082642 746.878052,1579.904419 
    C746.256653,1580.391479 745.479614,1580.679443 744.367676,1580.902344 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M459.688171,1383.039307 
    C460.207764,1382.995605 460.496643,1383.039551 461.214355,1383.180176 
    C461.009949,1383.875854 460.376678,1384.474854 459.409363,1385.094116 
    C459.050842,1384.919312 459.026428,1384.724243 458.971436,1384.236328 
    C458.996307,1383.597290 459.168488,1383.325073 459.688171,1383.039307 
  z"/>
  <path fill="#C0C0C0" opacity="1.000000" stroke="none" 
    d="
  M701.914429,1650.613525 
    C701.709351,1650.132446 701.564636,1649.287109 701.626953,1648.244141 
    C701.880920,1648.780884 701.927856,1649.515015 701.914429,1650.613525 
  z"/>
  <path fill="#CFCFCF" opacity="1.000000" stroke="none" 
    d="
  M723.541138,1385.418213 
    C723.111145,1385.356323 723.084778,1385.062622 723.008301,1384.329590 
    C723.163086,1383.302246 723.367798,1382.714355 723.898132,1382.092407 
    C724.130737,1383.101074 724.037720,1384.143799 723.541138,1385.418213 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M438.105347,1409.188232 
    C438.772675,1409.282349 439.357697,1409.735352 439.606354,1410.525879 
    C438.854309,1410.424561 438.438660,1409.985718 438.105347,1409.188232 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M751.464355,1418.185303 
    C752.159424,1417.986206 752.640381,1417.988281 753.481812,1417.989258 
    C753.239075,1418.527954 752.635803,1419.067749 751.742859,1419.272705 
    C751.385498,1418.754150 751.317871,1418.570312 751.464355,1418.185303 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M504.892151,1423.889282 
    C504.351929,1423.982666 503.813202,1423.728638 503.146362,1423.200439 
    C503.643372,1423.131470 504.268494,1423.336670 504.892151,1423.889282 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M479.057922,1651.627197 
    C479.101959,1651.947144 478.690308,1652.036743 478.479736,1652.039917 
    C478.096283,1651.639771 477.923401,1651.236450 477.771881,1650.502319 
    C477.965668,1650.131348 478.138031,1650.091309 478.575378,1650.041504 
    C478.898224,1650.456909 478.956085,1650.882080 479.057922,1651.627197 
  z"/>
  <path fill="#C3C3C3" opacity="1.000000" stroke="none" 
    d="
  M649.386108,1734.023193 
    C649.478821,1733.681396 649.888489,1733.339722 650.579041,1732.957642 
    C650.474365,1733.285767 650.088745,1733.654419 649.386108,1734.023193 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M483.915771,1515.101318 
    C483.973633,1515.379761 483.744293,1515.628662 483.261169,1515.911865 
    C483.214478,1515.654663 483.421539,1515.363159 483.915771,1515.101318 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M658.287354,1726.842529 
    C658.252869,1726.601807 658.488831,1726.365601 658.973877,1726.069824 
    C659.001343,1726.289062 658.779602,1726.567993 658.287354,1726.842529 
  z"/>
  <path fill="#C0C0C0" opacity="1.000000" stroke="none" 
    d="
  M715.254150,1588.901123 
    C715.274414,1588.759155 715.540588,1588.667114 715.900146,1588.716797 
    C715.829041,1588.889160 715.664551,1588.920166 715.254150,1588.901123 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M479.791504,1656.551025 
    C479.960846,1656.154541 480.132355,1656.108887 480.569397,1656.044067 
    C480.863312,1656.302124 480.891693,1656.579224 480.854004,1657.269531 
    C480.456512,1657.422485 480.125092,1657.161987 479.791504,1656.551025 
  z"/>
  <path fill="#030303" opacity="1.000000" stroke="none" 
    d="
  M1712.927002,947.578308 
    C1712.926880,947.578308 1712.903320,947.468506 1712.618774,947.887329 
    C1712.501343,949.517151 1712.668457,950.728149 1712.718750,952.199585 
    C1713.009888,953.491577 1713.417847,954.523193 1713.756226,955.677246 
    C1713.686523,955.799683 1713.876099,956.008301 1713.830688,956.402344 
    C1714.167847,957.720947 1714.550293,958.645386 1714.932861,959.569885 
    C1714.932861,959.569885 1714.893433,959.464355 1714.644775,959.815063 
    C1714.733521,960.933044 1715.071045,961.700256 1715.775757,963.302551 
    C1716.945679,960.957520 1717.710083,959.425354 1718.723633,957.628784 
    C1720.717773,954.596069 1722.462891,951.827881 1724.491455,948.920410 
    C1725.219604,947.861084 1725.664307,946.940918 1726.353760,945.701355 
    C1726.829712,944.903503 1727.060547,944.424988 1727.521729,943.762207 
    C1727.578247,943.076782 1727.404297,942.575562 1727.230225,942.074402 
    C1727.230225,942.074402 1727.097534,942.061646 1727.427002,942.378174 
    C1729.234863,940.264038 1730.713135,937.833374 1732.446533,935.240845 
    C1733.000244,934.369263 1733.298950,933.659607 1733.813232,932.670288 
    C1735.398804,929.358948 1736.768921,926.327271 1738.380859,923.133545 
    C1738.895752,922.294983 1739.168701,921.618408 1739.648193,920.669800 
    C1740.348389,919.140137 1740.841797,917.882507 1741.589355,916.407837 
    C1742.337524,914.783936 1742.831543,913.376953 1743.528320,911.676147 
    C1743.787354,910.913696 1743.843628,910.445068 1744.156250,909.744873 
    C1748.757935,895.726746 1753.123291,881.946289 1757.372559,868.130066 
    C1757.538330,867.590820 1756.592896,866.709900 1756.165161,865.988159 
    C1756.514282,864.591187 1756.863403,863.194275 1757.492432,861.426025 
    C1759.193481,852.060791 1760.614868,843.066772 1762.167480,833.242554 
    C1769.111816,835.680969 1776.208252,837.710266 1782.910645,840.640442 
    C1791.781616,844.518555 1800.344238,849.101440 1809.190063,853.626343 
    C1809.523438,853.929016 1809.706055,853.986877 1809.986328,854.353027 
    C1811.005371,855.198914 1811.926758,855.736450 1812.854858,856.218872 
    C1812.861450,856.163757 1812.758423,856.204956 1812.906982,856.494995 
    C1814.359741,857.540649 1815.664062,858.296265 1816.977295,859.022705 
    C1816.986328,858.993469 1816.942261,859.036255 1817.081665,859.341431 
    C1818.148926,860.230896 1819.076904,860.815186 1820.105713,861.666504 
    C1821.085327,862.643921 1821.963867,863.354370 1822.954346,864.378052 
    C1824.704712,866.170715 1826.343506,867.650208 1828.131348,869.491455 
    C1829.146851,869.980652 1830.013428,870.108032 1830.879883,870.235474 
    C1830.879883,870.235535 1830.899414,870.094116 1830.479736,870.388062 
    C1832.973389,874.696106 1835.886719,878.710266 1838.800049,882.724487 
    C1838.824219,883.145752 1838.848389,883.566956 1839.128052,884.930908 
    C1840.903687,890.107849 1842.423828,894.342041 1843.944092,898.576233 
    C1843.944092,898.576233 1843.924561,898.452515 1843.595459,898.709534 
    C1843.372925,899.664246 1843.479614,900.361877 1843.502930,901.378296 
    C1843.533081,902.112854 1843.646851,902.528687 1843.622070,903.396851 
    C1843.481201,931.609619 1843.478882,959.369995 1843.055908,987.263733 
    C1840.474121,987.455505 1838.313232,987.564819 1836.152222,987.565002 
    C1730.244873,987.573364 1624.337402,987.571167 1518.430054,987.580505 
    C1516.437500,987.580688 1514.444946,987.705017 1512.153931,987.399048 
    C1511.671143,985.733582 1511.326904,984.440735 1511.326050,983.147583 
    C1511.308105,956.355591 1511.112061,929.560303 1511.518433,902.774292 
    C1511.603516,897.163513 1513.732788,891.528015 1515.319702,886.019104 
    C1516.126099,883.220154 1517.821655,880.677307 1519.279541,877.825562 
    C1519.470215,877.465515 1519.496948,877.298645 1519.833008,877.039978 
    C1520.733887,876.074097 1521.325684,875.200012 1521.953247,874.309448 
    C1521.989136,874.292969 1522.046021,874.237976 1522.372314,874.137085 
    C1526.810425,869.922729 1530.564575,865.349670 1535.119873,861.806519 
    C1541.480469,856.859375 1548.439331,852.681335 1555.114258,848.149658 
    C1555.086426,848.125061 1555.098633,848.197327 1555.473755,848.158752 
    C1560.105347,845.851013 1564.361938,843.581848 1568.939087,841.337708 
    C1569.825562,841.099304 1570.391479,840.835876 1571.325684,840.552002 
    C1575.313965,838.771851 1578.934082,837.012085 1582.554077,835.252319 
    C1582.944092,835.210632 1583.334106,835.169006 1584.582764,835.257568 
    C1587.905762,834.825867 1590.370239,834.263977 1593.171143,833.625305 
    C1594.437134,853.228455 1597.056396,872.028564 1603.060181,890.181519 
    C1605.320557,897.016052 1608.183838,903.651184 1610.741943,910.553955 
    C1610.711304,910.730652 1610.931274,911.014038 1610.873047,911.368713 
    C1611.485107,912.936707 1612.155518,914.150085 1612.828247,915.715332 
    C1613.711304,918.024841 1614.592163,919.982483 1615.430664,922.231018 
    C1615.872192,923.124817 1616.355835,923.727661 1616.831543,924.632385 
    C1617.026001,925.271118 1617.228760,925.607971 1617.396973,926.248169 
    C1617.818359,927.216919 1618.274536,927.882263 1618.720215,928.817261 
    C1618.906494,929.377380 1619.103149,929.667847 1619.277100,930.267700 
    C1619.747681,931.233215 1620.240967,931.889221 1620.749023,932.888977 
    C1622.065918,935.459534 1623.368164,937.686462 1624.624756,940.219849 
    C1625.300049,941.530273 1626.020752,942.534180 1626.798340,943.874634 
    C1627.546631,944.693481 1628.238159,945.175781 1628.929810,945.658081 
    C1628.929810,945.658020 1628.996338,945.557800 1628.797852,946.039429 
    C1629.370483,946.905518 1630.141602,947.289978 1630.912598,947.674438 
    C1630.912598,947.674438 1630.951538,947.521851 1630.463867,947.794006 
    C1630.184814,948.676514 1630.393311,949.286865 1630.554932,950.160400 
    C1631.612915,951.486206 1632.717896,952.548828 1633.822998,953.611450 
    C1633.872559,953.874512 1633.922119,954.137573 1634.138184,955.059814 
    C1634.876221,956.468689 1635.447876,957.218445 1636.010986,957.982422 
    C1636.002441,957.996643 1636.027222,957.982971 1636.021973,958.318115 
    C1637.251465,959.634033 1636.913330,963.293030 1640.193848,960.710449 
    C1640.381470,959.484436 1640.431152,958.573792 1640.717285,957.407410 
    C1641.333130,954.759216 1641.712646,952.366882 1642.208740,949.630371 
    C1642.390259,948.084717 1642.454956,946.883240 1642.761719,945.445984 
    C1643.322510,943.143860 1643.640991,941.077454 1644.072510,938.654785 
    C1644.244507,937.058838 1644.303589,935.819092 1644.602905,934.315796 
    C1645.243774,931.363892 1645.644409,928.675598 1646.153076,925.661621 
    C1646.305176,924.426575 1646.349121,923.517090 1646.646362,922.353027 
    C1647.293823,919.391357 1647.687988,916.684204 1648.190308,913.654785 
    C1648.340942,912.431702 1648.383667,911.530762 1648.686035,910.377808 
    C1649.152466,908.725342 1649.359375,907.324768 1649.719727,905.536011 
    C1650.040649,902.962036 1650.207886,900.776367 1650.647095,898.351196 
    C1651.120117,896.714172 1651.321167,895.316772 1651.671631,893.613647 
    C1651.824341,892.859131 1651.827881,892.410278 1651.993896,891.812744 
    C1652.107666,891.108459 1652.059204,890.552856 1652.111206,889.697998 
    C1652.242432,888.771484 1652.273193,888.144287 1652.567627,887.275757 
    C1653.014160,885.657959 1653.197144,884.281433 1653.561035,882.569519 
    C1653.782837,881.479004 1653.823730,880.723999 1654.023926,879.816223 
    C1654.138550,879.104614 1654.093872,878.545776 1654.155518,877.693970 
    C1654.284790,876.783020 1654.307617,876.165100 1654.588867,875.299805 
    C1655.009033,873.669250 1655.171021,872.286133 1655.505371,870.539001 
    C1655.743652,869.108398 1655.809692,868.041748 1656.028809,866.815979 
    C1656.145386,866.098938 1656.108887,865.541016 1656.193848,864.594666 
    C1655.905396,863.430603 1655.495483,862.654907 1655.085693,861.879272 
    C1655.085693,861.879272 1655.083130,861.963867 1655.446045,861.665527 
    C1654.909302,860.194397 1654.009766,859.021545 1653.110229,857.848694 
    C1653.110229,857.848694 1653.095581,857.945618 1653.487061,857.661804 
    C1652.953003,856.203613 1652.027466,855.029236 1651.101929,853.854858 
    C1651.101929,853.854919 1651.088989,853.950256 1651.473511,853.665710 
    C1650.944214,852.204590 1650.030396,851.028015 1649.116699,849.851379 
    C1649.116699,849.851379 1649.104614,849.946045 1649.494385,849.658081 
    C1648.957764,848.197205 1648.031372,847.024231 1647.104980,845.851196 
    C1647.104980,845.851196 1647.092896,845.952271 1647.481445,845.705200 
    C1647.295288,844.297119 1646.720581,843.136108 1646.180420,841.629761 
    C1645.573242,840.356934 1644.931641,839.429504 1644.273926,838.148682 
    C1643.578125,836.562561 1642.898315,835.329773 1642.299683,833.820496 
    C1641.935425,832.999512 1641.490234,832.455017 1640.954346,831.567017 
    C1640.009399,829.514160 1639.154785,827.804810 1638.443726,825.657837 
    C1640.045044,824.745422 1641.471313,824.085266 1642.966553,823.830322 
    C1647.671631,823.028198 1652.402588,822.378235 1657.531250,821.714478 
    C1659.572388,821.666931 1661.205811,821.574158 1663.286621,821.664246 
    C1673.541382,821.742249 1683.348755,821.637390 1693.544922,821.605713 
    C1695.251099,821.679626 1696.568359,821.680542 1698.250977,821.870239 
    C1704.408203,822.838501 1710.200317,823.617798 1716.187134,824.423279 
    C1716.061890,825.691162 1715.951782,826.804565 1715.537842,828.133972 
    C1714.425781,831.068481 1713.617554,833.786865 1712.809326,836.505249 
    C1712.809326,836.505249 1712.939087,836.492249 1712.463623,836.394897 
    C1711.932861,836.830566 1711.877319,837.363586 1711.821777,837.896606 
    C1711.821899,837.896606 1711.937866,837.908997 1711.483154,837.707397 
    C1710.607910,838.969849 1710.187134,840.433899 1709.766357,841.897888 
    C1709.766357,841.897888 1709.869995,841.923218 1709.493896,841.692566 
    C1706.672607,846.944824 1704.227295,852.427734 1701.781982,857.910645 
    C1701.781982,857.910645 1701.916748,857.920349 1701.655273,857.613770 
    C1701.195190,857.424316 1700.996460,857.541504 1700.525635,857.850464 
    C1699.839966,859.028564 1699.426392,860.014893 1698.827393,861.417908 
    C1698.793823,864.230713 1698.945435,866.626831 1698.950928,869.287720 
    C1699.389893,871.577454 1699.974854,873.602539 1700.510254,875.900879 
    C1700.635132,877.220825 1700.809570,878.267334 1700.853516,879.543274 
    C1700.975464,880.755310 1701.228149,881.737976 1701.438843,883.017761 
    C1701.587769,883.873962 1701.778687,884.433044 1701.793457,885.171814 
    C1701.905518,886.119446 1702.193848,886.887390 1702.457275,888.039429 
    C1702.644531,889.954529 1702.856812,891.485657 1702.916748,893.277344 
    C1703.358398,895.569580 1703.952393,897.601135 1704.507324,899.998291 
    C1704.637451,901.573975 1704.806519,902.784119 1704.831543,904.281372 
    C1705.314209,906.917542 1705.940918,909.266541 1706.531860,912.003052 
    C1706.703369,913.936340 1706.910522,915.482178 1706.963867,917.272217 
    C1707.328613,919.246399 1707.847412,920.976440 1708.328857,923.083130 
    C1708.510498,924.969055 1708.729614,926.478333 1708.798584,928.260315 
    C1709.239380,930.585205 1709.830322,932.637451 1710.383057,935.069336 
    C1710.568237,936.967163 1710.791626,938.485291 1710.856812,940.277100 
    C1711.441284,942.893311 1712.184082,945.235779 1712.927002,947.578308 
  z"/>
  <path fill="#020202" opacity="1.000000" stroke="none" 
    d="
  M1644.471558,619.013794 
    C1645.429688,618.647156 1646.387817,618.280457 1648.041138,617.718994 
    C1649.500000,617.376709 1650.263794,617.229248 1651.443848,617.096436 
    C1652.906616,616.803589 1653.953125,616.496033 1655.273926,616.260071 
    C1656.174805,615.932739 1656.801514,615.533936 1657.823120,615.163696 
    C1659.493042,614.894104 1660.767822,614.595947 1662.457031,614.410767 
    C1668.306030,614.049011 1673.737183,613.260681 1679.176880,613.196045 
    C1683.767944,613.141541 1688.369019,613.926697 1693.322266,614.526489 
    C1694.740479,614.825012 1695.801880,614.937195 1697.069824,615.265808 
    C1698.185425,615.753723 1699.094482,616.025146 1700.310913,616.496216 
    C1701.101685,616.721436 1701.585083,616.747009 1702.375732,616.949158 
    C1704.776001,617.701233 1706.869019,618.276672 1709.181152,619.030151 
    C1710.062988,619.535950 1710.725586,619.863770 1711.581543,620.426514 
    C1712.523438,620.926025 1713.271973,621.190613 1714.159668,621.710815 
    C1714.657349,622.079407 1715.016235,622.192444 1715.613037,622.516724 
    C1716.929443,623.251770 1718.007935,623.775513 1719.421387,624.539307 
    C1721.473022,625.261353 1723.189819,625.743408 1724.906616,626.225464 
    C1724.906616,626.225464 1724.930908,626.132446 1724.739258,626.606323 
    C1725.318359,627.139465 1726.089111,627.198730 1726.859741,627.257996 
    C1726.859741,627.257996 1726.871216,627.118469 1726.489502,627.405579 
    C1726.705566,628.470093 1727.303345,629.247498 1728.010498,630.313232 
    C1729.104736,631.243835 1730.089600,631.886230 1731.284668,632.803528 
    C1733.927734,635.414062 1736.360596,637.749695 1738.894775,640.415771 
    C1741.013916,643.074280 1743.031616,645.402405 1745.191895,648.060913 
    C1746.505127,649.336060 1747.675903,650.280701 1748.846680,651.225403 
    C1748.846680,651.225403 1748.871826,651.093445 1748.451416,651.336304 
    C1748.814941,653.120422 1749.598999,654.661621 1750.447021,656.535767 
    C1750.820679,657.186768 1751.130249,657.504883 1751.550903,657.679321 
    C1751.661987,657.535706 1751.330322,657.387695 1751.230469,657.663025 
    C1751.739990,658.966492 1752.349487,659.994629 1753.249756,661.097839 
    C1753.670776,661.020569 1753.800781,660.868225 1753.930664,660.715881 
    C1753.930664,660.715881 1754.002808,660.560852 1753.553101,660.864868 
    C1753.395752,662.110474 1753.688110,663.052124 1753.894775,664.269348 
    C1754.635498,666.878479 1755.557861,669.183044 1756.272583,671.550293 
    C1760.579590,685.814636 1761.573242,700.368469 1757.758423,714.745667 
    C1755.457764,723.416992 1751.332031,731.604065 1747.898315,740.139648 
    C1747.770264,740.270691 1747.774780,740.637085 1747.482300,740.804321 
    C1746.437012,742.309265 1745.684204,743.646973 1744.582520,745.281006 
    C1744.396484,746.348267 1744.559204,747.119141 1744.721924,747.890015 
    C1744.721924,747.890015 1744.879395,747.903442 1744.472900,747.477966 
    C1743.640625,748.006653 1743.214600,748.960754 1742.788574,749.914856 
    C1742.788574,749.914856 1742.924438,749.893677 1742.623047,749.517578 
    C1741.879639,749.414795 1741.437500,749.688232 1740.678589,750.061768 
    C1738.288330,752.484985 1736.214844,754.808105 1733.829468,757.197144 
    C1732.661499,758.173279 1731.805664,759.083496 1730.650146,760.131836 
    C1728.242676,761.945496 1726.134888,763.621094 1723.679321,765.318848 
    C1720.859253,766.869263 1718.386841,768.397522 1715.939331,769.942017 
    C1715.964111,769.958130 1715.960083,769.899536 1715.597900,769.932251 
    C1713.432983,770.946594 1711.630127,771.928284 1709.513184,772.896362 
    C1708.820435,773.047485 1708.441650,773.212158 1707.748047,773.317688 
    C1706.531250,773.790833 1705.629272,774.323242 1704.368164,774.841919 
    C1701.673096,775.561707 1699.337158,776.295166 1696.754761,776.917358 
    C1695.596313,777.171265 1694.684204,777.536499 1693.382324,777.897766 
    C1683.519165,778.145325 1674.046021,778.396790 1664.408691,778.461548 
    C1663.521851,778.266785 1662.799072,778.258911 1661.744629,778.052734 
    C1659.417480,777.493896 1657.421753,777.133301 1655.239014,776.546753 
    C1653.719727,775.955750 1652.387451,775.590576 1650.715820,775.035767 
    C1647.710449,773.827454 1645.044434,772.808655 1642.219238,771.486572 
    C1637.669189,768.913208 1633.278442,766.643127 1628.734619,764.051147 
    C1627.745850,763.458923 1626.910156,763.188599 1626.074463,762.918213 
    C1626.074463,762.918213 1625.999756,762.986145 1626.121094,762.588379 
    C1625.848633,761.922485 1625.454834,761.654419 1624.962280,761.094116 
    C1621.262695,757.431702 1617.661865,754.061523 1613.999268,750.529541 
    C1613.788330,750.162781 1613.587158,750.063232 1613.270752,749.753784 
    C1612.804810,748.969788 1612.401855,748.501038 1611.920532,747.776489 
    C1611.672607,747.465149 1611.503174,747.409729 1611.265259,747.041016 
    C1610.317749,745.517944 1609.438721,744.308105 1608.573730,742.773071 
    C1607.479370,740.937317 1606.370972,739.426697 1605.207764,737.567444 
    C1603.974365,735.150330 1602.795898,733.081848 1601.680298,730.643677 
    C1600.297485,726.985291 1598.851807,723.696655 1597.438232,720.103882 
    C1597.343140,719.206360 1597.215942,718.613037 1597.210205,717.747925 
    C1596.737061,715.759827 1596.142334,714.043396 1595.592529,711.967896 
    C1595.472168,710.416504 1595.306885,709.224304 1595.282715,707.671997 
    C1595.318359,699.198975 1595.212891,691.086060 1595.228027,682.651978 
    C1595.379517,681.421021 1595.410278,680.511353 1595.657227,679.344238 
    C1596.084229,678.025574 1596.295166,676.964355 1596.707764,675.590454 
    C1597.060425,674.062927 1597.211182,672.848145 1597.608643,671.385864 
    C1598.297852,670.248352 1598.847534,669.395142 1599.166992,668.462952 
    C1605.612549,649.659180 1617.757080,635.508789 1634.506958,625.112732 
    C1637.815674,623.059143 1641.149292,621.045776 1644.471558,619.013794 
  z"/>
  <path fill="#CFCFCF" opacity="1.000000" stroke="none" 
    d="
  M1843.760620,902.944458 
    C1843.646851,902.528687 1843.533081,902.112854 1843.796997,901.354675 
    C1844.761963,900.953613 1845.349365,900.894897 1845.936646,900.836121 
    C1845.936646,929.979675 1845.936646,959.123169 1845.936646,989.024902 
    C1734.523682,989.024902 1623.174438,989.024902 1511.562256,988.722656 
    C1511.683594,988.204041 1512.067993,987.987732 1512.452393,987.771423 
    C1514.444946,987.705017 1516.437500,987.580688 1518.430054,987.580505 
    C1624.337402,987.571167 1730.244873,987.573364 1836.152222,987.565002 
    C1838.313232,987.564819 1840.474121,987.455505 1843.407349,987.099731 
    C1844.452026,985.887146 1844.961182,984.972351 1844.962769,984.056763 
    C1845.005737,958.184814 1845.013550,932.312744 1844.945190,906.440918 
    C1844.942139,905.274414 1844.172974,904.109863 1843.760620,902.944458 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M1512.153931,987.399048 
    C1512.067993,987.987732 1511.683594,988.204041 1511.087646,988.677429 
    C1510.247070,988.525330 1509.618042,988.116211 1509.306885,987.034790 
    C1509.735474,985.546143 1509.942261,984.729858 1509.942871,983.913452 
    C1509.966919,956.487061 1509.983032,929.060608 1509.939941,901.634277 
    C1509.937988,900.390381 1509.374512,899.147339 1509.072632,897.903931 
    C1509.503052,890.700684 1511.770630,884.159302 1516.800537,878.197205 
    C1518.031006,878.025757 1518.573120,878.022217 1519.115356,878.018738 
    C1517.821655,880.677307 1516.126099,883.220154 1515.319702,886.019104 
    C1513.732788,891.528015 1511.603516,897.163513 1511.518433,902.774292 
    C1511.112061,929.560303 1511.308105,956.355591 1511.326050,983.147583 
    C1511.326904,984.440735 1511.671143,985.733582 1512.153931,987.399048 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1610.772461,910.377197 
    C1608.183838,903.651184 1605.320557,897.016052 1603.060181,890.181519 
    C1597.056396,872.028564 1594.437134,853.228455 1593.171143,833.625305 
    C1590.370239,834.263977 1587.905762,834.825867 1585.165039,835.173828 
    C1587.851074,833.989746 1590.780518,832.871094 1593.808838,832.198486 
    C1594.302734,832.088684 1595.673096,833.868103 1595.868164,834.917480 
    C1596.226929,836.848145 1595.889893,838.895691 1596.060547,840.875793 
    C1596.679810,848.062378 1596.731689,855.381714 1598.226929,862.388489 
    C1600.227295,871.762085 1603.368408,880.892578 1606.029053,890.124695 
    C1607.666016,895.804504 1609.320435,901.479370 1610.983398,907.945435 
    C1610.923950,909.281982 1610.848145,909.829590 1610.772461,910.377197 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1809.039429,853.381470 
    C1800.344238,849.101440 1791.781616,844.518555 1782.910645,840.640442 
    C1776.208252,837.710266 1769.111816,835.680969 1762.167480,833.242554 
    C1760.614868,843.066772 1759.193481,852.060791 1757.495605,860.981812 
    C1757.852783,856.417236 1758.771729,851.942993 1759.045532,847.429565 
    C1759.364746,842.166687 1759.120239,836.869629 1759.120239,830.906677 
    C1763.228638,831.760376 1767.227051,832.153503 1770.907837,833.449158 
    C1778.111572,835.984863 1785.283813,838.714172 1792.187866,841.961121 
    C1797.011108,844.229431 1801.352539,847.515503 1805.945190,850.287109 
    C1806.754150,850.775330 1807.741211,850.968323 1808.837769,851.841797 
    C1809.052490,852.717590 1809.055786,853.049438 1809.039429,853.381470 
  z"/>
  <path fill="#C3C3C3" opacity="1.000000" stroke="none" 
    d="
  M1644.288086,618.932861 
    C1641.149292,621.045776 1637.815674,623.059143 1634.506958,625.112732 
    C1617.757080,635.508789 1605.612549,649.659180 1599.166992,668.462952 
    C1598.847534,669.395142 1598.297852,670.248352 1597.518311,670.983154 
    C1598.177124,667.237854 1599.173096,663.647766 1600.169067,660.057678 
    C1605.928223,647.289795 1613.321533,635.782959 1625.393188,628.012146 
    C1630.700806,624.595459 1636.135742,621.371582 1641.596924,618.205078 
    C1642.129028,617.896606 1643.254639,618.611877 1644.288086,618.932861 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1748.026367,740.008667 
    C1751.332031,731.604065 1755.457764,723.416992 1757.758423,714.745667 
    C1761.573242,700.368469 1760.579590,685.814636 1756.272583,671.550293 
    C1755.557861,669.183044 1754.635498,666.878479 1754.147583,664.344421 
    C1754.936890,664.415771 1755.387695,664.687622 1755.838623,664.959473 
    C1757.859985,670.900208 1759.925049,676.826782 1761.862061,682.794922 
    C1762.206299,683.855469 1762.067505,685.088623 1762.068359,686.242188 
    C1762.071655,691.222473 1761.874878,696.209351 1762.068604,701.181458 
    C1762.334717,708.007324 1760.805420,714.406250 1758.261108,720.662170 
    C1756.815918,724.215637 1755.567627,727.849182 1753.743652,731.948303 
    C1751.513306,734.969543 1749.769897,737.489075 1748.026367,740.008667 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M1642.378418,771.789917 
    C1645.044434,772.808655 1647.710449,773.827454 1650.878784,775.357239 
    C1652.729492,776.169739 1654.077759,776.471191 1655.426147,776.772644 
    C1657.421753,777.133301 1659.417480,777.493896 1661.988770,778.296143 
    C1663.233887,778.707886 1663.903320,778.678101 1664.572754,778.648315 
    C1674.046021,778.396790 1683.519165,778.145325 1693.737549,777.984009 
    C1695.322144,777.725769 1696.161743,777.377258 1697.001221,777.028687 
    C1699.337158,776.295166 1701.673096,775.561707 1704.714355,774.922241 
    C1706.300903,774.469788 1707.181885,773.923279 1708.062988,773.376831 
    C1708.441650,773.212158 1708.820435,773.047485 1709.874634,772.944092 
    C1711.695557,772.614319 1712.841064,772.223206 1714.294556,771.883057 
    C1714.807007,771.972839 1715.011475,772.011658 1715.216064,772.050476 
    C1713.622070,773.310547 1712.208740,775.189453 1710.401001,775.716980 
    C1704.532471,777.429321 1698.575562,778.996643 1692.547363,779.961243 
    C1685.803589,781.040527 1678.899658,782.228516 1672.147705,781.860046 
    C1664.019287,781.416504 1655.814209,780.159119 1648.302246,776.326904 
    C1645.358765,774.825378 1642.143555,773.856384 1639.315063,772.272888 
    C1640.511475,771.863892 1641.444946,771.826904 1642.378418,771.789917 
  z"/>
  <path fill="#CACACA" opacity="1.000000" stroke="none" 
    d="
  M1644.362549,934.579407 
    C1644.303589,935.819092 1644.244507,937.058838 1643.787109,938.905396 
    C1643.099121,941.568726 1642.809448,943.625244 1642.519653,945.681763 
    C1642.454956,946.883240 1642.390259,948.084717 1641.911133,949.877502 
    C1641.157959,952.866943 1640.819336,955.265076 1640.480835,957.663208 
    C1640.431152,958.573792 1640.381470,959.484436 1639.907959,960.579590 
    C1638.650635,959.849670 1637.817383,958.935181 1636.992554,958.009888 
    C1637.001099,957.999146 1637.021240,957.979004 1637.021240,957.979004 
    C1637.591187,957.745239 1638.604004,957.593262 1638.664551,957.265442 
    C1639.497559,952.752686 1640.135864,948.204163 1640.947876,943.687073 
    C1642.178711,936.840454 1643.508301,930.011658 1644.793335,923.174805 
    C1644.854126,922.851318 1644.900635,922.524353 1644.936768,922.197144 
    C1645.599243,916.165833 1646.003906,910.091736 1646.997070,904.115479 
    C1647.867920,898.874878 1649.408447,893.746216 1650.627808,888.562195 
    C1650.814453,887.768372 1650.882324,886.944092 1650.971680,886.130249 
    C1651.678955,879.695312 1652.364380,873.257935 1653.120728,866.828857 
    C1653.159424,866.498962 1653.785156,866.238281 1654.656250,866.101685 
    C1655.408569,866.497009 1655.642090,866.736023 1655.875732,866.975098 
    C1655.809692,868.041748 1655.743652,869.108398 1655.189697,870.713379 
    C1654.578003,872.683533 1654.454224,874.115356 1654.330444,875.547119 
    C1654.307617,876.165100 1654.284790,876.783020 1653.938843,877.828247 
    C1653.698730,878.826660 1653.781738,879.397827 1653.864624,879.968933 
    C1653.823730,880.723999 1653.782837,881.479004 1653.234375,882.726318 
    C1652.585815,884.651367 1652.444946,886.084229 1652.303955,887.517029 
    C1652.273193,888.144287 1652.242432,888.771484 1651.897461,889.832275 
    C1651.666016,890.830933 1651.748657,891.396179 1651.831299,891.961365 
    C1651.827881,892.410278 1651.824341,892.859131 1651.329346,893.759033 
    C1650.683716,895.670227 1650.529541,897.130432 1650.375244,898.590698 
    C1650.207886,900.776367 1650.040649,902.962036 1649.370728,905.677185 
    C1648.720703,907.681030 1648.573486,909.155457 1648.426270,910.629822 
    C1648.383667,911.530762 1648.340942,912.431702 1647.907715,913.917358 
    C1647.142334,917.203979 1646.767700,919.905823 1646.393066,922.607605 
    C1646.349121,923.517090 1646.305176,924.426575 1645.871094,925.922485 
    C1645.108154,929.199097 1644.735352,931.889282 1644.362549,934.579407 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M1701.969604,884.992126 
    C1701.778687,884.433044 1701.587769,883.873962 1701.558350,882.431274 
    C1701.474487,880.803101 1701.229248,880.058533 1700.984131,879.313904 
    C1700.809570,878.267334 1700.635132,877.220825 1700.648682,875.507874 
    C1700.256714,872.901978 1699.676880,870.962463 1699.096924,869.022949 
    C1698.945435,866.626831 1698.793823,864.230713 1699.145874,861.276123 
    C1700.032349,859.697998 1700.415161,858.678345 1700.797852,857.658691 
    C1700.996460,857.541504 1701.195190,857.424316 1701.642822,857.547363 
    C1701.699585,859.183044 1701.411865,860.573792 1701.342285,861.975342 
    C1701.273315,863.362122 1701.373047,864.764771 1701.502686,866.150696 
    C1701.559692,866.761047 1701.985474,867.334839 1702.054077,867.946472 
    C1702.746826,874.118713 1703.133423,880.339478 1704.144043,886.457642 
    C1705.047119,891.924500 1706.723145,897.259094 1707.875854,902.690735 
    C1708.739502,906.759766 1709.482788,910.869751 1709.982666,914.997498 
    C1711.072632,923.998413 1711.973267,933.022339 1712.689453,942.260193 
    C1711.956909,941.656799 1711.486084,940.830078 1711.015137,940.003418 
    C1710.791626,938.485291 1710.568237,936.967163 1710.530273,934.676392 
    C1710.126709,931.931641 1709.537720,929.959656 1708.948730,927.987671 
    C1708.729614,926.478333 1708.510498,924.969055 1708.489258,922.715210 
    C1708.163818,920.323059 1707.640747,918.675598 1707.117676,917.028076 
    C1706.910522,915.482178 1706.703369,913.936340 1706.659058,911.593201 
    C1706.206543,908.528748 1705.591064,906.261475 1704.975586,903.994263 
    C1704.806519,902.784119 1704.637451,901.573975 1704.643066,899.603394 
    C1704.234863,896.900879 1703.651978,894.958801 1703.069092,893.016724 
    C1702.856812,891.485657 1702.644531,889.954529 1702.599854,887.685120 
    C1702.501343,886.295227 1702.235474,885.643677 1701.969604,884.992126 
  z"/>
  <path fill="#D5D5D5" opacity="1.000000" stroke="none" 
    d="
  M1599.932251,660.365723 
    C1599.173096,663.647766 1598.177124,667.237854 1597.271484,671.230591 
    C1597.211182,672.848145 1597.060425,674.062927 1596.364990,675.714844 
    C1595.694092,677.301880 1595.567627,678.451721 1595.441040,679.601624 
    C1595.410278,680.511353 1595.379517,681.421021 1594.910034,682.878479 
    C1592.340088,691.692322 1591.791992,699.915283 1595.141602,708.032104 
    C1595.306885,709.224304 1595.472168,710.416504 1595.437134,712.350891 
    C1595.854126,714.735229 1596.471436,716.377441 1597.088745,718.019653 
    C1597.215942,718.613037 1597.343140,719.206360 1597.333008,720.493958 
    C1598.669678,724.463257 1600.143555,727.738342 1601.617432,731.013428 
    C1602.795898,733.081848 1603.974365,735.150330 1604.930786,737.735291 
    C1604.476807,738.616089 1604.244873,738.980408 1604.013062,739.344727 
    C1598.336670,732.067627 1595.041748,723.727905 1594.014771,714.664795 
    C1592.966797,705.415710 1591.769897,696.051453 1592.200195,686.810425 
    C1592.520508,679.932068 1595.245483,673.146240 1597.086792,666.370178 
    C1597.627197,664.381897 1598.808105,662.567749 1599.932251,660.365723 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M1755.976807,866.335449 
    C1756.592896,866.709900 1757.538330,867.590820 1757.372559,868.130066 
    C1753.123291,881.946289 1748.757935,895.726746 1743.864502,909.763672 
    C1742.927002,910.003906 1742.537476,909.993774 1742.148071,909.983643 
    C1746.694946,895.550049 1751.241699,881.116455 1755.976807,866.335449 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M1555.142090,848.174194 
    C1548.439331,852.681335 1541.480469,856.859375 1535.119873,861.806519 
    C1530.564575,865.349670 1526.810425,869.922729 1522.354004,873.732788 
    C1521.995483,872.890198 1521.981934,872.350952 1521.968384,871.811768 
    C1528.636597,865.481323 1535.162964,858.989319 1542.063599,852.923157 
    C1544.018921,851.204346 1547.066772,850.728149 1550.080078,849.279114 
    C1550.735596,848.607544 1550.924805,848.338928 1551.113892,848.070374 
    C1551.113892,848.070374 1551.391602,847.959778 1551.973389,848.007812 
    C1553.417480,848.095276 1554.279785,848.134766 1555.142090,848.174194 
  z"/>
  <path fill="#CFCFCF" opacity="1.000000" stroke="none" 
    d="
  M1509.031494,898.381714 
    C1509.374512,899.147339 1509.937988,900.390381 1509.939941,901.634277 
    C1509.983032,929.060608 1509.966919,956.487061 1509.942871,983.913452 
    C1509.942261,984.729858 1509.735474,985.546143 1509.368530,986.689453 
    C1509.071533,957.630737 1509.030884,928.245056 1509.031494,898.381714 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M1738.138916,923.295532 
    C1736.768921,926.327271 1735.398804,929.358948 1733.503174,932.763062 
    C1732.715576,933.891235 1732.453491,934.646973 1732.191406,935.402771 
    C1730.713135,937.833374 1729.234863,940.264038 1727.437866,942.443909 
    C1727.768433,939.699341 1727.988403,936.982300 1729.147583,934.753662 
    C1732.630737,928.056580 1736.479980,921.549866 1740.645020,915.363953 
    C1741.180786,916.047668 1741.257935,916.336243 1741.335083,916.624817 
    C1740.841797,917.882507 1740.348389,919.140137 1739.358643,920.766968 
    C1738.621216,921.855957 1738.380005,922.575745 1738.138916,923.295532 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1615.473022,921.940063 
    C1614.592163,919.982483 1613.711304,918.024841 1612.880371,915.343750 
    C1612.607910,913.426208 1612.285645,912.232056 1611.992188,911.008850 
    C1612.020996,910.979858 1612.078979,910.922363 1612.078979,910.922363 
    C1614.036743,913.862671 1616.291870,916.650879 1617.889771,919.775146 
    C1621.138672,926.127075 1624.032593,932.660522 1627.006104,939.590088 
    C1626.939209,940.060974 1626.713989,940.276794 1626.465332,940.212158 
    C1625.701172,940.069458 1625.185791,939.991394 1624.670288,939.913330 
    C1623.368164,937.686462 1622.065918,935.459534 1620.817749,932.546143 
    C1620.347778,931.225891 1619.823853,930.592102 1619.299805,929.958313 
    C1619.103149,929.667847 1618.906494,929.377380 1618.793213,928.484741 
    C1618.395020,927.236572 1617.913330,926.590698 1617.431519,925.944824 
    C1617.228760,925.607971 1617.026001,925.271118 1616.883545,924.316956 
    C1616.453491,923.113159 1615.963257,922.526611 1615.473022,921.940063 
  z"/>
  <path fill="#EFEFEF" opacity="1.000000" stroke="none" 
    d="
  M1697.885742,821.681396 
    C1696.568359,821.680542 1695.251099,821.679626 1693.355835,821.280823 
    C1683.291504,820.701538 1673.805420,820.502869 1664.318115,820.388794 
    C1663.829590,820.382812 1663.332520,821.100525 1662.839355,821.481384 
    C1661.205811,821.574158 1659.572388,821.666931 1657.580078,821.501465 
    C1657.221191,821.243347 1656.991943,820.871094 1656.991943,820.871094 
    C1657.707031,820.240784 1658.417114,819.067444 1659.137817,819.060974 
    C1671.283691,818.951111 1683.430786,818.967468 1695.577271,819.039185 
    C1696.275757,819.043274 1696.970093,819.760681 1697.725952,820.699585 
    C1697.785522,821.252991 1697.885742,821.681396 1697.885742,821.681396 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1698.250977,821.870239 
    C1697.885742,821.681396 1697.785522,821.252991 1697.899170,821.064148 
    C1703.125122,820.890137 1708.238037,820.872314 1713.349976,820.929321 
    C1717.973389,820.980896 1719.455688,823.388428 1717.010620,827.877563 
    C1716.224854,827.992676 1716.033325,827.955322 1715.841675,827.917908 
    C1715.951782,826.804565 1716.061890,825.691162 1716.187134,824.423279 
    C1710.200317,823.617798 1704.408203,822.838501 1698.250977,821.870239 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1692.965576,614.340210 
    C1688.369019,613.926697 1683.767944,613.141541 1679.176880,613.196045 
    C1673.737183,613.260681 1668.306030,614.049011 1662.605713,614.112183 
    C1664.543823,613.186584 1666.747681,612.672546 1668.951416,612.158447 
    C1674.339966,612.117920 1679.728394,612.077393 1685.855713,612.331909 
    C1688.718140,613.198059 1690.841797,613.769104 1692.965576,614.340210 
  z"/>
  <path fill="#CACACA" opacity="1.000000" stroke="none" 
    d="
  M1638.300171,826.095459 
    C1639.154785,827.804810 1640.009399,829.514160 1640.916382,831.839905 
    C1641.385498,833.003235 1641.802002,833.550110 1642.218628,834.097046 
    C1642.898315,835.329773 1643.578125,836.562561 1644.203613,838.508789 
    C1644.814941,840.139893 1645.480469,841.057495 1646.145874,841.975159 
    C1646.720581,843.136108 1647.295288,844.297119 1647.531494,845.696289 
    C1646.423218,845.560303 1645.263550,845.390503 1644.943726,844.780334 
    C1641.700928,838.594971 1638.518433,832.373535 1635.569092,826.045593 
    C1635.270142,825.404114 1636.608765,823.999390 1637.501953,823.185242 
    C1637.977661,824.312866 1638.138916,825.204163 1638.300171,826.095459 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1638.443726,825.657837 
    C1638.138916,825.204163 1637.977661,824.312866 1637.899536,823.149353 
    C1644.010742,822.244263 1650.038940,821.611328 1656.529541,820.924805 
    C1656.991943,820.871094 1657.221191,821.243347 1657.172363,821.456360 
    C1652.402588,822.378235 1647.671631,823.028198 1642.966553,823.830322 
    C1641.471313,824.085266 1640.045044,824.745422 1638.443726,825.657837 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1738.793335,640.085327 
    C1736.360596,637.749695 1733.927734,635.414062 1731.274170,632.514893 
    C1730.946167,631.391602 1730.838745,630.831848 1730.836426,630.163025 
    C1730.941528,630.053894 1731.149902,629.834045 1731.149902,629.834045 
    C1735.384521,633.966553 1739.619019,638.099060 1743.894653,642.648132 
    C1743.935669,643.064697 1743.709595,643.283875 1743.407471,643.168701 
    C1741.668091,642.064087 1740.230713,641.074707 1738.793335,640.085327 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M1614.061035,750.691345 
    C1617.661865,754.061523 1621.262695,757.431702 1624.971436,761.530151 
    C1625.052612,762.547424 1625.025879,762.836487 1624.999268,763.125549 
    C1621.328247,759.703247 1617.657227,756.280945 1613.988770,752.142822 
    C1614.014648,751.181763 1614.037842,750.936523 1614.061035,750.691345 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1838.720703,882.462524 
    C1835.886719,878.710266 1832.973389,874.696106 1830.409180,870.399048 
    C1836.578369,872.061890 1837.582886,877.148804 1838.720703,882.462524 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M1702.190186,857.963074 
    C1704.227295,852.427734 1706.672607,846.944824 1709.484619,841.640076 
    C1708.298950,845.887878 1706.826172,849.990723 1705.151489,854.009399 
    C1704.551392,855.449280 1703.463623,856.686035 1702.190186,857.963074 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M1642.219238,771.486572 
    C1641.444946,771.826904 1640.511475,771.863892 1639.109863,771.952026 
    C1638.641602,772.003052 1638.440430,772.028198 1638.223267,771.611816 
    C1636.871948,770.793213 1635.737793,770.390991 1634.603638,769.988770 
    C1634.603638,769.988770 1634.442749,770.031311 1634.268433,769.628418 
    C1633.288452,768.813721 1632.482910,768.401917 1631.677246,767.990173 
    C1631.677246,767.990173 1631.427124,768.016113 1631.186279,767.733765 
    C1630.663818,767.251282 1630.382202,767.051147 1630.100586,766.850952 
    C1629.973389,766.541321 1629.774780,766.287903 1629.243896,765.730225 
    C1628.951538,765.037598 1628.919678,764.705322 1628.887695,764.372986 
    C1633.278442,766.643127 1637.669189,768.913208 1642.219238,771.486572 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1668.503906,612.092285 
    C1666.747681,612.672546 1664.543823,613.186584 1662.191406,613.999268 
    C1660.767822,614.595947 1659.493042,614.894104 1657.528198,615.139404 
    C1656.225342,615.453918 1655.612549,615.821228 1654.999634,616.188477 
    C1653.953125,616.496033 1652.906616,616.803589 1651.412598,616.784912 
    C1650.934204,616.252380 1650.903442,616.045959 1650.872681,615.839600 
    C1651.118286,615.273499 1651.297852,614.255554 1651.619263,614.208496 
    C1657.087891,613.409729 1662.573975,612.731201 1668.503906,612.092285 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M1843.940430,898.088257 
    C1842.423828,894.342041 1840.903687,890.107849 1839.390015,885.507080 
    C1844.639893,887.934570 1844.260254,892.777588 1843.940430,898.088257 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1693.322266,614.526489 
    C1690.841797,613.769104 1688.718140,613.198059 1686.323364,612.390564 
    C1692.339111,610.969543 1697.998413,613.466797 1703.687744,615.577454 
    C1703.078857,616.242371 1702.573608,616.507446 1702.068481,616.772522 
    C1701.585083,616.747009 1701.101685,616.721436 1700.180420,616.219238 
    C1698.782959,615.511536 1697.823120,615.280457 1696.863403,615.049316 
    C1695.801880,614.937195 1694.740479,614.825012 1693.322266,614.526489 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M1582.379883,835.443115 
    C1578.934082,837.012085 1575.313965,838.771851 1571.404785,840.232056 
    C1573.700195,838.687317 1576.284546,837.442078 1578.869019,836.196899 
    C1579.981201,836.009216 1581.093506,835.821533 1582.379883,835.443115 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M1555.114258,848.149658 
    C1554.279785,848.134766 1553.417480,848.095276 1552.122681,848.012939 
    C1555.831421,845.625977 1559.972656,843.281799 1564.570068,840.983887 
    C1565.026367,841.030151 1565.197632,841.220764 1565.076172,841.536987 
    C1561.669434,843.967957 1558.384033,846.082703 1555.098633,848.197388 
    C1555.098633,848.197327 1555.086426,848.125061 1555.114258,848.149658 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1724.027100,765.296631 
    C1726.134888,763.621094 1728.242676,761.945496 1731.029907,760.145996 
    C1732.215454,760.039795 1732.721680,760.057373 1733.227783,760.075012 
    C1730.361938,762.652100 1727.495972,765.229248 1724.274170,767.541382 
    C1723.954468,766.616516 1723.990845,765.956543 1724.027100,765.296631 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M1724.208008,949.059692 
    C1722.462891,951.827881 1720.717773,954.596069 1718.400513,957.657471 
    C1717.393799,958.001404 1716.959351,958.052185 1716.524780,958.103027 
    C1718.441040,954.705444 1720.357300,951.307861 1722.781982,948.078369 
    C1723.596313,948.517517 1723.902222,948.788574 1724.208008,949.059692 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M1578.464355,836.090210 
    C1576.284546,837.442078 1573.700195,838.687317 1571.036499,840.252441 
    C1570.391479,840.835876 1569.825562,841.099304 1568.514648,841.245972 
    C1566.912354,841.159729 1566.055054,841.190247 1565.197632,841.220764 
    C1565.197632,841.220764 1565.026367,841.030151 1564.940674,840.934937 
    C1569.256592,839.220947 1573.658203,837.602234 1578.464355,836.090210 
  z"/>
  <path fill="#E2E2E2" opacity="1.000000" stroke="none" 
    d="
  M1747.898315,740.139648 
    C1749.769897,737.489075 1751.513306,734.969543 1753.540894,732.280396 
    C1752.128052,735.999939 1750.431152,739.888977 1748.327637,743.853333 
    C1747.921143,743.928711 1747.712891,743.728577 1747.761353,743.345398 
    C1747.798096,742.187195 1747.786377,741.412109 1747.774658,740.637085 
    C1747.774780,740.637085 1747.770264,740.270691 1747.898315,740.139648 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1734.141479,757.131287 
    C1736.214844,754.808105 1738.288330,752.484985 1740.693237,750.414551 
    C1741.039673,751.137695 1741.054810,751.608154 1741.069824,752.078552 
    C1741.069824,752.078552 1741.003418,752.043762 1740.773315,752.172058 
    C1740.323608,752.840881 1740.104004,753.381348 1739.884521,753.921875 
    C1739.884521,753.921875 1739.567017,754.031799 1739.112061,754.155029 
    C1738.407104,754.822693 1738.156982,755.367065 1737.906738,755.911499 
    C1737.906738,755.911438 1737.556274,756.013794 1737.069336,756.111084 
    C1735.828003,756.573853 1735.073730,756.939270 1734.274658,757.261597 
    C1734.229980,757.218445 1734.141479,757.131287 1734.141479,757.131287 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1723.679321,765.318848 
    C1723.990845,765.956543 1723.954468,766.616516 1723.900269,767.606812 
    C1723.882324,767.937134 1723.580811,768.050537 1723.049072,768.023315 
    C1721.641357,768.639526 1720.765259,769.282959 1719.889160,769.926331 
    C1719.889160,769.926331 1719.579712,770.041138 1718.999023,770.016724 
    C1717.583862,769.970093 1716.749146,769.947937 1715.914551,769.925781 
    C1718.386841,768.397522 1720.859253,766.869263 1723.679321,765.318848 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1822.842529,864.064819 
    C1821.963867,863.354370 1821.085327,862.643921 1820.005371,861.323914 
    C1818.850098,860.154968 1817.896240,859.595581 1816.942261,859.036255 
    C1816.942261,859.036255 1816.986328,858.993469 1817.007568,858.739258 
    C1817.041992,858.295593 1817.055176,858.106018 1817.068481,857.916504 
    C1821.310791,857.299316 1822.766602,860.898865 1824.752930,863.597656 
    C1823.901001,864.013428 1823.371826,864.039124 1822.842529,864.064819 
  z"/>
  <path fill="#D5D5D5" opacity="1.000000" stroke="none" 
    d="
  M1611.998901,748.032227 
    C1612.401855,748.501038 1612.804810,748.969788 1612.908203,749.742676 
    C1612.367554,750.062134 1612.126343,750.077515 1611.885132,750.092957 
    C1609.987915,747.923889 1608.090820,745.754822 1606.462891,743.261963 
    C1607.341309,742.991516 1607.950439,743.044861 1608.559692,743.098267 
    C1609.438721,744.308105 1610.317749,745.517944 1611.196289,747.254272 
    C1611.463379,747.864624 1611.731201,747.948425 1611.998901,748.032227 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M1715.537842,828.133972 
    C1716.033325,827.955322 1716.224854,827.992676 1716.706787,828.062988 
    C1715.853394,830.780273 1714.709595,833.464600 1713.187500,836.327026 
    C1713.617554,833.786865 1714.425781,831.068481 1715.537842,828.133972 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1750.383057,656.202820 
    C1749.598999,654.661621 1748.814941,653.120422 1748.384766,651.345154 
    C1753.162842,652.411987 1753.074951,656.429993 1753.963135,660.278320 
    C1753.800781,660.868225 1753.670776,661.020569 1753.199951,660.593384 
    C1752.349609,659.138428 1751.839966,658.263062 1751.330322,657.387695 
    C1751.330322,657.387695 1751.661987,657.535706 1751.598145,657.295654 
    C1751.150513,656.771301 1750.766724,656.487061 1750.383057,656.202820 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M1608.573730,742.773071 
    C1607.950439,743.044861 1607.341309,742.991516 1606.425781,742.916504 
    C1606.119507,742.894836 1605.996826,742.598572 1606.004639,742.081299 
    C1605.373413,740.982422 1604.734497,740.400818 1604.095581,739.819275 
    C1604.095581,739.819275 1603.987305,739.592224 1604.000244,739.468506 
    C1604.244873,738.980408 1604.476807,738.616089 1604.985596,738.083923 
    C1606.370972,739.426697 1607.479370,740.937317 1608.573730,742.773071 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1748.937744,650.842834 
    C1747.675903,650.280701 1746.505127,649.336060 1745.201904,647.731873 
    C1744.987549,646.421509 1744.905396,645.770569 1744.907471,645.058228 
    C1744.991821,644.996704 1745.154297,644.865845 1745.154297,644.865845 
    C1746.445801,646.730652 1747.737183,648.595459 1748.937744,650.842834 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1822.954346,864.378052 
    C1823.371826,864.039124 1823.901001,864.013428 1824.827148,863.958862 
    C1825.223999,863.930115 1825.575684,863.958191 1825.789307,864.325195 
    C1826.415283,865.107849 1826.827515,865.523560 1827.239746,865.939270 
    C1827.239746,865.939270 1827.580933,865.956543 1827.757446,866.395996 
    C1827.949951,867.600159 1827.966064,868.364929 1827.982178,869.129639 
    C1826.343506,867.650208 1824.704712,866.170715 1822.954346,864.378052 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1724.964722,625.819092 
    C1723.189819,625.743408 1721.473022,625.261353 1719.369873,624.303467 
    C1718.664307,623.270142 1718.345093,622.712646 1718.025879,622.155090 
    C1720.358154,623.241028 1722.690552,624.326904 1724.964722,625.819092 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1711.388306,620.191589 
    C1710.725586,619.863770 1710.062988,619.535950 1708.968384,618.806030 
    C1707.365601,617.639221 1706.194702,616.874573 1705.023804,616.109985 
    C1707.696533,617.138489 1710.369385,618.167053 1712.646118,619.630249 
    C1711.962891,620.107178 1711.675537,620.149414 1711.388306,620.191589 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1710.856812,940.277100 
    C1711.486084,940.830078 1711.956909,941.656799 1712.630615,942.697876 
    C1712.872803,944.155640 1712.911987,945.398926 1712.938965,947.110291 
    C1712.184082,945.235779 1711.441284,942.893311 1710.856812,940.277100 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1809.190063,853.626343 
    C1809.055786,853.049438 1809.052490,852.717590 1809.033447,852.136963 
    C1811.048096,852.989441 1813.058838,854.090759 1814.732178,855.599121 
    C1813.849365,856.072449 1813.303833,856.138733 1812.758423,856.204956 
    C1812.758423,856.204956 1812.861450,856.163757 1812.786621,855.880493 
    C1811.770752,855.079773 1810.829834,854.562256 1809.888794,854.044739 
    C1809.706055,853.986877 1809.523438,853.929016 1809.190063,853.626343 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M1716.314209,958.256836 
    C1716.959351,958.052185 1717.393799,958.001404 1718.151367,957.921936 
    C1717.710083,959.425354 1716.945679,960.957520 1715.775757,963.302551 
    C1715.071045,961.700256 1714.733521,960.933044 1714.592529,959.836304 
    C1715.227173,959.141357 1715.665405,958.776001 1716.314209,958.256836 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1704.811035,616.046143 
    C1706.194702,616.874573 1707.365601,617.639221 1708.749268,618.627991 
    C1706.869019,618.276672 1704.776001,617.701233 1702.375732,616.949158 
    C1702.573608,616.507446 1703.078857,616.242371 1703.874512,615.929810 
    C1704.165161,615.882263 1704.598145,615.982361 1704.811035,616.046143 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M1713.876099,956.008301 
    C1713.876099,956.008301 1713.686523,955.799683 1713.803955,955.270996 
    C1713.559448,953.807983 1713.197632,952.873535 1712.835693,951.939148 
    C1712.668457,950.728149 1712.501343,949.517151 1712.564697,947.902588 
    C1717.085205,949.018250 1714.272949,952.564880 1714.660889,955.553223 
    C1714.353882,955.996094 1713.876099,956.008301 1713.876099,956.008301 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1633.630249,953.375732 
    C1632.717896,952.548828 1631.612915,951.486206 1630.940674,950.208618 
    C1631.888550,950.052002 1632.403687,950.110413 1632.918701,950.168884 
    C1633.091553,951.159241 1633.264526,952.149597 1633.630249,953.375732 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M1628.734619,764.051147 
    C1628.919678,764.705322 1628.951538,765.037598 1629.026855,765.618896 
    C1627.914307,765.121216 1626.758301,764.374451 1625.838379,763.272949 
    C1626.910156,763.188599 1627.745850,763.458923 1628.734619,764.051147 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1812.906982,856.494995 
    C1813.303833,856.138733 1813.849365,856.072449 1814.805908,855.970947 
    C1815.217041,855.935730 1815.576294,855.964722 1815.790405,856.317261 
    C1816.368652,857.106018 1816.732788,857.542175 1817.096924,857.978394 
    C1817.096924,857.978394 1817.034424,857.970764 1817.051514,857.943604 
    C1817.055176,858.106018 1817.041992,858.295593 1816.998535,858.768494 
    C1815.664062,858.296265 1814.359741,857.540649 1812.906982,856.494995 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M1521.917480,874.325928 
    C1521.325684,875.200012 1520.733887,876.074097 1519.430176,876.949036 
    C1518.452026,876.880371 1518.185791,876.810791 1517.919434,876.741272 
    C1518.282349,875.813049 1518.645386,874.884827 1519.905029,874.050049 
    C1521.173584,874.204285 1521.545532,874.265137 1521.917480,874.325928 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1628.945312,945.244873 
    C1628.238159,945.175781 1627.546631,944.693481 1626.871948,943.466431 
    C1626.830566,941.906616 1626.772339,941.091736 1626.713989,940.276794 
    C1626.713989,940.276794 1626.939209,940.060974 1627.052490,939.953796 
    C1627.764282,941.508301 1628.362549,943.169983 1628.945312,945.244873 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1715.939331,769.941956 
    C1716.749146,769.947937 1717.583862,769.970093 1718.834839,770.032593 
    C1718.158569,770.735962 1717.065918,771.399048 1715.594727,772.056274 
    C1715.011475,772.011658 1714.807007,771.972839 1714.490234,771.681702 
    C1714.905396,770.919434 1715.432739,770.409485 1715.960083,769.899536 
    C1715.960083,769.899536 1715.964111,769.958130 1715.939331,769.941956 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1733.392090,760.059937 
    C1732.721680,760.057373 1732.215454,760.039795 1731.329590,760.007935 
    C1731.805664,759.083496 1732.661499,758.173279 1733.829468,757.197144 
    C1734.141479,757.131287 1734.229980,757.218445 1734.168213,757.576660 
    C1734.026123,758.599243 1733.945557,759.263611 1733.865112,759.927979 
    C1733.865112,759.927979 1733.556396,760.044922 1733.392090,760.059937 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M1741.589355,916.407837 
    C1741.257935,916.336243 1741.180786,916.047668 1741.033691,915.316406 
    C1740.963623,914.873657 1741.016846,914.423462 1741.282837,914.047852 
    C1742.141113,913.104858 1742.733398,912.537415 1743.325684,911.969971 
    C1742.831543,913.376953 1742.337524,914.783936 1741.589355,916.407837 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1650.646362,615.893860 
    C1650.903442,616.045959 1650.934204,616.252380 1650.996338,616.770264 
    C1650.263794,617.229248 1649.500000,617.376709 1648.690063,617.292358 
    C1649.235840,616.689697 1649.827881,616.318909 1650.646362,615.893860 
  z"/>
  <path fill="#CACACA" opacity="1.000000" stroke="none" 
    d="
  M1647.048828,846.269104 
    C1648.031372,847.024231 1648.957764,848.197205 1649.541016,849.647461 
    C1648.462646,848.845520 1647.727661,847.766235 1647.048828,846.269104 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M1724.491455,948.920410 
    C1723.902222,948.788574 1723.596313,948.517517 1723.148560,947.966309 
    C1723.006836,947.686157 1722.994263,947.390625 1723.370239,947.197876 
    C1724.533813,946.677002 1725.321289,946.348877 1726.108887,946.020752 
    C1725.664307,946.940918 1725.219604,947.861084 1724.491455,948.920410 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M1743.528442,911.676208 
    C1742.733398,912.537415 1742.141113,913.104858 1741.344727,913.829834 
    C1741.366577,912.867371 1741.592285,911.747375 1741.983032,910.305542 
    C1742.537476,909.993774 1742.927002,910.003906 1743.608154,909.995178 
    C1743.843628,910.445068 1743.787354,910.913696 1743.528442,911.676208 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1717.804932,622.088989 
    C1718.345093,622.712646 1718.664307,623.270142 1719.035034,624.063477 
    C1718.007935,623.775513 1716.929443,623.251770 1716.048828,622.414185 
    C1716.540649,622.050171 1716.834595,621.999878 1717.128418,621.949524 
    C1717.128418,621.949524 1717.583862,622.022888 1717.804932,622.088989 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1727.901123,630.025024 
    C1727.303345,629.247498 1726.705566,628.470093 1726.421631,627.423218 
    C1728.078857,627.844910 1729.421875,628.536011 1730.957520,629.530518 
    C1731.149902,629.834045 1730.941528,630.053894 1730.491943,630.092773 
    C1729.328491,630.096069 1728.614868,630.060547 1727.901123,630.025024 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1828.131348,869.491455 
    C1827.966064,868.364929 1827.949951,867.600159 1827.918457,866.453064 
    C1828.942139,867.213379 1829.981323,868.356018 1830.950195,869.867065 
    C1830.013428,870.108032 1829.146851,869.980652 1828.131348,869.491455 
  z"/>
  <path fill="#CACACA" opacity="1.000000" stroke="none" 
    d="
  M1653.058594,858.266174 
    C1654.009766,859.021545 1654.909302,860.194397 1655.486938,861.654785 
    C1654.445557,860.856140 1653.726196,859.769897 1653.058594,858.266174 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1755.913574,664.553040 
    C1755.387695,664.687622 1754.936890,664.415771 1754.233154,664.068848 
    C1753.688110,663.052124 1753.395752,662.110474 1753.474365,660.831299 
    C1754.559814,661.711304 1755.274170,662.928955 1755.913574,664.553040 
  z"/>
  <path fill="#CACACA" opacity="1.000000" stroke="none" 
    d="
  M1651.055054,854.273132 
    C1652.027466,855.029236 1652.953003,856.203613 1653.535278,857.653076 
    C1652.464111,856.849243 1651.736206,855.770325 1651.055054,854.273132 
  z"/>
  <path fill="#CACACA" opacity="1.000000" stroke="none" 
    d="
  M1649.055664,850.268311 
    C1650.030396,851.028015 1650.944214,852.204590 1651.520874,853.657349 
    C1650.454102,852.850708 1649.724365,851.767944 1649.055664,850.268311 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M1710.189087,841.947754 
    C1710.187134,840.433899 1710.607910,838.969849 1711.440674,837.667603 
    C1711.439087,839.218811 1711.025513,840.608215 1710.189087,841.947754 
  z"/>
  <path fill="#E2E2E2" opacity="1.000000" stroke="none" 
    d="
  M1745.073242,747.920654 
    C1744.559204,747.119141 1744.396484,746.348267 1744.893433,745.229980 
    C1746.273071,744.497864 1746.993042,744.113220 1747.712891,743.728516 
    C1747.712891,743.728577 1747.921143,743.928711 1748.024414,744.029541 
    C1747.226807,745.403992 1746.325806,746.677673 1745.073242,747.920654 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1636.019409,957.968201 
    C1635.447876,957.218445 1634.876221,956.468689 1634.329590,955.412720 
    C1634.716431,955.087708 1635.078247,955.068909 1635.707642,955.446289 
    C1635.989868,956.551147 1636.004639,957.259644 1636.019409,957.968201 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1734.223999,759.890503 
    C1733.945557,759.263611 1734.026123,758.599243 1734.212891,757.619812 
    C1735.073730,756.939270 1735.828003,756.573853 1736.886963,756.119446 
    C1736.322021,757.304749 1735.452515,758.578918 1734.223999,759.890503 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1720.276611,769.989258 
    C1720.765259,769.282959 1721.641357,768.639526 1722.888550,768.037048 
    C1722.394409,768.736084 1721.529297,769.394104 1720.276611,769.989258 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1717.091431,621.572388 
    C1716.834595,621.999878 1716.540649,622.050171 1715.810913,622.203003 
    C1715.016235,622.192444 1714.657349,622.079407 1714.154297,621.491943 
    C1714.003540,620.725769 1713.999390,620.433899 1713.997681,620.142090 
    C1715.016602,620.493103 1716.035522,620.844116 1717.091431,621.572388 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M1845.977295,900.468872 
    C1845.349365,900.894897 1844.761963,900.953613 1843.880615,901.035950 
    C1843.479614,900.361877 1843.372925,899.664246 1843.533691,898.720154 
    C1844.540039,899.016357 1845.279053,899.559021 1845.977295,900.468872 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M1726.353760,945.701355 
    C1725.321289,946.348877 1724.533813,946.677002 1723.428833,947.062134 
    C1723.700928,946.273376 1724.290527,945.427612 1725.552612,944.304932 
    C1726.580566,944.000793 1726.935913,943.973633 1727.291382,943.946472 
    C1727.060547,944.424988 1726.829712,944.903503 1726.353760,945.701355 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M1634.812744,770.298706 
    C1635.737793,770.390991 1636.871948,770.793213 1638.135498,771.560791 
    C1637.183960,771.487061 1636.103027,771.047913 1634.812744,770.298706 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1713.779175,620.085083 
    C1713.999390,620.433899 1714.003540,620.725769 1714.015381,621.236389 
    C1713.271973,621.190613 1712.523438,620.926025 1711.581543,620.426514 
    C1711.675537,620.149414 1711.962891,620.107178 1712.682373,620.010803 
    C1713.114502,619.956604 1713.560669,620.028015 1713.779175,620.085083 
  z"/>
  <path fill="#CFCFCF" opacity="1.000000" stroke="none" 
    d="
  M1521.953369,874.309448 
    C1521.545532,874.265137 1521.173584,874.204285 1520.243774,874.046997 
    C1520.210327,873.277771 1520.734741,872.604980 1521.613770,871.871948 
    C1521.981934,872.350952 1521.995483,872.890198 1522.027588,873.833679 
    C1522.046021,874.237976 1521.989136,874.292969 1521.953369,874.309448 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1656.028687,866.815918 
    C1655.642090,866.736023 1655.408569,866.497009 1655.084839,866.017456 
    C1654.994751,865.776917 1655.025757,865.373047 1655.320801,865.168457 
    C1655.615967,864.963928 1656.072510,864.983093 1656.072510,864.983093 
    C1656.108887,865.541016 1656.145386,866.098938 1656.028687,866.815918 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1632.972412,949.764771 
    C1632.403687,950.110413 1631.888550,950.052002 1630.987793,949.945435 
    C1630.393311,949.286865 1630.184814,948.676514 1630.385986,947.782593 
    C1631.539185,948.119507 1632.282715,948.740051 1632.972412,949.764771 
  z"/>
  <path fill="#E2E2E2" opacity="1.000000" stroke="none" 
    d="
  M1743.185791,749.950806 
    C1743.214600,748.960754 1743.640625,748.006653 1744.458740,747.400146 
    C1744.428345,748.494202 1744.005615,749.240479 1743.185791,749.950806 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1741.443481,752.055847 
    C1741.054810,751.608154 1741.039673,751.137695 1741.010010,750.314453 
    C1741.437500,749.688232 1741.879639,749.414795 1742.597168,749.453918 
    C1742.520752,750.522034 1742.168945,751.277588 1741.443481,752.055847 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M1631.792725,768.364868 
    C1632.482910,768.401917 1633.288452,768.813721 1634.200439,769.580566 
    C1633.507202,769.536865 1632.707764,769.138245 1631.792725,768.364868 
  z"/>
  <path fill="#C0C0C0" opacity="1.000000" stroke="none" 
    d="
  M1611.922363,750.435303 
    C1612.126343,750.077515 1612.367554,750.062134 1612.971191,750.057861 
    C1613.587158,750.063232 1613.788330,750.162781 1613.999268,750.529541 
    C1614.037842,750.936523 1614.014648,751.181763 1613.979248,751.796631 
    C1613.297852,751.703369 1612.628662,751.240479 1611.922363,750.435303 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1713.830688,956.402344 
    C1713.876099,956.008301 1714.353882,955.996094 1714.592529,955.994507 
    C1714.869995,956.886292 1714.908691,957.779785 1714.940186,959.121582 
    C1714.550293,958.645386 1714.167847,957.720947 1713.830688,956.402344 
  z"/>
  <path fill="#CACACA" opacity="1.000000" stroke="none" 
    d="
  M1636.010986,957.982422 
    C1636.004639,957.259644 1635.989868,956.551147 1635.976318,955.488770 
    C1636.316162,955.850952 1636.654663,956.566956 1637.007324,957.630981 
    C1637.021240,957.979004 1637.001099,957.999146 1636.754395,957.974976 
    C1636.507568,957.950745 1636.027222,957.982971 1636.027222,957.982971 
    C1636.027222,957.982971 1636.002441,957.996643 1636.010986,957.982422 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M1727.521729,943.762207 
    C1726.935913,943.973633 1726.580566,944.000793 1725.690430,944.019043 
    C1725.633911,943.370911 1726.111938,942.731750 1726.910156,942.083496 
    C1727.404297,942.575562 1727.578247,943.076782 1727.521729,943.762207 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1610.741821,910.553955 
    C1610.848145,909.829590 1610.923950,909.281982 1611.017578,908.318665 
    C1611.362305,908.679016 1611.689209,909.455078 1612.047607,910.576782 
    C1612.078979,910.922363 1612.020996,910.979858 1611.734375,910.990967 
    C1611.275635,911.006042 1611.103516,911.010071 1610.931274,911.014038 
    C1610.931274,911.014038 1610.711304,910.730652 1610.741821,910.553955 
  z"/>
  <path fill="#D5D5D5" opacity="1.000000" stroke="none" 
    d="
  M1604.098145,740.152405 
    C1604.734497,740.400818 1605.373413,740.982422 1606.009277,741.920959 
    C1605.371094,741.680481 1604.735962,741.083008 1604.098145,740.152405 
  z"/>
  <path fill="#CACACA" opacity="1.000000" stroke="none" 
    d="
  M1656.193848,864.594666 
    C1656.072510,864.983093 1655.615967,864.963928 1655.387939,864.977417 
    C1655.121338,864.213379 1655.082642,863.435791 1655.064819,862.268799 
    C1655.495483,862.654907 1655.905396,863.430603 1656.193848,864.594666 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1817.070557,857.649658 
    C1816.732788,857.542175 1816.368652,857.106018 1815.961426,856.374390 
    C1816.293701,856.492981 1816.668945,856.906982 1817.070557,857.649658 
  z"/>
  <path fill="#CFCFCF" opacity="1.000000" stroke="none" 
    d="
  M1517.658569,876.881287 
    C1518.185791,876.810791 1518.452026,876.880371 1519.120972,877.040833 
    C1519.496948,877.298645 1519.470215,877.465515 1519.279541,877.825562 
    C1518.573120,878.022217 1518.031006,878.025757 1517.082764,877.988525 
    C1516.916992,877.639038 1517.157349,877.330139 1517.658569,876.881287 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1744.049316,642.955811 
    C1744.464233,643.319763 1744.765381,643.792664 1745.110352,644.565674 
    C1745.154297,644.865845 1744.991821,644.996704 1744.694336,644.883606 
    C1744.167725,644.274963 1743.938721,643.779419 1743.709595,643.283875 
    C1743.709595,643.283875 1743.935669,643.064697 1744.049316,642.955811 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1827.163086,865.617798 
    C1826.827515,865.523560 1826.415283,865.107849 1825.956299,864.382568 
    C1826.301758,864.480713 1826.694214,864.888489 1827.163086,865.617798 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1726.872070,626.887146 
    C1726.089111,627.198730 1725.318359,627.139465 1724.691772,626.613159 
    C1725.518677,626.269531 1726.201538,626.392883 1726.872070,626.887146 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1630.908325,947.252319 
    C1630.141602,947.289978 1629.370483,946.905518 1628.746460,946.008301 
    C1629.563599,945.940430 1630.233887,946.385315 1630.908325,947.252319 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1740.219482,753.902954 
    C1740.104004,753.381348 1740.323608,752.840881 1740.810303,752.166809 
    C1740.903198,752.650208 1740.728882,753.267151 1740.219482,753.902954 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1738.238281,755.890625 
    C1738.156982,755.367065 1738.407104,754.822693 1738.944580,754.165344 
    C1739.011230,754.658203 1738.790527,755.263977 1738.238281,755.890625 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M1630.095703,767.169678 
    C1630.382202,767.051147 1630.663818,767.251282 1631.071289,767.682739 
    C1630.828369,767.772095 1630.459473,767.630249 1630.095703,767.169678 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M1625.310669,763.291626 
    C1625.025879,762.836487 1625.052612,762.547424 1625.070312,761.822388 
    C1625.454834,761.654419 1625.848633,761.922485 1626.151855,762.547852 
    C1625.914917,763.089294 1625.768555,763.273499 1625.310669,763.291626 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M1712.196045,837.843811 
    C1711.877319,837.363586 1711.932861,836.830566 1712.449097,836.331360 
    C1712.796753,836.840454 1712.683594,837.315735 1712.196045,837.843811 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M1550.812012,848.063232 
    C1550.924805,848.338928 1550.735596,848.607544 1550.316895,848.977417 
    C1550.228394,848.737854 1550.369263,848.396973 1550.812012,848.063232 
  z"/>
  <path fill="#030303" opacity="1.000000" stroke="none" 
    d="
  M1051.518311,472.085510 
    C1051.518311,472.085510 1051.493652,472.003479 1051.410889,472.406616 
    C1054.336792,474.830017 1057.345459,476.850250 1060.375610,479.185791 
    C1061.611816,480.313660 1062.826538,481.126190 1064.034180,481.960388 
    C1064.026978,481.982025 1064.066528,481.957214 1064.162720,482.272766 
    C1066.791138,485.101074 1069.323486,487.613861 1071.865723,490.106384 
    C1071.875732,490.086090 1071.847900,490.111359 1071.834106,490.438599 
    C1072.526489,491.542267 1073.232544,492.318634 1074.005493,493.317719 
    C1074.072388,493.540405 1074.402832,493.867737 1074.395752,494.193756 
    C1075.267090,495.666077 1076.145630,496.812378 1077.137451,498.226929 
    C1077.360107,498.655670 1077.469360,498.816193 1077.496826,499.320435 
    C1078.846802,502.546722 1080.278564,505.429230 1081.707031,508.510468 
    C1081.703735,508.709167 1081.830566,509.085846 1081.702881,509.361908 
    C1082.192139,511.254639 1082.809204,512.871338 1083.433594,514.839722 
    C1083.581299,516.117676 1083.721680,517.044006 1083.678711,518.340881 
    C1084.219971,522.990967 1082.226929,523.951782 1078.196167,523.941772 
    C1028.955200,523.819824 979.713684,523.862671 930.472351,523.862793 
    C919.561584,523.862793 919.561584,523.862793 920.081970,512.827209 
    C920.179382,512.658264 920.148254,512.269470 920.364014,512.159546 
    C920.734680,511.362366 920.889587,510.675079 921.216431,509.579437 
    C921.299072,508.608185 921.209900,508.045349 921.120667,507.482483 
    C921.120667,507.482483 921.035339,507.493896 921.384399,507.429260 
    C921.822510,506.909821 921.911499,506.455017 922.246704,505.779388 
    C924.175964,502.038605 925.858826,498.518616 927.790894,494.762512 
    C929.042236,493.058044 930.044373,491.589722 931.331726,489.991821 
    C932.271606,488.849426 932.926331,487.836609 933.702637,486.820618 
    C933.824280,486.817474 933.831177,486.574188 934.116577,486.573486 
    C934.794739,485.991852 935.187378,485.410950 935.717468,484.802734 
    C935.854858,484.775482 935.883728,484.496857 936.198608,484.469269 
    C940.840881,481.065430 945.168152,477.689178 949.669556,474.272034 
    C949.843689,474.231140 949.968506,473.895874 950.173645,473.808167 
    C950.764526,473.542786 951.150330,473.365051 951.536072,473.187317 
    C951.536072,473.187317 951.922974,472.951569 952.418152,472.731873 
    C953.600708,472.210846 954.288086,471.909576 955.303772,471.553345 
    C957.113464,470.675781 958.594910,469.853149 960.482666,469.008423 
    C961.917419,468.680115 962.945740,468.373840 964.222168,468.161133 
    C965.028381,467.873932 965.586548,467.493164 966.116211,467.068970 
    C966.087646,467.025513 966.086060,467.129456 966.422791,467.147217 
    C967.179688,467.011505 967.599792,466.858063 968.405640,466.736084 
    C969.518860,466.546906 970.246399,466.326294 971.248291,466.214905 
    C972.176758,465.943665 972.830872,465.563171 973.632263,465.237732 
    C973.779541,465.292755 974.008057,465.076721 974.361694,465.121704 
    C975.158875,465.012878 975.602417,464.859070 976.371155,464.752625 
    C977.822754,464.273895 978.949158,463.747772 980.399902,463.019226 
    C980.928833,462.196625 981.309753,461.576996 981.311646,460.956207 
    C981.350708,448.334381 981.376099,435.712219 981.289978,423.090912 
    C981.283630,422.157745 980.412476,421.230530 979.563965,420.070770 
    C976.355042,419.738617 973.525513,419.636230 970.434326,419.322754 
    C968.108215,418.717224 966.043701,418.322815 963.703491,417.804230 
    C962.828918,417.664062 962.230042,417.648041 961.392090,417.418121 
    C959.426636,416.773193 957.700317,416.342194 955.709839,415.777771 
    C954.861328,415.607666 954.276917,415.570953 953.489502,415.308258 
    C951.856567,414.717651 950.426697,414.353058 948.768677,413.862122 
    C948.197815,413.734741 947.854980,413.733643 947.316162,413.497803 
    C946.380005,413.072357 945.639832,412.881592 944.625000,412.451172 
    C943.401062,412.059753 942.451660,411.908020 941.265381,411.505127 
    C938.667114,410.308655 936.305786,409.363373 933.705200,408.227570 
    C933.066833,407.980835 932.667725,407.924622 932.083252,407.608612 
    C930.792297,406.881042 929.686707,406.413239 928.160095,405.980835 
    C927.652100,406.284058 927.565063,406.551941 927.478088,406.819824 
    C927.478088,406.819824 927.513977,406.967346 927.800781,406.627869 
    C927.645020,405.748962 927.202454,405.209564 926.543335,404.384064 
    C918.228943,397.363342 910.131226,390.628784 901.962036,383.630066 
    C901.341492,382.905273 900.792358,382.444550 900.210510,381.644897 
    C899.457214,380.454315 898.736572,379.602692 897.991333,378.601562 
    C897.865417,378.273865 897.728210,378.129944 897.435364,377.658539 
    C895.245422,374.806091 893.175110,372.315460 891.104797,369.824829 
    C891.104797,369.824829 891.068237,369.922394 891.341309,369.628387 
    C888.356506,359.519196 885.267395,349.641174 881.660889,339.955872 
    C881.113159,338.484985 878.181152,337.091492 876.321899,337.051178 
    C864.349548,336.791595 852.367615,336.805756 840.391235,336.944672 
    C821.743225,337.160980 807.974976,328.921539 798.494385,312.885193 
    C798.077820,312.035950 797.573975,311.481079 797.057739,310.932800 
    C797.045288,310.939423 797.072021,310.929993 797.081421,310.525146 
    C796.181702,304.426178 794.501038,298.734589 794.482544,293.037598 
    C794.289185,233.430862 794.413086,173.823105 794.264343,114.216095 
    C794.252563,109.491798 795.792053,108.296265 800.289734,108.357597 
    C828.530090,108.742699 856.773804,108.881973 885.284302,109.173889 
    C885.918274,109.292870 886.284363,109.340538 886.805176,109.686218 
    C887.977417,110.314148 888.994995,110.644066 890.290283,111.097534 
    C891.310608,111.541595 892.053162,111.862091 892.875000,112.490753 
    C893.715332,113.031334 894.476440,113.263756 895.456421,113.749710 
    C897.111145,115.040596 898.546997,116.077934 900.033875,117.438614 
    C901.645447,118.924385 903.205994,120.086823 905.114136,121.546371 
    C905.951538,121.631287 906.441284,121.419083 906.930969,121.206879 
    C906.930969,121.206886 906.954163,121.100395 906.764954,121.484886 
    C907.013184,121.963310 907.450623,122.057243 907.888062,122.151169 
    C907.888062,122.151169 907.909546,122.034256 907.500977,122.251747 
    C907.198853,122.967651 907.305298,123.466064 907.299500,124.220001 
    C908.303467,125.762909 909.419556,127.050301 910.708618,128.579407 
    C911.127380,129.132126 911.373230,129.443130 911.528564,130.090881 
    C912.586182,132.331085 913.734253,134.234528 914.901550,136.131485 
    C914.920776,136.125000 914.874695,136.124161 914.892700,136.493073 
    C915.529663,138.351898 916.148560,139.841812 916.762451,141.515869 
    C916.757568,141.700012 916.960754,142.007339 916.919495,142.296219 
    C917.135315,143.051910 917.392456,143.518723 917.629395,144.321075 
    C917.657532,145.101761 917.705811,145.546906 917.554077,146.159180 
    C917.584778,146.883194 917.815491,147.440079 918.094116,148.201538 
    C918.142090,148.406128 918.344116,148.774673 918.209900,149.019333 
    C918.711243,149.393967 919.346863,149.523941 920.447021,149.724579 
    C951.669983,149.806580 982.428345,149.840897 1013.186707,149.821686 
    C1036.460205,149.807159 1059.733643,149.724319 1083.081543,149.904510 
    C1083.578613,149.773804 1084.001465,149.410446 1084.609375,148.756577 
    C1084.899658,148.020432 1085.004883,147.574783 1085.382812,146.967896 
    C1085.586548,145.776047 1085.517456,144.745453 1085.507812,143.378174 
    C1085.629272,142.360794 1085.691162,141.680069 1086.053101,140.801956 
    C1087.540649,137.731277 1088.728027,134.857986 1090.056396,131.740570 
    C1090.143677,131.316406 1090.089722,131.136353 1090.035767,130.956284 
    C1090.035767,130.956284 1089.959473,130.978699 1090.227051,130.824310 
    C1092.288330,128.514038 1093.975342,126.257736 1095.894043,124.219337 
    C1105.094482,114.444626 1115.673584,107.865654 1129.818237,108.028687 
    C1154.304810,108.310905 1178.797729,108.221931 1203.285645,108.009567 
    C1208.140869,107.967461 1209.605713,109.545311 1209.596069,114.308250 
    C1209.475586,173.616318 1209.571655,232.924866 1209.415039,292.232758 
    C1209.402100,297.135223 1208.456543,302.179779 1207.075928,306.904572 
    C1203.992676,317.455353 1196.070068,324.375366 1187.474121,330.963196 
    C1186.794067,331.280640 1186.436523,331.531128 1185.744385,331.747681 
    C1182.700317,332.991180 1179.991211,334.268646 1176.947510,335.501770 
    C1175.740479,335.644104 1174.868042,335.830811 1173.667969,335.908203 
    C1169.734863,336.120422 1166.131714,336.681976 1162.523315,336.719177 
    C1150.959106,336.838440 1139.392578,336.718842 1127.827881,336.813904 
    C1126.169312,336.827515 1124.516357,337.516083 1122.917603,337.931335 
    C1122.974487,337.970398 1122.891968,337.859802 1122.596069,337.946350 
    C1121.847168,339.694733 1121.394043,341.356567 1120.812744,343.288879 
    C1120.663696,344.152740 1120.642944,344.746155 1120.398560,345.548126 
    C1119.747070,347.182373 1119.319336,348.608032 1118.766113,350.237183 
    C1118.524902,350.757233 1118.535767,351.069427 1118.428223,351.633362 
    C1116.480103,356.259491 1114.777100,360.629517 1112.919800,365.255798 
    C1112.464844,366.246246 1112.163940,366.980408 1111.555176,367.856781 
    C1109.996216,370.350952 1108.745483,372.702850 1107.299561,375.257355 
    C1107.071411,375.644592 1107.038452,375.829193 1106.705444,376.157349 
    C1105.191162,378.193512 1103.976929,380.086060 1102.585938,382.055969 
    C1102.179565,382.427307 1101.949951,382.721252 1101.411377,383.205322 
    C1096.839844,387.779022 1092.577393,392.162659 1088.014648,396.689392 
    C1077.531616,404.627747 1066.301270,410.365234 1053.736572,413.878357 
    C1051.804077,414.400208 1050.135010,415.043427 1048.215088,415.642944 
    C1047.648438,415.708221 1047.332275,415.817200 1046.747314,415.808960 
    C1044.787231,416.336823 1043.095825,416.981903 1041.100586,417.579834 
    C1040.202637,417.667358 1039.608643,417.802002 1038.715820,417.810272 
    C1036.072144,418.322937 1033.727173,418.962006 1030.981445,419.537476 
    C1028.390015,419.661407 1026.199463,419.848938 1023.640381,420.036682 
    C1022.791016,421.195587 1021.902039,422.350891 1021.892395,423.513489 
    C1021.790161,435.779083 1021.776855,448.046356 1021.902039,460.311523 
    C1021.915527,461.627808 1022.714050,463.869049 1023.566223,464.093201 
    C1029.343872,465.613007 1035.233643,466.705872 1041.087280,467.936707 
    C1041.379761,468.002594 1041.672241,468.068451 1042.351196,468.298798 
    C1042.737671,468.463257 1042.739990,468.483551 1042.739990,468.483551 
    C1042.739990,468.483551 1042.961182,468.784515 1043.161865,469.216064 
    C1045.250610,470.402374 1047.138916,471.157166 1049.422363,472.150818 
    C1050.384644,472.288269 1050.951416,472.186890 1051.518311,472.085510 
  M947.101013,368.304932 
    C947.101013,368.304932 947.379456,368.308563 947.827026,368.855591 
    C957.417297,374.040833 967.628418,377.012451 978.827393,377.986877 
    C979.892151,378.039154 980.956970,378.091431 982.947815,378.362183 
    C985.134705,378.275085 987.321533,378.187988 989.523499,378.026611 
    C989.523499,378.026611 989.467102,378.077240 989.988708,378.861816 
    C999.393860,378.723633 1008.798950,378.585449 1018.863281,378.513550 
    C1019.508423,378.384552 1020.153503,378.255554 1021.392334,378.487457 
    C1022.406982,378.138458 1023.421631,377.789459 1025.305908,377.401428 
    C1041.525146,376.147705 1056.183350,370.890533 1068.087280,359.565643 
    C1071.577759,356.244965 1073.832764,351.625519 1076.630005,347.584747 
    C1076.632446,347.581329 1076.288574,347.278687 1076.076050,347.210632 
    C1075.965576,347.175293 1075.788452,347.347351 1076.439941,346.328766 
    C1077.032593,345.645477 1077.625122,344.962219 1078.655151,343.950104 
    C1079.110229,342.635651 1079.565308,341.321167 1080.229492,339.704651 
    C1080.229492,339.704651 1080.196533,339.338715 1080.739136,339.062592 
    C1080.919189,338.337830 1081.099243,337.613068 1081.625610,336.335480 
    C1081.670044,335.906799 1081.714478,335.478119 1082.066895,334.411163 
    C1082.057373,333.944672 1082.047974,333.478149 1082.224976,332.672119 
    C1082.224976,332.672119 1082.167603,332.288971 1082.706177,331.919006 
    C1082.865356,330.907959 1083.024414,329.896881 1083.517578,328.137146 
    C1083.593140,326.775452 1083.668701,325.413727 1084.098267,323.350159 
    C1084.605469,318.898376 1085.536865,314.448151 1085.553223,309.994568 
    C1085.692871,271.871094 1085.617065,233.746826 1085.767456,195.623428 
    C1085.782471,191.825043 1084.515625,190.791656 1080.889160,190.797470 
    C1027.948364,190.882355 975.007568,190.877060 922.066772,190.807877 
    C918.682556,190.803467 917.444763,191.812149 917.457214,195.367996 
    C917.593445,234.323929 917.529175,273.280609 917.692688,312.236328 
    C917.708252,315.945282 918.894653,319.649323 919.499207,324.013763 
    C919.577148,324.667480 919.655090,325.321228 919.374512,326.600311 
    C920.755066,330.940125 922.135681,335.279938 923.153931,340.430389 
    C924.385498,342.955444 925.617004,345.480499 926.526550,347.864899 
    C926.590759,347.684052 926.655029,347.503174 926.719238,347.322327 
    C926.827637,347.532349 926.936035,347.742371 926.999634,347.935364 
    C926.999634,347.935364 926.963562,347.966797 926.790283,348.661591 
    C926.962158,349.095459 927.133972,349.529297 927.490295,350.472656 
    C928.015625,350.922760 928.541016,351.372894 929.205872,352.503662 
    C931.768494,355.342499 934.331055,358.181305 937.064148,361.595551 
    C937.720581,361.972198 938.377075,362.348877 939.423096,363.228271 
    C940.275391,363.821655 941.127625,364.415070 942.269836,365.604126 
    C943.845886,366.418152 945.421875,367.232178 947.101013,368.304932 
  M1128.819336,295.239777 
    C1141.548950,295.166656 1154.278442,295.093536 1167.754883,294.966614 
    C1168.282715,292.999512 1169.264648,291.033813 1169.270752,289.065094 
    C1169.367065,257.749512 1169.338501,226.433548 1169.338501,195.117661 
    C1169.338379,181.625183 1169.275146,168.132202 1169.378052,154.640518 
    C1169.407593,150.774979 1168.173096,148.679810 1163.961792,148.716385 
    C1152.635620,148.814789 1141.307129,148.689331 1129.982422,148.850922 
    C1128.892944,148.866486 1127.823120,150.266357 1126.594604,151.947815 
    C1126.587280,197.980759 1126.566162,244.013702 1126.630493,290.046539 
    C1126.632812,291.647064 1127.488647,293.246429 1128.819336,295.239777 
  M876.066040,149.814499 
    C862.690308,149.779602 849.314575,149.744690 835.215454,149.931870 
    C834.702881,151.423767 833.745056,152.914886 833.742432,154.407684 
    C833.663086,199.730835 833.708862,245.054214 833.626099,290.377350 
    C833.618469,294.565063 835.370361,295.946930 839.341614,295.897064 
    C849.837646,295.765320 860.346985,295.575928 870.829590,295.973541 
    C875.996460,296.169525 877.237671,294.491425 877.216492,289.483032 
    C877.027283,244.827057 877.111206,200.169937 877.086670,155.513184 
    C877.085815,153.873734 876.796875,152.234451 876.066040,149.814499 
  z"/>
  <path fill="#8A8A8A" opacity="1.000000" stroke="none" 
    d="
  M885.016418,109.102562 
    C856.773804,108.881973 828.530090,108.742699 800.289734,108.357597 
    C795.792053,108.296265 794.252563,109.491798 794.264343,114.216095 
    C794.413086,173.823105 794.289185,233.430862 794.482544,293.037598 
    C794.501038,298.734589 796.181702,304.426178 796.806641,310.569397 
    C796.338318,311.039734 796.153992,311.060974 795.969727,311.082184 
    C793.501648,307.313293 791.839355,303.451904 791.849854,298.679504 
    C791.987793,236.084778 791.968201,173.489670 792.291992,110.133713 
    C794.192688,108.580902 795.785950,107.107056 797.386902,107.098801 
    C824.463501,106.959152 851.541260,106.954582 878.617859,107.094696 
    C880.754150,107.105751 882.883728,108.403038 885.016418,109.102562 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M1187.796631,330.896179 
    C1196.070068,324.375366 1203.992676,317.455353 1207.075928,306.904572 
    C1208.456543,302.179779 1209.402100,297.135223 1209.415039,292.232758 
    C1209.571655,232.924866 1209.475586,173.616318 1209.596069,114.308250 
    C1209.605713,109.545311 1208.140869,107.967461 1203.285645,108.009567 
    C1178.797729,108.221931 1154.304810,108.310905 1129.818237,108.028687 
    C1115.673584,107.865654 1105.094482,114.444626 1095.894043,124.219337 
    C1093.975342,126.257736 1092.288330,128.514038 1090.228516,130.864044 
    C1096.315430,118.828903 1106.125977,110.592178 1119.699707,106.282852 
    C1149.755615,106.722038 1179.121094,106.786743 1208.486572,106.809296 
    C1209.071655,106.809746 1209.657104,106.317146 1210.242310,106.054565 
    C1210.503784,105.922264 1210.719482,105.975548 1210.908691,106.895355 
    C1210.974487,110.071037 1211.060791,112.565781 1211.061157,115.060532 
    C1211.068970,168.469376 1211.117676,221.878326 1211.021606,275.286987 
    C1211.003662,285.210144 1210.395386,295.132233 1210.059570,305.054810 
    C1209.356689,307.463898 1208.843384,309.948730 1207.916138,312.268188 
    C1204.888672,319.841492 1199.195190,325.409271 1193.434326,330.876160 
    C1192.978760,331.308533 1191.854980,331.036804 1190.246704,331.039124 
    C1188.900024,330.955994 1188.348267,330.926086 1187.796631,330.896179 
  z"/>
  <path fill="#F6F6F6" opacity="1.000000" stroke="none" 
    d="
  M917.754089,145.992035 
    C917.705811,145.546906 917.657532,145.101761 917.981812,144.342148 
    C918.583191,143.972565 918.811951,143.917435 919.040710,143.862289 
    C920.923340,146.798767 923.688049,147.072281 926.941040,147.064865 
    C978.709656,146.946701 1030.478516,146.949265 1083.163086,146.882629 
    C1084.422607,146.937042 1084.766479,147.033096 1085.110107,147.129150 
    C1085.004883,147.574783 1084.899658,148.020432 1084.306519,148.616058 
    C1083.548096,149.068008 1083.277710,149.369949 1083.007202,149.671875 
    C1059.733643,149.724319 1036.460205,149.807159 1013.186707,149.821686 
    C982.428345,149.840897 951.669983,149.806580 920.415283,149.431793 
    C919.393982,148.970444 918.869080,148.872559 918.344116,148.774673 
    C918.344116,148.774673 918.142090,148.406128 918.322510,148.060303 
    C918.253357,147.140350 918.003723,146.566193 917.754089,145.992035 
  z"/>
  <path fill="#989898" opacity="1.000000" stroke="none" 
    d="
  M919.984558,512.996155 
    C919.561584,523.862793 919.561584,523.862793 930.472351,523.862793 
    C979.713684,523.862671 1028.955200,523.819824 1078.196167,523.941772 
    C1082.226929,523.951782 1084.219971,522.990967 1083.974609,518.551819 
    C1086.563965,524.537109 1086.051270,525.300232 1079.535522,525.301697 
    C1027.466553,525.313416 975.397583,525.322754 923.328674,525.252441 
    C921.265869,525.249695 919.204163,524.438171 917.141907,524.003418 
    C917.336487,520.336548 917.531006,516.669556 918.497437,512.989990 
    C919.507751,512.983643 919.746155,512.989868 919.984558,512.996155 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M796.004272,311.464081 
    C796.153992,311.060974 796.338318,311.039734 796.797302,310.974243 
    C797.072021,310.929993 797.045288,310.939423 796.997559,311.221252 
    C797.435608,312.061951 797.921326,312.620758 798.407104,313.179565 
    C807.974976,328.921539 821.743225,337.160980 840.391235,336.944672 
    C852.367615,336.805756 864.349548,336.791595 876.321899,337.051178 
    C878.181152,337.091492 881.113159,338.484985 881.660889,339.955872 
    C885.267395,349.641174 888.356506,359.519196 891.391052,369.612885 
    C890.674072,369.925232 889.805908,370.120209 889.741028,369.969543 
    C887.684509,365.190643 883.650452,361.247467 884.958984,355.066589 
    C885.445984,352.766266 883.041931,349.857117 881.965820,347.221619 
    C880.999023,344.854095 880.045471,342.481140 878.747864,339.274475 
    C878.446594,339.256714 877.019775,339.101898 875.592712,339.099823 
    C862.784119,339.081116 849.972412,338.911865 837.167664,339.133667 
    C820.551392,339.421509 808.072693,332.012054 798.632874,318.903595 
    C797.221985,316.944366 796.876892,314.217651 796.004272,311.464081 
  z"/>
  <path fill="#E2E2E2" opacity="1.000000" stroke="none" 
    d="
  M917.115234,524.439453 
    C919.204163,524.438171 921.265869,525.249695 923.328674,525.252441 
    C975.397583,525.322754 1027.466553,525.313416 1079.535522,525.301697 
    C1086.051270,525.300232 1086.563965,524.537109 1084.157959,518.181213 
    C1083.721680,517.044006 1083.581299,516.117676 1083.593994,514.471802 
    C1083.108276,512.196777 1082.469482,510.641327 1081.830566,509.085846 
    C1081.830566,509.085846 1081.703735,508.709167 1081.817505,508.080078 
    C1081.811890,505.975739 1081.692627,504.500549 1081.573242,503.025330 
    C1082.310547,504.460205 1083.341797,505.819580 1083.733154,507.343323 
    C1085.243652,513.225647 1086.549805,519.160522 1088.126709,525.908936 
    C1084.503418,525.908936 1082.080811,525.908875 1079.658203,525.908936 
    C1026.911011,525.909546 974.163879,525.918457 921.416748,525.867493 
    C919.973633,525.866150 918.531250,525.220703 917.115234,524.439453 
  z"/>
  <path fill="#F6F6F6" opacity="1.000000" stroke="none" 
    d="
  M1210.430176,304.885468 
    C1210.395386,295.132233 1211.003662,285.210144 1211.021606,275.286987 
    C1211.117676,221.878326 1211.068970,168.469376 1211.061157,115.060532 
    C1211.060791,112.565781 1210.974487,110.071037 1210.947998,107.072464 
    C1211.311157,108.115196 1211.953003,109.661507 1211.954346,111.208359 
    C1212.007202,174.190506 1212.010864,237.172668 1211.954590,300.154816 
    C1211.953247,301.675568 1211.202148,303.195709 1210.430176,304.885468 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M1054.000000,413.999695 
    C1066.301270,410.365234 1077.531616,404.627747 1088.473145,396.827515 
    C1089.543945,396.888733 1089.855957,396.954956 1090.168091,397.021210 
    C1085.925781,400.369141 1081.971680,404.203064 1077.363770,406.934265 
    C1072.317261,409.925507 1066.788574,412.237885 1061.246094,414.220612 
    C1055.621826,416.232666 1049.759155,417.625580 1043.937256,419.025146 
    C1037.602295,420.548065 1031.194092,421.766571 1024.364868,422.792145 
    C1023.944275,421.656494 1023.976624,420.846466 1024.008911,420.036469 
    C1026.199463,419.848938 1028.390015,419.661407 1031.405762,419.667603 
    C1034.492188,419.219757 1036.753296,418.578186 1039.014526,417.936646 
    C1039.608643,417.802002 1040.202637,417.667358 1041.501587,417.701691 
    C1043.809692,417.222504 1045.412964,416.574341 1047.016235,415.926178 
    C1047.332275,415.817200 1047.648438,415.708221 1048.598633,415.749695 
    C1050.821899,415.266663 1052.411011,414.633179 1054.000000,413.999695 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M1187.474121,330.963196 
    C1188.348267,330.926086 1188.900024,330.955994 1189.867188,331.010559 
    C1189.124023,332.278442 1188.170898,334.240662 1186.771484,334.640442 
    C1180.706543,336.372833 1174.552734,338.632324 1168.355103,338.893951 
    C1153.780762,339.509186 1139.162598,339.091034 1125.962402,339.091034 
    C1121.350220,349.977814 1117.090088,360.033325 1112.401367,369.751038 
    C1111.936279,368.847015 1111.899780,368.280792 1111.863159,367.714539 
    C1112.163940,366.980408 1112.464844,366.246246 1113.228394,365.090576 
    C1115.351807,360.238434 1117.012573,355.807831 1118.673340,351.377228 
    C1118.535767,351.069427 1118.524902,350.757233 1119.074219,350.020325 
    C1119.879272,348.179840 1120.250610,346.759674 1120.622070,345.339539 
    C1120.642944,344.746155 1120.663696,344.152740 1121.104248,343.084045 
    C1121.979858,341.025787 1122.435913,339.442780 1122.891968,337.859802 
    C1122.891968,337.859802 1122.974487,337.970398 1123.395142,337.967529 
    C1138.249756,337.967712 1152.684570,338.056458 1167.116577,337.886230 
    C1169.416504,337.859131 1171.702881,336.669586 1173.995483,336.017487 
    C1174.868042,335.830811 1175.740479,335.644104 1177.342896,335.611328 
    C1180.741577,334.437347 1183.410278,333.109467 1186.079102,331.781586 
    C1186.436523,331.531128 1186.794067,331.280640 1187.474121,330.963196 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M1023.640381,420.036682 
    C1023.976624,420.846466 1023.944275,421.656494 1023.963745,422.870056 
    C1024.015625,423.273590 1024.011963,423.658722 1023.705017,424.172943 
    C1023.312744,431.164001 1023.108093,437.642120 1023.177246,444.117310 
    C1023.240601,450.051178 1023.599670,455.981842 1023.828430,461.913940 
    C1029.444946,463.711212 1035.061401,465.508514 1040.882568,467.621277 
    C1035.233643,466.705872 1029.343872,465.613007 1023.566223,464.093201 
    C1022.714050,463.869049 1021.915527,461.627808 1021.902039,460.311523 
    C1021.776855,448.046356 1021.790161,435.779083 1021.892395,423.513489 
    C1021.902039,422.350891 1022.791016,421.195587 1023.640381,420.036682 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M885.284302,109.173889 
    C882.883728,108.403038 880.754150,107.105751 878.617859,107.094696 
    C851.541260,106.954582 824.463501,106.959152 797.386902,107.098801 
    C795.785950,107.107056 794.192688,108.580902 792.370483,109.668579 
    C792.145203,108.803650 792.145203,107.642899 792.145203,105.968468 
    C793.766418,105.968468 795.378296,105.968460 796.990173,105.968475 
    C823.466370,105.968643 849.945190,106.172417 876.416992,105.831627 
    C883.388428,105.741882 889.361877,107.467705 895.015686,111.569237 
    C895.018250,111.981476 894.991943,112.008781 894.623291,112.042236 
    C893.768372,112.111336 893.282043,112.146973 892.795715,112.182602 
    C892.053162,111.862091 891.310608,111.541595 890.158081,110.772324 
    C888.715515,110.011772 887.682983,109.699997 886.650452,109.388214 
    C886.284363,109.340538 885.918274,109.292870 885.284302,109.173889 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M980.075500,463.221680 
    C978.949158,463.747772 977.822754,464.273895 976.375732,464.491760 
    C976.037537,463.836548 976.020020,463.489563 976.002502,463.142548 
    C976.982422,461.683105 978.782471,460.240143 978.812134,458.761597 
    C979.046265,447.115967 978.942200,435.463470 978.942200,422.660400 
    C974.654358,422.135223 970.386047,421.884552 966.242371,421.029938 
    C961.915710,420.137604 957.702759,418.685059 953.452209,417.435883 
    C950.878052,416.679382 948.327087,415.844025 945.382019,414.737823 
    C944.998352,414.431519 944.997559,414.007996 945.419983,413.992310 
    C946.398987,413.895264 946.955566,413.813904 947.512146,413.732544 
    C947.854980,413.733643 948.197815,413.734741 948.992065,414.159607 
    C950.859802,414.900330 952.276123,415.217285 953.692444,415.534271 
    C954.276917,415.570953 954.861328,415.607666 955.932983,416.090515 
    C958.157104,416.901825 959.894165,417.266937 961.631165,417.632019 
    C962.230042,417.648041 962.828918,417.664062 963.937500,418.115173 
    C966.530090,418.878113 968.612976,419.205963 970.695923,419.533813 
    C973.525513,419.636230 976.355042,419.738617 979.547546,420.518921 
    C979.965515,435.205139 980.020508,449.213379 980.075500,463.221680 
  z"/>
  <path fill="#E9E9E9" opacity="1.000000" stroke="none" 
    d="
  M1209.748047,106.029099 
    C1209.657104,106.317146 1209.071655,106.809746 1208.486572,106.809296 
    C1179.121094,106.786743 1149.755615,106.722038 1120.066895,106.356888 
    C1149.580322,106.035797 1179.416992,106.019714 1209.748047,106.029099 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M902.033508,383.894226 
    C910.131226,390.628784 918.228943,397.363342 926.039795,404.484802 
    C925.415710,404.924957 925.078552,404.978241 924.741333,405.031555 
    C915.974243,400.950104 908.887756,394.768036 902.452698,386.801086 
    C902.126709,385.417755 902.080078,384.655975 902.033508,383.894226 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1090.470825,396.872253 
    C1089.855957,396.954956 1089.543945,396.888733 1088.773438,396.684387 
    C1092.577393,392.162659 1096.839844,387.779022 1101.488281,383.754822 
    C1101.930298,384.478973 1101.986084,384.843658 1102.041870,385.208344 
    C1098.285767,389.046661 1094.529663,392.885010 1090.470825,396.872253 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M1023.892944,461.455383 
    C1023.599670,455.981842 1023.240601,450.051178 1023.177246,444.117310 
    C1023.108093,437.642120 1023.312744,431.164001 1023.632751,424.351440 
    C1023.897461,436.342743 1023.927429,448.669800 1023.892944,461.455383 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M949.495422,474.312927 
    C945.168152,477.689178 940.840881,481.065430 936.256104,484.151886 
    C936.646423,482.554901 937.294128,481.247711 937.941895,479.940491 
    C937.941895,479.940521 938.000000,479.995117 938.321045,480.012939 
    C939.092468,479.556946 939.542847,479.083160 939.993164,478.609375 
    C939.993164,478.609375 939.928101,478.411316 940.307068,478.290771 
    C941.116455,477.755096 941.546814,477.339996 941.977234,476.924866 
    C941.977234,476.924866 941.973877,476.995911 942.310364,477.005951 
    C943.746277,475.986633 944.845703,474.957245 945.945129,473.927856 
    C945.945129,473.927856 946.004395,473.967529 946.415283,474.032928 
    C947.715881,474.169861 948.605652,474.241394 949.495422,474.312927 
  z"/>
  <path fill="#C3C3C3" opacity="1.000000" stroke="none" 
    d="
  M944.997559,414.007996 
    C944.997559,414.007996 944.998352,414.431519 944.999023,414.643280 
    C939.278198,412.423553 933.556580,409.992065 927.656555,407.190186 
    C927.565063,406.551941 927.652100,406.284058 928.421387,406.348267 
    C930.158691,407.076385 931.213684,407.472382 932.268677,407.868378 
    C932.667725,407.924622 933.066833,407.980835 933.806946,408.546783 
    C936.599426,409.956421 939.050903,410.856354 941.502319,411.756287 
    C942.451660,411.908020 943.401062,412.059753 944.618286,412.671753 
    C944.931702,413.422943 944.968872,413.714935 944.997559,414.007996 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M927.541687,494.998657 
    C925.858826,498.518616 924.175964,502.038605 922.043030,505.755371 
    C921.593018,505.952148 921.182922,505.939911 921.182922,505.939911 
    C920.319153,502.117310 922.012024,499.240417 925.121155,496.369446 
    C926.273865,495.695190 926.907776,495.346924 927.541687,494.998657 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1060.354248,478.870514 
    C1057.345459,476.850250 1054.336792,474.830017 1051.370239,472.420197 
    C1056.368042,472.004608 1059.986084,474.539917 1062.985352,478.620758 
    C1062.909180,479.127502 1062.689087,479.409668 1062.404785,479.313751 
    C1061.531860,479.102051 1060.942993,478.986298 1060.354248,478.870514 
  z"/>
  <path fill="#989898" opacity="1.000000" stroke="none" 
    d="
  M1071.855713,490.126648 
    C1069.323486,487.613861 1066.791138,485.101074 1064.541748,482.264038 
    C1065.563599,481.940613 1066.302734,481.941437 1067.041870,481.942261 
    C1067.041870,481.942261 1067.009766,482.000214 1066.921631,482.324554 
    C1068.378174,484.106781 1069.922852,485.564697 1071.467529,487.022614 
    C1071.467529,487.022614 1071.509277,486.986633 1071.576660,487.399353 
    C1071.714600,488.583588 1071.785156,489.355133 1071.855713,490.126648 
  z"/>
  <path fill="#9C9C9C" opacity="1.000000" stroke="none" 
    d="
  M1089.915405,131.984680 
    C1088.728027,134.857986 1087.540649,137.731277 1085.833496,140.913727 
    C1085.313965,141.222870 1084.898193,140.958282 1084.898193,140.958282 
    C1085.933228,137.960617 1086.968262,134.962952 1088.676636,131.962494 
    C1089.538452,131.968018 1089.726929,131.976349 1089.915405,131.984680 
  z"/>
  <path fill="#989898" opacity="1.000000" stroke="none" 
    d="
  M1081.553101,502.982208 
    C1081.692627,504.500549 1081.811890,505.975739 1081.820801,507.881348 
    C1080.278564,505.429230 1078.846802,502.546722 1077.742432,499.464417 
    C1078.733032,499.496765 1079.395996,499.728882 1080.058960,499.960999 
    C1080.058960,499.960999 1080.012573,500.005096 1079.961426,500.363464 
    C1080.432983,501.487030 1080.955688,502.252258 1081.478394,503.017487 
    C1081.478394,503.017487 1081.532959,502.939087 1081.553101,502.982208 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M891.034302,370.185669 
    C893.175110,372.315460 895.245422,374.806091 896.987366,377.658142 
    C896.065796,378.053864 895.472595,378.088135 894.879333,378.122375 
    C894.879333,378.122375 894.916565,378.006714 894.851562,377.833862 
    C894.637756,377.357666 894.408325,377.138977 894.098206,377.004913 
    C894.098206,377.004913 893.971741,376.603394 893.965454,376.022156 
    C893.265930,374.656769 892.572754,373.872650 891.879578,373.088562 
    C891.879578,373.088531 891.959167,373.033325 891.875122,372.846985 
    C891.638062,372.358429 891.406372,372.139435 891.096008,372.003723 
    C891.051880,371.518005 891.007812,371.032288 891.034302,370.185669 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M937.611694,480.038086 
    C937.294128,481.247711 936.646423,482.554901 935.941162,484.179474 
    C935.883728,484.496857 935.854858,484.775482 935.450684,484.845886 
    C934.641357,485.468903 934.236267,486.021545 933.831177,486.574188 
    C933.831177,486.574188 933.824280,486.817474 933.395081,486.842712 
    C932.366638,486.968170 931.767334,487.068359 931.089478,487.092407 
    C931.010925,487.016327 930.852905,486.865021 930.852905,486.864990 
    C932.995728,484.621918 935.138611,482.378815 937.611694,480.038086 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M927.790894,494.762512 
    C926.907776,495.346924 926.273865,495.695190 925.367676,496.075073 
    C926.806213,493.143890 928.516907,490.181030 930.540283,487.041595 
    C930.852905,486.865021 931.010925,487.016327 931.063721,487.457397 
    C931.093140,488.639435 931.069824,489.380402 931.046570,490.121399 
    C930.044373,491.589722 929.042236,493.058044 927.790894,494.762512 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M963.974060,468.067566 
    C962.945740,468.373840 961.917419,468.680115 960.119629,469.022552 
    C958.187012,469.359314 957.023926,469.659912 955.860779,469.960449 
    C958.970154,468.640320 962.079529,467.320251 965.605957,466.320312 
    C966.023010,466.640442 966.086060,467.129456 966.086060,467.129456 
    C966.086060,467.129456 966.087646,467.025513 965.855225,467.033264 
    C965.073242,467.383179 964.523682,467.725372 963.974060,468.067566 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M899.982788,117.115257 
    C898.546997,116.077934 897.111145,115.040596 895.442078,113.493881 
    C895.136536,112.659264 895.064270,112.334023 894.991943,112.008781 
    C894.991943,112.008781 895.018250,111.981476 895.031494,111.967819 
    C897.064331,113.081398 899.083923,114.208626 901.021240,115.845352 
    C900.620178,116.608315 900.301453,116.861778 899.982788,117.115257 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1071.865723,490.106384 
    C1071.785156,489.355133 1071.714600,488.583588 1071.591797,487.422302 
    C1074.305176,489.096649 1077.774170,490.684357 1077.019531,495.556702 
    C1077.015747,495.983643 1076.986450,496.008514 1076.739258,495.851196 
    C1075.795654,495.085175 1075.099243,494.476440 1074.402832,493.867737 
    C1074.402832,493.867737 1074.072388,493.540405 1074.034424,492.983124 
    C1073.280396,491.654358 1072.564087,490.882874 1071.847900,490.111389 
    C1071.847900,490.111359 1071.875732,490.086090 1071.865723,490.106384 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M1111.555176,367.856781 
    C1111.899780,368.280792 1111.936279,368.847015 1112.009399,369.838470 
    C1112.045898,370.263672 1112.044800,370.594116 1111.679199,370.920807 
    C1110.888672,372.271973 1110.463745,373.296448 1110.038940,374.320923 
    C1110.038940,374.320923 1110.060547,374.591797 1109.696533,374.733307 
    C1108.719971,374.934784 1108.107300,374.994751 1107.494629,375.054749 
    C1108.745483,372.702850 1109.996216,370.350952 1111.555176,367.856781 
  z"/>
  <path fill="#8A8A8A" opacity="1.000000" stroke="none" 
    d="
  M900.033813,117.438599 
    C900.301453,116.861778 900.620178,116.608315 901.208008,116.190704 
    C901.477051,116.026573 901.467773,115.984947 901.537964,116.397598 
    C902.232666,117.223106 902.857239,117.635956 903.481812,118.048805 
    C903.481812,118.048798 903.499390,117.999962 903.585144,118.368042 
    C904.036133,119.573837 904.401306,120.411537 904.766479,121.249252 
    C903.205994,120.086823 901.645447,118.924385 900.033813,117.438599 
  z"/>
  <path fill="#8A8A8A" opacity="1.000000" stroke="none" 
    d="
  M916.767456,141.331726 
    C916.148560,139.841812 915.529663,138.351898 915.224365,136.456818 
    C915.981079,136.039429 916.424072,136.027206 916.867188,136.014984 
    C917.255066,137.050720 917.642944,138.086472 917.779663,139.663971 
    C917.274841,140.581070 917.021179,140.956390 916.767456,141.331726 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M1102.762695,381.978638 
    C1103.976929,380.086060 1105.191162,378.193512 1106.686035,376.529541 
    C1106.657715,377.947662 1106.348755,379.137146 1106.039795,380.326660 
    C1106.039673,380.326630 1106.064453,380.587738 1105.668945,380.750793 
    C1104.436646,381.268768 1103.599609,381.623688 1102.762695,381.978638 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M1106.400757,380.224823 
    C1106.348755,379.137146 1106.657715,377.947662 1106.986084,376.385986 
    C1107.038452,375.829193 1107.071411,375.644592 1107.299561,375.257355 
    C1108.107300,374.994751 1108.719971,374.934784 1109.640625,374.857117 
    C1108.886475,376.600647 1107.824097,378.361816 1106.400757,380.224823 
  z"/>
  <path fill="#8A8A8A" opacity="1.000000" stroke="none" 
    d="
  M910.535645,128.337677 
    C909.419556,127.050301 908.303467,125.762909 907.820312,124.291405 
    C908.802795,124.085152 909.152283,124.063019 909.501831,124.040863 
    C910.014648,124.694183 910.527466,125.347511 910.881470,126.712067 
    C910.660278,127.728081 910.598022,128.032867 910.535645,128.337677 
  z"/>
  <path fill="#989898" opacity="1.000000" stroke="none" 
    d="
  M1049.027100,471.911987 
    C1047.138916,471.157166 1045.250610,470.402374 1043.305664,469.335205 
    C1044.633667,469.391998 1046.018555,469.761200 1047.875488,470.381653 
    C1048.573975,471.059265 1048.800537,471.485626 1049.027100,471.911987 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1071.295410,486.675781 
    C1069.922852,485.564697 1068.378174,484.106781 1066.944092,482.299255 
    C1068.410889,483.409363 1069.767090,484.869141 1071.295410,486.675781 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M974.008057,465.076721 
    C974.008057,465.076721 973.779541,465.292755 973.336853,465.187775 
    C972.254089,465.423767 971.614014,465.764740 970.973938,466.105713 
    C970.246399,466.326294 969.518860,466.546906 968.406250,466.476898 
    C968.016052,465.841003 968.011047,465.495758 968.005981,465.150513 
    C969.737671,464.776917 971.469421,464.403320 973.595947,464.328125 
    C973.990845,464.626556 974.008057,465.076721 974.008057,465.076721 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M955.646973,469.986206 
    C957.023926,469.659912 958.187012,469.359314 959.713257,469.044617 
    C958.594910,469.853149 957.113464,470.675781 955.301392,471.305725 
    C954.994446,470.783539 955.009888,470.453644 955.017090,470.123383 
    C955.017090,470.123383 955.433167,470.011902 955.646973,469.986206 
  z"/>
  <path fill="#F6F6F6" opacity="1.000000" stroke="none" 
    d="
  M1084.551880,141.112976 
    C1084.898193,140.958282 1085.313965,141.222870 1085.533447,141.111115 
    C1085.691162,141.680069 1085.629272,142.360794 1085.232056,143.487167 
    C1084.287231,144.433701 1083.677856,144.934586 1083.068359,145.435486 
    C1083.447388,144.046204 1083.826416,142.656921 1084.551880,141.112976 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M1102.585938,382.055969 
    C1103.599609,381.623688 1104.436646,381.268768 1105.614258,380.869934 
    C1104.898193,382.247955 1103.841431,383.669861 1102.413330,385.150085 
    C1101.986084,384.843658 1101.930298,384.478973 1101.797363,383.564758 
    C1101.949951,382.721252 1102.179565,382.427307 1102.585938,382.055969 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M901.962036,383.630096 
    C902.080078,384.655975 902.126709,385.417755 902.195068,386.562134 
    C900.875793,385.520752 899.534790,384.096710 898.527222,382.335968 
    C899.321472,381.994110 899.782288,381.989014 900.243164,381.983887 
    C900.792358,382.444550 901.341492,382.905273 901.962036,383.630096 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M945.579468,473.933746 
    C944.845703,474.957245 943.746277,475.986633 942.284119,476.981934 
    C943.018860,475.945129 944.116394,474.942383 945.579468,473.933746 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1079.946167,499.620544 
    C1079.395996,499.728882 1078.733032,499.496765 1077.824463,499.120667 
    C1077.469360,498.816193 1077.360107,498.655670 1077.171387,497.902069 
    C1077.056641,496.875458 1077.021606,496.441986 1076.986572,496.008514 
    C1076.986450,496.008514 1077.015747,495.983643 1077.029297,495.969971 
    C1077.973022,497.064209 1078.903198,498.172150 1079.946167,499.620544 
  z"/>
  <path fill="#8A8A8A" opacity="1.000000" stroke="none" 
    d="
  M1082.999268,145.599945 
    C1083.677856,144.934586 1084.287231,144.433701 1085.172607,143.823822 
    C1085.517456,144.745453 1085.586548,145.776047 1085.382935,146.967896 
    C1084.766479,147.033096 1084.422607,146.937042 1083.579834,146.642090 
    C1082.933838,146.238297 1082.883667,146.012039 1082.999268,145.599945 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M920.081970,512.827209 
    C919.746155,512.989868 919.507751,512.983643 918.910706,512.977417 
    C919.160156,511.279297 919.768311,509.581024 920.748535,507.682617 
    C921.209900,508.045349 921.299072,508.608185 920.938477,509.766785 
    C920.375244,510.998169 920.261780,511.633820 920.148254,512.269470 
    C920.148254,512.269470 920.179382,512.658264 920.081970,512.827209 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M910.708618,128.579407 
    C910.598022,128.032867 910.660278,127.728081 910.834106,126.969406 
    C911.891174,127.440987 912.836670,128.366455 913.896362,129.642700 
    C914.010681,129.993484 913.955261,130.048141 913.667236,130.151917 
    C912.792542,130.088516 912.205811,129.921310 911.619080,129.754120 
    C911.373230,129.443130 911.127380,129.132126 910.708618,128.579407 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1066.963989,481.617249 
    C1066.302734,481.941437 1065.563599,481.940613 1064.445557,481.948486 
    C1064.066528,481.957214 1064.026978,481.982025 1064.024170,481.661377 
    C1063.577393,480.697052 1063.133301,480.053345 1062.689087,479.409668 
    C1062.689087,479.409668 1062.909180,479.127502 1063.020020,478.987061 
    C1064.382690,479.661804 1065.634399,480.476990 1066.963989,481.617249 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M900.210510,381.644897 
    C899.782288,381.989014 899.321472,381.994110 898.515015,382.001923 
    C898.169495,382.004608 898.057617,381.534973 898.020386,380.912994 
    C897.994141,379.777679 898.005066,379.264374 898.015991,378.751038 
    C898.736572,379.602692 899.457214,380.454315 900.210510,381.644897 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M949.669556,474.272034 
    C948.605652,474.241394 947.715881,474.169861 946.384460,474.020477 
    C947.214478,473.386780 948.486145,472.830902 949.827881,472.836609 
    C949.921570,473.564087 949.945007,473.729980 949.968506,473.895874 
    C949.968506,473.895874 949.843689,474.231140 949.669556,474.272034 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M905.114136,121.546371 
    C904.401306,120.411537 904.036133,119.573837 903.589294,118.393547 
    C904.639893,118.842148 905.772156,119.633324 906.917664,120.815689 
    C906.441284,121.419083 905.951538,121.631287 905.114136,121.546371 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M897.991333,378.601562 
    C898.005066,379.264374 897.994141,379.777679 897.976013,380.675720 
    C897.022156,380.271545 896.075500,379.482635 895.004089,378.408051 
    C895.472595,378.088135 896.065796,378.053864 897.107056,378.019958 
    C897.728210,378.129944 897.865417,378.273865 897.991333,378.601562 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M1110.420532,374.215759 
    C1110.463745,373.296448 1110.888672,372.271973 1111.620361,371.075226 
    C1111.552124,371.972168 1111.177124,373.041382 1110.420532,374.215759 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M914.039062,129.966797 
    C914.606079,131.056854 915.144836,132.173615 915.539001,133.647949 
    C915.394409,134.005508 914.966431,134.103622 914.720947,133.835144 
    C914.302063,132.393829 914.128662,131.220978 913.955261,130.048141 
    C913.955261,130.048141 914.010681,129.993484 914.039062,129.966797 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M954.644409,470.061096 
    C955.009888,470.453644 954.994446,470.783539 954.973145,471.360657 
    C954.288086,471.909576 953.600708,472.210846 952.525391,472.532349 
    C952.848877,471.701355 953.560242,470.850098 954.644409,470.061096 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1049.422363,472.150818 
    C1048.800537,471.485626 1048.573975,471.059265 1048.243774,470.404816 
    C1049.133545,470.587341 1050.127075,470.997986 1051.319336,471.747070 
    C1050.951416,472.186890 1050.384644,472.288269 1049.422363,472.150818 
  z"/>
  <path fill="#9C9C9C" opacity="1.000000" stroke="none" 
    d="
  M916.762512,141.515869 
    C917.021179,140.956390 917.274841,140.581070 917.802612,140.003723 
    C918.368164,140.320496 918.659790,140.839294 918.583374,141.677673 
    C917.797180,142.000595 917.378967,142.003967 916.960754,142.007324 
    C916.960754,142.007339 916.757568,141.700012 916.762512,141.515869 
  z"/>
  <path fill="#8A8A8A" opacity="1.000000" stroke="none" 
    d="
  M916.919495,142.296204 
    C917.378967,142.003967 917.797180,142.000595 918.527954,141.992111 
    C918.892456,142.402802 918.944397,142.818634 919.018555,143.548370 
    C918.811951,143.917435 918.583191,143.972565 918.002075,144.006592 
    C917.392456,143.518723 917.135315,143.051910 916.919495,142.296204 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M892.009216,373.382996 
    C892.572754,373.872650 893.265930,374.656769 893.943115,375.812836 
    C893.331055,375.348999 892.734924,374.513184 892.009216,373.382996 
  z"/>
  <path fill="#C3C3C3" opacity="1.000000" stroke="none" 
    d="
  M924.836792,405.446350 
    C925.078552,404.978241 925.415710,404.924957 926.256470,404.770935 
    C927.202454,405.209564 927.645020,405.748962 927.872314,406.602600 
    C926.748840,406.564941 925.840515,406.213043 924.836792,405.446350 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M967.719482,465.175323 
    C968.011047,465.495758 968.016052,465.841003 968.020508,466.445435 
    C967.599792,466.858063 967.179688,467.011505 966.422791,467.147217 
    C966.086060,467.129456 966.023010,466.640442 966.011475,466.394409 
    C966.477661,465.832275 966.955383,465.516205 967.719482,465.175323 
  z"/>
  <path fill="#9C9C9C" opacity="1.000000" stroke="none" 
    d="
  M914.966431,134.103622 
    C914.966431,134.103622 915.394409,134.005508 915.611084,133.970551 
    C916.166809,134.428146 916.505859,134.920670 916.856018,135.714111 
    C916.424072,136.027206 915.981079,136.039429 915.206360,136.087906 
    C914.874695,136.124161 914.920776,136.125000 914.945007,135.793564 
    C914.968323,135.009293 914.967407,134.556458 914.966431,134.103622 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M974.361694,465.121704 
    C974.008057,465.076721 973.990845,464.626556 973.989136,464.401459 
    C974.467224,463.852905 974.947144,463.529480 975.714783,463.174286 
    C976.020020,463.489563 976.037537,463.836548 976.050537,464.444397 
    C975.602417,464.859070 975.158875,465.012878 974.361694,465.121704 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1081.302490,502.699188 
    C1080.955688,502.252258 1080.432983,501.487030 1079.970947,500.332947 
    C1080.396484,500.756378 1080.761475,501.568634 1081.302490,502.699188 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M950.173645,473.808167 
    C949.945007,473.729980 949.921570,473.564087 949.945618,473.150604 
    C950.328308,473.037750 950.663452,473.172485 951.267334,473.247253 
    C951.150330,473.365051 950.764526,473.542786 950.173645,473.808167 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M909.297485,123.730988 
    C909.152283,124.063019 908.802795,124.085152 907.932495,124.035889 
    C907.305298,123.466064 907.198853,122.967651 907.442200,122.260216 
    C908.225708,122.507820 908.659485,122.964455 909.297485,123.730988 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M941.622253,476.936096 
    C941.546814,477.339996 941.116455,477.755096 940.364990,478.204132 
    C940.451782,477.807800 940.859497,477.377563 941.622253,476.936096 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M903.283691,117.693550 
    C902.857239,117.635956 902.232666,117.223106 901.541016,116.417542 
    C902.011169,116.462654 902.548340,116.900467 903.283691,117.693550 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M939.691223,478.754089 
    C939.542847,479.083160 939.092468,479.556946 938.291626,479.988281 
    C938.423828,479.596832 938.906555,479.247833 939.691223,478.754089 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M891.089722,372.269836 
    C891.406372,372.139435 891.638062,372.358429 891.862244,372.893707 
    C891.650085,372.929810 891.366760,372.732880 891.089722,372.269836 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M894.080566,377.271790 
    C894.408325,377.138977 894.637756,377.357666 894.851074,377.894562 
    C894.631348,377.931641 894.347107,377.735138 894.080566,377.271790 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M1090.056396,131.740570 
    C1089.726929,131.976349 1089.538452,131.968018 1089.065430,131.960052 
    C1089.020874,131.678589 1089.260864,131.396759 1089.768311,131.035599 
    C1090.089722,131.136353 1090.143677,131.316406 1090.056396,131.740570 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M907.924866,121.825760 
    C907.450623,122.057243 907.013184,121.963310 906.711548,121.495636 
    C907.218750,121.248047 907.590210,121.374207 907.924866,121.825760 
  z"/>
  <path fill="#989898" opacity="1.000000" stroke="none" 
    d="
  M921.126160,506.347229 
    C921.182922,505.939911 921.593018,505.952148 921.796753,505.976196 
    C921.911499,506.455017 921.822510,506.909821 921.395630,507.470825 
    C921.061584,507.302887 921.065491,507.028717 921.126160,506.347229 
  z"/>
  <path fill="#989898" opacity="1.000000" stroke="none" 
    d="
  M1042.740723,468.506714 
    C1042.739990,468.483551 1042.737671,468.463257 1042.760620,468.484955 
    C1042.783569,468.506653 1042.741577,468.529907 1042.740723,468.506714 
  z"/>
  <path fill="#030303" opacity="1.000000" stroke="none" 
    d="
  M158.908051,615.945190 
    C162.280609,615.055908 165.653183,614.166687 169.872864,613.271973 
    C200.184769,613.216003 229.649612,613.182556 259.114166,613.069885 
    C260.764435,613.063538 262.412231,612.403992 264.061157,612.048401 
    C264.061157,612.048401 263.989990,612.031311 264.377869,612.043457 
    C265.786285,609.041199 266.806824,606.026733 267.827362,603.012268 
    C268.162262,602.628723 268.497131,602.245239 269.296783,601.544067 
    C273.804810,596.745361 277.738983,592.158936 281.930725,587.821350 
    C284.613739,585.045044 287.677032,582.636292 290.569855,580.062744 
    C290.569855,580.062744 290.973511,579.981934 291.390717,579.799438 
    C292.450623,579.144653 293.093323,578.672485 294.049255,578.416260 
    C302.418518,576.440247 310.355255,573.252625 318.556213,572.269897 
    C334.107910,570.406494 348.115570,575.604736 361.100708,584.768372 
    C362.068970,585.131592 362.782654,585.156555 363.496307,585.181519 
    C363.496307,585.181519 363.458099,585.035034 363.181824,585.413391 
    C363.237915,586.203552 363.570282,586.615295 363.979218,587.323608 
    C364.710663,588.068970 365.365540,588.517761 366.011108,588.980164 
    C366.001831,588.993774 366.033264,588.980591 366.107971,589.297913 
    C367.765808,591.150879 369.348907,592.686462 371.216309,594.517212 
    C371.953369,594.629761 372.406158,594.447205 372.858948,594.264709 
    C372.858948,594.264709 372.883911,594.111511 372.442261,594.388184 
    C373.939117,597.745972 375.877563,600.827087 377.750122,604.186523 
    C378.086884,605.046204 378.489502,605.627625 378.957886,606.542480 
    C379.493927,607.893311 379.964233,608.910583 380.401672,610.223755 
    C380.891418,611.077209 381.414062,611.634705 382.330078,612.419861 
    C382.982208,612.489807 383.240997,612.332214 383.499756,612.174561 
    C383.499756,612.174561 383.523956,612.104065 383.732727,612.502441 
    C414.800171,612.996399 445.658905,613.091980 476.517609,613.187622 
    C476.517609,613.187622 476.440063,613.057373 476.523315,613.480225 
    C478.403931,614.269714 480.201263,614.636414 482.285461,615.190796 
    C487.753784,618.429016 492.935272,621.479553 498.317474,624.821655 
    C506.540375,633.880859 510.515350,644.225159 510.535583,656.090332 
    C510.556549,668.397095 510.543579,680.703857 510.543976,693.010620 
    C510.544830,721.282898 510.549774,749.555237 510.538605,777.827515 
    C510.537262,781.224792 510.635803,784.500854 515.133484,784.982178 
    C517.314453,787.754272 519.495422,790.526367 521.744141,793.974487 
    C522.832336,795.500000 523.852844,796.349609 524.873291,797.199219 
    C524.873291,797.199219 524.905701,797.110229 524.617188,797.464661 
    C525.836548,799.447021 527.344360,801.075012 528.852112,802.703003 
    C528.852112,802.703003 528.915649,802.513489 528.427673,802.580811 
    C530.627380,807.689209 533.536072,812.627136 535.949951,817.796082 
    C539.423767,825.234741 542.537659,832.841431 545.769470,840.661255 
    C545.853088,841.304932 545.972351,841.663879 545.973145,842.279114 
    C546.472656,844.204895 547.090759,845.874329 547.651733,847.789795 
    C547.699951,848.349609 547.805176,848.663452 547.792114,849.261108 
    C548.349304,851.549927 549.024902,853.554932 549.638367,855.904968 
    C549.717529,857.166687 549.858826,858.083313 549.861572,859.310669 
    C550.319031,862.318909 550.915161,865.016479 551.432861,868.123840 
    C551.559631,872.353088 551.764893,876.172607 551.806274,880.323120 
    C551.751648,883.105713 551.860901,885.557251 551.848877,888.452026 
    C551.650085,892.692017 551.572571,896.488770 551.277283,900.564331 
    C550.689270,903.567017 550.318970,906.291016 549.826355,909.336548 
    C549.685913,910.569275 549.667786,911.480286 549.422913,912.615845 
    C548.792542,914.561523 548.388916,916.282654 547.847778,918.279541 
    C547.683777,919.164124 547.657410,919.772949 547.404663,920.578857 
    C546.840393,922.170227 546.502502,923.564575 546.020874,925.258484 
    C545.837158,926.216248 545.797119,926.874512 545.505371,927.772766 
    C542.341492,935.029480 539.429260,942.046204 536.318665,949.342896 
    C536.041260,950.069275 535.962280,950.515686 535.597900,951.120972 
    C532.766846,955.833008 530.221313,960.386108 527.490723,965.017395 
    C527.073120,965.270508 526.957397,965.503479 526.653931,965.914917 
    C525.806885,966.965881 525.264160,967.896423 524.782349,968.839722 
    C524.843201,968.852417 524.768433,968.752991 524.506897,968.892944 
    C523.831421,969.689087 523.417542,970.345276 522.749756,971.150269 
    C522.363525,971.660461 522.231140,972.021912 521.821045,972.465942 
    C520.509033,974.078369 519.474854,975.608093 518.232910,977.433838 
    C518.260315,978.110718 518.495544,978.491516 518.730713,978.872375 
    C518.730713,978.872375 518.871887,978.890625 518.479431,978.470337 
    C517.647034,978.987305 517.207092,979.924500 516.767151,980.861755 
    C516.767151,980.861755 516.886658,980.881165 516.505127,980.478882 
    C515.674561,981.006653 515.225525,981.936768 514.776489,982.866882 
    C514.776428,982.866882 514.901367,982.880432 514.608398,982.499268 
    C513.875488,982.402588 513.435547,982.687073 512.689819,983.099731 
    C509.576080,986.146423 506.768036,989.064880 503.647217,992.102051 
    C501.233643,994.174988 499.132904,996.129272 496.717529,998.172668 
    C495.507874,999.269531 494.612854,1000.277344 493.717804,1001.285156 
    C493.717773,1001.285156 493.443573,1001.444336 493.023926,1001.545593 
    C491.870544,1001.962952 491.058624,1002.166077 490.414764,1002.611938 
    C480.325409,1009.597290 469.655487,1015.428772 457.969574,1019.330566 
    C450.797699,1021.725159 443.682831,1024.290527 436.281738,1026.730835 
    C435.683685,1026.777710 435.346313,1026.873047 434.666229,1026.842773 
    C430.666687,1027.360962 427.009827,1028.004883 422.950317,1028.577393 
    C420.040009,1028.641235 417.532379,1028.776489 414.646118,1028.767090 
    C408.835876,1028.719604 403.404205,1028.816650 397.557129,1028.812866 
    C394.651184,1028.677734 392.160675,1028.643311 389.400513,1028.374268 
    C386.419128,1027.755127 383.707428,1027.370728 380.700439,1026.868652 
    C379.775635,1026.749268 379.146088,1026.747314 378.281677,1026.513916 
    C376.030731,1025.853149 374.014587,1025.423950 371.762329,1024.867188 
    C371.174103,1024.750244 370.822021,1024.760864 370.236725,1024.538574 
    C368.003479,1023.874390 366.003479,1023.443176 363.768066,1022.891235 
    C363.184631,1022.766541 362.836639,1022.762451 362.268311,1022.482910 
    C355.011871,1019.358704 347.975769,1016.510071 340.664093,1013.440063 
    C339.927826,1013.139343 339.467133,1013.059937 338.842072,1012.699219 
    C335.767883,1010.833862 332.858063,1009.249756 329.676453,1007.436096 
    C327.662567,1006.119629 325.920441,1005.032715 324.034729,1003.643616 
    C321.703369,1002.138184 319.515594,1000.934875 317.327820,999.731567 
    C317.229034,999.538696 317.130280,999.345825 316.720856,998.714111 
    C314.956665,997.287415 313.503113,996.299561 312.049561,995.311646 
    C312.049530,995.311707 312.067139,995.057190 311.913971,994.724854 
    C310.865509,993.560669 309.970215,992.728760 309.050415,991.946777 
    C309.025879,991.996765 309.105743,991.919250 308.988464,991.645752 
    C308.245850,990.922241 307.620514,990.472107 306.732819,989.712341 
    C304.352264,988.802612 302.235291,987.684082 300.115570,987.678833 
    C256.632324,987.570435 213.148773,987.589172 169.396698,987.345581 
    C163.114059,984.336182 157.099991,981.563721 150.943207,978.516235 
    C149.584061,977.146057 148.367599,976.050964 147.098236,974.641296 
    C146.405426,973.782166 145.765549,973.237549 144.837753,972.369568 
    C144.079758,972.272339 143.609695,972.498474 143.139618,972.724670 
    C143.139618,972.724670 143.110992,972.896912 143.502045,972.682922 
    C143.928894,972.308777 144.021576,972.135620 143.988663,971.991089 
    C143.920242,971.690552 143.785309,971.405151 143.698456,970.807922 
    C141.756378,966.685913 139.793549,962.869507 137.900269,958.647949 
    C137.330215,949.491760 136.148926,940.741577 136.134949,931.989624 
    C135.996414,845.242310 136.044189,758.494812 136.059006,671.747314 
    C136.061066,659.691101 134.894943,647.494873 140.169037,635.718140 
    C142.421036,632.380676 144.482285,629.315491 146.806396,626.154785 
    C147.821304,625.248840 148.573318,624.438354 149.641724,623.487549 
    C151.365097,622.242065 152.772079,621.136963 154.507721,619.771606 
    C154.643829,619.049072 154.451263,618.586731 154.258713,618.124390 
    C154.258713,618.124390 154.095932,618.098145 154.355652,618.550415 
    C156.046249,617.983521 157.477142,616.964355 158.908051,615.945190 
  M481.376404,955.605896 
    C481.573486,955.330444 481.770569,955.054993 482.435913,954.306580 
    C490.159882,948.146240 494.960968,939.887817 499.429230,930.695190 
    C499.778503,930.100342 500.127777,929.505554 500.908081,928.288391 
    C502.120148,925.135315 503.332184,921.982300 504.987946,918.238342 
    C506.666321,911.871826 508.978668,905.595032 509.894196,899.120605 
    C511.950867,884.576050 511.637177,870.060486 506.810516,855.297974 
    C506.667542,854.890259 506.524567,854.482544 506.599060,853.486267 
    C506.095642,852.648499 505.592224,851.810791 505.057434,850.218079 
    C504.818817,849.509888 504.580170,848.801697 504.527435,847.517090 
    C504.093811,846.875977 503.660217,846.234802 503.210571,844.918884 
    C502.983215,844.293335 502.755859,843.667786 502.602905,842.369263 
    C501.456512,840.477783 500.310120,838.586365 499.166748,836.088196 
    C498.979736,835.736633 498.792694,835.385132 498.607483,834.348877 
    C494.111267,828.148254 489.615051,821.947632 484.996002,815.359436 
    C484.849457,815.112061 484.636780,814.953247 484.226196,814.180603 
    C477.397827,808.105591 470.625092,801.965576 463.682129,796.024414 
    C462.622040,795.117371 460.774475,795.130493 458.864319,794.079163 
    C458.624268,793.989868 458.384216,793.900635 458.254547,793.575562 
    C458.133545,793.424622 458.012512,793.273621 457.891510,793.122681 
    C457.957581,793.345581 458.023651,793.568542 457.283630,793.769470 
    C456.837036,793.543945 456.390472,793.318359 456.058838,792.482849 
    C455.911591,792.337585 455.764374,792.192261 455.303497,791.702026 
    C454.847076,791.467896 454.390656,791.233704 453.406342,790.445068 
    C451.351196,789.593933 449.296051,788.742737 447.126190,787.402344 
    C446.395142,787.198730 445.664062,786.995056 444.587524,786.524231 
    C444.299225,786.397583 444.016022,786.408203 443.353241,786.130371 
    C442.224518,785.717285 441.095825,785.304199 439.596130,784.610291 
    C439.288696,784.480469 438.986725,784.492126 438.206573,784.210022 
    C436.456268,783.761108 434.705963,783.312195 432.565399,782.609619 
    C432.253143,782.495850 431.951263,782.518799 431.199402,782.219055 
    C429.458466,781.788635 427.717529,781.358215 425.299225,780.671753 
    C424.103516,780.657959 422.907776,780.644165 421.116608,780.157104 
    C411.137054,778.214844 401.178101,777.606079 390.577637,780.435486 
    C389.393921,780.593445 388.210236,780.751404 386.473297,780.672180 
    C384.748413,781.326172 383.023529,781.980225 380.873108,782.500366 
    C380.557190,782.486145 380.285004,782.588318 379.487305,782.613892 
    C377.755219,783.285095 376.023163,783.956299 373.841583,784.514038 
    C373.510071,784.518738 373.238464,784.648743 372.548035,784.691772 
    C371.443390,785.298706 370.338715,785.905640 368.821686,786.405640 
    C368.517944,786.409180 368.267120,786.526184 367.547363,786.573120 
    C366.210510,787.287415 364.873688,788.001648 362.958191,788.709717 
    C362.652191,788.926575 362.346161,789.143433 361.361969,789.433716 
    C359.400085,790.511414 357.438232,791.589172 354.953217,792.685730 
    C354.600189,793.045593 354.247162,793.405518 353.178375,793.834839 
    C351.756958,794.874390 350.335541,795.914001 348.984131,796.983826 
    C348.984131,796.983826 348.976471,796.908020 348.394928,796.602234 
    C347.930298,797.033508 347.465637,797.464722 346.364960,797.975647 
    C345.615112,798.665283 344.865265,799.354919 343.355225,800.290039 
    C343.152466,801.148254 342.949677,802.006531 342.896240,802.898193 
    C342.896240,802.898193 342.870636,802.747314 342.321381,802.083679 
    C341.223328,802.793884 340.125275,803.504089 338.389557,804.337830 
    C337.011322,805.758301 335.633087,807.178772 333.675720,808.778320 
    C332.766907,809.846558 331.858093,810.914856 330.336609,812.157532 
    C329.283630,813.446167 328.230682,814.734863 326.644623,816.430237 
    C325.043060,818.476807 323.441498,820.523376 321.255280,822.917725 
    C320.479584,824.255432 319.703888,825.593201 318.364716,827.284912 
    C317.826508,828.484009 317.288269,829.683167 316.197174,831.157654 
    C315.782715,832.070007 315.368225,832.982300 314.417877,834.094849 
    C314.134216,834.747742 313.850586,835.400574 313.174042,836.559509 
    C313.086090,836.972961 312.998108,837.386414 312.334656,838.085205 
    C311.462952,840.087769 310.591278,842.090332 309.403870,844.737793 
    C309.558716,845.144592 309.713531,845.551453 309.956879,845.967590 
    C309.956879,845.967590 309.916260,845.888428 309.200256,845.798584 
    C307.407806,851.885315 305.615356,857.972107 303.562164,864.699829 
    C303.538910,865.820679 303.515656,866.941467 303.082123,868.713562 
    C301.056946,878.486267 300.830841,888.233887 303.348694,898.594421 
    C303.508820,899.712585 303.668945,900.830688 303.594330,902.587280 
    C304.736084,906.436401 305.877838,910.285522 307.005676,914.671021 
    C307.347107,915.073792 307.688538,915.476624 307.638428,916.432556 
    C311.545380,924.607483 315.452332,932.782471 319.315063,941.530884 
    C319.845093,942.032166 320.375153,942.533386 321.042999,943.701782 
    C321.861450,944.783020 322.679901,945.864197 323.531921,947.547485 
    C324.342987,948.425293 325.154083,949.303101 326.087494,950.270935 
    C326.087494,950.270935 326.228638,950.214905 326.560730,950.858093 
    C329.147003,953.629822 331.638733,956.500793 334.378265,959.111755 
    C335.179169,959.875183 336.685089,959.898926 337.894318,960.095337 
    C337.894318,960.095337 337.728851,960.126770 337.042572,960.626892 
    C337.968353,961.786072 338.894165,962.945190 340.072845,964.675781 
    C341.094116,965.251221 342.115387,965.826660 343.565765,966.929688 
    C345.002655,967.977356 346.439545,969.025024 348.164948,970.672424 
    C356.870667,974.986328 365.272095,980.175415 374.377014,983.341370 
    C381.857605,985.942505 390.173859,986.140320 399.018616,987.602295 
    C403.964172,987.544373 408.909729,987.486450 414.701263,987.794434 
    C421.467773,986.530579 428.234314,985.266785 435.797821,984.099670 
    C441.550598,981.914856 447.348511,979.836792 453.013336,977.443787 
    C453.995911,977.028809 454.415985,975.282104 455.971375,974.162659 
    C456.258575,974.110840 456.545807,974.058960 457.568787,974.167725 
    C458.391846,973.632568 459.214935,973.097473 460.684265,972.369141 
    C462.820007,970.991943 464.955750,969.614746 467.646393,968.127869 
    C467.751312,967.971191 467.856232,967.814575 468.530884,967.619751 
    C469.073700,967.103455 469.616547,966.587219 470.824677,965.963501 
    C473.108154,963.337402 475.391663,960.711304 477.526276,958.053833 
    C477.526276,958.053833 477.518585,958.205750 478.102753,958.918457 
    C479.086456,957.948486 480.070129,956.978455 481.376404,955.605896 
  M270.387909,831.581726 
    C270.510986,831.272705 270.511230,830.963562 270.836182,830.120789 
    C273.406342,824.430603 275.976501,818.740479 279.076538,812.679749 
    C279.448639,811.934143 279.820740,811.188599 280.772278,810.086121 
    C282.430573,807.381592 284.088837,804.677063 286.156036,801.561646 
    C286.440460,801.059814 286.724854,800.557983 287.706787,799.778870 
    C288.242035,798.065247 288.777313,796.351562 289.245789,794.572693 
    C289.245789,794.572693 289.184723,794.502075 289.057495,794.584839 
    C289.057495,794.584839 289.154602,794.701538 290.087555,795.159424 
    C290.472687,794.153442 290.857788,793.147461 291.109680,792.125854 
    C291.109680,792.125854 291.136505,792.257324 291.707733,792.915466 
    C293.312500,790.983582 294.917267,789.051697 297.081360,787.311157 
    C297.734711,786.397949 298.388062,785.484802 299.764648,784.503418 
    C300.587585,783.374817 301.410492,782.246277 302.839539,780.919128 
    C304.211639,779.562561 305.583771,778.205994 307.555817,776.829102 
    C308.032227,776.217651 308.508636,775.606140 309.618683,774.307373 
    C309.461365,774.038391 309.304077,773.769470 309.028717,773.665588 
    C309.028717,773.665588 309.194092,773.783142 309.902740,774.195312 
    C311.607391,772.798950 313.312042,771.402588 315.675690,769.634399 
    C316.215118,768.474548 316.754547,767.314758 317.118134,766.123718 
    C317.118134,766.123718 317.130707,766.301941 317.663513,767.054932 
    C318.462189,766.779175 319.260834,766.503418 320.779205,766.158203 
    C323.988037,763.857178 327.196899,761.556152 331.069366,759.132019 
    C332.001740,758.507629 332.934143,757.883240 334.455719,757.394592 
    C335.429688,756.675964 336.403656,755.957336 337.991699,755.142334 
    C338.651825,754.648193 339.311981,754.153992 340.615051,753.807190 
    C341.452423,753.241516 342.289764,752.675842 343.113037,752.076660 
    C343.113037,752.076660 343.120392,752.115234 343.887451,752.124817 
    C351.945709,749.148254 360.003998,746.171753 368.903015,743.221558 
    C372.777618,742.400330 376.616333,741.188293 380.533295,740.828552 
    C394.305420,739.563843 407.990784,736.294128 421.970764,739.312073 
    C427.899353,740.591919 433.996185,741.092712 440.655334,742.277893 
    C448.422913,744.755432 456.190491,747.232910 464.498840,750.187805 
    C469.022491,752.530640 469.691223,752.226074 469.695709,747.452942 
    C469.723511,717.863098 469.653534,688.273071 469.773529,658.683716 
    C469.789337,654.781738 468.496918,653.404297 464.596588,653.469727 
    C453.794342,653.651001 442.984070,653.680054 432.183258,653.460327 
    C427.869781,653.372559 426.365204,654.801331 426.413879,659.198730 
    C426.549988,671.488464 426.263550,683.782837 425.336243,696.254700 
    C362.863068,696.269409 300.389893,696.280151 237.916733,696.305847 
    C232.422821,696.308105 226.928925,696.408142 220.938446,695.807922 
    C220.529282,693.935303 219.786926,692.066345 219.766190,690.189453 
    C219.650223,679.695190 219.576920,669.196533 219.775864,658.704773 
    C219.849899,654.799805 218.518372,653.402405 214.597015,653.468933 
    C203.771408,653.652710 192.937149,653.692383 182.113602,653.455688 
    C177.685532,653.358826 176.425156,654.987488 176.429520,659.289429 
    C176.525131,753.249390 176.533218,847.209473 176.411118,941.169312 
    C176.404877,945.969055 178.167313,947.055603 182.569473,946.995239 
    C197.893402,946.785217 213.222000,946.914917 228.548813,946.914917 
    C242.542862,946.914917 256.536926,946.899353 270.530914,946.927429 
    C273.140686,946.932678 275.524933,946.852112 274.171570,943.156982 
    C271.099792,934.769897 267.994232,926.395203 264.981415,917.156677 
    C264.859985,915.830994 264.882172,914.473389 264.595093,913.184631 
    C261.578094,899.640625 260.328430,885.975525 261.549622,872.116211 
    C261.631958,871.181824 261.277710,870.208923 261.129944,868.394653 
    C261.467102,864.354797 261.804230,860.315002 262.728821,856.190308 
    C264.590912,849.786499 266.453033,843.382629 268.653534,836.359009 
    C268.703644,835.895569 268.753723,835.432068 269.243713,834.688599 
    C269.532043,833.780273 269.820374,832.871948 270.387909,831.581726 
  M340.317444,622.035767 
    C339.582214,621.940247 338.846985,621.844727 338.097412,621.904175 
    C338.097412,621.904175 338.251648,621.883484 338.990723,621.368347 
    C337.881714,619.812317 337.043610,617.928345 335.620392,616.752625 
    C325.141266,608.096130 308.011078,613.196106 303.351135,626.296082 
    C301.096008,632.635620 300.627075,638.782898 305.723022,644.541321 
    C305.772308,644.903076 305.979401,645.090454 306.397308,645.864624 
    C311.293396,653.710632 321.477966,656.969055 330.531281,653.586060 
    C339.609772,650.193604 346.181030,639.727661 344.166016,631.114380 
    C343.487000,628.211975 341.478546,625.620544 340.020691,622.950867 
    C340.020691,622.950867 340.106262,622.949280 340.317444,622.035767 
  z"/>
  <path fill="#E9E9E9" opacity="1.000000" stroke="none" 
    d="
  M515.092651,784.594116 
    C510.635803,784.500854 510.537262,781.224792 510.538605,777.827515 
    C510.549774,749.555237 510.544830,721.282898 510.543976,693.010620 
    C510.543579,680.703857 510.556549,668.397095 510.535583,656.090332 
    C510.515350,644.225159 506.540375,633.880859 498.306091,624.561768 
    C497.768097,623.400940 497.442261,622.791687 497.116394,622.182434 
    C498.101105,622.471619 499.430389,622.448914 500.017853,623.097778 
    C506.805817,630.595520 512.103516,638.705872 512.070557,649.461548 
    C511.953156,687.738342 511.983917,726.015747 512.049194,764.292725 
    C512.060730,771.047791 510.622986,778.089172 515.092651,784.594116 
  z"/>
  <path fill="#8F8F8F" opacity="1.000000" stroke="none" 
    d="
  M139.978256,635.990417 
    C134.894943,647.494873 136.061066,659.691101 136.059006,671.747314 
    C136.044189,758.494812 135.996414,845.242310 136.134949,931.989624 
    C136.148926,940.741577 137.330215,949.491760 137.742615,958.689575 
    C137.515442,959.136475 137.197769,959.210083 137.197754,959.210083 
    C136.465179,956.222229 135.095642,953.235107 135.092285,950.246399 
    C134.981308,851.329895 135.033768,752.413208 134.919998,653.496765 
    C134.913208,647.589355 135.462387,641.992798 138.394104,636.291748 
    C139.177887,635.949158 139.578079,635.969788 139.978256,635.990417 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M551.495117,900.285583 
    C551.572571,896.488770 551.650085,892.692017 552.141724,888.190674 
    C552.360657,884.988159 552.165405,882.490112 551.970154,879.992065 
    C551.764893,876.172607 551.559631,872.353088 551.581360,867.687988 
    C551.205627,864.228210 550.602905,861.614136 550.000183,859.000000 
    C549.858826,858.083313 549.717529,857.166687 549.751831,855.495972 
    C549.255127,852.820435 548.582764,850.898865 547.910461,848.977295 
    C547.805176,848.663452 547.699951,848.349609 547.759521,847.408081 
    C547.313416,845.194580 546.702576,843.608643 546.091675,842.022766 
    C545.972351,841.663879 545.853088,841.304932 545.853394,840.310669 
    C545.676636,838.063110 545.380249,836.450989 545.083862,834.838806 
    C546.024414,836.657654 547.241943,838.389282 547.847534,840.313538 
    C549.090149,844.261475 550.221558,848.270691 551.006775,852.330444 
    C552.423279,859.653992 554.021667,866.992676 554.660095,874.401245 
    C555.224670,880.951599 554.714722,887.611450 554.421631,894.211487 
    C554.284912,897.288574 553.662903,900.363953 553.042358,903.395447 
    C551.840820,909.265564 550.681152,915.156555 549.136780,920.940796 
    C547.599304,926.699402 545.611267,932.337646 543.439941,937.674683 
    C543.958435,934.057983 544.857788,930.795349 545.757141,927.532715 
    C545.797119,926.874512 545.837158,926.216248 546.350830,925.081421 
    C547.093384,923.197205 547.362183,921.789490 547.630981,920.381836 
    C547.657410,919.772949 547.683777,919.164124 548.191772,918.095093 
    C548.998840,915.887085 549.324219,914.139221 549.649658,912.391357 
    C549.667786,911.480286 549.685913,910.569275 550.123901,909.088501 
    C550.860901,905.774414 551.177979,903.029968 551.495117,900.285583 
  z"/>
  <path fill="#ADADAD" opacity="1.000000" stroke="none" 
    d="
  M360.846130,584.430115 
    C348.115570,575.604736 334.107910,570.406494 318.556213,572.269897 
    C310.355255,573.252625 302.418518,576.440247 294.045197,578.435669 
    C293.727936,578.238953 293.684387,578.212158 293.684387,578.212158 
    C299.775024,572.861633 307.181915,571.858582 314.926727,570.801758 
    C324.612885,569.480042 333.983307,570.444763 343.022491,573.184387 
    C349.318329,575.092590 355.015045,578.977539 360.967896,582.772217 
    C360.919617,583.853394 360.882874,584.141724 360.846130,584.430115 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M169.665283,987.582581 
    C213.148773,987.589172 256.632324,987.570435 300.115570,987.678833 
    C302.235291,987.684082 304.352264,988.802612 306.761597,990.042603 
    C307.737030,991.094788 308.421387,991.507019 309.105743,991.919250 
    C309.105743,991.919250 309.025879,991.996765 309.034668,992.340515 
    C309.036926,993.210144 309.030426,993.736084 309.023926,994.261963 
    C308.698425,994.191650 308.235504,994.235962 308.067383,994.034363 
    C303.223969,988.226746 296.626678,988.974426 290.100952,988.986938 
    C249.128052,989.065552 208.154922,989.056519 167.182022,988.994446 
    C165.500153,988.991882 163.819519,988.170532 162.358582,987.335449 
    C164.940994,987.154297 167.303146,987.368469 169.665283,987.582581 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M362.488647,1022.758423 
    C362.836639,1022.762451 363.184631,1022.766541 364.002014,1023.185364 
    C366.470947,1023.990540 368.470459,1024.380981 370.469971,1024.771362 
    C370.822021,1024.760864 371.174103,1024.750244 371.991272,1025.169678 
    C374.476410,1025.981567 376.496460,1026.363525 378.516541,1026.745361 
    C379.146088,1026.747314 379.775635,1026.749268 380.955017,1027.155518 
    C384.226624,1027.909546 386.948425,1028.259277 389.670197,1028.608887 
    C392.160675,1028.643311 394.651184,1028.677734 397.855743,1029.105835 
    C404.054779,1029.303589 409.539764,1029.107666 415.024719,1028.911743 
    C417.532379,1028.776489 420.040009,1028.641235 423.418945,1028.701782 
    C427.863129,1028.254517 431.436035,1027.611450 435.008942,1026.968506 
    C435.346313,1026.873047 435.683685,1026.777710 436.699554,1026.820801 
    C439.286713,1026.653198 441.195435,1026.347412 443.104126,1026.041504 
    C439.734528,1027.384521 436.446533,1029.582886 432.980347,1029.913696 
    C421.579132,1031.001709 410.107025,1031.990234 398.674713,1031.865723 
    C391.898743,1031.792114 385.147095,1029.548218 378.383057,1028.287964 
    C374.353851,1027.537231 370.242310,1027.086548 366.310364,1025.989746 
    C360.849335,1024.466431 355.522034,1022.463562 350.344788,1020.301758 
    C354.530945,1020.877869 358.509796,1021.818115 362.488647,1022.758423 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M443.071381,1026.022827 
    C441.195435,1026.347412 439.286713,1026.653198 436.960205,1026.869141 
    C443.682831,1024.290527 450.797699,1021.725159 457.969574,1019.330566 
    C469.655487,1015.428772 480.325409,1009.597290 490.414764,1002.611938 
    C491.058624,1002.166077 491.870544,1001.962952 492.961029,1001.691101 
    C489.261383,1005.140259 485.602753,1009.261841 481.056854,1011.784851 
    C473.929993,1015.740356 466.204041,1018.616394 458.249756,1021.757568 
    C457.521088,1021.730957 457.274414,1021.896362 457.027710,1022.061768 
    C457.027710,1022.061707 457.013763,1021.996704 456.629700,1021.971436 
    C451.829010,1023.319458 447.412354,1024.692749 442.995728,1026.066162 
    C442.995728,1026.066162 443.038635,1026.004150 443.071381,1026.022827 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M545.069702,834.482056 
    C545.380249,836.450989 545.676636,838.063110 545.889099,840.025879 
    C542.537659,832.841431 539.423767,825.234741 535.949951,817.796082 
    C533.536072,812.627136 530.627380,807.689209 528.330139,802.558960 
    C530.677063,805.084961 533.048584,807.489563 534.504333,810.358826 
    C537.603821,816.467773 540.227844,822.817993 543.067566,829.780518 
    C543.668701,830.991699 544.248962,831.491760 544.829224,831.991821 
    C544.904663,832.703003 544.980103,833.414124 545.069702,834.482056 
  z"/>
  <path fill="#9F9F9F" opacity="1.000000" stroke="none" 
    d="
  M263.589050,612.031128 
    C262.412231,612.403992 260.764435,613.063538 259.114166,613.069885 
    C229.649612,613.182556 200.184769,613.216003 170.234680,613.171814 
    C171.452057,612.718140 173.154114,612.049500 174.857513,612.046021 
    C204.277237,611.986694 233.697128,612.009277 263.589050,612.031128 
  z"/>
  <path fill="#9F9F9F" opacity="1.000000" stroke="none" 
    d="
  M476.188354,612.858643 
    C445.658905,613.091980 414.800171,612.996399 383.696350,612.494263 
    C413.291962,612.058594 443.132721,612.024414 472.973450,612.022583 
    C473.935333,612.022522 474.897186,612.353149 476.188354,612.858643 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M290.239746,580.116699 
    C287.677032,582.636292 284.613739,585.045044 281.930725,587.821350 
    C277.738983,592.158936 273.804810,596.745361 269.469055,601.198608 
    C269.828644,594.181641 275.055817,590.217529 279.694305,586.136658 
    C282.599915,583.580261 286.471466,582.121704 290.239746,580.116699 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M496.796814,621.995850 
    C497.442261,622.791687 497.768097,623.400940 498.105347,624.270142 
    C492.935272,621.479553 487.753784,618.429016 482.300659,614.926392 
    C482.041473,614.298035 482.053925,614.121887 482.066376,613.945801 
    C488.562714,613.464722 492.919983,616.903931 496.796814,621.995850 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M362.268311,1022.482849 
    C358.509796,1021.818115 354.530945,1020.877869 350.127869,1019.982239 
    C349.703674,1020.026917 349.405365,1020.021973 349.088318,1019.667847 
    C347.756042,1018.881592 346.740845,1018.449524 345.725616,1018.017456 
    C345.725616,1018.017456 345.416412,1018.013428 345.163116,1017.611877 
    C343.844330,1016.812744 342.778839,1016.415161 341.713379,1016.017578 
    C341.713379,1016.017517 341.420410,1016.017639 341.253143,1015.683655 
    C341.037140,1014.786926 340.988403,1014.224121 340.939667,1013.661377 
    C347.975769,1016.510071 355.011871,1019.358704 362.268311,1022.482849 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M545.505371,927.772766 
    C544.857788,930.795349 543.958435,934.057983 543.047791,937.711426 
    C543.036499,938.102234 543.001953,938.034119 542.752075,938.247620 
    C542.005066,940.414001 541.507935,942.366943 541.010864,944.319824 
    C541.010864,944.319824 541.023071,944.582031 540.611694,944.810547 
    C539.803833,946.134644 539.407349,947.230347 539.010864,948.325989 
    C539.010864,948.325989 539.024353,948.582336 538.672119,948.736694 
    C537.718872,948.948364 537.117981,949.005615 536.517029,949.062866 
    C539.429260,942.046204 542.341492,935.029480 545.505371,927.772766 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M169.396698,987.345581 
    C167.303146,987.368469 164.940994,987.154297 162.130463,986.980835 
    C161.682083,987.021423 161.408844,987.026489 161.097321,986.671326 
    C159.747284,985.880981 158.708786,985.445801 157.670288,985.010620 
    C157.670288,985.010620 157.420441,985.028137 157.185379,984.618286 
    C155.840454,983.809326 154.730576,983.410156 153.620712,983.010986 
    C153.620712,983.010986 153.425919,983.041504 153.277832,982.683228 
    C152.725586,981.885376 152.321396,981.445923 151.917206,981.006470 
    C151.917206,981.006470 151.991638,981.006165 151.880005,980.751343 
    C151.540878,979.928101 151.313385,979.359741 151.085907,978.791260 
    C157.099991,981.563721 163.114059,984.336182 169.396698,987.345581 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M527.675781,964.939270 
    C530.221313,960.386108 532.766846,955.833008 535.854248,951.282837 
    C536.600830,951.633118 536.805542,951.980347 537.010315,952.327637 
    C537.010315,952.327637 537.026123,952.579834 536.645386,952.789429 
    C535.847656,953.738831 535.430664,954.478577 535.013672,955.218384 
    C534.829529,956.448792 534.976562,957.872986 534.393127,958.869690 
    C533.128845,961.029663 531.490784,962.971008 529.238037,965.001221 
    C528.205566,964.980225 527.940674,964.959717 527.675781,964.939270 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M377.816040,603.908264 
    C375.877563,600.827087 373.939117,597.745972 372.365082,594.396362 
    C375.464630,597.313049 378.530334,600.281494 380.812714,603.763428 
    C382.216248,605.904663 382.422424,608.830750 383.333008,611.789490 
    C383.240997,612.332214 382.982208,612.489807 382.337097,612.110352 
    C381.445343,611.024780 380.939941,610.476318 380.434570,609.927917 
    C379.964233,608.910583 379.493927,607.893311 379.011780,606.264282 
    C378.605316,605.071167 378.210693,604.489685 377.816040,603.908264 
  z"/>
  <path fill="#C3C3C3" opacity="1.000000" stroke="none" 
    d="
  M140.169037,635.718140 
    C139.578079,635.969788 139.177887,635.949158 138.478134,635.909180 
    C140.125931,632.588013 142.073303,629.286194 144.836319,626.028198 
    C145.949158,626.131592 146.246338,626.190979 146.543518,626.250305 
    C144.482285,629.315491 142.421036,632.380676 140.169037,635.718140 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M497.032166,998.083618 
    C499.132904,996.129272 501.233643,994.174988 504.010132,992.113220 
    C505.405182,991.931519 506.124451,991.857300 506.920410,991.880737 
    C506.997070,991.978333 507.161865,992.164062 507.161865,992.164062 
    C504.013672,994.782471 500.865479,997.400879 497.360992,999.647095 
    C497.013855,998.877747 497.023010,998.480713 497.032166,998.083618 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M137.136917,959.570801 
    C137.197769,959.210083 137.515442,959.136475 137.673080,959.094788 
    C139.793549,962.869507 141.756378,966.685913 143.262573,970.753662 
    C142.226700,970.933044 141.647461,970.861084 141.068222,970.789185 
    C141.035385,970.420227 141.002533,970.051331 140.952209,969.086304 
    C140.341843,967.674500 139.748962,966.858826 139.156067,966.043091 
    C138.462738,964.005859 137.769409,961.968689 137.136917,959.570801 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M329.948242,1007.665649 
    C332.858063,1009.249756 335.767883,1010.833862 338.688232,1012.940552 
    C338.367035,1013.648376 338.035309,1013.833679 337.703552,1014.018921 
    C337.703522,1014.018860 337.423187,1014.023254 337.184631,1013.614197 
    C335.855499,1012.810120 334.764923,1012.415100 333.674377,1012.020081 
    C333.674377,1012.020081 333.423065,1012.031799 333.252747,1011.675903 
    C332.683289,1010.888062 332.284180,1010.456116 331.885071,1010.024170 
    C331.885101,1010.024170 331.445923,1009.985718 331.128235,1009.702820 
    C330.523102,1008.835144 330.235657,1008.250427 329.948242,1007.665649 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M443.440369,1026.046875 
    C447.412354,1024.692749 451.829010,1023.319458 456.650177,1021.997681 
    C453.206543,1025.168701 448.792206,1026.413818 443.440369,1026.046875 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M329.676453,1007.436096 
    C330.235657,1008.250427 330.523102,1008.835144 330.915283,1009.645874 
    C327.989410,1008.168701 324.958801,1006.465637 322.248779,1004.383118 
    C323.105713,1003.984375 323.641998,1003.965088 324.178314,1003.945801 
    C325.920441,1005.032715 327.662567,1006.119629 329.676453,1007.436096 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M150.943207,978.516235 
    C151.313385,979.359741 151.540878,979.928101 151.878784,980.788574 
    C149.640869,979.334106 147.292526,977.587585 144.968445,975.425659 
    C144.992676,975.010254 145.118088,974.883118 145.455933,974.911499 
    C146.246216,974.945251 146.698669,974.950562 147.151138,974.955872 
    C148.367599,976.050964 149.584061,977.146057 150.943207,978.516235 
  z"/>
  <path fill="#9F9F9F" opacity="1.000000" stroke="none" 
    d="
  M267.565369,603.231140 
    C266.806824,606.026733 265.786285,609.041199 264.407532,612.065308 
    C265.134003,609.199951 266.218689,606.324951 267.565369,603.231140 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M324.034729,1003.643677 
    C323.641998,1003.965088 323.105713,1003.984375 322.165161,1004.012939 
    C320.432098,1002.664307 319.103210,1001.306458 317.551086,999.840088 
    C319.515594,1000.934875 321.703369,1002.138184 324.034729,1003.643677 
  z"/>
  <path fill="#ADADAD" opacity="1.000000" stroke="none" 
    d="
  M370.932007,594.222107 
    C369.348907,592.686462 367.765808,591.150879 366.472839,589.298889 
    C367.486694,589.085693 368.210388,589.188843 368.934082,589.291992 
    C368.934082,589.291992 369.022644,589.458496 369.100189,589.891846 
    C369.765564,590.656067 370.353394,590.986877 370.941223,591.317688 
    C370.941223,591.317688 371.028351,591.459106 370.981934,591.975708 
    C370.934357,593.068909 370.933197,593.645508 370.932007,594.222107 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M528.929932,802.273376 
    C527.344360,801.075012 525.836548,799.447021 524.570557,797.472412 
    C526.210815,798.698425 527.609314,800.271057 528.929932,802.273376 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M527.490723,965.017395 
    C527.940674,964.959717 528.205566,964.980225 528.869385,965.022827 
    C528.134766,967.048523 527.001343,969.052002 525.445740,971.038452 
    C525.023560,971.021362 524.900452,970.903748 524.911560,970.543823 
    C524.871277,969.706970 524.819824,969.229980 524.768433,968.752991 
    C524.768433,968.752991 524.843201,968.852417 525.124146,968.766479 
    C525.922852,967.718506 526.440613,966.756470 526.958374,965.794434 
    C526.957397,965.503479 527.073120,965.270508 527.490723,965.017395 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M312.269623,995.497314 
    C313.503113,996.299561 314.956665,997.287415 316.439209,998.551880 
    C315.142029,997.779968 313.815857,996.731445 312.269623,995.497314 
  z"/>
  <path fill="#9F9F9F" opacity="1.000000" stroke="none" 
    d="
  M481.789856,613.620972 
    C482.053925,614.121887 482.041473,614.298035 482.013824,614.738647 
    C480.201263,614.636414 478.403931,614.269714 476.463074,613.526184 
    C478.050842,613.198303 479.782074,613.247192 481.789856,613.620972 
  z"/>
  <path fill="#D5D5D5" opacity="1.000000" stroke="none" 
    d="
  M146.806396,626.154785 
    C146.246338,626.190979 145.949158,626.131592 145.200485,626.013550 
    C145.942093,624.636230 147.135178,623.317444 148.732849,622.443054 
    C149.200104,623.134216 149.262726,623.381042 149.325348,623.627869 
    C148.573318,624.438354 147.821304,625.248840 146.806396,626.154785 
  z"/>
  <path fill="#C3C3C3" opacity="1.000000" stroke="none" 
    d="
  M149.641739,623.487549 
    C149.262726,623.381042 149.200104,623.134216 149.086227,622.509155 
    C149.034988,622.130798 149.495621,622.021240 149.982162,621.847534 
    C150.671921,621.146484 150.875153,620.619263 151.078384,620.091980 
    C151.078384,620.091980 151.435547,619.988770 152.017120,619.985840 
    C153.125473,619.999268 153.652267,620.015503 154.179047,620.031799 
    C152.772079,621.136963 151.365097,622.242065 149.641739,623.487549 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M518.440674,977.137878 
    C519.474854,975.608093 520.509033,974.078369 521.787537,972.750610 
    C521.708618,973.639221 521.385315,974.325867 521.062073,975.012512 
    C521.034607,975.178345 521.007202,975.344238 520.622437,975.906494 
    C519.656860,976.581238 519.048767,976.859558 518.440674,977.137878 
  z"/>
  <path fill="#D5D5D5" opacity="1.000000" stroke="none" 
    d="
  M158.492706,615.968994 
    C157.477142,616.964355 156.046249,617.983521 154.360138,618.632690 
    C153.710602,614.498840 156.589813,616.463440 158.492706,615.968994 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M524.938171,796.793701 
    C523.852844,796.349609 522.832336,795.500000 521.912842,794.257019 
    C523.010254,794.705078 524.006653,795.546631 524.938171,796.793701 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M521.412964,975.005737 
    C521.385315,974.325867 521.708618,973.639221 522.065308,972.667969 
    C522.231140,972.021912 522.363525,971.660461 523.067261,971.160217 
    C524.059204,970.982178 524.479858,970.942932 524.900452,970.903687 
    C524.900452,970.903748 525.023560,971.021362 525.085938,971.079407 
    C524.020142,972.424622 522.891968,973.711853 521.412964,975.005737 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M496.717529,998.172668 
    C497.023010,998.480713 497.013855,998.877747 496.985443,999.572266 
    C496.052094,1000.237305 495.137939,1000.604980 493.970825,1001.128906 
    C494.612854,1000.277344 495.507874,999.269531 496.717529,998.172668 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M368.931488,588.904724 
    C368.210388,589.188843 367.486694,589.085693 366.398132,588.981567 
    C366.033264,588.980591 366.001831,588.993774 365.982178,588.651245 
    C365.275879,587.881470 364.589264,587.454285 363.902649,587.027100 
    C363.570282,586.615295 363.237915,586.203552 363.110474,585.438599 
    C365.186554,586.229492 367.057709,587.373474 368.931488,588.904724 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M541.348389,944.108765 
    C541.507935,942.366943 542.005066,940.414001 542.784302,938.227051 
    C542.606140,939.961243 542.145996,941.929504 541.348389,944.108765 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M309.204773,994.508911 
    C309.030426,993.736084 309.036926,993.210144 309.059204,992.290527 
    C309.970215,992.728760 310.865509,993.560669 311.787415,994.708923 
    C311.004517,994.935486 310.195068,994.845642 309.204773,994.508911 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M337.808441,1014.398438 
    C338.035309,1013.833679 338.367035,1013.648376 338.852600,1013.221863 
    C339.467133,1013.059937 339.927826,1013.139343 340.664093,1013.440063 
    C340.988403,1014.224121 341.037140,1014.786926 341.116089,1015.631836 
    C340.068665,1015.535339 338.990997,1015.156616 337.808441,1014.398438 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M537.319885,952.138062 
    C536.805542,951.980347 536.600830,951.633118 536.139709,951.123962 
    C535.962280,950.515686 536.041260,950.069275 536.318665,949.342896 
    C537.117981,949.005615 537.718872,948.948364 538.621338,948.854614 
    C538.491699,949.861572 538.060608,950.905090 537.319885,952.138062 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M341.814087,1016.396484 
    C342.778839,1016.415161 343.844330,1016.812744 345.017731,1017.559204 
    C344.055359,1017.530579 342.985046,1017.152954 341.814087,1016.396484 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M153.827179,983.313293 
    C154.730576,983.410156 155.840454,983.809326 157.070618,984.568237 
    C156.138489,984.490479 155.086060,984.053040 153.827179,983.313293 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M139.085022,966.412109 
    C139.748962,966.858826 140.341843,967.674500 140.952225,968.807739 
    C140.317810,968.343872 139.665894,967.562500 139.085022,966.412109 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M293.433258,578.240845 
    C293.684387,578.212158 293.727936,578.238953 293.731995,578.219604 
    C293.093323,578.672485 292.450623,579.144653 291.458191,579.604980 
    C291.799652,579.151855 292.490906,578.710632 293.433258,578.240845 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M518.232910,977.433838 
    C519.048767,976.859558 519.656860,976.581238 520.566223,976.152222 
    C520.420227,977.002625 519.973083,978.003601 519.128296,978.938477 
    C518.495544,978.491516 518.260315,978.110718 518.232910,977.433838 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M512.995544,982.971558 
    C513.435547,982.687073 513.875488,982.402588 514.595703,982.437744 
    C514.509094,983.781433 514.142273,984.805542 513.370728,985.901978 
    C512.966003,985.974365 512.765259,985.779297 512.826538,985.435120 
    C512.923645,984.384460 512.959595,983.677979 512.995544,982.971558 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M157.791534,985.386597 
    C158.708786,985.445801 159.747284,985.880981 160.970764,986.619751 
    C160.074768,986.536438 158.993790,986.149536 157.791534,985.386597 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M513.065369,986.072815 
    C512.351318,987.073853 511.537933,987.976440 510.347870,988.923584 
    C509.971222,988.968201 509.764313,988.768188 509.866791,988.465210 
    C510.901276,987.367920 511.833282,986.573608 512.765259,985.779297 
    C512.765259,985.779297 512.966003,985.974365 513.065369,986.072815 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M333.862732,1012.327881 
    C334.764923,1012.415100 335.855499,1012.810120 337.053955,1013.563416 
    C336.124939,1013.493042 335.088013,1013.064392 333.862732,1012.327881 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M345.821442,1018.396973 
    C346.740845,1018.449524 347.756042,1018.881592 348.948608,1019.615417 
    C348.056427,1019.536987 346.986847,1019.156738 345.821442,1018.396973 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M539.319824,948.137207 
    C539.407349,947.230347 539.803833,946.134644 540.561157,944.931641 
    C540.490967,945.865723 540.059937,946.907104 539.319824,948.137207 
  z"/>
  <path fill="#D5D5D5" opacity="1.000000" stroke="none" 
    d="
  M154.507721,619.771606 
    C153.652267,620.015503 153.125473,619.999268 152.202637,619.974121 
    C152.372223,619.315308 152.937866,618.665344 153.881104,618.069824 
    C154.451263,618.586731 154.643829,619.049072 154.507721,619.771606 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M517.161499,980.930908 
    C517.207092,979.924500 517.647034,978.987305 518.466919,978.400269 
    C518.416565,979.500366 517.986206,980.250244 517.161499,980.930908 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M515.168518,982.935303 
    C515.225525,981.936768 515.674561,981.006653 516.493713,980.419373 
    C516.429382,981.509399 515.994995,982.256592 515.168518,982.935303 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M143.063263,973.090942 
    C143.609695,972.498474 144.079758,972.272339 144.795380,972.734253 
    C145.066635,973.909302 145.092361,974.396240 145.118088,974.883118 
    C145.118088,974.883118 144.992676,975.010254 144.930634,975.074463 
    C144.241364,974.578186 143.614136,974.017700 143.063263,973.090942 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M510.076477,989.066284 
    C509.729614,989.800659 509.277527,990.436890 508.403687,991.034607 
    C507.981934,990.996094 507.791199,990.836670 507.879211,990.543396 
    C508.566284,989.756165 509.165314,989.262146 509.764313,988.768188 
    C509.764313,988.768188 509.971222,988.968201 510.076477,989.066284 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M535.378967,955.139282 
    C535.430664,954.478577 535.847656,953.738831 536.595459,952.905457 
    C536.532288,953.561340 536.138245,954.310791 535.378967,955.139282 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M371.216309,594.517212 
    C370.933197,593.645508 370.934357,593.068909 370.970612,592.057983 
    C371.668091,592.247925 372.330536,592.872253 372.925964,593.880615 
    C372.406158,594.447205 371.953369,594.629761 371.216309,594.517212 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M141.069550,971.144897 
    C141.647461,970.861084 142.226700,970.933044 143.241821,971.059265 
    C143.785309,971.405151 143.920242,971.690552 143.988663,971.991089 
    C144.021576,972.135620 143.928894,972.308777 143.589172,972.677795 
    C142.547150,972.424622 141.809021,971.962646 141.069550,971.144897 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M544.810913,831.698120 
    C544.248962,831.491760 543.668701,830.991699 543.071106,830.172729 
    C543.633362,830.370728 544.213013,830.887573 544.810913,831.698120 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M361.100708,584.768372 
    C360.882874,584.141724 360.919617,583.853394 360.981659,583.127991 
    C361.713470,583.294312 362.419952,583.897705 363.311401,584.841248 
    C362.782654,585.156555 362.068970,585.131592 361.100708,584.768372 
  z"/>
  <path fill="#D5D5D5" opacity="1.000000" stroke="none" 
    d="
  M150.754593,620.120667 
    C150.875153,620.619263 150.671921,621.146484 150.216492,621.813843 
    C150.119781,621.352417 150.275284,620.750854 150.754593,620.120667 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M151.936066,981.356323 
    C152.321396,981.445923 152.725586,981.885376 153.191742,982.635254 
    C152.820786,982.532410 152.387848,982.119324 151.936066,981.356323 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M331.921875,1010.361084 
    C332.284180,1010.456116 332.683289,1010.888062 333.137329,1011.625854 
    C332.781097,1011.520447 332.369904,1011.109253 331.921875,1010.361084 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M370.933105,590.948120 
    C370.353394,590.986877 369.765564,590.656067 369.093079,589.985901 
    C369.647278,589.957275 370.286133,590.267883 370.933105,590.948120 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M457.273071,1022.029297 
    C457.274414,1021.896362 457.521088,1021.730957 457.880737,1021.712402 
    C457.993744,1021.859314 457.518372,1021.996887 457.273071,1022.029297 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M508.073608,991.080017 
    C508.072083,991.493530 507.885925,991.757507 507.384277,992.059937 
    C507.161865,992.164062 506.997070,991.978333 507.049988,991.697144 
    C507.295074,991.178650 507.524475,990.985535 507.791199,990.836670 
    C507.791199,990.836670 507.981934,990.996094 508.073608,991.080017 
  z"/>
  <path fill="#A349A4" opacity="1.000000" stroke="none" 
    d="
  M1281.110840,628.087830 
    C1284.236450,636.740845 1287.544067,645.333008 1290.460327,654.056030 
    C1333.482422,782.744812 1376.455078,911.450012 1419.433350,1040.153442 
    C1430.740112,1074.012573 1441.961914,1107.900269 1453.413330,1141.710327 
    C1454.654907,1145.375732 1454.003784,1147.078857 1450.842163,1149.309204 
    C1308.438599,1249.765747 1166.116089,1350.337036 1023.778564,1450.886963 
    C1016.181213,1456.253784 1008.536926,1461.554443 1000.708435,1467.030151 
    C849.297058,1360.107300 698.015381,1253.276001 546.650879,1146.386108 
    C554.873047,1121.637939 562.948303,1097.218262 571.097229,1072.823242 
    C618.004822,932.397034 664.926514,791.975647 711.858093,651.557434 
    C714.418213,643.897766 717.109253,636.281921 720.402100,628.326172 
    C906.248901,628.004395 1091.432861,628.002014 1276.616821,628.003662 
    C1278.114868,628.003662 1279.612793,628.058533 1281.110840,628.087830 
  M1218.722534,1052.846069 
    C1219.124512,1052.150391 1219.526489,1051.454712 1219.925049,1050.924072 
    C1219.925049,1050.924072 1219.762939,1050.893311 1220.478638,1050.950806 
    C1221.421509,1050.328735 1222.364380,1049.706665 1223.652588,1048.918701 
    C1223.868652,1048.761719 1224.010498,1048.554077 1224.577637,1047.947876 
    C1225.013550,1047.305176 1225.449463,1046.662354 1225.909424,1045.489014 
    C1225.904907,1045.311890 1225.900513,1045.134888 1226.163940,1044.471924 
    C1226.402710,1043.988037 1226.641479,1043.504150 1226.958008,1042.262085 
    C1226.931152,1041.501953 1226.904297,1040.741699 1226.797485,1039.429443 
    C1226.531250,1038.941895 1226.265015,1038.454346 1226.039062,1037.246948 
    C1224.097046,1034.145508 1222.155029,1031.044067 1220.060547,1027.306274 
    C1219.406738,1026.509033 1218.753052,1025.711792 1218.078491,1024.124146 
    C1216.966675,1019.820190 1215.621094,1015.674561 1210.514038,1013.328796 
    C1210.352295,1013.182861 1210.190430,1013.036987 1209.934814,1012.065125 
    C1209.961182,1010.736816 1210.530762,1009.049866 1209.928101,1008.136963 
    C1205.061157,1000.765625 1199.973999,993.539917 1194.266113,986.022644 
    C1191.382935,984.269775 1188.711304,983.071655 1185.048462,984.760437 
    C1180.237183,986.978760 1175.034668,988.348755 1169.150757,990.099609 
    C1163.692383,990.435547 1158.078369,990.391174 1154.212891,996.624023 
    C1152.780273,997.344727 1151.347534,998.065430 1150.240234,998.622437 
    C1147.240112,996.529358 1144.487549,994.609070 1141.627563,992.700134 
    C1141.411743,992.547119 1141.210205,992.407593 1140.044189,992.180908 
    C1139.720947,992.124878 1139.397705,992.068787 1138.979858,991.251099 
    C1136.003906,986.253662 1130.980713,985.059998 1125.828857,984.087280 
    C1125.828857,984.087280 1125.888916,984.133850 1125.971924,983.215149 
    C1124.647095,976.598389 1123.322144,969.981689 1121.976929,962.485474 
    C1121.956665,961.312927 1121.936401,960.140381 1122.128296,958.292480 
    C1122.122070,954.690186 1122.141113,951.087585 1122.103760,947.485596 
    C1122.049438,942.252930 1118.420532,938.892212 1112.236938,939.070618 
    C1092.392334,939.110779 1072.547852,939.150879 1051.906372,939.123352 
    C1048.773804,938.362183 1046.682007,939.869324 1045.988647,942.659668 
    C1044.420044,948.972839 1042.932007,955.334167 1041.953491,961.758423 
    C1040.854736,968.973145 1040.353027,976.278809 1039.650024,982.987366 
    C1038.046997,983.924500 1036.866089,984.645142 1035.657349,985.315552 
    C1032.779419,986.911682 1029.888428,988.484009 1026.310425,989.964172 
    C1025.212158,990.648743 1024.113892,991.333313 1022.944275,992.371582 
    C1022.944275,992.371582 1022.952881,992.732361 1022.234131,992.862000 
    C1020.425232,993.837646 1018.616394,994.813293 1016.155457,995.482666 
    C1010.072571,993.624939 1003.490417,992.662170 998.061096,989.633057 
    C993.521545,987.100464 989.317322,985.654297 983.267639,985.275940 
    C980.515198,984.878601 977.762695,984.481201 974.156372,984.076477 
    C972.753052,984.497375 970.623230,984.477966 970.059570,985.407837 
    C964.884155,993.946045 959.773254,1002.538269 955.071411,1011.343323 
    C952.038147,1017.023804 949.720825,1023.086609 947.108154,1029.703979 
    C943.246948,1034.487305 940.779663,1039.625244 942.466614,1046.228271 
    C942.620117,1046.865234 942.773560,1047.502075 943.164612,1048.674194 
    C943.753845,1049.182373 944.343079,1049.690552 945.096313,1050.592163 
    C945.265991,1050.838867 945.497498,1050.992554 946.197510,1051.639648 
    C949.402222,1054.144653 952.606873,1056.649536 955.897583,1059.131104 
    C955.897583,1059.131104 955.951721,1059.060181 956.071167,1059.603027 
    C956.393799,1059.744873 956.716370,1059.886841 957.346008,1060.107666 
    C957.346008,1060.107666 957.662964,1060.112793 957.871094,1060.809570 
    C960.018066,1062.139160 962.164978,1063.468872 964.169434,1064.847778 
    C964.169434,1064.847778 964.176758,1064.697144 964.152710,1065.448486 
    C964.831421,1065.555298 965.510193,1065.661987 966.048584,1065.791748 
    C966.048584,1065.791748 966.161194,1065.704834 965.997070,1066.433960 
    C967.006409,1067.292358 968.015808,1068.150635 969.365173,1069.085205 
    C969.365173,1069.085205 969.713684,1069.092529 969.906067,1069.843140 
    C971.117188,1069.876343 972.328308,1069.909546 974.003540,1069.804810 
    C974.263611,1070.157837 974.523621,1070.510864 974.409790,1071.323242 
    C974.387512,1071.892456 974.365234,1072.461670 974.101074,1073.800903 
    C969.818115,1081.895630 972.183838,1090.114502 972.860168,1098.915527 
    C969.454346,1101.348877 965.056091,1104.130859 961.105286,1107.446167 
    C958.641968,1109.513184 956.854431,1112.385376 953.934937,1115.769165 
    C953.561523,1115.915771 953.188049,1116.062500 952.480286,1116.562134 
    C950.634521,1118.055542 948.788818,1119.548950 946.151001,1121.869995 
    C945.802307,1122.025757 945.453674,1122.181396 945.173218,1122.324707 
    C945.173218,1122.324707 945.114075,1122.277588 944.123596,1123.048950 
    C943.560120,1123.667969 942.996704,1124.286987 942.565552,1125.017578 
    C942.545532,1125.198364 942.534363,1125.366089 942.286865,1126.300781 
    C942.145020,1126.533447 942.003174,1126.766235 941.455505,1127.673218 
    C940.061523,1132.896362 941.704895,1137.401611 944.887878,1141.448853 
    C946.066956,1142.947998 947.585876,1144.179810 949.017883,1146.286255 
    C949.044434,1146.534790 949.070923,1146.783325 948.968201,1147.770752 
    C950.235840,1150.249146 951.503479,1152.727417 952.886597,1155.891968 
    C953.876648,1156.968384 954.866760,1158.044800 955.989929,1159.749023 
    C956.366882,1160.508667 956.743835,1161.268433 957.267700,1162.696899 
    C957.881653,1163.655029 958.495605,1164.613037 958.970520,1165.447998 
    C958.970520,1165.447998 959.088928,1165.304688 959.089844,1166.038940 
    C959.717773,1166.724976 960.345703,1167.410889 961.036621,1168.560669 
    C961.036621,1168.560669 961.118774,1169.021606 961.240295,1169.666748 
    C962.141235,1170.135986 963.042114,1170.605347 964.414001,1171.074707 
    C964.414001,1171.074707 964.853149,1171.244995 965.214783,1171.576050 
    C965.417480,1171.912598 965.371826,1172.211182 964.371765,1172.894653 
    C964.881836,1174.375854 965.391907,1175.857178 965.905273,1177.644409 
    C965.905273,1177.644409 965.972778,1177.942993 965.923950,1178.698853 
    C967.351379,1180.296631 968.778809,1181.894287 970.060974,1183.467773 
    C970.060974,1183.467773 970.102478,1183.326538 969.972900,1184.213135 
    C970.330566,1185.205078 970.410400,1186.486694 971.092163,1187.140869 
    C974.792725,1190.692017 979.056824,1189.270752 983.675903,1187.974731 
    C983.874634,1187.702271 984.073364,1187.429810 985.073425,1187.125732 
    C987.809143,1185.772461 990.544861,1184.419189 994.096069,1183.094727 
    C995.894592,1182.624268 997.689331,1182.138794 999.492371,1181.686157 
    C1007.772644,1179.607178 1015.472961,1170.704102 1024.682251,1179.537720 
    C1024.801147,1179.651733 1024.891846,1179.795410 1025.187256,1180.613403 
    C1027.071411,1181.467285 1028.955444,1182.321289 1030.940186,1183.911133 
    C1032.532837,1184.940430 1034.152710,1185.930664 1035.710327,1187.010498 
    C1037.115967,1187.984863 1039.383789,1188.855469 1039.658081,1190.121338 
    C1040.751953,1195.168945 1041.283081,1200.344849 1041.895996,1205.488525 
    C1042.645264,1211.775024 1042.987305,1218.126709 1044.096924,1224.344604 
    C1044.483521,1226.510498 1046.630615,1228.362427 1047.926880,1230.636475 
    C1047.926880,1230.636475 1047.985718,1230.913086 1048.119263,1231.567749 
    C1048.736450,1231.729858 1049.353516,1231.891968 1049.990234,1232.000000 
    C1049.990234,1232.000000 1049.960938,1232.053589 1050.264893,1232.816406 
    C1052.107300,1233.249634 1053.947876,1234.050049 1055.792358,1234.059448 
    C1074.202637,1234.152954 1092.614258,1234.039673 1111.023804,1234.191895 
    C1114.063110,1234.216919 1116.350464,1233.541504 1118.016724,1231.057861 
    C1118.016724,1231.057861 1118.055176,1231.067261 1118.825317,1231.039429 
    C1121.998657,1227.968750 1122.465210,1224.149658 1121.979126,1219.206421 
    C1122.007690,1217.816650 1122.036377,1216.426758 1122.794800,1214.766357 
    C1123.167847,1212.523926 1123.540894,1210.281494 1124.010498,1207.188232 
    C1124.036743,1205.477539 1124.062866,1203.766846 1124.820435,1201.755493 
    C1125.163818,1198.875000 1125.507202,1195.994385 1125.967651,1192.264282 
    C1125.937866,1191.125122 1125.908081,1189.985840 1125.922119,1188.925049 
    C1125.922119,1188.925049 1125.832275,1188.926392 1126.613647,1189.019287 
    C1127.025391,1188.258301 1127.437134,1187.497314 1127.867920,1186.883301 
    C1127.867920,1186.883301 1127.721924,1186.857056 1128.553223,1187.012207 
    C1131.158691,1185.702271 1133.764160,1184.392334 1136.644165,1183.095947 
    C1136.644165,1183.095947 1136.910889,1183.023804 1137.634521,1183.063477 
    C1139.520874,1181.722534 1141.407227,1180.381592 1143.656616,1179.021973 
    C1143.656616,1179.021973 1144.005737,1178.920410 1144.602783,1178.787354 
    C1145.178101,1178.204102 1145.753418,1177.620850 1146.619873,1177.079590 
    C1146.619873,1177.079590 1146.907104,1177.016113 1147.651123,1176.861816 
    C1149.763428,1176.248657 1151.875732,1175.635498 1154.381348,1175.609497 
    C1159.556274,1177.746216 1164.731201,1179.882935 1170.346558,1182.605957 
    C1174.734497,1184.657715 1179.115967,1186.723267 1183.511963,1188.757935 
    C1189.432251,1191.498047 1196.986938,1187.943359 1198.214600,1181.336182 
    C1199.510864,1179.167114 1200.812866,1177.001587 1202.102295,1174.828613 
    C1204.802979,1170.276733 1207.496948,1165.720825 1210.933838,1161.070190 
    C1211.359375,1159.775757 1211.784912,1158.481201 1212.958862,1157.061768 
    C1214.683228,1153.739258 1216.407593,1150.416626 1218.099609,1147.053467 
    C1218.099609,1147.053467 1218.048584,1147.060303 1218.496826,1146.882446 
    C1218.800171,1146.683838 1218.925049,1146.405273 1219.105591,1145.510010 
    C1219.461670,1145.046021 1219.817749,1144.582153 1220.667114,1143.758179 
    C1221.069702,1142.842285 1221.472168,1141.926514 1221.933350,1140.568848 
    C1221.933350,1140.568848 1222.016968,1140.130981 1222.793823,1140.046875 
    C1223.905640,1137.405396 1225.017456,1134.763916 1226.916260,1132.032104 
    C1227.198975,1130.448364 1228.131714,1128.621582 1227.646729,1127.324951 
    C1225.967163,1122.834595 1223.046387,1119.286865 1218.059204,1117.114014 
    C1215.742065,1115.807861 1213.425049,1114.501831 1210.528076,1113.283447 
    C1209.765747,1112.918945 1209.003296,1112.554443 1207.500122,1111.892090 
    C1207.343750,1111.676880 1207.187256,1111.461548 1206.733643,1111.068359 
    C1206.432617,1110.760132 1206.131714,1110.451782 1205.177612,1109.838623 
    C1205.093140,1109.613525 1205.008789,1109.388550 1204.694824,1108.635986 
    C1196.254272,1102.097778 1191.868286,1093.912842 1193.939819,1082.923584 
    C1194.362915,1080.678467 1193.653564,1078.193970 1194.204102,1076.005615 
    C1194.823853,1073.542236 1195.878906,1070.963501 1197.461914,1069.018677 
    C1199.978271,1065.927368 1203.088989,1063.319702 1206.090088,1060.007324 
    C1206.261108,1059.978882 1206.432007,1059.950562 1206.956299,1059.554565 
    C1207.633789,1059.383545 1208.311279,1059.212402 1209.133911,1059.446655 
    C1209.459351,1059.347290 1209.784790,1059.247925 1210.745850,1059.071655 
    C1211.857910,1058.162720 1212.970093,1057.253784 1214.634644,1055.898438 
    C1214.935181,1055.532471 1215.235718,1055.166504 1215.507080,1054.655884 
    C1215.507080,1054.655884 1215.752808,1054.558105 1216.397217,1054.234863 
    C1216.997192,1053.883179 1217.597168,1053.531494 1218.722534,1052.846069 
  M969.970032,902.934509 
    C969.970032,902.934509 970.067749,902.976929 969.722046,903.050537 
    C969.394165,902.914368 969.066223,902.778259 967.460144,901.131775 
    C967.178650,900.535339 966.897095,899.938904 966.631958,899.411743 
    C966.631958,899.411743 966.748779,899.387329 966.010071,899.287659 
    C965.323975,899.054993 964.637878,898.822327 963.919678,897.570496 
    C963.916077,890.784302 963.912476,883.998047 964.182617,876.537476 
    C968.624939,873.624268 973.067261,870.711121 977.742371,867.280151 
    C978.818054,866.859314 979.893677,866.438477 981.697998,865.761841 
    C985.075684,862.502563 984.710754,858.716675 983.118713,854.055359 
    C981.492004,851.634705 979.865356,849.214050 978.149048,846.092468 
    C977.180786,844.319519 976.212524,842.546509 974.861572,840.153564 
    C973.289246,837.674988 971.716919,835.196411 970.095337,832.369629 
    C970.095337,832.369629 970.018066,832.026611 970.075195,831.310242 
    C968.758301,829.435425 967.441467,827.560669 966.102295,825.354797 
    C966.102295,825.354797 966.022278,825.032776 965.848083,824.402161 
    C965.236572,824.228821 964.625061,824.055481 963.973511,823.160828 
    C962.990845,822.932251 962.008118,822.703674 960.775635,821.754272 
    C959.506531,821.863708 958.237427,821.973145 956.952881,821.986084 
    C956.952881,821.986084 957.046692,821.958679 956.440491,822.453674 
    C954.280884,823.027527 952.121216,823.601379 949.178589,824.015686 
    C948.540344,824.084534 947.868774,824.048523 947.269165,824.238953 
    C942.571411,825.731079 937.887390,827.266479 932.967285,828.366638 
    C932.767151,828.103638 932.513367,827.911560 931.784790,827.230652 
    C929.205566,826.196411 926.626404,825.162109 923.453735,823.698853 
    C921.925293,820.778503 920.396912,817.858215 918.983398,814.120300 
    C918.991699,812.739624 918.999939,811.359009 919.095032,809.145996 
    C918.425476,804.947021 918.152588,800.625549 916.910889,796.603149 
    C916.332031,794.728027 913.910828,792.123901 912.265625,792.080261 
    C898.675293,791.719971 885.066406,791.711121 871.476440,792.083191 
    C869.570312,792.135376 866.478210,794.571045 866.112305,796.350952 
    C865.131592,801.121948 865.510742,806.154053 865.008850,811.047546 
    C864.594666,815.086243 863.693481,819.075073 863.006592,823.004639 
    C863.006592,823.004639 863.087952,823.005371 862.403931,823.197815 
    C861.263733,823.490662 860.123535,823.783447 858.249695,823.985657 
    C855.763855,825.247437 853.278076,826.509155 850.090393,827.886963 
    C848.737244,827.879761 847.315186,828.141907 846.043457,827.816589 
    C841.685486,826.701782 837.380249,825.380859 832.280334,824.024109 
    C830.491882,823.680664 828.703430,823.337280 827.007629,822.998474 
    C827.007629,822.998474 827.004517,823.091248 826.837708,822.421021 
    C824.926025,822.533203 823.014282,822.645386 820.633362,823.098572 
    C820.180298,823.444214 819.727173,823.789856 818.886292,823.733215 
    C818.631226,824.211853 818.376160,824.690491 818.066406,825.060974 
    C818.066406,825.060974 818.170776,825.122742 817.400024,824.977478 
    C813.884766,829.464722 809.927124,833.736694 810.016602,840.543823 
    C809.728027,840.725647 809.439453,840.907410 808.574646,841.209778 
    C808.097412,841.795105 807.620178,842.380493 806.900269,843.442810 
    C806.572510,843.864197 806.244751,844.285583 805.170044,844.883179 
    C804.776001,845.945007 804.381897,847.006836 803.926025,848.365845 
    C803.926025,848.365845 803.930725,848.669434 803.171204,848.887390 
    C802.757080,850.253479 802.342957,851.619568 801.974792,852.933167 
    C801.974792,852.933167 801.922791,852.886536 801.144287,852.962402 
    C800.087402,854.746033 798.655579,856.416443 798.073792,858.343567 
    C797.428223,860.482117 797.688599,862.744385 801.010132,862.002686 
    C801.010132,862.002686 801.049622,861.939209 800.846191,862.680298 
    C804.072021,865.862122 807.301636,869.040039 810.522766,872.226624 
    C814.849609,876.506958 820.563782,879.419006 820.270081,887.278137 
    C820.055420,893.020203 818.768982,897.289307 814.065735,900.555969 
    C812.902527,901.363770 812.145630,902.756714 811.008667,904.646362 
    C810.816772,904.826477 810.624817,905.006531 810.484497,905.178528 
    C810.484497,905.178528 810.528198,905.176819 809.822937,905.854492 
    C809.007141,906.367310 808.191406,906.880188 807.322083,907.663818 
    C807.085999,907.837280 806.849854,908.010803 806.133179,909.096130 
    C805.950745,909.387268 805.768311,909.678406 805.629150,909.920715 
    C805.629150,909.920715 805.692688,909.905518 804.573669,909.551331 
    C804.188416,909.482971 803.803162,909.414612 803.220398,909.659485 
    C802.771118,909.865784 802.321838,910.072083 801.206421,910.358032 
    C799.767029,913.116272 795.325439,915.429932 799.932861,919.868591 
    C801.254456,922.367737 802.575989,924.866943 803.902161,927.628540 
    C803.902161,927.628540 803.971497,927.883362 803.934204,928.630371 
    C804.606079,929.213196 805.278015,929.796021 805.922791,930.647034 
    C805.922791,930.647034 805.980652,930.910339 805.955750,931.673340 
    C807.280029,933.560303 808.604248,935.447327 809.925110,937.625610 
    C809.925110,937.625610 809.984558,937.912720 809.929749,938.627258 
    C811.026306,939.738281 812.122864,940.849304 813.076111,941.977844 
    C813.076111,941.977844 813.075562,941.833496 813.201660,942.385010 
    C813.509460,942.584595 813.817322,942.784119 814.029846,942.946533 
    C814.029846,942.946533 814.077698,942.856140 814.082214,943.626343 
    C815.615967,947.097778 817.149658,950.569153 818.676514,954.024963 
    C821.226929,954.024963 823.682495,954.516724 825.830566,953.913574 
    C829.336914,952.928894 832.642700,951.230225 836.828491,949.987610 
    C839.718079,948.615051 842.607666,947.242493 845.475708,945.970581 
    C845.475708,945.970581 845.377563,945.939880 846.313416,945.981384 
    C847.856812,945.918823 849.400146,945.856262 851.368958,945.902649 
    C851.368958,945.902649 851.805054,945.954468 852.222290,946.566956 
    C856.263916,948.639771 860.305603,950.712524 864.604248,953.509155 
    C864.744263,959.082092 864.456726,964.710938 865.175293,970.208252 
    C865.651123,973.848389 864.107971,978.240723 867.999939,981.014038 
    C867.999939,981.014038 867.934753,981.010986 868.080505,981.533691 
    C868.382751,981.709839 868.684998,981.886047 868.991272,981.999878 
    C868.991272,981.999878 868.939209,982.034302 869.280579,982.777466 
    C870.126892,983.193604 870.971008,983.966919 871.819946,983.972229 
    C884.695496,984.053101 897.572083,984.072083 910.446960,983.950378 
    C911.312195,983.942200 912.165833,982.692749 913.763428,981.910706 
    C914.851318,979.513855 916.442444,977.213318 916.923035,974.700378 
    C917.942444,969.369873 918.079590,963.864624 919.199951,958.562378 
    C919.697205,956.209351 921.701416,954.174744 923.825989,952.010803 
    C925.347778,949.459961 933.962769,945.366577 936.246643,946.315308 
    C941.857971,948.646240 947.414795,951.109924 952.972168,953.568604 
    C956.406067,955.087891 963.395691,953.719055 965.695190,950.695435 
    C965.810120,949.810059 965.925049,948.924744 966.845032,947.991882 
    C967.390259,946.604675 967.935486,945.217407 968.471069,943.965027 
    C968.471069,943.965027 968.337585,943.943848 969.115295,943.930481 
    C970.088806,942.593933 971.062317,941.257385 972.102600,939.658203 
    C972.102600,939.658203 972.080933,939.388123 972.902954,939.094482 
    C973.218384,937.824951 973.533752,936.555481 973.951111,935.407288 
    C973.951111,935.407288 973.820251,935.496704 974.548889,935.195801 
    C975.042603,934.438293 975.536316,933.680786 976.104004,932.643127 
    C976.104004,932.643127 976.114990,932.353699 976.706543,931.956604 
    C977.873291,929.703430 979.040039,927.450195 980.633545,924.970398 
    C980.897827,924.770935 981.094238,924.518677 981.805359,923.714905 
    C982.205322,922.855408 982.511230,921.935181 983.020874,921.146545 
    C985.713318,916.980103 984.278198,910.798157 980.084167,908.919373 
    C980.084167,908.919373 980.036926,908.948853 979.916504,908.402710 
    C979.590210,908.264832 979.263855,908.126892 978.395203,907.759521 
    C977.675354,907.489624 976.955505,907.219727 976.006348,906.233765 
    C974.789856,905.504700 973.573364,904.775574 972.483398,904.001099 
    C972.483398,904.001099 972.526672,904.128418 972.022888,903.561829 
    C971.319153,903.382385 970.615356,903.202942 969.970032,902.934509 
  z"/>
  <path fill="#828181" opacity="1.000000" stroke="none" 
    d="
  M1280.895752,627.697632 
    C1279.612793,628.058533 1278.114868,628.003662 1276.616821,628.003662 
    C1091.432861,628.002014 906.248901,628.004395 720.607239,628.011902 
    C721.658203,627.680847 723.166748,627.050293 724.675476,627.049927 
    C908.690125,627.005798 1092.704834,627.007629 1276.719482,627.020569 
    C1278.039917,627.020691 1279.360352,627.207642 1280.895752,627.697632 
  z"/>
  <path fill="#9C9C9C" opacity="1.000000" stroke="none" 
    d="
  M1604.858643,1532.642212 
    C1605.554077,1533.289307 1607.090454,1534.371704 1607.106812,1535.476685 
    C1607.282227,1547.265137 1607.186279,1559.057129 1607.237915,1570.847900 
    C1607.250977,1573.829590 1605.899658,1575.163208 1602.987671,1574.918213 
    C1600.707397,1574.726685 1598.435303,1574.438110 1596.005371,1573.852539 
    C1596.155884,1573.383057 1596.454834,1573.156982 1596.766357,1573.138062 
    C1605.728394,1572.588379 1605.728882,1572.591797 1605.728882,1563.333496 
    C1605.729004,1555.037720 1605.770752,1546.741577 1605.695068,1538.446411 
    C1605.678833,1536.658325 1605.238770,1534.874023 1604.858643,1532.642212 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1444.026245,1429.270996 
    C1446.106567,1428.711060 1448.154907,1428.395996 1450.596802,1428.063354 
    C1452.913208,1428.076782 1454.836304,1428.108032 1457.234619,1428.264771 
    C1453.380615,1429.018311 1449.051270,1429.646484 1444.360352,1430.142090 
    C1443.998535,1430.009766 1443.994385,1429.515869 1444.026245,1429.270996 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1351.046387,1467.418701 
    C1353.660156,1466.458130 1356.238647,1465.827759 1359.216675,1465.303223 
    C1355.584229,1467.333496 1351.552124,1469.257812 1347.264160,1471.069092 
    C1348.342529,1469.886963 1349.676880,1468.817871 1351.046387,1467.418701 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1426.313354,1437.567139 
    C1426.962891,1436.633179 1427.975830,1435.703125 1429.077271,1434.478149 
    C1431.698975,1433.504883 1434.232056,1432.826538 1437.171265,1432.208130 
    C1433.943726,1434.035767 1430.310181,1435.803589 1426.313354,1437.567139 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1486.203613,1591.283447 
    C1489.052490,1593.488159 1491.935791,1596.019287 1494.881836,1598.893677 
    C1492.042480,1596.694580 1489.140259,1594.152100 1486.203613,1591.283447 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M1584.279053,1572.421143 
    C1581.843872,1572.285034 1579.166870,1571.900391 1576.237549,1571.229248 
    C1578.669067,1571.352661 1581.353271,1571.762695 1584.279053,1572.421143 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1388.391113,1701.487549 
    C1386.263306,1701.305664 1383.862549,1700.906982 1381.216064,1700.210205 
    C1383.352905,1700.364990 1385.735474,1700.817749 1388.391113,1701.487549 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M1574.142700,1570.543091 
    C1572.073486,1570.345825 1569.770264,1569.915405 1567.221680,1569.196533 
    C1569.287109,1569.375366 1571.597900,1569.842651 1574.142700,1570.543091 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1273.566650,1665.364502 
    C1273.730103,1663.235596 1274.120483,1660.846680 1274.809814,1658.212402 
    C1274.670410,1660.346069 1274.232056,1662.725342 1273.566650,1665.364502 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1271.774902,1674.628174 
    C1271.876099,1672.715942 1272.201660,1670.556030 1272.804688,1668.185547 
    C1272.721069,1670.110229 1272.360229,1672.245483 1271.774902,1674.628174 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1368.341797,1697.534302 
    C1366.238892,1697.368286 1363.861450,1696.987549 1361.243652,1696.308716 
    C1363.357910,1696.446899 1365.712524,1696.883179 1368.341797,1697.534302 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1358.332275,1695.530884 
    C1356.231567,1695.360474 1353.866333,1694.963379 1351.250244,1694.281738 
    C1353.355347,1694.432861 1355.711670,1694.868408 1358.332275,1695.530884 
  z"/>
  <path fill="#ADADAD" opacity="1.000000" stroke="none" 
    d="
  M1302.763428,1641.535889 
    C1304.852661,1641.677246 1307.183350,1642.056763 1309.758911,1642.725464 
    C1307.670776,1642.601074 1305.338013,1642.187622 1302.763428,1641.535889 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1275.602051,1655.390747 
    C1275.744873,1653.263062 1276.122803,1650.877686 1276.786621,1648.235107 
    C1276.660767,1650.362915 1276.249146,1652.748047 1275.602051,1655.390747 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1464.556641,1428.610596 
    C1466.398193,1428.687622 1468.500854,1428.979614 1470.795898,1429.615234 
    C1468.931396,1429.580933 1466.874512,1429.203247 1464.556641,1428.610596 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1378.400879,1699.471558 
    C1376.280518,1699.307617 1373.887329,1698.922607 1371.240479,1698.249634 
    C1373.367310,1698.391357 1375.747681,1698.820923 1378.400879,1699.471558 
  z"/>
  <path fill="#ADADAD" opacity="1.000000" stroke="none" 
    d="
  M1277.628174,1645.303955 
    C1277.823730,1643.091553 1278.279419,1640.630737 1279.034912,1637.994751 
    C1278.852661,1640.231567 1278.370605,1642.643555 1277.628174,1645.303955 
  z"/>
  <path fill="#ADADAD" opacity="1.000000" stroke="none" 
    d="
  M1312.741211,1643.556396 
    C1314.849121,1643.691284 1317.183594,1644.081787 1319.765381,1644.760498 
    C1317.664307,1644.636475 1315.316162,1644.224365 1312.741211,1643.556396 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1421.488281,1686.600220 
    C1421.318481,1688.414673 1420.929810,1690.488037 1420.230957,1692.793823 
    C1420.370239,1690.970459 1420.819824,1688.914917 1421.488281,1686.600220 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1419.429443,1695.553955 
    C1419.256836,1697.389648 1418.856323,1699.476074 1418.154297,1701.806152 
    C1418.302246,1699.968140 1418.751831,1697.886353 1419.429443,1695.553955 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1397.524902,1703.276733 
    C1395.678223,1703.172485 1393.575684,1702.847900 1391.224487,1702.225830 
    C1393.073608,1702.304443 1395.171265,1702.680298 1397.524902,1703.276733 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1407.522827,1705.285278 
    C1405.658325,1705.150757 1403.539307,1704.791504 1401.178223,1704.121582 
    C1403.046875,1704.227539 1405.157715,1704.644043 1407.522827,1705.285278 
  z"/>
  <path fill="#ADADAD" opacity="1.000000" stroke="none" 
    d="
  M1284.299194,1637.839478 
    C1285.948120,1637.889038 1287.788086,1638.204468 1289.822754,1638.793335 
    C1288.174927,1638.746338 1286.332642,1638.425903 1284.299194,1637.839478 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1455.950684,1633.842285 
    C1455.519409,1634.025391 1455.088867,1633.965088 1454.334473,1633.946777 
    C1453.343506,1632.688110 1452.676270,1631.387451 1451.952515,1629.771240 
    C1453.148560,1630.488159 1454.401123,1631.520874 1455.810181,1632.833130 
    C1455.966553,1633.112671 1455.951416,1633.598999 1455.950684,1633.842285 
  z"/>
  <path fill="#ADADAD" opacity="1.000000" stroke="none" 
    d="
  M1293.591675,1639.729980 
    C1295.412964,1639.808472 1297.459351,1640.137451 1299.757812,1640.752441 
    C1297.945557,1640.685669 1295.881226,1640.332886 1293.591675,1639.729980 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1423.309326,1678.475586 
    C1423.214600,1679.999512 1422.905151,1681.767090 1422.289795,1683.769775 
    C1422.354248,1682.243042 1422.724487,1680.480957 1423.309326,1678.475586 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1425.376465,1669.511963 
    C1425.248413,1671.027222 1424.912720,1672.793457 1424.264648,1674.787598 
    C1424.357666,1673.264648 1424.763184,1671.513794 1425.376465,1669.511963 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1481.066895,1434.326416 
    C1482.201660,1434.890991 1483.504761,1435.736694 1484.898438,1436.925903 
    C1483.737793,1436.382080 1482.486450,1435.494751 1481.066895,1434.326416 
  z"/>
  <path fill="#9C9C9C" opacity="1.000000" stroke="none" 
    d="
  M1564.842529,1524.572510 
    C1565.865967,1524.502197 1567.060791,1524.739014 1568.630371,1524.985352 
    C1568.996094,1525.168945 1568.986816,1525.343018 1568.980347,1525.778564 
    C1567.659912,1525.653320 1566.336792,1525.266602 1564.842529,1524.572510 
  z"/>
  <path fill="#9C9C9C" opacity="1.000000" stroke="none" 
    d="
  M1537.164062,1507.279297 
    C1538.009644,1507.478882 1538.902832,1508.001953 1539.872803,1508.839844 
    C1539.037109,1508.637207 1538.124390,1508.119995 1537.164062,1507.279297 
  z"/>
  <path fill="#9C9C9C" opacity="1.000000" stroke="none" 
    d="
  M1549.875732,1516.491699 
    C1550.703247,1516.635986 1551.702881,1517.067505 1552.827881,1517.825928 
    C1551.984741,1517.694946 1551.016235,1517.236938 1549.875732,1516.491699 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M1589.820557,1573.006714 
    C1589.394165,1573.260620 1588.826660,1573.343750 1588.127075,1573.203369 
    C1588.556519,1572.931885 1589.117920,1572.883911 1589.820557,1573.006714 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1376.815552,1573.107910 
    C1376.732178,1573.614502 1376.362793,1574.204956 1375.685791,1574.659668 
    C1375.761841,1574.079956 1376.145630,1573.635864 1376.815552,1573.107910 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1497.992432,1602.351562 
    C1498.617554,1602.463135 1499.296631,1602.881714 1500.000732,1603.628906 
    C1499.365967,1603.524658 1498.706055,1603.091431 1497.992432,1602.351562 
  z"/>
  <path fill="#9C9C9C" opacity="1.000000" stroke="none" 
    d="
  M1569.868896,1526.466797 
    C1570.463989,1526.364502 1571.208130,1526.530518 1572.060303,1526.982544 
    C1571.451416,1527.090698 1570.734863,1526.912964 1569.868896,1526.466797 
  z"/>
  <path fill="#9C9C9C" opacity="1.000000" stroke="none" 
    d="
  M1542.208252,1511.224365 
    C1542.764648,1511.258301 1543.375610,1511.573730 1544.067871,1512.148193 
    C1543.520264,1512.106934 1542.891479,1511.806396 1542.208252,1511.224365 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1440.260010,1431.620972 
    C1440.610718,1431.108398 1441.267578,1430.623901 1442.263916,1430.215210 
    C1441.924316,1430.743652 1441.245361,1431.196411 1440.260010,1431.620972 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1477.662598,1432.478760 
    C1478.258179,1432.481201 1479.058838,1432.708984 1479.954346,1433.260254 
    C1479.321899,1433.290405 1478.594849,1432.997192 1477.662598,1432.478760 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1389.218750,1453.251709 
    C1389.500610,1452.789673 1390.042480,1452.399048 1390.854736,1452.030273 
    C1390.576294,1452.475830 1390.027588,1452.899536 1389.218750,1453.251709 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1472.742310,1429.210449 
    C1472.910767,1429.282715 1472.874634,1429.494141 1472.758545,1430.017578 
    C1472.678589,1430.329468 1472.300293,1430.453125 1472.159058,1430.312988 
    C1472.081909,1429.829468 1472.255127,1429.554932 1472.742310,1429.210449 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1456.083496,1396.577637 
    C1455.632324,1396.707642 1455.098755,1396.468994 1454.300537,1396.101318 
    C1453.053345,1392.722656 1452.070923,1389.473022 1451.140381,1385.797119 
    C1452.795410,1388.983643 1454.398193,1392.596313 1456.083496,1396.577637 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1450.647461,1376.609863 
    C1450.295898,1375.415039 1450.084473,1373.816772 1450.172119,1372.103394 
    C1450.576538,1373.394287 1450.682007,1374.800293 1450.647461,1376.609863 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1469.049927,1410.587646 
    C1468.345337,1410.651855 1467.494873,1410.456177 1466.341797,1410.115967 
    C1466.021240,1409.684448 1466.001343,1409.397583 1465.972046,1408.895264 
    C1466.944214,1409.229126 1467.924072,1409.778442 1469.049927,1410.587646 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1451.151001,1383.775269 
    C1450.880249,1384.006348 1450.712158,1384.000610 1450.292725,1383.977539 
    C1450.144043,1383.147583 1450.246826,1382.334961 1450.565430,1381.300781 
    C1450.938721,1381.898926 1451.096191,1382.718628 1451.151001,1383.775269 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1450.051270,1367.313599 
    C1450.210083,1367.028931 1450.377441,1367.017212 1450.796387,1366.996582 
    C1451.071411,1367.536499 1451.094971,1368.085083 1450.974243,1368.791748 
    C1450.573242,1368.495361 1450.316406,1368.040894 1450.051270,1367.313599 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1455.277344,1355.968994 
    C1455.343750,1355.451782 1455.648438,1354.797852 1456.231934,1354.063843 
    C1456.178955,1354.599854 1455.847290,1355.216064 1455.277344,1355.968994 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1453.311279,1360.276367 
    C1453.308472,1359.711182 1453.545166,1358.966675 1454.062866,1358.102051 
    C1454.079468,1358.687012 1453.815186,1359.391968 1453.311279,1360.276367 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1451.469482,1365.520386 
    C1451.418091,1364.875854 1451.605469,1364.073242 1452.156372,1363.043945 
    C1452.249390,1363.665649 1451.978760,1364.514038 1451.469482,1365.520386 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1461.924072,1404.688721 
    C1461.381714,1404.468872 1460.727173,1403.957520 1460.042725,1403.100586 
    C1460.612427,1403.302368 1461.212280,1403.849731 1461.924072,1404.688721 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1463.968140,1406.690918 
    C1463.411987,1406.522583 1462.754150,1406.070923 1462.057495,1405.292603 
    C1462.634644,1405.446533 1463.250488,1405.927246 1463.968140,1406.690918 
  z"/>
  <path fill="#707070" opacity="1.000000" stroke="none" 
    d="
  M619.538879,1489.183594 
    C620.022400,1488.882935 620.239441,1488.913940 620.779907,1489.004395 
    C620.978638,1502.146729 620.854004,1515.229614 620.669556,1528.797974 
    C620.090210,1528.251343 619.122314,1527.220459 619.119568,1526.187134 
    C619.086975,1513.963379 619.198608,1501.739258 619.538879,1489.183594 
  z"/>
  <path fill="#A5A5A5" opacity="1.000000" stroke="none" 
    d="
  M580.691650,1758.287964 
    C580.187256,1758.929565 579.224426,1759.829590 578.276672,1759.814087 
    C570.246094,1759.682495 562.218140,1759.384033 554.021118,1758.793213 
    C562.648499,1758.341064 571.444336,1758.231445 580.691650,1758.287964 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M506.313538,1503.628174 
    C508.773102,1502.117432 511.587952,1500.588135 514.779480,1499.064697 
    C512.327026,1500.583618 509.497955,1502.096558 506.313538,1503.628174 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M441.705383,1574.415527 
    C442.411194,1572.175659 443.379669,1569.727905 444.676025,1567.139771 
    C443.991943,1569.402100 442.979980,1571.805054 441.705383,1574.415527 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M498.364380,1508.134033 
    C499.010406,1507.064331 500.015594,1505.985474 501.169250,1504.631836 
    C502.094574,1504.267578 502.871429,1504.178101 504.040527,1504.143188 
    C502.529694,1505.506714 500.626617,1506.815796 498.364380,1508.134033 
  z"/>
  <path fill="#8F8F8F" opacity="1.000000" stroke="none" 
    d="
  M781.477722,1570.250488 
    C781.032104,1570.595337 780.770630,1570.661865 780.294678,1570.707886 
    C779.489624,1570.714600 778.888062,1570.698853 777.859070,1570.537354 
    C778.803406,1569.779907 780.175171,1569.168335 781.778442,1568.704712 
    C781.897644,1569.240112 781.785217,1569.627686 781.477722,1570.250488 
  z"/>
  <path fill="#8F8F8F" opacity="1.000000" stroke="none" 
    d="
  M825.755005,1556.810547 
    C824.447449,1557.590454 822.886658,1558.230469 820.951965,1558.766113 
    C822.219299,1557.997925 823.860535,1557.334106 825.755005,1556.810547 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M653.093506,1660.442749 
    C653.676270,1659.087769 654.222778,1658.091064 655.042236,1656.996338 
    C654.794312,1658.595581 654.273499,1660.293213 653.438232,1662.112793 
    C653.101624,1661.756958 653.079407,1661.279053 653.093506,1660.442749 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M437.653564,1586.404907 
    C437.773468,1585.187378 438.100006,1583.750732 438.777374,1582.141846 
    C438.705505,1583.374878 438.282867,1584.780396 437.653564,1586.404907 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M439.297302,1665.786865 
    C438.532288,1664.725586 437.870483,1663.400879 437.323212,1661.692749 
    C438.092010,1662.713989 438.746277,1664.118896 439.297302,1665.786865 
  z"/>
  <path fill="#8F8F8F" opacity="1.000000" stroke="none" 
    d="
  M818.758240,1558.765625 
    C817.442688,1559.535034 815.867981,1560.171875 813.920898,1560.713135 
    C815.198669,1559.956055 816.848877,1559.294434 818.758240,1558.765625 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M675.618652,1704.961182 
    C675.891357,1705.534424 675.880676,1706.274414 675.792480,1707.372803 
    C674.978088,1708.093506 674.241333,1708.455811 673.200684,1708.891357 
    C673.709595,1707.685669 674.522339,1706.406860 675.618652,1704.961182 
  z"/>
  <path fill="#C0C0C0" opacity="1.000000" stroke="none" 
    d="
  M528.857544,1709.390869 
    C530.022705,1709.586182 531.361938,1710.017822 532.866943,1710.782227 
    C531.698975,1710.618896 530.365234,1710.122925 528.857544,1709.390869 
  z"/>
  <path fill="#8F8F8F" opacity="1.000000" stroke="none" 
    d="
  M788.774048,1566.839355 
    C787.720703,1567.549316 786.438599,1568.115967 784.802795,1568.560303 
    C785.814453,1567.857300 787.179871,1567.276611 788.774048,1566.839355 
  z"/>
  <path fill="#8F8F8F" opacity="1.000000" stroke="none" 
    d="
  M810.765015,1560.864990 
    C809.720764,1561.572998 808.441284,1562.147339 806.809448,1562.597900 
    C807.814636,1561.893188 809.172302,1561.312134 810.765015,1560.864990 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M518.199219,1498.323120 
    C519.258545,1497.549316 520.582031,1496.870728 522.297119,1496.281494 
    C521.280273,1497.053345 519.871826,1497.735962 518.199219,1498.323120 
  z"/>
  <path fill="#8F8F8F" opacity="1.000000" stroke="none" 
    d="
  M803.781738,1562.751099 
    C802.729675,1563.497925 801.442139,1564.098999 799.797852,1564.571289 
    C800.809509,1563.830200 802.177917,1563.217773 803.781738,1562.751099 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M501.759888,1557.282471 
    C501.176331,1558.431152 500.276855,1559.626099 499.039307,1560.828369 
    C499.615509,1559.666870 500.529724,1558.497803 501.759888,1557.282471 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M487.724731,1734.713745 
    C487.239380,1734.103027 487.083069,1733.605957 486.905640,1732.844727 
    C487.896942,1733.176514 488.909363,1733.772461 490.034882,1734.656128 
    C489.449921,1734.904907 488.751831,1734.866211 487.724731,1734.713745 
  z"/>
  <path fill="#8F8F8F" opacity="1.000000" stroke="none" 
    d="
  M796.782471,1564.712646 
    C795.731445,1565.451050 794.437805,1566.054810 792.785278,1566.529297 
    C793.797546,1565.792603 795.168701,1565.185303 796.782471,1564.712646 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M441.083893,1670.766479 
    C440.390564,1670.006104 439.804535,1669.017822 439.333679,1667.667969 
    C440.029633,1668.383667 440.610413,1669.461182 441.083893,1670.766479 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M669.764160,1712.198486 
    C669.364624,1713.053467 668.686096,1714.029053 667.698242,1715.065308 
    C668.087708,1714.190308 668.786438,1713.254761 669.764160,1712.198486 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M463.909576,1535.328613 
    C464.263336,1535.068359 464.482147,1535.070435 465.027344,1535.107910 
    C464.758453,1535.955688 464.163177,1536.768311 463.278198,1537.676514 
    C463.250519,1537.044922 463.512573,1536.317871 463.909576,1535.328613 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M490.429077,1513.189575 
    C490.335236,1512.722168 490.560211,1512.181763 490.941101,1511.387939 
    C491.541168,1511.094604 491.985321,1511.054688 492.763428,1511.041992 
    C492.314270,1511.751831 491.531067,1512.434204 490.429077,1513.189575 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M493.377289,1511.051758 
    C493.897339,1510.433960 494.741486,1509.759277 495.934326,1509.107544 
    C495.422485,1509.751831 494.561951,1510.373291 493.377289,1511.051758 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M453.069366,1695.659424 
    C452.383026,1695.112671 451.729706,1694.228027 451.126404,1692.994385 
    C451.818420,1693.537476 452.460388,1694.429565 453.069366,1695.659424 
  z"/>
  <path fill="#C0C0C0" opacity="1.000000" stroke="none" 
    d="
  M519.340210,1704.190186 
    C520.091553,1704.293945 520.896179,1704.689819 521.838745,1705.325439 
    C521.115662,1705.204102 520.254578,1704.843140 519.340210,1704.190186 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M671.692383,1710.044556 
    C671.553162,1710.607544 671.135559,1711.280396 670.394836,1711.995850 
    C670.519104,1711.410522 670.966553,1710.782593 671.692383,1710.044556 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M631.883911,1742.783447 
    C631.672302,1743.225952 631.302490,1743.573853 630.551147,1744.001831 
    C630.688354,1743.617554 631.207031,1743.153076 631.883911,1742.783447 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M476.739380,1723.782593 
    C476.162781,1723.724609 475.586273,1723.390747 474.951538,1722.800537 
    C475.508698,1722.864990 476.124084,1723.185913 476.739380,1723.782593 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M479.902954,1726.728149 
    C479.324677,1726.589478 478.671295,1726.165161 477.996094,1725.420288 
    C478.592133,1725.547363 479.209991,1725.994995 479.902954,1726.728149 
  z"/>
  <path fill="#C0C0C0" opacity="1.000000" stroke="none" 
    d="
  M524.787842,1707.428223 
    C525.375305,1707.418579 526.139465,1707.647217 526.985474,1708.188232 
    C526.366455,1708.222534 525.665466,1707.944458 524.787842,1707.428223 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M457.273254,1545.898071 
    C457.352112,1545.348999 457.702271,1544.693970 458.346313,1543.983887 
    C458.274994,1544.549805 457.909790,1545.171021 457.273254,1545.898071 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M446.376465,1564.095215 
    C446.285736,1563.510864 446.468719,1562.832153 446.897675,1562.021729 
    C446.979156,1562.593750 446.814667,1563.297241 446.376465,1564.095215 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M494.698761,1565.029785 
    C494.661560,1565.685303 494.324768,1566.374512 493.682251,1567.108765 
    C493.717407,1566.457031 494.058319,1565.760254 494.698761,1565.029785 
  z"/>
  <path fill="#8F8F8F" opacity="1.000000" stroke="none" 
    d="
  M766.825684,1572.735352 
    C766.831238,1573.208618 766.649353,1573.522217 766.244751,1574.004883 
    C765.805298,1574.132446 765.588501,1574.091187 765.060791,1573.935669 
    C765.379333,1573.406250 766.008789,1572.990845 766.825684,1572.735352 
  z"/>
  <path fill="#C0C0C0" opacity="1.000000" stroke="none" 
    d="
  M503.400787,1692.159668 
    C503.846252,1692.298950 504.377838,1692.685181 504.961792,1693.327637 
    C504.505066,1693.191528 503.995972,1692.799194 503.400787,1692.159668 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M487.714478,1575.031860 
    C487.647858,1575.544800 487.348083,1576.211060 486.765442,1576.959229 
    C486.815460,1576.422485 487.148407,1575.803833 487.714478,1575.031860 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M439.658966,1580.401611 
    C439.575867,1579.785400 439.717499,1578.958862 440.179138,1578.020752 
    C440.293976,1578.669922 440.088837,1579.430542 439.658966,1580.401611 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M476.755615,1648.179199 
    C477.230499,1648.499756 477.589386,1649.083130 477.874939,1649.936768 
    C477.414276,1649.618652 477.026978,1649.030273 476.755615,1648.179199 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M656.539673,1653.317261 
    C656.465210,1652.711914 656.638367,1651.920654 657.118408,1651.019775 
    C657.212585,1651.650391 656.999878,1652.390869 656.539673,1653.317261 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M478.558533,1654.199463 
    C479.076324,1654.493774 479.506622,1655.067993 479.867218,1655.928223 
    C479.355347,1655.635986 478.913177,1655.057495 478.558533,1654.199463 
  z"/>
  <path fill="#C0C0C0" opacity="1.000000" stroke="none" 
    d="
  M500.152039,1689.278564 
    C500.707214,1689.433594 501.321045,1689.869385 501.981934,1690.608887 
    C501.422882,1690.461670 500.816803,1690.010620 500.152039,1689.278564 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M452.478149,1390.210693 
    C452.934418,1389.530029 453.717682,1388.790039 454.852997,1388.035645 
    C454.405090,1388.731201 453.605133,1389.441406 452.478149,1390.210693 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M493.360718,1412.260254 
    C493.883453,1412.512451 494.419861,1413.067017 494.945007,1413.941895 
    C494.413971,1413.695679 493.894165,1413.129150 493.360718,1412.260254 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M491.769836,1463.361450 
    C491.491577,1463.913818 490.921295,1464.403564 490.045959,1464.817383 
    C490.319885,1464.260742 490.898865,1463.779785 491.769836,1463.361450 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M457.279846,1386.759644 
    C457.490356,1386.212158 457.993011,1385.644775 458.810699,1385.080811 
    C458.607819,1385.636108 458.089905,1386.187866 457.279846,1386.759644 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M691.420288,1430.103394 
    C691.630127,1429.267456 692.133362,1428.256104 692.984741,1427.131592 
    C692.793152,1427.988281 692.253479,1428.958130 691.420288,1430.103394 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M696.082275,1421.469727 
    C696.465149,1421.044067 696.818054,1420.980713 697.440552,1420.909424 
    C697.376221,1421.627197 697.042419,1422.353027 696.417969,1423.180420 
    C696.102356,1422.798706 696.077332,1422.315308 696.082275,1421.469727 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M740.650269,1432.728760 
    C740.942383,1433.114502 740.952148,1433.628784 740.934204,1434.526123 
    C740.553040,1434.945190 740.199646,1434.981079 739.579468,1435.018311 
    C739.664429,1434.298706 740.016235,1433.577881 740.650269,1432.728760 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M728.068420,1378.353760 
    C728.641418,1378.259521 729.178162,1378.407593 729.865479,1378.802002 
    C729.508301,1379.222534 729.000427,1379.396484 728.224792,1379.572021 
    C727.941650,1379.244629 727.966736,1378.918823 728.068420,1378.353760 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M705.801941,1410.078979 
    C705.696472,1409.806274 705.828674,1409.578247 706.308594,1409.161621 
    C706.450806,1409.356567 706.245239,1409.740112 705.801941,1410.078979 
  z"/>
  <path fill="#040404" opacity="1.000000" stroke="none" 
    d="
  M578.563538,1343.387695 
    C591.253540,1342.788330 603.980225,1342.660278 617.144531,1342.472412 
    C618.051392,1344.291382 618.924683,1346.168945 618.929810,1348.048950 
    C619.014587,1379.017944 618.928589,1409.987427 619.062683,1440.956055 
    C619.080750,1445.134888 618.099548,1446.911987 613.511841,1446.771973 
    C603.198364,1446.457153 592.867859,1446.601074 582.546082,1446.716187 
    C579.614502,1446.748779 578.326111,1445.825195 578.338440,1442.746704 
    C578.470032,1409.784302 578.524597,1376.821533 578.563538,1343.387695 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M1843.622070,903.396851 
    C1844.172974,904.109863 1844.942139,905.274414 1844.945190,906.440918 
    C1845.013550,932.312744 1845.005737,958.184814 1844.962769,984.056763 
    C1844.961182,984.972351 1844.452026,985.887146 1843.828125,986.966309 
    C1843.478882,959.369995 1843.481201,931.609619 1843.622070,903.396851 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1663.286621,821.664246 
    C1663.332520,821.100525 1663.829590,820.382812 1664.318115,820.388794 
    C1673.805420,820.502869 1683.291504,820.701538 1692.967041,821.207764 
    C1683.348755,821.637390 1673.541382,821.742249 1663.286621,821.664246 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M1565.076172,841.536987 
    C1566.055054,841.190247 1566.912354,841.159729 1568.194092,841.220886 
    C1564.361938,843.581848 1560.105347,845.851013 1555.473877,848.158813 
    C1558.384033,846.082703 1561.669434,843.967957 1565.076172,841.536987 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1644.602905,934.315796 
    C1644.735352,931.889282 1645.108154,929.199097 1645.762939,926.248108 
    C1645.644409,928.675598 1645.243774,931.363892 1644.602905,934.315796 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1646.646484,922.353027 
    C1646.767700,919.905823 1647.142334,917.203979 1647.799561,914.239563 
    C1647.687988,916.684204 1647.293823,919.391357 1646.646484,922.353027 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1640.717285,957.407410 
    C1640.819336,955.265076 1641.157959,952.866943 1641.794312,950.221680 
    C1641.712646,952.366882 1641.333130,954.759216 1640.717285,957.407410 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1704.831543,904.281372 
    C1705.591064,906.261475 1706.206543,908.528748 1706.694824,911.205811 
    C1705.940918,909.266541 1705.314209,906.917542 1704.831543,904.281372 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1708.798584,928.260315 
    C1709.537720,929.959656 1710.126709,931.931641 1710.568481,934.296631 
    C1709.830322,932.637451 1709.239380,930.585205 1708.798584,928.260315 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1642.761719,945.445984 
    C1642.809448,943.625244 1643.099121,941.568726 1643.674316,939.261658 
    C1643.640991,941.077454 1643.322510,943.143860 1642.761719,945.445984 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1702.916748,893.277344 
    C1703.651978,894.958801 1704.234863,896.900879 1704.682007,899.237793 
    C1703.952393,897.601135 1703.358398,895.569580 1702.916748,893.277344 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1698.950928,869.287720 
    C1699.676880,870.962463 1700.256714,872.901978 1700.698242,875.234497 
    C1699.974854,873.602539 1699.389893,871.577454 1698.950928,869.287720 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1636.021973,958.318115 
    C1636.027222,957.982971 1636.507568,957.950745 1636.745850,957.985718 
    C1637.817383,958.935181 1638.650635,959.849670 1639.770020,960.895020 
    C1636.913330,963.293030 1637.251465,959.634033 1636.021973,958.318115 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1706.963867,917.272217 
    C1707.640747,918.675598 1708.163818,920.323059 1708.526489,922.338562 
    C1707.847412,920.976440 1707.328613,919.246399 1706.963867,917.272217 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1626.465332,940.212158 
    C1626.772339,941.091736 1626.830566,941.906616 1626.815186,943.129761 
    C1626.020752,942.534180 1625.300049,941.530273 1624.624756,940.219849 
    C1625.185791,939.991394 1625.701172,940.069458 1626.465332,940.212158 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1652.567627,887.275757 
    C1652.444946,886.084229 1652.585815,884.651367 1653.053467,883.061768 
    C1653.197144,884.281433 1653.014160,885.657959 1652.567627,887.275757 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1654.588867,875.299805 
    C1654.454224,874.115356 1654.578003,872.683533 1655.017334,871.077393 
    C1655.171021,872.286133 1655.009033,873.669250 1654.588867,875.299805 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1648.686035,910.377808 
    C1648.573486,909.155457 1648.720703,907.681030 1649.217041,906.065430 
    C1649.359375,907.324768 1649.152466,908.725342 1648.686035,910.377808 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1650.647095,898.351196 
    C1650.529541,897.130432 1650.683716,895.670227 1651.180176,894.064636 
    C1651.321167,895.316772 1651.120117,896.714172 1650.647095,898.351196 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1610.873047,911.368713 
    C1611.103516,911.010071 1611.275635,911.006042 1611.705566,911.019958 
    C1612.285645,912.232056 1612.607910,913.426208 1612.878174,914.991882 
    C1612.155518,914.150085 1611.485107,912.936707 1610.873047,911.368713 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1712.718750,952.199585 
    C1713.197632,952.873535 1713.559448,953.807983 1713.873657,955.148560 
    C1713.417847,954.523193 1713.009888,953.491577 1712.718750,952.199585 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1646.180420,841.629761 
    C1645.480469,841.057495 1644.814941,840.139893 1644.219849,838.862183 
    C1644.931641,839.429504 1645.573242,840.356934 1646.180420,841.629761 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1817.081665,859.341431 
    C1817.896240,859.595581 1818.850098,860.154968 1819.904419,861.056885 
    C1819.076904,860.815186 1818.148926,860.230896 1817.081665,859.341431 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1700.525757,857.850464 
    C1700.415161,858.678345 1700.032349,859.697998 1699.331055,860.859436 
    C1699.426392,860.014893 1699.839966,859.028564 1700.525757,857.850464 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1809.986328,854.353027 
    C1810.829834,854.562256 1811.770752,855.079773 1812.780029,855.935608 
    C1811.926758,855.736450 1811.005371,855.198914 1809.986328,854.353027 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1619.277100,930.267700 
    C1619.823853,930.592102 1620.347778,931.225891 1620.802979,932.202454 
    C1620.240967,931.889221 1619.747681,931.233215 1619.277100,930.267700 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1617.396973,926.248169 
    C1617.913330,926.590698 1618.395020,927.236572 1618.803711,928.215088 
    C1618.274536,927.882263 1617.818359,927.216919 1617.396973,926.248169 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1615.430664,922.230957 
    C1615.963257,922.526611 1616.453491,923.113159 1616.891602,924.015137 
    C1616.355835,923.727661 1615.872192,923.124817 1615.430664,922.230957 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M1738.380859,923.133545 
    C1738.380005,922.575745 1738.621216,921.855957 1739.151978,921.039062 
    C1739.168701,921.618408 1738.895752,922.294983 1738.380859,923.133545 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M1732.446411,935.240845 
    C1732.453491,934.646973 1732.715576,933.891235 1733.287598,933.042725 
    C1733.298950,933.659607 1733.000244,934.369263 1732.446411,935.240845 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1651.993774,891.812744 
    C1651.748657,891.396179 1651.666016,890.830933 1651.796997,890.131470 
    C1652.059204,890.552856 1652.107666,891.108459 1651.993774,891.812744 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1701.793457,885.171814 
    C1702.235474,885.643677 1702.501343,886.295227 1702.624756,887.301025 
    C1702.193848,886.887390 1701.905518,886.119446 1701.793457,885.171814 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1700.853516,879.543274 
    C1701.229248,880.058533 1701.474487,880.803101 1701.600342,882.134155 
    C1701.228149,881.737976 1700.975464,880.755310 1700.853516,879.543274 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1654.023926,879.816223 
    C1653.781738,879.397827 1653.698730,878.826660 1653.832520,878.121216 
    C1654.093872,878.545776 1654.138550,879.104614 1654.023926,879.816223 
  z"/>
  <path fill="#A9A9A9" opacity="1.000000" stroke="none" 
    d="
  M1642.299683,833.820496 
    C1641.802002,833.550110 1641.385498,833.003235 1641.006836,832.183472 
    C1641.490234,832.455017 1641.935425,832.999512 1642.299683,833.820496 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M1595.282715,707.671997 
    C1591.791992,699.915283 1592.340088,691.692322 1594.789307,683.199707 
    C1595.212891,691.086060 1595.318359,699.198975 1595.282715,707.671997 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M1601.680298,730.643677 
    C1600.143555,727.738342 1598.669678,724.463257 1597.301025,720.798096 
    C1598.851807,723.696655 1600.297485,726.985291 1601.680298,730.643677 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1743.407471,643.168701 
    C1743.938721,643.779419 1744.167725,644.274963 1744.610107,644.945068 
    C1744.905396,645.770569 1744.987549,646.421509 1745.059570,647.401489 
    C1743.031616,645.402405 1741.013916,643.074280 1738.894775,640.415771 
    C1740.230713,641.074707 1741.668091,642.064087 1743.407471,643.168701 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M1597.210205,717.747925 
    C1596.471436,716.377441 1595.854126,714.735229 1595.392334,712.709961 
    C1596.142334,714.043396 1596.737061,715.759827 1597.210205,717.747925 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1715.597900,769.932251 
    C1715.432739,770.409485 1714.905396,770.919434 1714.182129,771.630737 
    C1712.841064,772.223206 1711.695557,772.614319 1710.188721,772.957642 
    C1711.630127,771.928284 1713.432983,770.946594 1715.597900,769.932251 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1655.239014,776.546753 
    C1654.077759,776.471191 1652.729492,776.169739 1651.218140,775.546753 
    C1652.387451,775.590576 1653.719727,775.955750 1655.239014,776.546753 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1747.761353,743.345337 
    C1746.993042,744.113220 1746.273071,744.497864 1745.242310,744.933594 
    C1745.684204,743.646973 1746.437012,742.309265 1747.482178,740.804321 
    C1747.786377,741.412109 1747.798096,742.187195 1747.761353,743.345337 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1728.010498,630.313232 
    C1728.614868,630.060547 1729.328491,630.096069 1730.386841,630.201904 
    C1730.838745,630.831848 1730.946167,631.391602 1731.063965,632.239990 
    C1730.089600,631.886230 1729.104736,631.243835 1728.010498,630.313232 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1707.748047,773.317627 
    C1707.181885,773.923279 1706.300903,774.469788 1705.073486,774.935913 
    C1705.629272,774.323242 1706.531250,773.790833 1707.748047,773.317627 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1697.069824,615.265869 
    C1697.823120,615.280457 1698.782959,615.511536 1699.873047,616.019592 
    C1699.094482,616.025146 1698.185425,615.753723 1697.069824,615.265869 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M1595.657227,679.344238 
    C1595.567627,678.451721 1595.694092,677.301880 1596.163330,676.027527 
    C1596.295166,676.964355 1596.084229,678.025574 1595.657227,679.344238 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1751.230469,657.663025 
    C1751.839966,658.263062 1752.349609,659.138428 1752.909180,660.518311 
    C1752.349487,659.994629 1751.739990,658.966492 1751.230469,657.663025 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1696.754761,776.917358 
    C1696.161743,777.377258 1695.322144,777.725769 1694.127441,777.988037 
    C1694.684204,777.536499 1695.596313,777.171265 1696.754761,776.917358 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1655.273926,616.260010 
    C1655.612549,615.821228 1656.225342,615.453918 1657.133179,615.110840 
    C1656.801514,615.533936 1656.174805,615.932739 1655.273926,616.260010 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1664.408691,778.461548 
    C1663.903320,778.678101 1663.233887,778.707886 1662.320312,778.494324 
    C1662.799072,778.258911 1663.521851,778.266785 1664.408691,778.461548 
  z"/>
  <path fill="#C0C0C0" opacity="1.000000" stroke="none" 
    d="
  M1611.920532,747.776428 
    C1611.731201,747.948425 1611.463379,747.864624 1611.264648,747.567505 
    C1611.503174,747.409729 1611.672607,747.465149 1611.920532,747.776428 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M1750.447021,656.535767 
    C1750.766724,656.487061 1751.150513,656.771301 1751.487061,657.439270 
    C1751.130249,657.504883 1750.820679,657.186768 1750.447021,656.535767 
  z"/>
  <path fill="#ED1C24" opacity="1.000000" stroke="none" 
    d="
  M926.848511,348.005585 
    C925.617004,345.480499 924.385498,342.955444 923.226196,339.771698 
    C922.833923,335.479218 922.369385,331.845428 921.937378,327.768829 
    C921.644836,325.419037 921.036926,323.512207 921.035828,321.605042 
    C921.011353,278.417297 921.053284,235.229507 921.546143,192.036133 
    C975.653259,192.037338 1029.296875,192.044144 1082.965088,192.514114 
    C1083.029663,233.009537 1083.069702,273.041779 1083.035400,313.519836 
    C1082.944580,317.272888 1082.928223,320.580170 1082.538330,324.045044 
    C1081.828613,327.126434 1081.492310,330.050171 1081.083374,333.295380 
    C1080.971558,334.053345 1080.932617,334.489868 1080.491821,334.944092 
    C1079.785522,336.624695 1079.480957,338.287567 1079.033447,340.261780 
    C1078.666260,341.808411 1078.442017,343.043701 1078.217773,344.278961 
    C1077.625122,344.962219 1077.032593,345.645477 1075.989014,346.989075 
    C1073.979736,350.084656 1072.874390,353.055115 1070.765503,354.840332 
    C1066.761841,358.229767 1062.163696,360.912231 1057.848511,363.939636 
    C1050.853760,368.846893 1043.510254,372.827087 1034.844727,374.033569 
    C1029.251831,374.812286 1023.731689,376.113770 1017.741394,377.125061 
    C1014.249939,377.373199 1011.200867,377.862701 1008.141113,377.942383 
    C1001.919495,378.104523 995.692139,378.045288 989.467102,378.077271 
    C989.467102,378.077240 989.523499,378.026611 989.334229,377.644196 
    C983.581055,376.139069 978.016663,374.105896 972.453308,374.108948 
    C964.291565,374.113373 957.204041,371.553406 950.153076,367.568481 
    C948.732971,366.743744 947.386108,366.310455 946.059753,365.906311 
    C946.080200,365.935455 946.133972,365.888855 946.101074,365.519592 
    C939.883606,360.294189 933.106812,356.034210 929.675354,348.431793 
    C929.464233,347.964081 927.898865,348.107635 926.963562,347.966797 
    C926.963562,347.966797 926.999634,347.935364 927.003479,347.987732 
    C927.007324,348.040131 926.848511,348.005585 926.848511,348.005585 
  z"/>
  <path fill="#A2A2A2" opacity="1.000000" stroke="none" 
    d="
  M1082.911865,323.887451 
    C1082.928223,320.580170 1082.944580,317.272888 1083.300049,313.189240 
    C1083.752686,311.594421 1083.964722,310.776062 1083.965576,309.957520 
    C1084.005371,271.849182 1084.036987,233.740814 1084.003662,195.632523 
    C1084.002686,194.438354 1083.310547,193.244781 1082.940552,192.050934 
    C1029.296875,192.044144 975.653259,192.037338 921.149902,192.222687 
    C920.104980,193.541031 919.757446,194.667252 919.757629,195.793411 
    C919.764160,235.184387 919.810364,274.575348 919.824585,313.966339 
    C919.825745,317.096069 919.637695,320.225861 919.537537,323.355621 
    C918.894653,319.649323 917.708252,315.945282 917.692688,312.236328 
    C917.529175,273.280609 917.593445,234.323929 917.457214,195.367996 
    C917.444763,191.812149 918.682556,190.803467 922.066772,190.807877 
    C975.007568,190.877060 1027.948364,190.882355 1080.889160,190.797470 
    C1084.515625,190.791656 1085.782471,191.825043 1085.767456,195.623428 
    C1085.617065,233.746826 1085.692871,271.871094 1085.553223,309.994568 
    C1085.536865,314.448151 1084.605469,318.898376 1083.706055,323.696167 
    C1083.313721,324.042175 1082.911743,323.887451 1082.911865,323.887451 
  z"/>
  <path fill="#808080" opacity="1.000000" stroke="none" 
    d="
  M876.642151,150.595093 
    C876.796875,152.234451 877.085815,153.873734 877.086670,155.513184 
    C877.111206,200.169937 877.027283,244.827057 877.216492,289.483032 
    C877.237671,294.491425 875.996460,296.169525 870.829590,295.973541 
    C860.346985,295.575928 849.837646,295.765320 839.341614,295.897064 
    C835.370361,295.946930 833.618469,294.565063 833.626099,290.377350 
    C833.708862,245.054214 833.663086,199.730835 833.742432,154.407684 
    C833.745056,152.914886 834.702881,151.423767 835.587219,150.124359 
    C835.962769,150.518890 835.966553,150.720932 835.923584,151.395584 
    C835.868469,197.685181 835.845825,243.502167 835.911865,289.319031 
    C835.914124,290.898346 836.804504,292.476379 837.730103,294.011078 
    C850.615112,293.967163 863.050964,293.967163 875.939209,293.967163 
    C875.939209,245.970474 875.939209,198.563065 876.107056,151.005600 
    C876.274841,150.855545 876.642151,150.595093 876.642151,150.595093 
  z"/>
  <path fill="#8C8C8C" opacity="1.000000" stroke="none" 
    d="
  M1126.744263,151.023590 
    C1127.823120,150.266357 1128.892944,148.866486 1129.982422,148.850922 
    C1141.307129,148.689331 1152.635620,148.814789 1163.961792,148.716385 
    C1168.173096,148.679810 1169.407593,150.774979 1169.378052,154.640518 
    C1169.275146,168.132202 1169.338379,181.625183 1169.338501,195.117661 
    C1169.338501,226.433548 1169.367065,257.749512 1169.270752,289.065094 
    C1169.264648,291.033813 1168.282715,292.999512 1167.368408,294.686768 
    C1166.984741,294.202271 1166.987671,293.997589 1166.970215,293.341187 
    C1166.949829,245.715332 1166.949829,198.541168 1166.949829,150.939514 
    C1153.576538,150.939514 1140.951904,150.939514 1127.928467,150.906158 
    C1127.268066,150.923065 1127.006104,150.973328 1126.744263,151.023590 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M1018.178955,377.180969 
    C1023.731689,376.113770 1029.251831,374.812286 1034.844727,374.033569 
    C1043.510254,372.827087 1050.853760,368.846893 1057.848511,363.939636 
    C1062.163696,360.912231 1066.761841,358.229767 1070.765503,354.840332 
    C1072.874390,353.055115 1073.979736,350.084656 1075.589844,347.537537 
    C1075.788452,347.347351 1075.965576,347.175293 1076.076050,347.210632 
    C1076.288574,347.278687 1076.632446,347.581329 1076.630005,347.584747 
    C1073.832764,351.625519 1071.577759,356.244965 1068.087280,359.565643 
    C1056.183350,370.890533 1041.525146,376.147705 1024.555786,377.278015 
    C1022.803345,377.478607 1021.800964,377.802612 1020.798645,378.126587 
    C1020.153503,378.255554 1019.508423,378.384552 1018.570679,378.270325 
    C1018.212097,377.748932 1018.179016,377.466888 1018.178955,377.180969 
  z"/>
  <path fill="#EFEFEF" opacity="1.000000" stroke="none" 
    d="
  M1126.669434,151.485718 
    C1127.006104,150.973328 1127.268066,150.923065 1127.788330,151.364899 
    C1128.034912,199.201431 1128.023315,246.545868 1127.924561,294.124481 
    C1127.837646,294.358673 1127.946655,294.846313 1127.946655,294.846313 
    C1127.488647,293.246429 1126.632812,291.647064 1126.630493,290.046539 
    C1126.566162,244.013702 1126.587280,197.980759 1126.669434,151.485718 
  z"/>
  <path fill="#F6F6F6" opacity="1.000000" stroke="none" 
    d="
  M919.518372,323.684692 
    C919.637695,320.225861 919.825745,317.096069 919.824585,313.966339 
    C919.810364,274.575348 919.764160,235.184387 919.757629,195.793411 
    C919.757446,194.667252 920.104980,193.541031 920.686523,192.228271 
    C921.053284,235.229507 921.011353,278.417297 921.035828,321.605042 
    C921.036926,323.512207 921.644836,325.419037 921.657715,327.603516 
    C920.807861,327.245636 920.270447,326.610291 919.733032,325.974976 
    C919.655090,325.321228 919.577148,324.667480 919.518372,323.684692 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M1173.667969,335.908203 
    C1171.702881,336.669586 1169.416504,337.859131 1167.116577,337.886230 
    C1152.684570,338.056458 1138.249756,337.967712 1123.338257,337.928467 
    C1124.516357,337.516083 1126.169312,336.827515 1127.827881,336.813904 
    C1139.392578,336.718842 1150.959106,336.838440 1162.523315,336.719177 
    C1166.131714,336.681976 1169.734863,336.120422 1173.667969,335.908203 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M950.226440,367.959900 
    C957.204041,371.553406 964.291565,374.113373 972.453308,374.108948 
    C978.016663,374.105896 983.581055,376.139069 989.326721,377.681335 
    C987.321533,378.187988 985.134705,378.275085 982.244080,377.949158 
    C980.541687,377.514526 979.543030,377.492889 978.544373,377.471252 
    C967.628418,377.012451 957.417297,374.040833 948.072937,368.488159 
    C948.954712,368.067108 949.590576,368.013519 950.226440,367.959900 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M980.399902,463.019226 
    C980.020508,449.213379 979.965515,435.205139 979.926880,420.748718 
    C980.412476,421.230530 981.283630,422.157745 981.289978,423.090912 
    C981.376099,435.712219 981.350708,448.334381 981.311646,460.956207 
    C981.309753,461.576996 980.928833,462.196625 980.399902,463.019226 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M926.876953,348.314209 
    C927.898865,348.107635 929.464233,347.964081 929.675354,348.431793 
    C933.106812,356.034210 939.883606,360.294189 945.740723,365.538330 
    C944.268860,365.620422 943.124390,365.314453 941.979919,365.008484 
    C941.127625,364.415070 940.275391,363.821655 939.174194,362.670410 
    C938.248047,361.748413 937.570862,361.384277 936.893677,361.020142 
    C934.331055,358.181305 931.768494,355.342499 929.114258,351.873169 
    C928.450378,350.816193 927.878113,350.389679 927.305847,349.963165 
    C927.133972,349.529297 926.962158,349.095459 926.876953,348.314209 
  z"/>
  <path fill="#8F8F8F" opacity="1.000000" stroke="none" 
    d="
  M835.970276,150.922958 
    C835.966553,150.720932 835.962769,150.518890 835.948914,150.013306 
    C849.314575,149.744690 862.690308,149.779602 876.354126,150.204803 
    C876.642151,150.595093 876.274841,150.855545 875.642639,150.973495 
    C862.434265,151.045959 849.858154,151.000473 836.954712,150.918121 
    C836.408447,150.895142 836.189331,150.909058 835.970276,150.922958 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M1128.383057,295.043030 
    C1127.946655,294.846313 1127.837646,294.358673 1128.391602,294.167847 
    C1141.627319,293.915649 1154.308960,293.854248 1166.990723,293.792877 
    C1166.987671,293.997589 1166.984741,294.202271 1166.994873,294.713684 
    C1154.278442,295.093536 1141.548950,295.166656 1128.383057,295.043030 
  z"/>
  <path fill="#828181" opacity="1.000000" stroke="none" 
    d="
  M1017.741394,377.125061 
    C1018.179016,377.466888 1018.212097,377.748932 1018.241089,378.237183 
    C1008.798950,378.585449 999.393860,378.723633 989.727905,378.469543 
    C995.692139,378.045288 1001.919495,378.104523 1008.141113,377.942383 
    C1011.200867,377.862701 1014.249939,377.373199 1017.741394,377.125061 
  z"/>
  <path fill="#A2A2A2" opacity="1.000000" stroke="none" 
    d="
  M919.553772,326.287659 
    C920.270447,326.610291 920.807861,327.245636 921.625061,328.046326 
    C922.369385,331.845428 922.833923,335.479218 923.407349,339.366394 
    C922.135681,335.279938 920.755066,330.940125 919.553772,326.287659 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M1118.428223,351.633362 
    C1117.012573,355.807831 1115.351807,360.238434 1113.382568,364.834290 
    C1114.777100,360.629517 1116.480103,356.259491 1118.428223,351.633362 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M1082.538330,324.045044 
    C1082.911743,323.887451 1083.313721,324.042175 1083.529053,324.047119 
    C1083.668701,325.413727 1083.593140,326.775452 1083.069824,328.670227 
    C1082.470459,330.231873 1082.318970,331.260406 1082.167603,332.288971 
    C1082.167603,332.288971 1082.224976,332.672119 1081.911255,332.827972 
    C1081.597534,332.983826 1081.156006,332.973907 1081.156006,332.973907 
    C1081.492310,330.050171 1081.828613,327.126434 1082.538330,324.045044 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M1185.744385,331.747620 
    C1183.410278,333.109467 1180.741577,334.437347 1177.677368,335.655670 
    C1179.991211,334.268646 1182.700317,332.991180 1185.744385,331.747620 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M1038.715820,417.810242 
    C1036.753296,418.578186 1034.492188,419.219757 1031.806641,419.731201 
    C1033.727173,418.962006 1036.072144,418.322937 1038.715820,417.810242 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M970.434326,419.322723 
    C968.612976,419.205963 966.530090,418.878113 964.213135,418.239319 
    C966.043701,418.322815 968.108215,418.717224 970.434326,419.322723 
  z"/>
  <path fill="#8A8A8A" opacity="1.000000" stroke="none" 
    d="
  M914.720947,133.835144 
    C914.967407,134.556458 914.968323,135.009293 914.925781,135.800049 
    C913.734253,134.234528 912.586182,132.331085 911.528564,130.090881 
    C912.205811,129.921310 912.792542,130.088516 913.667236,130.151917 
    C914.128662,131.220978 914.302063,132.393829 914.720947,133.835144 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M941.265381,411.505127 
    C939.050903,410.856354 936.599426,409.956421 934.046265,408.737274 
    C936.305786,409.363373 938.667114,410.308655 941.265381,411.505127 
  z"/>
  <path fill="#989898" opacity="1.000000" stroke="none" 
    d="
  M1081.702881,509.361908 
    C1082.469482,510.641327 1083.108276,512.196777 1083.586670,514.120117 
    C1082.809204,512.871338 1082.192139,511.254639 1081.702881,509.361908 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M1046.747314,415.808960 
    C1045.412964,416.574341 1043.809692,417.222504 1041.805420,417.748840 
    C1043.095825,416.981903 1044.787231,416.336823 1046.747314,415.808960 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M1122.596069,337.946350 
    C1122.435913,339.442780 1121.979858,341.025787 1121.232422,342.813568 
    C1121.394043,341.356567 1121.847168,339.694733 1122.596069,337.946350 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M1053.736572,413.878357 
    C1052.411011,414.633179 1050.821899,415.266663 1048.849365,415.793396 
    C1050.135010,415.043427 1051.804077,414.400208 1053.736572,413.878357 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M961.392090,417.418121 
    C959.894165,417.266937 958.157104,416.901825 956.197021,416.223938 
    C957.700317,416.342194 959.426636,416.773193 961.392090,417.418121 
  z"/>
  <path fill="#989898" opacity="1.000000" stroke="none" 
    d="
  M1062.404785,479.313721 
    C1063.133301,480.053345 1063.577393,480.697052 1064.031494,481.639740 
    C1062.826538,481.126190 1061.611816,480.313660 1060.375610,479.185791 
    C1060.942993,478.986298 1061.531860,479.102051 1062.404785,479.313721 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M1079.176392,339.950439 
    C1079.480957,338.287567 1079.785522,336.624695 1080.704834,334.998962 
    C1081.319702,335.036133 1081.758911,335.049438 1081.758911,335.049438 
    C1081.714478,335.478119 1081.670044,335.906799 1081.173584,336.731995 
    C1080.546631,337.865234 1080.371582,338.601990 1080.196533,339.338715 
    C1080.196533,339.338715 1080.229492,339.704651 1079.914795,339.827759 
    C1079.600220,339.950836 1079.176392,339.950439 1079.176392,339.950439 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M942.124878,365.306305 
    C943.124390,365.314453 944.268860,365.620422 945.773682,365.907593 
    C946.133972,365.888855 946.080200,365.935455 946.150024,366.191345 
    C946.479126,366.980225 946.738525,367.513214 946.997925,368.046204 
    C945.421875,367.232178 943.845886,366.418152 942.124878,365.306305 
  z"/>
  <path fill="#989898" opacity="1.000000" stroke="none" 
    d="
  M1076.739258,495.851196 
    C1077.021606,496.441986 1077.056641,496.875458 1077.057861,497.633820 
    C1076.145630,496.812378 1075.267090,495.666077 1074.395752,494.193726 
    C1075.099243,494.476440 1075.795654,495.085175 1076.739258,495.851196 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M953.489502,415.308258 
    C952.276123,415.217285 950.859802,414.900330 949.220093,414.285919 
    C950.426697,414.353058 951.856567,414.717651 953.489502,415.308258 
  z"/>
  <path fill="#A2A2A2" opacity="1.000000" stroke="none" 
    d="
  M1079.033447,340.261780 
    C1079.176392,339.950439 1079.600220,339.950836 1079.810303,339.978760 
    C1079.565308,341.321167 1079.110229,342.635651 1078.436523,344.114532 
    C1078.442017,343.043701 1078.666260,341.808411 1079.033447,340.261780 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M1120.398438,345.548126 
    C1120.250610,346.759674 1119.879272,348.179840 1119.199707,349.816833 
    C1119.319336,348.608032 1119.747070,347.182373 1120.398438,345.548126 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M931.331726,489.991821 
    C931.069824,489.380402 931.093140,488.639435 931.142273,487.533478 
    C931.767334,487.068359 932.366638,486.968170 933.273438,486.845886 
    C932.926331,487.836609 932.271606,488.849426 931.331726,489.991821 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M947.049438,368.175568 
    C946.738525,367.513214 946.479126,366.980225 946.129517,366.162170 
    C947.386108,366.310455 948.732971,366.743744 950.153076,367.568481 
    C949.590576,368.013519 948.954712,368.067108 947.849121,368.214630 
    C947.379456,368.308563 947.101013,368.304932 947.049438,368.175568 
  z"/>
  <path fill="#A2A2A2" opacity="1.000000" stroke="none" 
    d="
  M1082.436890,332.104004 
    C1082.318970,331.260406 1082.470459,330.231873 1082.902832,329.044586 
    C1083.024414,329.896881 1082.865356,330.907959 1082.436890,332.104004 
  z"/>
  <path fill="#828181" opacity="1.000000" stroke="none" 
    d="
  M978.685913,377.729065 
    C979.543030,377.492889 980.541687,377.514526 981.781006,377.839905 
    C980.956970,378.091431 979.892151,378.039154 978.685913,377.729065 
  z"/>
  <path fill="#828181" opacity="1.000000" stroke="none" 
    d="
  M1021.095459,378.307037 
    C1021.800964,377.802612 1022.803345,377.478607 1024.120972,377.297546 
    C1023.421631,377.789459 1022.406982,378.138458 1021.095459,378.307037 
  z"/>
  <path fill="#989898" opacity="1.000000" stroke="none" 
    d="
  M1071.834106,490.438629 
    C1072.564087,490.882874 1073.280396,491.654358 1073.967529,492.760437 
    C1073.232544,492.318634 1072.526489,491.542267 1071.834106,490.438629 
  z"/>
  <path fill="#8A8A8A" opacity="1.000000" stroke="none" 
    d="
  M886.805176,109.686218 
    C887.682983,109.699997 888.715515,110.011772 889.880249,110.648766 
    C888.994995,110.644066 887.977417,110.314148 886.805176,109.686218 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M932.083252,407.608612 
    C931.213684,407.472382 930.158691,407.076385 928.842407,406.312927 
    C929.686707,406.413239 930.792297,406.881042 932.083252,407.608612 
  z"/>
  <path fill="#8A8A8A" opacity="1.000000" stroke="none" 
    d="
  M1083.081543,149.904526 
    C1083.277710,149.369949 1083.548096,149.068008 1084.121460,148.906586 
    C1084.001465,149.410446 1083.578613,149.773804 1083.081543,149.904526 
  z"/>
  <path fill="#8A8A8A" opacity="1.000000" stroke="none" 
    d="
  M918.209900,149.019333 
    C918.869080,148.872559 919.393982,148.970444 919.950684,149.361115 
    C919.346863,149.523941 918.711243,149.393967 918.209900,149.019333 
  z"/>
  <path fill="#8A8A8A" opacity="1.000000" stroke="none" 
    d="
  M917.554077,146.159180 
    C918.003723,146.566193 918.253357,147.140350 918.274536,147.855728 
    C917.815491,147.440079 917.584778,146.883194 917.554077,146.159180 
  z"/>
  <path fill="#8A8A8A" opacity="1.000000" stroke="none" 
    d="
  M798.494385,312.885193 
    C797.921326,312.620758 797.435608,312.061951 797.010010,311.214661 
    C797.573975,311.481079 798.077820,312.035950 798.494385,312.885193 
  z"/>
  <path fill="#8A8A8A" opacity="1.000000" stroke="none" 
    d="
  M894.623291,112.042236 
    C895.064270,112.334023 895.136536,112.659264 895.223145,113.240341 
    C894.476440,113.263756 893.715332,113.031334 892.875000,112.490753 
    C893.282043,112.146973 893.768372,112.111336 894.623291,112.042236 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M964.222168,468.161133 
    C964.523682,467.725372 965.073242,467.383179 965.883789,467.076721 
    C965.586548,467.493164 965.028381,467.873932 964.222168,468.161133 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M971.248291,466.214935 
    C971.614014,465.764740 972.254089,465.423767 973.189575,465.132751 
    C972.830872,465.563171 972.176758,465.943665 971.248291,466.214935 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M934.116577,486.573486 
    C934.236267,486.021545 934.641357,485.468903 935.313232,484.873138 
    C935.187378,485.410950 934.794739,485.991852 934.116577,486.573486 
  z"/>
  <path fill="#989898" opacity="1.000000" stroke="none" 
    d="
  M920.364014,512.159546 
    C920.261780,511.633820 920.375244,510.998169 920.766602,510.175171 
    C920.889587,510.675079 920.734680,511.362366 920.364014,512.159546 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M936.978882,361.307861 
    C937.570862,361.384277 938.248047,361.748413 938.979370,362.419037 
    C938.377075,362.348877 937.720581,361.972198 936.978882,361.307861 
  z"/>
  <path fill="#A2A2A2" opacity="1.000000" stroke="none" 
    d="
  M1080.467773,339.200653 
    C1080.371582,338.601990 1080.546631,337.865234 1081.000488,337.008423 
    C1081.099243,337.613068 1080.919189,338.337830 1080.467773,339.200653 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M945.419983,413.992310 
    C944.968872,413.714935 944.931702,413.422943 944.892944,412.911438 
    C945.639832,412.881592 946.380005,413.072357 947.316162,413.497803 
    C946.955566,413.813904 946.398987,413.895264 945.419983,413.992310 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M926.687500,347.935242 
    C926.848511,348.005585 927.007324,348.040131 927.025879,347.996277 
    C926.936035,347.742371 926.827637,347.532349 926.719238,347.322327 
    C926.655029,347.503174 926.590759,347.684052 926.687500,347.935242 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M927.398071,350.217896 
    C927.878113,350.389679 928.450378,350.816193 929.044495,351.532867 
    C928.541016,351.372894 928.015625,350.922760 927.398071,350.217896 
  z"/>
  <path fill="#A2A2A2" opacity="1.000000" stroke="none" 
    d="
  M1081.912842,334.730286 
    C1081.758911,335.049438 1081.319702,335.036133 1081.106689,334.981262 
    C1080.932617,334.489868 1080.971558,334.053345 1081.083252,333.295380 
    C1081.156006,332.973907 1081.597534,332.983826 1081.818115,332.997742 
    C1082.047974,333.478149 1082.057373,333.944672 1081.912842,334.730286 
  z"/>
  <path fill="#FF7F27" opacity="1.000000" stroke="none" 
    d="
  M262.141388,856.275146 
    C261.804230,860.315002 261.467102,864.354797 261.033020,869.207703 
    C260.626923,871.112549 260.057556,872.202454 260.049408,873.296509 
    C259.979340,882.709961 259.530579,892.158203 260.192841,901.525452 
    C260.585663,907.081360 262.778381,912.510010 264.100220,918.435791 
    C263.819550,926.496216 267.315430,933.038696 270.081451,940.206665 
    C270.294647,941.654846 270.533142,942.681824 270.764923,943.679810 
    C240.399475,943.679810 210.347382,943.679810 180.325607,943.679810 
    C180.325607,847.999756 180.325607,752.672241 180.325607,657.049500 
    C192.767105,657.049500 204.895203,657.049500 217.023254,657.016479 
    C217.023224,656.983398 216.957489,656.976929 216.982513,657.447144 
    C217.007523,671.171631 217.007523,684.425842 217.007523,698.001953 
    C219.226196,698.001953 220.860535,698.001892 222.494873,698.001892 
    C289.247437,698.001709 356.000031,698.000977 422.752594,698.002197 
    C430.047272,698.002380 430.047455,698.007751 430.047546,690.693970 
    C430.047699,679.600830 430.047577,668.507690 430.047577,657.032471 
    C442.763153,657.032471 454.882843,657.032471 467.005127,657.007568 
    C467.007751,656.982605 466.957489,656.976929 466.982544,657.447144 
    C467.011810,681.334717 467.041199,704.752075 467.004852,728.169312 
    C466.994049,735.131775 466.798492,742.093994 466.397461,749.009216 
    C465.390594,748.698853 464.673889,748.435608 463.584351,748.085815 
    C459.988586,746.848206 456.626862,745.979370 453.575958,744.478638 
    C449.251953,742.351379 445.038513,740.232605 439.663879,740.980835 
    C432.561768,738.832336 426.108704,735.978638 418.662109,736.882202 
    C406.564972,738.349976 394.202179,734.867249 382.147705,738.894653 
    C377.590668,740.417175 372.697906,740.934814 367.545532,741.945312 
    C363.142700,742.970520 359.007416,743.584534 355.200958,745.051636 
    C350.946106,746.691650 346.989471,749.105408 342.516235,751.110291 
    C335.718689,752.176147 330.492554,755.461670 325.957581,759.985596 
    C325.975037,760.002563 325.977722,759.956360 325.617065,759.948669 
    C323.828125,760.945801 322.399902,761.950684 320.983643,762.974792 
    C320.995605,762.994080 320.957458,762.970032 320.626282,763.060730 
    C319.240265,764.201599 318.185455,765.251770 317.130676,766.301880 
    C317.130707,766.301941 317.118134,766.123718 316.828552,766.056519 
    C315.001556,767.312256 313.464081,768.635254 311.940338,769.975708 
    C311.954041,769.993164 311.970978,769.963257 311.684723,770.046875 
    C311.293945,770.495789 311.189453,770.861145 310.831543,771.479248 
    C310.116821,772.415710 309.655457,773.099426 309.194092,773.783142 
    C309.194092,773.783142 309.028717,773.665588 308.745544,773.778076 
    C304.420593,774.768005 301.612610,777.088501 299.971558,781.333252 
    C299.537659,782.640869 299.289551,783.606262 299.041412,784.571655 
    C298.388062,785.484802 297.734711,786.397949 296.728699,786.849609 
    C294.629547,788.344421 292.883026,790.300903 291.136505,792.257324 
    C291.136505,792.257324 291.109680,792.125854 290.736084,792.067627 
    C289.959839,792.906738 289.557220,793.804138 289.154602,794.701538 
    C289.154602,794.701538 289.057495,794.584839 288.775208,794.709595 
    C287.978699,795.538513 287.464447,796.242737 286.925659,796.936340 
    C286.901093,796.925720 286.848511,796.915833 286.537659,797.046997 
    C285.170868,798.842346 284.114929,800.506592 283.006470,802.297241 
    C282.953979,802.423706 282.944580,802.697327 282.584808,802.798035 
    C281.835419,803.656738 281.445801,804.414734 281.002625,805.297241 
    C280.949066,805.421692 280.937744,805.692383 280.695190,805.836914 
    C280.292267,806.304993 280.131897,806.628418 279.944153,806.937256 
    C279.916809,806.922546 279.855103,806.916016 279.542358,807.088623 
    C275.928162,814.020203 270.595795,819.888977 270.111938,828.156128 
    C270.016144,828.566223 269.987396,828.732422 269.566589,828.926147 
    C268.828308,830.300232 268.482086,831.646790 268.082489,833.317505 
    C267.982117,834.076111 267.935150,834.510620 267.504120,834.959106 
    C266.802765,836.291748 266.485504,837.610474 266.078674,839.323975 
    C263.208557,844.889343 261.415405,850.289551 262.141388,856.275146 
  z"/>
  <path fill="#FF7F27" opacity="1.000000" stroke="none" 
    d="
  M455.943878,793.092834 
    C456.390472,793.318359 456.837036,793.543945 457.683258,793.762451 
    C458.082886,793.755493 458.144196,793.811401 458.144196,793.811401 
    C458.384216,793.900635 458.624268,793.989868 459.297363,794.545532 
    C465.510254,799.920532 471.290100,804.829163 477.082642,810.117432 
    C479.842590,813.314087 482.589844,816.131104 485.390259,818.991882 
    C485.443451,819.035645 485.569824,818.980713 485.731079,819.275024 
    C486.250397,820.059875 486.608459,820.550354 486.980896,821.019775 
    C486.995300,820.998779 486.959595,821.038940 487.042664,821.322388 
    C487.669373,821.694397 488.212952,821.783020 488.990723,822.143311 
    C490.757751,824.949707 492.290619,827.484436 493.885071,830.340088 
    C494.285706,831.173767 494.624695,831.686462 494.985046,832.400269 
    C495.006409,832.601318 495.123749,832.988281 495.135620,833.259827 
    C495.419830,833.763489 495.692139,833.995605 495.978210,834.406128 
    C495.991943,834.584534 496.104248,834.924316 496.151733,835.276672 
    C497.457367,837.123474 498.715454,838.617981 499.996094,840.342041 
    C500.018646,840.571594 500.136810,841.017517 500.067871,841.433228 
    C501.335815,845.344604 502.672699,848.840271 504.008118,852.472656 
    C504.006714,852.609314 504.105591,852.864197 504.069763,853.209290 
    C504.410095,854.362549 504.786255,855.170715 505.127258,856.371826 
    C509.466949,873.459167 510.997162,890.197693 506.101349,907.093323 
    C505.183105,910.262390 504.683777,913.552917 503.588196,916.864868 
    C502.703766,918.367188 502.440125,919.916992 501.705627,921.196533 
    C496.843445,929.666443 491.918457,938.101074 486.927277,946.495667 
    C485.359192,949.133057 483.524841,951.612183 481.463684,954.068970 
    C480.303711,954.633179 479.492371,955.292175 478.414185,956.143799 
    C477.937714,956.959534 477.728119,957.582642 477.518555,958.205750 
    C477.518585,958.205750 477.526276,958.053833 477.195038,958.023682 
    C473.145416,960.975342 469.427032,963.957153 465.561462,966.944214 
    C465.414337,966.949341 465.140930,967.058899 464.773468,967.014038 
    C463.914185,967.626343 463.422333,968.283569 462.945251,968.970825 
    C462.960022,969.000854 462.970276,968.934692 462.652649,968.938293 
    C461.875153,969.273621 461.415253,969.605408 460.970978,969.964233 
    C460.986572,969.991211 460.935486,969.955200 460.583405,970.074829 
    C459.098541,971.465271 457.965759,972.736206 456.833008,974.007141 
    C456.545807,974.058960 456.258575,974.110840 455.287659,974.237183 
    C453.611115,974.871216 452.661499,975.533325 451.618134,975.973022 
    C446.078247,978.307922 440.514893,980.587036 434.536072,982.920837 
    C429.433411,983.677795 424.754333,984.399414 419.609283,985.082520 
    C410.085907,985.071045 401.028564,985.098083 391.549866,985.060547 
    C388.898499,984.319336 386.658508,983.673767 384.440308,982.960571 
    C375.085724,979.952637 365.700043,977.033752 356.410919,973.834900 
    C353.754028,972.919983 351.383698,971.172852 348.933716,969.453003 
    C347.037567,967.348389 345.089691,965.598083 342.984680,963.542908 
    C341.127960,962.200989 339.428406,961.163879 337.728882,960.126709 
    C337.728851,960.126770 337.894318,960.095337 337.947235,959.800903 
    C334.698547,956.296753 331.396973,953.086975 327.939697,949.619751 
    C327.207123,949.223694 326.630219,949.085083 326.020447,948.711609 
    C325.987640,948.476685 325.871857,948.016602 325.921539,947.641602 
    C324.668976,945.418945 323.366730,943.571350 322.054352,941.583130 
    C322.044220,941.442566 321.938568,941.181152 321.878387,940.804443 
    C319.899323,937.197693 317.908081,934.007874 316.078491,930.727966 
    C313.336090,925.811646 310.707153,920.832092 308.029968,915.879395 
    C307.688538,915.476624 307.347107,915.073792 307.190674,914.133362 
    C306.865509,910.711670 306.355408,907.827576 305.912292,904.509338 
    C305.684906,897.323181 305.167755,890.571716 305.155304,883.819214 
    C305.141357,876.241455 305.583618,868.662903 305.887024,860.676331 
    C307.269867,855.474792 308.593048,850.681641 309.916260,845.888428 
    C309.916260,845.888428 309.956879,845.967590 310.301758,845.994873 
    C311.056091,845.009705 311.465546,843.997314 311.930237,842.785950 
    C311.985443,842.586975 312.029114,842.176331 312.418640,842.117310 
    C314.491150,838.365662 316.174133,834.672913 317.918823,830.752686 
    C317.980530,830.525146 318.045380,830.058105 318.414062,830.034180 
    C319.217407,829.019714 319.652100,828.029175 320.051453,827.029663 
    C320.016083,827.020691 320.016479,827.093689 320.357391,827.082336 
    C321.109497,826.656311 321.520660,826.241638 321.983948,825.692871 
    C322.036041,825.558899 322.057587,825.272095 322.413147,825.185974 
    C325.214142,821.751404 327.659546,818.402954 330.080811,815.037476 
    C330.056641,815.020386 330.024475,815.069519 330.363800,815.058472 
    C331.113708,814.637817 331.524292,814.228210 331.988129,813.687927 
    C332.041412,813.557312 332.057800,813.275757 332.408203,813.185181 
    C333.931671,811.744263 335.104736,810.394043 336.420319,809.039368 
    C336.562836,809.034973 336.828644,808.931702 337.172668,808.910400 
    C337.768982,808.271667 338.021301,807.654236 338.417145,807.033997 
    C338.560699,807.031250 338.829254,806.929565 339.207336,806.875610 
    C340.680511,805.463501 341.775574,804.105408 342.870636,802.747314 
    C342.870636,802.747314 342.896240,802.898193 343.202271,802.952637 
    C346.369965,801.905518 348.953308,800.554443 348.976471,796.908020 
    C348.976471,796.908020 348.984131,796.983826 349.293274,796.973389 
    C350.059509,796.935181 350.516663,796.907471 351.323792,796.933044 
    C352.131012,796.341187 352.588226,795.695984 353.287109,795.010315 
    C353.528809,794.969788 354.003448,794.847473 354.375793,794.922485 
    C355.533600,794.344666 356.319061,793.691833 357.337006,793.005493 
    C357.569519,792.972046 358.023926,792.852783 358.394897,792.927124 
    C359.552032,792.345642 360.338196,791.689941 361.345825,791.003174 
    C361.567230,790.972168 361.998657,790.854492 362.371979,790.927307 
    C363.519501,790.348206 364.293671,789.696289 365.327820,788.999390 
    C365.757812,788.909241 365.927795,788.864075 366.493896,788.894287 
    C369.271454,788.495117 371.761688,788.317505 374.014679,787.492249 
    C381.721130,784.669434 389.391266,781.912720 397.787750,782.054260 
    C404.926910,782.174622 412.069824,782.068542 419.211060,782.073547 
    C420.371887,782.074341 421.611115,781.876160 422.680817,782.204346 
    C429.873230,784.411377 437.040375,786.702820 444.193512,789.034973 
    C448.132599,790.319214 452.028503,791.735901 455.943878,793.092834 
  M412.131561,922.733704 
    C413.401947,923.210205 414.672302,923.686707 416.253906,924.794739 
    C422.101685,928.094299 428.079437,931.186157 433.764954,934.744995 
    C441.184967,939.389526 448.327576,944.474731 455.677643,949.234253 
    C460.629456,952.440735 462.625122,951.712646 465.475464,946.368347 
    C466.513367,944.422302 468.137207,942.779175 469.104462,940.806946 
    C471.499756,935.922791 473.670380,930.928528 476.718201,925.988037 
    C478.561523,924.258911 479.077576,922.735901 476.040405,921.416870 
    C476.040405,921.416870 475.931305,921.089417 475.792511,920.360962 
    C472.778595,919.295105 469.764648,918.229248 466.092957,916.967529 
    C465.008850,916.312866 463.924744,915.658203 462.655548,914.429016 
    C462.075104,914.295044 461.494629,914.161011 460.985474,914.017029 
    C460.985474,914.017029 460.967377,914.086792 461.014343,913.259094 
    C460.893555,912.636292 460.987274,911.679993 460.618500,911.442749 
    C457.259949,909.282593 453.864471,907.171448 450.397186,905.190491 
    C439.697449,899.077332 428.961426,893.027893 418.044861,886.038635 
    C418.003937,857.332031 417.963043,828.625488 417.800110,799.322449 
    C417.218781,799.244324 416.637451,799.166260 415.115784,798.994812 
    C405.385284,799.025513 395.654755,799.056274 385.335266,799.212341 
    C385.278107,799.788574 385.220978,800.364807 385.045013,801.878906 
    C385.096649,835.673340 385.148315,869.467712 385.098999,903.830566 
    C385.117981,904.219177 385.136963,904.607849 385.031372,905.737976 
    C386.980286,906.869019 388.929199,908.000061 390.958282,909.861145 
    C394.015656,911.216003 397.073059,912.570923 400.049255,913.939758 
    C400.049255,913.939758 400.062103,913.858459 399.975098,914.614929 
    C402.986908,916.366333 405.998749,918.117737 409.440765,919.972717 
    C409.440765,919.972717 409.880096,920.025818 409.929321,920.669678 
    C410.295715,921.089111 410.662109,921.508545 411.407074,922.044800 
    C411.407074,922.044800 411.798981,922.102539 412.131561,922.733704 
  z"/>
  <path fill="#FF7F27" opacity="1.000000" stroke="none" 
    d="
  M306.344360,645.103455 
    C305.979401,645.090454 305.772308,644.903076 305.591919,643.942322 
    C305.304016,639.236389 305.061951,635.130554 305.010803,631.022339 
    C304.937958,625.166260 311.896423,616.575073 317.668640,616.234009 
    C324.393799,615.836670 331.692657,614.527283 336.401794,621.664185 
    C336.622437,621.998535 337.617340,621.822021 338.251648,621.883484 
    C338.251648,621.883484 338.097412,621.904175 338.141602,622.174072 
    C338.825928,622.612366 339.466095,622.780823 340.106262,622.949341 
    C340.106262,622.949280 340.020691,622.950867 340.013977,623.342407 
    C340.657349,627.766296 341.965942,631.822266 341.822205,635.826050 
    C341.510956,644.498718 335.504028,649.279358 328.204468,652.107361 
    C322.444244,654.338928 316.703308,653.544189 311.920807,648.846313 
    C310.351105,647.304382 308.219177,646.334778 306.344360,645.103455 
  z"/>
  <path fill="#9F9F9F" opacity="1.000000" stroke="none" 
    d="
  M270.106750,939.785583 
    C267.315430,933.038696 263.819550,926.496216 264.285248,918.441772 
    C264.531830,918.007874 264.902405,918.015442 264.902405,918.015442 
    C267.994232,926.395203 271.099792,934.769897 274.171570,943.156982 
    C275.524933,946.852112 273.140686,946.932678 270.530914,946.927429 
    C256.536926,946.899353 242.542862,946.914917 228.548813,946.914917 
    C213.222000,946.914917 197.893402,946.785217 182.569473,946.995239 
    C178.167313,947.055603 176.404877,945.969055 176.411118,941.169312 
    C176.533218,847.209473 176.525131,753.249390 176.429520,659.289429 
    C176.425156,654.987488 177.685532,653.358826 182.113602,653.455688 
    C192.937149,653.692383 203.771408,653.652710 214.597015,653.468933 
    C218.518372,653.402405 219.849899,654.799805 219.775864,658.704773 
    C219.576920,669.196533 219.650223,679.695190 219.766190,690.189453 
    C219.786926,692.066345 220.529282,693.935303 220.799683,696.311768 
    C219.788574,695.143005 218.202377,693.487732 218.161377,691.795044 
    C217.921249,681.878174 218.092651,671.952148 217.992920,662.030457 
    C217.975952,660.342651 217.318863,658.661255 216.957489,656.976929 
    C216.957489,656.976929 217.023224,656.983398 216.859833,656.622498 
    C208.427872,655.880310 200.162231,655.278320 191.890015,655.167603 
    C178.209839,654.984314 178.201782,655.117737 178.198349,668.931641 
    C178.192657,691.738403 178.195679,714.545227 178.195618,737.351990 
    C178.195435,804.274109 178.193130,871.196228 178.199036,938.118347 
    C178.199661,945.155029 178.222488,945.164978 185.016205,945.166016 
    C212.151291,945.170166 239.286392,945.167603 266.421478,945.167603 
    C268.184204,945.167603 269.946930,945.167603 273.142761,945.167603 
    C271.692047,942.595886 270.899414,941.190735 270.106750,939.785583 
  z"/>
  <path fill="#E6E6E6" opacity="1.000000" stroke="none" 
    d="
  M216.982513,657.447144 
    C217.318863,658.661255 217.975952,660.342651 217.992920,662.030457 
    C218.092651,671.952148 217.921249,681.878174 218.161377,691.795044 
    C218.202377,693.487732 219.788574,695.143005 221.047974,696.639160 
    C226.928925,696.408142 232.422821,696.308105 237.916733,696.305847 
    C300.389893,696.280151 362.863068,696.269409 426.148956,696.117065 
    C427.339966,694.270081 428.003204,692.568481 428.049988,690.850159 
    C428.334869,680.381226 428.565247,669.908813 428.618195,659.436646 
    C428.633820,656.346130 429.436737,654.916321 432.839203,654.971497 
    C442.988647,655.135925 453.143494,654.960815 463.293152,655.117493 
    C464.539154,655.136719 465.766510,656.364685 467.002533,657.032471 
    C454.882843,657.032471 442.763153,657.032471 430.047577,657.032471 
    C430.047577,668.507690 430.047699,679.600830 430.047546,690.693970 
    C430.047455,698.007751 430.047272,698.002380 422.752594,698.002197 
    C356.000031,698.000977 289.247437,698.001709 222.494873,698.001892 
    C220.860535,698.001892 219.226196,698.001953 217.007523,698.001953 
    C217.007523,684.425842 217.007523,671.171631 216.982513,657.447144 
  z"/>
  <path fill="#9F9F9F" opacity="1.000000" stroke="none" 
    d="
  M467.005127,657.007568 
    C465.766510,656.364685 464.539154,655.136719 463.293152,655.117493 
    C453.143494,654.960815 442.988647,655.135925 432.839203,654.971497 
    C429.436737,654.916321 428.633820,656.346130 428.618195,659.436646 
    C428.565247,669.908813 428.334869,680.381226 428.049988,690.850159 
    C428.003204,692.568481 427.339966,694.270081 426.552765,696.027344 
    C426.263550,683.782837 426.549988,671.488464 426.413879,659.198730 
    C426.365204,654.801331 427.869781,653.372559 432.183258,653.460327 
    C442.984070,653.680054 453.794342,653.651001 464.596588,653.469727 
    C468.496918,653.404297 469.789337,654.781738 469.773529,658.683716 
    C469.653534,688.273071 469.723511,717.863098 469.695709,747.452942 
    C469.691223,752.226074 469.022491,752.530640 464.210724,749.692932 
    C463.934143,748.856140 463.945679,748.514221 463.957214,748.172363 
    C464.673889,748.435608 465.390594,748.698853 466.795410,748.805298 
    C467.671448,747.522583 468.022369,746.396912 468.023529,745.270874 
    C468.051880,717.199646 468.058533,689.128418 467.995361,661.057373 
    C467.992310,659.696411 467.318787,658.337036 466.957520,656.976929 
    C466.957489,656.976929 467.007751,656.982605 467.005127,657.007568 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M338.621185,621.625916 
    C337.617340,621.822021 336.622437,621.998535 336.401794,621.664185 
    C331.692657,614.527283 324.393799,615.836670 317.668640,616.234009 
    C311.896423,616.575073 304.937958,625.166260 305.010803,631.022339 
    C305.061951,635.130554 305.304016,639.236389 305.652466,643.723755 
    C300.627075,638.782898 301.096008,632.635620 303.351135,626.296082 
    C308.011078,613.196106 325.141266,608.096130 335.620392,616.752625 
    C337.043610,617.928345 337.881714,619.812317 338.621185,621.625916 
  z"/>
  <path fill="#A5A5A5" opacity="1.000000" stroke="none" 
    d="
  M367.958160,741.910522 
    C372.697906,740.934814 377.590668,740.417175 382.147705,738.894653 
    C394.202179,734.867249 406.564972,738.349976 418.662109,736.882202 
    C426.108704,735.978638 432.561768,738.832336 439.666626,741.176514 
    C440.019867,741.555908 440.016541,741.947571 440.016541,741.947571 
    C433.996185,741.092712 427.899353,740.591919 421.970764,739.312073 
    C407.990784,736.294128 394.305420,739.563843 380.533295,740.828552 
    C376.616333,741.188293 372.777618,742.400330 368.455872,742.887207 
    C367.991852,742.338806 367.975006,742.124695 367.958160,741.910522 
  z"/>
  <path fill="#A5A5A5" opacity="1.000000" stroke="none" 
    d="
  M503.991089,916.787354 
    C504.683777,913.552917 505.183105,910.262390 506.101349,907.093323 
    C510.997162,890.197693 509.466949,873.459167 505.392273,856.359558 
    C506.045715,855.953735 506.398987,855.953064 506.752228,855.952393 
    C511.637177,870.060486 511.950867,884.576050 509.894196,899.120605 
    C508.978668,905.595032 506.666321,911.871826 504.606750,918.028259 
    C504.147369,917.474548 504.069244,917.130981 503.991089,916.787354 
  z"/>
  <path fill="#B1B1B1" opacity="1.000000" stroke="none" 
    d="
  M306.370850,645.484009 
    C308.219177,646.334778 310.351105,647.304382 311.920807,648.846313 
    C316.703308,653.544189 322.444244,654.338928 328.204468,652.107361 
    C335.504028,649.279358 341.510956,644.498718 341.822205,635.826050 
    C341.965942,631.822266 340.657349,627.766296 340.042480,623.310547 
    C341.478546,625.620544 343.487000,628.211975 344.166016,631.114380 
    C346.181030,639.727661 339.609772,650.193604 330.531281,653.586060 
    C321.477966,656.969055 311.293396,653.710632 306.370850,645.484009 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M456.001343,792.787842 
    C452.028503,791.735901 448.132599,790.319214 444.193512,789.034973 
    C437.040375,786.702820 429.873230,784.411377 422.680817,782.204346 
    C421.611115,781.876160 420.371887,782.074341 419.211060,782.073547 
    C412.069824,782.068542 404.926910,782.174622 397.787750,782.054260 
    C389.391266,781.912720 381.721130,784.669434 374.014679,787.492249 
    C371.761688,788.317505 369.271454,788.495117 366.679382,788.671753 
    C367.002289,787.834717 367.535767,787.295654 368.069244,786.756531 
    C368.267120,786.526184 368.517944,786.409180 369.404236,786.576416 
    C371.000122,786.132751 372.013458,785.518311 373.026794,784.903931 
    C373.238464,784.648743 373.510071,784.518738 374.474976,784.671143 
    C376.757812,784.154480 378.407196,783.480713 380.056610,782.807007 
    C380.285004,782.588318 380.557190,782.486145 381.488556,782.671143 
    C383.744843,782.197754 385.385681,781.553528 387.026520,780.909363 
    C388.210236,780.751404 389.393921,780.593445 391.419830,780.645264 
    C397.999115,780.588135 403.734253,780.179810 409.473907,780.102234 
    C413.550171,780.047180 417.632477,780.438354 421.712067,780.630371 
    C422.907776,780.644165 424.103516,780.657959 425.869080,781.104370 
    C428.179230,781.917480 429.919495,782.297974 431.659790,782.678406 
    C431.951263,782.518799 432.253143,782.495850 432.989868,783.049194 
    C435.172974,783.874207 436.931610,784.259705 438.690216,784.645264 
    C438.986725,784.492126 439.288696,784.480469 439.954956,785.092651 
    C441.455200,785.901978 442.596588,786.228943 443.737976,786.555969 
    C444.016022,786.408203 444.299225,786.397583 444.949829,786.947144 
    C445.955017,787.543884 446.597961,787.717773 447.240906,787.891602 
    C449.296051,788.742737 451.351196,789.593933 453.735657,790.934631 
    C454.582336,791.631775 455.099731,791.839355 455.617126,792.046875 
    C455.764374,792.192261 455.911591,792.337585 456.001343,792.787842 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M348.881989,969.807312 
    C351.383698,971.172852 353.754028,972.919983 356.410919,973.834900 
    C365.700043,977.033752 375.085724,979.952637 384.440308,982.960571 
    C386.658508,983.673767 388.898499,984.319336 391.819397,985.294250 
    C394.380096,986.196106 396.249939,986.799683 398.119751,987.403320 
    C390.173859,986.140320 381.857605,985.942505 374.377014,983.341370 
    C365.272095,980.175415 356.870667,974.986328 348.264404,970.277100 
    C348.536560,969.856934 348.709290,969.832092 348.881989,969.807312 
  z"/>
  <path fill="#C3C3C3" opacity="1.000000" stroke="none" 
    d="
  M503.588196,916.864868 
    C504.069244,917.130981 504.147369,917.474548 504.384888,918.323730 
    C503.332184,921.982300 502.120148,925.135315 500.384674,928.650024 
    C499.597748,929.718750 499.334198,930.425842 499.070648,931.132996 
    C494.960968,939.887817 490.159882,948.146240 482.156067,954.390808 
    C481.876251,954.475037 481.812347,954.163696 481.812347,954.163696 
    C483.524841,951.612183 485.359192,949.133057 486.927277,946.495667 
    C491.918457,938.101074 496.843445,929.666443 501.705627,921.196533 
    C502.440125,919.916992 502.703766,918.367188 503.588196,916.864868 
  z"/>
  <path fill="#8C8C8C" opacity="1.000000" stroke="none" 
    d="
  M264.941895,917.586060 
    C264.902405,918.015442 264.531830,918.007874 264.346802,918.001892 
    C262.778381,912.510010 260.585663,907.081360 260.192841,901.525452 
    C259.530579,892.158203 259.979340,882.709961 260.049408,873.296509 
    C260.057556,872.202454 260.626923,871.112549 261.031311,869.637329 
    C261.277710,870.208923 261.631958,871.181824 261.549622,872.116211 
    C260.328430,885.975525 261.578094,899.640625 264.595093,913.184631 
    C264.882172,914.473389 264.859985,915.830994 264.941895,917.586060 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M477.069946,809.737854 
    C471.290100,804.829163 465.510254,799.920532 459.510803,794.864929 
    C460.774475,795.130493 462.622040,795.117371 463.682129,796.024414 
    C470.625092,801.965576 477.397827,808.105591 483.938232,814.499878 
    C481.456818,813.125366 479.263397,811.431641 477.069946,809.737854 
  z"/>
  <path fill="#C0C0C0" opacity="1.000000" stroke="none" 
    d="
  M307.834198,916.156006 
    C310.707153,920.832092 313.336090,925.811646 316.078491,930.727966 
    C317.908081,934.007874 319.899323,937.197693 321.555481,940.775513 
    C320.648285,941.067993 320.003784,941.012695 319.359283,940.957397 
    C315.452332,932.782471 311.545380,924.607483 307.834198,916.156006 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M421.414337,780.393738 
    C417.632477,780.438354 413.550171,780.047180 409.473907,780.102234 
    C403.734253,780.179810 397.999115,780.588135 391.768555,780.736450 
    C401.178101,777.606079 411.137054,778.214844 421.414337,780.393738 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M367.545532,741.945312 
    C367.975006,742.124695 367.991852,742.338806 368.035461,742.874023 
    C360.003998,746.171753 351.945709,749.148254 343.423157,751.892944 
    C342.958862,751.661133 342.903046,751.182434 342.903046,751.182434 
    C346.989471,749.105408 350.946106,746.691650 355.200958,745.051636 
    C359.007416,743.584534 363.142700,742.970520 367.545532,741.945312 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M303.489380,897.941284 
    C300.830841,888.233887 301.056946,878.486267 303.423248,868.890198 
    C303.641876,875.272278 303.486389,881.477295 303.409973,887.683350 
    C303.367859,891.101807 303.458557,894.521912 303.489380,897.941284 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M303.419037,898.267822 
    C303.458557,894.521912 303.367859,891.101807 303.409973,887.683350 
    C303.486389,881.477295 303.641876,875.272278 303.628387,868.564575 
    C303.515656,866.941467 303.538910,865.820679 303.955811,864.215210 
    C304.842102,862.848572 305.334747,861.966614 305.827393,861.084656 
    C305.583618,868.662903 305.141357,876.241455 305.155304,883.819214 
    C305.167755,890.571716 305.684906,897.323181 305.689240,904.293396 
    C304.875824,903.657410 304.352448,902.803101 303.829102,901.948853 
    C303.668945,900.830688 303.508820,899.712585 303.419037,898.267822 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M440.335938,742.112732 
    C440.016541,741.947571 440.019867,741.555908 440.017090,741.360229 
    C445.038513,740.232605 449.251953,742.351379 453.575958,744.478638 
    C456.626862,745.979370 459.988586,746.848206 463.584351,748.085754 
    C463.945679,748.514221 463.934143,748.856140 463.940338,749.454224 
    C456.190491,747.232910 448.422913,744.755432 440.335938,742.112732 
  z"/>
  <path fill="#E9E9E9" opacity="1.000000" stroke="none" 
    d="
  M398.569183,987.502808 
    C396.249939,986.799683 394.380096,986.196106 392.240723,985.358765 
    C401.028564,985.098083 410.085907,985.071045 419.337036,985.323853 
    C417.638977,986.211975 415.747131,986.820251 413.855286,987.428589 
    C408.909729,987.486450 403.964172,987.544373 398.569183,987.502808 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M262.435120,856.232727 
    C261.415405,850.289551 263.208557,844.889343 266.278137,839.176025 
    C267.149811,838.081848 267.732483,837.530334 268.315155,836.978821 
    C266.453033,843.382629 264.590912,849.786499 262.435120,856.232727 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M434.959656,982.885498 
    C440.514893,980.587036 446.078247,978.307922 451.618134,975.973022 
    C452.661499,975.533325 453.611115,974.871216 454.849915,974.231201 
    C454.415985,975.282104 453.995911,977.028809 453.013336,977.443787 
    C447.348511,979.836792 441.550598,981.914856 435.391724,983.771851 
    C434.976959,983.257812 434.968292,983.071655 434.959656,982.885498 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M495.123749,832.988281 
    C495.123749,832.988281 495.006409,832.601318 494.982483,832.063721 
    C494.580170,831.023804 494.201813,830.521484 493.823456,830.019226 
    C492.290619,827.484436 490.757751,824.949707 488.873840,821.887817 
    C488.001740,821.253479 487.480652,821.146179 486.959595,821.038940 
    C486.959595,821.038940 486.995300,820.998779 487.020020,820.663757 
    C486.553070,819.879395 486.061462,819.430054 485.569824,818.980713 
    C485.569824,818.980713 485.443451,819.035645 485.339294,818.590637 
    C485.196350,817.346069 485.157593,816.546570 485.118805,815.747009 
    C489.615051,821.947632 494.111267,828.148254 498.293396,834.691833 
    C497.354279,834.997986 496.729248,834.961121 496.104248,834.924316 
    C496.104248,834.924316 495.991943,834.584534 495.915283,834.152588 
    C495.600311,833.476501 495.362030,833.232361 495.123749,832.988281 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M434.536041,982.920776 
    C434.968292,983.071655 434.976959,983.257812 434.993225,983.723511 
    C428.234314,985.266785 421.467773,986.530579 414.278259,987.611511 
    C415.747131,986.820251 417.638977,986.211975 419.803040,985.362427 
    C424.754333,984.399414 429.433411,983.677795 434.536041,982.920776 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M305.887024,860.676331 
    C305.334747,861.966614 304.842102,862.848572 304.086182,863.894653 
    C305.615356,857.972107 307.407806,851.885315 309.558258,845.843506 
    C308.593048,850.681641 307.269867,855.474792 305.887024,860.676331 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M342.516235,751.110291 
    C342.903046,751.182434 342.958862,751.661133 343.039612,751.888184 
    C343.120392,752.115234 343.113037,752.076660 342.809662,752.050293 
    C341.661560,752.569214 340.816803,753.114502 339.972107,753.659790 
    C339.311981,754.153992 338.651825,754.648193 337.366089,755.106812 
    C335.782471,755.800537 334.824493,756.529663 333.866516,757.258911 
    C332.934143,757.883240 332.001740,758.507629 330.356750,759.127197 
    C328.409485,759.404419 327.174805,759.686523 325.940125,759.968567 
    C330.492554,755.461670 335.718689,752.176147 342.516235,751.110291 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M270.178955,827.912109 
    C270.595795,819.888977 275.928162,814.020203 279.625244,807.526184 
    C280.078186,808.675049 280.135498,809.559021 280.192810,810.442993 
    C279.820740,811.188599 279.448639,811.934143 278.549927,813.049133 
    C275.408508,818.249756 272.793762,823.080933 270.178955,827.912109 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M270.111938,828.156128 
    C272.793762,823.080933 275.408508,818.249756 278.284973,813.234375 
    C275.976501,818.740479 273.406342,824.430603 270.486145,829.953125 
    C270.076935,829.489929 270.017792,829.194336 269.958618,828.898682 
    C269.987396,828.732422 270.016144,828.566223 270.111938,828.156128 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M414.646118,1028.767090 
    C409.539764,1029.107666 404.054779,1029.303589 398.271179,1029.206665 
    C403.404205,1028.816650 408.835876,1028.719604 414.646118,1028.767090 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M328.095398,949.877258 
    C331.396973,953.086975 334.698547,956.296753 337.934021,959.884094 
    C336.685089,959.898926 335.179169,959.875183 334.378265,959.111755 
    C331.638733,956.500793 329.147003,953.629822 326.864288,950.467957 
    C327.477020,950.010986 327.786224,949.944092 328.095398,949.877258 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M465.708618,966.939026 
    C469.427032,963.957153 473.145416,960.975342 477.269470,958.039429 
    C475.391663,960.711304 473.108154,963.337402 470.178589,965.996521 
    C469.008728,966.572327 468.484924,967.115112 467.961151,967.657837 
    C467.856232,967.814575 467.751312,967.971191 467.205841,967.903259 
    C466.413086,967.432129 466.060852,967.185547 465.708618,966.939026 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M507.879211,990.543396 
    C507.524475,990.985535 507.295074,991.178650 506.973328,991.599548 
    C506.124451,991.857300 505.405182,991.931519 504.322968,991.994507 
    C506.768036,989.064880 509.576080,986.146423 512.689819,983.099731 
    C512.959595,983.677979 512.923645,984.384460 512.826538,985.435120 
    C511.833282,986.573608 510.901276,987.367920 509.866791,988.465210 
    C509.165314,989.262146 508.566284,989.756165 507.879211,990.543396 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M330.104919,815.054504 
    C327.659546,818.402954 325.214142,821.751404 322.374054,824.735352 
    C321.932892,823.770569 321.886414,823.170227 321.839935,822.569946 
    C323.441498,820.523376 325.043060,818.476807 327.221130,816.202026 
    C328.566711,815.667297 329.335815,815.360901 330.104919,815.054504 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M300.157318,780.991089 
    C301.612610,777.088501 304.420593,774.768005 308.804565,773.695557 
    C309.304077,773.769470 309.461365,774.038391 308.985321,774.642944 
    C307.886627,775.602234 307.421295,776.225830 306.955933,776.849487 
    C305.583771,778.205994 304.211639,779.562561 302.192505,780.971252 
    C301.082764,781.012573 300.620026,781.001831 300.157318,780.991089 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M303.711700,902.268066 
    C304.352448,902.803101 304.875824,903.657410 305.622253,904.727600 
    C306.355408,907.827576 306.865509,910.711670 307.197632,913.865173 
    C305.877838,910.285522 304.736084,906.436401 303.711700,902.268066 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M434.666229,1026.842773 
    C431.436035,1027.611450 427.863129,1028.254517 423.821594,1028.773071 
    C427.009827,1028.004883 430.666687,1027.360962 434.666229,1026.842773 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M325.957581,759.985596 
    C327.174805,759.686523 328.409485,759.404419 330.024963,759.188721 
    C327.196899,761.556152 323.988037,763.857178 320.476379,765.846558 
    C320.434875,764.679932 320.696167,763.825012 320.957458,762.970032 
    C320.957458,762.970032 320.995605,762.994080 321.335846,763.069214 
    C323.109955,762.081604 324.543823,761.018982 325.977722,759.956360 
    C325.977722,759.956360 325.975037,760.002563 325.957581,759.985596 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M504.009583,852.335938 
    C502.672699,848.840271 501.335815,845.344604 500.282166,841.599792 
    C501.219727,841.914490 501.874115,842.478333 502.528503,843.042236 
    C502.755859,843.667786 502.983215,844.293335 503.144958,845.559937 
    C503.500092,846.831848 503.920837,847.462708 504.341553,848.093506 
    C504.580170,848.801697 504.818817,849.509888 504.824707,850.759033 
    C504.397858,851.645264 504.203735,851.990601 504.009583,852.335938 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M280.482544,810.264526 
    C280.135498,809.559021 280.078186,808.675049 279.937988,807.353516 
    C279.855103,806.916016 279.916809,806.922546 280.212158,806.829590 
    C280.650940,806.388611 280.794342,806.040466 280.937744,805.692383 
    C280.937744,805.692383 280.949066,805.421692 281.346924,805.207642 
    C282.144714,804.228149 282.544647,803.462708 282.944580,802.697327 
    C282.944580,802.697327 282.953979,802.423706 283.342621,802.267517 
    C284.403198,802.065063 285.075165,802.018799 285.747101,801.972534 
    C284.088837,804.677063 282.430573,807.381592 280.482544,810.264526 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M317.857117,830.980225 
    C316.174133,834.672913 314.491150,838.365662 312.432129,841.738892 
    C312.340790,840.212952 312.625458,839.006409 312.910156,837.799866 
    C312.998108,837.386414 313.086090,836.972961 313.642944,836.215332 
    C314.392487,835.212341 314.673126,834.553528 314.953766,833.894653 
    C315.368225,832.982300 315.782715,832.070007 316.749207,831.057800 
    C317.486511,830.965332 317.671814,830.972778 317.857117,830.980225 
  z"/>
  <path fill="#C3C3C3" opacity="1.000000" stroke="none" 
    d="
  M465.561493,966.944214 
    C466.060852,967.185547 466.413086,967.432129 466.928406,967.958069 
    C464.955750,969.614746 462.820007,970.991943 460.484314,972.207336 
    C460.501373,971.348755 460.718414,970.651978 460.935486,969.955200 
    C460.935486,969.955200 460.986572,969.991211 461.282776,969.991577 
    C462.042725,969.639526 462.506500,969.287109 462.970276,968.934692 
    C462.970276,968.934692 462.960022,969.000854 463.278320,968.976196 
    C464.111389,968.320679 464.626160,967.689819 465.140930,967.058899 
    C465.140930,967.058899 465.414337,966.949341 465.561493,966.944214 
  z"/>
  <path fill="#E2E2E2" opacity="1.000000" stroke="none" 
    d="
  M485.057404,815.553223 
    C485.157593,816.546570 485.196350,817.346069 485.286133,818.546875 
    C482.589844,816.131104 479.842590,813.314087 477.082642,810.117432 
    C479.263397,811.431641 481.456818,813.125366 484.004150,814.851074 
    C484.636780,814.953247 484.849457,815.112061 485.057404,815.553223 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M549.861572,859.310669 
    C550.602905,861.614136 551.205627,864.228210 551.659790,867.278198 
    C550.915161,865.016479 550.319031,862.318909 549.861572,859.310669 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M348.933716,969.453003 
    C348.709290,969.832092 348.536560,969.856934 348.120148,969.977295 
    C346.439545,969.025024 345.002655,967.977356 343.327209,966.399414 
    C342.943115,965.363770 342.797577,964.858337 342.774658,964.226807 
    C342.897339,964.100769 343.141846,963.847717 343.141846,963.847717 
    C345.089691,965.598083 347.037567,967.348389 348.933716,969.453003 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M551.277344,900.564331 
    C551.177979,903.029968 550.860901,905.774414 550.246216,908.766846 
    C550.318970,906.291016 550.689270,903.567017 551.277344,900.564331 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M389.400513,1028.374268 
    C386.948425,1028.259277 384.226624,1027.909546 381.250275,1027.273071 
    C383.707428,1027.370728 386.419128,1027.755127 389.400513,1028.374268 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M551.806274,880.323120 
    C552.165405,882.490112 552.360657,884.988159 552.263062,887.747498 
    C551.860901,885.557251 551.751648,883.105713 551.806274,880.323120 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M348.685699,796.755127 
    C348.953308,800.554443 346.369965,801.905518 343.127625,802.935913 
    C342.949677,802.006531 343.152466,801.148254 344.055908,800.140503 
    C345.504730,799.292725 346.252869,798.594360 347.000977,797.895996 
    C347.465637,797.464722 347.930298,797.033508 348.685699,796.755127 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M337.385742,960.376831 
    C339.428406,961.163879 341.127960,962.200989 342.984680,963.542908 
    C343.141846,963.847717 342.897339,964.100769 342.432312,964.137939 
    C341.251526,964.151550 340.535736,964.127991 339.819977,964.104370 
    C338.894165,962.945190 337.968353,961.786072 337.385742,960.376831 
  z"/>
  <path fill="#C0C0C0" opacity="1.000000" stroke="none" 
    d="
  M322.064484,941.723755 
    C323.366730,943.571350 324.668976,945.418945 325.684265,947.525146 
    C324.764313,947.504272 324.131317,947.224854 323.498291,946.945435 
    C322.679901,945.864197 321.861450,944.783020 321.230255,943.213684 
    C321.633148,942.391663 321.848816,942.057678 322.064484,941.723755 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M378.281677,1026.513916 
    C376.496460,1026.363525 374.476410,1025.981567 372.227417,1025.297119 
    C374.014587,1025.423950 376.030731,1025.853149 378.281677,1026.513916 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M291.422119,792.586426 
    C292.883026,790.300903 294.629547,788.344421 296.449036,786.753906 
    C294.917267,789.051697 293.312500,790.983582 291.422119,792.586426 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M338.829224,806.929565 
    C338.829254,806.929565 338.560699,807.031250 338.112366,807.142090 
    C337.385559,807.812500 337.107117,808.372131 336.828674,808.931702 
    C336.828644,808.931702 336.562836,809.034973 335.911926,808.938599 
    C334.925659,808.761292 334.590271,808.680298 334.254883,808.599304 
    C335.633087,807.178772 337.011322,805.758301 338.706909,804.616455 
    C338.959229,805.573303 338.894226,806.251404 338.829224,806.929565 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M333.965302,808.688843 
    C334.590271,808.680298 334.925659,808.761292 335.769409,808.942993 
    C335.104736,810.394043 333.931671,811.744263 332.285339,812.917969 
    C331.524475,812.488647 331.236847,812.235840 330.949249,811.983093 
    C331.858093,810.914856 332.766907,809.846558 333.965302,808.688843 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M547.792114,849.261108 
    C548.582764,850.898865 549.255127,852.820435 549.813965,855.151001 
    C549.024902,853.554932 548.349304,851.549927 547.792114,849.261108 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M311.926636,769.958252 
    C313.464081,768.635254 315.001556,767.312256 316.916504,766.072144 
    C316.754547,767.314758 316.215118,768.474548 314.958801,769.795166 
    C313.470154,769.956726 312.698395,769.957458 311.926636,769.958252 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M330.642944,812.070312 
    C331.236847,812.235840 331.524475,812.488647 331.934937,813.008545 
    C332.057800,813.275757 332.041412,813.557312 331.687012,813.743042 
    C330.896545,814.309021 330.460510,814.689270 330.024475,815.069519 
    C330.024475,815.069519 330.056641,815.020386 330.080780,815.037476 
    C329.335815,815.360901 328.566711,815.667297 327.487671,815.998657 
    C328.230682,814.734863 329.283630,813.446167 330.642944,812.070312 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M311.940369,769.975708 
    C312.698395,769.957458 313.470154,769.956726 314.629303,769.981079 
    C313.312042,771.402588 311.607391,772.798950 309.548401,773.989258 
    C309.655457,773.099426 310.116821,772.415710 311.074890,771.339844 
    C311.704742,770.619446 311.837860,770.291382 311.970978,769.963257 
    C311.970978,769.963257 311.954041,769.993164 311.940369,769.975708 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M370.236725,1024.538574 
    C368.470459,1024.380981 366.470947,1023.990540 364.237457,1023.306030 
    C366.003479,1023.443176 368.003479,1023.874390 370.236725,1024.538574 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M502.565704,842.705750 
    C501.874115,842.478333 501.219727,841.914490 500.351074,841.184082 
    C500.136810,841.017517 500.018646,840.571594 499.879395,840.002197 
    C499.548004,838.520142 499.355865,837.607544 499.163727,836.694885 
    C500.310120,838.586365 501.456512,840.477783 502.565704,842.705750 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M312.622406,837.942505 
    C312.625458,839.006409 312.340790,840.212952 312.042603,841.797913 
    C312.029114,842.176331 311.985443,842.586975 311.657898,842.921875 
    C310.793457,843.535522 310.256531,843.814209 309.719604,844.092896 
    C310.591278,842.090332 311.462952,840.087769 312.622406,837.942505 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M285.951569,801.767090 
    C285.075165,802.018799 284.403198,802.065063 283.395111,802.141052 
    C284.114929,800.506592 285.170868,798.842346 286.617340,797.434998 
    C287.008331,798.479919 287.008789,799.268066 287.009277,800.056152 
    C286.724854,800.557983 286.440460,801.059814 285.951569,801.767090 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M549.422913,912.615845 
    C549.324219,914.139221 548.998840,915.887085 548.329346,917.819336 
    C548.388916,916.282654 548.792542,914.561523 549.422913,912.615845 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M358.023926,792.852783 
    C358.023926,792.852783 357.569519,792.972046 356.924500,792.935791 
    C356.011780,792.821960 355.744080,792.744385 355.476349,792.666870 
    C357.438232,791.589172 359.400085,790.511414 361.710785,789.646423 
    C362.027863,790.190186 362.007568,790.521973 361.998657,790.854492 
    C361.998657,790.854492 361.567230,790.972168 361.024170,791.011230 
    C359.662079,791.651123 358.843018,792.251953 358.023926,792.852783 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M379.771973,782.710449 
    C378.407196,783.480713 376.757812,784.154480 374.699738,784.727905 
    C376.023163,783.956299 377.755219,783.285095 379.771973,782.710449 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M438.448395,784.427612 
    C436.931610,784.259705 435.172974,783.874207 433.184998,783.176025 
    C434.705963,783.312195 436.456268,783.761108 438.448395,784.427612 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M386.749908,780.790771 
    C385.385681,781.553528 383.744843,782.197754 381.701324,782.738159 
    C383.023529,781.980225 384.748413,781.326172 386.749908,780.790771 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M431.429596,782.448730 
    C429.919495,782.297974 428.179230,781.917480 426.207764,781.232422 
    C427.717529,781.358215 429.458466,781.788635 431.429596,782.448730 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M499.165222,836.391541 
    C499.355865,837.607544 499.548004,838.520142 499.856812,839.772644 
    C498.715454,838.617981 497.457367,837.123474 496.151733,835.276672 
    C496.729248,834.961121 497.354279,834.997986 498.292480,835.034180 
    C498.792694,835.385132 498.979736,835.736633 499.165222,836.391541 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M545.973145,842.279114 
    C546.702576,843.608643 547.313416,845.194580 547.816528,847.162109 
    C547.090759,845.874329 546.472656,844.204895 545.973145,842.279114 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M460.583405,970.074829 
    C460.718414,970.651978 460.501373,971.348755 460.161194,972.303955 
    C459.214935,973.097473 458.391846,973.632568 457.200897,974.087402 
    C457.965759,972.736206 459.098541,971.465271 460.583405,970.074829 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M547.404602,920.578857 
    C547.362183,921.789490 547.093384,923.197205 546.494629,924.781860 
    C546.502502,923.564575 546.840393,922.170227 547.404602,920.578857 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M350.973785,796.879761 
    C350.516663,796.907471 350.059509,796.935181 349.258240,796.958252 
    C350.335541,795.914001 351.756958,794.874390 353.576904,794.069336 
    C353.984772,794.484985 353.994110,794.666260 354.003448,794.847473 
    C354.003448,794.847473 353.528809,794.969788 353.016449,795.101624 
    C351.993988,795.782227 351.483887,796.330933 350.973785,796.879761 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M287.358032,799.917480 
    C287.008789,799.268066 287.008331,798.479919 286.928192,797.303833 
    C286.848511,796.915833 286.901093,796.925720 287.372498,796.854736 
    C288.333496,796.068542 288.823059,795.353210 289.312592,794.637939 
    C288.777313,796.351562 288.242035,798.065247 287.358032,799.917480 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M321.547607,822.743835 
    C321.886414,823.170227 321.932892,823.770569 322.018494,824.821472 
    C322.057587,825.272095 322.036041,825.558899 321.678101,825.743774 
    C320.885590,826.316956 320.451050,826.705322 320.016479,827.093689 
    C320.016479,827.093689 320.016083,827.020691 319.841431,827.064819 
    C319.666779,827.108948 319.268677,827.259705 319.183563,827.177490 
    C319.098450,827.095337 318.928223,826.930969 318.928223,826.930969 
    C319.703888,825.593201 320.479584,824.255432 321.547607,822.743835 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M367.808289,786.664795 
    C367.535767,787.295654 367.002289,787.834717 366.283295,788.596436 
    C365.927795,788.864075 365.757812,788.909241 364.940552,788.937988 
    C364.041168,788.853027 363.789032,788.784485 363.536865,788.715942 
    C364.873688,788.001648 366.210510,787.287415 367.808289,786.664795 
  z"/>
  <path fill="#A5A5A5" opacity="1.000000" stroke="none" 
    d="
  M504.008148,852.472656 
    C504.203735,851.990601 504.397858,851.645264 504.840393,851.136475 
    C505.592224,851.810791 506.095642,852.648499 506.234253,853.736816 
    C505.281494,853.612976 504.693542,853.238586 504.105591,852.864197 
    C504.105591,852.864197 504.006714,852.609314 504.008148,852.472656 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M339.946411,964.390076 
    C340.535736,964.127991 341.251526,964.151550 342.309631,964.264038 
    C342.797577,964.858337 342.943115,965.363770 343.112671,966.135620 
    C342.115387,965.826660 341.094116,965.251221 339.946411,964.390076 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M339.207336,806.875610 
    C338.894226,806.251404 338.959229,805.573303 339.025726,804.554688 
    C340.125275,803.504089 341.223328,802.793884 342.596008,802.415527 
    C341.775574,804.105408 340.680511,805.463501 339.207336,806.875610 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M268.484344,836.668945 
    C267.732483,837.530334 267.149811,838.081848 266.367676,838.781250 
    C266.485504,837.610474 266.802765,836.291748 267.732361,834.991943 
    C268.344696,835.010986 268.803833,834.968628 268.803833,834.968628 
    C268.753723,835.432068 268.703644,835.895569 268.484344,836.668945 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M323.515106,947.246460 
    C324.131317,947.224854 324.764313,947.504272 325.634583,947.900146 
    C325.871857,948.016602 325.987640,948.476685 326.006134,949.020691 
    C326.004822,949.770081 325.984985,949.975525 325.965179,950.180908 
    C325.154083,949.303101 324.342987,948.425293 323.515106,947.246460 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M269.023773,834.828613 
    C268.803833,834.968628 268.344696,835.010986 268.116455,834.978088 
    C267.935150,834.510620 267.982117,834.076111 268.332642,833.192993 
    C269.127014,832.484192 269.617828,832.223938 270.108704,831.963623 
    C269.820374,832.871948 269.532043,833.780273 269.023773,834.828613 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M270.248291,831.772705 
    C269.617828,832.223938 269.127014,832.484192 268.386017,832.868958 
    C268.482086,831.646790 268.828308,830.300232 269.566589,828.926147 
    C270.017792,829.194336 270.076935,829.489929 270.262360,830.219849 
    C270.511230,830.963562 270.510986,831.272705 270.248291,831.772705 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M334.161133,757.326721 
    C334.824493,756.529663 335.782471,755.800537 337.059021,755.155029 
    C336.403656,755.957336 335.429688,756.675964 334.161133,757.326721 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M320.626282,763.060730 
    C320.696167,763.825012 320.434875,764.679932 320.116547,765.881348 
    C319.260834,766.503418 318.462189,766.779175 317.397095,766.678406 
    C318.185455,765.251770 319.240265,764.201599 320.626282,763.060730 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M443.545593,786.343140 
    C442.596588,786.228943 441.455200,785.901978 440.140442,785.233093 
    C441.095825,785.304199 442.224518,785.717285 443.545593,786.343140 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M372.787415,784.797852 
    C372.013458,785.518311 371.000122,786.132751 369.610413,786.629883 
    C370.338715,785.905640 371.443390,785.298706 372.787415,784.797852 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M504.069763,853.209290 
    C504.693542,853.238586 505.281494,853.612976 506.125549,854.031067 
    C506.524567,854.482544 506.667542,854.890259 506.781372,855.625244 
    C506.398987,855.953064 506.045715,855.953735 505.427429,855.966675 
    C504.786255,855.170715 504.410095,854.362549 504.069763,853.209290 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M317.918823,830.752686 
    C317.671814,830.972778 317.486511,830.965332 317.025635,830.920166 
    C317.288269,829.683167 317.826508,828.484009 318.646484,827.107910 
    C318.928223,826.930969 319.098450,827.095337 319.073364,827.460938 
    C318.713959,828.570374 318.379669,829.314270 318.045380,830.058105 
    C318.045380,830.058105 317.980530,830.525146 317.918823,830.752686 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M354.375793,794.922485 
    C353.994110,794.666260 353.984772,794.484985 353.934753,794.034546 
    C354.247162,793.405518 354.600189,793.045593 355.214783,792.676270 
    C355.744080,792.744385 356.011780,792.821960 356.692017,792.969299 
    C356.319061,793.691833 355.533600,794.344666 354.375793,794.922485 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M363.247528,788.712891 
    C363.789032,788.784485 364.041168,788.853027 364.680603,788.982971 
    C364.293671,789.696289 363.519501,790.348206 362.371979,790.927307 
    C362.007568,790.521973 362.027863,790.190186 362.049866,789.609741 
    C362.346161,789.143433 362.652191,788.926575 363.247528,788.712891 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M299.971558,781.333252 
    C300.620026,781.001831 301.082764,781.012573 301.889465,781.070557 
    C301.410492,782.246277 300.587585,783.374817 299.403046,784.537537 
    C299.289551,783.606262 299.537659,782.640869 299.971558,781.333252 
  z"/>
  <path fill="#AFAFAF" opacity="1.000000" stroke="none" 
    d="
  M322.054352,941.583130 
    C321.848816,942.057678 321.633148,942.391663 321.161346,942.880127 
    C320.375153,942.533386 319.845093,942.032166 319.337158,941.244141 
    C320.003784,941.012695 320.648285,941.067993 321.615662,941.152222 
    C321.938568,941.181152 322.044220,941.442566 322.054352,941.583130 
  z"/>
  <path fill="#C3C3C3" opacity="1.000000" stroke="none" 
    d="
  M477.810669,958.562134 
    C477.728119,957.582642 477.937714,956.959534 478.809937,956.172607 
    C479.999664,956.008728 480.526733,956.008606 481.053833,956.008484 
    C480.070129,956.978455 479.086456,957.948486 477.810669,958.562134 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M481.215118,955.807190 
    C480.526733,956.008606 479.999664,956.008728 479.076813,955.979980 
    C479.492371,955.292175 480.303711,954.633179 481.463684,954.068970 
    C481.812347,954.163696 481.876251,954.475037 481.921936,954.627258 
    C481.770569,955.054993 481.573486,955.330444 481.215118,955.807190 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M526.653931,965.914917 
    C526.440613,966.756470 525.922852,967.718506 525.063232,968.753723 
    C525.264160,967.896423 525.806885,966.965881 526.653931,965.914917 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M309.561737,844.415344 
    C310.256531,843.814209 310.793457,843.535522 311.602692,843.120850 
    C311.465546,843.997314 311.056091,845.009705 310.257507,845.990234 
    C309.713531,845.551453 309.558716,845.144592 309.561737,844.415344 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M346.682983,797.935791 
    C346.252869,798.594360 345.504730,799.292725 344.436035,800.017822 
    C344.865265,799.354919 345.615112,798.665283 346.682983,797.935791 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M340.293579,753.733459 
    C340.816803,753.114502 341.661560,752.569214 342.816711,752.067017 
    C342.289764,752.675842 341.452423,753.241516 340.293579,753.733459 
  z"/>
  <path fill="#A5A5A5" opacity="1.000000" stroke="none" 
    d="
  M499.249939,930.914062 
    C499.334198,930.425842 499.597748,929.718750 500.169128,928.961182 
    C500.127777,929.505554 499.778503,930.100342 499.249939,930.914062 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M145.455933,974.911499 
    C145.092361,974.396240 145.066635,973.909302 145.083282,973.057739 
    C145.765549,973.237549 146.405426,973.782166 147.098221,974.641296 
    C146.698669,974.950562 146.246216,974.945251 145.455933,974.911499 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M524.911560,970.543823 
    C524.479858,970.942932 524.059204,970.982178 523.321106,971.011353 
    C523.417542,970.345276 523.831421,969.689087 524.506897,968.892944 
    C524.819824,969.229980 524.871277,969.706970 524.911560,970.543823 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M308.988464,991.645752 
    C308.421387,991.507019 307.737030,991.094788 307.023926,990.352234 
    C307.620514,990.472107 308.245850,990.922241 308.988464,991.645752 
  z"/>
  <path fill="#C3C3C3" opacity="1.000000" stroke="none" 
    d="
  M468.246002,967.638794 
    C468.484924,967.115112 469.008728,966.572327 469.845947,966.050232 
    C469.616547,966.587219 469.073700,967.103455 468.246002,967.638794 
  z"/>
  <path fill="#ADADAD" opacity="1.000000" stroke="none" 
    d="
  M363.979218,587.323608 
    C364.589264,587.454285 365.275879,587.881470 365.991455,588.637634 
    C365.365540,588.517761 364.710663,588.068970 363.979218,587.323608 
  z"/>
  <path fill="#ADADAD" opacity="1.000000" stroke="none" 
    d="
  M377.750122,604.186523 
    C378.210693,604.489685 378.605316,605.071167 378.946045,605.930786 
    C378.489502,605.627625 378.086884,605.046204 377.750122,604.186523 
  z"/>
  <path fill="#ADADAD" opacity="1.000000" stroke="none" 
    d="
  M380.401672,610.223755 
    C380.939941,610.476318 381.445343,611.024780 381.943726,611.882690 
    C381.414062,611.634705 380.891418,611.077209 380.401672,610.223755 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M289.279175,794.605347 
    C288.823059,795.353210 288.333496,796.068542 287.397095,796.865356 
    C287.464447,796.242737 287.978699,795.538513 288.838837,794.668213 
    C289.184723,794.502075 289.245789,794.572693 289.279175,794.605347 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M458.199371,793.693481 
    C458.144196,793.811401 458.082886,793.755493 458.086304,793.773438 
    C458.023651,793.568542 457.957581,793.345581 457.891510,793.122681 
    C458.012512,793.273621 458.133545,793.424622 458.199371,793.693481 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M289.621094,794.930481 
    C289.557220,793.804138 289.959839,792.906738 290.802673,792.075439 
    C290.857788,793.147461 290.472687,794.153442 289.621094,794.930481 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M455.460327,791.874451 
    C455.099731,791.839355 454.582336,791.631775 453.999603,791.211853 
    C454.390656,791.233704 454.847076,791.467896 455.460327,791.874451 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M447.183533,787.646973 
    C446.597961,787.717773 445.955017,787.543884 445.122559,787.080688 
    C445.664062,786.995056 446.395142,787.198730 447.183533,787.646973 
  z"/>
  <path fill="#A5A5A5" opacity="1.000000" stroke="none" 
    d="
  M504.434509,847.805298 
    C503.920837,847.462708 503.500092,846.831848 503.152985,845.897339 
    C503.660217,846.234802 504.093811,846.875977 504.434509,847.805298 
  z"/>
  <path fill="#ABABAB" opacity="1.000000" stroke="none" 
    d="
  M307.255859,776.839294 
    C307.421295,776.225830 307.886627,775.602234 308.668518,774.986633 
    C308.508636,775.606140 308.032227,776.217651 307.255859,776.839294 
  z"/>
  <path fill="#B5B5B5" opacity="1.000000" stroke="none" 
    d="
  M314.685822,833.994751 
    C314.673126,834.553528 314.392487,835.212341 313.839386,835.962341 
    C313.850586,835.400574 314.134216,834.747742 314.685822,833.994751 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M340.211853,622.492554 
    C339.466095,622.780823 338.825928,622.612366 338.148773,622.096558 
    C338.846985,621.844727 339.582214,621.940247 340.211853,622.492554 
  z"/>
  <path fill="#C0C0C0" opacity="1.000000" stroke="none" 
    d="
  M326.026337,950.225952 
    C325.984985,949.975525 326.004822,949.770081 326.038940,949.255615 
    C326.630219,949.085083 327.207123,949.223694 327.939697,949.619751 
    C327.786224,949.944092 327.477020,950.010986 326.698242,950.146362 
    C326.228638,950.214905 326.087494,950.270935 326.026337,950.225952 
  z"/>
  <path fill="#020202" opacity="1.000000" stroke="none" 
    d="
  M959.088989,1165.304688 
    C959.088928,1165.304688 958.970520,1165.447998 959.056152,1165.488281 
    C959.141785,1165.528442 959.195129,1165.520386 959.641968,1165.551514 
    C959.156555,1163.359863 958.224365,1161.137085 957.266602,1158.541748 
    C956.561523,1157.138062 955.881958,1156.106934 955.251831,1154.778442 
    C954.608521,1153.482910 953.915833,1152.484497 953.174927,1151.153320 
    C952.497314,1149.903320 951.867859,1148.986328 951.289917,1147.793457 
    C950.559875,1146.681274 949.778381,1145.844604 949.026855,1144.623535 
    C946.658386,1138.492432 944.259827,1132.745728 941.861267,1126.999146 
    C942.003174,1126.766235 942.145020,1126.533447 942.477356,1126.100586 
    C942.900757,1125.619751 943.133667,1125.338989 943.366577,1125.058105 
    C943.055542,1125.007568 942.744385,1124.956787 942.433228,1124.906006 
    C942.996704,1124.286987 943.560120,1123.667969 944.680603,1122.784912 
    C945.193420,1122.459595 945.149170,1122.398315 945.104980,1122.337158 
    C945.453674,1122.181396 945.802307,1122.025757 946.714294,1121.606689 
    C949.123291,1119.632080 950.968994,1117.920654 952.814697,1116.209106 
    C953.188049,1116.062500 953.561523,1115.915771 954.569458,1115.491455 
    C961.227600,1110.671387 967.306396,1106.199097 973.220825,1101.519043 
    C974.214905,1100.732422 975.014160,1099.052979 975.026489,1097.777466 
    C975.106445,1089.533203 974.943176,1081.286621 974.980896,1072.681152 
    C974.996094,1071.835693 974.889893,1071.349854 974.783691,1070.863892 
    C974.523621,1070.510864 974.263611,1070.157837 973.629272,1069.617065 
    C972.923279,1069.251221 972.591492,1069.072998 972.065796,1068.609863 
    C970.559814,1067.402954 969.247742,1066.481079 967.657593,1065.312500 
    C966.973389,1065.278931 966.567322,1065.491821 966.161194,1065.704834 
    C966.161194,1065.704834 966.048584,1065.791748 966.225586,1065.332031 
    C965.660645,1064.813843 964.918701,1064.755493 964.176758,1064.697144 
    C964.176758,1064.697144 964.169434,1064.847778 964.552979,1064.534790 
    C963.985291,1063.138794 963.034058,1062.055664 961.924561,1060.679321 
    C959.553284,1058.783691 957.340271,1057.181274 954.979858,1055.292236 
    C952.922302,1053.657349 951.012268,1052.309082 948.957275,1050.670044 
    C947.563477,1049.524536 946.314636,1048.669556 944.926270,1047.552124 
    C944.221741,1047.116089 943.656616,1046.942627 943.103333,1046.558350 
    C943.115112,1046.347656 942.974365,1045.949585 942.974365,1045.949585 
    C940.779663,1039.625244 943.246948,1034.487305 947.405640,1029.243408 
    C952.206360,1021.287964 956.666931,1013.766968 961.225098,1006.305603 
    C965.769165,998.867188 970.411133,991.488586 975.010254,984.083862 
    C977.762695,984.481201 980.515198,984.878601 983.460083,985.577881 
    C983.686584,985.717285 983.673706,985.513062 983.769470,985.405273 
    C983.846619,985.318420 984.079956,985.285828 984.201599,985.334656 
    C993.250122,988.965271 1002.294373,992.606445 1011.585205,996.503418 
    C1014.876953,998.830872 1017.837769,999.628845 1020.675659,996.214905 
    C1020.835205,996.247742 1020.997620,995.965271 1021.334412,995.909546 
    C1023.287720,994.649292 1024.904297,993.444885 1026.683105,992.264648 
    C1026.845581,992.288940 1027.000000,991.999084 1027.352783,991.927124 
    C1030.541748,990.269897 1033.211426,988.092163 1036.252930,987.236816 
    C1040.935181,985.919922 1042.334839,982.893799 1042.878906,978.598022 
    C1044.144409,968.605042 1045.824707,958.661682 1046.942139,948.654175 
    C1047.414917,944.419006 1049.110718,941.557312 1053.393188,939.956543 
    C1073.589233,939.975708 1093.319824,939.903137 1113.386475,939.951660 
    C1117.708618,942.061890 1119.575073,945.155701 1119.769287,949.733398 
    C1119.900879,952.836365 1121.160889,955.891357 1121.916138,958.967834 
    C1121.936401,960.140381 1121.956665,961.312927 1121.824219,963.188599 
    C1122.344971,968.936462 1122.892090,974.003113 1123.760132,979.014160 
    C1124.067749,980.790344 1125.156616,982.431213 1125.888916,984.133850 
    C1125.888916,984.133850 1125.828857,984.087280 1125.822021,984.470337 
    C1130.234863,987.239868 1134.654663,989.626221 1139.074463,992.012573 
    C1139.397705,992.068787 1139.720947,992.124878 1140.516846,992.385254 
    C1141.352905,992.890991 1141.716187,993.192444 1142.079590,993.493896 
    C1141.964722,993.225525 1141.849976,992.957092 1141.735107,992.688721 
    C1144.487549,994.609070 1147.240112,996.529358 1150.240234,998.622437 
    C1151.347534,998.065430 1152.780273,997.344727 1154.783203,996.457092 
    C1160.235962,994.221313 1165.118164,992.152466 1170.000488,990.083618 
    C1175.034668,988.348755 1180.237183,986.978760 1185.048462,984.760437 
    C1188.711304,983.071655 1191.382935,984.269775 1194.502563,986.344238 
    C1197.748535,992.189880 1200.668701,997.765198 1203.800537,1003.218933 
    C1205.707764,1006.539917 1207.941650,1009.673401 1210.028687,1012.891052 
    C1210.190430,1013.036987 1210.352295,1013.182861 1210.651123,1013.794250 
    C1212.335449,1017.162659 1213.882690,1020.065613 1215.455566,1023.283691 
    C1216.307739,1024.764648 1217.134277,1025.930420 1218.059814,1027.376099 
    C1218.329102,1027.756836 1218.499390,1027.857666 1218.676270,1028.294434 
    C1220.615479,1031.802856 1222.548096,1034.975220 1224.482666,1038.466309 
    C1224.628052,1039.181641 1224.771362,1039.578003 1224.811401,1040.315918 
    C1223.155396,1043.440063 1221.602661,1046.222778 1219.681396,1049.230835 
    C1219.463013,1049.935303 1219.613037,1050.414307 1219.762939,1050.893311 
    C1219.762939,1050.893311 1219.925049,1050.924072 1219.683960,1050.521973 
    C1218.983887,1050.313110 1218.524780,1050.506348 1217.821899,1050.658325 
    C1216.719604,1051.411377 1215.861328,1052.205688 1214.730225,1053.356934 
    C1214.889160,1053.995361 1215.321045,1054.276733 1215.752808,1054.558105 
    C1215.752808,1054.558105 1215.507080,1054.655884 1215.398193,1054.440674 
    C1215.090454,1054.163086 1214.891602,1054.100586 1214.414551,1053.789551 
    C1212.376709,1054.971191 1210.616943,1056.401245 1208.576904,1057.883789 
    C1207.732178,1058.598267 1207.167480,1059.260132 1206.602905,1059.922119 
    C1206.432007,1059.950562 1206.261108,1059.978882 1205.705322,1060.311279 
    C1201.991455,1062.985474 1198.729126,1065.457153 1195.313965,1067.695679 
    C1192.205566,1069.733154 1191.115601,1072.282227 1191.458496,1076.063965 
    C1191.922241,1081.179688 1191.872070,1086.367432 1191.684326,1091.511108 
    C1191.372925,1100.052734 1196.206787,1106.675171 1204.924561,1109.163696 
    C1205.008789,1109.388550 1205.093140,1109.613525 1205.516357,1110.218262 
    C1206.247070,1110.813843 1206.638916,1111.030029 1207.030762,1111.246216 
    C1207.187256,1111.461548 1207.343750,1111.676880 1207.691650,1112.216187 
    C1208.923828,1113.356812 1209.964233,1114.173340 1211.226074,1115.224609 
    C1212.707397,1116.289185 1213.967651,1117.119141 1215.269043,1118.261963 
    C1216.202026,1119.067383 1217.093750,1119.559814 1218.113037,1120.290771 
    C1218.985352,1120.996704 1219.729980,1121.463989 1220.442261,1122.179321 
    C1221.252808,1123.000977 1222.095825,1123.574707 1223.021606,1124.453125 
    C1223.729248,1125.837158 1224.354004,1126.916260 1224.845337,1128.329102 
    C1224.179077,1130.777344 1223.646240,1132.891968 1222.916016,1135.219971 
    C1222.482056,1135.962158 1222.245605,1136.490967 1221.703125,1137.077881 
    C1220.781128,1138.429077 1220.165161,1139.722412 1219.309692,1141.218628 
    C1218.974121,1141.821655 1218.878052,1142.221558 1218.494141,1142.796143 
    C1217.157104,1144.978027 1216.107910,1146.985474 1214.868408,1149.250244 
    C1214.098145,1150.618530 1213.518066,1151.729492 1212.654785,1153.015625 
    C1211.537842,1154.780640 1210.704102,1156.370605 1209.630859,1158.119751 
    C1209.246826,1158.823853 1209.102173,1159.368530 1208.666016,1160.073120 
    C1204.172119,1167.449219 1199.969727,1174.665527 1195.484741,1182.048340 
    C1194.149780,1183.588501 1193.097534,1184.962036 1191.606812,1186.371582 
    C1188.162720,1185.842041 1185.008911,1185.679688 1182.177734,1184.639282 
    C1171.713257,1180.793457 1161.355469,1176.657471 1150.696289,1172.473877 
    C1149.614136,1172.770142 1148.793213,1173.222900 1147.609253,1173.706055 
    C1144.346680,1175.731079 1141.447266,1177.725586 1138.263184,1179.717773 
    C1137.670410,1179.920898 1137.362427,1180.126099 1136.726318,1180.338379 
    C1135.177979,1181.188232 1133.957520,1182.031128 1132.482544,1182.911621 
    C1131.813110,1183.249878 1131.398193,1183.550293 1130.634521,1183.812256 
    C1129.353760,1184.414062 1128.421509,1185.054565 1127.331909,1186.028564 
    C1127.357056,1186.527344 1127.539429,1186.692261 1127.721924,1186.857056 
    C1127.721924,1186.857056 1127.867920,1186.883301 1127.474487,1186.459229 
    C1126.664795,1186.998901 1126.248535,1187.962646 1125.832275,1188.926392 
    C1125.832275,1188.926392 1125.922119,1188.925049 1125.523560,1188.792480 
    C1124.654297,1191.466675 1124.183594,1194.273438 1123.541504,1197.463867 
    C1123.310303,1199.243774 1123.250854,1200.639771 1122.997192,1202.345459 
    C1122.405762,1205.450806 1122.008545,1208.246216 1121.468262,1211.414307 
    C1121.303711,1212.846680 1121.282104,1213.906372 1121.085815,1215.309692 
    C1120.607666,1217.102173 1120.304199,1218.551147 1119.941406,1220.393188 
    C1119.218628,1223.455933 1118.555298,1226.125488 1117.498291,1228.979980 
    C1115.089111,1229.671631 1113.076050,1230.605957 1111.057373,1230.618652 
    C1092.916626,1230.732910 1074.773682,1230.574951 1056.634521,1230.770386 
    C1052.617188,1230.813721 1049.481445,1229.992554 1047.343506,1226.250854 
    C1047.258911,1225.660400 1047.137817,1225.332397 1047.131836,1224.671875 
    C1046.571411,1221.067017 1045.895874,1217.794556 1045.298096,1214.210327 
    C1045.269165,1213.270630 1045.162354,1212.642944 1045.173950,1211.669678 
    C1044.609741,1207.705811 1043.927124,1204.087646 1043.310059,1200.123535 
    C1043.254761,1198.853027 1043.133789,1197.928101 1043.127686,1196.674194 
    C1042.579224,1193.383423 1041.916016,1190.421753 1041.263916,1187.171875 
    C1040.676025,1186.513672 1040.076904,1186.143677 1039.274658,1185.498291 
    C1036.021362,1183.661255 1032.971191,1182.099487 1029.720215,1180.303467 
    C1029.124756,1179.981323 1028.730225,1179.893677 1028.160400,1179.514648 
    C1025.258179,1177.382446 1022.603149,1175.418823 1019.772095,1173.754883 
    C1018.448120,1172.976807 1016.470276,1171.987061 1015.323303,1172.441772 
    C1006.307068,1176.015991 997.420288,1179.916870 988.164062,1183.694092 
    C987.233154,1183.906860 986.631775,1184.142334 985.646057,1184.399414 
    C981.247253,1186.176636 977.232849,1187.933960 972.812622,1184.770630 
    C971.814819,1184.046631 970.958618,1183.686523 970.102478,1183.326538 
    C970.102478,1183.326538 970.060974,1183.467773 970.520996,1183.219727 
    C970.450195,1181.941650 969.919434,1180.911743 969.365234,1179.515381 
    C968.237061,1177.407837 967.132385,1175.666626 965.957886,1173.633789 
    C965.617981,1173.052002 965.347961,1172.761841 965.077881,1172.471680 
    C965.371826,1172.211182 965.417480,1171.912598 964.914673,1171.056885 
    C963.426758,1168.817261 962.238892,1167.096802 960.760010,1165.132202 
    C960.008911,1165.027100 959.548950,1165.165894 959.088989,1165.304688 
  M1038.995361,1109.986328 
    C1038.995361,1109.986328 1038.887329,1109.991455 1038.711182,1110.524902 
    C1038.809570,1110.683960 1038.907959,1110.842896 1038.890625,1111.561035 
    C1039.015503,1111.704590 1039.140503,1111.848145 1039.540039,1112.621338 
    C1040.979126,1113.650513 1042.418335,1114.679565 1043.940552,1115.494263 
    C1043.940552,1115.494263 1043.711792,1115.469971 1042.935669,1115.568359 
    C1043.578125,1116.731934 1044.220581,1117.895508 1044.990356,1119.723267 
    C1045.805176,1120.477661 1046.620117,1121.232056 1047.527954,1122.598633 
    C1049.633911,1124.196655 1051.739746,1125.794678 1054.088379,1127.927124 
    C1054.919189,1128.350708 1055.750000,1128.774292 1056.965088,1129.764160 
    C1061.647583,1131.525513 1066.330078,1133.286987 1071.438721,1135.310425 
    C1071.756348,1135.261841 1072.074097,1135.213257 1072.916626,1135.653687 
    C1074.280762,1135.920410 1075.645020,1136.187012 1077.870972,1136.799194 
    C1081.585083,1136.694336 1085.299316,1136.589478 1089.816406,1136.656372 
    C1092.231445,1136.159058 1094.729614,1135.906616 1097.046753,1135.120483 
    C1105.619995,1132.212158 1114.055176,1129.000366 1120.172485,1121.130737 
    C1120.444580,1120.724976 1120.716675,1120.319092 1121.555908,1119.641846 
    C1122.684204,1118.092285 1123.812500,1116.542847 1125.462769,1114.549683 
    C1126.007202,1113.372559 1126.551514,1112.195435 1127.017456,1110.989502 
    C1127.017456,1110.989502 1126.985596,1111.066772 1127.593018,1110.811401 
    C1143.865234,1085.197144 1130.701904,1047.719604 1101.366577,1037.475342 
    C1100.870850,1037.444092 1100.375244,1037.412842 1099.360229,1036.965332 
    C1097.904297,1036.557251 1096.448242,1036.149292 1094.496826,1035.431885 
    C1094.304810,1035.463867 1094.112671,1035.495972 1093.183228,1035.202393 
    C1084.303711,1033.657837 1075.526489,1033.359863 1066.374268,1037.261719 
    C1065.928223,1037.438110 1065.482178,1037.614624 1064.394165,1037.643799 
    C1062.062134,1038.996582 1059.730103,1040.349365 1057.109253,1041.692383 
    C1057.109253,1041.692383 1056.998779,1041.959473 1056.331909,1042.009766 
    C1055.466675,1042.651733 1054.601440,1043.293701 1053.373657,1044.017090 
    C1053.149414,1044.164307 1053.027954,1044.371582 1052.319824,1044.749512 
    C1051.190063,1045.829346 1050.060425,1046.909180 1048.371582,1048.230713 
    C1047.578247,1049.134277 1046.784790,1050.037720 1045.361694,1051.052734 
    C1044.575439,1052.036987 1043.789185,1053.021240 1042.400635,1054.264404 
    C1041.413574,1055.890381 1040.426514,1057.516235 1039.070923,1059.717407 
    C1038.519653,1060.928345 1037.968506,1062.139160 1036.873047,1063.787598 
    C1029.527588,1075.380371 1030.109863,1097.902222 1038.012085,1108.995728 
    C1038.012085,1108.995728 1037.954346,1108.976440 1038.030273,1109.573364 
    C1038.356934,1109.746704 1038.683594,1109.920166 1038.995361,1109.986328 
  z"/>
  <path fill="#040404" opacity="1.000000" stroke="none" 
    d="
  M805.585815,909.969604 
    C805.768311,909.678406 805.950745,909.387268 806.506897,908.697510 
    C807.045593,907.996948 807.210632,907.695007 807.375610,907.393005 
    C808.191406,906.880188 809.007141,906.367310 810.225952,905.582336 
    C810.628967,905.310181 810.383850,905.501221 810.383850,905.501221 
    C810.383850,905.501221 810.432800,905.186646 810.432800,905.186646 
    C810.624817,905.006531 810.816772,904.826477 811.394287,904.378357 
    C813.708984,902.954041 815.843262,902.032898 817.511780,900.577698 
    C819.315918,899.004211 821.877625,897.017090 822.017090,895.061279 
    C822.410339,889.544922 821.782349,883.948486 821.400208,878.394409 
    C821.358765,877.791626 820.335205,877.207947 819.698425,876.702087 
    C813.490540,871.770630 807.268005,866.857483 801.049622,861.939209 
    C801.049622,861.939209 801.010132,862.002686 801.050903,861.589722 
    C801.431274,859.200806 801.770935,857.224854 802.410461,855.101135 
    C803.902588,852.622620 805.094849,850.291870 806.546143,847.706665 
    C806.920837,846.986877 807.036499,846.521545 807.445862,845.928467 
    C808.122498,844.862976 808.505554,843.925110 808.994202,842.682251 
    C809.116882,841.947815 809.133911,841.518494 809.150879,841.089172 
    C809.439453,840.907410 809.728027,840.725647 810.358521,840.146484 
    C813.190613,834.873657 815.680664,829.998230 818.170776,825.122742 
    C818.170776,825.122742 818.066406,825.060974 818.417786,825.213867 
    C818.937439,824.956299 819.105774,824.545898 819.274048,824.135498 
    C819.727173,823.789856 820.180298,823.444214 821.293213,822.939209 
    C823.636841,822.883667 825.320679,822.987488 827.004517,823.091248 
    C827.004517,823.091248 827.007629,822.998474 827.100098,823.293579 
    C829.464966,824.403320 831.737244,825.217896 834.179321,826.197632 
    C834.349060,826.362671 834.806763,826.484924 834.806763,826.484924 
    C834.806763,826.484924 835.268555,826.379333 835.459778,826.594482 
    C836.774048,827.227539 837.897095,827.645447 839.193115,828.219849 
    C839.366028,828.376282 839.819153,828.487793 839.819153,828.487793 
    C839.819153,828.487793 840.271423,828.372803 840.453125,828.592773 
    C841.756165,829.207153 842.877441,829.601501 844.190063,830.143372 
    C844.381409,830.290833 844.853149,830.396057 844.853149,830.396057 
    C844.853149,830.396057 845.324951,830.291321 845.582275,830.548645 
    C849.696960,833.165405 851.973145,830.026123 854.950439,828.271851 
    C855.844177,827.745789 856.435425,827.220886 857.369995,826.714355 
    C859.504883,825.490295 861.296448,824.247864 863.087952,823.005371 
    C863.087952,823.005371 863.006592,823.004639 863.374512,822.997498 
    C864.378296,821.357178 865.340393,819.772278 865.591064,818.081970 
    C866.465515,812.183960 867.092163,806.249207 867.816589,800.328918 
    C868.308838,796.306152 870.341736,793.970459 874.630615,793.979065 
    C885.915039,794.001648 897.199768,793.948425 908.483826,794.014587 
    C911.811707,794.034119 914.047852,795.368835 914.597046,799.135498 
    C915.504028,805.354980 917.222168,811.482727 917.757507,817.721313 
    C918.185364,822.706970 920.574219,825.106995 925.260742,826.440491 
    C926.488770,827.190491 927.474182,827.701782 928.669800,828.494934 
    C931.601685,830.460999 934.098633,833.469788 937.965942,830.310547 
    C938.843445,830.092285 939.404663,829.828125 940.274902,829.578918 
    C941.289062,829.171448 941.994141,828.749023 942.938416,828.387085 
    C943.538391,828.440247 943.814636,828.283752 944.233032,828.078491 
    C945.535034,827.555420 946.610352,826.932007 948.005310,826.355347 
    C948.866089,826.101379 949.407349,825.800598 950.302063,825.479065 
    C952.785950,824.291748 954.916321,823.125244 957.046692,821.958740 
    C957.046692,821.958679 956.952881,821.986084 957.263794,822.214111 
    C958.738708,822.467896 959.902588,822.493652 961.305542,822.810791 
    C962.884888,824.958984 964.225220,826.815796 965.565125,828.727417 
    C965.564636,828.782227 965.715515,828.959167 965.771484,829.306885 
    C966.833130,831.124573 967.838806,832.594543 968.862549,834.417969 
    C969.996155,836.500610 971.111755,838.229675 972.268799,840.293701 
    C973.149292,841.925293 973.988220,843.222046 974.827271,844.814026 
    C975.076660,845.396118 975.325928,845.682861 975.598999,846.292480 
    C976.689575,848.256653 977.756470,849.897949 978.824585,851.876709 
    C979.465820,853.128723 980.105896,854.043335 980.715637,855.264404 
    C981.336487,856.639404 981.987671,857.707886 982.529907,858.947021 
    C982.506531,859.495667 982.592163,859.873779 982.466187,860.498901 
    C981.889648,861.519897 981.524597,862.293762 981.098022,863.066040 
    C981.036438,863.064392 981.039307,863.187622 980.723389,863.260986 
    C979.441528,864.822205 978.475586,866.310059 977.509583,867.797913 
    C973.067261,870.711121 968.624939,873.624268 963.662842,876.891113 
    C960.451172,880.190125 960.372070,895.508789 963.055481,898.217102 
    C963.265503,898.429138 963.648987,898.469482 963.951782,898.589661 
    C964.637878,898.822327 965.323975,899.054993 966.342773,899.346802 
    C966.675537,899.405945 966.615540,899.342468 966.615540,899.342468 
    C966.897095,899.938904 967.178650,900.535339 968.049988,901.800964 
    C969.115845,902.639099 969.591797,902.807983 970.067749,902.976929 
    C970.067749,902.976929 969.970032,902.934509 970.014954,903.454346 
    C970.882141,904.025635 971.704407,904.077026 972.526672,904.128418 
    C972.526672,904.128418 972.483398,904.001099 972.209167,904.357910 
    C972.855347,905.494873 973.775757,906.275085 974.800476,907.383301 
    C976.908264,909.205750 978.911682,910.700256 981.068848,912.537476 
    C981.071411,915.401001 980.920166,917.921753 980.508789,920.657959 
    C979.279114,922.594788 978.309631,924.316162 977.102539,926.255615 
    C976.557190,927.270569 976.249451,928.067444 975.609009,929.025574 
    C974.748474,931.248962 974.220703,933.310974 973.727173,935.401428 
    C973.761536,935.429810 973.820251,935.496704 973.820251,935.496704 
    C973.820251,935.496704 973.951111,935.407288 973.563599,935.141052 
    C972.768311,935.150452 972.360474,935.426147 971.640747,935.813354 
    C970.672729,937.293030 970.016724,938.661255 969.101440,940.386108 
    C968.673950,941.809753 968.505737,942.876831 968.337524,943.943848 
    C968.337585,943.943848 968.471069,943.965027 968.127808,943.634888 
    C967.471191,943.751343 967.157776,944.197876 966.561096,944.830322 
    C965.851868,946.010742 965.425903,947.005371 964.797241,948.267334 
    C964.140259,949.287354 963.686035,950.039978 962.942871,950.929749 
    C958.703796,955.381470 955.243103,951.227661 951.958130,950.072815 
    C942.201965,946.642944 932.667908,939.523987 922.634277,950.114441 
    C919.353333,951.267639 918.191040,953.288025 917.815796,956.538025 
    C917.055847,963.121216 915.514038,969.610046 914.500244,976.169556 
    C913.955933,979.691284 912.089294,980.809998 908.692444,980.770508 
    C897.879761,980.644897 887.058350,980.511902 876.253662,980.832275 
    C871.944580,980.960083 868.911743,979.853210 867.043213,975.526245 
    C866.164062,967.647583 865.255615,960.216492 864.347229,952.785339 
    C860.305603,950.712524 856.263916,948.639771 852.038208,945.997559 
    C851.587585,945.245300 851.320923,945.062439 850.864502,944.583679 
    C849.797607,944.143555 848.920532,943.999329 847.818237,943.757202 
    C846.948303,944.074646 846.303528,944.489990 845.410217,945.115540 
    C845.233704,945.530457 845.305603,945.735168 845.377563,945.939880 
    C845.377563,945.939880 845.475708,945.970581 845.132812,945.602600 
    C842.543335,946.053040 840.296814,946.871399 837.772522,947.617493 
    C836.927002,947.971863 836.359131,948.398560 835.792725,948.846863 
    C835.794128,948.868469 835.787109,948.820923 835.393860,948.832520 
    C832.360901,949.716980 829.495239,950.194946 827.130432,951.548218 
    C822.749573,954.054871 820.632568,952.161743 818.623962,948.410156 
    C817.515930,946.340698 815.618958,944.693665 814.077698,942.856140 
    C814.077698,942.856140 814.029846,942.946533 814.251770,942.572144 
    C814.007629,942.076355 813.541626,941.954895 813.075562,941.833496 
    C813.075562,941.833496 813.076111,941.977844 813.536804,941.682251 
    C813.468323,940.284485 812.939148,939.182251 812.440186,937.771973 
    C811.752991,936.437439 811.035645,935.410828 810.204895,934.085693 
    C809.546021,932.883667 809.000488,931.980164 808.475952,930.761536 
    C807.393433,928.942017 806.289978,927.437561 805.155518,925.606934 
    C804.441711,924.185791 803.758911,923.090820 803.093262,921.642578 
    C802.304504,919.888733 801.498474,918.488220 800.770020,916.725830 
    C801.256592,914.982727 801.665649,913.601624 802.396484,912.054199 
    C802.951416,911.040710 803.184692,910.193420 803.417908,909.346191 
    C803.803162,909.414612 804.188416,909.482971 805.159241,909.852844 
    C805.744812,910.154358 805.509460,910.255615 805.509460,910.255615 
    C805.509460,910.255615 805.585876,909.969604 805.585815,909.969604 
  M918.736816,905.889709 
    C919.177734,904.923584 919.618591,903.957520 920.323669,902.822632 
    C920.323669,902.822632 920.237366,902.521362 920.818726,902.117188 
    C921.727783,899.407471 922.636841,896.697693 923.913574,893.289856 
    C923.890320,892.510193 923.867065,891.730469 924.132629,890.310913 
    C924.021667,888.230591 923.910706,886.150330 923.981812,883.370911 
    C923.849731,882.917786 923.717712,882.464661 923.758789,881.257446 
    C922.558716,878.337097 921.358643,875.416687 920.211548,871.909607 
    C919.978882,871.611816 919.746216,871.313965 919.508667,870.468323 
    C919.021423,869.937073 918.534180,869.405884 918.002808,868.238281 
    C916.548889,866.748962 915.095032,865.259644 913.270142,863.178528 
    C908.827332,860.735413 904.384583,858.292297 899.565430,855.592285 
    C899.245422,855.470520 898.960938,855.527100 898.075684,855.274536 
    C893.796204,855.412903 889.516663,855.551208 884.509216,855.475098 
    C877.638123,857.182556 871.352661,859.833862 866.905029,866.702820 
    C865.243591,869.743408 863.582153,872.783997 861.333374,875.921936 
    C856.436035,886.158203 857.782776,895.816101 864.018799,904.963440 
    C864.018799,904.963440 863.961243,904.964355 864.041931,905.642517 
    C864.693298,906.442932 865.344604,907.243408 866.400452,908.563293 
    C868.424927,910.442932 870.449402,912.322571 872.918457,914.740906 
    C884.819214,922.557190 900.845276,922.280823 910.691162,914.095947 
    C911.015259,913.968689 911.170471,913.731140 911.836304,913.226074 
    C913.947693,910.883606 916.059082,908.541138 918.120483,906.182739 
    C918.120483,906.182739 918.158386,906.206604 918.736816,905.889709 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M925.018188,826.201843 
    C920.574219,825.106995 918.185364,822.706970 917.757507,817.721313 
    C917.222168,811.482727 915.504028,805.354980 914.597046,799.135498 
    C914.047852,795.368835 911.811707,794.034119 908.483826,794.014587 
    C897.199768,793.948425 885.915039,794.001648 874.630615,793.979065 
    C870.341736,793.970459 868.308838,796.306152 867.816589,800.328918 
    C867.092163,806.249207 866.465515,812.183960 865.591064,818.081970 
    C865.340393,819.772278 864.378296,821.357178 863.375183,823.038208 
    C863.693481,819.075073 864.594666,815.086243 865.008850,811.047546 
    C865.510742,806.154053 865.131592,801.121948 866.112305,796.350952 
    C866.478210,794.571045 869.570312,792.135376 871.476440,792.083191 
    C885.066406,791.711121 898.675293,791.719971 912.265625,792.080261 
    C913.910828,792.123901 916.332031,794.728027 916.910889,796.603149 
    C918.152588,800.625549 918.425476,804.947021 918.788574,809.791321 
    C918.610901,811.937073 918.739685,813.437439 918.868408,814.937866 
    C920.396912,817.858215 921.925293,820.778503 923.836853,824.126831 
    C924.486023,825.103821 924.752075,825.652832 925.018188,826.201843 
  z"/>
  <path fill="#C3C3C3" opacity="1.000000" stroke="none" 
    d="
  M867.013916,975.973755 
    C868.911743,979.853210 871.944580,980.960083 876.253662,980.832275 
    C887.058350,980.511902 897.879761,980.644897 908.692444,980.770508 
    C912.089294,980.809998 913.955933,979.691284 914.500244,976.169556 
    C915.514038,969.610046 917.055847,963.121216 917.815796,956.538025 
    C918.191040,953.288025 919.353333,951.267639 922.638245,950.428101 
    C923.009766,951.159424 923.015686,951.577515 923.021606,951.995667 
    C921.701416,954.174744 919.697205,956.209351 919.199951,958.562378 
    C918.079590,963.864624 917.942444,969.369873 916.923035,974.700378 
    C916.442444,977.213318 914.851318,979.513855 912.965820,981.961426 
    C897.758606,982.019531 883.348877,982.026917 868.939209,982.034302 
    C868.939209,982.034302 868.991272,981.999878 868.923706,981.765137 
    C868.549011,981.357300 868.241882,981.184143 867.934753,981.010986 
    C867.934753,981.010986 867.999939,981.014038 867.987793,980.666992 
    C867.655029,978.871277 867.334473,977.422485 867.013916,975.973755 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M1052.927612,939.864807 
    C1049.110718,941.557312 1047.414917,944.419006 1046.942139,948.654175 
    C1045.824707,958.661682 1044.144409,968.605042 1042.878906,978.598022 
    C1042.334839,982.893799 1040.935181,985.919922 1036.252930,987.236816 
    C1033.211426,988.092163 1030.541748,990.269897 1027.347168,991.604858 
    C1026.993286,990.924988 1026.998047,990.495422 1027.002686,990.065918 
    C1029.888428,988.484009 1032.779419,986.911682 1035.657349,985.315552 
    C1036.866089,984.645142 1038.046997,983.924500 1039.650024,982.987366 
    C1040.353027,976.278809 1040.854736,968.973145 1041.953491,961.758423 
    C1042.932007,955.334167 1044.420044,948.972839 1045.988647,942.659668 
    C1046.682007,939.869324 1048.773804,938.362183 1052.356567,939.327026 
    C1052.806763,939.530701 1052.927612,939.864807 1052.927612,939.864807 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1204.809692,1108.899902 
    C1196.206787,1106.675171 1191.372925,1100.052734 1191.684326,1091.511108 
    C1191.872070,1086.367432 1191.922241,1081.179688 1191.458496,1076.063965 
    C1191.115601,1072.282227 1192.205566,1069.733154 1195.313965,1067.695679 
    C1198.729126,1065.457153 1201.991455,1062.985474 1205.634399,1060.561401 
    C1203.088989,1063.319702 1199.978271,1065.927368 1197.461914,1069.018677 
    C1195.878906,1070.963501 1194.823853,1073.542236 1194.204102,1076.005615 
    C1193.653564,1078.193970 1194.362915,1080.678467 1193.939819,1082.923584 
    C1191.868286,1093.912842 1196.254272,1102.097778 1204.809692,1108.899902 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M974.583252,984.080200 
    C970.411133,991.488586 965.769165,998.867188 961.225098,1006.305603 
    C956.666931,1013.766968 952.206360,1021.287964 947.392822,1028.880493 
    C949.720825,1023.086609 952.038147,1017.023804 955.071411,1011.343323 
    C959.773254,1002.538269 964.884155,993.946045 970.059570,985.407837 
    C970.623230,984.477966 972.753052,984.497375 974.583252,984.080200 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M800.947876,862.309753 
    C807.268005,866.857483 813.490540,871.770630 819.698425,876.702087 
    C820.335205,877.207947 821.358765,877.791626 821.400208,878.394409 
    C821.782349,883.948486 822.410339,889.544922 822.017090,895.061279 
    C821.877625,897.017090 819.315918,899.004211 817.511780,900.577698 
    C815.843262,902.032898 813.708984,902.954041 811.490967,903.995483 
    C812.145630,902.756714 812.902527,901.363770 814.065735,900.555969 
    C818.768982,897.289307 820.055420,893.020203 820.270081,887.278137 
    C820.563782,879.419006 814.849609,876.506958 810.522766,872.226624 
    C807.301636,869.040039 804.072021,865.862122 800.947876,862.309753 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M1047.306885,1226.513306 
    C1049.481445,1229.992554 1052.617188,1230.813721 1056.634521,1230.770386 
    C1074.773682,1230.574951 1092.916626,1230.732910 1111.057373,1230.618652 
    C1113.076050,1230.605957 1115.089111,1229.671631 1117.515137,1229.359375 
    C1117.968872,1230.058472 1118.011963,1230.562866 1118.055176,1231.067261 
    C1118.055176,1231.067261 1118.016724,1231.057861 1117.607422,1231.040527 
    C1114.245728,1231.348877 1111.294800,1231.941528 1108.340820,1231.956909 
    C1088.881226,1232.058472 1069.421021,1232.035767 1049.960938,1232.053589 
    C1049.960938,1232.053589 1049.990234,1232.000000 1049.853516,1231.742188 
    C1049.139893,1231.293823 1048.562744,1231.103394 1047.985718,1230.913086 
    C1047.985718,1230.913086 1047.926880,1230.636475 1047.867676,1230.101318 
    C1047.641113,1228.548462 1047.473999,1227.530884 1047.306885,1226.513306 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M974.859619,1073.040771 
    C974.943176,1081.286621 975.106445,1089.533203 975.026489,1097.777466 
    C975.014160,1099.052979 974.214905,1100.732422 973.220825,1101.519043 
    C967.306396,1106.199097 961.227600,1110.671387 954.983826,1115.054932 
    C956.854431,1112.385376 958.641968,1109.513184 961.105286,1107.446167 
    C965.056091,1104.130859 969.454346,1101.348877 972.860168,1098.915527 
    C972.183838,1090.114502 969.818115,1081.895630 974.350586,1073.419434 
    C974.600037,1073.037842 974.859619,1073.040771 974.859619,1073.040771 
  z"/>
  <path fill="#D5D5D5" opacity="1.000000" stroke="none" 
    d="
  M1050.112915,1232.435059 
    C1069.421021,1232.035767 1088.881226,1232.058472 1108.340820,1231.956909 
    C1111.294800,1231.941528 1114.245728,1231.348877 1117.623291,1231.034668 
    C1116.350464,1233.541504 1114.063110,1234.216919 1111.023804,1234.191895 
    C1092.614258,1234.039673 1074.202637,1234.152954 1055.792358,1234.059448 
    C1053.947876,1234.050049 1052.107300,1233.249634 1050.112915,1232.435059 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M988.493591,1183.717041 
    C997.420288,1179.916870 1006.307068,1176.015991 1015.323303,1172.441772 
    C1016.470276,1171.987061 1018.448120,1172.976807 1019.772095,1173.754883 
    C1022.603149,1175.418823 1025.258179,1177.382446 1027.746948,1179.581299 
    C1026.670898,1179.934692 1025.833252,1179.929932 1024.995605,1179.925171 
    C1024.891846,1179.795410 1024.801147,1179.651733 1024.682251,1179.537720 
    C1015.472961,1170.704102 1007.772644,1179.607178 999.492371,1181.686157 
    C997.689331,1182.138794 995.894592,1182.624268 993.275818,1183.087402 
    C991.134888,1183.292358 989.814270,1183.504761 988.493591,1183.717041 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M923.423767,952.003235 
    C923.015686,951.577515 923.009766,951.159424 923.000000,950.427612 
    C932.667908,939.523987 942.201965,946.642944 951.958130,950.072815 
    C955.243103,951.227661 958.703796,955.381470 963.424805,951.011841 
    C964.516663,951.008118 964.837585,951.059387 965.158508,951.110596 
    C963.395691,953.719055 956.406067,955.087891 952.972168,953.568604 
    C947.414795,951.109924 941.857971,948.646240 936.246643,946.315308 
    C933.962769,945.366577 925.347778,949.459961 923.423767,952.003235 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M1150.957520,1172.630493 
    C1161.355469,1176.657471 1171.713257,1180.793457 1182.177734,1184.639282 
    C1185.008911,1185.679688 1188.162720,1185.842041 1191.505371,1186.729736 
    C1189.409668,1187.045166 1186.842041,1187.539917 1184.572266,1186.928467 
    C1179.603271,1185.589966 1174.785645,1183.690186 1169.906128,1182.019653 
    C1164.731201,1179.882935 1159.556274,1177.746216 1154.006348,1175.084717 
    C1152.740112,1173.916870 1151.848877,1173.273682 1150.957520,1172.630493 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M1011.338989,996.246826 
    C1002.294373,992.606445 993.250122,988.965271 984.201599,985.334656 
    C984.079956,985.285828 983.846619,985.318420 983.769470,985.405273 
    C983.673706,985.513062 983.686584,985.717285 983.983032,985.928955 
    C989.317322,985.654297 993.521545,987.100464 998.061096,989.633057 
    C1003.490417,992.662170 1010.072571,993.624939 1016.542358,995.702209 
    C1016.929199,995.921753 1017.050842,996.054138 1016.994141,996.352783 
    C1015.071228,996.516602 1013.205139,996.381714 1011.338989,996.246826 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M1209.981689,1012.478088 
    C1207.941650,1009.673401 1205.707764,1006.539917 1203.800537,1003.218933 
    C1200.668701,997.765198 1197.748535,992.189880 1194.846436,986.467773 
    C1199.973999,993.539917 1205.061157,1000.765625 1209.928101,1008.136963 
    C1210.530762,1009.049866 1209.961182,1010.736816 1209.981689,1012.478088 
  z"/>
  <path fill="#D5D5D5" opacity="1.000000" stroke="none" 
    d="
  M1047.343506,1226.250854 
    C1047.473999,1227.530884 1047.641113,1228.548462 1047.890991,1229.961914 
    C1046.630615,1228.362427 1044.483521,1226.510498 1044.096924,1224.344604 
    C1042.987305,1218.126709 1042.645264,1211.775024 1041.895996,1205.488525 
    C1041.283081,1200.344849 1040.751953,1195.168945 1039.658081,1190.121338 
    C1039.383789,1188.855469 1037.115967,1187.984863 1035.710327,1187.010498 
    C1034.152710,1185.930664 1032.532837,1184.940430 1030.937500,1183.489990 
    C1030.934937,1183.068970 1031.029785,1182.962646 1031.400391,1182.984985 
    C1034.339844,1183.929443 1036.908813,1184.851562 1039.477905,1185.773682 
    C1040.076904,1186.143677 1040.676025,1186.513672 1041.171631,1187.620361 
    C1041.716431,1191.239014 1042.364624,1194.121216 1043.012695,1197.003296 
    C1043.133789,1197.928101 1043.254761,1198.853027 1043.207764,1200.587891 
    C1043.711548,1204.937134 1044.383545,1208.476074 1045.055542,1212.015137 
    C1045.162354,1212.642944 1045.269165,1213.270630 1045.197266,1214.666260 
    C1045.684692,1218.624146 1046.350708,1221.814209 1047.016724,1225.004395 
    C1047.137817,1225.332397 1047.258911,1225.660400 1047.343506,1226.250854 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M814.079956,943.241211 
    C815.618958,944.693665 817.515930,946.340698 818.623962,948.410156 
    C820.632568,952.161743 822.749573,954.054871 827.130432,951.548218 
    C829.495239,950.194946 832.360901,949.716980 835.471191,949.081665 
    C835.972229,949.490417 836.002686,949.661560 836.033081,949.832764 
    C832.642700,951.230225 829.336914,952.928894 825.830566,953.913574 
    C823.682495,954.516724 821.226929,954.024963 818.676514,954.024963 
    C817.149658,950.569153 815.615967,947.097778 814.079956,943.241211 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1195.767456,1181.881836 
    C1199.969727,1174.665527 1204.172119,1167.449219 1208.819580,1160.329346 
    C1209.574341,1160.672729 1209.884033,1160.919678 1210.193848,1161.166626 
    C1207.496948,1165.720825 1204.802979,1170.276733 1202.102295,1174.828613 
    C1200.812866,1177.001587 1199.510864,1179.167114 1197.708862,1181.666992 
    C1196.724609,1181.959229 1196.245972,1181.920532 1195.767456,1181.881836 
  z"/>
  <path fill="#E9E9E9" opacity="1.000000" stroke="none" 
    d="
  M963.935730,898.080078 
    C963.648987,898.469482 963.265503,898.429138 963.055481,898.217102 
    C960.372070,895.508789 960.451172,880.190125 963.525940,877.228271 
    C963.912476,883.998047 963.916077,890.784302 963.935730,898.080078 
  z"/>
  <path fill="#8F8F8F" opacity="1.000000" stroke="none" 
    d="
  M1053.393188,939.956543 
    C1052.927612,939.864807 1052.806763,939.530701 1052.755005,939.360840 
    C1072.547852,939.150879 1092.392334,939.110779 1112.677246,939.288696 
    C1113.117554,939.506775 1113.050293,939.830566 1113.050293,939.830566 
    C1093.319824,939.903137 1073.589233,939.975708 1053.393188,939.956543 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1113.386475,939.951660 
    C1113.050293,939.830566 1113.117554,939.506775 1113.154785,939.346558 
    C1118.420532,938.892212 1122.049438,942.252930 1122.103760,947.485596 
    C1122.141113,951.087585 1122.122070,954.690186 1122.022217,958.630127 
    C1121.160889,955.891357 1119.900879,952.836365 1119.769287,949.733398 
    C1119.575073,945.155701 1117.708618,942.061890 1113.386475,939.951660 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M1195.484741,1182.048340 
    C1196.245972,1181.920532 1196.724609,1181.959229 1197.564575,1181.995605 
    C1196.986938,1187.943359 1189.432251,1191.498047 1183.511963,1188.757935 
    C1179.115967,1186.723267 1174.734497,1184.657715 1170.126343,1182.312744 
    C1174.785645,1183.690186 1179.603271,1185.589966 1184.572266,1186.928467 
    C1186.842041,1187.539917 1189.409668,1187.045166 1191.943726,1186.693848 
    C1193.097534,1184.962036 1194.149780,1183.588501 1195.484741,1182.048340 
  z"/>
  <path fill="#EFEFEF" opacity="1.000000" stroke="none" 
    d="
  M869.109863,982.405884 
    C883.348877,982.026917 897.758606,982.019531 912.596558,982.016357 
    C912.165833,982.692749 911.312195,983.942200 910.446960,983.950378 
    C897.572083,984.072083 884.695496,984.053101 871.819946,983.972229 
    C870.971008,983.966919 870.126892,983.193604 869.109863,982.405884 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M1169.575684,990.091614 
    C1165.118164,992.152466 1160.235962,994.221313 1155.063721,996.138428 
    C1158.078369,990.391174 1163.692383,990.435547 1169.575684,990.091614 
  z"/>
  <path fill="#A2A2A2" opacity="1.000000" stroke="none" 
    d="
  M1125.930420,983.674500 
    C1125.156616,982.431213 1124.067749,980.790344 1123.760132,979.014160 
    C1122.892090,974.003113 1122.344971,968.936462 1121.834473,963.628296 
    C1123.322144,969.981689 1124.647095,976.598389 1125.930420,983.674500 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M941.658386,1127.336182 
    C944.259827,1132.745728 946.658386,1138.492432 949.003662,1144.753906 
    C948.950439,1145.268677 948.949707,1145.533569 948.949707,1145.533569 
    C947.585876,1144.179810 946.066956,1142.947998 944.887878,1141.448853 
    C941.704895,1137.401611 940.061523,1132.896362 941.658386,1127.336182 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M817.785400,825.050110 
    C815.680664,829.998230 813.190613,834.873657 810.391602,839.879883 
    C809.927124,833.736694 813.884766,829.464722 817.785400,825.050110 
  z"/>
  <path fill="#EFEFEF" opacity="1.000000" stroke="none" 
    d="
  M867.043213,975.526245 
    C867.334473,977.422485 867.655029,978.871277 867.973511,980.696350 
    C864.107971,978.240723 865.651123,973.848389 865.175293,970.208252 
    C864.456726,964.710938 864.744263,959.082092 864.475708,953.147217 
    C865.255615,960.216492 866.164062,967.647583 867.043213,975.526245 
  z"/>
  <path fill="#A2A2A2" opacity="1.000000" stroke="none" 
    d="
  M1139.027100,991.631836 
    C1134.654663,989.626221 1130.234863,987.239868 1125.807861,984.505615 
    C1130.980713,985.059998 1136.003906,986.253662 1139.027100,991.631836 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M1224.978760,1127.995483 
    C1224.354004,1126.916260 1223.729248,1125.837158 1222.944580,1124.103882 
    C1222.014648,1122.943481 1221.244629,1122.437378 1220.474609,1121.931274 
    C1219.729980,1121.463989 1218.985352,1120.996704 1218.135254,1119.970215 
    C1217.971924,1118.989380 1217.914062,1118.567627 1217.937500,1118.065918 
    C1218.018799,1117.985840 1218.183472,1117.827515 1218.183472,1117.827515 
    C1223.046387,1119.286865 1225.967163,1122.834595 1227.646729,1127.324951 
    C1228.131714,1128.621582 1227.198975,1130.448364 1226.488770,1132.045532 
    C1226.061279,1132.058960 1225.993530,1131.996338 1225.958740,1131.633301 
    C1225.609009,1130.178589 1225.293823,1129.087036 1224.978760,1127.995483 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M1215.429932,1022.968628 
    C1213.882690,1020.065613 1212.335449,1017.162659 1210.911011,1013.992310 
    C1215.621094,1015.674561 1216.966675,1019.820190 1218.059692,1024.544189 
    C1218.040894,1024.964355 1217.983276,1025.011108 1217.750854,1024.850220 
    C1216.822266,1024.115723 1216.126099,1023.542175 1215.429932,1022.968628 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1224.480713,1038.147461 
    C1222.548096,1034.975220 1220.615479,1031.802856 1218.932861,1028.296387 
    C1219.526245,1027.955688 1219.869629,1027.949219 1220.212891,1027.942627 
    C1222.155029,1031.044067 1224.097046,1034.145508 1225.638672,1037.646606 
    C1224.985718,1038.080078 1224.733154,1038.113770 1224.480713,1038.147461 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M980.768921,920.442505 
    C980.920166,917.921753 981.071411,915.401001 981.076294,912.194885 
    C980.664185,910.637146 980.398499,909.764832 980.132874,908.892456 
    C984.278198,910.798157 985.713318,916.980103 983.020874,921.146545 
    C982.511230,921.935181 982.205322,922.855408 981.416870,923.878418 
    C981.028442,924.041992 980.828003,923.877502 980.859253,923.449463 
    C980.849976,922.161804 980.809448,921.302124 980.768921,920.442505 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M939.965942,829.563965 
    C939.404663,829.828125 938.843445,830.092285 937.547241,830.232910 
    C935.525391,829.759644 934.238464,829.409973 933.012634,828.991638 
    C933.073730,828.922974 933.199158,828.788574 933.199158,828.788574 
    C937.887390,827.266479 942.571411,825.731079 947.269165,824.238953 
    C947.868774,824.048523 948.540344,824.084534 949.565552,824.315918 
    C949.915771,824.910522 949.914429,825.205139 949.948547,825.499817 
    C949.407349,825.800598 948.866089,826.101379 947.632812,826.275574 
    C945.962585,826.758728 944.984497,827.368408 944.006409,827.978088 
    C943.814636,828.283752 943.538391,828.440247 942.593628,828.304688 
    C941.328369,828.629272 940.647156,829.096680 939.965942,829.563965 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M845.324951,830.291321 
    C845.324951,830.291321 844.853149,830.396057 844.853149,830.396057 
    C844.853149,830.396057 844.381409,830.290833 844.015015,829.811890 
    C842.522888,829.012939 841.397156,828.692871 840.271423,828.372803 
    C840.271423,828.372803 839.819153,828.487793 839.819153,828.487793 
    C839.819153,828.487793 839.366028,828.376282 839.020874,827.880371 
    C837.539978,827.049438 836.404236,826.714417 835.268555,826.379333 
    C835.268555,826.379333 834.806763,826.484924 834.806763,826.484924 
    C834.806763,826.484924 834.349060,826.362671 834.094177,825.944702 
    C833.577820,825.064026 833.316345,824.601318 833.054932,824.138611 
    C837.380249,825.380859 841.685486,826.701782 846.043457,827.816589 
    C847.315186,828.141907 848.737244,827.879761 850.523193,827.920105 
    C850.956055,827.953247 851.119019,828.135742 850.988892,828.515869 
    C849.014099,829.361023 847.169556,829.826172 845.324951,830.291321 
  z"/>
  <path fill="#D5D5D5" opacity="1.000000" stroke="none" 
    d="
  M1118.440186,1231.053345 
    C1118.011963,1230.562866 1117.968872,1230.058472 1117.908813,1229.174561 
    C1118.555298,1226.125488 1119.218628,1223.455933 1120.252930,1220.390991 
    C1121.038208,1220.009155 1121.452759,1220.022705 1121.867188,1220.036377 
    C1122.465210,1224.149658 1121.998657,1227.968750 1118.440186,1231.053345 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1220.049927,1049.005371 
    C1221.602661,1046.222778 1223.155396,1043.440063 1225.138916,1040.323975 
    C1226.005493,1039.987549 1226.441528,1039.984497 1226.877441,1039.981567 
    C1226.904297,1040.741699 1226.931152,1041.501953 1226.648682,1042.669189 
    C1226.191528,1043.703491 1226.043823,1044.330688 1225.895996,1044.957886 
    C1225.900513,1045.134888 1225.904907,1045.311890 1225.567383,1045.809082 
    C1224.842896,1046.851196 1224.460449,1047.573486 1224.078003,1048.295776 
    C1224.010498,1048.554077 1223.868652,1048.761719 1223.072266,1048.961914 
    C1221.677979,1049.005371 1220.863892,1049.005371 1220.049927,1049.005371 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M970.037720,1183.769775 
    C970.958618,1183.686523 971.814819,1184.046631 972.901917,1185.128662 
    C976.365356,1186.504028 979.597839,1187.157227 982.932373,1187.918213 
    C983.034485,1188.025879 983.240723,1188.239502 983.240723,1188.239502 
    C979.056824,1189.270752 974.792725,1190.692017 971.092163,1187.140869 
    C970.410400,1186.486694 970.330566,1185.205078 970.037720,1183.769775 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M949.102295,1050.960693 
    C951.012268,1052.309082 952.922302,1053.657349 955.037354,1055.656616 
    C955.432129,1057.256592 955.621887,1058.205566 955.811584,1059.154541 
    C952.606873,1056.649536 949.402222,1054.144653 946.409241,1051.327881 
    C947.448059,1050.997681 948.275208,1050.979126 949.102295,1050.960693 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M802.110596,855.248840 
    C801.770935,857.224854 801.431274,859.200806 801.082764,861.570251 
    C797.688599,862.744385 797.428223,860.482117 798.073792,858.343567 
    C798.655579,856.416443 800.087402,854.746033 801.566895,853.319092 
    C802.029846,854.200134 802.070190,854.724487 802.110596,855.248840 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M972.227295,839.958801 
    C971.111755,838.229675 969.996155,836.500610 969.137695,834.256775 
    C969.644714,833.400635 969.894714,833.059265 970.144653,832.717896 
    C971.716919,835.196411 973.289246,837.674988 974.961548,840.548584 
    C975.061523,840.943665 974.879395,841.113525 974.593750,841.058960 
    C973.614563,840.655884 972.920898,840.307312 972.227295,839.958801 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M1121.611328,1211.041748 
    C1122.008545,1208.246216 1122.405762,1205.450806 1123.222412,1202.314453 
    C1123.641724,1201.973633 1124.089111,1202.056152 1124.089111,1202.056152 
    C1124.062866,1203.766846 1124.036743,1205.477539 1123.734131,1207.787476 
    C1122.842285,1209.271729 1122.226807,1210.156738 1121.611328,1211.041748 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M1138.547729,1179.719971 
    C1141.447266,1177.725586 1144.346680,1175.731079 1147.517822,1174.049072 
    C1147.495483,1175.246460 1147.201294,1176.131226 1146.907104,1177.016113 
    C1146.907104,1177.016113 1146.619873,1177.079590 1146.123657,1177.068726 
    C1145.086914,1177.678711 1144.546265,1178.299561 1144.005737,1178.920410 
    C1144.005737,1178.920410 1143.656616,1179.021973 1143.064453,1179.016968 
    C1141.164185,1179.247925 1139.855957,1179.483887 1138.547729,1179.719971 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M952.647461,1116.385620 
    C950.968994,1117.920654 949.123291,1119.632080 947.110352,1121.192993 
    C948.788818,1119.548950 950.634521,1118.055542 952.647461,1116.385620 
  z"/>
  <path fill="#C0C0C0" opacity="1.000000" stroke="none" 
    d="
  M1212.938110,1152.840454 
    C1213.518066,1151.729492 1214.098145,1150.618530 1215.141602,1149.116943 
    C1216.447144,1148.182129 1217.289551,1147.638062 1218.131836,1147.093994 
    C1216.407593,1150.416626 1214.683228,1153.739258 1212.523193,1157.071289 
    C1212.087402,1157.080688 1211.966553,1156.974121 1212.009155,1156.619385 
    C1212.347168,1155.123291 1212.642700,1153.981934 1212.938110,1152.840454 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M980.745972,854.957886 
    C980.105896,854.043335 979.465820,853.128723 978.853394,851.487732 
    C978.566467,849.523682 978.251953,848.286072 978.012512,846.984375 
    C978.087585,846.920288 978.238708,846.793396 978.238708,846.793396 
    C979.865356,849.214050 981.492004,851.634705 983.090454,854.500122 
    C983.062256,854.944946 982.882202,855.114868 982.617188,855.087036 
    C981.816772,855.025452 981.281372,854.991638 980.745972,854.957886 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M1124.454834,1201.905762 
    C1124.089111,1202.056152 1123.641724,1201.973633 1123.416504,1202.004639 
    C1123.250854,1200.639771 1123.310303,1199.243774 1123.817139,1197.345947 
    C1124.793091,1195.600708 1125.321899,1194.357300 1125.850586,1193.113892 
    C1125.507202,1195.994385 1125.163818,1198.875000 1124.454834,1201.905762 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M1215.227783,1117.949097 
    C1213.967651,1117.119141 1212.707397,1116.289185 1211.254761,1114.926270 
    C1211.077515,1113.994141 1211.092651,1113.594849 1211.107910,1113.195679 
    C1213.425049,1114.501831 1215.742065,1115.807861 1218.121338,1117.470703 
    C1218.183472,1117.827515 1218.018799,1117.985840 1217.612549,1118.037109 
    C1216.546875,1118.041992 1215.887329,1117.995483 1215.227783,1117.949097 
  z"/>
  <path fill="#CACACA" opacity="1.000000" stroke="none" 
    d="
  M988.164062,1183.694092 
    C989.814270,1183.504761 991.134888,1183.292358 992.868042,1183.072876 
    C990.544861,1184.419189 987.809143,1185.772461 984.391968,1187.102783 
    C983.522095,1187.068970 983.333801,1187.057983 983.280212,1186.778809 
    C984.286682,1185.799561 985.158508,1185.088623 986.030396,1184.377808 
    C986.631775,1184.142334 987.233154,1183.906860 988.164062,1183.694092 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M802.074707,912.220459 
    C801.665649,913.601624 801.256592,914.982727 800.567261,916.898621 
    C800.193604,917.954224 800.100098,918.475098 799.983521,919.017090 
    C799.960388,919.038147 799.914734,919.080933 799.914734,919.080933 
    C795.325439,915.429932 799.767029,913.116272 801.555908,910.643311 
    C801.961853,911.359253 802.018250,911.789856 802.074707,912.220459 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M836.430786,949.910156 
    C836.002686,949.661560 835.972229,949.490417 835.864380,949.070068 
    C835.787109,948.820923 835.794128,948.868469 836.075195,948.898621 
    C836.920959,948.515747 837.485596,948.102783 838.050232,947.689819 
    C840.296814,946.871399 842.543335,946.053040 845.143555,945.552246 
    C842.607666,947.242493 839.718079,948.615051 836.430786,949.910156 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M925.260742,826.440491 
    C924.752075,825.652832 924.486023,825.103821 924.133606,824.341309 
    C926.626404,825.162109 929.205566,826.196411 931.921326,827.590393 
    C932.057861,827.950134 931.916077,828.115417 931.484558,828.099792 
    C930.188538,828.127136 929.324097,828.170105 928.459595,828.213013 
    C927.474182,827.701782 926.488770,827.190491 925.260742,826.440491 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1208.857056,1057.831299 
    C1210.616943,1056.401245 1212.376709,1054.971191 1214.167969,1054.346558 
    C1214.160278,1055.549561 1214.121338,1055.947266 1214.082275,1056.344971 
    C1212.970093,1057.253784 1211.857910,1058.162720 1210.328125,1058.904175 
    C1209.748779,1058.451294 1209.505005,1058.290894 1209.099121,1058.149170 
    C1209.019165,1058.042603 1208.857056,1057.831177 1208.857056,1057.831299 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M1125.909180,1192.689087 
    C1125.321899,1194.357300 1124.793091,1195.600708 1123.988770,1196.962158 
    C1124.183594,1194.273438 1124.654297,1191.466675 1125.501709,1188.753418 
    C1125.908081,1189.985840 1125.937866,1191.125122 1125.909180,1192.689087 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M980.108521,908.905884 
    C980.398499,909.764832 980.664185,910.637146 980.922485,911.852173 
    C978.911682,910.700256 976.908264,909.205750 975.185059,907.352539 
    C975.722046,906.979187 975.978821,906.964539 976.235657,906.949890 
    C976.955505,907.219727 977.675354,907.489624 978.775024,908.110291 
    C979.448914,908.623657 979.742920,908.786255 980.036926,908.948853 
    C980.036926,908.948853 980.084167,908.919373 980.108521,908.905884 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M950.302063,825.479065 
    C949.914429,825.205139 949.915771,824.910522 949.957031,824.395691 
    C952.121216,823.601379 954.280884,823.027527 956.743591,822.206177 
    C954.916321,823.125244 952.785950,824.291748 950.302063,825.479065 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M802.410400,855.101135 
    C802.070190,854.724487 802.029846,854.200134 801.956177,853.281128 
    C801.922791,852.886536 801.974792,852.933167 802.243164,852.765259 
    C802.984680,851.288086 803.457703,849.978760 803.930725,848.669434 
    C803.930725,848.669434 803.926025,848.365845 804.245117,848.214600 
    C805.138489,848.029236 805.712830,847.995178 806.287109,847.961121 
    C805.094849,850.291870 803.902588,852.622620 802.410400,855.101135 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M803.076050,921.995850 
    C803.758911,923.090820 804.441711,924.185791 804.876038,925.778931 
    C804.384155,926.640076 804.140808,927.003113 803.897461,927.366089 
    C802.575989,924.866943 801.254456,922.367737 799.923828,919.474731 
    C799.914734,919.080933 799.960388,919.038147 800.241821,919.192688 
    C801.374146,920.230103 802.225098,921.112976 803.076050,921.995850 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M955.854614,1059.142822 
    C955.621887,1058.205566 955.432129,1057.256592 955.184875,1055.943359 
    C957.340271,1057.181274 959.553284,1058.783691 961.546631,1060.658325 
    C960.105652,1060.657959 958.884338,1060.385376 957.662964,1060.112793 
    C957.662964,1060.112793 957.346008,1060.107666 957.077148,1059.840576 
    C956.522766,1059.402344 956.237244,1059.231323 955.951721,1059.060181 
    C955.951721,1059.060181 955.897583,1059.131104 955.854614,1059.142822 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M951.238464,1148.069214 
    C951.867859,1148.986328 952.497314,1149.903320 953.106079,1151.571411 
    C953.112183,1153.160034 953.139038,1153.997803 953.067871,1154.928833 
    C952.969910,1155.022217 952.771118,1155.205811 952.771118,1155.205811 
    C951.503479,1152.727417 950.235840,1150.249146 949.256958,1147.484985 
    C950.109924,1147.489258 950.674194,1147.779297 951.238464,1148.069214 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M975.941711,928.864258 
    C976.249451,928.067444 976.557190,927.270569 977.387390,926.229492 
    C978.580627,925.631653 979.251343,925.278076 979.993347,924.992554 
    C980.064575,925.060669 980.206726,925.197021 980.206726,925.197021 
    C979.040039,927.450195 977.873291,929.703430 976.348816,931.720703 
    C975.974609,930.611328 975.958130,929.737793 975.941711,928.864258 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M1130.983154,1183.850708 
    C1131.398193,1183.550293 1131.813110,1183.249878 1132.935059,1182.958496 
    C1134.551147,1183.005859 1135.460327,1183.044067 1136.369507,1183.082275 
    C1133.764160,1184.392334 1131.158691,1185.702271 1128.137573,1186.934570 
    C1127.539429,1186.692261 1127.357056,1186.527344 1127.694336,1186.115479 
    C1129.137207,1185.195923 1130.060181,1184.523315 1130.983154,1183.850708 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M832.667603,824.081360 
    C833.316345,824.601318 833.577820,825.064026 833.924438,825.779663 
    C831.737244,825.217896 829.464966,824.403320 827.053833,823.291260 
    C828.703430,823.337280 830.491882,823.680664 832.667603,824.081360 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M857.026733,826.696045 
    C856.435425,827.220886 855.844177,827.745789 854.511047,828.195190 
    C852.885803,828.125061 852.002441,828.130371 851.119019,828.135742 
    C851.119019,828.135742 850.956055,827.953247 850.874146,827.862061 
    C853.278076,826.509155 855.763855,825.247437 858.506287,824.282898 
    C858.184143,825.285400 857.605408,825.990723 857.026733,826.696045 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1218.115723,1147.073730 
    C1217.289551,1147.638062 1216.447144,1148.182129 1215.331787,1148.859619 
    C1216.107910,1146.985474 1217.157104,1144.978027 1218.666382,1143.097656 
    C1219.475464,1143.522583 1219.824707,1143.820435 1220.173828,1144.118164 
    C1219.817749,1144.582153 1219.461670,1145.046021 1218.795410,1145.895020 
    C1218.251831,1146.490967 1218.106323,1146.750977 1218.048584,1147.060303 
    C1218.048584,1147.060303 1218.099609,1147.053467 1218.115723,1147.073730 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M1222.009033,1137.019775 
    C1222.245605,1136.490967 1222.482056,1135.962158 1223.207275,1135.114380 
    C1224.461792,1133.862427 1225.227661,1132.929321 1225.993530,1131.996338 
    C1225.993530,1131.996338 1226.061279,1132.058960 1226.095337,1132.090698 
    C1225.017456,1134.763916 1223.905640,1137.405396 1222.371094,1139.700195 
    C1221.968506,1138.575562 1221.988770,1137.797607 1222.009033,1137.019775 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M957.767029,1060.461182 
    C958.884338,1060.385376 960.105652,1060.657959 961.704956,1060.951660 
    C963.034058,1062.055664 963.985291,1063.138794 964.624207,1064.510132 
    C962.164978,1063.468872 960.018066,1062.139160 957.767029,1060.461182 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M957.292175,1158.914185 
    C958.224365,1161.137085 959.156555,1163.359863 959.616882,1165.091797 
    C958.470276,1163.743164 957.795593,1162.885620 957.120850,1162.028076 
    C956.743835,1161.268433 956.366882,1160.508667 956.280518,1159.370605 
    C956.811523,1158.966309 957.051880,1158.940186 957.292175,1158.914185 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M1121.468262,1211.414307 
    C1122.226807,1210.156738 1122.842285,1209.271729 1123.685791,1208.212891 
    C1123.540894,1210.281494 1123.167847,1212.523926 1122.231323,1214.852295 
    C1121.667847,1214.938354 1121.260498,1214.966064 1121.260498,1214.966064 
    C1121.282104,1213.906372 1121.303711,1212.846680 1121.468262,1211.414307 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M808.455017,931.076599 
    C809.000488,931.980164 809.546021,932.883667 810.111084,934.573303 
    C810.063354,936.017700 809.995911,936.675964 809.928528,937.334290 
    C808.604248,935.447327 807.280029,933.560303 806.278931,931.291382 
    C807.219788,930.965088 807.837402,931.020874 808.455017,931.076599 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M1147.279053,1176.938965 
    C1147.201294,1176.131226 1147.495483,1175.246460 1147.881104,1174.018555 
    C1148.793213,1173.222900 1149.614136,1172.770142 1150.696289,1172.473877 
    C1151.848877,1173.273682 1152.740112,1173.916870 1153.809814,1174.791260 
    C1151.875732,1175.635498 1149.763428,1176.248657 1147.279053,1176.938965 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M966.027649,1173.925415 
    C967.132385,1175.666626 968.237061,1177.407837 969.041382,1179.447998 
    C967.818237,1179.145508 966.895508,1178.544189 965.972778,1177.942993 
    C965.972778,1177.942993 965.905273,1177.644409 965.946899,1177.064697 
    C966.001587,1175.631714 966.014648,1174.778564 966.027649,1173.925415 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M965.565552,828.672546 
    C964.225220,826.815796 962.884888,824.958984 961.286255,822.807556 
    C961.028015,822.512878 961.025452,822.475098 961.025452,822.475098 
    C962.008118,822.703674 962.990845,822.932251 964.148376,823.790833 
    C964.889587,824.624817 965.455933,824.828796 966.022278,825.032776 
    C966.022278,825.032776 966.102295,825.354797 965.965881,826.265869 
    C965.741455,827.675476 965.653503,828.174011 965.565552,828.672546 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M977.625977,867.539062 
    C978.475586,866.310059 979.441528,864.822205 980.713379,863.614746 
    C981.002625,864.602600 980.985962,865.310120 980.969299,866.017578 
    C979.893677,866.438477 978.818054,866.859314 977.625977,867.539062 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M981.333618,865.889709 
    C980.985962,865.310120 981.002625,864.602600 981.029297,863.541382 
    C981.039307,863.187622 981.036438,863.064392 981.452515,862.957886 
    C982.138306,861.984863 982.408081,861.118347 982.677795,860.251831 
    C982.592163,859.873779 982.506531,859.495667 982.631165,858.491882 
    C982.855042,856.949036 982.868652,856.031982 982.882202,855.114868 
    C982.882202,855.114868 983.062256,854.944946 983.153076,854.860352 
    C984.710754,858.716675 985.075684,862.502563 981.333618,865.889709 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M808.475952,930.761536 
    C807.837402,931.020874 807.219788,930.965088 806.291382,930.909851 
    C805.980652,930.910339 805.922791,930.647034 805.949341,930.139282 
    C805.307800,929.048828 804.639648,928.466125 803.971497,927.883362 
    C803.971497,927.883362 803.902161,927.628540 803.899780,927.497314 
    C804.140808,927.003113 804.384155,926.640076 804.906982,926.105103 
    C806.289978,927.437561 807.393433,928.942017 808.475952,930.761536 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M1138.263184,1179.717773 
    C1139.855957,1179.483887 1141.164185,1179.247925 1142.883057,1179.026367 
    C1141.407227,1180.381592 1139.520874,1181.722534 1137.267944,1182.705688 
    C1136.952393,1181.675781 1137.003418,1181.003540 1137.054443,1180.331299 
    C1137.362427,1180.126099 1137.670410,1179.920898 1138.263184,1179.717773 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M961.051147,1165.376221 
    C962.238892,1167.096802 963.426758,1168.817261 964.733887,1170.891357 
    C964.853149,1171.244995 964.414001,1171.074707 963.936951,1170.881470 
    C962.679504,1170.132690 961.899170,1169.577148 961.118774,1169.021606 
    C961.118774,1169.021606 961.036621,1168.560669 961.014526,1167.876465 
    C961.011963,1166.587036 961.031555,1165.981567 961.051147,1165.376221 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M857.369995,826.714355 
    C857.605408,825.990723 858.184143,825.285400 858.873108,824.328186 
    C860.123535,823.783447 861.263733,823.490662 862.745972,823.101624 
    C861.296448,824.247864 859.504883,825.490295 857.369995,826.714355 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M1026.520752,992.240417 
    C1024.904297,993.444885 1023.287720,994.649292 1021.376404,995.586670 
    C1021.705383,994.457153 1022.329163,993.594788 1022.952881,992.732422 
    C1022.952881,992.732361 1022.944275,992.371582 1023.419556,992.202637 
    C1024.770142,992.102539 1025.645508,992.171448 1026.520752,992.240417 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M975.608948,929.025574 
    C975.958130,929.737793 975.974609,930.611328 976.053040,931.919312 
    C976.114990,932.353699 976.104004,932.643127 975.622925,932.905273 
    C974.658813,933.902649 974.175842,934.637878 973.692871,935.373047 
    C974.220703,933.310974 974.748474,931.248962 975.608948,929.025574 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M970.119995,832.543762 
    C969.894714,833.059265 969.644714,833.400635 969.119629,833.903320 
    C967.838806,832.594543 966.833130,831.124573 966.100952,829.427856 
    C967.588928,830.142944 968.803528,831.084778 970.018066,832.026611 
    C970.018066,832.026611 970.095337,832.369629 970.119995,832.543762 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M957.266602,1158.541748 
    C957.051880,1158.940186 956.811523,1158.966309 956.213989,1159.056763 
    C954.866760,1158.044800 953.876648,1156.968384 952.828857,1155.548828 
    C952.771118,1155.205811 952.969910,1155.022217 953.318237,1154.960205 
    C954.178528,1154.957397 954.690491,1155.016479 955.202393,1155.075684 
    C955.881958,1156.106934 956.561523,1157.138062 957.266602,1158.541748 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M975.575256,845.969666 
    C975.325928,845.682861 975.076660,845.396118 974.875244,844.387634 
    C974.908569,842.815125 974.893982,841.964355 974.879395,841.113525 
    C974.879395,841.113525 975.061523,840.943665 975.152832,840.858643 
    C976.212524,842.546509 977.180786,844.319519 978.193848,846.442932 
    C978.238708,846.793396 978.087585,846.920288 977.776733,846.870483 
    C976.835693,846.537048 976.205444,846.253357 975.575256,845.969666 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M826.921143,822.756104 
    C825.320679,822.987488 823.636841,822.883667 821.527832,822.768677 
    C823.014282,822.645386 824.926025,822.533203 826.921143,822.756104 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M948.957275,1050.670044 
    C948.275208,1050.979126 947.448059,1050.997681 946.205933,1051.034668 
    C945.497498,1050.992554 945.265991,1050.838867 945.043213,1049.996704 
    C945.015381,1048.872437 945.040588,1048.343506 945.065796,1047.814697 
    C946.314636,1048.669556 947.563477,1049.524536 948.957275,1050.670044 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M970.046631,831.668457 
    C968.803528,831.084778 967.588928,830.142944 966.044922,829.080139 
    C965.715515,828.959167 965.564636,828.782227 965.565063,828.727417 
    C965.653503,828.174011 965.741455,827.675476 965.977051,826.431396 
    C967.441467,827.560669 968.758301,829.435425 970.046631,831.668457 
  z"/>
  <path fill="#D5D5D5" opacity="1.000000" stroke="none" 
    d="
  M1025.091431,1180.269287 
    C1025.833252,1179.929932 1026.670898,1179.934692 1027.922119,1179.872803 
    C1028.730225,1179.893677 1029.124756,1179.981323 1029.746460,1180.573975 
    C1030.325562,1181.706909 1030.677612,1182.334717 1031.029785,1182.962646 
    C1031.029785,1182.962646 1030.934937,1183.068970 1030.887207,1183.122070 
    C1028.955444,1182.321289 1027.071411,1181.467285 1025.091431,1180.269287 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M1136.726318,1180.338379 
    C1137.003418,1181.003540 1136.952393,1181.675781 1136.906128,1182.685791 
    C1136.910889,1183.023804 1136.644165,1183.095947 1136.506836,1183.089111 
    C1135.460327,1183.044067 1134.551147,1183.005859 1133.189453,1182.920776 
    C1133.957520,1182.031128 1135.177979,1181.188232 1136.726318,1180.338379 
  z"/>
  <path fill="#C0C0C0" opacity="1.000000" stroke="none" 
    d="
  M1210.563843,1161.118408 
    C1209.884033,1160.919678 1209.574341,1160.672729 1209.111084,1160.169556 
    C1209.102173,1159.368530 1209.246826,1158.823853 1209.910400,1158.038574 
    C1210.941772,1157.523438 1211.454224,1157.248779 1211.966553,1156.974121 
    C1211.966553,1156.974121 1212.087402,1157.080688 1212.148926,1157.133667 
    C1211.784912,1158.481201 1211.359375,1159.775757 1210.563843,1161.118408 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1221.703125,1137.077881 
    C1221.988770,1137.797607 1221.968506,1138.575562 1221.982666,1139.742188 
    C1222.016968,1140.130981 1221.933350,1140.568848 1221.614258,1140.786377 
    C1220.713257,1141.007812 1220.131104,1141.011719 1219.549072,1141.015625 
    C1220.165161,1139.722412 1220.781128,1138.429077 1221.703125,1137.077881 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M965.948364,1178.320923 
    C966.895508,1178.544189 967.818237,1179.145508 969.064819,1179.814209 
    C969.919434,1180.911743 970.450195,1181.941650 970.593628,1183.231934 
    C968.778809,1181.894287 967.351379,1180.296631 965.948364,1178.320923 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M969.360718,940.029419 
    C970.016724,938.661255 970.672729,937.293030 971.657654,936.273926 
    C972.018005,937.544739 972.049500,938.466431 972.080933,939.388123 
    C972.080933,939.388123 972.102600,939.658203 971.734131,939.785645 
    C970.697327,939.951904 970.029053,939.990662 969.360718,940.029419 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M967.935669,1065.559204 
    C969.247742,1066.481079 970.559814,1067.402954 971.642212,1068.648926 
    C970.846313,1069.012939 970.279968,1069.052734 969.713684,1069.092529 
    C969.713684,1069.092529 969.365173,1069.085205 969.160583,1068.686768 
    C968.615845,1067.378540 968.275757,1066.468872 967.935669,1065.559204 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M1121.085815,1215.309692 
    C1121.260498,1214.966064 1121.667847,1214.938354 1121.866455,1214.987671 
    C1122.036377,1216.426758 1122.007690,1217.816650 1121.923096,1219.621338 
    C1121.452759,1220.022705 1121.038208,1220.009155 1120.312256,1219.997803 
    C1120.304199,1218.551147 1120.607666,1217.102173 1121.085815,1215.309692 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M969.101440,940.386108 
    C970.029053,939.990662 970.697327,939.951904 971.700684,939.916992 
    C971.062317,941.257385 970.088806,942.593933 968.726440,943.937134 
    C968.505737,942.876831 968.673950,941.809753 969.101440,940.386108 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M812.410034,938.080017 
    C812.939148,939.182251 813.468323,940.284485 813.608459,941.673462 
    C812.122864,940.849304 811.026306,939.738281 810.261719,938.267578 
    C811.199158,937.965210 811.804626,938.022583 812.410034,938.080017 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M1022.593506,992.797241 
    C1022.329163,993.594788 1021.705383,994.457153 1021.039612,995.642456 
    C1020.997620,995.965271 1020.835205,996.247742 1020.243408,996.161377 
    C1018.784729,996.067993 1017.917786,996.061096 1017.050842,996.054199 
    C1017.050842,996.054138 1016.929199,995.921753 1016.868408,995.855347 
    C1018.616394,994.813293 1020.425232,993.837646 1022.593506,992.797241 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M808.888550,842.987305 
    C808.505554,843.925110 808.122498,844.862976 807.177979,845.768188 
    C806.383301,845.392700 806.150146,845.049866 805.916992,844.706970 
    C806.244751,844.285583 806.572510,843.864197 807.311768,843.210999 
    C808.111755,842.981934 808.500122,842.984619 808.888550,842.987305 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M805.543518,844.795044 
    C806.150146,845.049866 806.383301,845.392700 806.884338,845.895874 
    C807.036499,846.521545 806.920837,846.986877 806.546143,847.706665 
    C805.712830,847.995178 805.138489,848.029236 804.276001,848.065979 
    C804.381897,847.006836 804.776001,845.945007 805.543518,844.795044 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M812.440186,937.771973 
    C811.804626,938.022583 811.199158,937.965210 810.289185,937.910278 
    C809.984558,937.912720 809.925110,937.625610 809.926819,937.479980 
    C809.995911,936.675964 810.063354,936.017700 810.224487,934.871826 
    C811.035645,935.410828 811.752991,936.437439 812.440186,937.771973 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M965.957886,1173.633789 
    C966.014648,1174.778564 966.001587,1175.631714 965.945312,1176.911621 
    C965.391907,1175.857178 964.881836,1174.375854 964.724854,1172.683105 
    C965.347961,1172.761841 965.617981,1173.052002 965.957886,1173.633789 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1210.817871,1113.239502 
    C1211.092651,1113.594849 1211.077515,1113.994141 1211.033447,1114.691650 
    C1209.964233,1114.173340 1208.923828,1113.356812 1208.062134,1112.365112 
    C1209.003296,1112.554443 1209.765747,1112.918945 1210.817871,1113.239502 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M848.043396,943.855103 
    C848.920532,943.999329 849.797607,944.143555 850.828369,944.811157 
    C850.981934,945.334595 850.943542,945.793762 850.943542,945.793701 
    C849.400146,945.856262 847.856812,945.918823 845.845459,945.960632 
    C845.305603,945.735168 845.233704,945.530457 845.763428,945.138733 
    C846.924561,944.586182 847.483948,944.220642 848.043396,943.855103 
  z"/>
  <path fill="#C0C0C0" opacity="1.000000" stroke="none" 
    d="
  M1219.309692,1141.218628 
    C1220.131104,1141.011719 1220.713257,1141.007812 1221.584961,1141.007202 
    C1221.472168,1141.926514 1221.069702,1142.842285 1220.420410,1143.938232 
    C1219.824707,1143.820435 1219.475464,1143.522583 1218.954102,1142.923096 
    C1218.878052,1142.221558 1218.974121,1141.821655 1219.309692,1141.218628 
  z"/>
  <path fill="#A2A2A2" opacity="1.000000" stroke="none" 
    d="
  M1141.681396,992.694458 
    C1141.849976,992.957092 1141.964722,993.225525 1142.079590,993.493896 
    C1141.716187,993.192444 1141.352905,992.890991 1141.006348,992.435547 
    C1141.210205,992.407593 1141.411743,992.547119 1141.681396,992.694458 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M951.289917,1147.793457 
    C950.674194,1147.779297 950.109924,1147.489258 949.321594,1147.115601 
    C949.070923,1146.783325 949.044434,1146.534790 948.983765,1145.909912 
    C948.949707,1145.533569 948.950439,1145.268677 948.973633,1145.138428 
    C949.778381,1145.844604 950.559875,1146.681274 951.289917,1147.793457 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M803.550964,848.778442 
    C803.457703,849.978760 802.984680,851.288086 802.220215,852.791565 
    C802.342957,851.619568 802.757080,850.253479 803.550964,848.778442 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M960.900513,822.114685 
    C961.025452,822.475098 961.028015,822.512878 961.047241,822.516113 
    C959.902588,822.493652 958.738708,822.467896 957.271545,822.262329 
    C958.237427,821.973145 959.506531,821.863708 960.900513,822.114685 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M967.657593,1065.312500 
    C968.275757,1066.468872 968.615845,1067.378540 968.990601,1068.648682 
    C968.015808,1068.150635 967.006409,1067.292358 966.079102,1066.069336 
    C966.567322,1065.491821 966.973389,1065.278931 967.657593,1065.312500 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M969.809875,1069.467773 
    C970.279968,1069.052734 970.846313,1069.012939 971.836182,1068.934082 
    C972.591492,1069.072998 972.923279,1069.251221 973.397217,1069.686035 
    C972.328308,1069.909546 971.117188,1069.876343 969.809875,1069.467773 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M942.499390,1124.961792 
    C942.744385,1124.956787 943.055542,1125.007568 943.366577,1125.058105 
    C943.133667,1125.338989 942.900757,1125.619751 942.599976,1125.710571 
    C942.534363,1125.366089 942.545532,1125.198364 942.499390,1124.961792 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M1026.683105,992.264648 
    C1025.645508,992.171448 1024.770142,992.102539 1023.455261,992.025757 
    C1024.113892,991.333313 1025.212158,990.648743 1026.656494,990.015015 
    C1026.998047,990.495422 1026.993286,990.924988 1026.994385,991.676758 
    C1027.000000,991.999084 1026.845581,992.288940 1026.683105,992.264648 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M972.491943,939.241333 
    C972.049500,938.466431 972.018005,937.544739 971.969604,936.162476 
    C972.360474,935.426147 972.768311,935.150452 973.512634,935.080383 
    C973.533752,936.555481 973.218384,937.824951 972.491943,939.241333 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M1220.136719,1027.624512 
    C1219.869629,1027.949219 1219.526245,1027.955688 1218.926270,1027.960327 
    C1218.499390,1027.857666 1218.329102,1027.756836 1218.083252,1027.029053 
    C1217.999756,1025.938477 1217.991455,1025.474731 1217.983276,1025.011108 
    C1217.983276,1025.011108 1218.040894,1024.964355 1218.070068,1024.939453 
    C1218.753052,1025.711792 1219.406738,1026.509033 1220.136719,1027.624512 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M802.396484,912.054199 
    C802.018250,911.789856 801.961853,911.359253 801.888977,910.603516 
    C802.321838,910.072083 802.771118,909.865784 803.319153,909.502808 
    C803.184692,910.193420 802.951416,911.040710 802.396484,912.054199 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M976.120972,906.591797 
    C975.978821,906.964539 975.722046,906.979187 975.080688,907.024536 
    C973.775757,906.275085 972.855347,905.494873 972.145874,904.380615 
    C973.573364,904.775574 974.789856,905.504700 976.120972,906.591797 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M966.844360,944.644409 
    C967.157776,944.197876 967.471191,943.751343 968.132629,943.567505 
    C967.935486,945.217407 967.390259,946.604675 966.428223,948.001343 
    C966.011414,948.010864 965.986206,947.981079 966.126465,947.657227 
    C966.459229,946.437073 966.651794,945.540771 966.844360,944.644409 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M918.925903,814.529053 
    C918.739685,813.437439 918.610901,811.937073 918.745178,810.207520 
    C918.999939,811.359009 918.991699,812.739624 918.925903,814.529053 
  z"/>
  <path fill="#CACACA" opacity="1.000000" stroke="none" 
    d="
  M961.179565,1169.344238 
    C961.899170,1169.577148 962.679504,1170.132690 963.701416,1170.881470 
    C963.042114,1170.605347 962.141235,1170.135986 961.179565,1169.344238 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M944.926270,1047.552124 
    C945.040588,1048.343506 945.015381,1048.872437 944.961243,1049.800049 
    C944.343079,1049.690552 943.753845,1049.182373 943.090271,1048.064209 
    C943.041199,1047.225830 943.066406,1046.997437 943.091553,1046.769165 
    C943.656616,1046.942627 944.221741,1047.116089 944.926270,1047.552124 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M1219.681396,1049.230835 
    C1220.863892,1049.005371 1221.677979,1049.005371 1222.899658,1049.044922 
    C1222.364380,1049.706665 1221.421509,1050.328735 1220.120850,1050.922119 
    C1219.613037,1050.414307 1219.463013,1049.935303 1219.681396,1049.230835 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1206.779541,1059.738281 
    C1207.167480,1059.260132 1207.732178,1058.598267 1208.576904,1057.883789 
    C1208.857056,1057.831177 1209.019165,1058.042603 1209.039795,1058.341919 
    C1209.060303,1058.641235 1208.988770,1059.041382 1208.988770,1059.041382 
    C1208.311279,1059.212402 1207.633789,1059.383545 1206.779541,1059.738281 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M969.894897,903.013672 
    C969.591797,902.807983 969.115845,902.639099 968.689087,902.556152 
    C969.066223,902.778259 969.394165,902.914368 969.894897,903.013672 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M973.727173,935.401428 
    C974.175842,934.637878 974.658813,933.902649 975.585938,933.045349 
    C975.536316,933.680786 975.042603,934.438293 974.184570,935.346252 
    C973.820251,935.496704 973.761536,935.429810 973.727173,935.401428 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M803.952881,928.256836 
    C804.639648,928.466125 805.307800,929.048828 805.962952,930.005249 
    C805.278015,929.796021 804.606079,929.213196 803.952881,928.256836 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1206.882202,1111.157227 
    C1206.638916,1111.030029 1206.247070,1110.813843 1205.842896,1110.370605 
    C1206.131714,1110.451782 1206.432617,1110.760132 1206.882202,1111.157227 
  z"/>
  <path fill="#CACACA" opacity="1.000000" stroke="none" 
    d="
  M957.194275,1162.362549 
    C957.795593,1162.885620 958.470276,1163.743164 959.170044,1165.060547 
    C959.195129,1165.520386 959.141785,1165.528442 959.125732,1165.549805 
    C958.495605,1164.613037 957.881653,1163.655029 957.194275,1162.362549 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M1126.223022,1188.972900 
    C1126.248535,1187.962646 1126.664795,1186.998901 1127.464844,1186.385742 
    C1127.437134,1187.497314 1127.025391,1188.258301 1126.223022,1188.972900 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M965.426880,950.903015 
    C964.837585,951.059387 964.516663,951.008118 963.713745,950.874756 
    C963.686035,950.039978 964.140259,949.287354 965.043945,948.270752 
    C965.493408,948.006714 965.986206,947.981079 965.986206,947.981079 
    C965.986206,947.981079 966.011414,948.010864 966.025696,948.025146 
    C965.925049,948.924744 965.810120,949.810059 965.426880,950.903015 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M807.348877,907.528442 
    C807.210632,907.695007 807.045593,907.996948 806.747192,908.241638 
    C806.849854,908.010803 807.085999,907.837280 807.348877,907.528442 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M808.994202,842.682251 
    C808.500122,842.984619 808.111755,842.981934 807.433105,842.972534 
    C807.620178,842.380493 808.097412,841.795105 808.862793,841.149475 
    C809.133911,841.518494 809.116882,841.947815 808.994202,842.682251 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M945.139099,1122.330933 
    C945.149170,1122.398315 945.193420,1122.459595 945.175842,1122.399170 
    C945.114075,1122.277588 945.173218,1122.324707 945.139099,1122.330933 
  z"/>
  <path fill="#CACACA" opacity="1.000000" stroke="none" 
    d="
  M960.760010,1165.132202 
    C961.031555,1165.981567 961.011963,1166.587036 960.983032,1167.644531 
    C960.345703,1167.410889 959.717773,1166.724976 959.089417,1165.671875 
    C959.548950,1165.165894 960.008911,1165.027100 960.760010,1165.132202 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M1216.074951,1054.396484 
    C1215.321045,1054.276733 1214.889160,1053.995361 1215.096191,1053.367432 
    C1216.463989,1052.987549 1217.192871,1052.954224 1217.990234,1052.985962 
    C1218.058838,1053.050903 1218.197144,1053.179810 1218.197144,1053.179810 
    C1217.597168,1053.531494 1216.997192,1053.883179 1216.074951,1054.396484 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M1144.304199,1178.853882 
    C1144.546265,1178.299561 1145.086914,1177.678711 1145.978027,1177.047729 
    C1145.753418,1177.620850 1145.178101,1178.204102 1144.304199,1178.853882 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M1218.065796,1050.699463 
    C1218.524780,1050.506348 1218.983887,1050.313110 1219.685791,1050.439453 
    C1219.526489,1051.454712 1219.124512,1052.150391 1218.459839,1053.012939 
    C1218.197144,1053.179810 1218.058838,1053.050903 1218.012695,1052.616699 
    C1217.999756,1051.688232 1218.032715,1051.193848 1218.065796,1050.699463 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M1224.327881,1048.121826 
    C1224.460449,1047.573486 1224.842896,1046.851196 1225.555420,1046.074341 
    C1225.449463,1046.662354 1225.013550,1047.305176 1224.327881,1048.121826 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M1226.030029,1044.714844 
    C1226.043823,1044.330688 1226.191528,1043.703491 1226.609863,1043.048096 
    C1226.641479,1043.504150 1226.402710,1043.988037 1226.030029,1044.714844 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M1226.837402,1039.705566 
    C1226.441528,1039.984497 1226.005493,1039.987549 1225.242188,1039.982422 
    C1224.771362,1039.578003 1224.628052,1039.181641 1224.482666,1038.466309 
    C1224.733154,1038.113770 1224.985718,1038.080078 1225.618530,1038.006592 
    C1226.265015,1038.454346 1226.531250,1038.941895 1226.837402,1039.705566 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M819.080200,823.934326 
    C819.105774,824.545898 818.937439,824.956299 818.445129,825.267944 
    C818.376160,824.690491 818.631226,824.211853 819.080200,823.934326 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M972.274780,903.845093 
    C971.704407,904.077026 970.882141,904.025635 969.985718,903.498901 
    C970.615356,903.202942 971.319153,903.382385 972.274780,903.845093 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M810.458618,905.182617 
    C810.432800,905.186646 810.383850,905.501221 810.383850,905.501221 
    C810.383850,905.501221 810.628967,905.310181 810.578613,905.243530 
    C810.528198,905.176819 810.484497,905.178528 810.458618,905.182617 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M965.935181,824.717468 
    C965.455933,824.828796 964.889587,824.624817 964.168396,824.151489 
    C964.625061,824.055481 965.236572,824.228821 965.935181,824.717468 
  z"/>
  <path fill="#D5D5D5" opacity="1.000000" stroke="none" 
    d="
  M1048.052490,1231.240479 
    C1048.562744,1231.103394 1049.139893,1231.293823 1049.843750,1231.769287 
    C1049.353516,1231.891968 1048.736450,1231.729858 1048.052490,1231.240479 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M943.103333,1046.558350 
    C943.066406,1046.997437 943.041199,1047.225830 942.971497,1047.796631 
    C942.773560,1047.502075 942.620117,1046.865234 942.720459,1046.088867 
    C942.974365,1045.949585 943.115112,1046.347656 943.103333,1046.558350 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M1209.061279,1059.244019 
    C1208.988770,1059.041382 1209.060303,1058.641235 1209.119629,1058.448486 
    C1209.505005,1058.290894 1209.748779,1058.451294 1210.010254,1058.942627 
    C1209.784790,1059.247925 1209.459351,1059.347290 1209.061279,1059.244019 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M974.980957,1072.681152 
    C974.859619,1073.040771 974.600037,1073.037842 974.471497,1073.034424 
    C974.365234,1072.461670 974.387512,1071.892456 974.596741,1071.093506 
    C974.889893,1071.349854 974.996094,1071.835693 974.980957,1072.681152 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M964.164734,1065.072754 
    C964.918701,1064.755493 965.660645,1064.813843 966.295776,1065.320435 
    C965.510193,1065.661987 964.831421,1065.555298 964.164734,1065.072754 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M966.623779,899.377075 
    C966.615540,899.342468 966.675537,899.405945 966.712158,899.396606 
    C966.748779,899.387329 966.631958,899.411743 966.623779,899.377075 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M932.131836,827.870300 
    C932.513367,827.911560 932.767151,828.103638 933.083252,828.577637 
    C933.199158,828.788574 933.073730,828.922974 932.793457,828.890686 
    C932.242737,828.668091 932.043701,828.420410 931.916077,828.115417 
    C931.916077,828.115417 932.057861,827.950134 932.131836,827.870300 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M956.011475,1059.331543 
    C956.237244,1059.231323 956.522766,1059.402344 956.923706,1059.801025 
    C956.716370,1059.886841 956.393799,1059.744873 956.011475,1059.331543 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M813.138611,942.109253 
    C813.541626,941.954895 814.007629,942.076355 814.299438,942.590698 
    C813.817322,942.784119 813.509460,942.584595 813.138611,942.109253 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M1214.358398,1056.121704 
    C1214.121338,1055.947266 1214.160278,1055.549561 1214.446045,1054.594971 
    C1214.891602,1054.100586 1215.090454,1054.163086 1215.412598,1054.513062 
    C1215.235718,1055.166504 1214.935181,1055.532471 1214.358398,1056.121704 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M851.156250,945.848206 
    C850.943542,945.793762 850.981934,945.334595 851.018066,945.107056 
    C851.320923,945.062439 851.587585,945.245300 851.829590,945.691284 
    C851.805054,945.954468 851.368958,945.902649 851.156250,945.848206 
  z"/>
  <path fill="#EFEFEF" opacity="1.000000" stroke="none" 
    d="
  M868.007629,981.272339 
    C868.241882,981.184143 868.549011,981.357300 868.921692,981.796265 
    C868.684998,981.886047 868.382751,981.709839 868.007629,981.272339 
  z"/>
  <path fill="#C0C0C0" opacity="1.000000" stroke="none" 
    d="
  M1218.272705,1146.971436 
    C1218.106323,1146.750977 1218.251831,1146.490967 1218.678345,1146.163452 
    C1218.925049,1146.405273 1218.800171,1146.683838 1218.272705,1146.971436 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M983.145569,1187.047119 
    C983.333801,1187.057983 983.522095,1187.068970 983.991211,1187.118652 
    C984.073364,1187.429810 983.874634,1187.702271 983.458313,1188.107178 
    C983.240723,1188.239502 983.034485,1188.025879 982.998779,1187.723145 
    C982.963013,1187.420410 983.145569,1187.047119 983.145569,1187.047119 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M979.976685,908.675781 
    C979.742920,908.786255 979.448914,908.623657 979.046265,908.224976 
    C979.263855,908.126892 979.590210,908.264832 979.976685,908.675781 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M805.607544,909.945190 
    C805.585876,909.969604 805.509460,910.255615 805.509460,910.255615 
    C805.509460,910.255615 805.744812,910.154358 805.718750,910.029907 
    C805.692688,909.905518 805.629150,909.920715 805.607544,909.945190 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M981.125610,924.127747 
    C981.094238,924.518677 980.897827,924.770935 980.420166,925.083740 
    C980.206726,925.197021 980.064575,925.060669 980.094910,924.779175 
    C980.307495,924.232056 980.541748,924.025330 980.828003,923.877502 
    C980.828003,923.877502 981.028442,924.041992 981.125610,924.127747 
  z"/>
  <path fill="#DADADA" opacity="1.000000" stroke="none" 
    d="
  M1082.965088,192.514099 
    C1083.310547,193.244781 1084.002686,194.438354 1084.003662,195.632523 
    C1084.036987,233.740814 1084.005371,271.849182 1083.965576,309.957520 
    C1083.964722,310.776062 1083.752686,311.594421 1083.374512,312.743469 
    C1083.069702,273.041779 1083.029663,233.009537 1082.965088,192.514099 
  z"/>
  <path fill="#ED1C24" opacity="1.000000" stroke="none" 
    d="
  M837.281982,150.954987 
    C849.858154,151.000473 862.434265,151.045959 875.474854,151.123550 
    C875.939209,198.563065 875.939209,245.970474 875.939209,293.967163 
    C863.050964,293.967163 850.615112,293.967163 837.606750,293.550720 
    C837.021851,246.728088 837.007751,200.321869 837.009155,153.915649 
    C837.009216,152.928772 837.187134,151.941895 837.281982,150.954987 
  z"/>
  <path fill="#F6F6F6" opacity="1.000000" stroke="none" 
    d="
  M836.954773,150.918121 
    C837.187134,151.941895 837.009216,152.928772 837.009155,153.915649 
    C837.007751,200.321869 837.021851,246.728088 837.157532,293.594666 
    C836.804504,292.476379 835.914124,290.898346 835.911865,289.319031 
    C835.845825,243.502167 835.868469,197.685181 835.923584,151.395584 
    C836.189331,150.909058 836.408447,150.895142 836.954773,150.918121 
  z"/>
  <path fill="#ED1C24" opacity="1.000000" stroke="none" 
    d="
  M1166.970215,293.341187 
    C1154.308960,293.854248 1141.627319,293.915649 1128.478516,293.933655 
    C1128.023315,246.545868 1128.034912,199.201431 1128.186890,151.398254 
    C1140.951904,150.939514 1153.576538,150.939514 1166.949829,150.939514 
    C1166.949829,198.541168 1166.949829,245.715332 1166.970215,293.341187 
  z"/>
  <path fill="#F6F6F6" opacity="1.000000" stroke="none" 
    d="
  M270.081451,940.206665 
    C270.899414,941.190735 271.692047,942.595886 273.142761,945.167603 
    C269.946930,945.167603 268.184204,945.167603 266.421478,945.167603 
    C239.286392,945.167603 212.151291,945.170166 185.016205,945.166016 
    C178.222488,945.164978 178.199661,945.155029 178.199036,938.118347 
    C178.193130,871.196228 178.195435,804.274109 178.195618,737.351990 
    C178.195679,714.545227 178.192657,691.738403 178.198349,668.931641 
    C178.201782,655.117737 178.209839,654.984314 191.890015,655.167603 
    C200.162231,655.278320 208.427872,655.880310 216.859879,656.655518 
    C204.895203,657.049500 192.767105,657.049500 180.325607,657.049500 
    C180.325607,752.672241 180.325607,847.999756 180.325607,943.679810 
    C210.347382,943.679810 240.399475,943.679810 270.764923,943.679810 
    C270.533142,942.681824 270.294647,941.654846 270.081451,940.206665 
  z"/>
  <path fill="#E6E6E6" opacity="1.000000" stroke="none" 
    d="
  M466.982544,657.447144 
    C467.318787,658.337036 467.992310,659.696411 467.995361,661.057373 
    C468.058533,689.128418 468.051880,717.199646 468.023529,745.270874 
    C468.022369,746.396912 467.671448,747.522583 467.085541,748.852417 
    C466.798492,742.093994 466.994049,735.131775 467.004852,728.169312 
    C467.041199,704.752075 467.011810,681.334717 466.982544,657.447144 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M325.617065,759.948669 
    C324.543823,761.018982 323.109955,762.081604 321.323853,763.049927 
    C322.399902,761.950684 323.828125,760.945801 325.617065,759.948669 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M282.584808,802.798035 
    C282.544647,803.462708 282.144714,804.228149 281.400482,805.083130 
    C281.445801,804.414734 281.835419,803.656738 282.584808,802.798035 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M311.684723,770.046875 
    C311.837860,770.291382 311.704742,770.619446 311.328278,771.087036 
    C311.189453,770.861145 311.293945,770.495789 311.684723,770.046875 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M280.695190,805.836914 
    C280.794342,806.040466 280.650940,806.388611 280.239532,806.844299 
    C280.131897,806.628418 280.292267,806.304993 280.695190,805.836914 
  z"/>
  <path fill="#050505" opacity="1.000000" stroke="none" 
    d="
  M462.840637,915.003540 
    C463.924744,915.658203 465.008850,916.312866 466.437408,917.422485 
    C468.650879,919.003357 470.519928,920.129272 472.599060,921.530884 
    C473.737122,922.469849 474.665100,923.133057 475.561279,924.176453 
    C475.462463,925.057373 475.395477,925.558167 475.039124,926.246948 
    C470.086212,933.778381 465.422607,941.121765 460.654175,948.630310 
    C457.476135,946.766785 454.771759,945.172302 452.059113,943.591919 
    C440.047302,936.594177 428.033112,929.600525 415.898743,922.326599 
    C414.872559,921.649231 413.967407,921.250610 412.944214,920.538574 
    C411.620605,919.628723 410.415070,919.032349 409.039307,918.148926 
    C405.933380,916.527405 402.997742,915.192932 400.062103,913.858459 
    C400.062103,913.858459 400.049255,913.939758 400.190735,913.572021 
    C397.948792,911.779907 395.565399,910.355469 393.085754,908.664551 
    C392.315918,908.163330 391.642365,907.928650 390.748840,907.428101 
    C389.172455,906.384521 387.816101,905.606812 386.415894,904.517334 
    C386.194946,903.825317 386.017822,903.445068 385.923523,902.598450 
    C386.001099,868.420044 385.995850,834.707947 386.102753,800.882263 
    C386.214905,800.768677 386.173096,800.452087 386.630127,800.442627 
    C396.719421,800.398560 406.351715,800.363892 416.006531,800.305542 
    C416.029053,800.281799 415.967468,800.290405 416.197083,800.685059 
    C416.524689,803.233826 416.700623,805.387573 416.708832,807.541992 
    C416.809906,834.029297 416.886505,860.516663 416.898346,887.365845 
    C418.106934,888.918335 419.225891,890.376831 420.692078,891.256714 
    C431.022217,897.455688 441.393860,903.587402 451.821686,909.620483 
    C454.751038,911.315308 457.912415,912.609070 460.967377,914.086792 
    C460.967377,914.086792 460.985474,914.017029 460.935608,914.375854 
    C461.537354,914.824219 462.188995,914.913879 462.840637,915.003540 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M416.019775,922.605408 
    C428.033112,929.600525 440.047302,936.594177 452.059113,943.591919 
    C454.771759,945.172302 457.476135,946.766785 460.654175,948.630310 
    C465.422607,941.121765 470.086212,933.778381 475.185516,926.194580 
    C475.621246,925.954224 475.931244,925.978516 475.931274,925.978516 
    C473.670380,930.928528 471.499756,935.922791 469.104462,940.806946 
    C468.137207,942.779175 466.513367,944.422302 465.475464,946.368347 
    C462.625122,951.712646 460.629456,952.440735 455.677643,949.234253 
    C448.327576,944.474731 441.184967,939.389526 433.764954,934.744995 
    C428.079437,931.186157 422.101685,928.094299 416.118103,924.089478 
    C415.994781,923.124634 416.007263,922.864990 416.019775,922.605408 
  z"/>
  <path fill="#C3C3C3" opacity="1.000000" stroke="none" 
    d="
  M460.990845,913.672974 
    C457.912415,912.609070 454.751038,911.315308 451.821686,909.620483 
    C441.393860,903.587402 431.022217,897.455688 420.692078,891.256714 
    C419.225891,890.376831 418.106934,888.918335 417.215851,887.353455 
    C417.816101,886.970764 418.027771,886.962219 418.239471,886.953674 
    C428.961426,893.027893 439.697449,899.077332 450.397186,905.190491 
    C453.864471,907.171448 457.259949,909.282593 460.618500,911.442749 
    C460.987274,911.679993 460.893555,912.636292 460.990845,913.672974 
  z"/>
  <path fill="#8F8F8F" opacity="1.000000" stroke="none" 
    d="
  M385.990601,800.995850 
    C385.995850,834.707947 386.001099,868.420044 385.765106,902.653503 
    C385.523834,903.174866 385.199951,903.262146 385.199951,903.262146 
    C385.148315,869.467712 385.096649,835.673340 385.311646,801.413452 
    C385.578278,800.947998 385.990601,800.995850 385.990601,800.995850 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M418.142151,886.496155 
    C418.027771,886.962219 417.816101,886.970764 417.286926,886.991638 
    C416.886505,860.516663 416.809906,834.029297 416.708832,807.541992 
    C416.700623,805.387573 416.524689,803.233826 416.684753,800.584412 
    C417.269257,800.032349 417.595673,799.975586 417.922119,799.918884 
    C417.963043,828.625488 418.003937,857.332031 418.142151,886.496155 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M415.983978,800.329224 
    C406.351715,800.363892 396.719421,800.398560 386.566437,800.101685 
    C386.005219,799.542358 385.964752,799.314697 385.924255,799.086975 
    C395.654755,799.056274 405.385284,799.025513 415.569763,799.351807 
    C416.010498,799.915649 415.997253,800.122437 415.983978,800.329224 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M400.018616,914.236694 
    C402.997742,915.192932 405.933380,916.527405 408.980408,918.506104 
    C409.064758,919.389893 409.037659,919.629517 409.010559,919.869141 
    C405.998749,918.117737 402.986908,916.366333 400.018616,914.236694 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M393.182007,908.931030 
    C395.565399,910.355469 397.948792,911.779907 400.231323,913.565063 
    C397.073059,912.570923 394.015656,911.216003 390.962463,909.448608 
    C390.966675,909.036072 391.056335,908.942200 391.410400,908.958008 
    C392.237000,908.959534 392.709473,908.945251 393.182007,908.931030 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M472.388977,921.255249 
    C470.519928,920.129272 468.650879,919.003357 466.766296,917.520386 
    C469.764648,918.229248 472.778595,919.295105 475.418213,920.719116 
    C474.158905,921.136597 473.273926,921.195923 472.388977,921.255249 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M386.459778,904.829102 
    C387.816101,905.606812 389.172455,906.384521 390.756897,907.636719 
    C391.003448,908.388733 391.027222,908.665710 391.056335,908.942200 
    C391.056335,908.942200 390.966675,909.036072 390.922394,909.083618 
    C388.929199,908.000061 386.980286,906.869019 385.420532,905.333008 
    C386.026428,904.895081 386.243103,904.862122 386.459778,904.829102 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M476.324707,925.983276 
    C475.931244,925.978516 475.621246,925.954224 475.474854,926.006592 
    C475.395477,925.558167 475.462463,925.057373 475.704010,923.952637 
    C475.939606,922.819641 476.000671,922.290527 476.061768,921.761475 
    C479.077576,922.735901 478.561523,924.258911 476.324707,925.983276 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M409.225647,919.920898 
    C409.037659,919.629517 409.064758,919.389893 409.150696,918.793091 
    C410.415070,919.032349 411.620605,919.628723 412.796448,920.804077 
    C412.444183,921.622864 412.121582,921.862732 411.799011,922.102539 
    C411.798981,922.102539 411.407074,922.044800 411.184021,921.689392 
    C410.600647,920.897949 410.240356,920.461914 409.880066,920.025818 
    C409.880096,920.025818 409.440765,919.972717 409.225647,919.920898 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M411.965271,922.418091 
    C412.121582,921.862732 412.444183,921.622864 412.914520,921.117493 
    C413.967407,921.250610 414.872559,921.649231 415.898743,922.326599 
    C416.007263,922.864990 415.994781,923.124634 415.962494,923.773743 
    C414.672302,923.686707 413.401947,923.210205 411.965271,922.418091 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M476.051086,921.589172 
    C476.000671,922.290527 475.939606,922.819641 475.735840,923.572510 
    C474.665100,923.133057 473.737122,922.469849 472.599030,921.530945 
    C473.273926,921.195923 474.158905,921.136597 475.487610,921.083374 
    C475.931305,921.089417 476.040405,921.416870 476.051086,921.589172 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M358.394897,792.927124 
    C358.843018,792.251953 359.662079,791.651123 360.802765,791.042236 
    C360.338196,791.689941 359.552032,792.345642 358.394897,792.927124 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M464.773468,967.014038 
    C464.626160,967.689819 464.111389,968.320679 463.263550,968.946167 
    C463.422333,968.283569 463.914185,967.626343 464.773468,967.014038 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M318.414062,830.034180 
    C318.379669,829.314270 318.713959,828.570374 319.158478,827.543091 
    C319.268677,827.259705 319.666779,827.108948 319.876801,827.073792 
    C319.652100,828.029175 319.217407,829.019714 318.414062,830.034180 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M351.323792,796.932983 
    C351.483887,796.330933 351.993988,795.782227 352.774780,795.142151 
    C352.588226,795.695984 352.131012,796.341187 351.323792,796.932983 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M493.885071,830.340088 
    C494.201813,830.521484 494.580170,831.023804 494.961121,831.862671 
    C494.624695,831.686462 494.285706,831.173767 493.885071,830.340088 
  z"/>
  <path fill="#C3C3C3" opacity="1.000000" stroke="none" 
    d="
  M462.748108,914.716309 
    C462.188995,914.913879 461.537354,914.824219 460.899933,914.380798 
    C461.494629,914.161011 462.075104,914.295044 462.748108,914.716309 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M409.904694,920.347778 
    C410.240356,920.461914 410.600647,920.897949 410.994720,921.630981 
    C410.662109,921.508545 410.295715,921.089111 409.904694,920.347778 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M386.415894,904.517334 
    C386.243103,904.862122 386.026428,904.895081 385.482849,904.962280 
    C385.136963,904.607849 385.117981,904.219177 385.149475,903.546387 
    C385.199951,903.262146 385.523834,903.174866 385.682251,903.119812 
    C386.017822,903.445068 386.194946,903.825317 386.415894,904.517334 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M320.357391,827.082336 
    C320.451050,826.705322 320.885590,826.316956 321.625977,825.877747 
    C321.520660,826.241638 321.109497,826.656311 320.357391,827.082336 
  z"/>
  <path fill="#E2E2E2" opacity="1.000000" stroke="none" 
    d="
  M487.042664,821.322388 
    C487.480652,821.146179 488.001740,821.253479 488.639679,821.616211 
    C488.212952,821.783020 487.669373,821.694397 487.042664,821.322388 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M462.652679,968.938293 
    C462.506500,969.287109 462.042725,969.639526 461.267151,969.964600 
    C461.415253,969.605408 461.875153,969.273621 462.652679,968.938293 
  z"/>
  <path fill="#C3C3C3" opacity="1.000000" stroke="none" 
    d="
  M385.629761,799.149658 
    C385.964752,799.314697 386.005219,799.542358 386.109406,800.111084 
    C386.173096,800.452087 386.214905,800.768677 386.102753,800.882263 
    C385.990601,800.995850 385.578278,800.947998 385.371063,800.944519 
    C385.220978,800.364807 385.278107,799.788574 385.629761,799.149658 
  z"/>
  <path fill="#C3C3C3" opacity="1.000000" stroke="none" 
    d="
  M416.006531,800.305542 
    C415.997253,800.122437 416.010498,799.915649 416.039948,799.398499 
    C416.637451,799.166260 417.218781,799.244324 417.861115,799.620667 
    C417.595673,799.975586 417.269257,800.032349 416.455139,800.189697 
    C415.967468,800.290405 416.029053,800.281799 416.006531,800.305542 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M337.172668,808.910400 
    C337.107117,808.372131 337.385559,807.812500 337.968811,807.144836 
    C338.021301,807.654236 337.768982,808.271667 337.172668,808.910400 
  z"/>
  <path fill="#E2E2E2" opacity="1.000000" stroke="none" 
    d="
  M485.731079,819.275024 
    C486.061462,819.430054 486.553070,819.879395 487.005615,820.684753 
    C486.608459,820.550354 486.250397,820.059875 485.731079,819.275024 
  z"/>
  <path fill="#C8C8C8" opacity="1.000000" stroke="none" 
    d="
  M330.363831,815.058472 
    C330.460510,814.689270 330.896545,814.309021 331.633728,813.873657 
    C331.524292,814.228210 331.113708,814.637817 330.363831,815.058472 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M495.135620,833.259827 
    C495.362030,833.232361 495.600311,833.476501 495.901520,833.974121 
    C495.692139,833.995605 495.419830,833.763489 495.135620,833.259827 
  z"/>
  <path fill="#A349A4" opacity="1.000000" stroke="none" 
    d="
  M1043.711792,1115.469971 
    C1043.711792,1115.469971 1043.940552,1115.494263 1043.982056,1115.214355 
    C1043.349365,1113.958862 1042.675049,1112.983032 1041.924316,1111.697998 
    C1041.248413,1111.244385 1040.648682,1111.100098 1039.888184,1110.758667 
    C1039.447388,1110.371460 1039.167358,1110.181396 1038.887329,1109.991455 
    C1038.887329,1109.991455 1038.995361,1109.986328 1038.867676,1109.817627 
    C1038.478027,1109.424805 1038.216187,1109.200684 1037.954346,1108.976440 
    C1037.954346,1108.976440 1038.012085,1108.995728 1037.953125,1108.610107 
    C1037.586548,1106.463501 1037.416016,1104.664307 1036.941284,1102.949585 
    C1036.065552,1099.787109 1034.302002,1096.704956 1034.163940,1093.534668 
    C1033.748047,1083.982300 1033.270020,1074.310181 1038.351929,1065.277832 
    C1039.823730,1062.994873 1040.927490,1060.844971 1042.036133,1058.639893 
    C1042.041138,1058.584595 1041.983521,1058.490112 1042.317871,1058.329102 
    C1043.789185,1056.801880 1044.926147,1055.435425 1046.081787,1054.100342 
    C1046.100342,1054.131592 1046.167603,1054.159424 1046.466553,1054.010742 
    C1048.563965,1051.962402 1050.362427,1050.062744 1052.146240,1048.129639 
    C1052.131470,1048.096313 1052.065796,1048.064819 1052.419678,1048.064209 
    C1053.885010,1046.747314 1054.996582,1045.430908 1056.493042,1044.091797 
    C1058.018066,1043.400635 1059.157959,1042.732300 1060.464355,1042.065308 
    C1060.630859,1042.066650 1060.956055,1041.994751 1061.303955,1042.028931 
    C1062.534424,1041.396851 1063.416992,1040.730591 1064.469482,1040.062256 
    C1064.639526,1040.060181 1064.969971,1039.979858 1065.311035,1040.011963 
    C1066.449951,1039.369995 1067.247803,1038.695801 1068.383545,1037.996338 
    C1069.171387,1037.934570 1069.621094,1037.898071 1070.431763,1037.921387 
    C1071.442749,1037.348022 1072.092773,1036.714722 1073.220093,1035.987305 
    C1080.184570,1035.925537 1086.671753,1035.958130 1093.084595,1036.374023 
    C1094.313843,1037.118408 1095.617432,1037.479492 1097.262817,1037.883789 
    C1098.062500,1037.956543 1098.520630,1037.986206 1098.966797,1038.395630 
    C1099.976440,1039.175171 1100.998169,1039.574829 1102.191895,1040.014893 
    C1102.364014,1040.055420 1102.717163,1040.076538 1102.808594,1040.459839 
    C1104.263428,1041.243774 1105.626709,1041.644287 1107.186523,1042.318115 
    C1114.804443,1048.234619 1121.210571,1054.776611 1125.944702,1062.905396 
    C1131.096680,1071.751343 1132.668823,1081.249146 1131.947510,1091.343628 
    C1131.454224,1098.246460 1131.432373,1105.191162 1126.985596,1111.066772 
    C1126.985596,1111.066772 1127.017456,1110.989502 1126.670166,1110.990967 
    C1124.867676,1112.348389 1123.412476,1113.704102 1121.923096,1115.196533 
    C1121.889160,1115.333130 1121.915894,1115.613525 1121.679565,1115.782593 
    C1121.279053,1116.287109 1121.114990,1116.622681 1120.943848,1116.962891 
    C1120.936890,1116.967529 1120.925415,1116.948975 1120.610352,1117.038086 
    C1118.850464,1118.727539 1117.405640,1120.327881 1115.975342,1121.947021 
    C1115.989990,1121.965698 1115.943115,1121.959961 1115.669800,1122.018066 
    C1115.257812,1122.401611 1115.119141,1122.727051 1114.949463,1123.209961 
    C1114.918579,1123.367432 1114.937988,1123.687744 1114.600586,1123.786255 
    C1113.905396,1124.573486 1113.547729,1125.262207 1112.933716,1126.150146 
    C1111.782349,1126.885376 1110.887329,1127.421509 1109.643311,1127.964111 
    C1108.483398,1128.297852 1107.672363,1128.625000 1106.559570,1129.109131 
    C1104.490234,1130.215698 1102.722900,1131.165527 1100.586670,1132.048096 
    C1099.467773,1131.974976 1098.717896,1131.969116 1097.616699,1131.923584 
    C1096.484741,1132.472778 1095.703979,1133.061768 1094.472778,1133.770752 
    C1086.390259,1133.837646 1078.758179,1133.784668 1071.092773,1133.375732 
    C1070.047363,1132.669800 1069.035400,1132.319702 1067.764404,1131.952393 
    C1067.333618,1131.957275 1067.161987,1131.979736 1066.815552,1131.962158 
    C1066.640869,1131.922241 1066.284546,1131.882324 1066.094238,1131.567139 
    C1061.985718,1129.406250 1058.067749,1127.560791 1054.121704,1125.411743 
    C1053.508423,1124.692627 1052.923218,1124.277222 1052.236572,1123.521729 
    C1050.146484,1121.360718 1048.157715,1119.539795 1046.106445,1117.355225 
    C1045.266724,1116.484497 1044.489258,1115.977173 1043.711792,1115.469971 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1127.289307,1110.939087 
    C1131.432373,1105.191162 1131.454224,1098.246460 1131.947510,1091.343628 
    C1132.668823,1081.249146 1131.096680,1071.751343 1125.944702,1062.905396 
    C1121.210571,1054.776611 1114.804443,1048.234619 1107.018677,1041.997559 
    C1105.342041,1040.961304 1104.029541,1040.518921 1102.717163,1040.076538 
    C1102.717163,1040.076538 1102.364014,1040.055420 1102.195190,1039.756348 
    C1102.013062,1038.940186 1101.999634,1038.422974 1101.986328,1037.905884 
    C1130.701904,1047.719604 1143.865234,1085.197144 1127.289307,1110.939087 
  z"/>
  <path fill="#9C9C9C" opacity="1.000000" stroke="none" 
    d="
  M1037.983887,1065.411011 
    C1033.270020,1074.310181 1033.748047,1083.982300 1034.163940,1093.534668 
    C1034.302002,1096.704956 1036.065552,1099.787109 1036.941284,1102.949585 
    C1037.416016,1104.664307 1037.586548,1106.463501 1037.950684,1108.640381 
    C1030.109863,1097.902222 1029.527588,1075.380371 1037.298584,1064.081787 
    C1037.810547,1064.720947 1037.897217,1065.066040 1037.983887,1065.411011 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1114.937988,1123.687744 
    C1114.937988,1123.687744 1114.918579,1123.367432 1115.181885,1123.098877 
    C1115.611206,1122.540161 1115.777100,1122.250000 1115.943115,1121.959961 
    C1115.943115,1121.959961 1115.989990,1121.965698 1116.356079,1121.949463 
    C1117.704224,1121.701294 1118.686401,1121.469482 1119.668457,1121.237671 
    C1114.055176,1129.000366 1105.619995,1132.212158 1097.046753,1135.120483 
    C1094.729614,1135.906616 1092.231445,1136.159058 1089.540771,1136.251099 
    C1091.151123,1135.114136 1093.037231,1134.382568 1094.923218,1133.650879 
    C1095.703979,1133.061768 1096.484741,1132.472778 1097.794922,1132.171631 
    C1099.201416,1132.344727 1100.078369,1132.229980 1100.955444,1132.115234 
    C1102.722900,1131.165527 1104.490234,1130.215698 1106.912354,1129.121338 
    C1108.375488,1128.636963 1109.183838,1128.297363 1109.992310,1127.957642 
    C1110.887329,1127.421509 1111.782349,1126.885376 1113.189087,1126.000122 
    C1114.113159,1124.996460 1114.525513,1124.342163 1114.937988,1123.687744 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1070.070923,1037.861450 
    C1069.621094,1037.898071 1069.171387,1037.934570 1068.186279,1037.941406 
    C1067.369995,1037.817139 1067.186646,1037.627930 1067.100952,1037.344116 
    C1075.526489,1033.359863 1084.303711,1033.657837 1093.454590,1035.484497 
    C1093.555176,1035.887207 1093.366211,1035.961914 1093.159058,1035.990601 
    C1086.671753,1035.958130 1080.184570,1035.925537 1072.976074,1036.106201 
    C1071.526855,1036.833374 1070.798828,1037.347412 1070.070923,1037.861450 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M1094.472778,1133.770752 
    C1093.037231,1134.382568 1091.151123,1135.114136 1089.139160,1136.165283 
    C1085.299316,1136.589478 1081.585083,1136.694336 1077.289062,1136.296875 
    C1075.268799,1135.584595 1073.830200,1135.374634 1072.391724,1135.164673 
    C1072.074097,1135.213257 1071.756348,1135.261841 1071.244873,1134.849487 
    C1071.076172,1134.169556 1071.101196,1133.950562 1071.126099,1133.731689 
    C1078.758179,1133.784668 1086.390259,1133.837646 1094.472778,1133.770752 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1071.092773,1133.375732 
    C1071.101196,1133.950562 1071.076172,1134.169556 1071.031738,1134.718506 
    C1066.330078,1133.286987 1061.647583,1131.525513 1057.162964,1129.453125 
    C1060.335449,1130.055420 1063.309937,1130.968872 1066.284546,1131.882324 
    C1066.284546,1131.882324 1066.640869,1131.922241 1066.912354,1132.126465 
    C1067.463745,1132.210327 1067.743652,1132.089966 1068.023438,1131.969727 
    C1069.035400,1132.319702 1070.047363,1132.669800 1071.092773,1133.375732 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M983.280212,1186.778809 
    C983.145569,1187.047119 982.963013,1187.420410 982.896667,1187.615479 
    C979.597839,1187.157227 976.365356,1186.504028 973.043579,1185.492676 
    C977.232849,1187.933960 981.247253,1186.176636 985.646057,1184.399414 
    C985.158508,1185.088623 984.286682,1185.799561 983.280212,1186.778809 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M1045.173950,1211.669678 
    C1044.383545,1208.476074 1043.711548,1204.937134 1043.142090,1200.933716 
    C1043.927124,1204.087646 1044.609741,1207.705811 1045.173950,1211.669678 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M1066.094238,1131.567139 
    C1063.309937,1130.968872 1060.335449,1130.055420 1056.970703,1129.169922 
    C1055.750000,1128.774292 1054.919189,1128.350708 1054.037842,1127.239624 
    C1054.041626,1126.273071 1054.095703,1125.994141 1054.149658,1125.715332 
    C1058.067749,1127.560791 1061.985718,1129.406250 1066.094238,1131.567139 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M1047.131836,1224.671875 
    C1046.350708,1221.814209 1045.684692,1218.624146 1045.119385,1214.978027 
    C1045.895874,1217.794556 1046.571411,1221.067017 1047.131836,1224.671875 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M1031.400391,1182.984985 
    C1030.677612,1182.334717 1030.325562,1181.706909 1029.947266,1180.808350 
    C1032.971191,1182.099487 1036.021362,1183.661255 1039.274658,1185.498291 
    C1036.908813,1184.851562 1034.339844,1183.929443 1031.400391,1182.984985 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M1043.127686,1196.674194 
    C1042.364624,1194.121216 1041.716431,1191.239014 1041.160522,1187.908447 
    C1041.916016,1190.421753 1042.579224,1193.383423 1043.127686,1196.674194 
  z"/>
  <path fill="#CCCCCC" opacity="1.000000" stroke="none" 
    d="
  M1016.994141,996.352844 
    C1017.917786,996.061096 1018.784729,996.067993 1020.083862,996.128540 
    C1017.837769,999.628845 1014.876953,998.830872 1011.585205,996.503418 
    C1013.205139,996.381714 1015.071228,996.516602 1016.994141,996.352844 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1054.121704,1125.411743 
    C1054.095703,1125.994141 1054.041626,1126.273071 1053.916504,1126.972412 
    C1051.739746,1125.794678 1049.633911,1124.196655 1047.805054,1122.360107 
    C1049.500732,1122.701660 1050.919312,1123.281616 1052.337891,1123.861572 
    C1052.923218,1124.277222 1053.508423,1124.692627 1054.121704,1125.411743 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M1052.236572,1123.521729 
    C1050.919312,1123.281616 1049.500732,1122.701660 1047.758545,1122.053955 
    C1046.620117,1121.232056 1045.805176,1120.477661 1045.201416,1119.229980 
    C1045.664673,1118.397339 1045.916748,1118.057983 1046.168823,1117.718750 
    C1048.157715,1119.539795 1050.146484,1121.360718 1052.236572,1123.521729 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M1052.161011,1048.162964 
    C1050.362427,1050.062744 1048.563965,1051.962402 1046.382568,1053.613037 
    C1045.996948,1052.556396 1045.994141,1051.748779 1045.991455,1050.941284 
    C1046.784790,1050.037720 1047.578247,1049.134277 1049.055908,1048.118896 
    C1050.547241,1048.059082 1051.354126,1048.110962 1052.161011,1048.162964 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1064.969971,1039.979858 
    C1064.969971,1039.979858 1064.639526,1040.060181 1064.087891,1040.029297 
    C1062.676147,1040.663818 1061.816040,1041.329346 1060.956055,1041.994751 
    C1060.956055,1041.994751 1060.630859,1042.066650 1059.978516,1042.016846 
    C1058.683472,1041.878784 1058.040894,1041.790527 1057.398193,1041.702148 
    C1059.730103,1040.349365 1062.062134,1038.996582 1064.714233,1037.991455 
    C1065.012817,1038.885986 1064.991455,1039.432983 1064.969971,1039.979858 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M1038.351929,1065.277832 
    C1037.897217,1065.066040 1037.810547,1064.720947 1037.570557,1063.863037 
    C1037.968506,1062.139160 1038.519653,1060.928345 1039.583740,1059.397461 
    C1040.741455,1058.949951 1041.386353,1058.822510 1042.031250,1058.695068 
    C1040.927490,1060.844971 1039.823730,1062.994873 1038.351929,1065.277832 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1121.915894,1115.613525 
    C1121.915894,1115.613525 1121.889160,1115.333130 1122.296509,1115.199585 
    C1123.449463,1115.041748 1124.195190,1115.017578 1124.940796,1114.993408 
    C1123.812500,1116.542847 1122.684204,1118.092285 1121.262085,1119.406738 
    C1120.953979,1118.430664 1120.939697,1117.689819 1120.925415,1116.948975 
    C1120.925415,1116.948975 1120.936890,1116.967529 1121.206543,1116.827637 
    C1121.622803,1116.329712 1121.769287,1115.971558 1121.915894,1115.613525 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1225.958740,1131.633301 
    C1225.227661,1132.929321 1224.461792,1133.862427 1223.404663,1134.901123 
    C1223.646240,1132.891968 1224.179077,1130.777344 1224.845337,1128.329102 
    C1225.293823,1129.087036 1225.609009,1130.178589 1225.958740,1131.633301 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1125.201782,1114.771484 
    C1124.195190,1115.017578 1123.449463,1115.041748 1122.330566,1115.062988 
    C1123.412476,1113.704102 1124.867676,1112.348389 1126.709473,1111.005371 
    C1126.551514,1112.195435 1126.007202,1113.372559 1125.201782,1114.771484 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1042.000732,1112.007324 
    C1042.675049,1112.983032 1043.349365,1113.958862 1043.940430,1115.321655 
    C1042.418335,1114.679565 1040.979126,1113.650513 1039.744141,1112.307495 
    C1040.632324,1111.998169 1041.316528,1112.002808 1042.000732,1112.007324 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1120.610352,1117.038086 
    C1120.939697,1117.689819 1120.953979,1118.430664 1120.978516,1119.542358 
    C1120.716675,1120.319092 1120.444580,1120.724976 1119.920410,1121.184204 
    C1118.686401,1121.469482 1117.704224,1121.701294 1116.341553,1121.930786 
    C1117.405640,1120.327881 1118.850464,1118.727539 1120.610352,1117.038086 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1098.978638,1038.015747 
    C1098.520630,1037.986206 1098.062500,1037.956543 1097.120605,1037.686279 
    C1096.088623,1036.877563 1095.540527,1036.309326 1094.992310,1035.741211 
    C1096.448242,1036.149292 1097.904297,1036.557251 1099.519531,1037.337646 
    C1099.474121,1037.877563 1099.240723,1037.979492 1098.978638,1038.015747 
  z"/>
  <path fill="#9C9C9C" opacity="1.000000" stroke="none" 
    d="
  M1042.036133,1058.639893 
    C1041.386353,1058.822510 1040.741455,1058.949951 1039.767944,1059.109741 
    C1040.426514,1057.516235 1041.413574,1055.890381 1042.760010,1054.386841 
    C1043.127686,1054.681519 1043.135742,1054.853638 1042.921265,1055.331177 
    C1042.460205,1056.587646 1042.221802,1057.538818 1041.983398,1058.490112 
    C1041.983521,1058.490112 1042.041138,1058.584595 1042.036133,1058.639893 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1212.009155,1156.619507 
    C1211.454224,1157.248779 1210.941772,1157.523438 1210.149902,1157.879272 
    C1210.704102,1156.370605 1211.537842,1154.780640 1212.654785,1153.015625 
    C1212.642700,1153.981934 1212.347168,1155.123291 1212.009155,1156.619507 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1043.143921,1055.025879 
    C1043.135742,1054.853638 1043.127686,1054.681519 1043.061157,1054.257324 
    C1043.789185,1053.021240 1044.575439,1052.036987 1045.676514,1050.997070 
    C1045.994141,1051.748779 1045.996948,1052.556396 1046.083618,1053.761719 
    C1046.167603,1054.159424 1046.100342,1054.131592 1045.764648,1054.067871 
    C1044.667358,1054.344727 1043.905640,1054.685303 1043.143921,1055.025879 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1052.146240,1048.129639 
    C1051.354126,1048.110962 1050.547241,1048.059082 1049.335449,1047.998047 
    C1050.060425,1046.909180 1051.190063,1045.829346 1052.572266,1045.045410 
    C1052.571777,1046.249023 1052.318726,1047.156982 1052.065796,1048.064819 
    C1052.065796,1048.064819 1052.131470,1048.096313 1052.146240,1048.129639 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M1052.419678,1048.064209 
    C1052.318726,1047.156982 1052.571777,1046.249023 1052.916992,1044.989990 
    C1053.027954,1044.371582 1053.149414,1044.164307 1053.930176,1044.010010 
    C1054.988281,1043.997925 1055.489624,1043.992920 1056.020264,1044.019531 
    C1056.049316,1044.051392 1056.108032,1044.114502 1056.108032,1044.114502 
    C1054.996582,1045.430908 1053.885010,1046.747314 1052.419678,1048.064209 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1046.106445,1117.355225 
    C1045.916748,1118.057983 1045.664673,1118.397339 1045.137817,1118.897827 
    C1044.220581,1117.895508 1043.578125,1116.731934 1043.323730,1115.519165 
    C1044.489258,1115.977173 1045.266724,1116.484497 1046.106445,1117.355225 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1072.654175,1135.409180 
    C1073.830200,1135.374634 1075.268799,1135.584595 1076.858154,1136.124023 
    C1075.645020,1136.187012 1074.280762,1135.920410 1072.654175,1135.409180 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1098.966797,1038.395630 
    C1099.240723,1037.979492 1099.474121,1037.877563 1099.779175,1037.545898 
    C1100.375244,1037.412842 1100.870850,1037.444092 1101.676514,1037.690674 
    C1101.999634,1038.422974 1102.013062,1038.940186 1102.023071,1039.715820 
    C1100.998169,1039.574829 1099.976440,1039.175171 1098.966797,1038.395630 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M955.251831,1154.778320 
    C954.690491,1155.016479 954.178528,1154.957397 953.416260,1154.866943 
    C953.139038,1153.997803 953.112183,1153.160034 953.154236,1151.904297 
    C953.915833,1152.484497 954.608521,1153.482910 955.251831,1154.778320 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1217.821899,1050.658325 
    C1218.032715,1051.193848 1217.999756,1051.688232 1217.944092,1052.551758 
    C1217.192871,1052.954224 1216.463989,1052.987549 1215.369141,1053.010376 
    C1215.861328,1052.205688 1216.719604,1051.411377 1217.821899,1050.658325 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1217.750854,1024.850220 
    C1217.991455,1025.474731 1217.999756,1025.938477 1217.984375,1026.749146 
    C1217.134277,1025.930420 1216.307739,1024.764648 1215.455566,1023.283691 
    C1216.126099,1023.542175 1216.822266,1024.115723 1217.750854,1024.850220 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M1057.253662,1041.697266 
    C1058.040894,1041.790527 1058.683472,1041.878784 1059.812012,1042.015503 
    C1059.157959,1042.732300 1058.018066,1043.400635 1056.493042,1044.091797 
    C1056.108032,1044.114502 1056.049316,1044.051392 1056.142090,1043.761963 
    C1056.489624,1042.968262 1056.744263,1042.463867 1056.998779,1041.959473 
    C1056.998779,1041.959473 1057.109253,1041.692383 1057.253662,1041.697266 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M1065.311035,1040.011963 
    C1064.991455,1039.432983 1065.012817,1038.885986 1065.035278,1038.065186 
    C1065.482178,1037.614624 1065.928223,1037.438110 1066.737549,1037.302979 
    C1067.186646,1037.627930 1067.369995,1037.817139 1067.848389,1037.966553 
    C1067.247803,1038.695801 1066.449951,1039.369995 1065.311035,1040.011963 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1094.744629,1035.586548 
    C1095.540527,1036.309326 1096.088623,1036.877563 1096.779053,1037.643066 
    C1095.617432,1037.479492 1094.313843,1037.118408 1093.084595,1036.374023 
    C1093.366211,1035.961914 1093.555176,1035.887207 1093.823364,1035.647461 
    C1094.112671,1035.495972 1094.304810,1035.463867 1094.744629,1035.586548 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1215.269043,1118.261963 
    C1215.887329,1117.995483 1216.546875,1118.041992 1217.531250,1118.117188 
    C1217.914062,1118.567627 1217.971924,1118.989380 1218.007690,1119.731689 
    C1217.093750,1119.559814 1216.202026,1119.067383 1215.269043,1118.261963 
  z"/>
  <path fill="#B9B9B9" opacity="1.000000" stroke="none" 
    d="
  M1220.442261,1122.179321 
    C1221.244629,1122.437378 1222.014648,1122.943481 1222.861694,1123.799072 
    C1222.095825,1123.574707 1221.252808,1123.000977 1220.442261,1122.179321 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M1056.665283,1041.984619 
    C1056.744263,1042.463867 1056.489624,1042.968262 1056.113037,1043.730225 
    C1055.489624,1043.992920 1054.988281,1043.997925 1054.111572,1043.969360 
    C1054.601440,1043.293701 1055.466675,1042.651733 1056.665283,1041.984619 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M1130.634521,1183.812256 
    C1130.060181,1184.523315 1129.137207,1185.195923 1127.851807,1185.781738 
    C1128.421509,1185.054565 1129.353760,1184.414062 1130.634521,1183.812256 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M1041.924316,1111.697998 
    C1041.316528,1112.002808 1040.632324,1111.998169 1039.606689,1111.992676 
    C1039.140503,1111.848145 1039.015503,1111.704590 1039.210327,1111.297607 
    C1039.703003,1111.008057 1039.876099,1110.981934 1040.049072,1110.955811 
    C1040.648682,1111.100098 1041.248413,1111.244385 1041.924316,1111.697998 
  z"/>
  <path fill="#9C9C9C" opacity="1.000000" stroke="none" 
    d="
  M1039.888184,1110.758545 
    C1039.876099,1110.981934 1039.703003,1111.008057 1039.268066,1111.018066 
    C1038.907959,1110.842896 1038.809570,1110.683960 1038.799316,1110.258179 
    C1039.167358,1110.181396 1039.447388,1110.371460 1039.888184,1110.758545 
  z"/>
  <path fill="#9C9C9C" opacity="1.000000" stroke="none" 
    d="
  M1037.992310,1109.274902 
    C1038.216187,1109.200684 1038.478027,1109.424805 1038.875000,1109.871338 
    C1038.683594,1109.920166 1038.356934,1109.746704 1037.992310,1109.274902 
  z"/>
  <path fill="#A349A4" opacity="1.000000" stroke="none" 
    d="
  M861.920654,875.824585 
    C863.582153,872.783997 865.243591,869.743408 867.467896,866.308167 
    C871.459778,864.099304 874.946228,862.384827 878.306152,860.450684 
    C886.108582,855.959229 894.106628,856.038513 902.295654,859.150635 
    C904.179810,859.866760 906.069153,860.569275 908.024292,861.461365 
    C908.247681,861.872314 908.458069,862.023193 908.797485,862.434326 
    C909.538940,863.224609 910.206421,863.677795 910.855774,864.150391 
    C910.837646,864.169800 910.825562,864.221497 910.992554,864.517090 
    C916.329712,870.619446 921.506836,876.410217 921.083130,885.001953 
    C921.065796,885.352478 922.298401,885.764771 922.979126,886.484436 
    C922.988037,887.495239 922.966675,888.169861 922.580322,889.015320 
    C921.764648,892.089111 921.313965,894.992126 920.885254,897.909546 
    C920.907349,897.924072 920.912476,897.875183 920.528870,897.914185 
    C919.032654,900.612366 917.920044,903.271545 916.606934,905.939941 
    C916.406372,905.949219 916.010742,906.017029 915.696533,906.088989 
    C915.172119,906.756653 914.961914,907.352417 914.413940,907.980774 
    C913.050232,909.346619 912.024170,910.679993 910.664673,912.004517 
    C909.528381,912.655029 908.725586,913.314392 907.593506,914.136963 
    C896.796448,918.929810 886.380249,917.745178 875.896484,913.691284 
    C872.540894,910.913940 869.275330,908.468628 865.817993,905.792542 
    C865.071228,905.362610 864.516235,905.163513 863.961243,904.964355 
    C863.961243,904.964355 864.018799,904.963440 863.906128,904.612122 
    C863.202209,901.968628 862.180481,899.691589 862.099609,897.381531 
    C861.848145,890.202576 861.953674,883.011169 861.920654,875.824585 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M875.986511,914.023315 
    C886.380249,917.745178 896.796448,918.929810 907.980713,914.149292 
    C909.211365,914.031311 909.725525,914.064331 910.239624,914.097412 
    C900.845276,922.280823 884.819214,922.557190 873.131958,914.406616 
    C874.225769,914.055969 875.106140,914.039673 875.986511,914.023315 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M861.627075,875.873291 
    C861.953674,883.011169 861.848145,890.202576 862.099609,897.381531 
    C862.180481,899.691589 863.202209,901.968628 863.911194,904.640503 
    C857.782776,895.816101 856.436035,886.158203 861.627075,875.873291 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M907.956177,861.278015 
    C906.069153,860.569275 904.179810,859.866760 902.295654,859.150635 
    C894.106628,856.038513 886.108582,855.959229 878.306152,860.450684 
    C874.946228,862.384827 871.459778,864.099304 867.680908,866.023682 
    C871.352661,859.833862 877.638123,857.182556 885.394043,855.676025 
    C890.423279,855.838684 894.567566,855.800354 898.711914,855.762085 
    C898.960938,855.527100 899.245422,855.470520 899.953430,856.012329 
    C902.879700,858.047607 905.417908,859.662842 907.956177,861.278015 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M922.948730,886.148254 
    C922.298401,885.764771 921.065796,885.352478 921.083130,885.001953 
    C921.506836,876.410217 916.329712,870.619446 911.459351,864.424683 
    C912.386414,863.947876 913.013733,863.859131 913.641113,863.770386 
    C915.095032,865.259644 916.548889,866.748962 918.025513,868.850464 
    C918.536682,869.980530 919.025146,870.498352 919.513550,871.016174 
    C919.746216,871.313965 919.978882,871.611816 920.164673,872.610229 
    C921.273743,876.211121 922.429688,879.111328 923.585632,882.011536 
    C923.717712,882.464661 923.849731,882.917786 923.676025,883.917297 
    C923.229675,885.025208 923.089233,885.586731 922.948730,886.148254 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M913.455627,863.474487 
    C913.013733,863.859131 912.386414,863.947876 911.292297,864.129089 
    C910.825562,864.221497 910.837646,864.169800 910.850586,863.796021 
    C910.150146,862.980591 909.436829,862.539001 908.723572,862.097412 
    C908.458069,862.023193 908.247681,861.872314 908.024292,861.461365 
    C905.417908,859.662842 902.879700,858.047607 900.141602,856.140808 
    C904.384583,858.292297 908.827332,860.735413 913.455627,863.474487 
  z"/>
  <path fill="#D6D6D6" opacity="1.000000" stroke="none" 
    d="
  M875.896484,913.691284 
    C875.106140,914.039673 874.225769,914.055969 872.909668,914.137268 
    C870.449402,912.322571 868.424927,910.442932 866.204346,907.966858 
    C866.008728,906.921387 866.009216,906.472412 866.009705,906.023376 
    C869.275330,908.468628 872.540894,910.913940 875.896484,913.691284 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M916.010742,906.017029 
    C916.010742,906.017029 916.406372,905.949219 916.949097,906.001221 
    C917.718079,906.101746 917.944275,906.150269 918.170532,906.198730 
    C916.059082,908.541138 913.947693,910.883606 911.443176,912.963623 
    C911.032776,912.471863 911.015442,912.242615 910.998108,912.013306 
    C912.024170,910.679993 913.050232,909.346619 914.703491,907.856628 
    C915.557312,907.138977 915.783997,906.578003 916.010742,906.017029 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M898.393799,855.518311 
    C894.567566,855.800354 890.423279,855.838684 885.758057,855.783264 
    C889.516663,855.551208 893.796204,855.412903 898.393799,855.518311 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M931.484558,828.099792 
    C932.043701,828.420410 932.242737,828.668091 932.732300,828.959351 
    C934.238464,829.409973 935.525391,829.759644 937.231079,830.187012 
    C934.098633,833.469788 931.601685,830.460999 928.669800,828.494873 
    C929.324097,828.170105 930.188538,828.127136 931.484558,828.099792 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M923.672241,881.634521 
    C922.429688,879.111328 921.273743,876.211121 920.138184,872.903625 
    C921.358643,875.416687 922.558716,878.337097 923.672241,881.634521 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M850.988892,828.515808 
    C852.002441,828.130371 852.885803,828.125061 854.208618,828.196411 
    C851.973145,830.026123 849.696960,833.165405 845.582275,830.548645 
    C847.169556,829.826172 849.014099,829.361023 850.988892,828.515808 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M920.863159,897.895081 
    C921.313965,894.992126 921.764648,892.089111 922.613647,889.313660 
    C923.289185,889.944397 923.566467,890.447571 923.843811,890.950806 
    C923.867065,891.730469 923.890320,892.510193 923.427612,893.738647 
    C922.248779,895.423340 921.555969,896.659180 920.863159,897.895081 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M920.885254,897.909546 
    C921.555969,896.659180 922.248779,895.423340 923.243774,894.087769 
    C922.636841,896.697693 921.727783,899.407471 920.482056,901.925171 
    C920.401062,900.447144 920.656799,899.161194 920.912476,897.875183 
    C920.912476,897.875183 920.907349,897.924072 920.885254,897.909546 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M923.988220,890.630859 
    C923.566467,890.447571 923.289185,889.944397 922.978577,889.142822 
    C922.966675,888.169861 922.988037,887.495239 922.979126,886.484436 
    C923.089233,885.586731 923.229675,885.025208 923.584961,884.266846 
    C923.910706,886.150330 924.021667,888.230591 923.988220,890.630859 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M920.528870,897.914185 
    C920.656799,899.161194 920.401062,900.447144 920.191345,902.127258 
    C920.237366,902.521362 920.323669,902.822632 919.885620,903.055115 
    C919.017883,904.260620 918.588135,905.233643 918.158447,906.206665 
    C918.158386,906.206604 918.120483,906.182739 918.145508,906.190735 
    C917.944275,906.150269 917.718079,906.101746 917.149658,905.991943 
    C917.920044,903.271545 919.032654,900.612366 920.528870,897.914185 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M980.859253,923.449463 
    C980.541748,924.025330 980.307495,924.232056 980.023682,924.711121 
    C979.251343,925.278076 978.580627,925.631653 977.625000,926.011414 
    C978.309631,924.316162 979.279114,922.594788 980.508789,920.657959 
    C980.809448,921.302124 980.849976,922.161804 980.859253,923.449463 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M975.598999,846.292480 
    C976.205444,846.253357 976.835693,846.537048 977.701660,846.934570 
    C978.251953,848.286072 978.566467,849.523682 978.852173,851.150269 
    C977.756470,849.897949 976.689575,848.256653 975.598999,846.292480 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M803.093262,921.642578 
    C802.225098,921.112976 801.374146,920.230103 800.264893,919.171631 
    C800.100098,918.475098 800.193604,917.954224 800.489746,917.260498 
    C801.498474,918.488220 802.304504,919.888733 803.093262,921.642578 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M974.593750,841.058960 
    C974.893982,841.964355 974.908569,842.815125 974.875122,844.092346 
    C973.988220,843.222046 973.149292,841.925293 972.268799,840.293701 
    C972.920898,840.307312 973.614563,840.655884 974.593750,841.058960 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M982.617188,855.087036 
    C982.868652,856.031982 982.855042,856.949036 982.740112,858.321289 
    C981.987671,857.707886 981.336487,856.639404 980.715637,855.264404 
    C981.281372,854.991638 981.816772,855.025452 982.617188,855.087036 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M840.453125,828.592773 
    C841.397156,828.692871 842.522888,829.012939 843.823669,829.664429 
    C842.877441,829.601501 841.756165,829.207153 840.453125,828.592773 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M944.233032,828.078491 
    C944.984497,827.368408 945.962585,826.758728 947.313232,826.228760 
    C946.610352,826.932007 945.535034,827.555420 944.233032,828.078491 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M835.459778,826.594482 
    C836.404236,826.714417 837.539978,827.049438 838.847900,827.723938 
    C837.897095,827.645447 836.774048,827.227539 835.459778,826.594482 
  z"/>
  <path fill="#BCBCBC" opacity="1.000000" stroke="none" 
    d="
  M966.126465,947.657227 
    C965.986206,947.981079 965.493408,948.006714 965.246704,948.003357 
    C965.425903,947.005371 965.851868,946.010742 966.561035,944.830261 
    C966.651794,945.540771 966.459229,946.437073 966.126465,947.657227 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M918.447632,906.048218 
    C918.588135,905.233643 919.017883,904.260620 919.753540,903.139526 
    C919.618591,903.957520 919.177734,904.923584 918.447632,906.048218 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M865.817993,905.792542 
    C866.009216,906.472412 866.008728,906.921387 866.002075,907.707153 
    C865.344604,907.243408 864.693298,906.442932 864.001587,905.303467 
    C864.516235,905.163513 865.071228,905.362610 865.817993,905.792542 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M910.664673,912.004517 
    C911.015442,912.242615 911.032776,912.471863 911.103455,913.042236 
    C911.170471,913.731140 911.015259,913.968689 910.465393,914.096680 
    C909.725525,914.064331 909.211365,914.031311 908.310059,913.986023 
    C908.725586,913.314392 909.528381,912.655029 910.664673,912.004517 
  z"/>
  <path fill="#CBCBCB" opacity="1.000000" stroke="none" 
    d="
  M919.511108,870.742249 
    C919.025146,870.498352 918.536682,869.980530 918.047607,869.168701 
    C918.534180,869.405884 919.021423,869.937073 919.511108,870.742249 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M837.772522,947.617493 
    C837.485596,948.102783 836.920959,948.515747 836.073792,948.877014 
    C836.359131,948.398560 836.927002,947.971863 837.772522,947.617493 
  z"/>
  <path fill="#B4B4B4" opacity="1.000000" stroke="none" 
    d="
  M847.818237,943.757202 
    C847.483948,944.220642 846.924561,944.586182 846.011963,944.928528 
    C846.303528,944.489990 846.948303,944.074646 847.818237,943.757202 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M940.274963,829.578979 
    C940.647156,829.096680 941.328369,828.629272 942.354370,828.244263 
    C941.994141,828.749023 941.289062,829.171448 940.274963,829.578979 
  z"/>
  <path fill="#C1C1C1" opacity="1.000000" stroke="none" 
    d="
  M982.466187,860.498901 
    C982.408081,861.118347 982.138306,861.984863 981.514038,862.959534 
    C981.524597,862.293762 981.889648,861.519897 982.466187,860.498901 
  z"/>
  <path fill="#C7C7C7" opacity="1.000000" stroke="none" 
    d="
  M391.410400,908.958008 
    C391.027222,908.665710 391.003448,908.388733 390.976929,907.902588 
    C391.642365,907.928650 392.315918,908.163330 393.085724,908.664490 
    C392.709473,908.945251 392.237000,908.959534 391.410400,908.958008 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M1042.921265,1055.331177 
    C1043.905640,1054.685303 1044.667358,1054.344727 1045.746094,1054.036621 
    C1044.926147,1055.435425 1043.789185,1056.801880 1042.317871,1058.329102 
    C1042.221802,1057.538818 1042.460205,1056.587646 1042.921265,1055.331177 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1102.808594,1040.459839 
    C1104.029541,1040.518921 1105.342041,1040.961304 1106.822266,1041.724121 
    C1105.626709,1041.644287 1104.263428,1041.243774 1102.808594,1040.459839 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M1061.303955,1042.028931 
    C1061.816040,1041.329346 1062.676147,1040.663818 1063.917725,1040.031372 
    C1063.416992,1040.730591 1062.534424,1041.396851 1061.303955,1042.028931 
  z"/>
  <path fill="#D3D3D3" opacity="1.000000" stroke="none" 
    d="
  M1070.431763,1037.921387 
    C1070.798828,1037.347412 1071.526855,1036.833374 1072.498779,1036.200439 
    C1072.092773,1036.714722 1071.442749,1037.348022 1070.431763,1037.921387 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1114.600586,1123.786255 
    C1114.525513,1124.342163 1114.113159,1124.996460 1113.445312,1125.800903 
    C1113.547729,1125.262207 1113.905396,1124.573486 1114.600586,1123.786255 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M1109.643311,1127.964111 
    C1109.183838,1128.297363 1108.375488,1128.636963 1107.214111,1128.964478 
    C1107.672363,1128.625000 1108.483398,1128.297852 1109.643311,1127.964111 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M1100.586670,1132.047974 
    C1100.078369,1132.229980 1099.201416,1132.344727 1098.146118,1132.211426 
    C1098.717896,1131.969116 1099.467773,1131.974976 1100.586670,1132.047974 
  z"/>
  <path fill="#C5C5C5" opacity="1.000000" stroke="none" 
    d="
  M1067.764404,1131.952393 
    C1067.743652,1132.089966 1067.463745,1132.210327 1067.087158,1132.166260 
    C1067.161987,1131.979736 1067.333618,1131.957275 1067.764404,1131.952393 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1115.669800,1122.018066 
    C1115.777100,1122.250000 1115.611206,1122.540161 1115.212891,1122.941406 
    C1115.119141,1122.727051 1115.257812,1122.401611 1115.669800,1122.018066 
  z"/>
  <path fill="#CECECE" opacity="1.000000" stroke="none" 
    d="
  M1121.679565,1115.782593 
    C1121.769287,1115.971558 1121.622803,1116.329712 1121.213623,1116.822998 
    C1121.114990,1116.622681 1121.279053,1116.287109 1121.679565,1115.782593 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M908.797485,862.434387 
    C909.436829,862.539001 910.150146,862.980591 910.868652,863.776611 
    C910.206421,863.677795 909.538940,863.224609 908.797485,862.434387 
  z"/>
  <path fill="#D0D0D0" opacity="1.000000" stroke="none" 
    d="
  M915.696533,906.088989 
    C915.783997,906.578003 915.557312,907.138977 915.041138,907.824097 
    C914.961914,907.352417 915.172119,906.756653 915.696533,906.088989 
  z"/>
  </svg>
</template>